export default function () {
  return {
    language: 'pt-BR',
    'pt-BR': {
      session: {
        // Card da regra, na pagina de Usuarios
        policyTitle: 'Um dispositivo por usuário',
        policyDescription: 'Quando ativado, entrar em um novo dispositivo encerra a sessão anterior do mesmo usuário. Várias abas do mesmo navegador continuam funcionando.',
        stateOn: 'Ativado',
        stateOff: 'Desativado',
        policyUpdated: 'Configuração atualizada.',
        policyError: 'Não foi possível atualizar a configuração.',
        viewDevices: 'Ver dispositivos conectados',
        // Aviso que o usuário derrubado recebe
        revokedNewDevice: 'Sua conta foi acessada em outro dispositivo. Esta sessão foi encerrada.',
        revokedByAdmin: 'Sua sessão foi encerrada por um administrador.',
        // Lista de dispositivos
        title: 'Dispositivos conectados',
        subtitle: 'Onde esta conta está aberta agora',
        devices: 'dispositivos',
        device: 'dispositivo',
        currentDevice: 'Este dispositivo',
        lastSeen: 'Último acesso',
        firstSeen: 'Primeiro acesso',
        revoke: 'Encerrar sessão',
        revokeConfirm: 'Encerrar a sessão deste dispositivo? A pessoa será desconectada imediatamente.',
        revoked: 'Sessão encerrada.',
        revokeError: 'Não foi possível encerrar a sessão.',
        noDevices: 'Nenhum dispositivo conectado.'
      },
      components: {
        sounds: {
          audioBlocked: '🔈 Para ouvir as notificações sonoras, interaja com a tela clicando em qualquer lugar.'
        },
        tables: {
          noDataLabel: 'Nenhum dado disponível.',
          dragTableColumns: 'Ordene as Colunas'
        },
        selects: {
          noSearchResults: 'Nenhum resultado encontrado'
        },
        action: {
          requisition: {
            request: 'Requisição',
            method: 'Método',
            run: 'Run',
            messageError: 'Oops, está faltando dados.'
          },
          copyToClipboard: 'Copiado para a área de transferência!',
          copyToClipboardError: 'Erro ao copiar para a área de transferência',
          editCode: 'Editar código',
          copyCode: 'Copiar código',
          showEditableBlock: 'Ver apenas bloco editável',
          showFullCode: 'Ver código completo',
          editableBlockNotFound: 'Não foi possível localizar o bloco editável',
        },
        advancedSearch: {
          index: {
            myFilters: 'Meus filtros de pesquisa',
            custom: 'Personalizado',
            today: 'Hoje',
            yesterday: 'Ontem',
            thisMonth: 'Este mês',
            lastSevenDays: 'Últimos 7 dias',
            lastFifteenDays: 'Últimos 15 dias',
            lastThirtyDays: 'Últimos 30 dias',
            personalized: 'Personalizado',
            search: 'Pesquisar',
            initialDate: 'Data inicial',
            initialHour: 'Hora inicial',
            endDate: 'Data final',
            endHour: 'Hora final',
            chatbots: 'Chatbots',
            channel: 'Canal',
            all: 'Todos',
            webchat: 'Webchat',
            dialogue: 'Diálogo',
            dialogueDescription: 'Você pode filtrar por quem iniciou<br/> a conversa, atendente ou cliente.',
            from: 'De',
            to: 'Até',
            botDeleted: 'Bot excluído',
            active: 'Chatbot/Ativos',
            receptive: 'Cliente/Receptivos',
            whatsapp: 'Whatsapp',
            messenger: 'Messenger',
            instagram: 'Instagram',
            telegram: 'Telegram',
            gbm: 'GBM',
            rcs: 'RCS',
            identifiers: 'Identificadores',
            filter: 'Filtrar',
            fill: 'Preenchimento',
            filled: 'Preenchido',
            notFilled: 'Não preenchido',
            transhipment: 'Transbordo',
            transhipmentDescription: 'Esta é uma nova funcionalidade, filtros baseados neste<br/> campo não são aplicados à datas anteriores a 19/03/2020.',
            withAttachments: 'Com anexos',
            indifferent: 'Indiferente',
            attended: 'Atendidos',
            notAttended: 'Não atendidos',
            unrealized: 'Não realizados',
            none: 'Nenhum',
            attendants: 'Atendentes',
            departments: 'Departamentos',
            otherOptions: 'Outras opções',
            onlyConversations: 'Somente conversas',
            allConversations: 'Todas',
            incompleteConversations: 'Incompletas',
            conversationFinished: 'Finalizadas',
            satisfaction: 'Satisfação',
            oneStar: '1 estrela',
            twoStar: '2 estrelas',
            threeStar: '3 estrelas',
            fourStar: '4 estrelas',
            fiveStar: '5 estrelas',
            tags: 'Tags',
            term: 'Termo',
            inIdentifier: 'No identificador',
            clear: 'Limpar',
            createFilter: 'Criar filtro',
            title: 'Título',
            save: 'Salvar',
            messageError: 'Oops, ocorreu algum erro.',
            listBy: 'Lista de ',
            savedFilter: 'Seu filtro foi salvo!',
            of: 'de',
            selectAll: 'Todos',
            interno: 'Interno',
          }
        },
        advancedSearchCrm: {
          index: {
            people: 'Pessoas',
            companies: 'Empresas',
            equal: 'é igual a',
            notEqual: 'não é igual a',
            filled: 'está preenchido',
            notFilled: 'não está preenchido',
            contains: 'contém',
            notContains: 'não contém',
            greaterThan: 'maior que',
            lessThan: 'menor que',
            field: 'Campo',
            condition: 'Condição',
            value: 'Valor',
          }
        },
        analytics: {
          quickview: {
            conversation: {
              noDataAvailable: 'Nenhum dado disponível.'
            },
            knowledge: {
              noDataAvailable: 'Nenhum dado disponível.'
            },
            rating: {
              noDataAvailable: 'Nenhum dado disponível.'
            },
            usersConnected: {
              noDataAvailable: 'Nenhum dado disponível.'
            }
          },
          attendants: {
            attendants: 'Atendentes',
            satisfaction: 'Satisfação',
            attendance: 'Atendimentos',
            onlineTime: 'Tempo Online',
            awayTime: 'Tempo Away',
            responses: 'Tempo Away',
            reviewsAnswered: 'Avaliações Respondidas',
            tta: 'TTA',
            tma: 'TMA',
            tme: 'TME',
            tte: 'TTE',
            noDataAvailable: 'Nenhum dado disponível.',
            name: 'Nome',
            filteredConversations: 'Conversas no filtro',
            participations: 'Atendimentos (participações)',
            totalsHint: 'Conversas no filtro é o total de conversas que atendem aos filtros aplicados, o mesmo número do indicador da busca avançada. Atendimentos conta a participação de cada atendente: uma conversa transferida soma um atendimento para cada um deles, e uma conversa que não chegou a nenhum atendente não soma nenhum.',
            loadError: 'Não foi possível carregar os indicadores por atendente.',
            tryAgain: 'Tentar novamente'
          },
          botAndAttendant: {
            attendants: 'Atendentes',
            noDataAvailable: 'Nenhum dado disponível.',
            chatbots: 'Chatbots'
          },
          bubble: {
            sunday: 'Domingo',
            hours: ' horas',
            attendance: ' atendimentos'
          },
          campaign: {
            utmSource: 'UTM Source',
            tip: 'TIP',
            utmMedium: 'UTM Medium',
            utmCampaign: 'UTM Campaign',
            utmTerm: 'UTM Term',
            utmContent: 'UTM Content',
            withCampaign: 'Com campanha',
            withoutCampaign: 'Sem campanha'
          },
          channel: {
            noDataAvailable: 'Nenhum dado disponível.',
            total: 'Total',
            impressions: 'Impressões',
            impressionsDescription: 'No WebChat, é o volume de vezes que o chatbot apareceu disponível para clique/acionamento.',
            attendance: 'Atendimentos',
            attendanceDescription: 'Quando um usuário (cliente) aciona o chatbot para iniciar a conversa e um atendimento é iniciado.',
            messages: 'Mensagens',
            messagesDescription: 'Volume total de mensagens trocadas em todas as conversas (atendimentos). Entre usuário (cliente), chatbots e os atendentes (quando houver).',
            ttAttendance: 'TT Atendimentos',
            ttAttendanceDescription: 'É o tempo total em atendimento do canal, desde o momento do acionamento até o final da conversa.',
            tmAttendance: 'TM Atendimentos',
            tmAttendanceDescription: 'É o tempo médio dos atendimentos do canal, considerando o período selecionado.',
            totalTransshipments: 'Transbordos totais',
            totalTransshipmentsDescription: 'Quantidade de requisições em que o chatbot solicita atendimento de um atendente, seja acionado por alguma regra do fluxo ou pelo usuário (cliente).',
            transshipmentsAttended: 'Transbordos atendidos',
            transshipmentsAttendedDescription: 'Quantidade de atendimentos onde o chatbot passou a conversa para o atendente e ele conseguiu atender.',
            unattendedTransshipments: 'Transbordos não atendidos',
            unattendedTransshipmentsDescription: 'Quantidade de atendimentos onde o chatbot passou a conversa para o atendente e ele não conseguiu atender.',
            unrealizedTransshipments: 'Transbordados não realizados',
            unrealizedTransshipmentsDescription: 'Quantidade de atendimentos onde o chatbot não conseguiu passar a conversa para um atendente (não haviam atendentes on-line no momento). O chatbot retomou a conversa.',
            ttWait: 'TT Espera',
            ttWaitDescription: 'É o tempo total que os usuários (clientes) permaneceram em espera para serem atendidos pelos atendentes (quando a fila de atendimento está habilitada).',
            tmWait: 'TM Espera',
            tmWaitDescription: 'É o tempo médio que os usuários (clientes) permaneceram em espera para serem atendidos pelos atendentes (quando a fila de atendimento está habilitada).',
            satisfaction: 'Satisfação',
            satisfactionDescription: 'É a taxa de satisfação do atendimento em geral (pesquisa acionada ao final do atendimento). Escala de 0 a 5 e número de respondentes em parênteses.',
            monetaryValueDescription: 'Confira o valor total gerado pelas conversas no período (muito útil para quem vende produtos e serviços). Para aparecer aqui, o valor deve ser atribuído em cada conversa individualmente.',
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro',
            shortJan: 'Jan',
            shortFeb: 'Fev',
            shortMar: 'Mar',
            shortApr: 'Abr',
            shortMay: 'Mai',
            shortJun: 'Jun',
            shortJul: 'Jul',
            shortAug: 'Ago',
            shortSep: 'Set',
            shortOct: 'Out',
            shortNov: 'Nov',
            shortDec: 'Dez',
            sunday: 'Domingo',
            monday: 'Segunda',
            tuesday: 'Terça',
            wednesday: 'Quarta',
            thursday: 'Quinta',
            friday: 'Sexta',
            saturday: 'Sábado',
            shortSunday: 'Dom',
            shortMonday: 'Seg',
            shortTuesday: 'Ter',
            shortWednesday: 'Qua',
            shortThursday: 'Qui',
            shortFriday: 'Sex',
            shortSaturday: 'Sab',
            exportToSVG: 'Exportar para SVG',
            exportToPNG: 'Exportar para PNG',
            exportToCSV: 'Exportar para CSV',
            menu: 'Menu',
            selection: 'Selecionar',
            selectionZoom: 'Selecionar zoom',
            zoomIn: 'Mais zoom',
            zoomOut: 'Menos zoom',
            pan: 'Mover',
            reset: 'Retornar ao padrão'
          },
          city: {
            noDataAvailable: 'Nenhum dado disponível.',
            others: 'Outros'
          },
          country: {
            noDataAvailable: 'Nenhum dado disponível.',
            others: 'Outros'
          },
          department: {
            noDataAvailable: 'Nenhum dado disponível.'
          },
          heat: {
            sunday: 'Domingo',
            monday: 'Segunda',
            tuesday: 'Terça',
            wednesday: 'Quarta',
            thursday: 'Quinta',
            friday: 'Sexta',
            saturday: 'Sabado',
            hours: ' horas',
            attendance: 'Atendimentos'
          },
          identifier: {
            selectIdentifier: 'Selecione um identificador',
            noDataAvailable: 'Nenhum dado disponível.',
            others: 'Outros',
            limitCards: 'Volume máximo de 12 visões. Para criar uma nova, favor apagar uma existente.'
          },
          knowledgeAnswered: {
            noDataAvailable: 'Nenhum dado disponível.',
            answered: 'Respondidas',
            unambiguous: 'Desambiguadas',
            unanswered: 'Não respondidas',
            outContext: 'Fora de contexto'
          },
          knowledgeResponses: {
            noDataAvailable: 'Nenhum dado disponível.',
            others: 'Outros'
          },
          pivot: {
            origin: 'Origem',
            total: 'Total'
          },
          platform: {
            noDataAvailable: 'Nenhum dado disponível.',
            incognito: 'Incógnito'
          },
          sankey: {
            noDataAvailable: 'Nenhum dado disponível.',
            to: 'De',
            from: 'Para',
            amount: 'Quantidade'
          },
          state: {
            noDataAvailable: 'Nenhum dado disponível.',
            others: 'Outros'
          }
        },
        crm: {
          expansion: {
            required: 'Campo obrigatório',
            attach: 'Anexar',
            noData: 'Nenhum documento cadastrado',
            noPermission: 'Sem permissão para vizualizar',
            deleted: 'Contato excluído!',
            updated: 'Documento atualizado!',
            uploading: 'Subindo arquivo...',
            removed: 'Arquivo removido',
            phoneError: 'Telefone inválido para o país selecionado.'

          }
        },
        drawers: {
          crm: {
            section: {
              sectionData: 'Nova Seção',
              editSection: 'Editar Seção',
              nameRequired: 'Nome*',
              description: 'Descrição',
              newSection: 'Crie uma nova Seção, que irá conter diversos campos personalizados.',
              permissions: 'Permissões',
              required: 'Campo Obrigatório.',
              type: 'Tipo*',
              useFields: 'Usar campos desta seção para a listagem de contatos.',
              whoCanSeeAndEdit: 'Quem pode ver esta seção.',
              canView: 'Ver',
              canEdit: 'Editar',
              fillAllRequiredFields: 'Preencha todos os campos obrigatórios',
              sectionSaved: 'Seção salva.',
              people: 'Pessoa',
              company: 'Empresa',
              admin: 'Administrador',
              manager: 'Gerente',
              attendant: 'Atendente'
            },
            custom: {
              sectionData: 'Novo Campo',
              editCustom: 'Editar Campo',
              nameRequired: 'Nome*',
              description: 'Descrição',
              newSection: 'Crie um novo campo, definindo seus parâmetros e associe à uma Seção.',
              permissions: 'Permissões',
              mask: 'Máscara',
              currency: 'Moeda',
              placeholder: 'Rótulo Vísivel (placeholder)',
              required: 'Campo Obrigatório.',
              section: 'Seção*',
              type: 'Tipo*',
              writeOption: 'Digite uma opção',
              addOption: 'Adicionar opção',
              name: 'Nome',
              token_label: 'token',
              name_label: 'Nome',
              token_placeholder: 'token',
              interactionKey: 'Campo-chave para agrupamento das interações',
              whoCanSeeAndEdit: 'Quem pode ver ou editar.',
              canEdit: 'Editar',
              canView: 'Ver',
              admin: 'Administrador',
              manager: 'Gerente',
              attendant: 'Atendente',
              text: 'Texto',
              editor: 'Texto Grande',
              name: 'Nome',
              email: 'E-mail',
              number: 'Número',
              decimal: 'Número (com decimais)',
              date: 'Data',
              coin: 'Moeda (tipo internacional)',
              url: 'URL',
              tel: 'Telefone',
              list: 'Lista de Única Escolha',
              image: 'Imagem',
              file: 'Documento',
              cnpj: 'CNPJ',
              cpf: 'CPF',
              cep: 'CEP',
              fieldSaved: 'Campo salvo.',
              tokenExists: 'Este token já existe para esta seção.',
              fillAllRequiredFields: 'Preencha todos os campos abrigatórios'
            },
            imports: {
              importsData: 'Importação de Registros',
              fieldCompatibility: 'Compatibilidade de Campos',
              importRules: 'Regras da Importação',
              nameRequired: 'Nome*',
              required: 'Campo obrigatório.',
              importType: 'Importar registros do tipo*',
              example: 'Exemplo Mensageria.csv',
              fieldCompatibilityDescription: 'Associe os campos encontrados na sua planilha com os campos já configurados no módulo Contatos.',
              note: 'NOTA: ',
              fieldCompatibilityNote: 'Só serão associados os campos que são compatíveis (ex. número em campo do tipo "numérico").',
              keyFieldDescription: 'O campo-chave serve para verificar se os registros que estão sendo importados coincidem com registros que já existem no sistema.',
              keyFieldDescriptionTwo: 'Se o registro já existir, o que deve ser feito:',
              keepExisting: '"Manter o que já existe" não irá importar os registros no qual o campo-chave coincide. "Substituir pelos dados importados" irá substituir todos os campos do registro que contenham dados nesta importação.',
              selectAction: 'Selecione uma ação',
              listImported: 'Lista importada com sucesso.',
              fillAllRequiredFields: 'Preencha todos os campos abrigatórios',
              people: 'Pessoa',
              company: 'Empresa',
              keepExisting: 'Manter o que já existe',
              replaceWithImported: 'Substituir pelos dados importados',
              admin: 'Administrador',
              manager: 'Gerente',
              attendant: 'Atendente',
              field: 'Campo'
            }
          },
          broadcast: {
            template: {
              email: {
                save: 'Salvar',
                cancel: 'Cancelar',
                messageEditor: 'Editor de Mensagem',
                personalizeEmail: 'Você pode personalizar seu e-mail utilizando variáveis.',
                library: 'Biblioteca',
                messageErrorToCompile: 'Erro ao compilar email!',
                templateSaved: 'Seu template foi salvo!',
                messageErrorConnection: 'Oops, ocorreu um erro de conexão!'
              },
              sms: {
                save: 'Salvar',
                cancel: 'Cancelar',
                messageEditor: 'Editor de Mensagem',
                message: 'Mensagem *',
                messageHas: 'Sua mensagem tem',
                attention: '  Informe o número do celular do cliente com DDD com 2 dígitos, exemplo: (XX) XXXXX-XXXX.',
                characters: 'caracteres.',
                discountCredits: 'Será descontados',
                discountCreditsFinal: 'créditos para cada número',
                overcomeTheCharacters: 'Nos casos que o conteúdo do SMS superar 160 caracteres, será tarifado mais de um crédito a cada 153 caracteres.',
                notSupportConcatenation: 'Algumas operadoras como a Oi e Sercomtel não suportam concatenação da mensagens, então serão recebidos SMS separadamente.',
                templateSaved: 'Seu template foi salvo!',
                messageErrorConnection: 'Oops, ocorreu um erro de conexão!',
                messageNeedFilled: 'Os campos nome e mensagem precisam ser preenchidos!'
              },
              whatsapp: {
                save: 'Salvar',
                cancel: 'Cancelar',
                messageEditor: 'Editor de Mensagem',
                message: 'Mensagem *',
                messageHas: 'Sua mensagem tem',
                characters: 'caracteres.',
                discountCredits: 'Será descontados dois créditos para cada número',
                integrations: 'A integração entre Globalbot e o WhatsApp permite envios de mensagens ativas considerando as seguintes orientações:',
                activeMessages: 'Mensagens Ativas:',
                activeMessagesDescription: 'Neste caso o chatbot WhatsApp é usado para notificação e mensagem aos clientes. E a origem do atendimento (primeira mensagem) é pela empresa. Caso o cliente responda a mensagem, será iniciada uma nova sessão de conversa (ou atendimento).',
                dispatchesInLargeScale: 'Envios em massa:',
                dispatchesInLargeScaleDescription: 'É importante ter atenção a este tipo de uso, pois o envio em massa (quando relacionado a promoções, divulgações, publicidade e afins) não são permitidos. São aceitáveis os envios automatizados para grupos de clientes como por exemplo notificações e avisos (dentro de um contexto que o cliente tenha optado por receber a mensagem, conhecido como opt-in).',
                modelSaved: 'Seu modelo foi salvo!',
                youCannotChange: 'Você não pode alterar mensagens no WhatsApp oficial. Favor, entre em contato com a equipe de suporte.',
                messageErrorConnection: 'Oops, ocorreu um erro de conexão!',
                messageNeedFilled: 'Os campos nome e mensagem precisam ser preenchidos!'
              },
              save: 'Salvar',
              cancel: 'Cancelar',
              modelData: 'Dados do Modelo',
              name: 'Nome *',
              tags: 'Tags',
              observations: 'Observações',
              integrationsId: 'ID para uso em integrações: ',
              modelMessageRequired: 'Para realizar um Envio, você deverá sempre utilizar um Modelo de Mensagem já criado.',
              newMessageModelData: 'Aqui você irá informar os dados do novo Modelo de Mensagem, que poderá ser utilizado para realizar Envios aos destinatários que você designar.',
              clientsWaba: 'Para os clientes da WABA (WhatsApp Business API) as notificações no formato HSM são obrigatórias e devem seguir os formatos já pré-aprovados.',
              whatsappTerm: 'Termos de Uso do WhatsApp:',
              whatsappTermDescription: ' É muito importante salientar que para utilização da integração entre Globalbot e WhatsApp o cliente esteja ciente e aceite as Políticas de Uso do WhatsApp, utilizando a aplicação de forma a não infringi-los. Caso o faça, o número poderá ser bloqueado. ',
              whatsappUsagePolicies: 'Políticas de Uso do WhatsApp',
              messageSavedModel: 'Seu modelo foi salvo!',
              messageErrorConnection: 'Oops, ocorreu um erro de conexão!',
              fieldNameRequired: 'O campo nome precisa ser preeenchido!'
            },
            dispatch: {
              save: 'Salvar',
              cancel: 'Cancelar',
              dispatchData: 'Dados do Envio',
              newDispatch: 'Novo Envio |',
              draftData: 'Dados do Rascunho',
              createDispatch: 'Criar Envio',
              dispatchName: 'Nome do envio *',
              observations: 'Observações',
              originAndInitialization: 'Origem e Inicialização',
              indicateServer: 'Indique qual servidor WhatsApp você quer realizar o envio (corresponde a seu número habilitado).',
              optional: 'Opcional: Customize o comportamento do chatbot caso o usuário responda a esta mensagem. O número refere-se ao ponto do fluxo conversacional que será acionado após a resposta. Descubra qual ponto do fluxo e suas numerações no módulo Fluxo. Deixe o valor 0 para o fluxo seguir normalmente a partir do início.',
              whatsappServer: 'Servidor de WhatsApp *',
              flowIndex: 'Índice do fluxo',
              message: 'Mensagem *',
              replaceWith: 'Substituir por',
              dailyLimit: 'Limite atual de envio diário',
              templateDescription: 'O uso de Templates (Modelos de Mensagem) é obrigatório do WhatsApp. Para criar um envio você deverá selecionar um Template já criado e aprovado.',
              includeIdentifiers: 'Incluir identificadores na conversa',
              templateMediaDescription: 'Se o template escolhido possuir mídia (imagem, documento ou vídeo) faça o upload. Se pussuir variáveis como',
              templateMediaDescriptionTwo: ', utilize os campos abaixo para substituir pelos valores que estão em sua lista de destinatários.',
              pdfLimitExceeded: 'PDF deve ter no máximo 100MB.',
              imageLimitExceeded: 'Imagem deve ter no máximo 5MB.',
              videoLimitExceeded: 'Vídeo deve ter no máximo 16MB.',
              advancedSettings: 'Configurações Avançadas',
              advancedSettingsDescription: 'Se o cliente responder esta mensagem o chatbot irá para a seguinte linha do fluxo:',
              preview: 'Prévia',
              previewDescription: 'Na prévia, são exibidos valores da primeira linha da sua lista para preencher as variáveis, quando houver.',
              defineMessage: 'Defina a Mensagem',
              preperDispatch: 'Preapare o Envio',
              dispatchList: 'Lista de Envio',
              sendTest: 'Enviar Teste',
              sendTestDescription: 'No teste, serão utilizados valores da primeira linha da sua lista para preencher as variáveis, quando houver.',
              phoneNumber: 'Número do celular',
              saveAsModel: 'Salvar também como modelo, para ser usado depois.',
              textPlaceholder: 'Texto para substituição',
              text: 'TEXTO',
              back: 'Voltar',
              smsVarDescription: 'Caso necessite, você deve utilizar as variáveis encontradas em sua lista para que a mensagem faça a substituição conforme intruição a seguir.',
              smsVarEx: 'Exemplo: Se a variável na lista for NOME, utilizar na mensagem como %NOME%, tipo: "Olá %NOME%, estou enviando uma mensagem."',
              headerLike: 'Cabeçalho tipo:',
              importantDescription: 'As estatísticas podem ser parciais se o envio foi realizado recentemente.',
              readMessages: 'Observações sobre Mensagens Lidas:',
              readMessagesObs: 'Esta estatística pode ser aproximada, pois algumas pessoas não habilitam a permissão de vizualização.',
              subjectAndSender: 'Assunto e Remetente',
              personalizeEmail: 'Você pode personalizar seu e-mail utilizando variáveis. Veja as dicas.',
              subjectEmail: 'O assunto do seu email tem ',
              characters: ' caracteres. O número de caracteres exibidos em dispositivos móveis é de 35 e em desktops 70, em média.',
              unsubscribeGroup: {
                pending: 'O grupo deste domínio ainda está sincronizando com o provedor. Aguarde alguns minutos.',
                missing: 'Este domínio não tem grupo de desinscrição. Abra Configurações > Domínios e crie o grupo.',
                required: 'Escolha um remetente de um domínio que tenha grupo de desinscrição.'
              },
              senderName: 'Nome remetente *',
              sender: 'Remetente *',
              replyTo: 'Responder para *',
              recipients: 'Destinatários',
              trackingConversation: 'Rastreabilidade nas Conversas',
              trackingConversationDescription: 'Atribua uma TAG caso queira identificar as conversas que forem iniciadas a partir deste envio.',
              recipientsDesc: 'Total de destinatários selecionados para o envio, considerando os atributos e segmentações que você escolheu.',
              dispatchTest: 'Teste de Envio',
              replaceVar: 'Substituição de variáveis',
              combineLists: 'Você pode combinar listas e filtros ou mesmo importar uma nova lista. ',
              selectList: 'Selecione uma lista de envio já salva ou faça uma importação.',
              clickHere: 'Clique aqui',
              downloadModelList: 'para baixar um modelo.',
              importList: 'Importar Lista',
              lists: 'Listas',
              filters: 'Filtros',
              notSend: 'Não enviar para...',
              includeCampaign: 'Incluir em uma campanha',
              campaign: 'Campanha *',
              messageCampaignOne: 'Uma campanha é um conjunto de envios relacionados.',
              messageCampaignTwo: 'As campanhas fornecem uma série de relatórios e estatísticas agrupados para seus envios.',
              messageCampaignThree: 'Utilize as campanhas para agrupar os seus envios e analisar os resultados com o passar do tempo. Exemplos: Campanha Semanel, Envios de Janeiro, etc.',
              integrationsId: 'ID para uso em integrações: ',
              found: 'Encontrados',
              repeated: 'Repetidos',
              excluded: 'Retirados',
              range: 'Alcance',
              var: 'Variáveis da lista',
              varDescription: 'Abaixo as variáveis encontradas na lista e exemplo de valores que foram extraídos da primeira linha.',
              deliveries: 'Entregas',
              totalRecipients: 'Total de destinatários selecionados para o envio, considerando os atributos e segmentações que você previamente escolheu.',
              sent: 'Enviados',
              sentDesc: 'Total de destinatários que tiveram a mensagem entregue pela Globalbot ao servidor do WhatsApp.',
              processing:'Processados',
              processingDesc: 'Total de destinatários que tiveram ou estão tendo a mensagem processada pela Globalbot ao servidor do WhatsApp.',
              pending: 'Pendentes',
              pendingDesc: 'Total de destinatários que ainda não receberam a mensagem(WhatsApp deixou estas mensagens em fila).',
              notSent: 'Não enviados',
              read: 'Lidos',
              readDesc: 'Total de destinatários que efetivamente visualizaram a mensagem. Esta estatística pode ser aproximada, pois algumas pessoas não habilitam a permissão de visualização.',
              readDesc2: 'Porcentagem referente ao total de Entregues.',
              error: 'Não Entregues',
              errorDesc: 'Total de destinatários cujas mensagens não foram entregues, por razões como: número WhatsApp inexistente, usuário está em sessão de conversa aberta, problema específico com Template HSM, dentre outros.',
              errorCodesWhatsApp: {
                'BROADCAST_WHATSAPP_TIMEOUT_PROCESS':'Timeout de processamento',
                'GLOBALBOT_BUBBLE_NOT_FOUND': 'Bubble não encontrada',
                'BROADCAST_DISPATCH_UNEXPECTED_ERROR_TRANSACTION': 'Erro ao processar disparo do número',
                'BROADCAST_WHATSAPP_INTERNAL_ERROR': 'Erro inesperado',
                'BROADCAST_WHATSAPP_FAIL_SEND_TO_WORKER': 'Falha ao enviar mensagem para worker',
                'BROADCAST_WHATSAPP_CONVERSATION_ALREADY_EXISTS': 'Em conversa',
                'BROADCAST_WHATSAPP_BUBBLE_ALREADY_EXISTS': 'Em conversa',
                'GLOBALBOT_NOT_FOUND_TEMPLATE': 'Template não encontrado',
                'GLOBALBOT_INVALID_ARGUMENTS': 'Argumentos inválidos',
                'GLOBALBOT_MISSING_PARAMS': 'Parâmetros faltando',
                'GLOBALBOT_BOT_NOT_FOUND': 'Bot não encontrado',
                'GLOBALBOT_OPT_OUTED_PHONE': 'Opt-out',
                'GLOBALBOT_ALREADY_IN_CONVERSATION': 'Em conversa',
                'GLOBALBOT_UNEXPECTED_ERROR': 'Erro inesperado no processamento',
                'GUPSHUP_INVALID_TEMPLATE_CATEGORY': 'Categoria de template inválida',
                'GUPSHUP_REQUEST_ERROR': 'Erro ao processar solicitação',
                'GUPSHUP_GENERIC_ERROR': 'Erro genérico',
                'GUPSHUP_INVALID_ARGUMENTS': 'Argumentos inválidos',
                'GUPSHUP_MISSING_BOT_CONFIG': 'Configuração de bot faltando',
                'GUPSHUP_UNEXPECTED_ERROR': 'Erro inesperado no processamento',
                'BOT_HISTORY_NOT_FOUND': 'Bot não encontrado',
                'BOT_HISTORY_TOO_MANY_BOTS_WITH_APP_NAME': 'Vários bots com o mesmo nome de aplicativo',
                'BOT_HISTORY_NOT_FOUND_BOT_WPP_CONFIG': 'configuração de bot WhatsApp não inválidas',
                ///Internal GlobalBot erros
                '9991': 'Bot sem configuração ou inexistente',
                '9992': 'Erro ao enviar mensagem para broker',
                '9997': 'Falha ao enviar a mensagem ao canal',
                '9998': 'Saldo de créditos insuficiente',
                '9990': 'Erro desconhecido',
                ///Gupshup errors
                '400': 'Em Conversa',
                '403': 'Em Conversa',
                '472': 'O número de telefone do usuário faz parte de um experimento',
                '471': 'Restrição aplicada pela META (Mensagens bloqueadas ou Sinalizadas como spam)',
                '500': 'Erro no server da broker favor contatar Globalbot',
                '1001': 'Remetente Inválido',
                '1002': 'Número Inexistente',
                '1003': 'Créditos Globalbot',
                '1004': 'Problema com Template HSM',
                '1005': 'Problema com Template HSM',
                '1006': 'Problema com Template HSM',
                '1007': 'Problema com Template HSM',
                '1026': 'Não entregável',
                '1008': 'Opt-out',
                '1010': 'URL inválida',
                '1011': 'Tamanho da Mídia Inválido',
                '1012': 'O envio da mensagem falhou porque o número de telefone optou por sair deste canal de comunicação.',
                '1013': 'Número Inexistente',
                '2000': 'Problema com Template HSM',
                '4002': 'Resposta inválida do WhatsApp',
                '4003': 'O envio da mensagem falhou porque o template não correspondia.',
                '4004': 'O tipo de mensagem só é compatível com API de nuvem hospedada Meta.',
                '4005': 'O envio da mensagem falhou porque o template está pausado.',
                ///META Errors
                //'400':'Erro de download de mídia - Falha ao baixar a mídia do remetente.',
                '402': 'Elegibilidade da empresa (problema de pagamento) - Falha ao enviar mensagem devido a um ou mais erros relacionados à forma de pagamento.',
                '408': 'A mensagem não é válida - Falha ao enviar a mensagem porque ela ficou pendente por muito tempo (por exemplo, mais de 1 dia). Isso pode acontecer ao reiniciar o cliente da WhatsApp Business API após mais de um dia de inatividade.',
                '410': 'Mensagem expirada - Mensagem não enviada durante seu TTL (tempo de vida).',
                '429': 'Limite de taxa atingido - o número enviou muitas mensagens.',
                '430': 'Certificado não assinado - Falha ao enviar a mensagem porque ocorreu um erro relacionado ao certificado.',
                '432': 'Incompatibilidade na identificação do certificado - Falha ao enviar a mensagem porque ocorreu um erro relacionado ao certificado.',
                '433': 'Assinatura de certificado inválida - Ocorre quando uma mensagem é enviada, mas o certificado do cliente da empresa não está assinado de forma adequada com as chaves de identidade correspondentes. Isso indica que o cliente provavelmente refez o cadastro com chaves de identidade novas, mas não concluiu todo o fluxo de criação do certificado.',
                '470': 'Mensagem de reengajamento - Falha ao enviar a mensagem porque mais de 24 horas se passaram desde a última vez que o cliente respondeu a este número.',
                //'471':'Limite de taxa de spam atingido - Falha ao enviar a mensagem porque há um limite de envios que podem ser feitos deste número de telefone. É possível que muitas mensagens anteriores tenham sido bloqueadas ou marcadas como spam.',
                //'472':'O número do usuário faz parte de um experimento - Falha ao enviar a mensagem porque o número de telefone do usuário faz parte de um',
                '480': 'Possível mudança de usuário - Falha ao enviar a mensagem devido a uma possível alteração no número de telefone do usuário.',
                //'500':'Erro genérico - Falha ao enviar a mensagem devido a um erro desconhecido.',
                '501': 'O tipo de mensagem não é aceito no momento. - Atualmente, as mensagens de documentos com legendas não são compatíveis.',
                '1000': 'Erro genérico',
                //'1001':'Mensagem muito longa - O tamanho da mensagem é superior a 4.096 caracteres.',
                //'1002':'Tipo de destinatário inválido - Tipos de destinatário válidos:',
                //'1004':'Recurso já existente - Possível conflito de UUID para solicitações de carregamento de mídia ou UUID já existente atribuído a outra mídia.',
                //'1005':'Acesso negado -',
                //'1006':'Recurso não encontrado - Arquivo ou recurso não encontrado.',
                //'1007':'Destinatário bloqueado para receber mensagens ( - O destinatário não está na lista de permissão.',
                //'1008':'Parâmetro obrigatório ausente - Um parâmetro obrigatório está ausente.',
                '1009': 'Valor do parâmetro inválido - O valor inserido para um parâmetro não é do tipo correto ou há outro problema.',
                //'1010':'Parâmetro não obrigatório - Contém um parâmetro que não é obrigatório.',
                //'1011':'O serviço não está pronto -',
                //'1013':'O usuário não é válido -',
                '1014': 'Erro interno',
                '1015': 'Número excessivo de solicitações - O limite de taxa do cliente foi atingido.',
                '1016': 'Sobrecarga do sistema - Se o sistema receber carga muito intensa, esse erro é retornado para permitir a recuperação do sistema.',
                '1017': 'Mestre não primário - Esse erro ocorre quando uma solicitação somente de nível mestre (como definir ou obter configurações, importar, exportar, solicitar código, registrar, entre outros) é enviada a um nó que não é um mestre primário. Isso poderá acontecer caso o cliente da WhatsApp Business API não esteja configurado corretamente ou se houver erros internos.',
                '1018': 'Coreapp não primário - Esse erro ocorre quando solicitações são enviadas a um nó do Coreapp que não é proprietário do fragmento nem está em vias de se tornar o proprietário. Você poderá ver esse erro quando estivermos fazendo failover de fragmento na configuração de multiconexão.',
                '1021': 'Usuário incorreto - Esse erro ocorre quando um usuário envia uma mensagem para si mesmo.',
                '1022': 'URL de webhooks não configurada - Esse erro ocorrerá se o formato de webhooks da API de REST não for configurado.',
                '1023': 'Erro de banco de dados',
                '1024': 'Alteração de senha solicitada - É necessário alterar a senha.',
                '1025': 'Solicitação inválida - A solicitação não é válida.',
                //'1026':'Destinatário indisponível - Mensagem não entregue. Consulte "Por que minha taxa de entrega não é de 100%?".',
                '1028': 'A notificação de sistema do tipo  - Você enviou uma mensagem a um usuário do WhatsApp que pode ter sido alterado. Uma notificação',
                '1031': 'A conta do remetente está bloqueada - Sua conta foi bloqueada e não poderá enviar mensagens devido a uma violação da política de integridade. Consulte',
                //'2000':'Incompatibilidade na contagem de parâmetros do modelo - O número de parâmetros fornecidos não corresponde à quantidade esperada.',
                '2001': 'Modelo ausente - O modelo não está com status de ativo ou não existe para um idioma e local.',
                '2002': 'Falha na busca do modelo - O destinatário falhou ao baixar o modelo.',
                '2003': 'Pacote de modelos ausente - Não há modelos para determinado idioma e localidade.',
                '2004': 'Parâmetro do modelo longo demais - O parâmetro é longo demais.',
                '2005': 'Texto hidratado do modelo longo demais - O texto traduzido é longo demais.',
                '2006': 'Política de espaço em branco do modelo violada - A política de espaço em branco foi violada.',
                '2007': 'Política de caracteres do formato do modelo violada - A política de caracteres do formato foi violada.',
                '2008': 'Formato de mídia do modelo incompatível - O formato de mídia usado não é compatível.',
                '2009': 'Componente obrigatório do modelo ausente - Um componente obrigatório do modelo não está presente.',
                '2010': 'URL hidratada do modelo inválida - A URL no componente de botão não é válida.',
                '2011': 'Número de telefone do modelo inválido - O número de telefone no componente de botão não é válido.',
                '2012': 'Incompatibilidade no formato do parâmetro do modelo - O formato do parâmetro não corresponde ao do modelo criado.',
                '2013': 'Botões do modelo incompatíveis - Os botões não são aceitos pelo destinatário.',
                '2014': 'O namespace esperado está vazio - Esse erro ocorre quando o pacote de idiomas de um modelo de mensagem ainda não foi baixado.',
                '2015': 'Número de seções inválido - O número de seções da solicitação de mensagem está abaixo ou acima do limite permitido. Consulte o',
                '2016': 'Número de linhas inválido - O número de linhas não é válido. Para',
                '2017': 'Política de caracteres violada - A política de caracteres do formato foi violada.',
                '2023': 'Número inválido de produto - O objeto da seção não tem produtos ou a contagem total de produtos ultrapassou o número máximo permitido.',
                '2024': 'Identificação de catálogo não encontrada - A identificação do catálogo fornecida não existe ou não pertence à sua conta do WhatsApp Business (WABA, pela sigla em inglês).',
                '2025': 'Identificação de catálogo não vinculada ao número da API - A identificação de catálogo que você forneceu não está vinculada ao número de telefone usado para enviar mensagens.',
                '2026': 'Produtos não encontrados - Alguns produtos fornecidos na sua solicitação não foram encontrados no catálogo.',
                '2027': 'Nenhum produto encontrado - Nenhum produto foi encontrado no catálogo fornecido.',
                '2028': 'Lista de todos os produtos com falha de conformidade',
                '2029': 'Lista de alguns produtos com falha de conformidade',
                '2030': 'Lista que combina produtos inválidos e com falha de conformidade',
                '2036': 'Estrutura de cabeçalho inválida - Esse erro é retornado quando a estrutura do',
                '2050': 'Informação de conformidade ausente',
                '2060': 'Modelo rejeitado - O status do modelo é ',
                '2061': 'Modelo em pausa - O status do modelo é',
                '2062': 'Modelo desabilitado - O status do modelo é',
                '2064': 'ID do Fluxo inválido - O fluxo com ID especificado não existe, não pertence à sua conta do WhatsApp Business ou está em estado inválido.',
                '2068': 'Fluxo bloqueado - O fluxo está no estado bloqueado.',
                '2069': 'Fluxo limitado - O fluxo está no estado limitado, e 10 mensagens usando esse fluxo já foram enviadas na última hora.',
                ///CLOUD API META ERROS https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes
                ///Erros de autorização
                '0': 'AuthException - Não foi possível autenticar o usuário do app.',
                '3': 'Método de API - Indica um problema que envolve recursos ou permissões.',
                '10': 'Permissão negada - A permissão não foi concedida ou foi removida.',
                '190': 'O token de acesso expirou.',
                '200': 'Permissão da API - A permissão não foi concedida ou foi removida.',
                '299': 'Permissão da API - A permissão não foi concedida ou foi removida.',
                ///Erros de limitação
                '4': 'O app atingiu o limite da taxa de chamadas de API. - O app atingiu o limite da taxa de chamadas de API.',
                '80007': 'A conta do WhatsApp Business atingiu o limite de volume. - A conta do WhatsApp Business atingiu o limite de volume.',
                '130429': 'A taxa de transferência de dados de mensagens da API de Nuvem foi atingida. - A taxa de transferência de dados de mensagens da API de Nuvem foi atingida.',
                '131048': 'Falha ao enviar a mensagem devido a um limite de envios que podem ser feitos deste número de telefone. É possível que muitas mensagens anteriores tenham sido bloqueadas ou marcadas como spam. - Falha ao enviar a mensagem devido a um limite de envios que podem ser feitos deste número de telefone. É possível que muitas mensagens anteriores tenham sido bloqueadas ou marcadas como spam.',
                '131056': 'Foram enviadas muitas mensagens do número de telefone do remetente para o mesmo número de telefone do destinatário em um curto período. - Foram enviadas muitas mensagens do número de telefone do remetente para o mesmo número de telefone do destinatário em um curto período.',
                '133016': 'O registo ou a exclusão do registro falhou porque foram feitas muitas tentativas neste número de telefone em um curto período de tempo. - O registo ou a exclusão do registro falhou porque foram feitas muitas tentativas neste número de telefone em um curto período de tempo.',
                ///Erros de integridade
                '368': 'Bloqueado temporariamente por violações de políticas - A conta do WhatsApp Business associada ao app foi restringida ou desabilitada por violar uma política da plataforma.',
                '131031': 'Conta bloqueada - A conta do WhatsApp Business associada ao app foi restringida ou desabilitada por violar uma política da plataforma. Ou então, não foi possível verificar os dados incluídos na solicitação em relação ao conjunto de dados na conta do WhatsApp Business (por exemplo, o pin de duas etapas incluído na solicitação está incorreto).',
                ///Outros erros
                '1': 'Há uma solicitação inválida ou um possível erro de servidor. - Há uma solicitação inválida ou um possível erro de servidor.',
                '2': 'Há um erro temporário por inatividade ou sobrecarga. - Há um erro temporário por inatividade ou sobrecarga.',
                '33': 'O número de telefone comercial foi excluído. - O número de telefone comercial foi excluído.',
                '100': 'O pedido incluía um ou mais parâmetros incompatíveis ou escritos de forma errada. - O pedido incluía um ou mais parâmetros incompatíveis ou escritos de forma errada.',
                '130472': 'A mensagem não foi enviada como parte de um experimento.',
                '131000': 'Falha ao enviar a mensagem devido a um erro desconhecido. - Falha ao enviar a mensagem devido a um erro desconhecido.',
                '131005': 'A permissão não foi concedida ou foi removida. - A permissão não foi concedida ou foi removida.',
                '131008': 'Falta um parâmetro obrigatório no pedido. - Falta um parâmetro obrigatório no pedido.',
                '131009': 'Um ou mais valores de parâmetros são inválidos. - Um ou mais valores de parâmetros são inválidos.',
                '131016': 'Um serviço está temporariamente indisponível. - Um serviço está temporariamente indisponível.',
                '131021': 'O número de telefone do destinatário e do remetente é o mesmo. - O número de telefone do destinatário e do remetente é o mesmo.',
                '131026': 'Não foi possível entregar a mensagem. Os motivos podem ser os seguintes: - O número de telefone do destinatário não está registrado no WhatsApp. / Houve tentativa de envio de um modelo de autenticação a um usuário do WhatsApp com o código de ligação de país +91 (Índia). Atualmente, não é possível enviar modelos de autenticação a usuários do WhatsApp na Índia.  / O destinatário não aceitou os novos Termos de Serviço e a nova Política de Privacidade. / O destinatário está usando uma versão antiga do WhatsApp / A mensagem não foi entregue para criar uma experiência de alta qualidade para o usuário.',
                '131042': 'Ocorreu um erro relacionado à forma de pagamento. - Ocorreu um erro relacionado à forma de pagamento.',
                '131045': 'Ocorreu uma falha ao enviar a mensagem devido a um erro de registro do número de telefone. - Ocorreu uma falha ao enviar a mensagem devido a um erro de registro do número de telefone.',
                '131047': 'Mais de 24 horas se passaram desde que o destinatário respondeu pela última vez ao número do remetente. - Mais de 24 horas se passaram desde que o destinatário respondeu pela última vez ao número do remetente.',
                '131049': 'A Meta escolheu não entregar a mensagem, para manter o engajamento saudável do ecossistema. - Ao receber este código de erro, não tente enviar a mensagem de novo imediatamente se suspeitar que o problema é relacionado ao limite. Em vez disso, tente novamente aplicando incrementos de tempo maiores até que a mensagem seja entregue, já que o limite talvez esteja em vigor por diferentes períodos. Consulte Limites de mensagem de modelo de marketing por usuário para saber mais.',
                '131050': 'Não é possível entregar a mensagem. O destinatário interrompeu o recebimento de mensagens de marketing da sua empresa no WhatsApp. - Não tente enviar mensagens novamente, já que elas não serão recebidas por este usuário.',
                '131051': 'O tipo de mensagem não é compatível. - O tipo de mensagem não é compatível.',
                '131052': 'Não foi possível baixar a mídia enviada pelo usuário. - Não foi possível baixar a mídia enviada pelo usuário.',
                '131053': 'Não foi possível carregar a mídia por algum dos seguintes motivos: Tipo não aceito, Mídia muita grande (Imagem: 5MB, Vídeo/Áudio: 16MB, Documentos: 100MB).',
                '131057': 'A conta comercial está em modo de manutenção. - A conta comercial está em modo de manutenção.',
                '132000': 'O número de valores de parâmetros variáveis incluídos na solicitação não corresponde ao número de parâmetros variáveis definidos no modelo. - O número de valores de parâmetros variáveis incluídos na solicitação não corresponde ao número de parâmetros variáveis definidos no modelo.',
                '132001': 'O modelo não existe no idioma especificado ou não foi aprovado. - O modelo não existe no idioma especificado ou não foi aprovado.',
                '132005': 'O texto traduzido é longo demais. - O texto traduzido é longo demais.',
                '132007': 'O conteúdo do modelo viola uma política do WhatsApp. - O conteúdo do modelo viola uma política do WhatsApp.',
                '132012': 'Os valores de parâmetros variáveis foram formatados incorretamente. - Os valores de parâmetros variáveis foram formatados incorretamente.',
                '132015': 'O modelo foi pausado por  - O modelo foi pausado por ',
                '132016': 'O modelo foi pausado muitas vezes por  - O modelo foi pausado muitas vezes por ',
                '132018': 'O parâmetro text não pode conter quebras de linha, tabulações ou mais de 4 espaços consecutivos.',
                '132068': 'O fluxo está no estado bloqueado. - O fluxo está no estado bloqueado.',
                '132069': 'O fluxo está no estado limitado, e 10 mensagens usando esse fluxo já foram enviadas na última hora. - O fluxo está no estado limitado, e 10 mensagens usando esse fluxo já foram enviadas na última hora.',
                '133000': 'Uma tentativa anterior de cancelamento do registro falhou. - Uma tentativa anterior de cancelamento do registro falhou.',
                '133004': 'O servidor está temporariamente indisponível. - O servidor está temporariamente indisponível.',
                '133005': 'O PIN de confirmação em duas etapas está incorreto. - O PIN de confirmação em duas etapas está incorreto.',
                '133006': 'O número de telefone precisa ser verificado antes do registro. - O número de telefone precisa ser verificado antes do registro.',
                '133008': 'Ocorreram muitas tentativas do PIN de confirmação em duas etapas para este número de telefone. - Ocorreram muitas tentativas do PIN de confirmação em duas etapas para este número de telefone.',
                '133009': 'O PIN de confirmação em duas etapas foi inserido muito rapidamente. - O PIN de confirmação em duas etapas foi inserido muito rapidamente.',
                '133010': 'O número de telefone não está registrado na Plataforma do WhatsApp Business. - O número de telefone não está registrado na Plataforma do WhatsApp Business.',
                '133015': 'O número de telefone que você está tentando registrar foi excluído recentemente, e a exclusão ainda não foi concluída. - O número de telefone que você está tentando registrar foi excluído recentemente, e a exclusão ainda não foi concluída.',
                '135000': 'Falha ao enviar a mensagem devido a um erro desconhecido no servidor da META. Entre em contato com o suporte@globalbot.com.br',
              },
              internalError: 'Erro Interno',
              totalEmails: 'Total de e-mails efetivamente enviados, descontando os endereços de e-mail inválidos e descartados pelo serviço de disparo de e-mails.',
              handedOut: 'Entregues',
              handedOutDesc: 'Total de destinatários que tiveram a mensagem entregue pelo WhatsApp aos dispositivos dos clientes.',
              handedOutDesc2: 'Porcentagem referente ao total de Enviadas.',
              receivedTheEmail: 'Total de destinatários que receberam o e-mail, descontando os que ocorreram bounce. A porcentagem é sobre o número de e-mails enviados.',
              softBounce: 'Soft Bounce',
              totalEmailsNotHandedTemporary: 'Total de e-mails que não foram entregues por razões temporárias, tais como: caixa de entrada cheia do destinatário ou servidor offline do destinatário. O provedor de e-mail tentará enviar novamente a mensagem durante as próximas 72h. A porcentagem é sobre o número de e-mails enviados.',
              hardBounce: 'Hard Bounce',
              totalEmailsNotHandedPermanent: 'Total de e-mails que não foram entregues por razões permanentes, tais como: e-mails inexistentes ou bloqueio por parte do servidor de e-mail do destinatário, por considerá-lo spam. A porcentagem é sobre o número de e-mails enviados.',
              engagement: 'Engajamento',
              openings: 'Aberturas',
              totalUniqueEmailOpenings: 'Total de aberturas únicas do e-mail. A porcentagem é sobre o número de e-mails entregues.',
              clicks: 'Cliques',
              totalClickUnique: 'Total de cliques únicos em links do e-mail. A porcentagem é sobre o número de e-mails abertos.',
              markedSpam: 'Marcados como spam',
              totalMarkedSpam: 'Total de usuários que marcaram este e-mail como Spam. A porcentagem é sobre o número de e-mails entregues.',
              unsubscriptions: 'Descadastramentos',
              totalUnsubscriptions: 'Total de usuários que cancelaram a inscrição a partir do e-mail enviado. A porcentagem é sobre o número de e-mails entregues.',
              totalRecipientsSent: 'Total de destinatários com mensagem efetivamente enviada, descontando os destinatários descartados por conterem números inválidos ou inexistentes.',
              totalRecipientsSms: 'Total de destinatários que tiveram a mensagem entregue pelas operadoras de SMS.',
              totalRecipientsNotSend: 'Total de destinatários que não foi possível entregar a mensagem por razões permanentes, tais como: conter número inválido ou inexistente.',
              waiting: 'Aguardando',
              numberOfRecipientsWaiting: 'Número de destinatários que ainda estão aguardando o processo de envio ser finalizado.',
              handedOutServer: 'Entregues (Servidor)',
              totalRecipientsFromGlobalbotToWhatsapp: 'Total de destinatários que tiveram a mensagem entregue pela Globalbot ao servidor do WhatsApp.',
              handedOutDevice: 'Entregues (Dispositivo)',
              totalRecipientsFromWhatsappToClients: 'Total de destinatários que tiveram a mensagem entregue pelo WhatsApp aos dispositivos dos clientes.',
              totalRecipientsNotHandedTemporary: 'Total de destinatários cujas mensagens não foram entregues por razões temporárias, tais como: destinatário está em sessão de conversa aberta. O sistema tentará enviar novamente a mensagem durante as próximas 24h. A porcentagem é sobre o número de destinatários enviados.',
              preview: 'Visualização',
              totalRecipientsViewedMessage: 'Total de destinatários que efetivamente visualizou a mensagem.',
              important: 'Importante:',
              messageImportantOne: ' Você deve importar uma lista no formato de arquivo .CSV, lembrando que para envios SMS e',
              messageImportantTwo: 'WhatsApp o campo "telefone" (phone) é obrigatório.',
              /// Variante exibida quando o bot tem envio por BSUID habilitado
              /// (integrations.whatsapp.bsuid.sendByBsuid).
              messageImportantTwoBsuid: 'WhatsApp: informe a coluna "phone" (telefone) ou "bsuid" — ao menos uma por linha.',
              messageImportantThree: 'Para os envios de e-mail o campo "email" também é obrigatório.',
              messageImportantFour: 'Para os envios de WhatsApp é obrigatório o número de telefone ter o DDI do usuário, exemplo: 554899999999 (Brasil)',
              messageImportantFourBsuid: 'Para os envios de WhatsApp é obrigatório o número de telefone ter o DDI do usuário, exemplo: 554899999999 (Brasil). Quando usar "bsuid", informe o identificador completo, exemplo: IN.1648738043044942',
              totalFound: 'Encontramos um total de ',
              finish: 'Encerrar',
              finishEdit: 'Encerrar Edição',
              finishEditQuestion: 'O que deseja fazer?',
              items: ' itens.',
              import: 'Importar',
              modelSelectedNotHaveChannel: 'O modelo selecionado não tem um canal, por favor crie novamente um novo modelo.',
              modelSelectedNotMessageValid: 'O modelo selecionado não tem mensagem válida, favor verificar a mensagem deste modelo.',
              notIncludeDomain: 'Não inclua o domínio nos campos "remetente" e "responder para", esses campos são selecionados através dos domínios autorizados!',
              weNeedDomain: 'Infelizmente precisamos de um domínio autorizado para continuar, você pode autenticar um nas preferências.',
              fieldsNeedFilledOne: 'O campo nome, remetente, responder para, e listas ou filtros precisam ser preenchidos!',
              selectServer: 'Por favor selecione um servidor, caso não tenha, solicite um com a Globalbot!',
              fieldsNeedFilledTwo: 'O campo nome e listas ou filtros precisam ser preenchidos!',
              dispatchSaved: 'Seu envio foi salvo!',
              draftSaved: 'Seu envio foi salvo!',
              messageErrorConnection: 'Oops, ocorreu um erro de conexão!',
              testDispatchProcessing: 'Seu teste está sendo processado, espere por volta de 1 minuto.',
              columnEmailRequired: 'A coluna de "email" é obrigatório.',
              columnPhoneRequired: 'A coluna de "phone" é obrigatório.',
              columnPhoneOrBsuidRequired: 'A coluna "phone" ou "bsuid" é obrigatória para este canal.',
              bsuidLabel: 'BSUID do cliente',
              contact: 'Contato',
              messageError: 'Oops, ocorreu algum erro.',
              listSaved: 'Sua lista foi salva!',
              exportData: 'Você realmente deseja exportar todos os seus registros?',
              hasConversation: 'Conversa',
              hasConversationTooltip: 'Confira se uma conversa foi gerada a partir deste envio de WhatsApp',
              emailInvalid: 'E-mail inválido. Por favor, verifique o e-mail e tente novamente.',
              requiredField: 'Campo obrigatório.'
            },
            list: {
              title: 'Título *',
              toggleLabel: 'Alterar rótulo',
              filter: 'Filtro *',
              save: 'Salvar',
              messageError: 'Oops, ocorreu algum erro.',
              listSaved: 'Sua lista foi salva!',
              messageErrorConnection: 'Oops, ocorreu um erro de conexão',
              fieldsRequired: 'Os campos campanha, assunto e email de origem precisam ser preenchidos!'
            }
          },
          conversation: {
            save: 'Salvar',
            session: 'Sessão',
            hasAttachments: 'Contém Anexo(s)',
            cancel: 'Cancelar',
            saveSuccess: 'Alterações salvas!',
            saveError: 'Erro ao salvar as alterações.',
            conversationData: 'Dados da Conversa',
            sections: {
              conversationData: 'Dados da Conversa',
              kanbanBoards: 'Quadros Kanban',
              identifiersAndFields: 'Identificadores e Campos'
            },
            summary: {
              title: 'Resumo da Conversa',
              newBadge: 'Novo',
              disclaimer: 'O resumo é gerado automaticamente por Inteligência Artificial e pode conter imprecisões. Recomendamos consultar o histórico da conversa quando necessário.',
              generate: 'Gerar Resumo',
              generating: 'Gerando resumo. Conversas longas podem levar alguns segundos.',
              refresh: 'Atualizar Resumo',
              generatedAt: 'Gerado em {date}',
              loadError: 'Não foi possível carregar o resumo da conversa.',
              generateFailed: 'Não foi possível gerar o resumo.',
              noMessages: 'Esta conversa ainda não tem mensagens para resumir.',
              notFound: 'Conversa não encontrada.',
              timeout: 'O resumo está demorando mais que o esperado.',
              supportCode: 'Código para o suporte: {errorId}',
              retry: 'Tentar novamente',
              availableIn: 'Disponível em {time}',
              originNotAllowed: 'O resumo só pode ser gerado pelo painel, no navegador.'
            },
            protocol: 'Protocolo',
            identifierId: 'Identificador',
            attendants: 'Atendente(s)',
            tags: 'Tags',
            device: 'Dispositivo',
            dispatchEmail: 'Email de lead enviado',
            dispatchEmailToClient: 'Email enviado para o cliente',
            emailViewedByClient: 'Email visualizado pelo cliente',
            dateAndHour: 'Data e Hora',
            channel: 'Canal',
            satisfaction: 'Satisfação',
            punctuation: 'Pontuação',
            whatsappPhone: 'WhatsApp Telefone',
            search: 'Pesquisar',
            location: 'Localização',
            origin: 'Origem',
            campaigns: 'Campanhas',
            messageSent: 'Mensagem enviada:',
            comments: 'Comentários',
            messageNotFound: 'Infelizmente não achamos essa conversa.',
            messageTryAgain: 'Oops, tivemos um problema ao recuperar essa conversa, tente novamente. Caso o erro persista por favor entre em contato.',
            metaCampaigns: 'Dados da Campanha META',
            openMedia: 'Abrir mídia',
            accessConversation: 'Acessar conversa',
            phoneUnavailable: 'Telefone indisponível: contato identificado por BSUID (Meta).',
            clickToWhatsAppClientId: 'ID do cliente Click to WhatsApp'
          },
          integration: {
            save: 'Salvar',
            cancel: 'Cancelar',
            integrationDetails: 'Detalhes da integração',
            activeIntegration: 'Integração ativa',
            identifier: 'Identificador',
            hash: 'Hash',
            token: 'Token',
            hasToken: 'Possui API token',
            webhook: 'Webhook',
            host: 'Host',
            key: 'Key',
            haveRestriction: 'Tem restrição?',
            contactPurpose: 'Coloque abaixo os valores do botão "Objetivo do contato" que você não deseja que vá ao VistaSoft',
            add: 'Adicionar',
            customIdFields: 'Defina abaixo os ids dos campos personalizados e seus identificadores, exemplo %NAME%.',
            idField: 'Id do campo ',
            websiteAddress: 'Endereço do site',
            userProvidedByKSI: 'Usuário fornecido pela KSI',
            passwordProvidedByKSI: 'Senha fornecida pela KSI',
            salesFlow: 'Fluxo de Venda',
            salesFlowValue: 'Qual o identificador que tem o valor de venda no fluxo?',
            salesValue: 'Valor do identificador de venda',
            createIdSales: 'Crie um id padrão de imóvel de venda e coloque aqui',
            rentalFlow: 'Fluxo de Aluguel',
            rentalFlowValue: 'Qual o identificador que tem o valor de aluguel no fluxo?',
            rentalValue: 'Valor do identificador de aluguel',
            createIdRental: 'Crie um id padrão de imóvel de aluguel e coloque aqui',
            releasesFlow: 'Fluxo de Lançamentos',
            releasesFlowValue: 'Qual o identificador que tem o valor de lançamento no fluxo?',
            releasesValue: 'Valor do identificador de lançamento',
            createIdSalesInReleases: 'Crie um id padrão de imóvel de venda e coloque lançamento',
            endpoint: 'Endpoint',
            enterprises: 'Empreendimento',
            sendToAttendant: 'Enviar ao atendente',
            includeInternalMessages: 'Incluir mesagens internas',
            enterpriseId: 'ID do Empreendimento',
            subdomain: 'Subdomínio',
            clientSecret: 'Client_Secret',
            clientId: 'Client_Id',
            code: 'Code',
            user: 'Usuário',
            password: 'Senha',
            project: 'Projeto',
            problemType: 'Tipo do problema',
            customField: 'Campo Customizado',
            customFieldValue: 'Valor do campo customizado',
            title: 'Título (opcional)',
            sendOnlyLivechat: 'Enviar conversas apenas do Livechat',
            loadLink: 'Link da carga',
            savedPreferences: 'Preferência salva com sucesso',
            hasForms: 'Possui formulário',
            formId: 'ID do formulário',
            textFormId: 'ID do formulário que está presente no zendesk na aba de "Configurações" na página "Formulários de ticket", após selecionar o seu formulário o ID do mesmo estara presente na URL após o /edit.',
            fieldId: 'ID do campo',
            textFieldId: 'ID do campo que está presente no zendesk na aba de "Configurações" na página "Campos de ticket", após entrar na página o ID do campo estará ao lado do nome.',
            responsible: 'Responsável(Id)',
            createdBy: 'Criado por(Id)',
            businessPhaseId: 'Fase de negócios(Id)',
            salerCode: 'Código do vendedor',
            methodologyCode: 'Código da metodologia',
            salesChannelCode: 'Código do canal de vendas',
            baseURL: 'URL base. ex: https://sua-loja-de-desenvolvimento.myshopify.com',
            integrationTriggers: 'Acionadores da integração',
            integrationTriggersDescription: 'Defina quando a integração será acionada (POST).',
            integrationTriggerFinish: 'Quando a conversa for finalizada (pelo chatbot ou atendente)',
            integrationTriggerAttendant: 'Quando o atendente assumir a conversa',
            integrationTriggerNote: 'A integração dependerá das regras definidas no sistema de destino. Caso mais de uma opção seja marcada, a integração será disparada mais de uma vez, portanto para não haver duplicação de registros, o sistema de destino deverá tratar esta informação.',
            pipedriveReferral: {
              title: 'Atribuição de anúncio (Click to WhatsApp)',
              description: 'Quando a conversa começa por um anúncio do Facebook ou Instagram com o botão "Enviar mensagem no WhatsApp", o Globalbot recebe os dados desse anúncio. Aqui você define em qual campo personalizado do negócio no Pipedrive cada dado será gravado.',
              instructions: 'Em cada linha, escolha à esquerda o campo do negócio no Pipedrive e à direita o valor do Globalbot que será gravado nele. Só aparecem campos personalizados do tipo texto criados na sua conta Pipedrive. O campo só é preenchido quando o valor existir na conversa.',
              loadFields: 'Buscar campos do Pipedrive',
              loadFieldsTooltip: 'Busca os campos personalizados de texto usando o token informado acima.',
              loadFieldsTokenRequired: 'Informe o token do Pipedrive acima para buscar os campos.',
              beforeFetch: 'Clique em "Buscar campos do Pipedrive" para carregar os campos personalizados de texto da sua conta.',
              dealField: 'Campo do negócio (Pipedrive)',
              globalbotValue: 'Valor do Globalbot',
              addRow: 'Adicionar mapeamento',
              addRowDisabled: 'Todos os campos personalizados de texto disponíveis já foram mapeados.',
              removeRow: 'Remover mapeamento',
              emptyFields: 'Nenhum campo personalizado de texto foi encontrado nesta conta. No Pipedrive, acesse Configurações > Campos de dados > Negócio, crie um campo do tipo Texto e busque os campos novamente.',
              errorInvalidToken: 'Não foi possível acessar o Pipedrive com este token. Confira o token informado acima e tente novamente.',
              errorRateLimited: 'Muitas buscas seguidas. Aguarde um minuto e tente novamente.',
              errorGeneric: 'Não foi possível buscar os campos do Pipedrive agora. Tente novamente em alguns instantes.',
              fieldMissingSuffix: '(não encontrado no Pipedrive)',
              fieldMissing: 'Este campo não existe mais no Pipedrive. Escolha outro campo ou remova o mapeamento.',
              values: {
                headline: 'Título do anúncio',
                body: 'Texto do anúncio',
                sourceType: 'Tipo de origem do anúncio',
                sourceId: 'ID do anúncio',
                sourceUrl: 'URL do anúncio',
                mediaType: 'Tipo de mídia do anúncio',
                mediaUrl: 'URL da mídia do anúncio',
                imageUrl: 'URL da imagem do anúncio',
                videoUrl: 'URL do vídeo do anúncio',
                thumbnailUrl: 'URL da miniatura do anúncio',
                ctwaClid: 'ID do clique Click to WhatsApp (ctwa_clid)',
                total: 'Total de anúncios na conversa'
              }
            },
            eventWebhook: {
              title: 'Webhook de eventos',
              intro: 'A Globalbot vai chamar a URL abaixo a cada evento selecionado, com o corpo assinado (HMAC-SHA256 no header X-Globalbot-Signature). Seu endpoint precisa responder 2xx.',
              active: 'Webhook ativo',
              name: 'Nome (só para você identificar)',
              url: 'URL do endpoint (https)',
              urlHint: 'Só https. Redirecionamentos não são seguidos.',
              events: 'Eventos que você quer receber',
              eventLabels: {
                'message.status.enqueued': 'Mensagem enfileirada',
                'message.status.sent': 'Mensagem enviada',
                'message.status.delivered': 'Mensagem entregue',
                'message.status.read': 'Mensagem lida',
                'message.status.failed': 'Falha no envio',
                'message.status.deleted': 'Mensagem apagada'
              },
              eventsRequired: 'Selecione ao menos um evento.',
              notifyTitle: 'Quem avisar se o webhook for desativado',
              notifyUsers: 'Usuários da conta',
              notifyEmails: 'Outros e-mails',
              notifyEmailsHint: 'Digite e pressione Enter. Sem ninguém selecionado, avisamos os administradores da conta.',
              invalidEmail: 'E-mail inválido',
              terms: 'Declaro que tenho base legal para receber estes dados (que podem incluir telefone e identificador do contato) no endpoint informado, e que sou responsável pela segurança dele.',
              termsRequired: 'Para ativar, é preciso aceitar a declaração acima.',
              secretTitle: 'Secret da assinatura',
              secretCurrent: 'Secret atual',
              secretNone: 'O secret é gerado ao salvar pela primeira vez.',
              secretShownOnce: 'Copie agora: por segurança, o secret não será mostrado de novo. Se perder, gere um novo.',
              copy: 'Copiar',
              copied: 'Copiado',
              rotate: 'Gerar novo secret',
              rotateConfirm: 'Gerar um novo secret invalida o atual imediatamente: seu endpoint vai rejeitar as assinaturas até você atualizar o valor lá. Continuar?',
              test: 'Enviar evento de teste',
              testHint: 'Envia um evento message.status.delivered marcado como teste (test: true) para a URL salva.',
              testOk: 'Seu endpoint respondeu {status} em {ms} ms.',
              testFail: 'Falha: {detail}',
              testBlocked: 'URL recusada pela nossa proteção: {detail}. Use um endereço público em https.',
              testSaveFirst: 'Salve a configuração antes de testar.',
              health: { active: 'Ativo', failing: 'Com falhas', disabled: 'Desativado automaticamente', inactive: 'Desligado' },
              healthLastError: 'Último erro',
              healthLastDelivery: 'Última entrega',
              healthFailures: 'Falhas consecutivas',
              propagation: 'Alterações levam até 2 minutos para valer em todos os servidores.',
              reactivated: 'Webhook reativado. O contador de falhas foi zerado; eventos perdidos durante a desativação não são reenviados.',
              saved: 'Webhook salvo.',
              atLeastOnce: 'Entregas podem se repetir: use o campo deliveryId para descartar duplicatas.',
              permissionDenied: 'Só administradores da conta podem configurar o webhook de eventos.',
              loadError: 'Não foi possível carregar a configuração do webhook.',
              removedUser: 'Usuário removido',
              fieldErrors: {
                required: 'Campo obrigatório.',
                'too-long': 'Valor muito longo.',
                malformed: 'URL inválida.',
                'not-https': 'A URL precisa começar com https://.',
                'credentials-in-url': 'A URL não pode conter usuário e senha.',
                'local-host': 'Use um endereço público; hosts locais não são aceitos.',
                'at-least-one': 'Selecione ao menos um evento.',
                'not-an-array': 'Lista de eventos inválida.',
                'invalid-email': 'Há um e-mail inválido na lista.',
                'invalid-id': 'Há um usuário inválido na lista.',
                'not-in-account': 'Há um usuário que não pertence a esta conta.',
                'too-many': 'Destinatários demais.',
                'required-to-activate': 'Para ativar, é preciso aceitar a declaração.',
                generic: 'Valor inválido.'
              },
              testReasons: {
                'test-unavailable': 'envio de teste temporariamente indisponível',
                'no-whatsapp': 'este bot não tem integração com WhatsApp',
                'bot-not-found': 'bot não encontrado',
                'subscription-not-found': 'configuração não encontrada; salve antes de testar',
                'endpoint-error': 'seu endpoint não respondeu 2xx',
                'internal-error': 'erro interno ao enviar o teste',
                generic: 'não foi possível enviar o evento de teste'
              }
            },
          },
          knowledge: {
            close: 'Fechar',
            cancel: 'Cancelar',
            answered: 'Respondidas',
            unambiguous: 'Desambiguadas',
            unanswered: 'Não respondidas',
            outContext: 'Fora de contexto',
            channel: 'Canal',
            date: 'Data',
            question: 'Pergunta',
            media: 'Mídia',
            response: 'Resposta',
            responsible: 'Responsável',
            createdBy: 'Criado por',
            testEnvironment: 'Ambiente de teste',
            mode: 'Modo',
            test: 'Teste',
            public: 'Público'
          },
          liveAttendants: {
            close: 'Fechar',
            attendants: 'Atendentes',
            avatar: 'Avatar',
            attendance: 'Conversas ativas',
            name: 'Nome',
            departments: 'Departamentos',
            role: 'Cargo',
            away: 'Away',
            clear: 'Limpar',
            offline: 'Offline',
            rooms: 'Salas ativas',
            actions: 'Ações'
          },
          connectedUsers: {
            close: 'Fechar',
            users: 'Usuários conectados',
            avatar: 'Avatar',
            attendance: 'Conversas ativas',
            name: 'Nome',
            departments: 'Departamentos',
            role: 'Cargo',
            away: 'Away',
            clear: 'Limpar',
            offline: 'Offline',
            rooms: 'Salas ativas',
            actions: 'Ações'
          },
          liveConfig: {
            save: 'Salvar',
            cancel: 'Cancelar',
            settings: 'Configurações',
            soundNewAttendance: 'Som de novo atendimento',
            messageSoundReceived: 'Som de mensagem recebida',
            listOrdering: 'Ordenação de lista',
            ascendingArrivalDate: 'Data de chegada crescente',
            descendingArrivalDate: 'Data de chegada decrescente',
            lastMessageCrescent: 'Última mensagem crescente',
            lastMessageDecreasing: 'Última mensagem decrescente',
            crescentGroup: 'Por grupo crescente',
            decreasingGroup: 'Por grupo decrescente',
            amountMessageCrescent: 'Quantidade de mensagens crescente',
            amountMessageDecreasing: 'Quantidade de mensagens decrescente',
            activeTimer: 'Habilitar Cronômetro',
            totalTimeOfAttendant: 'Tempo total de atendimento',
            lastClientInteraction: 'Contador de última interação do cliente',
            exhibitionAlertTime: 'Limite do Aviso de Alerta',
            minutes: 'minutos',
            alertTimeAttendance: 'Atendimento excedendo limite'
          },
          notifications: {
            notifications: 'Central de Notificações',
            noNotifications: 'Não há notificações para você no momento.',
            HSM_TEST: {
              label: {
                error: 'Falha',
                delivered: 'Sucesso!'
              },
              title: {
                error: 'Envio de HSM Teste',
                delivered: 'Envio de HSM Teste'
              },
              message: {
                error: 'Falha no envio de HSM teste, não foi entregue para o usuário.',
                delivered: 'O teste de HSM foi enviado com sucesso e entregue para o usuário.'
              }
            }
          }
        },
        dashboard: {
          connectedUsers: 'Usuários Conectados',
          connectedUsersTip: 'Confira os usuários que estão conectados na plataforma Globalbot neste momento.'
        },
        editable: {
          carousel: {
            idealResolution: 'Resolução ideal',
            librarySearch: 'Buscar na biblioteca',
            key: 'Chave',
            value: 'Valor',
            jump: 'Salto',
            title: 'Título',
            description: 'Descrição',
            select: 'Selecionar',
            image: 'Imagem',
            buttons: 'Botões'
          }
        },
        emailBuilder: {
          add: {
            campaigns: 'Campanhas ',
            addEmail: ' Adicionar e-mail',
            subject: 'Assunto *',
            sender: 'Remetente *',
            replyTo: 'Responder para',
            tags: 'Tags',
            save: 'Salvar',
            attendanceRealized: 'Atendimento Realizado',
            attendanceProtocol: 'Protocolo de atendimento',
            historic: 'Histórico',
            templateSaved: 'Seu template foi salvo!',
            messageErrorConnection: 'Oops, ocorreu um erro de conexão!',
            fieldsRequired: 'Os campos campanha, assunto e email de origem precisam ser preenchidos!'
          },
          emailBuilder: {
            messageEmailSaved: 'Mensagens de email salvas',
            subject: 'Assunto: ',
            addNewTemplate: 'Adicionar novo template'
          }
        },
        lists: {
          push: {
            insertList: 'Inserir em Lista',
            list: 'Lista',
            cancel: 'Cancelar',
            insert: 'Inserir',
            updatedList: 'Lista atualizada!',
            failedUpdateList: 'Falha ao atualizar lista!'
          }
        },
        live: {
          container: {
            message: {
              replied: {
                you: 'Você',
                video: 'Vídeo',
                audio: 'Áudio',
                loading: 'Carregando mensagem respondida...',
                unavailable: 'Mensagem respondida não disponível',
                outOfHistory: 'Carregue mais mensagens para ir até ela',
              },
              cards: {
                startConversation: 'Iniciar Conversa',
                insertList: 'Inserir em Lista'
              },
              media: {
                speechToText: 'Speech to Text (transcrição de áudio para texto)',
                notSupport: 'O seu navegador não tem suporte, por favor use o Chrome.',
                notRegistered: 'Não registrado',
                openOriginalImage: 'Abrir imagem original',
                downloadVideo: 'Baixar vídeo',
                downloadError: 'Não foi possível baixar o arquivo. Tente novamente.'
              },
              yesterday: 'Ontem',
              today: 'Hoje',
              hsmYesterday: 'HSM enviado ontem',
              hsmToday: 'HSM enviado hoje',
              hsmSent: 'HSM enviado',
              userNotFound: 'Usuário não encontrado',
              status: {
                noSubmitted: 'Mensagem não enviada(clique para tentar novamente)',
                sending: 'Enviando mensagem',
                sended: 'Mensagem enviada',
                delivered: 'Mensagem entregue',
                read: 'Mensagem lida',
                fail: 'Mensagem falhou'
              },
              openInNewTab: 'Abrir em nova guia',
              networkRequired: 'Você precisa estar conectado para enviar a mensagem novamente.',
              queuePositionFail: 'Não foi possível enviar a mensagem, pois a última interação do usuário ocorreu há mais de 24 horas.',
              systemMessageSuppressed: 'Mensagem não enviada ao cliente: desativada em Configurações › Chat ao Vivo › Mensagens. Registrada apenas para auditoria.',
              systemMessageSuppressedByFlowNode: 'Mensagem não enviada ao cliente: persistência desativada neste nó do fluxo ({step}). Registrada apenas para auditoria.',
              persistenceFirstNotice: '1º aviso',
              persistenceSecondNotice: '2º aviso',
              serviceMessageBilling: 'Service Message: Esta mensagem está categorizada como Service pela Meta (WhatsApp). Estas mensagens passarão a ser cobradas unitariamente a partir de 01 de outubro de 2026. É necessária inclusão de Créditos Meta WhatsApp na plataforma para continuidade da operação.',
              balanceBlocked: {
                ariaLabelMessage: 'Mensagem não enviada: saldo de créditos insuficiente',
                ariaLabelConversation: 'Conversa com mensagem não enviada por saldo de créditos insuficiente',
                messageBefore: 'Esta mensagem WhatsApp não pode ser enviada pois o saldo de créditos é insuficiente. Favor carregar créditos em',
                conversationBefore: 'Uma mensagem WhatsApp desta conversa não pôde ser enviada pois o saldo de créditos é insuficiente. Favor carregar créditos em',
                after: 'para reativar a operação. (Conforme novas regras da Meta válidas desde 1/10/26).',
                /// conta mini-globalbot não tem o menu Preferências > Consumo WhatsApp
                miniMessage: 'Esta mensagem WhatsApp não pode ser enviada pois o saldo de créditos é insuficiente. Entre em contato com a equipe de suporte para carregar créditos e reativar a operação. (Conforme novas regras da Meta válidas desde 1/10/26).',
                miniConversation: 'Uma mensagem WhatsApp desta conversa não pôde ser enviada pois o saldo de créditos é insuficiente. Entre em contato com a equipe de suporte para carregar créditos e reativar a operação. (Conforme novas regras da Meta válidas desde 1/10/26).'
              }
            },
            conversation: {
              identifierId: 'Identificador',
              session: 'Sessão',
              changeName: 'Alterar nome',
              protocol: 'Protocolo',
              tags: 'Tags',
              device: 'Dispositivo',
              dispatchEmailLead: 'Email de lead enviado',
              dispatchEmailClient: 'Email enviado para o cliente',
              emailViewedClient: 'Email visualizado pelo cliente',
              dateAndTime: 'Data e Hora',
              channel: 'Canal',
              satisfaction: 'Satisfação',
              punctuation: 'Pontuação',
              search: 'Pesquisar',
              location: 'Localização',
              origin: 'Origem'
            },
            knowledge: {
              reply: 'Responder',
              copyReply: 'Copiar resposta',
              messageErrorKnowledge: 'Erro ao consultar bases de conhecimento',
              messageErrorConsult: 'Erro ao consultar perguntas.'
            }
          },
          footer: {
            actions: {
              annex: {
                sendImage: 'Enviar imagem! (5 MB tamanho máximo)',
                sendVideo: 'Enviar Vídeo! (16 MB tamanho máximo)',
                sendFile: 'Enviar arquivo! (100 MB tamanho máximo)',
                selectLibrary: 'Selecionar da biblioteca!',
                library: 'Biblioteca',
                preview: 'Pré-visualizar',
                addLegend: 'Adicionar legenda',
                pdfLimitExceeded: 'O tamanho do arquivo é maior que o máximo permitido. (100 MB)',
                imageLimitExceeded: 'O tamanho da imagem é maior que o máximo permitido. (5 MB)',
                videoLimitExceeded: 'O tamanho do vídeo é maior que o máximo permitido. (16 MB)',
                audioLimitExceeded: 'O tamanho do áudio é maior que o máximo permitido. (16 MB)',
                cancel: 'Cancelar',
                send: 'Enviar',
                file: 'Arquivo',
                avatar: 'Avatar',
                maxFileSize: 'O tamanho do arquivo é maior que o máximo permitido.',
                errorProcessingDoc: 'Erro ao processar documento.',
                fileFormatNotAccepted: 'Formato de arquivo não aceito!'
              },
              audio: {
                recordAudio: 'Gravar áudio (máximo 2 minutos)',
                cancel: 'Cancelar',
                send: 'Enviar',
                preview: 'Pré-visualizar',
                addLegend: 'Adicionar legenda',
                sendText: 'Enviar texto',
                sendAudio: 'Enviar áudio',
                errorProcessingAudio: 'Erro ao processar audio.',
                accessMicrophoneRequired: 'Para o pleno funcionamento do chat ao vivo é necessário permitir o acesso para o microfone.',
                transcribe: 'Transcrição do áudio'
              },
              quickResponse: {
                quickResponse: 'Resposta rápida',
                add: 'Adicionar',
                close: 'Fechar',
                unshare: 'Descompartilhar',
                removeShare: 'Remover vinculo desta resposta',
                reply: 'Responder',
                edit: 'Colar na caixa de texto',
                share: 'Compartilhar',
                exclude: 'Excluir',
                createQuickResponse: 'Adicionar resposta rápida',
                title: 'Título',
                message: 'Mensagem',
                cancel: 'Cancelar',
                errorConsultQuickResponse: 'Erro ao consultar respostas rápida.',
                errorRegisterQuickResponse: 'Erro ao cadastrar resposta rápida.',
                errorExcludeQuickResponse: 'Erro ao excluir resposta rápida.',
                errorShareQuickResponse: 'Erro ao compartilhar resposta rápida.',
                excludeQuickResponse: 'Excluir resposta rápida',
                youSureExclude: 'Tem certeza que deseja excluir esta resposta?',
                removeShareQuickResponse: 'Remover vínculo',
                youSureRemoveShare: 'Tem certeza que deseja remover o vínculo desta resposta rápida?',
                remove: 'Remover',
                requiredField: 'Campo obrigatório',
              }
            }
          },
          utils: {
            attendants: {
              attendant: 'Atendente',
              attendants: 'Atendentes',
              actualCalls: 'Total atendimentos',
              avatar: 'Avatar',
              name: 'Nome',
              role: 'Cargo',
              select: 'Selecionar',
              searchAttendant: 'Procurar atendente',
              noSearchResults: 'Nenhum resultado encontrado',
              actions: 'Ações'
            },
            departments: {
              department: 'Departamento',
              attendants: 'Atendentes',
              noSearchResults: 'Nenhum resultado encontrado'
            },
            roomOptions: {
              endAttendance: 'Finalizar atendimento',
              archiveAttendance: 'Arquivar atendimento',
              reactivateNotifications: 'Reativar notificações',
              muteNotifications: 'Silenciar notificações',
              unpinAttendance: 'Desafixar atendimento',
              fixedAttendance: 'Fixar atendimento',
              transferAttendance: 'Transferir atendimento',
              transferAttendanceSelected: 'Transferir selecionadas',
              endAttendanceSelected: 'Finalizar selecionadas',
              transferRestrictedAttendanceSelected: 'Transferir selecionadas (apenas para Gerentes e Administradores)',
              archiveAttendanceSelected: 'Arquivar selecionadas'
            }
          },
          createGroup: {
            newGroup: 'Novo grupo',
            newConversation: 'Nova conversa'
          },
          createHsm: {
            department: 'Departamento',
            departmentRequired: 'Selecione um departamento.',
            numberBlocked: 'Este número está bloqueado neste chatbot. O envio continua disponível, mas as mensagens do cliente não chegam ao atendimento enquanto o bloqueio estiver ativo.',
            numberBlockedUnlockAt: 'O desbloqueio é feito em',
            numberBlockedContinue: 'Para enviar mesmo assim, avance para escolher o template.',
            numberBlockedLookupFailed: 'Não foi possível verificar se este número está bloqueado.',
            numberBlockedChecking: 'Verificando o número...',
            limitCharactersExceeded: 'Limite de caracteres excedido!',
            credits: 'Créditos',
            creditsDescription: 'Para envio de mensagens para clientes que estão inativos no WhatsApp (24h após a última mensagem enviada pelo cliente) é necessário utilizar um Template de Mensagem (HSM) pré-aprovado pelo WhatsApp.',
            creditsInsufficient: 'Infelizmente você não possui créditos suficientes.',
            attention: 'Atenção:',
            attentionDescription: ' Após 24h de inatividade do cliente, a empresa somente poderá enviar mensagem padronizada e pré-aprovada pelo WhatsApp, conhecida como HSM. Cada mensagem HSM consome 01 crédito na plataforma, pois são passíveis de cobrança pelo WhatsApp.',
            requestCredits: 'Solicitar mais créditos',
            whoToSendMessage: 'Para quem você quer enviar a mensagem?',
            originNumber: 'Número de origem *',
            nameClient: 'Nome do Cliente *',
            country: 'País *',
            nameClientWhatsapp: 'Número do Whatsapp do Cliente *',
            attentionNinthNumber: ' Informe o número do celular do cliente com DDD com 2 dígitos, exemplo: (XX) XXXXX-XXXX. As mensagens só serão enviadas para clientes que possuem conta WhatsApp ativa.',
            messageYouCanNot: 'Ops! Você não poderá enviar mensagem para',
            messageActiveConversationWith: 'porque ele já está em uma conversa ATIVA com ',
            messageActiveConversationAttendants: 'porque ele já está em uma conversa ATIVA com outro atendente.',
            messageConversationWithYou: 'já está em conversa com você! Envie mensagens através da sala de conversa.',
            goToRoom: 'Ir para sala',
            messageTemplate: 'Template de Mensagem (HSM)',
            notAuthorized: 'Ops! Você não poderá enviar mensagem para esta pessoa pois ela não autorizou o recebimento de mensagens (Opt-In) conforme políticas do WhatsApp.',
            messageUserOptIn: 'Para sua empresa enviar mensagem para o cliente (estando fora da sessão de conversa), este cliente precisa necessariamente ser um usuário OPT-IN (ou seja, deu consentimento para receber mensagens). Saiba mais sobre Opt-In.',
            messageSent: 'Mensagem enviada!',
            return: 'Voltar',
            advance: 'Avançar',
            missingMessage: 'Mensagem ausente',
            notPossibleStartConversation: 'Não foi possível iniciar a conversa pois o usuário já está conversando com o chatbot.',
            numberNotValid: 'Ops! O número informado não é uma conta válida no WhatsApp! Verifique o número e tente novamente. Lembre-se, não informar o DDI.',
            identifierPhone: 'Telefone',
            identifierBsuid: 'BSUID',
            bsuidLabel: 'BSUID do contato *',
            bsuidHint: 'Identificador da Meta, no formato PP.números — por exemplo IN.1648738043044942.',
            bsuidNotValid: 'Ops! O BSUID informado não é válido. O formato esperado é PP.números, por exemplo IN.1648738043044942.',
            bsuidCopied: 'BSUID copiado',
            bsuidCopyHint: 'Clique para copiar o BSUID completo',
            nameNotValid: 'Favor informar o nome do cliente.',
            requiredMessage: 'Ops! Você precisa preencher a mensagem a ser enviada!',
            satisfactionSurvey: 'está respondendo a pesquisa de satisfação.',
            optout: 'optou por não receber mensagens da sua empresa em',
            livechatQueue: 'está em fila de atendimento.',
            chatbot: 'está conversando com o chatbot.',
            pdfLimitExceeded: 'PDF deve ter no máximo 100MB.',
            imageLimitExceeded: 'Imagem deve ter no máximo 5MB.',
            videoLimitExceeded: 'Vídeo deve ter no máximo 16MB.',
          },
          pushGroup: {
            add: 'Adicionar',
            attendantAdded: 'Atendente adicionado!',
            alreadyInGroup: 'Este atendente já está no grupo!'
          },
        },
        micro: {
          cdt: {
            yesterday: 'Ontem',
            today: 'Hoje'
          },
          cdtWithHours: {
            yesterday: 'Ontem',
            today: 'Hoje',
            sunday: 'Domingo',
            monday: 'Segunda',
            tuesday: 'Terça',
            wednesday: 'Quarta',
            thursday: 'Quinta',
            friday: 'Sexta',
            saturday: 'Sabado'
          }
        },
        modals: {
          feedback: {
            newFunctions: 'Ajude a gente a desenvolver novas funcionalidades para o painel!',
            help: 'Vamos ajudar a melhorar nosso painel?',
            info: 'Esse feedback é somente para melhorias, caso você queira reportar algum problema técnico entre em contato com o suporte.',
            nowYouCan: 'Agora você pode ajudar a melhorar a nossa plataforma!',
            feedbackWillBeApplied: 'Essa é a página que será aplicado o feedback',
            whatCanBeImproved: 'Conte pra gente o que pode ser melhorado nesta página?',
            example: 'Ex: Essa página poderia ter um botão informativo.',
            send: 'Enviar',
            feedbackSentError: 'Ocorreu um erro no envio do feedback',
            feedbackSentSuccessfully: 'Feedback enviado com sucesso!',
            requireFields: 'Você precisa preencher os campos.',
            contactSupport: 'Ocorreu um erro, favor contatar o suporte',
            feedbackExcludeError: 'Ocorreu um erro ao excluir o feedback!',
            feedbackExcludeSuccessfully: 'Feedback excluído com sucesso!'
          },
          image: {
            image: 'Imagem'
          },
          recharge: {
            requestCredits: 'Solicitar Créditos',
            requestCreditsDescriptionMini: 'Você pode solicitar créditos adicionais para utilização na Globalbot.',
            requestCreditsDescriptionMini2: 'Escolha uma das opções abaixo que nossa equipe irá contatar você.',
            requestCreditsDescription: 'Solicite créditos adicionais para utilização no módulo Campanhas. <span style="color: #ff6600;">Valores de acordo com seu plano contratado.</span>',
            requestCreditsDescriptionCopilot: 'Você pode solicitar créditos adicionais para utilização no Copiloto.',
            requestCreditsDescription2: 'Escolha uma das opções abaixo e entraremos em contato com você o quanto antes.',
            whatsapp: 'Pacotes WhatsApp*',
            copilot: 'Copiloto*',
            type: 'Tipo *',
            value: 'Quantidade',
            cancel: 'Cancelar',
            request: 'Solicitar',
            messageFailedRequestCredits: 'Oops, falha ao solicitar créditos.',
            creditsRequested: 'Créditos solicitados.',
            fieldsRequired: 'Você precisa preencher os campos.',
            mostPopular: 'mais popular',
            single: 'avulso',
            credits: 'créditos',
            monthly: 'mensal',
            important: '* Os créditos adquiridos tem validade de 6 meses.',
            smsAndEmail: 'SMS e Email',
            consult: 'Consulte'
          },
          upgrade: {
            meetGlobalbot: 'Conheça a versão completa da Globalbot!',
            additionalFeaturesDescription: 'Mais de 100 recursos adicionais para sua empresa vender mais e atender melhor no WhatsApp e outros canais de chat, incluindo:',
            additionalFeatures: 'Chat ao vivo, campanhas de marketing, integrações, automações, relatórios analíticos e muito mais!',
            wantToMeetDescription: 'Clique agora em <strong>Quero Conhecer</strong> e um de nossos profissionais entrará em contato com você para agendar uma demonstração!',
            wantToMeet: 'Quero Conhecer',
            cancel: 'Cancelar',
            requestCompleted: 'Solicitação concluída!',
            requestError: 'Falha ao solicitar, tente novamente.'
          }
        },
        tags: {
          removeTag: 'Retirar tag',
          addTags: 'Adicionar tag',
          labelTag: 'Procurar tag',
          tagAlreadyExistsInConversation: 'Essa tag já existe na conversa.',
          categoryNotFound: 'Categoria não encontrada, verifique o componente miniTags.',
          manageTags: 'Gerenciar Tags'
        },
        departments: {
          searchDepartment: 'Procurar departamento',
          manageDepartments: 'Gerenciar Departamentos',
          noDepartments: 'Nenhum departamento encontrado.'
        },
        exporter: {
          mountingReport: 'Montando relatório...',
          exportToCsv: 'Exporta para CSV',
          type: 'Tipo',
          answered: 'Respondida',
          response: 'Resposta',
          disambiguated: 'Desambiguada',
          notResponse: 'Não respondida',
          active: 'Ativo',
          inactive: 'Inativo',
          reportGeneratedSuccessfully: 'Relatório gerado com sucesso.',
          messageFailedReport: 'Oops, a geração de relatórios falhou, tente novamente.'
        },
        loading: {
          connectingToServer: 'Conectando ao servidor...',
          assemblingTheInformation: 'Montando as informações...'
        },
        zendesk: {
          title: 'Zendesk',
          brands: 'Marcas',
          forms: 'Formulários',
          fields: 'Tags',
          group: 'Grupo',
        }
      },
      layouts: {
        default: {
          messageErrorInfo: 'Oops, algum erro aconteceu ao salvar as informações.',
          tolerancePeriod: 'Período de Tolerância',
          finishedJourneyDescription: 'Sua jornada de trabalho encerrou, mas você entrou no período de tolerância.',
          timeLeft: 'Encerre seus trabalhos no tempo restante de',
          disconnectedFromThePlatform: 'Após o término do período de tolerância você será desconactado da plataforma.',
          iKnow: 'Estou Ciente',
          finishedJourney: 'Jornada Encerrada',
          workingEnded: 'Sua jornada de trabalho foi encerrada.',
          freeTime: 'Aproveite seu tempo livre!',
          seeYouLater: 'Até logo',
          lostConnection: 'Conexão perdida',
          whatsappBalanceBlocked: {
            title: 'Saldo de WhatsApp esgotado',
            description: 'O envio de mensagens pelo WhatsApp está pausado. Adicione créditos para retomar.',
            descriptionNoPermission: 'O envio de mensagens pelo WhatsApp está pausado. Fale com o administrador da conta para adicionar créditos.',
            action: 'Adicionar créditos',
            close: 'Fechar aviso'
          }
        }
      },
      pages: {
        actions: {
          create: {
            addAction: 'Adicionar ação',
            title: 'Título',
            description: 'Descrição',
            request: 'Requisição',
            getAndPost: 'GET, POST',
            newAction: 'Nova ação',
            newActionDescription: 'Descrição de nova ação'
          },
          list: {
            actions: 'Ações',
            addAction: 'Adicionar ação'
          }
        },
        crm: {
          fields: {
            people: 'Pessoas',
            company: 'Empresas'
          },
          exportTableCrm: {
            exportReport: 'Exportar registros',
            exportReportAll: 'Exportar todos os registros.',
            exportReportSelected: 'Exportar registros selecionados:',
            exportReportError: 'Erro ao exportar registros',
            exportReportSuccess: 'Registros exportados com sucesso',
            exportReportCancel: 'Cancelar',
            exportReportExportXLSX: 'Exportar XLSX',
            exportReportExportCSV: 'Exportar CSV',
          },
          contact: {
            exportReportAll: 'Exportar todos os registros',
            exportReportSelected: 'Exportar registros selecionados',
            openArchive: 'Abrir arquivo',
            openLink: 'Abrir link',
            openImage: 'Abrir imagem',
            noPermission: 'Sem permissão',
            deleteSelected: 'Excluir registros selecionados',
            contactDeleted: 'Contato excluído.',
            contactFavorite: 'Contato favoritado.',
            excludePeople: 'Excluir Pessoas',
            excludeCompany: 'Excluir Empresas',
            peopleSelected: 'pessoas selecionadas',
            companySelected: 'empresas selecionadas'
          },
          contactAdvanced: {
            customization: 'Personalização',
            confirmLeaveDescription: 'Você está no modo de edição deste registro e não salvou ainda suas alterações. O que deseja fazer?',
            discardChanges: 'Descartar Alterações',
            keepEditing: 'Continuar Editando',
            editingBy: 'Este contato está sendo editado por ',
            editContact: 'Editar Contato',
            waitUser: 'Espere o usuário finalizar a edição deste contato.',
            save: 'Salvar',
            deleteContact: 'Excluir Contato',
            defineAttributes: 'Defina atributos para segmentação e personalização.',
            deleteContactConfirm: 'Você quer mesmo excluir este contato?',
            none: 'nenhum',
            byDepartment: 'por departamento',
            byAttendant: 'por atendente',
            emailInvalid: 'Email inválido na Seção: ',
            cpfInvalid: 'CPF inválido na Seção: ',
            saveSuccess: 'Contato salvo com sucesso!',
            editing: 'Este contato já está sendo editado.',
            contactDeleted: 'Contato excluído.',
            lastUpdate: 'Última alteração: ',
            booklet: 'Encarteiramento',
            attendant: 'Atendente',
            department: 'Departamento',
            create: 'Criar',
          },
          import: {
            type: 'Tipo',
            name: 'Nome',
            autor: 'Autor',
            status: 'Status',
            listName: 'Lista Importada',
            count: 'Quantidade Importada'
          },
          default_sections: {
            people: {
              "people_registration_data_default": "Dados Cadastrais",
              "people_address_default": "Endereço",
              "people_professional_data_default": "Dados Profissionais",
            },
            company: {
              "company_registration_data_default": "Dados Cadastrais",
              "company_address_default": "Endereço"
            }
          },
          default_fields: {
            people: {
              "people_name_default": "Nome",
              "people_cpf_default": "CPF",
              "people_email_default": "E-mail",
              "people_phone_whatsapp_default": "Telefone Whatsapp",
              "people_born_date_default": "Data Nascimento",
              "people_cep_default": "CEP",
              "people_address_street_default": "Rua",
              "people_address_number_default": "Número",
              "people_address_complement_default": "Complemento",
              "people_address_neighborhood_default": "Bairro",
              "people_address_city_default": "Cidade",
              "people_address_state_default": "Estado",
              "people_address_country_default": "País",
              "people_company_default": "Empresa",
            },
            company: {
              "company_name_default": "Nome",
              "company_cnpj_default": "CNPJ",
              "company_corporate_reason_default": "Razão Social",
              "company_email_default": "E-mail",
              "company_phone_default": "Telefone",
              "company_cep_default": "CEP",
              "company_address_street_default": "Rua",
              "company_address_number_default": "Número",
              "company_address_complement_default": "Complemento",
              "company_address_neighborhood_default": "Bairro",
              "company_address_city_default": "Cidade",
              "company_address_state_default": "Estado",
              "company_address_country_default": "País",
            }
          }
        },
        advanced: {
          emailUnsubscribes: {
            title: 'Descadastros de e-mail',
            description: 'Console do supermaster. "Supressão global": e-mails que não recebem campanha de nenhum cliente. "Grupos por domínio": e-mails descadastrados de cada domínio, de qualquer conta. Remover ou liberar exige motivo e fica registrado.',
            tabGlobal: 'Supressão global',
            tabGroups: 'Grupos por domínio',
            email: 'E-mail',
            created: 'Descadastrado em',
            actions: 'Ações',
            remove: 'Remover da global',
            removeTitle: 'Remover e-mail da supressão global',
            removeDescription: 'O e-mail voltará a receber e-mails de todos os clientes. Esta ação fica auditada com o motivo.',
            removed: 'E-mail removido da supressão global.',
            loadMore: 'Carregar mais',
            page: 'Página',
            previousPage: 'Página anterior',
            nextPage: 'Próxima página',
            empty: 'Nenhum e-mail na supressão global.',
            searchGroups: 'Buscar por domínio ou id da conta',
            account: 'Conta',
            unsubscribed: 'Descadastrados',
            openGroup: 'Ver e-mails',
            groupsEmpty: 'Nenhum grupo encontrado.',
            back: 'Voltar',
            checkEmail: 'Verificar e-mail',
            checkEmailHint: 'O provedor não tem busca por texto: informe o e-mail completo.',
            check: 'Verificar',
            invalidEmail: 'Informe um e-mail válido.',
            checkSuppressed: 'Este e-mail está na supressão global.',
            checkNotSuppressed: 'Este e-mail não está na supressão global.',
            tabBlackList: 'Bloqueios e liberações',
            blackListDescription: 'Histórico local de e-mails descadastrados (bloqueios) e liberados, com o motivo da liberação, de todas as contas.',
            searchBlackList: 'Buscar por e-mail ou id da conta',
            filterStatus: 'Situação',
            filterScope: 'Escopo',
            all: 'Todos',
            scopeGlobal: 'Global',
            scopeGroup: 'Grupo do domínio',
            domain: 'Domínio',
            lastSource: 'Origem',
            blackListEmpty: 'Nenhum registro encontrado.',
            sources: {
              webhook: 'Descadastro pelo destinatário',
              panel: 'Administrador da conta',
              supermaster: 'Supermaster',
              'global-reset-script': 'Reinício da supressão global'
            }
          },
          logs: {
            list: {
              addLog: 'Adicionar log',
              version: 'Versão',
              change: 'Módulo',
              visibility: 'Visualização',
              description: 'Descrição',
              cancel: 'Cancelar',
              add: 'Adicionar',
              update: 'Atualizar',
              removedColumn: 'Retirado coluna de categorias por inutilização',
              deprecateModal: 'Modal de observação depreciado.',
              updateVisualsAndProgrammatic: 'Atualizações visuais e programáticas.'
            }
          },
          copilot: {
            assistant: 'Assistente de Escrita',
            main: 'Principal',
            cdt: 'Data/Hora',
            account: 'Conta',
            user: 'Usuário',
            type: 'Tipo Copiloto',
            question: 'Consulta',
            response: 'Resposta',
            rowsPerPage: 'Registros por página:'
          },
          conversation: {
            conversationDetails: 'Detalhes da conversa',
            search: 'Pesquisar',
            account: 'Conta',
            attendants: 'Atendente(s)',
            device: 'Dispositivo',
            desktop: 'Desktop',
            mobile: 'Mobile',
            chrome: 'Chrome',
            safari: 'Safari',
            mozilla: 'Mozilla Firefox',
            edge: 'Edge',
            explorer: 'Internet Explorer',
            whatsapp: 'Whatsapp',
            facebook: 'Facebook Messenger',
            dispatchEmail: 'Email de lead enviado',
            dispatchEmailToClient: 'Email enviado para o cliente',
            viewedEmailByClient: 'Email visualizado pelo cliente',
            dateAndHour: 'Data e Hora',
            channel: 'Canal',
            origin: 'Origem',
            messageNotFoundConversation: 'Infelizmente não achamos essa conversa'
          },
          edit: {
            billingCredits: 'Faturamento de Créditos',
            hsmMarketingDiscount: 'Descontar 2 créditos em HSM Marketing',
            billing: {
              title: 'Billing — Mensagens de serviço',
              model: 'Modelo de cobrança',
              modelPerMessageBalance: 'Saldo por mensagem',
              modelSessionCredits: 'Créditos por sessão (legado)',
              modelPerMessageBalanceHint: 'Cada mensagem de serviço entregue debita o saldo em reais da conta.',
              modelSessionCreditsHint: 'Modelo antigo: consome 1 crédito por sessão de conversa, sem debitar saldo.',
              currency: 'Moeda',
              currencyHint: 'Fixa em BRL por enquanto.',
              gatewayCustomerId: 'Id do cliente no provedor de pagamento',
              gatewayCustomerIdHint: 'Definido pelo backend ao vincular a conta ao provedor.',
              gatewayNotConfigured: 'Não configurado',
              unitPrice: 'Preço por mensagem de serviço',
              unitPriceHint: 'Em branco aplica o preço padrão:',
              lowBalanceThreshold: 'Limite de alerta de saldo baixo',
              lowBalanceThresholdHint: 'Em branco desliga o alerta de saldo baixo.',
              alertRecipients: 'Destinatários dos alertas de saldo',
              alertRecipientsHint: 'Vazio notifica os usuários MASTER/ADMIN da conta, mesmo com e-mails adicionais.',
              alertEmails: 'E-mails adicionais',
              alertEmailsHint: 'Para quem não tem usuário na plataforma (ex.: financeiro). Digite e pressione Enter ou clique em +. Recebem apenas o e-mail de aviso. Máximo:',
              alertEmailsMax: 'Limite de e-mails adicionais atingido. Máximo:',
              addAlertEmail: 'Adicionar e-mail',
              invalidEmail: 'Informe um e-mail válido.',
              searchUser: 'Buscar usuário',
              removedUser: 'Usuário removido',
              chargeNonBillable: 'Cobrar mensagens isentas pela Meta',
              chargeNonBillableHint: 'Debita também as mensagens que a Meta não cobrou, dentro da franquia gratuita mensal.',
              balance: 'Saldo atual',
              balanceUpdatedAt: 'Atualizado em',
              lowBalanceAlert: 'Alerta de saldo baixo',
              zeroBalanceAlert: 'Alerta de saldo zerado',
              lastNotifiedAt: 'Última notificação',
              lastBalance: 'Saldo na notificação',
              neverNotified: 'Nunca notificado',
              minPrice: 'Mínimo:',
              priceBelowMinimum: 'Preço abaixo do mínimo permitido:',
              invalidPrice: 'Informe um valor válido, com até 4 casas decimais.',
              invalidThreshold: 'Informe um valor maior ou igual a zero.',
              overdraftLimit: 'Cheque especial (limite)',
              overdraftLimitHint: 'Quanto o saldo pode ficar negativo continuando a enviar. Em branco ou 0 desliga. Máximo:',
              maxBlockedNotifications: 'Máximo de avisos de bloqueio',
              maxBlockedNotificationsHint: 'Avisos por ciclo de bloqueio (o imediato mais os reenvios diários). 0 envia só o imediato. Em branco usa o padrão:',
              overdraftExhaustedAlert: 'Alerta de cheque especial esgotado',
              overdraftBelowUsage: 'Este limite não cobre o negativo atual: a conta bloqueia ao salvar, e sem disparar alerta. Uso atual:',
              addBalance: 'Adicionar saldo',
              addBalanceHint: 'Lança um ajuste manual no saldo da conta. Fica registrado no extrato com a observação abaixo e o usuário que fez.',
              adjustAmount: 'Valor a adicionar',
              adjustNote: 'Motivo do ajuste',
              adjustNoteHint: 'Explique por que o saldo está sendo alterado. Mínimo de caracteres:',
              adjustDuplicate: 'Este ajuste já havia sido aplicado; o saldo não mudou de novo.',
              invalidAdjustAmount: 'Informe um valor maior que zero, com até 4 casas decimais.',
              invalidAdjustNote: 'Descreva o motivo com pelo menos',
              invalidAdjustNoteMax: 'O motivo deve ter no máximo',
              errorInvalidAmount: 'Valor fora dos limites aceitos pelo servidor.',
              errorNoteRequired: 'O ajuste de saldo exige uma observação explicando o motivo.',
              errorModelNotEnabled: 'Esta conta não está no modelo de saldo por mensagem.',
              notifiedCount: 'Avisos no ciclo',
              invalidOverdraftLimit: 'Informe um valor maior ou igual a zero, com até 4 casas decimais.',
              invalidOverdraftLimitMax: 'Cheque especial acima do máximo permitido:',
              invalidMaxBlockedNotifications: 'Informe um número inteiro entre 0 e',
              errorForbidden: 'Você não tem permissão para alterar o billing desta conta.',
              errorAccountNotFound: 'Conta não encontrada.',
              errorValidation: 'Revise os campos: algum valor não foi aceito.'
            },
            yes: 'Sim',
            delPayment: 'Deletar pagamento',
            paid: 'Pago',
            consumption: 'Consumo',
            status: 'Status',
            editAccount: 'Editar conta',
            clientsList: 'Lista de clientes',
            editAccountTwo: 'Editar conta - ',
            credits: 'Créditos',
            recurrentCredits: 'Franquia recorrente de mensageria',
            sharedFranchise: 'Franquia compartilhada',
            newFranchise: 'Novo modelo',
            shared: 'Compartilhada',
            otherChannels: 'Outros canais',
            add: 'Adicionar',
            del: 'Deletar',
            fa: '2FA',
            email: 'E-mail',
            active: 'Ativo',
            inactive: 'Inativo',
            phone: 'Telefone',
            security: 'Módulos habilitados',
            realTime: 'Tempo real',
            statistics: 'Estatísticas',
            people: 'Pessoas',
            conversation: 'Conversas',
            interface: 'Interface',
            flow: 'Fluxo',
            intelligence: 'Inteligência',
            campaigns: 'Campanhas',
            liveChat: 'Chat ao vivo',
            library: 'Biblioteca',
            preferences: 'Preferências',
            limiter: 'Usuários  - Limitador ',
            decraseLimit: 'Diminuir limite',
            increaseLimit: 'Aumentar limite',
            createMaster: 'Criar master',
            accountDetails: 'Detalhes da conta',
            accountName: 'Nome da conta',
            addPermissions: 'Adicionar permissões',
            addBriefing: 'Adicionar briefing',
            companyName: 'Razão social',
            fantasyName: 'Nome fantasia',
            cnpj: 'CNPJ',
            address: 'Endereço',
            zipCode: 'CEP',
            street: 'Rua',
            edit: 'Editar',
            contacts: 'Contatos',
            plan: 'Plano e Contrato',
            uploadContractLabel: 'Contrato',
            contractValidityLabel: 'Validade do contrato',
            contractDateLabel: 'Data do contrato',
            seeDocument: 'Ver documento',
            successUpdate: 'Cliente atualizado!',
            errorUpdate: 'Erro ao atualizar cliente!',
            type: 'Tipo',
            characteristics: 'Franquia e canais',
            numberAttendances: 'Whatsapp - Franquia mensal',
            otherChannelAttendances: 'Outros canais - Franquia mensal',
            whatsAppAttendances: 'Whatsapp - Franquia mensal',
            emailAttendances: 'E-mail - Franquia mensal',
            smsAttendances: 'SMS - Franquia mensal',
            webchat: 'Webchat',
            facebook: 'Facebook',
            whatsapp: 'Whatsapp',
            whatsappFranchise: 'Whatsapp Franquia',
            sms: 'SMS',
            integration: 'Integração',
            observations: 'Observações',
            none: 'Nenhuma',
            simple: 'Simples',
            intermediate: 'Intermediário',
            advanced: 'Avançado',
            payments: 'Pagamentos',
            form: 'Forma',
            setup: 'Setup',
            description: 'Descrição',
            valueReal: 'Valor: R$ ',
            date: 'Data',
            monthlyPayment: 'Mensalidade',
            cronogram: 'Cronograma',
            planning: 'Planejamento',
            initialDate: 'Data inicial',
            implementation: 'Implementação',
            endDate: 'Data final',
            observation: 'Observação',
            customerSuccess: 'Customer Success',
            chatbots: 'Chatbots',
            online: 'Online',
            offline: 'Offline',
            versioning: 'Versionamento',
            old: 'ANTIGO',
            stable: 'ESTÁVEL',
            beta: 'BETA',
            alpha: 'ALFA',
            editAddress: 'Editar endereço',
            number: 'Número',
            district: 'Bairro',
            city: 'Cidade',
            state: 'Estado',
            cancel: 'Cancelar',
            save: 'Salvar',
            addContact: 'Adicionar contato',
            delContact: 'Deletar contato',
            editContact: 'Editar contato',
            role: 'Cargo',
            name: 'Nome',
            projectManager: 'Gerente de projeto',
            title: 'Titulo',
            addImplementationCronogram: 'Adicionar cronograma de implementação',
            addCronogramByCs: 'Adicionar cronograma de CS',
            addCronogramByPlanning: 'Adicionar cronograma de planejamento',
            addRateBySetup: 'Adicionar taxa de SETUP',
            value: 'Valor',
            values: 'Valores',
            ongoing: 'OnGoing',
            onboarding: 'OnBoarding',
            csStage: 'Etapa CS',
            currentStatus: 'Status atual',
            accountStatusOnline: 'Online',
            accountStatusPartialOnline: 'Online parcial',
            accountStatusPaused: 'Pausado',
            accountStatusChurn: 'Churn',
            flag: 'Flag',
            addRateMonthly: 'Adicionar taxa de mensalidade',
            newUser: 'Adicionar usuário',
            password: 'Senha',
            addCredits: 'Adicionar créditos',
            veryLow: 'Muito baixa',
            low: 'Baixa',
            medium: 'Média',
            high: 'Alta',
            veryHigh: 'Muito Alta',
            important: 'IMPORTANTE',
            starter: 'G-Starter',
            professional: 'G-Professional',
            enterprise: 'G-Enterprise',
            gAdvanced: 'G-Advanced',
            orion: 'G-Orion',
            planLite: 'Lite',
            planStarter: 'Starter',
            planProfessional: 'Professional',
            planAdvanced: 'Advanced',
            planEnterprise: 'Enterprise',
            planGlobal: 'Global',
            planLite22: 'LITE-22',
            planStarter22: 'STARTER-22',
            planProfessional22: 'PROFESSIONAL-22',
            planAdvanced22: 'ADVANCED-22',
            planEnterprise22: 'ENTERPRISE-22',
            planLite23: 'LITE-23',
            planStarter23: 'STARTER-23',
            planProfessional23: 'PROFESSIONAL-23',
            planEnterprise23: 'ENTERPRISE-23',
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro',
            genAi: 'IA Generativa',
            instagram: 'Instagram',
            crm: "CRM",
            genAiFranchise: 'Franquia IA Generativa',
            genAiStandalone: 'IA Generativa avulso',
            miniGlobalbot: 'Globalbot Mini'
          },
          list: {
            exportAccounts: 'Exportar contas',
            cs: 'CS Responsável',
            csStage: 'Etapa CS',
            accountStatus: 'Status da conta',
            plan: 'Plano',
            listClients: 'Lista de clientes',
            flagOk: 'Saudável',
            flagYellow: 'Atenção',
            flagRed: 'Crítica',
            flagNone: 'Sem classificação',
            model: 'Mod.',
            modelLetterBalance: 'S',
            modelLetterCredits: 'C',
            balance: 'Saldo',
            overdraftLimit: 'Cheque especial',
            noOverdraft: 'Sem limite',
            notOnBalance: 'Sem saldo monetário',
            usingOverdraft: 'No cheque especial',
            balanceFilter: 'Situação do saldo',
            balanceAll: 'Todas',
            balanceWithBalance: 'Com saldo',
            balanceZero: 'Saldo zerado',
            balanceUsingOverdraft: 'Usando cheque especial',
            balanceWithOverdraft: 'Com cheque especial',
            refreshList: 'Atualizar lista',
            createNewAccount: 'Criar nova conta',
            wantToCreateNewAccount: 'Quer criar uma nova conta? Clique aqui :)',
            version: 'Versão',
            stable: 'Estável',
            beta: 'Beta',
            alpha: 'Alpha',
            old: 'Old',
            updateNewVersion: 'Atualizar para nova versão',
            edit: 'Editar',
            exclude: 'Excluir',
            addAccount: 'Adicionar conta',
            companyName: 'Nome da empresa',
            steps: 'Agora siga estes passos',
            open: 'Abra a',
            spreadsheetClients: 'planilha de clientes',
            insertEmail: 'Coloque este e-mail',
            insertPassword: 'Ao lado, insira a senha desejada para a conta, ela precisa ser uma senha muito segura.',
            insertPasswordAndAdd: 'Insira no campo abaixo a senha digitada na planilha e clique em Adicionar.',
            passwordMaster: 'Senha do Master',
            cancel: 'Cancelar',
            add: 'Adicionar',
            excludeAccount: 'Excluir conta',
            sureExcludeAccount: 'Tem certeza que deseja excluir essa conta?',
            allConversationsAndChatbotsDeleted: 'Todas as conversas e todos os chatbots serão apagados.',
            updateVersionToStable: 'Atualizar a versão para Stable',
            beAware: 'Antes de seguir, esteja ciente que',
            thisChangesVersionPanel: 'Essa é uma ação que irá mudar a versão do painel do cliente.',
            losesAllAttendance: 'Essa opção que irá fazer o cliente perder todos os atendimentos atuais do Old, e ele não terá mais acesso, somente pela aba Conversas.',
            beforeToClick: 'Antes de clicar em atualizar, verifique se já tem departamentos criados acessando pelo https://panel.globalbot.ai na conta do cliente (se já tiver exclua pois pode interferir na migração).',
            createNewDepartment: 'Esta ação irá criar novos departamentos (com os mesmos nomes) e atribuir nos fluxos e nos usuários, então por segurança não se pode estar editando usuários nem o fluxo na hora da atualização.',
            switchToStableVersion: 'Mudar para versão Estável',
            name: 'Nome',
            actions: 'Ações',
            jan: 'Jan.',
            feb: 'Fev.',
            mar: 'Mar.',
            apr: 'Abr.',
            may: 'Mai.',
            jun: 'Jun.',
            jul: 'Jul',
            aug: 'Ago.',
            sep: 'Set.',
            oct: 'Out.',
            nov: 'Nov.',
            dec: 'Dez.',
            migratedAccountSuccess: 'Conta foi migrada com sucesso!',
            errorHasOccurred: 'Ocorreu um erro, contate um desenvolvedor urgente!',
            normalStatus: 'Normal',
            endingStatus: 'Acabando',
            exceededStatus: 'Excedido',
            columnFranchise: 'Consumo da franquia'
          },
          server: {
            serversWhatsapp: 'Servidores de WhatsApp',
            updateGit: 'Atualizar Git',
            requestUpdateGit: 'Solicitar atualização de git em todos os servidores.',
            update: 'Atualizar',
            servers: 'Servidores',
            serversDescription: 'Adicionar um novo servidor.',
            add: 'Adicionar',
            numbering: 'Numeração',
            version: 'Versão',
            responsible: 'Responsável',
            whatsapp: 'Whatsapp',
            indifferent: 'Indiferente',
            normal: 'Normal',
            business: 'Business',
            chip: 'Chip',
            client: 'Cliente',
            globalbot: 'Globalbot',
            server: 'Servidor',
            instanceType: 'Tipo de Instância',
            ip: 'IP',
            account: 'Conta',
            chatbot: 'Chatbot',
            info: 'Informações',
            actions: 'Ações',
            running: 'Rodando!',
            serverAvailable: 'Servidor disponível',
            serverDown: 'Serviço fora do ar, aguardar gerente.',
            qrCode: 'QR Code',
            gitPull: 'Git Pull',
            restartServer: 'Reiniciar servidor',
            edit: 'Editar',
            excludePairing: 'Excluir pareamento',
            save: 'Salvar',
            cancel: 'Cancelar',
            serverData: 'Dados do Servidor',
            instanceId: 'ID da Instância',
            serverName: 'Nome do servidor',
            sureRestartServer: 'Tem certeza que deseja reiniciar este servidor? Isso pode levar alguns minutos.',
            restart: 'Reiniciar',
            exclude: 'Excluir',
            sureExcludePairing: 'Tem certeza que deseja excluir o pareamento deste servidor? Você terá que ler novamente o QR Code.',
            cellphone: 'Celular',
            manager: 'Gerente',
            isBusiness: 'is Business',
            isChipResponsible: 'is Chip Responsible',
            messageError: 'Erro, veja o console!',
            routeNotFound: 'Rota não encontrada, servidor ',
            serverAddedSuccessfully: 'Servidor adicionado com sucesso!',
            pairingDeleted: 'Pareamento excluído com sucesso!'
          },
          tasks: {
            tasks: 'Tarefas | ',
            newTask: 'Nova Tarefa',
            plan: 'Plan',
            status: 'Status',
            notStarted: 'Não iniciado',
            ready: 'Pronto',
            stoppedGlobalbot: 'Parado Globalbot',
            stoppedClient: 'Parado Cliente',
            date: 'Data',
            invalidDate: 'Data inválida',
            noDate: 'Sem data',
            description: 'Descrição',
            notDescription: 'Sem descrição',
            advancedSettings: 'Configurações avançadas',
            do: 'Do',
            go: 'Go',
            learn: 'Learn',
            editTask: 'Editar Tarefa',
            selectUsers: 'Selecionar usuários',
            selectAccount: 'Selecionar conta',
            selectBot: 'Selecionar bot',
            selectType: 'Selecionar tipo',
            title: 'Título',
            selectStatus: 'Selecionar status',
            done: 'Feito'
          },
          users: {
            listUsers: 'Lista de usuários',
            user: 'Usuário',
            name: 'Nome',
            email: 'Email',
            role: 'Cargo',
            newPassword: 'Nova senha',
            avatar: 'Avatar',
            permission: 'Permissão',
            done: 'Feito',
            supreme: 'Supreme',
            master: 'Master',
            administrator: 'Administrador',
            manager: 'Gerente',
            attendant: 'Atendente',
            junior: 'Junior',
            messageErrorInfo: 'Oops, algum erro aconteceu ao salvar as informações.',
            messageErrorUser: 'Oops, algum erro aconteceu ao salvar o usuário.',
            supremeCommander: 'Supreme Commander',
            textExports: 'Você realmente deseja exportar todos os seus logs?'
          }
        },
        analytics: {
          attendant: {
            attendant: {
              indicatorsByAttendants: 'Indicadores por Atendentes',
              attendantsByTime: 'Atendimentos por horário do dia',
              chatbotsAndAttendants: 'Chatbots x Atendentes',
              departments: 'Departamentos',
              attendants: 'Atendentes',
              statistics: 'Estatísticas',
              exportAttendants: 'Exportar atendimentos',
              textExports: 'Você realmente deseja exportar todos os seus atendimentos?',
              knowledgeTextExports: 'Você realmente deseja exportar?'
            }
          },
          channels: {
            channels: {
              indicatorsByChannels: 'Indicadores por Canais',
              attendantsByTime: 'Atendimentos por horário do dia',
              chatbotsAndAttendants: 'Chatbots x Atendentes',
              channelOverview: 'Visão Geral por Canal',
              statistics: 'Estatísticas'
            }
          },
          flow: {
            flow: {
              flowAnalysis: 'Análise de Fluxo',
              statistics: 'Estatísticas'
            }
          },
          identifiers: {
            identifiers: {
              customIdentifiers: 'Identificadores Customizados',
              statistics: 'Estatísticas',
              seeMore: 'Visualizar Mais',
              quantity: 'Quantidade',
              identifier: 'Identificador'
            }
          },
          knowledge: {
            knowledge: {
              intelligencePerformance: 'Performance da Inteligência',
              conventionalIA: 'IA Convencional',
              conventionalIADescription: 'Respostas padronizadas. Interpreta a intenção do usuário e apresenta respostas cadastradas (texto, vídeo, imagens, documentos e links).',
              generativeIA: 'IA Generativa',
              generativeIADescription: 'Respostas criadas a partir de grande massa de dados (modelo GPT). Interpreta a intenção do usuário e apresenta respostas geradas (texto e links).',
              knowledgeBase: 'Base de conhecimento',
              commonQuestions: 'Perguntas Frequentes',
              advanced: 'Avançado',
              artificialIntelligence: 'Inteligência',
              statistics: 'Estatísticas'
            },
            responses: {
              response: 'Resposta'
            }
          },
          location: {
            location: {
              countries: 'Países',
              states: 'Estados',
              cities: 'Cidades',
              geolocationAdvanced: 'Avançado',
              geolocation: 'Geolocalização',
              statistics: 'Estatísticas',
              search: 'Pesquisar'
            }
          },
          origin: {
            origin: {
              platformAndBrowsers: 'Plataforma e Navegadores',
              campaign: 'Campanhas',
              originAttendance: 'Origem dos Atendimentos',
              statistics: 'Estatísticas',
              url: 'Localizador Uniforme de Recursos'
            }
          },
          cards: {
            attendance: 'Atendimentos',
            descriptionAttendance: 'Volume total de atendimentos (todos os canais) do<br/>período selecionado. O comparativo é relativo ao<br/> período imediatamente anterior.',
            leads: 'Leads',
            descriptionLeads: 'Total de Leads captados no período selecionado. Leads são conversas em que os usuários preencheram ao menos o email ou o telefone',
            satisfaction: 'Satisfação',
            descriptionSatisfaction: 'Taxa de satisfação relativa à Pesquisa de Satisfação dos<br/>usuários no período selecionado. O comparativo é relativo<br/>ao período imediatamente anterior. Este indicador é visível<br/>somente quando habilitada a Pesquisa de Satisfação na<br/>rota Preferências > Chatbot > Comportamento.',
            descriptionSatisfactionMini: 'Taxa de satisfação relativa à Pesquisa de Satisfação dos<br/>usuários no período selecionado. O comparativo é relativo<br/>ao período imediatamente anterior.',
            intelligence: 'Inteligência',
            descriptionIntelligenceOne: 'Taxa de sucesso da(s) Inteligência(s) Artificial(is) dos chatbots <br>  e período selecionados. Para IA Convencional é o somatório<br> das Perguntas Respondidas e Perguntas Desambiguadas.<br> Para a IA Generativa é considera-se apenas as Respondidas, pois <br> não há desambiguação.<br> O comparativo é relativo ao período imediatamente anterior.',
            descriptionIntelligenceMini: 'Taxa de respostas da Inteligência Artificial Generativa, que foram respondidas de acordo com o conteúdo fornecido. O comparativo é relativo ao período imediatamente anterior.',
            connected: 'Conectados',
            descriptionConnected: 'Total de usuários (colaboradores) atualmente<br/>conectados na Plataforma Globalbot. Refere-se<br/>aos indivíduos utilizadores da plataforma<br/>(tais como administradores, gerentes ou<br/>atendentes), não se referindo ao número de<br/>clientes em atendimento.',
            beta: 'BETA',
            descriptionBeta: 'O recurso identificado como BETA está em desenvolvimento<br/> e testes pela equipe Globalbot. Aguarde novidades em<br/>relação à evolução deste recurso.',
            viewByChannel: 'Visão por Canal',
            descriptionViewByChannel: 'Confira os principais indicadores de atendimento por canal, quantitativos e qualitativos.',
            attendants: 'Atendentes',
            descriptionAttendants: 'Veja os indicadores de performance dos atendentes de forma individual e coletiva.',
            descriptionIntelligenceTwo: 'Analise a performance da Inteligência Artificial, incluindo questões respondidas, desambiguadas e não respondidas.',
            geolocation: 'Geolocalização',
            descriptionGeolocation: 'Confira de quais localidades os atendimentos estão chegando, por país, estado e cidade.',
            origin: 'Origem',
            descriptionOrigin: 'Analise a origem dos atendimentos, considerando as fontes de tráfego, por exemplo, campanhas digitais.',
            flowAnalysis: 'Análise de Fluxo',
            descriptionFlowAnalysis: 'Veja como os usuários interagem com os fluxos conversacionais, considerando engajamento e abandono.',
            customized: 'Customizados',
            descriptionCustomized: 'Confira as métricas dos seus identificadores customizados que fazem parte dos fluxos conversacionais.',
            statistics: 'Estatísticas',
            tooltipStatistics: 'Dúvidas nas Estatísticas? Clique aqui e acesse o Tutorial que nossa equipe preparou. Temos muitas novidades!',
            totalValue: 'Valor Total',
            totalValueDescription: 'Confira o valor total gerado pelas conversas no período (muito útil para quem vende produtos e serviços). Para aparecer aqui, o valor deve ser atribuído em cada conversa individualmente.'
          }
        },
        block: {
          create: {
            add: 'Adicionar',
            blocks: 'Blocos',
            welcome: 'Boas vindas',
            addButton: 'Adicionar botão',
            create: 'create',
            title: 'Título',
            description: 'Descrição',
            message: 'Mensagem',
            name: 'Nome',
            firstName: 'Primeiro nome',
            lastName: 'Sobrenome',
            buttons: 'Botões',
            button: 'Botão',
            email: 'E-mail',
            phone: 'Telefone',
            cpf: 'CPF',
            cnpj: 'CNPJ',
            birthDate: 'Data de nascimento',
            calendar: 'Calendário',
            number: 'Número',
            checkbox: 'Checkbox',
            slider: 'Slider',
            image: 'Imagem',
            intelligence: 'Inteligência',
            liveChat: 'Chat Ao vivo',
            zipCode: 'CEP',
            city: 'Cidade',
            state: 'Estado',
            country: 'País',
            carousel: 'Carrossel',
            guideScreen: 'Tela guiada',
            money: 'Máscara de dinheiro',
            exit: 'Finalizar'
          },
          index: {
            blocks: 'Blocos',
            listblock: 'list block',
            new: 'Novo',
            index: 'index'
          }
        },
        bots: {
          bots: {
            testChatbot: 'Testar Chatbot',
            editFlow: 'Editar Fluxo',
            viewer: 'Visualizador',
            lite: 'Lite',
            pro: 'Pro',
            editor: 'Editor',
            settingsAccess: 'Acessar as Configurações',
            createNewChatbot: 'Novo Chatbot',
            createNewChatbotDesc: 'Crie um novo chatbot, edite o fluxo conversacional, defina os parâmetros e realize os testes.',
            installation: 'Instalação',
            titleChatbot: 'Título do chatbot',
            nameAttendant: 'Nome do atendente',
            descriptionChatbot: 'Descrição',
            fieldRequired: 'Campo obrigatório',
            cancel: 'Cancelar',
            create: 'Criar',
            createSuccessfully: 'Chatbot criado com sucesso!',
            createError: 'Erro ao criar chatbot',
            hello: 'Olá, Posso ajudar?',
            contactGlobalbot: 'Contato Globalbot',
            subject: 'assunto',
            content: 'content',
            indication: 'Seu amigo tem uma indicação',
            thanks: 'Olá{nome}, muito obrigado pelo seu interesse no ',
            introduction: 'Com o Globalbot sua empresa irá oferecer uma experiência de diálogo com seus públicos nas mais diversas situações. Essa experiência é fantástica, principalmente nos dispositivos móveis (celulares e tablets), pois as pessoas já estão acostumadas com uso de aplicativos de mensagens, como Facebook, Whatsapp e muitos outros.',
            listing: 'Eu listei aqui também algumas possíveis aplicações do ',
            inCompany: ' na sua empresa:',
            leadGeneration: 'Geração de Leads:',
            leadGenerationDescription: ' Utilização para reter o visitante do site através do diálogo e gerar leads para equipes comerciais, integrando com ferramentas de força de vendas ou disparando um e-mail.',
            marketingAndSales: 'Marketing e Vendas:',
            marketingAndSalesDescription: ' Realizar campanhas de marketing e ações focadas em vendas, apresentando um diálogo que leve o cliente a se envolver com o produto e suas características.',
            search: 'Pesquisas:',
            searchDescription: ' Transformar as extensas pesquisas de opinião e satisfação em diálogos amigáveis, evitando o tédio e a dispersão.',
            attendance: 'Atendimento ao Cliente:',
            attendanceDescription: ' Realizar serviços de atendimento ao cliente, baseando-se nas dúvidas mais frequentes e assim eliminar posições de atendimento e/ou reduzir as filas de espera.',
            schedulingAndReservations: 'Agendamento e Reservas:',
            schedulingAndReservationsDescription: ' Utilização para realizar agendamentos e reservas (consultórios, concessionárias, restaurantes, eventos e muitos outros) integrando a sistemas internos.',
            databaseAndCrm: 'Qualificação de Bases de Dados e CRM:',
            databaseAndCrmDescription: ' pode servir de interface para acesso à informações disponíveis em bases de dados, permitindo a qualificação das bases de dados através do diálogo.',
            teachingAndLearning: 'Ensino e Aprendizado:',
            teachingAndLearningDescription: ' Utilização para ações de ensino e aprendizado, usando conteúdo de aulas para os alunos, podendo conversar sobre os assuntos específicos das diversas matérias dos cursos.',
            furthermore: 'Além disso o ',
            dispatchDescription: ' pode enviar e-mail, SMS, exibir arquivos de imagem, áudio, vídeo e muito mais!',
            surpriseAudience: 'Surpreenda seu público com essa nova experiência!',
            regards: 'Atenciosamente,',
            telmaAyala: 'Telma Ayala',
            virtualAssistant: 'Assistente Virtual',
            address: ' Av. Cristovão Colombo, 3000 / salas 802 e 304 / Floresta Porto Alegre - RS - CEP 90560-002 ',
            moreInformations: 'Mais informações',
            // oneMessage: 'Ainda está por ai?',
            // twoMessage: 'Caso você não responda eu vou ter que finalizar o atendimento.',
            // threeMessage: 'Tudo bem, se você precisar de ajuda novamente me avise!',
            // closeMessage: 'O atendimento foi encerrado pelo atendente, agradecemos seu contato e caso tenha mais alguma dúvida é só me chamar novamente.',
            chatbots: 'Chatbots',
            viewGrid: 'Quadros',
            viewList: 'Lista',
            statusActive: 'Ativo',
            statusInactive: 'Inativo',
            botName: 'Nome Chatbot',
            botDescription: 'Descrição',
            botAuthor: 'Autor',
            botUpdatedAt: 'Última atualização',
            changeDescription: 'Editar descrição',
            updateDescriptionSuccess: 'Descrição atualizada!',
            channels: 'Canais',
            integrations: 'Integrações',
            integrationsActive: 'Integrações ativas',
            channelWebchat: 'WebChat',
            channelDomains: 'domínio(s) configurado(s)',
            channelWhatsappCopy: 'Clique para copiar o número',
            channelWhatsappCopied: 'Número copiado!',
            searchBotName: 'Buscar chatbot...',
            filterAll: 'Todos',
            filterStatus: 'Status',
            filterChannels: 'Canal',
            filterChannelsSelected: 'canal(is)',
            actions: 'Ações',
            filterGroups: 'Filtrar por grupo',
            noData: 'Nenhum chatbot por aqui.',
            editChatbot: 'Editar Chatbot',
            flowEditor: 'Edição de fluxo',
            createChatbot: 'Novo Chatbot',
            save: 'Salvar',
            updateSuccess: 'Chatbot atualizado!',
            updateError: 'Erro ao atualizar chatbot'
          },
          groups: {
            allBots: 'Todos os bots',
            manageGroups: 'Gerenciar Grupos',
            createGroup: 'Criar Grupo',
            editGroup: 'Editar Grupo',
            deleteGroup: 'Excluir Grupo',
            groupName: 'Grupo',
            selectBots: 'Selecionar bots',
            selectBotsHint: 'Selecione ao menos um bot para o grupo',
            searchBots: 'Procurar bot',
            noBots: 'Nenhum bot encontrado',
            botsSelected: 'bots selecionados',
            noGroups: 'Nenhum grupo criado ainda',
            botsInGroup: 'bots',
            groupSingular: 'grupo',
            groupPlural: 'grupos',
            save: 'Salvar',
            cancel: 'Cancelar',
            close: 'Fechar',
            confirmDelete: 'Deseja excluir este grupo?',
            groupSaved: 'Grupo salvo com sucesso!',
            groupDeleted: 'Grupo excluído com sucesso!',
            errorLoad: 'Erro ao carregar grupos',
            errorSave: 'Erro ao salvar grupo',
            errorDelete: 'Erro ao excluir grupo',
            createdAt: 'Data de criação'
          }
        },
        broadcast: {
          broadcast: {
            campaigns: 'Campanhas',
            processing: 'Processando...',
            sending: 'Enviando: ',
            of: ' de ',
            messageCreate: 'Criar mensagem',
            messageType: 'Tipo de mensagem',
            messageSave: 'Mensagens de SMS/Whatsapp salvas',
            email: 'Email',
            messageTitle: 'Título da mensagem',
            confirmation: 'Confirmação',
            saveNewMessageWithName: 'Salvar nova mensagem com o nome ',
            save: 'Salvar',
            cancel: 'Cancelar',
            messageText: 'Texto da mensagem',
            next: 'Próximo',
            recipients: 'Destinatários',
            importNewList: 'Importar nova lista',
            myLists: 'Minhas listas',
            listJson: 'Lista Json',
            send: 'Envio',
            sendNow: 'Enviar agora',
            scheduleShipping: 'Agendar envio',
            submit: 'Enviar',
            importList: 'Importar lista',
            import: 'Importar',
            saveList: 'Salvar lista',
            listTitle: 'Título da lista',
            totalRecipients: 'Total de destinatários',
            recipientsToLowerCase: ' destinatários',
            importedList: 'Lista importada',
            messageSaveList: 'Sua lista foi salva!',
            messageOpsError: 'Oops, ocorreu algum erro.',
            allMessagesWereSent: 'Todas as mensagens foram enviadas.',
            messageNotCreditsSms: 'Oops, parece que está faltando créditos de SMS. Por favor entre em contato com a gente.',
            allMessagesWereScheduled: 'Todas as mensagens foram agendadas.',
            failedToConnect: 'Falha ao conectar ao serviço de broadcast, favor recarregar a página.',
            messageNotCreditsWhatsapp: 'Oops, parece que está faltando créditos de WhatsApp. Por favor entre em contato com a gente.',
            messageWereSent: 'Foram enviadas ',
            messageOfTheTotal: ' do total de ',
            chargedMessages: ' mensagens. Apenas as mensagens enviadas serão cobradas.',
            gupshupTemplateImport: "Importar template HSM"
          },
          broadcast2: {
            templateSyncronizedFailed: 'Oops, ocorreu um erro ao sincronizar os templates. Por favor tente novamente.',
            templateSyncronized: 'Solicitação de sincronização de templates enviada com sucesso!, aguarde alguns instantes para que os templates sejam sincronizados.',
            templateSyncronizedSuccess: 'Templates sincronizados com sucesso',
            email: 'E-mail',
            communicate: 'Comunique-se através de ações de e-mail marketing ou e-mail transacionais.',
            createModel: 'Criar modelo',
            sms: 'SMS',
            sendNotificationsSms: 'Envie notificações e avisos através de mensagens de texto (SMS).',
            whatsapp: 'WhatsApp',
            instance: 'Instância',
            bot: 'Bot',
            sendNotificationsWhatsapp: 'Envie mensagens promocionais, notificações e pesquisas via WhatsApp.',
            requestCredits: 'Solicitar Créditos',
            requestCreditsMessaging: 'Solicite créditos adicionais para realizar campanhas.',
            models: 'Modelos',
            modelNotCreated: 'Você ainda não criou nenhum modelo. Comece escolhendo qual tipo de modelo você deseja criar.',
            modelHsm: 'Modelo de mensagem HSM (High Structured Message)<br/>utilizado para envios de mensagens pré-aprovadas<br/>através do WhatsApp Business API.',
            tipTemplateQualityWarning: 'ALERTA: Este template está em risco de ser bloqueado em virtude das altas taxas de denúncias e feedbacks negativos dos usuários. Evite utilizar.',
            tipTemplateQualityBlocked: 'BLOQUEADO: Este template está com bloqueio de segurança pela Globalbot pois atingiu níveis críticos em taxas de denúncias e feedbacks negativos pelos usuários. Este bloqueio é necessário para evitar o bloqueio (banimento total) do próprio número utilizado no WhatsApp. Utilize outro Template.',
            tipCategoryMarketing: 'Template Marketing: Esta mensagem está categorizada como Marketing pela Meta (WhatsApp). Uso comercial com foco promoções, vendas ou engajamento. NOTA: Mensagens de Marketing podem estar sujeitas a restrições de entrega em virtude de experimentos da Meta.',
            tipCategoryUtility: 'Template Utility: Esta mensagem está categorizada como Utility pela Meta (WhatsApp). Uso transacional com foco em atualizações solicitadas pelo cliente como status de pedidos, notificações e outros.',
            tipCategoryAuthentication: 'Template Authentication: Esta mensagem está categorizada como Authentication pela Meta (WhatsApp). Uso específico para autenticar usuários e proteger contas com foco em envios de códigos ou tokens.',
            modelData: 'Dados do Modelo',
            messageEditor: 'Editor de Mensagem',
            preview: 'Pré-visualização',
            duplicate: 'Duplicar envio',
            duplicateDraft: 'Duplicar rascunho',
            createDispatch: 'Criar Envio',
            exclude: 'Excluir',
            dispatches: 'Envios',
            dispatchesApi: 'Api',
            dispatchNotCreated: 'Você ainda não criou nenhum envio. Crie um envio a partir de um modelo de mensagem.',
            draftNotCreated: 'Você ainda não tem rascunhos.',
            drafts: 'Rascunhos',
            static: 'Estático',
            recurring: 'Recorrente',
            draft: 'Rascunho',
            readyToSend: 'Pronto para Envio',
            scheduled: 'Agendado',
            processing: 'Processando',
            scheduledFor: 'Agendado para ',
            processed: 'Processando',
            delivered: 'Entregue',
            device: 'Entregue',
            read: 'Lida',
            error: 'Não Entregue',
            open: 'Abertura',
            click: 'Clique',
            spamreport: 'Marcado como spam',
            unsubscribe: 'Descadastro',
            notSent: 'Não enviado',
            sent: 'Enviado',
            insufficientCredits: 'Créditos insuficiente',
            editDispatch: 'Editar Envio',
            editDraft: 'Editar rascunho',
            dataDispatch: 'Dados do Envio',
            statsDispach: 'Estatísticas do Envio',
            prepareDispatch: 'Preparar Envio',
            modelExclude: 'Excluir modelo',
            cancel: 'Cancelar',
            areSureModelExclude: 'Tem certeza que deseja excluir este item?',
            excludeDispatch: 'Excluir envio',
            duplicateDispatch: 'Você deseja fazer uma cópia deste envio?',
            duplicateQuestionDraft: 'Você deseja fazer uma cópia deste rascunho?',
            areSureDispatchExclude: 'Tem certeza que deseja excluir este envio?',
            dispatch: 'Enviar',
            areSureDispatch: 'Tem certeza que deseja enviar?',
            found: 'Encontrados',
            repeated: 'Repetidos',
            removed: 'Retirados',
            range: 'Alcance',
            schedule: 'Agendar Envio',
            saveDraft: 'Salvar como Rascunho',
            templateChannel: 'Canal',
            templateName: 'Nome',
            templateAuthor: 'Autor',
            templateEdited: 'Última atualização',
            templateActions: 'Ações',
            dispatchChannel: 'Canal',
            dispatchName: 'Nome',
            dispatchAuthor: 'Autor',
            dispatchStatus: 'Status',
            dispatchActions: 'Ações',
            templateExclude: 'Template excluído!',
            dispatchExclude: 'Envio excluído!',
            dispatchSuccess: 'Envio realizado com sucesso! Pode chegar em até 1 minuto.',
            processingDispatch: 'O envio está sendo processado.',
            dispatchScheduled: 'O envio foi agendado.',
            messageOpsNotDispatch: 'Oops, tivemos algum problema ao processar o envio.',
            messageNotCredits: 'Infelizmente seu saldo de créditos não é suficiente!',
            messageOpsNotValid: 'Oops, tivemos algum problema ao validar o envio.',
            messageNotFoundDispatch: 'Envio não encontrado',
            messageOpsErrorDispatch: 'Oops, ocorreu um erro ao recuperar o envio.',
            messageOpsFailedCompileTemplate: 'Oops, falha ao compilar template',
            campaigns: 'Campanhas',
            doubtsInMessaging: 'Dúvidas? Clique aqui e veja o tour interativo.',
            canNotDuplicateMissingTemplate: 'Template deletado, não é possível duplicar este envio',
            ON_BLACK_LIST_UNSUBSCRIBED: 'Destinatário cancelou inscrição para receber emails',
            deleted: 'Deletado',
            rejected: 'Rejeitado',
            disabled: 'Desabilitado',
            paused: 'Pausado',
            pending: 'Pendente',
            failed: 'Falhou',
            submitted: 'Enviado',
            deactivated: 'Desativado'
          }
        },
        conversations: {
          conversation: {
            noData: 'Nenhuma conversa para mostrar.',
            rowsPerPage: 'Registros por página',
            recipients: ' destinatários',
            createNewList: 'Criar nova lista',
            excludeConversationSelected: 'Excluir conversas selecionados',
            createListConversationSelected: 'Criar lista com conversas selecionadas',
            of: 'de',
            createListConversationAll: 'Criar lista com todas conversas',
            includeOnKanban: 'Incluir no Kanban',
            includeOnKanbanTitle: 'Incluir conversas no Quadro',
            selectBoard: 'Selecione um Quadro',
            selectColumn: 'Selecione uma Etapa',
            attention: 'Atenção:',
            kanbanIncludeHint: 'Serão incluídas somente as conversas dos chatbot(s) e/ou departamento(s) designados no Quadro de destino.',
            include: 'Incluir',
            kanbanIncludeSuccess: 'conversas incluídas no Quadro.',
            kanbanIncludeSkipped: 'ignoradas (já incluídas ou fora dos parâmetros).',
            kanbanIncludeError: 'Não foi possível incluir as conversas no Quadro.',
            kanbanIncludeNoneEligible: 'Nenhuma conversa selecionada atende aos parâmetros do Quadro.',
            exportConversationSelected: 'Exportar conversas selecionados',
            exportAllConversationSelected: 'Exportar todas as conversas',
            forwardConversationSelected: 'Encaminhar conversas selecionados',
            forwardConversationIntegrations: 'Encaminhar conversas nas integrações',
            columns: 'Colunas',
            dateAndHour: 'Data e Hora',
            protocol: 'Protocolo',
            chatbot: 'Chatbot',
            tags: 'Tags',
            channel: 'Canal',
            actions: 'Ações',
            monetaryValue: 'Valor',
            phone: 'Telefone',
            attendedBy: 'Atendido por',
            satisfaction: 'Satisfação',
            category: 'Categoria',
            department: 'Departamento',
            linkDepartment: 'Vincular departamento',
            departmentLinked: 'Departamento vinculado com sucesso.',
            linkDepartmentError: 'Não foi possível vincular o departamento.',
            name: 'Nome',
            transhipmentAttended: 'Transbordo atendido: o atendente atendeu o cliente. Tudo ok!',
            transhipmentUserLost: 'Transbordo não atendido: o cliente abandonou o chat, antes do atendente interagir!',
            transhipmentNotYetAttended: 'Transbordo ainda não atendido/espera: o atendente ainda não interagiu com o cliente.',
            transhipmentWaitigAttended: 'Transbordo não atendido: aguardando atendente assumir.',
            botDeleted: 'Bot excluído',
            transhipmentUnrealized: 'Transbordo não realizado: nenhum atendente online no momento. Chatbot retomou a conversa.',
            transhipmentRejected: 'Transbordo rejeitado: atendente finalizou a conversa antes de interagir com o usário',
            transhipmentFromHSMWaiting: 'Conversa iniciada pelo atendente ainda aguardando resposta do cliente (WhatsApp)',
            transhipmentFromLiveHSMOk: 'Conversa iniciada pelo atendente com resposta do cliente (WhatsApp). Tudo ok!',
            transhipmentFromBroadcastHSMOk: 'Conversa iniciada através de envios em massa do Módulo Campanhas com resposta do cliente (WhatsApp). Tudo ok!',
            transhipmentFromLiveHSMIdleFinished: 'Conversa iniciada e finalizada pelo atendente sem resposta do cliente (WhatsApp)',
            emailLeadSend: 'E-mail de lead enviado',
            nameEmailLeadSend: ', E-mail de lead enviado',
            createNewListWith: 'Crie uma Lista com as ',
            hasAttachments: 'Contém Anexo(s)',
            session: 'Sessão',
            conversationSelect: ' conversas selecionadas. Utilize a lista criada no módulo Mensageria para enviar mensagens via e-mail, SMS ou WhatsApp.',
            listName: 'Nome da lista',
            cancel: 'Cancelar',
            save: 'Salvar',
            excludeConversations: 'Excluir conversas',
            areSureWantToDelete: 'Tem certeza que deseja excluir ',
            conversationsSelected: ' conversas selecionadas?',
            exclude: 'Excluir',
            reportExport: 'Exportação de relatório',
            reportExportNPS: 'Exportação de relatório NPS',
            willReportExport: 'Você irá exportar um relatório com ',
            conversationsSelectedFormatCsv: ' conversas selecionadas no formato .CSV.',
            exported: 'Exportar',
            exportedXlsx: 'Exportar em XLSX',
            exportedCsv: 'Exportar em CSV',
            forward: 'Encaminhar',
            youCanSend: 'Você poderá enviar as conversas selecionadas por email para outra pessoa.',
            internalMessage: 'Enviar com mensagens internas do chat ao vivo.',
            email: 'E-mail',
            integrations: 'Integrações',
            youCanSendCrmOrTickets: 'Você poderá enviar as conversas selecionadas para o seu CRM ou sistema de tickets',
            sendConversations: 'conversas enviadas',
            notSendConversations: 'conversas não envidas:',
            selectIntegration: 'Selecione sua integração',
            send: 'Enviar',
            all: 'Todos',
            primary: 'Primário',
            conversations: 'Conversas',
            messageSendEmailBut: 'Os e-mails foram enviados porém ',
            messageSendEmailSuccess: 'E-mails enviados com sucesso!',
            messageNotSendEmail: 'Oops, os e-mails não foram enviados.',
            messageOps: 'Oops, ',
            messageNeedEmail: 'Oops, precisamos de um email para encaminhar!',
            messageIntegrationsSendBut: 'Integrações enviadas porém ',
            messageIntegrationsSendSuccess: 'Integrações enviadas com sucesso!',
            messageIntegrationsNotSend: 'Oops, as integrações não foram enviadas.',
            messageIntegrationsNotSendField: 'Oops, as integrações não foram enviadas por falta de campo obrigatório.',
            messageNeedIntegrations: 'Oops, precisamos de uma integração para enviar!',
            messageSaveList: 'Sua lista foi salva!',
            messageListNeedName: 'A sua lista precisa de um nome!',
            messageOpsError: 'Oops, ocorreu algum erro.',
            date: 'Data',
            hour: 'Hora'
          }
        },
        consumption: {
          list: {
            clientsConsumption: 'Consumos por cliente',
          }
        },
        dashboard: {
          dashboard: {
            weHaveNews: 'Temos novidades!',
            helpCenter: 'Conheça a nossa Central de Ajuda. São mais de',
            articles: '100 artigos',
            featuresPlatform: 'explicando<br/> passo a passo as funcionalidades da nossa plataforma.',
            viewMore: 'Ver mais!',
            welcomeMessage: 'Aproveite os mais novos recursos e funcionalidades que preparamos para você!',
            clickItem: 'Clique nos itens para assistir à demonstração.',
            newLook: 'A plataforma em um novo visual.',
            highPerformance: 'Maior performance e processamento.',
            talkTeam: 'Converse agora também com sua equipe.',
            attendanceChanges: 'Mudanças ao assumir e finalizar atendimento.',
            emojisAndQuickResponse: 'Emojis, respostas rápidas e outras novidades.',
            commentDuringAttendance: 'Comentários e anotações durante o atendimento.',
            insights: 'Insights',
            beSurprise: 'Surpreenda-se',
            beSurpriseDesc: 'Assista aos vídeos e veja o que há de mais novo na Globalbot!',
            beSurpriseStatusAndBlock: 'Status e Bloqueio de WhatsApp',
            beSurpriseWhatsappButton: 'Botão WhatsApp com rastreabilidade',
            beSurpriseMonetaryValue: 'Atribuindo valor nas conversas',
            beSurpriseCopilotWriter: 'Copiloto Assistente de Escrita',
            beSurpriseCopilotKnowledge: 'Copiloto Assistente de Conhecimento',
            startHere: 'Comece por aqui',
            startHereDesc: 'Veja as etapas para você deixar tudo pronto!',
            startHereStepOne: 'Defina aspectos visuais do chatbot',
            startHereStepTwo: 'Configure frases e coleta de dados',
            startHereStepThree: 'Configure a Inteligência Artificial Generativa',
            startHereStepFour: 'Teste o chatbot',
            startHereStepFive: 'Instale no seu site',
            stillInDoubt: 'Ainda com dúvidas?',
            seeVideo: 'Veja o vídeo explicativo',
            additionalFeatures: 'Recursos Adicionais',
            additionalFeaturesDesc: 'Veja alguns recursos da versão completa da Globalbot.',
            additionalFeaturesSeeMore: 'Saiba mais e faça o Upgrade!',
            multichannelFeatureDesc: 'Múltiplos canais para o seu chatbot: Whatsapp, Instagram, Chat do Site, Messenger e Telegram.',
            liveChatFeatureDesc: 'Chat ao Vivo! Transfira a conversa para seu time de vendas ou atendimento.',
            campaignFeatureDesc: 'Realize campanhas de marketing via WhatsApp, SMS e e-mail.',
            specialistFeatureDesc: 'Apoio com time de especialistas e mais de 100 recursos adicionais.',
            remainingCredits: 'Créditos restantes.',
            requestCredits: 'Solicitar créditos.',
            requestCreditsDesc: 'Sua conta já possui 100 créditos mensais renováveis e não cumulativos. Cada crédito é consumido por 1 pergunta + 1 resposta do chatbot. Você pode solicitar créditos adicionais (que não expiram).',
            news: 'Histórico de atualizações',
            improvement: 'Sugerir melhoria',
            newsDesc: 'Veja o histórico de atualizações na plataforma Globalbot.',
            visitBlog: 'Para acessar todo o conteúdo, visite o nosso ',
            version: 'Versão',
            build: 'Build',
            termsOfUse: 'Termos de Uso',
            goodMorning: 'Bom dia',
            goodAfternoon: 'Boa tarde',
            goodEvening: 'Boa noite',
            accountData: 'Dados da conta',
            accountDataLabel: 'Confira abaixo as informações do plano contratado.',
            systemAvailability: 'Disponibilidade do Sistema',
            cardAccount: {
              plan: 'Plano',
              consumption: 'Consumo mensal',
              lineWhatsapp: 'Whatsapp',
              lineOtherChannel: 'Outros canais',
              toltip: `
                Confira as informações de consumo e total da franquia mensal contratada em volume de conversas (atendimentos) do mês corrente.</br></br>
                No caso do consumo ultrapassar 100% a franquia contratada, a plataforma continuará em operação e haverá cobrança do valor excedente conforme tabela de preços vigente.</br></br>
                WhatsApp: conversa é uma sessão de 24h considerando todas as mensagens trocadas durante o período. (contempla conversas recebidas dos clientes e iniciadas pela empresa)\nOutros Canais: contempla o somatório de conversas recebidas dos clientes nos canais WebChat, Messenger ou Telegram)
              `
            },
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro',
          },
          layout: {
            localization: 'Idioma',
            portuguese: 'Português',
            english: 'Inglês',
            spanish: 'Espanhol',
            online: 'Online',
            kanban: 'Quadros Kanban',
            kanbanTagNew: 'NEW',
            availableToNewAttendance: 'Você estará disponível para receber novos atendimentos do(s) seu(s) departamento(s).',
            away: 'Away',
            pauseNewAttendance: 'Entrar em pausa. Você continuará atendendo suas conversas ativas mas não receberá novos atendimentos.',
            offline: 'Offline',
            disconnectToChat: 'Você desconectará imediatamente do chat. Nenhum atendimento novo será atribuído a você.',
            myProfile: 'Meu perfil',
            notificationCenter: 'Central de notificações',
            nightMode: 'Modo noturno',
            exit: 'Sair',
            tasks: 'Tarefas',
            clients: 'Clientes',
            copilotAnalytics: 'Copiloto Analytics',
            emailUnsubscribes: 'Descadastros de e-mail',
            actions: 'Actions',
            changeLogs: 'Novidades | Change Logs',
            nps: 'Relatório NPS',
            serverWhatsapp: 'Servidores de WhatsApp',
            conversationDetails: 'Detalhes da conversa',
            home: 'Tela inicial',
            statistics: 'Estatísticas',
            conversation: 'Conversas',
            chatBots: 'Chatbots',
            intelligence: 'Inteligência',
            campaigns: 'Campanhas',
            liveChat: 'Chat ao vivo',
            library: 'Biblioteca',
            needHelp: 'Precisa de Ajuda? Informe o que você<br/> precisa e nossa equipe irá ajudar você!',
            preferences: 'Preferências',
            important: 'Importante:',
            messageImportant: ' Ao entrar em pausa você continuará atendendo suas conversas ativas mas não receberá novos atendimentos.',
            reasonPause: 'Motivo da pausa',
            cancel: 'Cancelar',
            continue: 'Continuar',
            deleteAccount: 'Excluir Conta',
            realyDeleteAccount: 'Você realmente deseja excluir esta conta?',
            important: 'Importante:',
            deleteAccountDescription: 'Ao excluir a conta, todos os dados serão excluídos de forma permanente e você e os demais usuários não terão mais acesso ao software.',
            deleteAccountSuccess: 'Conta excluída com sucesso.',
            deleteAccontError: 'Erro ao excluir conta.',
            helpCenterTitle: 'Central de Ajuda',
            searchHelpCenter: 'Pesquisar na Central de Ajuda',
            searchHelpCenterDescription: 'Pesquise sua dúvida sobre a Globalbot em nossos artigos e materiais.',
            select: 'Selecionar',
            consultTelma: 'Consultar Telma',
            virtualAssistant: 'Assistente Virtual',
            consultTelmaDescription: 'Tire dúvidas sobre a solução Globalbot<br />com a nossa assistente virtual.',
            npsGreeting: 'Olá! Queremos sua opinião.',
            npsRecommendationQuestion: 'De 0 a 10, quanto você recomendaria a Globalbot para um amigo ou colega?',
            npsNotRecommend: 'Não recomendaria',
            npsHighlyRecommend: 'Recomendaria muito',
            npsRatingReason: 'Nos conte a razão para sua nota!',
            npsSend: 'Enviar',
            npsClose: 'Fechar',
            npsThanks: 'Muito obrigado pela sua participação.',
            npsGoogleHelp: 'Nos ajude também dando uma nota ou comentário no Google, ',
            npsClickHere: 'clique aqui.',
            npsPhone: 'Se deseja ser contatado(a) pela Globalbot, informe seu telefone.',
            npsNoThanks: 'Não, obrigado(a)',
            npsJump: 'Pular',
            npsWriteHere: 'Escreva aqui',
            npsCommentHere: 'Comente aqui antes de enviar!',
            npsPhoneHere: 'Digite seu telefone antes de enviar!'
          }
        },
        flow: {
          editor: {
            save: 'Salvar',
            errorSavingInformation: 'Oops, algum erro aconteceu ao salvar as informações.',
            savedFlow: 'Fluxo salvo'
          },
          flow: {
            flow: 'Fluxo',
            save: 'Salvar',
            addOneBalloon: 'Adicionar 1 balão',
            addTenBalloons: 'Adicionar 10 balões',
            removeLastBalloon: 'Remover último balão',
            removeTheLastTenBalloons: 'Remover os últimos 10 balões',
            test: 'Testar',
            indicateBalloonLine: 'Este número indica a linha em que o balão está.',
            responseField: 'Campo de resposta',
            emptyQuestion: 'Pergunta vazia',
            clickAndEditBalloon: 'Ao clicar você poderá editar o balão inteiro.',
            clickGoToLine: 'Ao clicar você poderá ir para a linha.',
            type: 'Tipo',
            indicatorName: 'Indicador do nome do',
            balloon: 'do balão.',
            identifier: 'Identificador',
            responseWillAppearInConversation: 'Esta resposta aparecerá na aba conversas.',
            knowledge: 'Base de conhecimento',
            jumpIfNotFound: 'Salto caso não encontrar',
            ifThereNoQuestionJumpTheLine: 'Caso não houver pergunta cadastrada, saltará para a linha',
            department: 'Departamento',
            jumpIfNoOneOnline: 'Salto caso ninguém online',
            jumpIfNoAttendantOnline: 'Caso não houver nenhum atendente online, saltará para a linha',
            jumpingToLine: 'Saltando para a linha',
            botWillGoToLine: 'O bot após passar por esse balão, irá para a linha',
            clickInNumberGoToLine: 'Clique no número para ir para a linha.',
            uniqueExternalCode: 'Código externo único',
            webchatExternalCode: 'Código externo Webchat',
            facebookExternalCode: 'Código externo Facebook',
            whatsappExternalCode: 'Código externo Whatsapp',
            glpiIntegration: 'Integração com GLPI',
            sendingLeadEmail: 'Enviando e-mail de lead',
            thisBalloonCreatesTags: 'Este balão cria tag(s)',
            appearanceTime: 'Tempo de aparecimento',
            previewAppearanceTime: 'Mostra o tempo de aparecimento do balão, o padrão é 3000 milisegundos (3 segundos)',
            finishingBot: 'Finalização do bot',
            finishingBotDescription: 'Quando o bot chegar nessa linha ele vai finalizar.',
            dontResponse: 'Não responder',
            dontResponseDescription: 'Aqui surge uma opção para o usuário não responder, quando clicar nela, o bot vai para o próximo balão.',
            comment: 'Comentário',
            commentDescription: 'Comentário feito por um editor deste fluxo.',
            secureMessage: 'Mensagem segura',
            secureMessageDescription: 'Essa resposta não será salva nas Conversas na plataforma Globalbot',
            editLine: 'Editar linha',
            emptyBalloon: 'Esvaziar balão',
            done: 'Feito',
            editText: 'Editar texto',
            addRandomResponse: 'Adicionar resposta randômica',
            enterYourQuestion: 'Digite aqui sua pergunta',
            editResponseAttributes: 'Edite os atributos da resposta abaixo',
            titleButtonsListWhatsApp: 'Título da lista de botões no WhatsApp',
            none: 'Nenhum',
            theType: 'O tipo',
            theTypeNoneDescription: 'é quando não espera nenhuma resposta, é só para mostrar algo na pergunta.',
            text: 'Texto',
            theTypeTextDescription: 'é para só para respostas, ele permite o usuário colocar qualquer texto, números sem nenhum tipo de máscara.',
            name: 'Nome',
            theTypeNameDescription: 'é para só para respostas, ele permite o usuário colocar o nome ou como ele deseja ser chamado.',
            cpf: 'CPF',
            theTypeCpfDescription: 'é para só para respostas, ele permite o usuário colocar o CPF com a máscara de CPF.',
            phone: 'Telefone',
            theTypePhoneDescription: 'é para só para respostas, ele permite o usuário colocar o Telefone com a máscara de Telefone.',
            email: 'E-mail',
            theTypeEmailDescription: 'é para só para respostas, ele permite o usuário colocar o e-mail e valida com uma ferramenta.',
            buttons: 'Botões',
            theTypeButtonsDescription: 'é para só para respostas, ele permite o usuário escolher entre 2 ou mais opções de botões.',
            list: 'Lista',
            faq: 'FAQ',
            dataBase: 'Base de Dados',
            theTypeFaqDescription: 'é para só para respostas, ele permite o usuário digite algo e ao enviar, procura na inteligência o que ele digitou.',
            carousel: 'Carrossel',
            theTypeCarouselDescription: 'é para só para respostas, ele permite o usuário escolher uma opção entre 2 ou mais de um carrossel.',
            liveChat: 'Chat Ao Vivo',
            theTypeLiveChatDescription: 'tenta conectar ao chat ao vivo da Globalbot.',
            calendar: 'Calendário',
            theTypeCalendarDescription: 'permite o usuário escolher a data desejada no calendário.',
            time: 'Horário',
            theTypeTimeDescription: 'permite o usuário escolher o horário no relógio.',
            response: 'Resposta',
            buttonOptions: 'Opções para os botões',
            dragToSwitchPosition: 'Arrastar para trocar posição',
            value: 'Valor',
            jump: 'Salto',
            switchToSmartButton: 'Trocar para botão com inteligência',
            switchToButtons: 'Trocar para botões',
            excludeButton: 'Excluir este botão',
            addButton: 'Adicionar outro botão',
            checkboxOptions: 'Opções para os checkbox',
            genai: 'IA Generativa',
            slidersOptions: 'Opções para os sliders',
            label: 'Label',
            minValue: 'Valor mínimo',
            maxValue: 'Valor máximo',
            initialValue: 'Valor inicial',
            step: 'Passada',
            guideScreenOptions: 'Opções para Tela Guiada',
            pageLink: 'Link da página',
            returnJump: 'Salto de retorno',
            pageButtonLabel: 'Texto do botão',
            pageButtonLabelHint: 'Texto do botão de link no WhatsApp. Padrão: "Abrir link".',
            faqOptions: 'Opções para FAQ',
            dataBaseOptions: 'Opções para Base de Dados',
            knowledgeBase: 'Base de conhecimento',
            secondaryKnowledgeBase: 'Base de conhecimento secundária',
            ifNotFound: 'Se não encontrado:',
            faqButtons: 'Botões na FAQ',
            learningTime: 'Tempo de aprendizado (dias)',
            buttonLimit: 'Limite de botões',
            machineLearning: 'Máquina de aprendizado',
            imageOptions: 'Opções para imagem do Facebook ou Whatsapp',
            imageLink: 'Link da imagem',
            textOptions: 'Opções para texto.',
            mask: 'Máscara',
            messageError: 'Mensagem de erro',
            messageErrorOption: 'Mensagem de erro de opção',
            newMask: 'Nova máscara',
            typeSomething: 'Por favor, digite algo.',
            onlyFacebook: 'Só para o facebook, utilize o embebed do youtube ou outros componentes',
            chooseVideoFromLibrary: 'Escolha um vídeo da biblioteca',
            videoLink: 'Link do vídeo AVI, MP4 etc',
            moreOptions: 'Mais opções',
            kanbanAssociation: 'Associar ao quadro Kanban',
            kanbanAssociationDescription: 'A conversa que passar por esta linha será adicionada como card no quadro e coluna escolhidos.',
            selectKanbanBoard: 'Selecione um quadro',
            selectKanbanColumn: 'Selecione uma coluna',
            kanbanNoBoards: 'Nenhum quadro Kanban associado a este bot.',
            kanbanColumnRequired: 'Selecione uma coluna do Kanban na linha ',
            liveChatOptions: 'Opções para o Chat ao vivo',
            fill: 'Preencha',
            message: 'Mensagem',
            liveErrorJump: 'Erro no salto',
            liveErrorJumpMessage: 'O salto não pode ser para a mesma linha',
            setIdentifier: 'Defina o identificador para salvar a resposta do usuário.',
            newIdentifier: 'Novo identificador',
            jumpLine: 'Salto de linha',
            defineJumpToNextLine: 'Defina onde vai ser a próxima linha para o chatbot saltar.',
            jumpToLine: 'Saltando para a linha',
            jumpTo: 'Saltar para',
            genaiErrorFallback: 'Se o agente de IA falhar',
            genaiErrorFallbackDescription: 'Caso ocorra algum erro ao processar a mensagem no agente de IA, o cliente recebe o aviso "Não consegui processar sua mensagem, tente novamente mais tarde." e o fluxo segue automaticamente para a linha definida em "Salto de linha". Se não houver salto definido, o cliente é levado para a próxima linha/balão do fluxo, sem ficar preso nesta linha.',
            assignComment: 'Atribuir um comentário',
            assignCommentDescription: 'Você irá atribuir um comentário para esta linha dentro do fluxo.',
            notResponseOptions: 'Opção de não responder',
            createNotResponseOnlyWebchat: 'Cria uma opção de não responder a pergunta. Apenas para Webchat.',
            notResponse: 'Não responder',
            secureMessageOptions: 'Opção de mensagem segura',
            writtenMessageOne: 'A mensagem escrita pelo usuário não será guardada pela Globalbot.',
            waitDefinedValue: 'Quando ativado, ele espera o valor definido em milisegundos para aparecer.',
            timing: 'Tempo',
            addTiming: 'Adicionar Tempo',
            integrations: 'Integrações',
            ticketTitle: 'Coloque o título do Ticket que você deseja e clique no + ao lado.',
            sendTicketToGlpi: 'Após salvar o bot ao passar por essa linha irá enviar um ticket para o Sistema GLPI.',
            clickTheIcon: 'Para desativar, é apenas clicar no ícone de menos.',
            editTicketTitle: 'Editar título do ticket',
            newTicketTitle: 'Novo título do ticket',
            sendLeadTranscriptEmail: 'Enviar transcrição de lead via e-mail',
            insertEmail: 'Coloque o e-mail para enviar o lead no campo abaixo.',
            saveBotAndSendEmail: 'Após salvar o bot ao passar por essa linha irá enviar e-mail de lead para o e-mail informado.',
            editEmail: 'Editar e-mail',
            newEmail: 'Novo e-mail',
            addTagInConversation: 'Adicionar TAG na conversa',
            selectTags: 'Selecione as tags para ser adicionadas na conversa caso passar por esta linha.',
            selectOneTag: 'Selecione uma TAG',
            addTag: 'Adicionar tags',
            externalCode: 'Códigos externos',
            masterOnlyFunction: 'Função só para masters.',
            insertCode: 'Aqui vai um código em javascript puro, que irá ser executado nessa linha.',
            codeAdapted: 'Caso não seja o Callback Único, cada plataforma precisa de um código adaptado para funcionar.',
            unifiedExternalCode: 'Código externo unificado',
            newUnifiedExternalCode: 'Novo código externo unificado',
            externalCodeForWebchat: 'Código externo para Webchat',
            newExternalCodeForWebchat: 'Novo código externo para Webchat',
            externalCodeForWhatsapp: 'Código externo para Whatsapp',
            newExternalCodeForWhatsapp: 'Novo código externo para Whatsapp',
            externalCodeForFacebook: 'Código externo para Facebook',
            newExternalCodeForFacebook: 'Novo código externo para Facebook',
            close: 'Fechar',
            guideScreen: 'Tela Guiada',
            businessHours: 'Jornada',
            zipCode: 'CEP',
            cnpj: 'CNPJ',
            finish: 'Finalizar',
            uploadImage: 'Upload de imagem',
            uploadMedia: 'Upload de mídia',
            uploadPdf: 'Upload de PDF',
            uploadMediaOptions: 'Opções do upload de mídia',
            mediaSkipToggle: 'Botão de ignorar envio',
            mediaSkipLabel: 'Texto do botão',
            mediaSkipJump: 'Salto ao ignorar',
            mediaRetryToggle: 'Limite de tentativas inválidas',
            mediaRetryLimit: 'Tentativas',
            mediaRetryJump: 'Salto no excesso',
            mediaRetryMessage: 'Mensagem de tentativa inválida (opcional)',
            mediaSkipOnCard: 'Ignorar envio',
            nameOptions: 'Opções do nome',
            nameConfirmButtonsToggle: 'Botões de confirmação',
            nameConfirmButtonsHint: 'No WhatsApp, quando o nome do perfil já é conhecido, pede a confirmação com os botões Sim e Não. Desligado, pergunta o nome diretamente.',
            nameConfirmButtonsOffOnCard: 'Sem botões de confirmação',
            persistenceSendMessagesToggle: 'Enviar mensagens de persistência',
            persistenceSendMessagesHint: 'Quando desligado, o cliente não recebe as mensagens de lembrete da persistência nem o reenvio deste nó. Os tempos, o encerramento ou o transbordo continuam funcionando e as mensagens ficam salvas no histórico para auditoria. Vale apenas para WhatsApp. Só tem efeito se a persistência estiver configurada no comportamento do bot.',
            persistenceSendMessagesOffOnCard: 'Mensagens de persistência desligadas (WhatsApp)',
            mediaRetryOnCard: 'Excesso de tentativas',
            messageErrorMediaSkip: 'Oops, botão de ignorar sem texto ou com salto inválido na linha ',
            messageErrorMediaRetry: 'Oops, limite de tentativas ou salto de excesso inválido na linha ',
            checkbox: 'Checkbox',
            rating: 'Estrelas',
            number: 'Número',
            firstName: 'Primeiro nome',
            lastName: 'Sobrenome',
            audio: 'Áudio',
            bornDate: 'Data de nascimento',
            slider: 'Slider',
            image: 'Imagem',
            facebookVideo: 'Vídeo Facebook',
            video: 'Video',
            city: 'Cidade',
            state: 'Estado',
            country: 'País',
            maskMoney: 'Máscara de dinheiro',
            noBaseAvailable: 'Sem base disponível',
            noBaseAssigned: 'Sem base atribuída',
            dataBaseNotFoundOption: 'Infelizmente não temos esta opção, escolha uma opção válida.',
            noBaseDefined: 'Sem base definida',
            noBodyOnline: 'Infelizmente não temos ninguém online no momento.',
            dataBaseNotFound: 'Dados da base não encontrados',
            messageErrorButtonsDuplication: 'Oops, nomes de botões duplicados na linha ',
            messageErrorButtonsValueDuplication: 'Oops, valores de botões duplicados na linha ',
            buttonValueDuplicated: 'Valor duplicado neste nó',
            messageErrorButtonsEmpty: 'Oops, botões com valores vazios na linha ',
            messageErrorFAQEmpty: 'Oops, é necessário definir uma base de conhecimento na linha ',
            messageErrorFAQButtonsEmpty: 'Oops botões de FAQ com valores vazios na linha ',
            messageErrorJourneyJump: 'Oops, salto de erro não definido na jornada ',
            mandatoryField: 'Campo obrigatório',
            messageErrorSaved: 'Oops, algum erro aconteceu ao salvar as informações.',
            saveDescription: 'Coloque uma descrição antes de salvar.',
            flowSaved: 'Fluxo salvo',
            flowPublish: 'Fluxo Publicado',
            editFlow: 'Editor de fluxo',
            title: 'Título',
            description: 'Descrição',
            select: 'Selecionar',
            defineOutOfHoursMessage: 'Defina uma mensagem que será mostrada caso o usuário esteja fora do horário.',
            outOfHoursMessage: 'Mensagem fora do horário',
            defineOutOfHoursJump: 'Determine para qual linha o fluxo irá caso o usuário esteja fora do horário.',
            outOfHoursJump: 'Salto fora de horário.',
            goToLineInput: 'Ir para a linha...',
            scrollToTop: 'Ir ao topo',
            flowChatbot: 'Fluxo'
          },
          flowLite: {
            flowLite: 'Fluxo Lite',
            addBalloonAbove: 'Adicionar balão a cima',
            randomMessage: 'Mensagem randômica',
            message: 'Mensagem',
            name: 'Nome',
            buttons: 'Botões',
            intelligence: 'Inteligência',
            carousel: 'Carrossel',
            text: 'Texto',
            email: 'Email',
            checkbox: 'Checkbox',
            rating: 'Estrelas',
            number: 'Número',
            firstName: 'Primeiro nome',
            lastName: 'Sobrenome',
            phone: 'Telefone',
            telephone: 'Telefone',
            audio: 'Áudio',
            liveChat: 'Chat ao vivo',
            cpf: 'CPF',
            zipCode: 'CEP',
            calendar: 'Calendário',
            slider: 'Slinder',
            image: 'Imagem',
            city: 'Cidade',
            state: 'Estado',
            country: 'País',
            money: 'Dinheiro',
            cnpj: 'CNPJ',
            uploadImage: 'Upload de imagem',
            finish: 'Finalizar',
            guideScreen: 'Tela guiada',
            done: 'Feito',
            editText: 'Editar texto',
            addRandomResponse: 'Adicionar resposta randômica',
            randomizeResponse: 'Randomizar resposta',
            edit: 'Editar',
            exclude: 'Excluir',
            identifier: 'Identificador',
            jump: 'Salto',
            excludeBalloon: 'Excluir balão',
            wantToExcludeBalloon: 'Tem certeza que deseja excluir este balão?',
            dontAskAgain: 'Não perguntar novamente',
            cancel: 'Cancelar',
            editBalloon: 'Editar balão',
            instructions: 'Instruções',
            saveRepliesDescription: 'O "identificador" é utilizado para criar saltos e ser gravado em locais como conversas, integrações, etc. Use para guardar respostas importantes de seus clientes.',
            doNotUse: 'Não use "espaços", use "_" (underscore), não use acentuações, caso tenha qualquer dúvida a respeito, entre em contato.',
            identifierName: 'Nome do identificador',
            replacementSystem: 'Caso você queira usar o sistema de substituição apenas coloque o identificador dentro de "%", exemplo: %MEU_IDENTIFICADOR%',
            useButtons: 'Use quantos botões for necessários, mas lembre-se, caso o número seja maior que 6 o mesmo irá virar uma lista (dropdown).',
            changePosition: 'Caso queira mudar os botões de posição clique no icone',
            andDrag: 'e arraste.',
            sameValue: 'Chave e valor devem sempre terem os mesmos valores. Não esqueça de escolher um identificador para saltar.',
            key: 'Chave',
            value: 'Valor',
            add: 'Adicionar',
            specificDepartment: 'Departamento: caso tenha um departamento específico, selecione, caso contrário deixe como "Primário".',
            messageErrorDescription: 'Mensagem de erro: mensagem caso a IA não consiga responser.',
            jumpErrorDescription: 'Salto de erro: saltar para algum identificador caso a IA não consiga responder.',
            departments: 'Departamentos',
            messageError: 'Mensagem de erro',
            jumpError: 'Salto de erro',
            knowledgeBaseDescription: 'Base de conhecimento: A busca da IA será apenas na base de conhecimento selecionada.',
            jumpDescription: 'Salto: Caso a IA não tenha resposta para a pergunta irá saltar para o identificador selecionado ou repetir a pergunta caso não seja selecionado nenhum identificador.',
            knowledgeBase: 'Base de conhecimento',
            jumpWithoutAiResponse: 'Salto (sem resposta da IA)',
            machineLearning: 'Máquina de aprendizado',
            importantDescription: 'Importante: Este recurso funciona apenas no Webchat.',
            machineLearningDescription: 'Máquina de aprendizado: A IA aprende com seus clientes, trazendo as respostas (em forma de botões) mais utilizadas para facilitar as dúvidas dos mesmos.',
            learningTimeDescription: 'Tempo de aprendizado: O tempo (em dias) que a IA pode utilizar para o aprendizado.',
            buttonLimitDescription: 'Limite de botões: A IA irá trazer as respostas se atendo ao número máximo de botões.',
            learningTime: 'Tempo de aprendizado (dias)',
            twoDays: 'Dois dias',
            threeDays: 'Três dias',
            oneWeek: 'Uma semana',
            twoWeek: 'Duas semanas',
            oneMonth: 'Um mês',
            oneQuarter: 'Um trimestre',
            oneSemester: 'Um semestre',
            buttonLimit: 'Limite de botões',
            three: 'Três',
            four: 'Quatro',
            five: 'Cinco',
            six: 'Seis',
            auxiliaryBases: 'Bases auxiliares',
            searchAuxiliaryBases: 'Caso a IA não tenha resposta usando a base de conhecimento escolhida a mesma irá procurar nas bases auxiliares.',
            optionToRefuseDisambiguation: 'Opção de recusar desambiguação',
            alwaysAllow: 'A IA vai sempre permitir que o cliente escolha a opção de recusar as respostas dada pela mesma.',
            onlyResponseUnambiguous: 'Lembre-se, esta opção é apenas para respostas desambiguadas.',
            fieldLabel: 'O campo Label irá aparecer junto ao número selecionado, por exemplo "25m²"',
            valueMaxAndMin: 'Valor mínimo e valor máximo definem até quanto seu cliente pode escolher.',
            selectionInitialValue: 'Escolha um valor inicial também, podendo facilitar para seu cliente.',
            stepDescription: 'A passada são os saltos de números, por exemplo se a passada for 5 o cliente pode escolher 25, 30, 35 e assim por diante.',
            label: 'Label',
            minValue: 'Valor mínimo',
            maxValue: 'Valor máximo',
            initialValue: 'Valor inicial',
            step: 'Passada',
            searchLibrary: 'Buscar na biblioteca',
            insertLink: 'Coloque o link da página que você queira guiar seu cliente.',
            restartReturnJump: 'O salto de retorno vai iniciar novamente o chat no identificador selecionado.',
            pageLink: 'Link da página',
            returnJump: 'Salto de retorno',
            useItems: 'Use quantos itens for necessários, mas lembre-se, caso o número seja maior que 6 o mesmo irá virar uma lista (dropdown).',
            changingThePositionButtons: 'Caso queira mudar os botões de posição clique no icone',
            googleAnalytics: 'Google Analytics',
            defineTheCategory: 'Defina a categoria, ação, etiqueta e o valor do evento.',
            requiredFields: 'Não esqueça, todas as informações precisam ser preenchidas.',
            category: 'Categoria',
            action: 'Ação',
            tag: 'Etiqueta',
            noInteraction: 'Sem interação',
            customerResponse: 'Resposta do cliente',
            manual: 'Manual',
            none: 'Nenhum',
            bornDate: 'Data de nascimento',
            maskMoney: 'Máscara de dinheiro',
            primary: 'Primário',
            all: 'Todas',
            clickHere: 'Clique aqui',
            select: 'Escolher',
            itemOne: 'Item um',
            noBodyOnline: 'Infelizmente não temos ninguém online no momento.',
            editFlowLite: 'Editor de fluxo lite'
          },
          list: {
            viewer: 'Visualizador',
            flowStructure: 'Visualize a estrutura do seu fluxo!.',
            editorPro: 'Explore sua criatividade no editor para profissionais, com diversos recursos interativos e novas configurações.',
            editor: 'Editor',
            editFlow: 'Edite o fluxo diretamente no código. Para quem possui conhecimentos de código HTML e JavaScript.',
            flows: 'Fluxos'
          },
          viewer: {
            flow: 'Fluxo',
            toView: 'Visualizar',
            test: 'Testar',
            indicatesTheBalloonLine: 'Este número indica a linha em que o balão está.',
            responseField: 'Campo de resposta',
            emptyQuestion: 'Pergunta vazia',
            clickGoToLine: 'Ao clicar você poderá ir para a linha.',
            type: 'Tipo',
            typeDescription: 'Indicador do nome do',
            theBalloon: 'do balão.',
            identifier: 'Identificador',
            identifierDescription: 'Esta resposta aparecerá na aba conversas.',
            knowledgeBase: 'Base de conhecimento',
            jumpCaseNotFound: 'Salto caso não encontrar',
            jumpCaseNotFoundDescription: 'Caso não houver pergunta cadastrada, saltará a linha',
            department: 'Departamento',
            noBodyOnline: 'Salto caso ninguém online',
            noBodyOnlineDescription: 'Caso não houver nenhum atendente online, saltará para a linha',
            jumpingToLine: 'Saltando para a linha',
            botWillGoToLine: 'O bot após passar por esse balão, irá para a linha',
            clickInNumberGoToLine: 'Clique no número para ir para a linha.',
            externalCode: 'Código externo',
            uniqueExternalCode: 'Código externo único',
            whatsappExternalCode: 'Código externo Whatsapp',
            facebookExternalCode: 'Código externo Facebook',
            glpiIntegration: 'Integração com GLPI',
            sendingLeadEmail: 'Enviando e-mail de lead',
            appearanceTime: 'Tempo de aparecimento',
            previewAppearanceTime: 'Mostra o tempo de aparecimento do balão, o padrão é 3000 milisegundos (3 segundos)',
            finishingBot: 'Finalização do bot',
            finishingBotDescription: 'Quando o bot chegar nessa linha ele vai finalizar.',
            dontResponse: 'Não responder',
            dontResponseDescription: 'Aqui surge uma opção para o usuário não responder, quando clicar nela, o bot vai para o próximo balão.',
            comment: 'Comentário',
            commentDescription: 'Comentário feito por um editor deste fluxo.',
            secureMessage: 'Mensagem segura',
            secureMessageDescription: 'Essa resposta não será salva nas Conversas na plataforma Globalbot',
            primary: 'Primário',
            none: 'Nenhum',
            name: 'Nome',
            faq: 'FAQ',
            buttons: 'Botões',
            list: 'Lista',
            carousel: 'Carrossel',
            text: 'Texto',
            email: 'E-mail',
            phone: 'Telefone',
            liveChat: 'Chat Ao Vivo',
            guideScreen: 'Tela guiada',
            cpf: 'CPF',
            zipCode: 'CEP',
            cnpj: 'CNPJ',
            finish: 'Finalizar',
            uploadImage: 'Upload de imagem',
            checkbox: 'Checkbox',
            rating: 'Estrelas',
            number: 'Número',
            firstName: 'Primeiro nome',
            lastName: 'Sobrenome',
            audio: 'Áudio',
            message: 'Mensagem',
            calendar: 'Calendário',
            bornDate: 'Data de nascimento',
            slider: ' Slider',
            image: 'Imagem',
            facebookVideo: 'Vídeo Facebook',
            video: 'Vídeo',
            city: 'Cidade',
            state: 'Estado',
            country: 'País',
            maskMoney: 'Máscara de dinheiro',
            noBaseAvailable: 'Sem base disponível',
            noBaseAssigned: 'Sem base atribuída',
            dataBaseNotFoundOption: 'Infelizmente não temos esta opção, escolha uma opção válida.',
            title: 'Título',
            description: 'Descrição',
            select: 'Selecionar',
            phoneIdentifierLowerCase: 'telefone',
            ratingIdentifierLowerCase: 'estrelas',
            numberIdentifierLowerCase: 'numero',
            messageLiveError: 'Infelizmente não temos ninguém online no momento.',
            noBaseDefined: 'Sem base definida',
            messageErrorSaveTheInformation: 'Oops, algum erro aconteceu ao salvar as informações.',
            flowSaved: 'Fluxo salvo',
            flowEditor: 'Editor de fluxo'
          }
        },
        help: {
          help: {
            help: 'Ajuda',
            whatIsYourDoubt: 'Qual sua dúvida?',
            needHelp: 'Precisa de ajuda?',
            tutorials: 'Tutoriais',
            messageErrorTestingIntelligence: 'Erro ao testar inteligência'
          }
        },
        kanban: {
          pageTitle: 'Quadros Kanban',
          making: 'Fazendo',
          done: 'Feito',
          createItem: 'Criar item',
          title: 'Título',
          message: 'Mensagem',
          cancel: 'Cancelar',
          add: 'Adicionar',
          newColumn: 'Adicionar nova Coluna',
          cardCreatedSuccess: 'Conversa incluída no Quadro.',
          cardCreateError: 'Não foi possível incluir a conversa no Quadro.',
          cardAlreadyExists: 'Esta conversa já está no Quadro.',
          newBoard: 'Novo Quadro',
          selectBoard: 'Selecione um quadro',
          notSelectedBoard: 'Nenhum quadro selecionado',
          createBoardHint: 'Ao criar um novo quadro, associe a chatbots e/ou departamentos. O quadro estará visível somente para os usuários vinculados a eles.',
          createBoardNameLabel: 'Nome*',
          createBoardNameRequired: 'Nome é obrigatório',
          createBoardNameMaxLength: 'O nome do quadro deve ter no máximo 45 caracteres',
          createBoardChatbotsLabel: 'Chatbots*',
          createBoardChatbotsRequired: 'Chatbots são obrigatórios',
          createBoardDepartmentsLabel: 'Departamentos',
          createBoardShowMonetaryValues: 'Mostrar valores das conversas no Quadro',
          createBoardError: 'Não foi possível criar o quadro',
          createBoardErrorTitleExists: 'Já existe um quadro com este nome',
          newBoardTitle: 'Novo Quadro',
          editBoardTitle: 'Editar Quadro',
          editBoardError: 'Não foi possível atualizar o quadro',
          reallyDeleteBoard: 'Tem certeza que deseja excluir este quadro?',
          reallyDeleteBoardDetail: 'Esta ação não pode ser desfeita.',
          reallyDeleteColumn: 'Tem certeza que deseja excluir esta coluna?',
          reallyDeleteColumnDetail: 'Esta ação não pode ser desfeita.',
          reallyClearColumn: 'Tem certeza que deseja limpar esta coluna?',
          reallyClearColumnDetail: 'Todos os cards serão removidos.',
          moveCardError: 'Não foi possível mover o card. A posição foi restaurada.',
          clearColumnTitle: 'Limpar coluna',
          deleteColumnTitle: 'Excluir coluna',
          board: 'Quadro',
          column: 'Coluna',
          selectPlaceholder: 'selecione',
          chooseColumnPlaceholder: 'escolha a coluna',
          cardNamePlaceholder: 'Nome do card',
          pressEnterToAdd: 'Pressione Enter para adicionar',
          cardNameRequired: 'Nome do card é obrigatório',
          columnTitleAlreadyExists: 'O nome da coluna já existe. Esta alteração não será salva.',
          newBoardTitleLabel: 'Novo Quadro',
          newBoardDescription: 'Adicione conversas a um quadro estilo Kanban para você organizar a sua operação.',
          emptyStateHint: 'Nada por aqui. Crie seu primeiro quadro.',
          emptyStateWatchDemoVideo: 'Veja aqui a demonstração em vídeo (3min)',
          emptyStateOr: 'ou',
          demoVideoTitle: 'Demonstração dos Quadros Kanban',
          scheduleDemo: 'Agendar Demonstração',
          scheduleDemoTitle: 'Agendar Demonstração Quadros Kanban',
          scheduleDemoDescription: 'O módulo Quadros Kanban já está incluído no seu plano. Agende uma demonstração e configuração personalizada com um de nossos especialistas. Assim que recebermos sua solicitação, entraremos em contato para organizar a agenda e convidados.',
          scheduleDemoPreferredDay: 'Dia preferido',
          scheduleDemoPreferredShift: 'Turno preferido',
          scheduleDemoDays: {
            monday: 'Segunda',
            tuesday: 'Terça',
            wednesday: 'Quarta',
            thursday: 'Quinta',
            friday: 'Sexta'
          },
          scheduleDemoShifts: {
            morning: 'Manhã',
            afternoon: 'Tarde'
          },
          scheduleDemoFieldRequired: 'Campo obrigatório',
          scheduleDemoConfirm: 'Solicitar',
          scheduleDemoSuccess: 'Solicitação enviada! Em breve entraremos em contato.',
          scheduleDemoError: 'Não foi possível enviar sua solicitação. Tente novamente.',
          last7Days: 'Últimos 7 dias',
          last30Days: 'Últimos 30 dias',
          last90Days: 'Últimos 90 dias',
          today: 'Hoje',
          searchPlaceholder: 'Pesquisar',
          conversations: 'conversas',
          conversationSingular: 'conversa',
          recentFirst: 'Recentes acima',
          manualOrder: 'Ordem manual',
          advancedFiltersHint: 'Filtros adicionais para esta busca serão aplicados aqui.',
          deleteBoardLabel: 'Excluir Quadro',
          chatbotTooltip: 'Chatbot',
          departmentTooltip: 'Departamento'
        },
        knowledge: {
          genai: {
            title: 'Inteligência Artificial Generativa',
            errors: {
              validation: 'Preencha todos os campos obrigatórios e tente novamente.',
              auth: 'Sessão inválida ou expirada. Faça login novamente.',
              insufficientCredits: 'Créditos insuficientes para utilizar a IA Generativa, solicite mais créditos e tente novamente.',
              notFound: 'O recurso solicitado não foi encontrado.',
              provider: 'Falha na comunicação com o provedor de IA. Tente novamente em instantes.',
              timeout: 'O provedor de IA demorou para responder. Tente novamente em instantes.',
              network: 'Falha de conexão. Verifique sua internet e tente novamente.',
              invalidCharacters: 'O campo {field} tem caracteres não aceitos: {chars}. Ajuste o nome e tente novamente.',
              fields: {
                assistantName: 'Nome do agente',
                trainingTitle: 'Título da base de conhecimento',
                triggerName: 'Nome do gatilho'
              },
              generic: 'Ocorreu um erro inesperado. Informe o código {errorId} ao suporte.'
            },
            card_title: "IA Generativa",
            card_description:
              "Respostas criadas a partir de grande massa de dados (modelo GPT).\nInterpreta a intenção do usuário e apresenta respostas geradas (texto e links).",
            column_name: "Nome",
            column_autor: "Autor",
            column_updatedAt: "Última atualização",
            column_action: "Ações",
            drawer_test: {
              title: "Teste da IA Generativa",
              name: 'Nome',
              text_motive: "Utilize o chat ao lado para testar as respostas da IA Generativa.<br>As respostas são geradas automaticamente baseadas nos arquivos e documentos informados.",
              note: "NOTA",
              text_note: "Lembre-se que a IA Generativa irá fazer parte de algum chatbot, portanto alguns recursos deste chat de teste são limitados (ex. não transbordo para atendentes).",
              restart: "Recomeçar",
              genai_mini: 'Utilize o chat abaixo para fazer os testes. Quando tudo estiver pronto, você poderá então fazer a instalação. O chat abaixo testa apenas a inteligência artificial e não capta as informações do lead.'
            },
            drawer_data: {
              updateWebsite: 'Atualizar Website',
              openWebsite: 'Abrir Website',
              editWebsite: 'Editar Website',
              deleteWebsite: 'Excluir Website',
              refreshWebsiteSuccess: 'Website atualizado com sucesso.',
              refreshWebsiteError: 'Erro ao atualizar website.',
              create: "Nova Base de Conhecimento",
              edit: "Editar Base de Conhecimento",
              provider: 'Motor de IA',
              providerDescription: 'Escolha qual IA generativa responde por esta base de conhecimento.',
              promptMinLength: 'Mínimo de {min} caracteres.',
              promptMaxLength: 'Máximo de {max} caracteres.',
              unavailableOnOpenai: 'Ainda não disponível no motor OpenAI.',
              triggersPromptDescriptionOpenai: 'No motor OpenAI, este texto é o que a IA lê para decidir se o gatilho se aplica. Descreva a situação, não a ação. Ex.: "quando o usuário pedir para falar com um atendente humano".',
              providerVerbeux: 'Verbeux',
              providerOpenai: 'OpenAI',
              providerImmutable: 'O motor de IA não pode ser alterado depois de criar a base.',
              providerFileUnsupported: 'Envio de arquivo na conversa não está disponível no motor OpenAI.',
              prompt: 'Orientações de Contexto (Prompt)',
              promptDescription: "Defina abaixo as orientações para direcionar as respostas da IA Generativa",
              docs: "Base de Conhecimento",
              docsDescriptions: "Submeta os arquivos e/ou informe os sites que serão utilizados pela IA Generativa (PDF) até 1,5 GB",
              docsDescriptionsOpenai: "Submeta os arquivos e/ou informe os sites que serão utilizados pela IA Generativa. Formatos aceitos: {formats} — até 512 MB por arquivo.",
              docsDescriptionsMini: "Submeta o conteúdo que será utilizado como fonte de informação da IA Generativa. Sites e documentos PDF de até 1,5 GB. Limite máximo de 400.000 caracteres no total.",
              informSite: 'Informar Site',
              informSiteDescription: 'Informe o endereço de um site.',
              url: 'Endereço URL *',
              recursiveSearch: "Busca recursiva: uma vez ativada esta opção, todos os links relacionados ao domínio informado serão incluídos.",
              cancel: 'Cancelar',
              importDoc: "Importar Arquivos",
              clickOrDrag: "Clique ou arraste os arquivos para esta área.",
              rules: "Regras Adicionais",
              triggers: "Gatilhos de Escape",
              triggersDescription: "Utilize gatilhos para levar o usuário a algum ponto do fluxo do chatbot.",
              name: 'Nome *',
              nameMinLength: 'O nome deve ter no mínimo 3 caracteres.',
              invalidCharacters: 'Caracteres não aceitos: {chars}',
              invalidCharactersReason: 'Este campo vira identificador na IA Generativa, por isso aceita apenas letras sem acento, números, _ e - (o espaço é convertido em _).',
              invalidCharactersReasonSpaces: 'Este campo aceita apenas letras sem acento, números, espaço, _ e -.',
              normalizedValue: 'Será salvo como: {value}',
              fileTitleSanitized: 'O nome do arquivo tinha caracteres não aceitos: {chars} — foi ajustado para {value}.',
              titleSanitized: 'O título tinha caracteres não aceitos: {chars} — foi ajustado para {value}.',
              requiredFieldsError: 'Preencha todos os campos obrigatórios.',
              save: 'Salvar',
              createSuccess: 'Assistente criado com sucesso.',
              updateSuccess: 'Assistente atualizado com sucesso.',
              deleteDocSuccess: 'Documento excluído com sucesso.',
              urlError: 'Erro ao atualizar URL:',
              triggerError: 'Erro ao atualizar gatilho:',
              updateFileError: 'Erro ao atualizar arquivo:',
              fileActive: 'Conteúdo Pronto e Disponível',
              fileProcessing: 'Conteúdo em Processamento',
              fileError: 'Erro ao Processar.. Apague o item e tente novamente',
              triggerError: 'Erro ao atualizar gatilho:',
              triggersPromptDescription: 'Defina abaixo as orientações para direcionar a IA Generativa a realizar a ação de gatilho.',
              flowJump: 'Ação: Ir para a seguinte linha do fluxo:',
              deleteTrigger: 'Exlcuir Gatilho',
              deletedTrigger: "Gatilho excluído.",
              errorDeleteThisTrigger: "Erro ao excluir gatilho.",
              areYouSureDeleteTrigger: "Tem certeza que deseja excluir este gatilho? Todos os dados do mesmo serão perdidos e esta ação não pode ser desfeita.",
              deleteDoc: 'Exlcuir Arquivo',
              deletedDoc: "Arquivo excluído.",
              errorDeleteThisDoc: "Erro ao excluir arquivo.",
              areYouSureDeleteDoc: "Tem certeza que deseja excluir este arquivo? Todos os dados do mesmo serão perdidos e esta ação não pode ser desfeita.",
              delete: 'Excluir',
              errorTreatment: 'Tratativa de Erro',
              errorTreatmentDescription: 'Defina o comportamento do chatbot quando não há resposta.',
              noResponse: 'Se ficar sem resposta por:',
              errorFlowJump: "Ir para a linha do fluxo",
              intervention: "Intervenção Programada",
              interventionDescription: "Defina uma intervenção programada a partir da quantidade de respostas.",
              from: "A partir de:",
              subsequentTimes: 'vezes seguidas',
              subsequentTime: 'vez',
              responsesRow: 'respostas seguidas',
              response: 'resposta',
              invalidURL: 'Por favor, informe uma URL válida.',
            },
            makeUpgrade: 'Faça o upgrade.',
            textLimitCharsTraining: 'de 400.000 caracteres utilizados. Exclua algum conteúdo ou aumente o limite.',
            textCountCharsTraining: 'de 400.000 caracteres utilizados. Para aumentar o limite.',
            genaiNotCreated: "Você ainda não tem assistentes",
            editGenai: "Editar assistente",
            testGenai: "Testar assistente",
            add: "Criar Assistente",
            exclude: "Excluir Assistente",
            deletedAssistant: "Assistente excluído.",
            errorDeleteThisAssistant: "Erro ao excluir assistente.",
            areYouSureDelete: "Tem certeza que deseja excluir este assistente? Todos os dados do mesmo serão perdidos e esta ação não pode ser desfeita.",
            cancel: "Cancelar",
            name: 'Nome',
            author: 'Autor',
            lastUpdate: 'Última atualização',
            actions: 'Ações'
          },
          knowledge: {
            card_title: "IA Convencional",
            card_description:
              "Respostas padronizadas. Interpreta a intenção do usuário e apresenta respostas cadastradas (texto, vídeo, imagens, documentos e links).",
            deleteQuestionSelected: 'Excluir repostas selecionadas',
            rowsPerPage: 'Registros por página:',
            conversations: 'Conversas',
            add: 'Adicionar',
            knowledgeBase: 'Base de conhecimento',
            exclude: 'Excluir',
            askQuestion: 'Faça uma pergunta (teste de intenções)',
            importQuestions: 'Importar perguntas',
            columns: 'Colunas',
            status: 'Status',
            questionKnowledgeBase: 'Pergunta / Base de conhecimento',
            response: 'Resposta',
            intentionsIa: 'Intenções (Inteligência Artificial)',
            actions: 'Ações',
            edit: 'Editar',
            save: 'Salvar',
            cancel: 'Cancelar',
            deleteQuestions: 'Excluir Perguntas',
            newQuestion: 'Nova pergunta',
            questionTitle: 'Título da pergunta',
            createNewKnowledgeBase: 'Crie uma nova Base de Conhecimento quando você precisar separar o conhecimento para públicos ou contextos distintos, uma vez que a Inteligência é compartilhada com todos os chatbots da sua conta.',
            textEditor: 'Editor de texto',
            addRandomResponse: 'Adicionar resposta randômica',
            responseNotFound: 'Resposta não encontrada ir para posição do fluxo',
            jumpToFlowPosition: 'Saltar para posição do fluxo',
            search: 'Buscar',
            noImagesFound: 'Nenhuma imagem encontrada',
            urlPage: 'URL da página',
            continueToFlowPosition: 'Continuar na posição do fluxo',
            randomizeResponse: 'Randomizar resposta',
            moveUp: 'Mover para cima',
            document: 'Documento',
            text: 'Texto',
            video: 'Vídeo',
            liveChat: 'Chat ao vivo',
            intelligence: 'Inteligência',
            image: 'Imagem',
            carousel: 'Carrossel',
            guideScreen: 'Tela guiada',
            jump: 'Salto',
            moveDown: 'Mover para baixo',
            continueFlow: 'Após a apresentação das respostas acima, o chatbot irá seguir o fluxo conforme o sequenciamento definido.',
            intentions: 'Intenções',
            registerIntentions: 'Cadastre as intenções considerando as principais palavras que poderão acionar a resposta que está sendo cadastrada. Atribua pesos maiores nas palavras que necessitam evitar desambiguação.',
            newIntention: 'Digite uma nova intenção aqui e tecle "Enter"',
            intention: 'Intenção',
            weight: 'Peso',
            minWeight: 'Peso mínimo',
            optional: 'Opcional',
            optionalDescription: 'Utilize caso queira definir o mínimo de peso a ser somado pelas intenções para exibir a resposta.',
            addKnowledgeBase: 'Adicionar Base de Conhecimento',
            title: 'Título',
            excludeQuestion: 'Excluir pergunta',
            youSureExclude: 'Tem certeza que deseja excluir esta pergunta?',
            justCopy: 'Para importar perguntas, basta copiar',
            thisModel: 'este modelo',
            standard: 'padrão',
            exportToCsv: 'e exporta-lo em CSV com as suas perguntas que deseja cadastrar.',
            chooseFileAndImport: 'Após isso, clique em Escolher arquivo logo abaixo para importar.',
            none: 'Nenhuma',
            question: 'Pergunta',
            all: 'Todas',
            messageErrorImportList: 'Erro ao importar lista do banco',
            youAlreadyHaveBase: 'Você já tem uma base com este título.',
            requiredTitle: 'O título não pode ficar em branco.',
            duplicateIntention: 'Já existe uma intenção igual, dê mais peso a mesma.',
            mustHaveMoreThanOneLetter: 'A intenção precisa ter mais de 1 letra.',
            cannotHaveMoreThanTwoWords: 'A intenção não pode ter mais de 2 palavras.',
            questionSave: 'Pergunta salva',
            messageErrorNewQuestion: 'Erro ao salvar nova pergunta',
            allFieldsRequired: 'Todos os campos precisam ser preenchidos',
            questionSuccessfullyDeleted: 'Pergunta excluída com sucesso.',
            messageErrorExcludeQuestion: 'Erro ao excluir pergunta.',
            messageErrorTestIntelligence: 'Erro ao testar inteligência',
            messageErrorFilter: 'Erro ao filtrar inteligência',
            knowledgeBaseExcluded: 'Base de conhecimento excluída.',
            itWasNotPossibleExclude: 'Não foi possível excluir esta base de conhecimento.'
          }
        },
        library: {
          library: {
            limitExceeded: 'Limite de 200 MB excedido',
            addFile: 'Adicionar mídia',
            libraryDescription: 'Aqui, na biblioteca de mídias, você pode adicionar mídias no chat ao vivo e nos carrosseis fluxo.',
            sizeLimitIs: 'Limite de tamanho é',
            video: 'Vídeo',
            videos: 'Vídeos',
            addMedia: 'Adicionar mídia',
            photos: 'Fotos',
            search: 'Buscar',
            list: 'Lista',
            gallery: 'Galeria',
            view: 'Visualizar',
            name: 'Nome',
            sent: 'Enviado',
            actions: 'Ações',
            of: 'de',
            documents: 'Documentos',
            document: 'Documento',
            exclude: 'Excluir',
            newFile: 'Novo arquivo',
            typeFile: 'Tipo de arquivo',
            image: 'Imagem',
            title: 'Título',
            description: 'Descrição',
            cancel: 'Cancelar',
            save: 'Salvar',
            areYouSure: 'Você tem certeza que deseja excluir o arquivo?',
            clickExclude: 'Ao clicar em "Excluir", o arquivo não poderá mais ser recuperado.',
            date: 'Data',
            size: 'Tamanho',
            library: 'Biblioteca',
            requiredTitle: 'O campo título precisa ser preenchido',
          }
        },
        live: {
          live2: {
            transferTooltip: 'Selecione um atendente ou departamento para transferir a conversa',
            userLeaveChat: 'O usuário abandonou o chat',
            userStayOnManualQueue: 'O usuário está em fila manual',
            userStayOnAutoQueue: 'O usuário está em fila automática',
            userStayWaiting: 'O usuário está em espera',
            chatIsFinished: 'A conversa está finalizada',
            chatWaitHsm: 'A conversa está em pausa e esperando interação do usuário',
            errorOnTransferRoom: 'Identificamos um erro ao transferir esta conversa. Neste caso, por gentileza, tire um print desta tela e envie para nosso suporte (suporte@globalbot.com.br). Favor tentar repetir a transferência novamente.',
            titleErrorOnLive: 'Não foi possível transferir a conversa',
            titleRuleOnLive: 'Não foi possível realizar esta ação',
            ruleTransferRoomUnauthorizedUser: 'Você não possui autorização para transferir esta sala',
            ruleTransferRoomInvalidStatus: 'Não é possível transferir esta sala pois o status dela é inválido, caso persista peça a um gerente para realizar esta ação',
            liveChatUpperCase: 'Chat ao Vivo',
            inbox: 'Caixa de entrada do atendente',
            waiting: 'Fila do atendente',
            newConversation: 'Nova conversa',
            filter: 'Filtro',
            attendants: 'Atendentes',
            settings: 'Configurações',
            filterByAttendant: 'Filtro de atendente',
            searchAttendant: 'Buscar atendente',
            attendantNoDepartments: 'Sem departamentos',
            noSearchResults: 'Nenhum resultado encontrado',
            searchCustomerName: 'Buscar cliente',
            all: 'Todos',
            filterByDepartment: 'Filtro de departamento',
            internalToUpperCase: 'INTERNO',
            finishedToUpperCase: 'FINALIZADO',
            inQueueToUpperCase: 'EM FILA',
            waitingToUpperCase: 'AGUARDANDO',
            newToUpperCase: 'NOVO',
            transferToUpperCase: 'TRANSFERIDO',
            yesterday: 'Ontem',
            finishAttendance: 'Finalizar Atendimento(s)',
            finishAndArchiveAttendance: 'Finalizar e Arquivar',
            processingAction: 'Processando... Por favor, aguarde finalizar.',
            finishSuccess: 'Atendimento(s) finalizado(s) com sucesso',
            noAttendance: 'Nenhum atendimento no momento.',
            important: 'Importante',
            completionMessage: 'Escolha uma das opções, considerando que "Finalizar" você finaliza e mas ainda vê a sala de conversa nesta tela, enquanto "Finalizar e Arquivar" a conversa é finalizada e arquivada. Você poderá consultar depois no Menu Conversas.',
            triggerAgain: 'A próxima interação do mesmo irá acionar o chatbot novamente, reabrindo um novo atendimento.',
            areYouSureFinish: 'Você tem certeza que deseja finalizar?',
            cancel: 'Cancelar',
            finish: 'Apenas Finalizar',
            archiveAttendance: 'Arquivar Atendimento(s)',
            archiveSuccess: 'Atendimento(s) arquivado(s) com sucesso',
            archiveSuccessOther: 'Atendimento(s) arquivado(s) por outro atendente',
            futureConversation: 'Ao arquivar os atendimentos, as conversas ativas serão automaticamente finalizadas e encerradas. A próxima interação do(s) usuários(s) irá acionar o chatbot novamente, reabrindo um novo atendimento. Você poderá consultar as conversas no futuro, no Menu Conversas. Você tem certeza que deseja arquivar?',
            areYouSureArchive: 'Você tem certeza que deseja arquivar?',
            archive: 'Arquivar',
            transferAttendance: 'Transferir Atendimento(s)',
            transferSuccess: 'Atendimento(s) transferido(s) com sucesso',
            transferDescription: 'Transfira para outro atendente (ele receberá os atendimentos) ou para um departamento (os atendimentos serão distribuídos de acordo com as configurações do departamento de destino). *Conversas internas não são transferíveis.',
            areYouSureTransfer: 'Você tem certeza que deseja transferir?',
            byAttendant: 'para atendente',
            byDepartment: 'para departamento',
            transfer: 'Transferir',
            withCustomer: 'com Cliente',
            viaWhatsapp: '(via WhatsApp)',
            startConversationWithCustomer: 'Inicie uma conversa com um cliente',
            sendingMessage: 'enviando uma mensagem via WhatsApp.',
            select: 'Selecionar',
            withAttendant: 'com Atendente',
            viaGlobalbot: '(via Globalbot)',
            startConversationWithSomeone: 'Inicie uma conversa com alguém do',
            teamSending: 'seu time de trabalho enviando uma',
            messageThroughTheGlobalbot: 'mensagem pela plataforma Globalbot.',
            newAttendance: 'Novo atendimento',
            waitingForYou: 'está aguardando você!',
            see: 'Ver',
            close: 'Fechar',
            waitingAttendant: 'está aguardando algum atendente.',
            take: 'Assumir',
            newTransfer: 'Nova transferência',
            transferredAndWaitingForYou: 'foi transferido e está aguardando você!',
            transferredDepartmentAndWaitingForYou: 'foi transferido para seu departamento está aguardando algum atendente.',
            anotherAttendant: 'Outro atendente já assumiu este atendimento.',
            pinConversation: 'Fixar conversa no topo.',
            couldNotFinish: 'Não foi possível finalizar',
            couldNotDescription: 'conversas, pois elas ainda não foram assumidas por nenhum atendente. Primeiro será preciso assumir estas conversas.',
            couldNotArchive: 'Não foi possível arquivar',
            finishRoomIdColumn: 'ID da sala',
            finishRoomReasonCodeColumn: 'Motivo'
          },
          room: {
            transferAttendance: 'Transferir atendimento',
            finishAttendance: 'Finalizar atendimento',
            noAttendance: 'Nenhum atendimento no momento.',
            archive: 'Arquivar',
            group: 'grupo',
            attendance: 'atendimento',
            theaterMode: 'Modo teatro',
            defaultView: 'Visualização padrão',
            noOneToAnswer: 'Ninguém para atender no momento. O que acha de uma xícara de café?',
            chooseOneToAnswer: 'Selecione um atendimento e vamos lá!',
            loadMoreMessages: 'Carregar mais mensagens',
            isTyping: 'O usuário ainda está digitando!',
            conversation: 'Conversa',
            intelligence: 'Inteligência',
            navigation: 'Navegação',
            data: 'Dados',
            abandonedTheChat: 'O usuário abandonou o chat',
            createdIn: 'Criado em',
            attendants: 'Atendentes',
            exit: 'Sair',
            quickResponse: 'Resposta rápida',
            internalMessage: 'Mensagem interna',
            send: 'Enviar',
            takeAttendance: 'ASSUMIR ATENDIMENTO',
            important: 'Importante',
            sendTemplateHsm: 'Para falar com o usuário, envie um Template de Mensagem (HSM)',
            onlyAttendants: 'Apenas atendentes desta conversa podem enviar mensagens.',
            automaticArchiving: [
              { label: 'Após 1 hora a conversa será arquivada automaticamente.', value: 1 },
              { label: 'Após 6 horas a conversa será arquivada automaticamente.', value: 6 },
              { label: 'Após 12 horas a conversa será arquivada automaticamente.', value: 12 },
              { label: 'Após1 dia a conversa será arquivada automaticamente.', value: 24 },
              { label: 'Após 2 dias a conversa será arquivada automaticamente.', value: 48 },
              { label: 'Após 3 dia a conversa será arquivada automaticamente.', value: 72 },
              { label: 'Após 4 dias a conversa será arquivada automaticamente.', value: 96 },
              { label: 'Após 5 dias a conversa será arquivada automaticamente.', value: 120 },
            ],
            preview: 'Pré-visualizar',
            addLegend: 'Adicionar legenda',
            cancel: 'Cancelar',
            search: 'Procurar',
            notFound: 'Nenhum emoji encontrado',
            found: 'Encontrados',
            recent: 'Usados frequentemente',
            people: 'Emojis & Pessoas',
            nature: 'Animais & Natureza',
            foods: 'Comida & Bebida',
            activity: 'Atividade',
            places: 'Viagens & Locais',
            objects: 'Objetos',
            symbols: 'Símbolos',
            flags: 'Bandeiras',
            others: 'Outros',
            fullFunctioning: 'Para o pleno funcionamento do chat ao vivo é necesário permitir o acesso para a área de transferência.',
            anotherAttendant: 'Outro atendente já assumiu este atendimento.',
            copilot: 'Copiloto',
            copilotDescription: 'O Copiloto Assistente de Escrita sugere uma nova escrita com um tom profissional e corrige ortografia.',
            copilotCardDescription: 'Selecione a Inteligência Artificial para tirar dúvidas e auxíliar nas respostas.',
            copilotGenai: 'Inteligência Artificial Generativa (modelo GPT). Você terá a Base de Conhecimento Geral (conhecimento do mundo) e pode também cadastrar Bases de Conhecimento específicas com conteúdo da sua empresa no Módulo Inteligência.',
            copilotConventional: 'Inteligência Artificial Convencional (respostas baseadas em conteúdo inserido manualmente em Bases de Conhecimento no Módulo Inteligência)',
            copilotCardCredits: 'Cada consulta do Copiloto na Inteligência Artificial Generativa consome 1 crédito. Sua conta possui 100 créditos gratuitos mensais.',
            copilotCardTooltip: 'O Copiloto ajuda você a tirar dúvidas suas e de seus clientes usando Inteligência Artificial (Generativa ou Convencional). Experimente!',
            assistantCopilotButtonDescription: 'Experimente o novo Assistente de Escrita.',
            copilotCopyMessage: 'Copiar Mensagem',
            copilotReplyMessage: 'Responder Direto',
            copilotCredtisDescription: 'Cada consulta do Copiloto na Inteligência Artificial Generativa consome 1 crédito. Sua conta possui 100 créditos gratuitos mensais.',
            noCredits: 'Créditos acabaram.',
            finishingCredits: 'Créditos acabando.',
            requestCredits: 'Solicitar créditos.',
            messageCopied: 'Mensagem copiada!',
            replyMessage: 'Responder nesta mensagem'
          }
        },
        login: {
          signin: {
            selectSegment: 'Selecione um segmento para prosseguir.',
            accountAlreadyExists: 'Já existe uma conta para este e-mail.'
          },
          forgot: {
            enterYourEmail: 'Informe seu email para enviarmos uma senha provisória',
            buttonRecover: 'Recuperar minha senha',
            goBack: 'Voltar',
            emptyEmail: 'Você precisa preencher o email',
            email: 'Email',
            pleaseEmptyEmail: 'Por favor preencha seu email',
            passwordSent: 'Sua nova senha foi enviada para seu email.',
            contact: 'Oops, por favor entre em contato com o suporte da Globalbot. (suporte@globalbot.com.br)',
            iForgotMyPassword: 'Esqueci minha senha'
          },
          login: {
            selectAccount: 'Selecione a conta desejada para acessar',
            cancel: 'Cancelar',
            forgotPassword: 'Esqueci minha senha',
            verificationCode: 'Código de verificação',
            enter: 'Entrar',
            validate: 'Validar',
            emptyEmail: 'Você precisa preencher o email',
            labelEmail: 'Email',
            fillAllData: 'Por favor preencha todos os campos',
            emptyPassword: 'Você precisa preencher a senha',
            labelPassword: 'Senha',
            userInactive: 'Este usuário está inativo, entre em contato com seu gerente.',
            outOfYourJourney: 'Você está fora da sua jornada de trabalho, entre em contato com seu gerente.',
            incorrectUsernameOrPassword: 'Usuário ou senha incorreto.',
            doubleFactor: 'Esta conta está protegida com autenticação de duplo fator, favor digitar o código de seis dígitos enviado a seu celular.',
            doubleFactorNeedNumber: 'Esta conta está protegida com autenticação de duplo fator, e seu usuário não tem um número de celular cadastrado, favor entrar em contato com seu gerente.',
            unexpectedError: 'Erro inesperado.',
            accountNotCorrect: 'Sua conta não parece correta, por favor entre em contato com a Globalbot',
            notifiedHere: 'Agora sempre que algo acontecer você será notificado por aqui.',
            notificationActivated: 'Notificação ativada',
            rememberMyPassword: 'Mantenha me conectado'
          }
        },
        notification: {
          control: {
            addNotification: 'Adicionar notificação',
            notificationDescription: 'Aqui, na central de notificações, você pode adicionar notificações.',
            dateAndTime: 'Data e Hora',
            type: 'Tipo',
            title: 'Título',
            actions: 'Ações',
            user: 'Usuário',
            tag: 'Tag',
            department: 'Departamento',
            role: 'Cargo',
            account: 'Conta',
            group: 'Grupo',
            all: 'Todos',
            edit: 'Editar',
            linkUsers: 'Vincular usuários',
            exclude: 'Excluir',
            recordsPerPage: 'Registros por página',
            save: 'Salvar',
            cancel: 'Cancelar',
            newNotification: 'Nova Notificação',
            showAvatar: 'Mostrar remetente',
            customizableLabel: 'Rótulo customizável',
            label: 'Rótulo',
            message: 'Mensagem',
            notificationType: 'Tipo de notificação',
            attachments: 'Anexos',
            loadImage: 'Carregar imagem',
            notificationControl: 'Controle de Notificações',
            errorUpload: 'Erro ao processar upload.',
            notificationSent: 'Notificação Enviada',
            errorSent: 'Erro ao enviar notificação'
          }
        },
        people: {
          people: {
            people: 'Pessoas',
            name: 'Nome',
            anonymous: 'Anônimo'
          },
          timeline: {
            people: 'Pessoa',
            fullName: 'Nome completo',
            name: 'Nome',
            nickname: 'Apelido',
            occupation: 'Ocupação',
            cpf: 'CPF',
            anonymous: 'Anônimo',
            company: 'Empresa',
            cnpj: 'CNPJ',
            country: 'País',
            city: 'Cidade',
            state: 'Estado',
            district: 'Bairro',
            conversationStarted: 'Conversa iniciada',
            of: 'de',
            at: 'as',
            hoursAnd: 'horas e',
            minutes: 'minutos'
          }
        },
        profile: {
          profile: {
            profile: 'Perfil',
            changePhoto: 'Alterar foto',
            hello: 'Olá',
            personalInformation: 'Informações Pessoais',
            name: 'Nome',
            email: 'Email',
            role: 'Cargo',
            phone: 'Celular',
            security: 'Segurança',
            newPassword: 'Nova senha',
            confirmNewPassword: 'Confirmação de nova senha',
            connectedDevices: 'Dispositivos Conectados',
            deleteDevice: 'Excluir dispositivo',
            save: 'Salvar',
            administrator: 'Administrador',
            manager: 'Gerente',
            attendant: 'Atendente',
            primary: 'Primário',
            passwordIsNotIdentical: 'Oops, sua senha não é idêntica, favor revisar.',
            informationSaved: 'Informações salvas!',
            errorSavingInformation: 'Oops, algum erro aconteceu ao salvar as informações.',
          }
        },
        realTime: {
          realTime: {
            preferences: 'Preferências',
            realTime: 'Tempo real',
            browsing: 'Navegando',
            withChatbots: 'Com chatbots',
            withAttendants: 'Com atendentes',
            alreadyTalked: 'Já conversou',
            attendedBy: 'Atendido por',
            currentPageContains: 'Página atual contém',
            columns: 'Colunas',
            channel: 'Canal',
            dateAndTime: 'Data/Hora',
            visitor: 'Visitante',
            chatbot: 'Chatbot',
            location: 'Localização',
            pages: 'Págs',
            currentPage: 'Página atual',
            time: 'Tempo',
            conversation: 'Conversa',
            actions: 'Ações',
            unknown: 'Desconhecido',
            seeOnMap: 'Ver no mapa',
            seeNavigation: 'Ver navegação',
            inAttendance: 'Em atendimento',
            waitingForAttendant: 'Aguardando atendente',
            finishAttendance: 'Atendimento finalizado',
            noAttendance: 'Nenhum atendimento no momento.',
            activeVisitor: 'Visitante ativo',
            inactiveVisitor: 'Visitante inativo',
            startedAt: 'Iniciado as',
            allConversations: 'Todas conversas',
            of: 'de',
            initialMessage: 'Mensagem inicial',
            message: 'Mensagem',
            cancel: 'Cancelar',
            intervene: 'Intervir',
            navigation: 'Navegação',
            openPage: 'Abrir página',
            close: 'Fechar',
            openConversation: 'Abrir conversa',
            all: 'Todos',
            chatbots: 'Chatbots',
            path: 'Caminho',
            conversations: 'Conversas'
          }
        },
        settings: {
          fields: {
            fields: 'Campos',
            sections: 'Seções',
            imports: 'Importações',
            sectionDescription: 'Crie uma seção para agrupar os campos personalizados e facilitar a visualização.',
            fieldsDescription: 'Crie campos personalizados para registrar dados de pessoas e empresas.',
            importsDescription: 'Realize importação de registros em lote e confira importações já realizadas.',
            createSection: 'Criar seção',
            createField: 'Criar campo',
            createImport: 'Importar',
            name: 'Nome',
            description: 'Descrição',
            actions: 'Ações',
            edit: 'Editar',
            type: 'Tipo',
            section: 'Seção',
            edit: 'Editar',
            processing: 'Processando',
            importError: 'Erro na importação',
            fail: 'Falha em',
            failImport: ' importações por compos obrigatórios não estarem preenchidos',
            exclude: 'Excluir',
            excludeSection: 'Excluir Seção',
            excludeField: 'Excluir Campo Personalizado',
            reallyDeleteSection: 'Você realmente deseja excluir esta seção?',
            reallyDeleteField: 'Você realmente deseja excluir este campo personalizado?',
            sectionExcluded: 'Seção excluída.',
            sectionInUse: 'Existe campos utilizando esta Seção',
            fieldExcluded: 'Campo excluído.',
            fieldInUse: 'Não foi possível excluir, este campo já foi preenchido em algum contato.',
            imported: 'Importado',
          },
          chatbot: {
            behavior: {
              chatbots: 'Chatbots',
              firstTime: 'Primeiro tempo',
              secondTime: 'Segundo tempo',
              preferences: 'Preferências',
              behavior: 'Comportamento',
              firstInteraction: 'Primeira interação *',
              secondInteraction: 'Segunda interação',
              desiredAction: {
                title: 'Ação desejada',
                actionTranshipment: 'Transbordar',
                actionEnd: 'Finalizar',
                messageTranshipment: 'Mensagem antes do transbordo',
                departmentTranshipment: 'Transferir o departamento',
                tag: 'Marcar com a Tag'
              },
              messageTranshipment: 'A conversa será transferida para um atendente.',
              messageEnd: 'Por falta de interação a conversa foi finalizada.',
              timers: 'Temporizadores',
              balloonAppearanceTime: 'Tempo de aparecimento do balão',
              chatbotShutdownTime: 'Tempo de encerramento do chatbot',
              interactionTime: 'Tempo de interação (...)',
              threeMinutes: '3 minutos',
              oneMinute: '1 minuto',
              fiveMinutes: '5 minutos',
              teenMinutes: '10 minutos',
              fifteenMinutes: '15 minutos',
              thirtyMinutes: '30 minutos',
              oneHour: '1 hora',
              twoHours: '2 horas',
              threeHours: '3 horas',
              fiveHours: '5 horas',
              teenHours: '10 horas',
              twelveHours: '12 horas',
              fifteenHours: '15 horas',
              twentyHours: '20 horas',
              twentyFourHours: '24 horas',
              whatsappCacheTime: 'Tempo de cache do WhatsApp',
              facebookCacheTime: 'Tempo de cache do Facebook',
              webchatCacheTime: 'Tempo de cache do Webchat',
              controllers: 'Controladores',
              sounds: 'Sons',
              soundType: 'Tipo de som',
              fullScreenMode: 'Modo tela-cheia',
              disableControls: 'Desabilitar controles',
              disableHeader: 'Desabilitar cabeçalho',
              automaticOpening: 'Abertura automática',
              notReopen: 'Não reabrir balão após atendimento',
              satisfactionSurvey: 'Pesquisa de satisfação',
              protocolAttendance: 'Protocolo de atendimento',
              includeInternalMessages: 'Incluir mensagens internas',
              optionFinishOrMin: 'Opção de finalizar ou minimizar.',
              imageUploader: 'Uploader de imagem (cliente)',
              fileUploader: 'Uploader de arquivo (cliente)',
              allConversations: 'Todas as conversas',
              conversationsNotTransshipment: 'Conversas do atendente e sem transbordo',
              onlyAttendantConversations: 'Apenas conversas do atendente',
              viewingConversationsForAttendants: 'Visualização de conversas para atendentes',
              persistence: 'Persistência do chatbot',
              activated: 'Ativado',
              disabled: 'Desativado',
              firstMessage: 'Primeira mensagem',
              firstMessageTime: 'Tempo da primeira mensagem',
              secondMessage: 'Segunda mensagem',
              secondMessageTime: 'Tempo da segunda mensagem',
              thirdMessage: 'Terceira mensagem',
              thirdMessageTime: 'Tempo da terceira mensagem',
              save: 'Salvar',
              areYouSure: 'Você tem certeza que deseja salvar as alterações?',
              youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
              previousContent: 'conteúdo anterior não pode ser restaurado.',
              cancel: 'Cancelar',
              interface: 'Interface',
              interfaceSettings: 'Configurações de interface',
              behaviorSettings: 'Configurações do chatbot',
              installation: 'Instalação',
              integrations: 'Integrações',
              liveChat: 'Chat ao vivo',
              // areYouStillAround: 'Ainda está por ai?',
              // ifNotResponse: 'Caso você não resposta eu vou ter que finalizar o atendimento.',
              // ifNeedHelp: 'Tudo bem, se você precisar de ajuda novamente me avise!',
              // closeMessage: 'O atendimento foi encerrado pelo atendente, agradecemos seu contato e caso tenha mais alguma dúvida é só me chamar novamente.',
              preferenceSaved: 'Preferência salva com sucesso'
            },
            installation: {
              whatsapp: {
                installation: 'Instalação Whatsapp',
                configuredWithChatbot: 'Seu WhatsApp está configurado com seu Chatbot.',
                notConfiguredWithChatbot: 'Seu WhatsApp não está configurado com seu Chatbot.',
                versionHint: 'Versão do Whatsapp a ser utilizado',
                version: 'Versão',
                instanceHint: 'ID da Instância fornecido pelo seu Gerente de Projetos',
                instance: 'Instância',
                tokenHint: 'Token da Instância fornecido pelo seu Gerente de Projetos',
                token: 'Token',
                mobileNumberHint: 'Número do celular a ser utilizado',
                mobileNumber: 'Número do celular',
                customerIdentifierHint: 'Identificador do cliente fornecido pela Globalbot',
                customerIdentifier: 'Identificador do cliente',
                instructionsMobileNumbers: 'Instruções para números móveis',
                notChangeConfig: 'Não é possível alterar as configurações enquanto houver conversas em andamento',
                stepOneMobileNumbers: 'Habilite o chip contendo o número que você deseja conectar o chatbot',
                stepTwoMobileNumbers: 'Você irá receber neste número um SMS contendo um código numérico',
                stepThreeMobileNumbers: 'Informe o código recebido para a equipe da Globalbot',
                stepFourMobileNumbers: 'Digite a instância e token fornecidos pela Globalbot nos campos abaixo',
                instructionsFixedNumbers: 'Instruções para números fixos',
                stepOneFixedNumbers: 'Você irá receber no seu número uma ligação contendo um código numérico',
                stepTwoFixedNumbers: 'Informe o código recebido para a equipe da Globalbot',
                stepThreeFixedNumbers: 'Digite a instância e token fornecidos pela Globalbot nos campos abaixo',
                areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
                youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
                previousContent: 'conteúdo anterior não pode ser restaurado.',
                cancel: 'Cancelar',
                save: 'Salvar',
                publish: 'Publicar',
                versioningMessage: 'Para acessar as versões anteriores, basta acessar as configurações do bot específico ir em versionamento e publicar a versão desejada para entrar em produção.',
                removeConfig: 'Remover configuração',
                wabaLabel: 'Conta do WhatsApp Business (WABA)',
                wabaHint: 'Escolha a conta do WhatsApp Business que contém o número',
                phoneLabel: 'Número de WhatsApp',
                phoneHint: 'Escolha o número que este chatbot vai usar',
                reconnectMetaAccount: 'Reconectar conta da Meta',
                saveRejected: 'Não foi possível salvar a configuração do WhatsApp. Tente novamente ou fale com a equipe da Globalbot.',
                metaTokenExchangeFailed: 'A Meta não emitiu um token de longa duração para este número. Reconecte a conta da Meta e salve novamente.',
                metaConnected: 'Número conectado à Meta com sucesso. Clique em salvar para concluir.',
                metaSignupCancelled: 'Conexão com a Meta cancelada antes de terminar.',
                metaSignupNoPhone: 'O cadastro na Meta terminou sem um número de WhatsApp. Conclua a escolha do número e tente de novo.',
                metaSignupFailed: 'Não foi possível concluir a conexão com a Meta. Tente novamente ou fale com a equipe da Globalbot.',
                metaWebhookNotSubscribed: 'O número foi salvo, mas a Meta não confirmou a inscrição do webhook. Reconecte a conta para que as mensagens cheguem.',
                pinOptionLabel: 'Meu número já usa verificação em duas etapas',
                pinOptionCaption: 'Informe o PIN atual do número. Sem PIN, a Globalbot gera um e mostra uma única vez.',
                pinLabel: 'PIN de verificação em duas etapas',
                pinHint: '6 dígitos. Fica guardado de forma cifrada e só é usado para operar o número.',
                pinInvalid: 'O PIN precisa ter exatamente 6 dígitos.',
                pinSubmit: 'Registrar com este PIN',
                pinPromptTitle: 'Informe o PIN do número',
                pinPromptDescription: 'A Meta exige o PIN de verificação em duas etapas deste número para registrá-lo. Se você não lembra, desative a verificação em duas etapas no WhatsApp Manager e tente de novo sem PIN.',
                pinGeneratedTitle: 'Guarde o PIN do seu número',
                pinGeneratedDescription: 'Este é o PIN de verificação em duas etapas definido para o número. Ele não será mostrado de novo e será pedido para trocar o PIN ou remover o número da plataforma.',
                pinCopy: 'Copiar PIN',
                pinCopied: 'PIN copiado',
                pinAcknowledge: 'Copiei e guardei o PIN em um lugar seguro',
                pinClose: 'Concluir',
                registerNumber: 'Registrar número',
                checkRegistration: 'Verificar status',
                registrationRegistered: 'Número registrado na Cloud API. Pronto para enviar e receber mensagens.',
                registrationPending: 'Número conectado, mas ainda não registrado na Cloud API. Registre até {deadline}, senão será preciso refazer a conexão.',
                registrationExpired: 'O prazo de 14 dias para registrar o número terminou. Reconecte a conta da Meta para começar de novo.',
                registrationBlockedUntil: 'Novas tentativas liberadas em {date}.',
                registrationInProgress: 'Já existe um registro em andamento para este número. Aguarde alguns segundos.',
                registrationFailed: 'Não foi possível registrar o número. Tente novamente ou fale com a equipe da Globalbot.',
                registrationErrorPinMismatch: 'A Meta recusou o PIN. Confira o PIN de verificação em duas etapas do número ou desative a verificação no WhatsApp Manager e tente de novo.',
                registrationErrorPinLocked: 'Muitas tentativas de PIN. Aguarde antes de tentar de novo.',
                registrationErrorRateLimited: 'A Meta limitou os registros deste número por 72 horas.',
                registrationErrorLocalRateLimit: 'Limite de tentativas atingido por enquanto. Aguarde antes de tentar de novo.',
                registrationErrorTosNotAccepted: 'O registro está bloqueado por uma pendência da Globalbot junto à Meta. Nossa equipe já foi avisada; tente mais tarde.',
                registrationErrorReverificationNeeded: 'A Meta pede uma nova verificação deste número. Refaça a verificação no WhatsApp Manager e tente de novo.',
                registrationErrorGraphUnavailable: 'A Meta não respondeu. Tente novamente em alguns minutos.',
                registrationErrorUnknown: 'A Meta recusou o registro. Tente novamente ou fale com a equipe da Globalbot.',
                bsuidSection: 'Identificação por BSUID (Meta)',
                bsuidSectionHint: 'O BSUID é o identificador que a Meta atribui ao contato. Ele permite atender quem chega sem número de telefone (QR Code, link wa.me, anúncios Click-to-WhatsApp).',
                bsuidEnabled: 'Habilitado',
                bsuidDisabled: 'Desabilitado',
                sendByBsuid: 'Enviar por BSUID',
                sendByBsuidHint: 'Permite disparar templates para contatos sem telefone, usando o BSUID como destinatário.',
                bsuidEffects: 'Ao habilitar: os envios de mensagens e templates deste bot passam a usar o BSUID como destinatário sempre que o contato tiver um (contatos só com telefone continuam recebendo normalmente); as telas de Campanhas ganham as opções de BSUID (coluna "bsuid" na importação de destinatários, envio de teste por BSUID e busca por BSUID nas estatísticas); e a exportação de conversas da conta ganha a coluna BSUID.',
                sendByBsuidNotSupported: 'Indisponível nesta versão: as APIs da Meta e da Cogna só aceitam telefone como destinatário. Disponível no Gupshup e no Globalbot WhatsApp.',
                reallyRemoveConfig: 'Você realmente quer remover a configuração?',
                moreThanOneBotWithWhatsAppInstance: 'Existe(m) outro(s) bot(s) configurados com o mesmo instaceId do WhatsApp',
                errorSave: 'Erro inesperado ao salvar ',
                attention: 'ATENÇÃO:',
                thereAreConversationsOpenOne: 'Existem conversas abertas na instância',
                thereAreConversationsOpenTwo: ', ao alterar todas essas conversas serão finalizadas. Deseja prosseguir?',
                proceed: 'Prosseguir',
                clearError: 'Falha ao finalizar conversas.',
                qrLeaveWarning: 'Este bot está conectado pelo WhatsApp QR Code. Ao salvar, a sessão do WhatsApp será encerrada e, para voltar a usar o QR Code, será necessário ler um novo código no celular.',
                qrLeaveError: 'Não foi possível encerrar a sessão do WhatsApp QR Code. Nada foi alterado; tente novamente.',
                qrMasterOnly: 'No momento, o WhatsApp QR Code só pode ser habilitado por usuários Master.',
                instructionsQr: 'Como conectar pelo QR Code',
                stepOneQr: 'Clique em Conectar para gerar o QR Code.',
                stepTwoQr: 'No celular do número que será usado pelo bot, abra o WhatsApp e acesse Configurações > Dispositivos conectados > Conectar dispositivo.',
                stepThreeQr: 'Aponte a câmera para o QR Code exibido. Ele é renovado automaticamente enquanto aguarda a leitura.',
                stepFourQr: 'Aguarde o status Conectado. Mantenha o celular com internet e o WhatsApp instalado para a sessão continuar ativa.',
                qrConnection: {
                  title: 'Conexão via QR Code',
                  description: 'Conecte o número do bot lendo o QR Code com o WhatsApp do celular. Não é necessário informar token nem identificador.',
                  providerSwitchHint: 'Ao conectar, este bot passa a usar o WhatsApp QR Code como provedor de WhatsApp.',
                  loading: 'Carregando o status da conexão...',
                  loadError: 'Não foi possível carregar o status da conexão.',
                  retry: 'Tentar novamente',
                  permissionDenied: 'Somente administradores da conta podem gerenciar a conexão do WhatsApp QR Code. Peça a um administrador para conectar ou desconectar o número.',
                  stateLabel: 'Status da conexão:',
                  notCreated: 'Nenhuma conexão criada para este bot ainda. Clique em Conectar para gerar o QR Code.',
                  phone: 'Número conectado',
                  profileName: 'Perfil',
                  qrAlt: 'QR Code para conectar o WhatsApp deste bot. Leia com o aplicativo WhatsApp do celular.',
                  qrLoading: 'Gerando o QR Code...',
                  qrExpired: 'O QR Code expirou. Um novo código será exibido em instantes.',
                  qrInstructions: 'No WhatsApp do celular, acesse Configurações > Dispositivos conectados > Conectar dispositivo e aponte a câmera para o código.',
                  qrExpiresIn: 'Este código expira em {seconds}s e é renovado automaticamente.',
                  qrRenewHint: 'Este código expira em poucos segundos e é renovado automaticamente.',
                  connect: 'Conectar',
                  reconnect: 'Reconectar',
                  disconnect: 'Desconectar (temporário)',
                  disconnectHint: 'Pausa a conexão mantendo a sessão. Para voltar, clique em Reconectar; não é preciso ler outro QR Code.',
                  logout: 'Sair da sessão',
                  logoutConfirmTitle: 'Sair da sessão do WhatsApp?',
                  logoutConfirmMessage: 'A sessão será encerrada no WhatsApp e o bot deixará de enviar e receber mensagens por este número. Para conectar novamente será necessário ler um novo QR Code no celular.',
                  logoutConfirm: 'Sair da sessão',
                  cancel: 'Cancelar',
                  actionError: 'Não foi possível concluir a ação. Tente novamente.',
                  conflictError: 'A conexão mudou de estado enquanto a ação era processada. Confira o status e tente novamente.',
                  unavailableError: 'O serviço de conexão do WhatsApp está indisponível no momento. Tente novamente em instantes.',
                  botHasActiveProviderError: 'Este bot já tem outro provedor de WhatsApp ativo. Desative o provedor atual antes de conectar por QR Code.',
                  rateLimitedError: 'Muitas tentativas em pouco tempo. Aguarde alguns instantes e tente novamente.',
                  states: {
                    disconnected: 'Desconectado',
                    awaiting_scan: 'Aguardando leitura',
                    connecting: 'Conectando',
                    connected: 'Conectado',
                    error: 'Erro',
                  },
                  reasons: {
                    paused: 'Conexão pausada. A sessão foi mantida; clique em Reconectar para retomar.',
                    logged_out: 'Sessão encerrada no celular. Será necessário ler um novo QR Code.',
                    qr_limit_reached: 'Limite de QR Codes atingido sem leitura. Clique em Reconectar para gerar um novo.',
                    session_rejected: 'O WhatsApp recusou a sessão. Clique em Reconectar e leia um novo QR Code.',
                    provider_error: 'Falha no serviço de conexão do WhatsApp. Tente reconectar em instantes.',
                  },
                },
              },
              webchat: {
                installation: 'Instalação (WebChat e Botão WhatsApp)',
                installationMiniGlobalot: 'Instalação Webchat',
                configuredWithChatbot: 'O script está instalado no seu site.',
                notConfiguredWithChatbot: 'O script não está instalado no seu site.',
                installationScript: 'Script de instalação',
                authorizedDomains: 'Domínios autorizados',
                domainNumber: 'Domínio nº',
                addDomain: 'Adicionar domínio',
                domainInvalid: 'Domínio inválido',
                instructions: 'Instruções para Instalação',
                stepOne: 'Copie o script de instalação ao lado',
                stepTwo: 'Insira o script no código HTML do seu site nas páginas que você quer acionar o chatbot (cole o script imediatamente após o final da tag </BODY>).',
                stepThree: 'Após colar o script nas páginas desejadas, você deve indicar ao lado quais domínios o chatbot foi adicionado.',
                stepFour: 'Você deve indicar abaixo em quais domínios o chatbot poderá ser acionado.',
                externalBoot: 'Inicialização externa',
                youCan: 'Você pode fazer a inicialização externa via código JavaScript.',
                accessElement: 'Acesse o elemento',
                andUse: 'E utilize as funções disponíveis para as inicializações.',
                openBalloon: 'Abrir o balão inicial',
                initialBalloon: 'Balão inicial com posição do fluxo',
                openChat: 'Abrir o chat',
                openChatWithFlowPosition: 'Abrir o chat com posição do fluxo',
                areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
                youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
                previousContent: 'conteúdo anterior não pode ser restaurado.',
                cancel: 'Cancelar',
                save: 'Salvar',
              },
              messenger: {
                installation: 'Instalação Facebook Messenger',
                configuredWithChatbot: 'Seu Facebook está configurado com seu Chatbot.',
                reset: 'Reconfigurar',
                notConfiguredWithChatbot: 'Seu Facebook não está configurado com seu Chatbot.',
                noPagesAvailable: 'Nenhuma página disponível.',
                synchronize: 'Sincronizar',
                almostConfigured: 'Falta pouco, sua página do Facebook está quase configurado com seu Chatbot.',
                yourPage: 'Sua página',
                instructions: 'Instruções',
                connectFacebook: 'Clique no botão Sincronizar',
                followSteps: 'Siga o passo-a-passo para conexão',
                youMustBeAdmin: 'Você deverá ser administrador da FanPage para conceder acesso',
                areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
                youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
                previousContent: 'conteúdo anterior não pode ser restaurado.',
                cancel: 'Cancelar',
                save: 'Salvar',
                disconnect: 'Desconectar',
                reallyDisconnectPage: 'Você realmente quer desconectar esta página?'
              },
              telegram: {
                installation: 'Instalação Telegram',
                configuredWithChatbot: 'Seu Telegram está configurado com seu Chatbot.',
                notConfiguredWithChatbot: 'Seu Telegram não está configurado com seu Chatbot.',
                tokenProvidedBot: 'Token de acesso para a API fornecida pelo Bot Father',
                token: 'Token',
                instructions: 'Instruções',
                talkToThe: 'Converse com o',
                followStep: 'Siga o passo-a-passo para criar o seu bot',
                indicateBelow: 'Indique abaixo o token de acesso para a API',
                areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
                youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
                previousContent: 'conteúdo anterior não pode ser restaurado.',
                cancel: 'Cancelar',
                save: 'Salvar',
                config: 'Instruções de configuração',
                step1: '1 - Vá para Telegram e encontre @BotFather usando a barra de pesquisa.',
                step2: '2 - Escreva /start e o robô fornecerá uma lista dos comandos disponíveis.',
                step3: '3 - Use o comando /newbot e siga as instruções fornecidas para criar um novo robô.',
                step4: '4 - O BotFather enviará uma mensagem de texto quando seu robô for criado. Você receberá um link para seu robô e um token de API.',
                step5: '5 - Copie esse token e digite-o no formulário ao lado.',
                step6: '6 - Agora todas as mensagens enviadas de novos contatos para o seu robô serão exibidas no módulo de conversas.',
                existingIntro: 'Para conectar o robô existente do Telegram, faça o seguinte:',
                existing1: '1 - Escreva o comando /mybots no @BotFather.',
                existing2: '2 - Escolha o robô que você deseja conectar.',
                existing3: '3 - Clique em API Token.',
                existing4: '4 - Copie o token e cole-o no formulário ao lado.'
              },
              instagram: {
                authInProgress: 'OAuth em Progresso',
                waitingForReturn: 'Aguardando retorno do Instagram...',
                alreadyAuthorized: 'Se você já autorizou no Instagram e não voltou automaticamente,',
                clickHereToCheck: 'clique aqui para verificar',
                toolTipDescribeInstallationBot: 'Abre em popup - não sai da aplicação',
                almostConfigured: 'Falta pouco, sua página do Instagram está quase configurado com seu Chatbot.',
                yourPage: 'Sua página',
                installation: 'Instalação Instagram',
                configuredWithChatbot: 'Seu Instagram está configurado com seu Chatbot.',
                reset: 'Reconfigurar',
                notConfiguredWithChatbot: 'Seu Instagram não está configurado com seu Chatbot.',
                motiveConfigure: 'a plataforma Globalbot pode gerenciar mensagens apenas de contas INSTAGRAM BUSINESS. Não é possível conectar e gerenciar mensagens em contas Instagram pessoais.',
                important: 'Importante: ',
                synchronize: 'Sincronizar',
                instructions: 'Instruções',
                stepOne: 'ADICIONAR 1° PASSO',
                stepTwo: 'ADICIONAR 2° PASSO',
                stepThree: 'ADICIONAR 3° PASSO',
                areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
                youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
                previousContent: 'conteúdo anterior não pode ser restaurado.',
                cancel: 'Cancelar',
                save: 'Salvar',
              },
              chatbots: 'Chatbots',
              preferences: 'Preferências',
              installation: 'Instalação',
              interface: 'Interface',
              interfaceSettings: 'Configurações de interface',
              behavior: 'Comportamento',
              chatbotSettings: 'Configurações de chatbot',
              integrations: 'Integrações',
              liveChat: 'Chat ao vivo',
              // areYouStillAround: 'Ainda está por ai?',
              // ifYouNotResponse: 'Caso você não resposta eu vou ter que finalizar o atendimento.',
              // ifYouNeedHelp: 'Tudo bem, se você precisar de ajuda novamente me avise!',
              // closeMessage: 'O atendimento foi encerrado pelo atendente, agradecemos seu contato e caso tenha mais alguma dúvida é só me chamar novamente.',
              youHavePermission: 'Oops, parece que está faltando permissões.',
              consultTheConsole: 'Oops, algum erro aconteceu, consulte o console.',
              preferenceSaved: 'Preferência salva com sucesso'
            },
            integrations: {
              chatbots: 'Chatbots',
              preferences: 'Preferências',
              integrations: 'Integrações',
              reset: 'Reconfigurar',
              toSetUp: 'Configurar',
              eventWebhookLabel: 'Webhook de eventos',
              descriptions: {
                googleAnalytics: 'Esta integração é responsável por fazer uma análise de estatísticas do fluxo.',
                pipeRun: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) no Piperun através dos campos compatíveis.',
                slack: 'Com esta integração a plataforma Globalbot irá realizar o envio do histórico da conversa para um canal específico. Precisa de um webhook configurado para receber o evento e realizar o envio de mensagens.',
                vistaSoft: 'Esta integração é responsável por busca imóveis para aluguel/compra de acordo com as opções selecionadas pelo usuário (numero de quartos, tipo, bairro) e registro de leads.\nCampos chave: telefone e/ou nome e e-mail e "objetivo_contato"/"interesse".',
                rdStation: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) na RD Station Marketing através dos campos compatíveis.\nCampos chave: e-mail.',
                pipeDrive: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) no PipeDrive através dos campos compatíveis. Realiza atribuição de atendente como responsável a partir do endereço de e-mail.',
                rdCrm: 'Com esta integração a plataforma Globalbot irá realizar o envio de negociações para o CRM.\nCampos chaves: e-mail e/ou telefone e nome.',
                ksi: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) na Kurole KSI através dos campos compatíveis.\nCampos chave: e-mail, nome e telefone.',
                cv: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) no Contrutor de Vendas através dos campos compatíveis.\nCampos chave: e-mail, nome e telefone.',
                movidesk: 'Com esta integração a plataforma Globalbot irá realizar a abertura de tickets.\nCampos chave: e-mail.',
                glpi: 'Com esta integração a plataforma Globalbot irá realizar a abertura de tickets.\nCampos chave: nome.',
                jira: 'Com esta integração a plataforma Globalbot irá realizar a criação de tarefas (tasks).\nCampos chave: e-mail.',
                zendesk: 'Com esta integração a plataforma Globalbot irá realizar a abertura de tickets.\nCampos chave: e-mail.',
                midasSoft: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) no MidasSoft.',
                rdStationV2: 'Esta integração é responsável pela busca de informações no RD Stations Marketing (apenas para casos específicos).',
                moskit: 'Com esta integração a plataforma Globalbot será responsável pela criação de negociações.',
                funilVendas: 'Com esta integração a plataforma Globalbot será responsável pela criação de negociações.\nCampos chave: e-mail, nome e telefone.',
                amigo: 'Com esta integração a plataforma Globalbot irá realizar agendamentos de consultas médicas.',
                agendor: 'Com esta integração a plataforma Globalbot será responsável pela criação de negociações e tarefas.\nCampos chave: telefone.',
                emailLead: 'Com esta integração a plataforma Globalbot será responsável pelo envio das trancrições das conversas por e-mail.',
                shopify: 'Esta integração é responsável pelo rastreio de pedidos.\nCampos chave: e-mail.',
                vTiger: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) no vTiger através dos campos compatíveis.\nCampos chave: e-mail, nome e telefone.',
                hubspot: 'Com esta integração a plataforma Globalbot irá registrar (postar) informações de contatos (leads) no Hubspot através dos campos compatíveis.\nCampos chave: e-mail, nome e telefone.',
                eventWebhook: 'Receba no seu sistema, em tempo quase real, os eventos de status das mensagens de WhatsApp (enviada, entregue, lida, falhou). Entrega assinada com HMAC, com reenvio automático em caso de falha.',
              },
              aboutIntegration: 'Sobre a integração',
              native: 'NATIVA',
            },
            interface: {
              chatbots: 'Chatbots',
              preferences: 'Preferências',
              interface: 'Interface WebChat',
              chatWindow: 'Janela do Chat',
              botName: 'Nome do(a) bot',
              attendantName: 'Nome Principal',
              attendantRole: 'Frase Adicional',
              avatarImage: 'Avatar',
              logo: 'Logotipo',
              balloonImage: 'Botão',
              logoImage: 'Logo',
              primaryColor: 'Cor primária',
              chatHeight: 'Altura do chat',
              installationInstructions: 'Instruções de Instalação no Site',
              installationInstructionsDescription: 'Instale o script de acionamento do WebChat no seu site.',
              copyRight: 'Copyright (apenas o master)',
              disabled: 'Desativado',
              activated: 'Ativado',
              startBalloon: 'Batão de início',
              message: 'Mensagem',
              position: 'Posição',
              left: 'Esquerda',
              right: 'Direita',
              textColor: 'Cor do texto',
              backgroundColor: 'Cor do fundo',
              templates: 'Modelos',
              default: 'Padrão',
              amplified: 'Amplificado',
              ticket: 'Ticket',
              noImage: 'Sem imagem',
              noText: 'Sem texto',
              ghost: 'Invisível',
              mobile: 'Móvel',
              save: 'Salvar',
              areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
              youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
              previousContent: 'conteúdo anterior não pode ser restaurado.',
              cancel: 'Cancelar',
              sampleQuestion: 'Exemplo de pergunta',
              answerExample: 'Exemplo de resposta',
              typeYourName: 'Digite seu nome',
              typeYourPhone: 'Digite seu telefone',
              typeYourExample: 'Exemplo de texto',
              virtualAssistant: 'Assistente Virtual',
              preferenceSaved: 'Preferência salva com sucesso'
            },
            whatsapp: {
              settings: 'Configurações',
              chatbotAndNumber: 'Chatbot | Número Whatsapp do Botão',
              needWhatsappConfig: 'É necessário ter um número de Whatsapp configurado no bot para habilitar esta opção!',
              buttonStatus: 'Status do Botão',
              buttonMessage: 'Mensagem do Botão (opcional)',
              buttonPosition: 'Posição do Botão',
              initialMessageWhatsapp: 'Mensagem inicial no Whatsapp (opcional)',
              initialMessageWhatsappDescription: 'Este é o texto que será automaticamente inserido no campo de mensagem do aplicativo WhatsApp.',
              enabled: 'Ativado',
              disabled: 'Desativado',
              rightPosition: 'direita',
              leftPosition: 'esquerda',
              installationInstructions: 'Instruções de Instalação no Site',
              installationInstructionsDescription: 'Instale o script de acionamento do Botão WhatsApp no seu site.',
              traceOrigin: 'Rastrear Origem de Tráfego (Tracking)',
              traceOriginDescription: 'Ao habilitar este recurso, será solicitado ao usuário informar seu número de telefone WhatsApp antes de iniciar a conversa. Com isto, a página que o usuário estava no site poderá ser identificada.',
              requestPhone: 'Solicitar telefone e habilitar a rastreabilidade.',
              logoOrAvatar: 'Avatar',
              visibleName: 'Nome Vísivel (Display Name)',
              resquestPhoneMessage: 'Mensagem para pedir o número do WhatsApp',
              copyright: 'Copyright (apenas o master)'
            },
            master: {
              chatbots: 'Chatbots',
              preferences: 'Preferências',
              master: 'Master',
              locationOfServers: 'Localização dos servidores (somente master)',
              newPln: 'Novo PLN (somente master)',
              realTime: 'Tempo real (somente master)',
              cacheConversation: 'Cache da conversa (somente master)',
              offshoreLastQuestion: 'Offshore last question (somente master)',
              excludeChatbot: 'Excluir chatbot',
              createCliWithoutBackground: 'Criar CLI sem Background',
              save: 'Salvar',
              areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
              youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
              previousContent: 'conteúdo anterior não pode ser restaurado.',
              doYouReallyExclude: 'Quer mesmo excluir o chatbot?',
              cancel: 'Cancelar',
              exclude: 'Excluir',
              interface: 'Interface',
              interfaceSettings: 'Configurações de interface',
              behavior: 'Comportamento',
              chatbotSettings: 'Configurações de chatbot',
              installation: 'Instalação',
              integrations: 'Integrações',
              // areYouStillAround: 'Ainda está por ai?',
              // ifYouNotResponse: 'Caso você não resposta eu vou ter que finalizar o atendimento.',
              // ifYouNeedHelp: 'Tudo bem, se você precisar de ajuda novamente me avise!',
              // closeMessage: 'O atendimento foi encerrado pelo atendente, agradecemos seu contato e caso tenha mais alguma dúvida é só me chamar novamente.',
              preferenceSaved: 'Preferência salva com sucesso'
            },
            messages: {
              chatbots: 'Chatbots',
              preferences: 'Preferências',
              messages: 'Mensagens',
              portuguese: 'Português',
              english: 'Inglês',
              spanish: 'Espanhol',
              faqNotFound: 'FAQ não encontrada',
              treatment: 'Quando o usuário digita bom dia em vez do nome dele.',
              noName: 'Quando o usuário digita: Meu nome é...',
              ask: 'Quando o usuário faz alguma pergunta.',
              special: 'Quando o usuário coloca algum caractere especial',
              justYourName: 'Quando o usuário digita o primeiro palavrão',
              cursed: 'Quando o usuário digita o segundo palavrão e fecha o chatbot.',
              knowledgeName: 'Quando existe uma intenção na inteligência e o usuário colocou ela no nome.',
              limit: 'Quando o usuário digita além do limite permitido.',
              manyItems: 'Quando desambigua uma pergunta',
              faqNoneButton: 'Quando desambiguado, aparece um botão com essa frase',
              connectLive: 'Quando conecta no Chat ao Vivo',
              nameError: 'Quando o usuário erra o nome',
              firstNameError: 'Quando o usuário erra o primeiro nome',
              textError: 'Quando o usuário não digita nada em algum pedido de texto',
              emailError: 'Quando o usuário erra o e-mail',
              moneyError: 'Quando o usuário erra o pedido de inserir um valor monetário',
              phoneError: 'Quando o usuário erra o Telefone',
              cpfError: 'Quando o usuário erra o CPF',
              cnpjError: 'Quando o usuário erra o CNPJ',
              faqError: 'Quando o usuário não digita nada em uma FAQ',
              save: 'Salvar',
              areYouSureSave: 'Você tem certeza que deseja salvar as alterações?',
              youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
              previousContent: 'conteúdo anterior não pode ser restaurado.',
              cancel: 'Cancelar',
              interface: 'Interface',
              interfaceSettings: 'Configurações de interface',
              behavior: 'Comportamento',
              chatbotSettings: 'Configurações de chatbot',
              installation: 'Instalação',
              integrations: 'Integrações',
              // areYouStillAround: 'Ainda está por ai?',
              // ifYouNotResponse: 'Caso você não resposta eu vou ter que finalizar o atendimento.',
              // ifYouNeedHelp: 'Tudo bem, se você precisar de ajuda novamente me avise!',
              // closeMessage: 'O atendimento foi encerrado pelo atendente, agradecemos seu contato e caso tenha mais alguma dúvida é só me chamar novamente.',
              typeYourName: 'Para começar nossa conversa, digite o seu nome.',
              onlyName: 'Digite apenas o seu nome.',
              toContinueTypeYourNamePlease: 'Para continuar, por favor, digite o seu nome. ',
              typeYourNamePleaseSpecial: 'Parece que você incluiu um caractere especial. Digite apenas o seu nome.',
              continueTheConversation: 'Dessa forma não posso continuar a conversa.',
              typeYourNamePlease: 'Por favor, digite apenas o seu nome.',
              toAnswerYourQuestions: 'Para responder suas dúvidas, preciso que digite seu nome.',
              virtualAssistant: 'Assistente Virtual',
              maxLimit: 'Você ultrapassou o limite máximo de caracteres.',
              iCanHelpYou: 'Nesta sua pergunta eu posso te ajudar com mais de uma opção.',
              noneOption: 'Nenhuma das opções acima',
              notFound: 'Não entendi sua pergunta.',
              waitMoment: 'Aguarde uns instantes. Um atendente já vai falar com você.',
              selectOneOptions: 'Selecione uma das opções',
              typeName: 'Digite seu nome',
              typeNameError: 'Digite um nome válido.',
              typeFirstName: 'Digite seu primeiro nome',
              typeFirstNameError: 'Digite apenas seu primeiro nome.',
              typeLastName: 'Digite seu sobrenome',
              typeLastNameError: 'Digite apenas seu sobrenome.',
              typeHere: 'Digite aqui',
              typeHerePlease: 'Por favor digite algo.',
              typeEmail: 'Digite seu e-mail',
              typeEmailError: 'Por favor, informe um e-mail válido.',
              typeMoney: 'Digite seu valor',
              typeMoneyError: 'Por favor, informe um valor válido.',
              typePhone: 'Digite seu telefone',
              typePhoneError: 'Por favor, informe um telefone válido.',
              typeCpf: 'Digite seu CPF',
              typeCpfError: 'Por favor, informe um CPF válido.',
              typeBornDate: 'Digite sua data de nascimento',
              typeBornDateError: 'Por favor, informe sua data de nascimento válido.',
              typeCnpj: 'Digite seu CNPJ',
              typeCnpjError: 'Por favor, informe um CNPJ válido.',
              typeFaq: 'Digite sua dúvida',
              typeFaqError: 'Por favor, preencha algo.',
              selectListFaq: 'Escolha uma opção',
              selectListFaqError: 'Por favor, escolha uma opção.',
              selectRating: 'Selecione',
              search: 'Procurar',
              searchCountry: 'Procurar país',
              searchState: 'Procurar estado',
              searchCity: 'Procurar cidade',
              typeMessage: 'Digite sua mensagem...',
              typeMessageError: 'Por favor, digite sua mensagem',
              selectDate: 'Escolha uma data',
              selectDateError: 'Por favor, escolha uma data',
              selectSize: 'Escolha um tamanho',
              selectSizeError: 'Por favor, escolha um tamanho',
              typeNumber: 'Digite um número',
              typeNumberError: 'Por favor, digite um número',
              preferenceSaved: 'Preferência salva com sucesso'
            },
            dataCollectionPage: {
              description: 'Defina as mensagens iniciais e quais campos serão solicitados no início da conversa para registrar dados do lead.',
              leadDataTitle: 'Coleta de dados do lead',
              leadDataDescription: 'Os campos habilitados serão solicitados ao iniciar uma conversa. Um lead é contabilizado quando há coleta do campo e-mail ou telefone.',
              initialPhrase: 'Mensagem Inicial (boas vindas)',
              phrase: 'Mensagem',
              phraseContinue: 'Mensagem de continuidade (após pedir os dados)',
              btnSave: 'Salvar',
              name: 'Nome',
              email: 'Email',
              phone: 'Telefone'
            },
            chatbots: 'Chatbots',
            preferences: 'Preferências',
            interfaceChatbot: 'Interface WebChat',
            setAllVisual: 'Habilite e defina os aspectos visuais e funções do WebChat (janela do chat) instalados no site.',
            behaviorChatbot: 'Comportamento',
            accessTheBehaviorSettings: 'Acesse as configurações de comportamento do chatbot (controles de tempo, acionamento, modos de visualização da janela do chat e persistência da conversa)',
            installationChatbot: 'Instalação',
            accessTheInstallationSettings: 'Acesse as configurações de instalação e ativação dos chatbots em cada um dos canais: WebChat, WhatsApp, Instagram, Messenger e Telegram.',
            whatsappChatbot: 'Botão Whatsapp',
            whatsappChatbotDescription: 'Habilite e defina os aspectos visuais do Botão WhatsApp para seu site e configure o recurso de Rastrear Origem de Tráfego.',
            integrationsChatbot: 'Integrações',
            accessTheIntegrationSettings: 'Acesse o painel de configuração das diversas integrações do Globalbot com outros sistemas. Algumas destas configurações são realizadas pela nossa equipe técnica em virtude da complexidade e segurança.',
            masterChatbot: 'Master',
            exclusiveAccess: 'Acesso exclusivo para equipe da Globalbot para configurações avançadas, como localização dos servidores, cache conversation, comportamento da inteligência artificial e real time.',
            excludeVersionerAccess: 'Acesso excluviso para a equipe da Globalbot para visualizar os Versionamentos do fluxo.',
            publishChatbot: 'Versionamento',
            dataCollection: 'Coleta de Dados',
            dataCollectionSubtitle: 'Defina frases iniciais e quais campos o chatbot irá solicitar ao usuário no início da conversa.',
            messagesChatbot: 'Mensagens',
            modifyMessages: 'Aqui você pode modificar algumas das mensagens, apenas para Masters no momento.',
            flowPublish: 'Preferência salva com sucesso'
          },
          permission: {
            permission: {
              permission: 'Permissões',
              preferences: 'Preferências',
              conversations: 'Conversas',
              manager: 'Gerente',
              attendant: 'Atendente',
              seeAll: 'Ver todas',
              seeAttendedAndWithoutTransshipment: 'Ver atendidas e sem transbordo',
              onlyAttended: 'Ver somente atendidas',
              junior: 'Junior',
              done: 'Salvar',
              updatedPermissions: 'Permissões atualizadas!',
              connectionError: 'Oops, erro de conexão.'
            }
          },
          users: {
            access: {
              preferences: 'Preferências',
              users: 'Usuários',
              journey: 'Jornadas',
              addJourney: 'Adicionar Jornada',
              name: 'Nome',
              description: 'Descrição',
              actions: 'Ações',
              edit: 'Editar',
              linkUsers: 'Vincular usuários',
              exclude: 'Excluir',
              totalOf: 'Total de',
              usersBeing: 'usuários, sendo',
              inNone: 'em nenhuma',
              inOneAnd: 'em uma e',
              inTwoOrMore: 'em duas ou mais jornadas.',
              save: 'Salvar',
              cancel: 'Cancelar',
              journeyData: 'Dados da Jornada',
              journeyName: 'Nome da jornada *',
              comments: 'Observações',
              schedules: 'Horários',
              dayOfTheWeek: 'Dia da semana *',
              sunday: 'Domingo',
              monday: 'Segunda-feira',
              tuesday: 'Terça-feira',
              wednesday: 'Quarta-feira',
              thursday: 'Quinta-feira',
              friday: 'Sexta-feira',
              saturday: 'Sábado',
              input: 'Entrada *',
              exit: 'Saída *',
              addTime: 'Adicionar horário',
              tolerance: 'Tolerância',
              defineTheTolerance: 'Defina o tempo de tolerância desta jornada para acesso e permanência na plataforma.',
              important: 'Importante',
              onceTheTolerance: 'Uma vez atingido o tempo de tolerância, a plataforma emitirá um alerta e um contador de tempo regressivo para que o usuário finalize com tranquilidade suas atividades.',
              whenTheTotal: 'Quando o tempo total de permanência for finalmente atingido, o usuário será deslogado automaticamente. Somente usuários administradores poderão logar na plataforma fora dos seus horários de jornada.',
              ifUser: 'Caso um usuário esteja vinculado em mais de uma jornada, o acesso e permanência levará em consideração a jornada em que houver maior duração (tanto para entrada quando para saída).',
              journeyUsers: 'Usuários da Jornada',
              outOfTheJourney: 'Fora da jornada',
              withinTheJourney: 'Dentro da jornada',
              addSelected: 'Adicionar selecionados',
              addAll: 'Adicionar todos',
              removeAll: 'Remover todos',
              removeSelected: 'Remover selecionados',
              nonexistent: 'Inexistente',
              deleteJourney: 'Excluir Jornada',
              areYouSure: 'Tem certeza que deseja excluir esta jornada? Todos os dados do mesmo serão perdidos e esta ação não pode ser desfeita.',
              fiveMinutes: '5 minutos',
              tenMinutes: '10 minutos',
              fifteenMinutes: '15 minutos',
              twentyMinutes: '20 minutos',
              twentyFiveMinutes: '25 minutos',
              thirtyMinutes: '30 minutos',
              oneHour: '1 hora',
              twoHours: '2 horas',
              fourHours: '4 horas',
              sixHours: '6 horas',
              twelveHours: '12 horas',
              journeyCreated: 'Sua jornada foi criada!',
              journeyEdited: 'Sua jornada foi editada!',
              errorAtTheTime: 'Oops, tivemos um erro no momento!',
              duplicateTime: 'Remova os horários duplicados para salvar!',
              journeyExcluded: 'Sua jornada foi excluída!',
              errorCompletingThisAction: 'Oops, tivemos um problema ao completar essa ação.',
              journeyAtDeparmentUnlink: 'A jornada está vinculada ao departamento %1% é preciso desvincular a jornada do departamento para deleta-la.',
              journeyAtBotUnlink: 'A jornada está vinculada ao bot %1% é preciso desvincular a jornada do bot para deleta-la.'
            },
            emailExits: 'Usuário com este email já existe',
            preferences: 'Preferências',
            users: 'Usuários',
            addNewUser: 'Adicione novos usuários na plataforma. Caso atinja seu limite solicite a ampliação do mesmo.',
            createUser: 'Criar usuário',
            permissions: 'Permissões',
            managerUserPermissions: 'Administre as permissões dos usuários, habilitando ou restringindo acesso aos recursos da plataforma.',
            passwordMinimun8chars: 'Por favor, use no mínimo 8 caracteres!',
            journeys: 'Jornadas',
            defineTheJourney: 'Defina a jornada de operação dos chatbots, departamentos e usuários, controlando o acesso e permanência na plataforma.',
            extendLimit: 'Ampliar Limite',
            yourCurrentLimit: 'Seu limite atual não é suficiente? Solicite agora a ampliação.',
            avatar: 'Avatar',
            reasonForAbsence: 'Razão da ausência',
            statusReasonLabel: 'Motivo do status',
            statusReasonMasterTooltip: 'Esta coluna é exibida apenas para usuários master.',
            statusReasonDescriptionLabel: 'Descrição do motivo',
            statusReasonDescriptions: {
              SESSION_REVOKED_NEW_DEVICE: 'Sessão encerrada: acesso em outro dispositivo',
              SESSION_REVOKED_BY_ADMIN: 'Sessão encerrada por um administrador',
              AUTH_CONNECT: 'Sessão conectada',
              AUTH_SERVER_NAMESPACE_DISCONNECT: 'Sessão encerrada pelo servidor',
              AUTH_CLIENT_NAMESPACE_DISCONNECT: 'Sessão encerrada pelo navegador',
              AUTH_PING_TIMEOUT: 'Sessão perdida por tempo de resposta',
              AUTH_TRANSPORT_ERROR: 'Erro de conexão na sessão',
              AUTH_TRANSPORT_CLOSE: 'Conexão de sessão perdida',
              LIVE_SERVER_NAMESPACE_DISCONNECT: 'Chat ao vivo encerrado pelo servidor',
              LIVE_CLIENT_NAMESPACE_DISCONNECT: 'Chat ao vivo encerrado pelo navegador',
              LIVE_PING_TIMEOUT: 'Conexão do chat ao vivo perdida por tempo de resposta',
              LIVE_TRANSPORT_ERROR: 'Erro de conexão no chat ao vivo',
              LIVE_TRANSPORT_CLOSE: 'Conexão do chat ao vivo perdida',
              PANEL_SYS_CONNECT: 'Status definido ao conectar',
              PANEL_SYS_COOKIE_CONNECT: 'Status restaurado ao abrir o painel',
              PANEL_SYS_RECONNECT: 'Status restaurado após reconexão',
              PANEL_USER_CHANGE_STATUS: 'Usuário alterou o status',
              PANEL_USER_CHANGE_STATUS_FROM_LIST: 'Status alterado pela lista de atendentes',
            },
            addAvatar: 'Adicionar avatar',
            name: 'Nome',
            nameRequired: 'Nome *',
            email: 'Email',
            emailRequired: 'Email *',
            role: 'Cargo',
            departmentsFilter: 'Selecione um Departamento',
            chatbotsFilter: 'Selecione um Chatbot',
            linked: 'Vinculados',
            unlinked: 'Sem Vínculo',
            roleRequired: 'Cargo *',
            permission: 'Permissão',
            permissionRequired: 'Permissão *',
            actions: 'Ações',
            accessReport: 'Relatório de acesso',
            edit: 'Editar',
            exclude: 'Excluir',
            understood: 'Entendi',
            important: 'IMPORTANTE',
            impossibleToDelete: ': Impossível excluir este usuário pois ele possui ',
            activeConversations: 'conversas ativas. Você deve transferir ou finalizar as conversas deste usuário antes de solicitar exclusão.',
            save: 'Salvar',
            cancel: 'Cancelar',
            close: 'Fechar',
            userData: 'Dados do Usuário',
            ddi: 'DDI',
            phone: 'Celular',
            newPassword: 'Nova senha *',
            chatbots: 'Chatbots',
            departments: 'Departamentos',
            accessLogs: 'Logs de Acesso',
            initialDate: 'Data inicial',
            startTime: 'Hora inicial',
            finalDate: 'Data final',
            endTime: 'Hora final',
            status: 'Status',
            date: 'Data',
            intentions: 'Intenções',
            intentionsDescription: 'Selecione a data e o horário para o filtro procurar entre a área escolhida.',
            available: 'Online',
            away: 'Ausente',
            offline: 'Offline',
            connected: 'Conectado',
            disconnected: 'Desconectado',
            endJourney: 'Fim da jornada',
            excludeUser: 'Excluir usuário',
            areYouSureDelete: 'Tem certeza que deseja excluir este usuário? Todos os dados do mesmo serão perdidos e esta ação não pode ser desfeita.',
            youCanRequest: 'Você pode solicitar usuários adicionais para utilização na plataforma. Favor informar os dados abaixo que um de nossos especialistas entrará em contato com você.',
            amount: 'Quantidade *',
            request: 'Solicitar',
            primary: 'Primário',
            administrator: 'Administrador',
            manager: 'Gerente',
            attendant: 'Atendente',
            junior: 'Junior',
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro',
            shortJan: 'Jan',
            shortFeb: 'Fev',
            shortMar: 'Mar',
            shortApr: 'Abr',
            shortMay: 'Mai',
            shortJun: 'Jun',
            shortJul: 'Jul',
            shortAug: 'Ago',
            shortSep: 'Set',
            shortOct: 'Out',
            shortNov: 'Nov',
            shortDec: 'Dez',
            sunday: 'Domingo',
            monday: 'Segunda',
            tuesday: 'Terça',
            wednesday: 'Quarta',
            thursday: 'Quinta',
            friday: 'Sexta',
            saturday: 'Sábado',
            shortSunday: 'Dom',
            shortMonday: 'Seg',
            shortTuesday: 'Ter',
            shortWednesday: 'Qua',
            shortThursday: 'Qui',
            shortFriday: 'Sex',
            shortSaturday: 'Sab',
            exportToSVG: 'Exportar para SVG',
            exportToPNG: 'Exportar para PNG',
            exportToCSV: 'Exportar para CSV',
            menu: 'Menu',
            selection: 'Selecionar',
            selectionZoom: 'Selecionar zoom',
            zoomIn: 'Mais zoom',
            zoomOut: 'Menos zoom',
            pan: 'Mover',
            reset: 'Retornar ao padrão',
            userDeleted: 'Usuário excluído.',
            errorUserDelete: 'Oops, não conseguimos excluir este usuário!',
            notLimit: 'Você não tem mais limite para adicionar usuários.',
            errorSavingUser: 'Preencha todos os campos obrigatórios.',
            invalidPassword: 'A senha deve ter no mínimo 8 dígitos!',
            errorPasswordLength: 'Cadastre uma senha com mais de 6 caracteres.',
            theArchitect: 'O Arquiteto',
            notFound: 'Não encontrado',
            dominion: 'Domínio',
            master: 'Mestre',
            senior: 'Sênior',
            failedToRequest: 'Oops, falha ao solicitar usuários.',
            requestedUsers: 'Usuários solicitados.',
            requiredFields: 'Você precisa preencher os campos.',
            userCreatedSuccessfully: 'Usuário criado com sucesso!',
            userUpdatedSuccessfully: 'Usuário atualizado com sucesso!',
            userSeeAnyAttendantConversations: "Permitir visualizar e transferir conversas de outros atendentes?",
            restrictToLinkedBots: "Permitir funções e visualizações somente ao(s) chatbot(s) atribuídos a este usuário.",
            restrictToLinkedBotsLockedTooltip: "Você não pode desativar esta opção no seu próprio perfil enquanto ela estiver ativa."
          },
          unsubscribeGroups: {
            title: 'Grupos de desinscrição',
            description: 'Cada domínio tem um grupo de desinscrição. Quem clicar em "descadastrar" num e-mail enviado por este domínio entra nesta lista e deixa de receber campanhas dele, sem afetar outros domínios nem os e-mails de sistema.',
            backToDomains: 'Voltar para domínios',
            domain: 'Domínio',
            status: 'Status',
            statusActive: 'Ativo',
            statusPendingSync: 'Sincronizando com o provedor',
            pendingSyncHint: 'O grupo ainda não foi confirmado pelo provedor de e-mail. Tentamos de novo automaticamente todo dia às 03:00, ou agora pelo botão Sincronizar.',
            displayName: 'Nome',
            descriptionField: 'Descrição exibida ao destinatário',
            descriptionHint: 'Até 100 caracteres. Aparece na página de preferências de e-mail do destinatário.',
            edit: 'Editar',
            save: 'Salvar',
            cancel: 'Cancelar',
            saved: 'Grupo atualizado.',
            noGroupTitle: 'Este domínio ainda não tem grupo de desinscrição',
            noGroupDescription: 'O grupo é criado automaticamente ao cadastrar o domínio. Se a criação falhou, você pode criar agora.',
            createGroup: 'Criar grupo',
            groupCreated: 'Grupo criado.',
            unsubscribedEmails: 'E-mails descadastrados',
            searchEmail: 'Buscar e-mail',
            email: 'E-mail',
            unsubscribedAt: 'Descadastrado em',
            releasedAt: 'Liberado em',
            releasedBy: 'Liberado por',
            reason: 'Motivo',
            actions: 'Ações',
            rowUnsubscribed: 'Descadastrado',
            rowReleased: 'Liberado',
            systemRelease: {
              resubscribed_by_recipient: 'Reinscrito pelo próprio destinatário',
              global_suppression_reset: 'Reinício da supressão global'
            },
            release: 'Liberar e-mail',
            releaseTitle: 'Liberar e-mail do grupo',
            releaseDescription: 'O e-mail voltará a receber campanhas deste domínio. Ele continua na lista como "liberado", com o motivo informado.',
            reasonLabel: 'Motivo *',
            reasonRequired: 'Informe um motivo com pelo menos 3 caracteres.',
            confirmRelease: 'Liberar',
            released: 'E-mail liberado.',
            releaseOnlyAdmin: 'Apenas administradores da conta podem liberar e-mails.',
            empty: 'Nenhum e-mail descadastrado neste grupo.',
            loadError: 'Não foi possível carregar os dados. Tente novamente.',
            providerUnavailable: 'O provedor de e-mail está indisponível no momento. Tente novamente em instantes.',
            rowsPerPage: 'Linhas por página',
            retry: 'Tentar novamente',
            displayNameRequired: 'Informe o nome do grupo.',
            saveError: 'Não foi possível salvar o grupo. Tente novamente.',
            syncNow: 'Sincronizar agora',
            stillPending: 'O grupo continua sincronizando com o provedor. Tentaremos de novo automaticamente.',
            onlyAdminCanCreate: 'Apenas administradores da conta podem criar ou sincronizar o grupo.',
            editOnlyAdmin: 'Apenas administradores da conta podem editar o grupo.',
            forbidden: 'Você não tem permissão para esta ação.',
            invalidPayload: 'Dados inválidos. Revise os campos e tente novamente.',
            genericError: 'Não foi possível concluir a operação. Tente novamente.'
          },
          domains: {
            unsubscribeGroups: 'Grupos de desinscrição',
            domainInUse: 'O grupo de desinscrição deste domínio está em uso por envios agendados ou em andamento. Conclua ou cancele esses envios antes de excluir o domínio.',
            providerUnavailable: 'O provedor de e-mail está indisponível no momento e o domínio não foi excluído. Tente novamente em instantes.',
            deleteConsequence: 'O grupo de desinscrição e a lista de descadastros deste domínio também serão apagados no provedor de e-mail.',
            preferences: 'Preferências',
            domains: 'Domínios',
            addNewDomainsToThePlatform: 'Adicione novos domínios na plataforma. Antes deve ser registrado DKIM, TXT e CNAME do domínio.',
            addDomain: 'Adicionar domínio',
            creation: 'Criação',
            domain: 'Domínio',
            emails: 'E-mails',
            name: 'Nome',
            actions: 'Ações',
            waiting: 'Aguardando',
            verified: 'Verificado',
            type: 'TIPO',
            host: 'HOST',
            data: 'DATA',
            verifyDomain: 'Verificar domínio',
            exclude: 'Excluir',
            addNewDomain: 'Adicionar novo domínio',
            insertRecords: 'Agora é necessário inserir os seguintes registros no seu DNS.',
            updateDomain: 'A propagação do seu DNS pode levar algumas horas, e o status do seu domínio será atualizado na plataforma.',
            record: 'Registro',
            nameToUpperCase: 'NOME',
            valueToUpperCase: 'VALOR',
            cancel: 'Cancelar',
            add: 'Adicionar',
            addNewEmail: 'Adicionar novo e-mail',
            confirmationEmail: 'Você receberá um email de confirmação, clique no link no corpo do email para proceguir com a verificação de email.',
            email: 'Email',
            excludeDomain: 'Excluir Domínio',
            areYouSure: 'Tem certeza que deseja excluir este domínio?',
            domainSuccessfully: 'Dominio cadastrado com sucesso.',
            connectionError: 'Erro de conexão',
            domainAlreadyRegistered: 'Domínio já cadastrado, tente novamente com outro.',
            startTheProcess: 'Para começar o processo é necessário um domínio.',
            deletedDomain: 'Domínio excluído.',
            domainSuccessfullyValidated: 'Domínio validado com sucesso!',
            fieldsNotAuthenticated: 'Há alguns campos ainda não autenticados, '
          },
          lists: {
            preferences: 'Preferências',
            lists: 'Listas',
            deleteSelectedLists: 'Excluir listas selecionadas',
            avatar: 'Avatar',
            title: 'Título',
            amount: 'Quantidade',
            actions: 'Ações',
            view: 'Visualizar',
            exclude: 'Excluir',
            save: 'Salvar',
            cancel: 'Cancelar',
            listData: 'Dados da lista',
            name: 'Nome',
            email: 'Email',
            phone: 'Telefone',
            excludeList: 'Excluir lista',
            areYouSure: 'Tem certeza que deseja excluir esta lista?',
            listDeleted: 'Sua lista foi excluída!',
            errorDeleteThisList: 'Oops, não conseguimos excluir esta lista!'
          },
          dataBases: {
            importData: 'Importar Base de Dados',
            name: 'Nome',
            cdt: 'Data/Hora',
            replaceData: 'Substituir dados',
            import: 'Importar',
            importCSV: "Impotar arquivo CSV",
            syncGoogleSheet: "Sincronizar com Google Sheets",
            invalidSpreadsheetId: 'O ID da planilha inválido',
            foundSheets: 'Planilhas encontradas',
            shareSpreadsheet: 'Você precisa compartilhar sua planilha com este email: ',
            listPages: 'Listar páginas',
            reportSpreadsheetId: 'Informe o ID da planilha',
            reportTabSheet: 'Selecione a planilha que deseja importar.',
            reportName: 'Coloque um nome',
            alreadyBaseName: 'Já existe uma base com este nome',
            alreadyBaseSheetName: 'Já existe uma base com esta página da planilha',
            descriptionSpreadsheetId: "O ID da planilha por ser extraído a partir da URL. Por exemplo: O ID da planilha nesta URL https://docs.google.com/spreadsheets/d/abc1234567/edit#gid=0 é 'abc1234567'.",
            dataGoogleSpreadSheet: 'Dados planilha Google',
            deleteDataBase: 'Deletar base de dados',
            spreadSheetId: 'ID da planilha Google',
            sheetPageName: 'Nome da página',
            close: 'Fechar',
            delete: 'Deletar'
          },
          status: {
            consult: 'Consultar',
            consultDescription: 'Verifique o status atual de um número WhatsApp dentro da Globalbot e realize ações de reset e bloqueio.',
            consultNumber: 'Consultar número WhatsApp',
            country: 'País *',
            customerNumber: 'Número do WhatsApp do Cliente *',
            alert: 'Atenção:',
            alertDescription: 'Informe o número do celular do cliente com DDD com 2 dígitos, exemplo (XX) XXXXX-XXXX.',
            cancel: 'Cancelar',
            back: 'Voltar',
            phoneRequired: 'Preencha o telefone para consultar.',
            status: 'Status:',
            statusMessage: {
              live: 'Em conversa com atendente.',
              bot: 'Em conversa com o chatbot.',
              live_satisfactionSurvey: 'Conversa com o atendente encerrada, agora o usuário está respondendo a pesquisa de satisfação.',
              bot_satisfactionSurvey: 'Conversa com o chatbot encerrada, agora o usuário está respondendo a pesquisa de satisfação.',
              no_conversation: 'Não está em conversa.',
              blocked: 'Número bloqueado.'
            },
            reset: 'Resetar',
            block: 'Bloquear',
            resetNumber: 'Resetar número WhatsApp',
            confirmReset: 'Por favor confirme o RESET do número WhatsApp',
            resetDescription: 'A partir do momento do RESET o número será desvinculado da jornada de conversa. A próxima interação do usuário iniciará a conversa com o chatbot.',
            resetBlockedWarning: 'Este número está bloqueado neste chatbot. O reset encerra a interação, mas não remove o bloqueio.',
            blockNumber: 'Bloquear número WhatsApp',
            confirmBlock: 'Por favor confirme o bloqueio do número WhatsApp',
            blockDescription: 'Este número não consiguirá mais interagir no chatbot até que seja desbloqueado.',
            unblockNumber: 'Desbloquear número WhatsApp',
            confirmUnblock: 'Por favor confirme o desbloqueio do número WhatsApp',
            unblockDesription: 'A partir deste momento este número estará liberado para interagir novamente no chatbot',
            confirm: 'Confirmar',
            current_status: {
              reseted: 'Número resetado',
              blocked: 'Número bloqueado',
              unblocked: 'Número desbloqueado'
            },
            channel: 'Canal',
            cdt: 'Data e Hora',
            chatbot: 'Chatbot',
            number: 'Número',
            identification: 'Identificação',
            identificationTooltip: 'Identificação do contato: o número de telefone ou, quando a Meta não fornece o telefone, o BSUID — identificador do usuário atribuído pela Meta (ex.: BR.1914261605930178).',
            condition: 'Condição',
            user: 'Autor',
            actions: 'Ações',
            resetError: 'Oops! Não foi possível resetar número.',
            resetSuccess: 'Número resetado com sucesso!',
            blockError: 'Oops! Não foi possível bloquear número.',
            blockSuccess: 'Número bloqueado com sucesso!',
            unblockError: 'Oops! Não foi possível desbloquear número.',
            unblockSuccess: 'Número desbloqueado com sucesso!',
            consultError: 'Oops! Não foi possível consultar número.',
            consultSuccess: 'Número não está em conversa.',
            system: 'Sistema',
            reason: 'Motivo:',
            blockReason: {
              too_many_messages: 'Mais de 200 mensagens trocadas no tempo de 20 minutos.',
              loop_marker: 'O usuário foi e voltou mais de 50 vezes para o mesmo ponto do fluxo.',
              lock_marker: 'O usuário saltou para o mesmo ponto do fluxo repetidamente mais de 50 vezes.'
            },
            noInformation: 'Sem informação',
            numberNoConversationDescriprion: 'O número em questão não está em nenhuma conversa. Caso queira bloquear este número, selecione o ChatBot desejado abaixo.',
            historyFilter: 'Histórico de ações',
            historyFilterTooltip: 'Mostra apenas as ações do tipo selecionado. A lista é o histórico de ações, da mais recente para a mais antiga.',
            historyAll: 'Todos',
            historyAction: {
              blocked: 'Foi bloqueado',
              unblocked: 'Foi desbloqueado',
              reseted: 'Foi resetado'
            },
            viewHistory: 'Ver histórico',
            historyTitle: 'Histórico de ações',
            historyEmpty: 'Nenhuma ação registrada para este número.',
            historyError: 'Oops! Não foi possível carregar o histórico.',
            listError: 'Oops! Não foi possível carregar a listagem de números.',
            tryAgain: 'Tentar novamente',
            close: 'Fechar'
          },
          live: {
            serviceMessages: 'Mensagens de serviço',
            portuguese: 'Português',
            english: 'Inglês',
            spanish: 'Espanhol',
            completionMessage: 'Mensagem de finalização',
            finishAndArchivedMessage: 'Mensagem de finalização e arquivamento',
            archivalMessage: 'Mensagem de arquivamento',
            transferMessage: 'Mensagem de transferência',
            automaticTransferToAttendant: 'Transbordo automático para atendente',
            transshipmentAvailableForAttendants: 'Transbordo disponível para atendentes',
            queueTransshipmentWithoutDistribution: 'Transbordo em fila (sem distribuição)',
            queueTransshipmentWithDistribution: 'Transbordo em fila (com distribuição)',
            queuePositionLabel: 'Mensagem para transmitir posição na fila',
            queuePositionVariableRequired: 'Esta mensagem precisa da variável %POSITION%',
            deliveryTitle: 'Envio ao cliente',
            deliveryDescription: 'Escolha quais mensagens automáticas o cliente recebe. Uma mensagem desligada não é enviada, mas continua registrada na conversa para auditoria, com a indicação de que não foi enviada.',
            deliveryReadOnlyHint: 'Texto padrão da plataforma, sem edição.',
            deliveryEditableHint: 'Texto configurável acima.',
            sendToCustomer: 'Enviar ao cliente',
            deliveryTypes: {
              take_room: { label: 'Atendente assumiu o atendimento', example: '{nome} assumiu este atendimento.' },
              transfer_room: { label: 'Conversa transferida', example: '{nome} transferiu este atendimento.' },
              finish_room: { label: 'Atendimento finalizado', example: '{nome} finalizou o atendimento.' },
              finish_and_archive_room: { label: 'Atendimento finalizado e arquivado', example: '{nome} finalizou e arquivou o atendimento.' },
              archive_room: { label: 'Atendimento arquivado', example: '{nome} arquivou o atendimento.' },
              with_attendant: { label: 'Transbordo automático para atendente', example: 'Com atendente.' },
              available: { label: 'Transbordo disponível para atendentes', example: 'Disponível.' },
              queue: { label: 'Transbordo em fila (sem distribuição)', example: 'Em fila.' },
              queue_distribution: { label: 'Transbordo em fila (com distribuição)', example: 'Em fila automática.' },
              waiting: { label: 'Aguardando atendente', example: 'Aguardando.' },
              no_vacancy: { label: 'Nenhum atendente disponível', example: 'Texto definido no nó de Chat ao Vivo do fluxo.' },
              finished_reply: { label: 'Resposta em conversa já finalizada', example: 'Usa a mensagem de finalização.' },
              user_reconnected: { label: 'Cliente retornou ao chat', example: 'O usuário retornou ao chat.' }
            },
            transshipmentAwaitingAttendants: 'Transbordo aguardando atendentes (check in desabilitado)',
            noAttendantsAvailable: 'Sem atendentes disponíveis (check in habilitado)',
            tipDepartmentIsPersistent: 'Não é possível ativar o check-in pois este departamento está configurado na persistência dos bots: ',
            pauseOptions: 'Opções de pausa',
            activated: 'Ativado',
            disabled: 'Desativado',
            enterHereAll: 'Insira aqui todas as possíveis pausas que os atendentes podem selecionar.',
            add: 'Adicionar opção',
            automaticAway: 'Away automático',
            determineTheCheckInTime: 'Determine o tempo de checagem.',
            time: 'Tempo',
            viewingOptions: 'Opções de visualização',
            autoArchive: 'Tempo de arquivamento de conversas',
            autoArchiveCaption: 'Configure o arquivamento automático de conversas no chat ao vivo.',
            conversationCloseOptions: 'Opções ao finalizar conversa',
            conversationCloseOptionsDescription: 'Habilite a atribuição de tags ou valor ao finalizar uma conversa.',
            addTag: 'Atribuir Tags',
            addMonetary: 'Atribuir Valor',
            requiredTagsBatch:'Conversas sem tags, defina as tags para finalizar as conversas!',
            requiredMonetaryValueBatch:'Conversas sem valor, defina o valor monetário para finalizar as conversas!',
            errorReasonPhrases: {
              ROOM_NOT_FOUND: 'Conversa não encontrada.',
              ROOM_NOT_FINISHED: 'A conversa não foi finalizada.',
              NO_ATTENDANTS: 'Não há atendentes na conversa.',
              MISSING_INFORMATION: 'Informações em falta.',
              UNKNOWN_ERROR: 'Erro desconhecido.',
              ROOM_ALREADY_CLOSED: 'A conversa já foi finalizada.',
            },
            required: 'Obrigatório',
            coin: 'Moeda',
            coinTypes: {
              BRL: 'Real Brasileiro - BRL',
              USD: 'Dólar Americano - USD',
            },
            chooseTheLevel: 'Escolha o nível de acesso em que seus operadores poderão ver na lista de atendentes.',
            managers: 'Gerentes',
            attendants: 'Atendentes',
            departments: 'Departamentos',
            newDepartment: 'Novo departamento',
            newDepartmentDescription: 'Crie departamentos para organizar e direcionar conversas para atendimento humano.',
            addDepartment: 'Adicionar um novo',
            actions: 'Ações',
            color: 'Cor',
            departmentConfig: 'Configurações do Departamento',
            defineTheDepartments: 'Defina abaixo os departamentos do módulo Chat ao Vivo. Os departamentos são úteis para "rotear" as solicitações de contato, tratando-as de forma segmentada.',
            whenCreatingTheDepartments: 'Ao criar os departamentos, utilize as configurações de Usuários para definir em qual(is) departamento(s) cada usuário poderá operar.',
            name: 'Nome',
            setBehavior: 'Defina o comportamento de entrada caso não tenha nenhum atendente online no momento.',
            checkIn: 'Check-in',
            forcePass: 'Force Pass',
            forcePassDescription: 'Distribuir atendimentos também para atendentes offline.',
            forcePassDistributionNone: 'Você precisa selecionar um tipo de distribuição quando o Force Pass está habilitado.',
            queueDisable: 'A Fila de Atendimento é obrigatória com o Force Pass habilitado.',
            queuePositionDisable: 'Transmitir Posição da Fila só pode ser ativada com a Fila de Atendimento habilitada e um tipo de Distribuição selecionada.',
            forcePassDisable: 'Não é possível habilitar o Force Pass com o Check-in habilitado.',
            checkInDisable: 'Não é possível habilitar o Check-in com o Force Pass habilitado.',
            attendanceQueue: 'Fila de atendimento',
            lastUpdate: 'Última atualização',
            persistence: 'Persistência',
            persistenceDescription: 'O recurso persistência envia mensagens ao cliente quando ele fica sem interagir no Chat ao Vivo, com objetivo de obter resposta para agilizar o atendimento.',
            activatePersistence: 'Ativar Persistência',
            firstMessageIn: 'Primeira mensagem em',
            secondMessageIn: 'Segunda mensagem em',
            firstMessageTooltip: 'Tempo para enviar a primeira mensagem de persistência',
            secondMessageTooltip: 'Tempo para enviar a segunda mensagem de persistência',
            transmitQueuePosition: 'Transmitir Posição da Fila',
            transmitQueuePositionDescription: 'Transmitir a posição da fila para os clientes que estão aguardando.',
            maxAttendances: 'Máximo de atendimentos',
            maxAttendancesDescription: 'Defina a quantidade máxima que cada atendente pode atender simultaneamente.',
            customersByAttendants: 'Clientes por atendentes',
            distribution: 'Distribuição',
            distributionDescription: 'Escolha a forma de distribuição dos atendimentos no módulo Chat ao Vivo.',
            balancing: 'Balanceamento',
            disabledNone: 'Desabilitado',
            businessHours: 'Jornada de Atendimento',
            businessHoursDescription: 'Escolha uma Jornada de Atendimento para determinar horários de funcionamento para o departamento.',
            autoBalance: 'Auto Balanceamento',
            sequential: 'Sequencial',
            save: 'Salvar',
            comfirm: 'Confirmar',
            exclude: 'Excluir',
            addDepartment: 'Adicionar departamento',
            cantDeleteDepartmentUser: 'Você não pode excluir este departamento pois existem pessoas vinculadas à ele:',
            cantDeleteDepartmentPersistence: 'Você não pode excluir este departamento pois existem bots vinculados à ele na configuração de persistência:',
            areYouSureSaved: 'Você tem certeza que deseja salvar as alterações?',
            areYouSureDeleted: 'Você quer mesmo excluir este departamento?',
            youCanChange: 'Você pode alterar as configurações quando quiser, mas o',
            previousContent: 'conteúdo anterior não pode ser restaurado.',
            cancel: 'Cancelar',
            finishRoom: 'A conversa foi finalizada.',
            archiveRoom: 'A conversa foi arquivada.',
            transferRoom: 'A conversa foi transferida.',
            withAttendant: 'Com atendente.',
            available: 'Disponível.',
            queue: 'Em fila.',
            queueDistribution: 'Em fila automática',
            waiting: 'Aguardando',
            noVacancy: 'Nenhum atendente no momento.',
            oneMinute: '1 minuto',
            twoMinutes: '2 minutos',
            threeMinutes: '3 minutos',
            fourMinutes: '4 minutos',
            fiveMinutes: '5 minutos',
            tenMinutes: '10 minutos',
            fifteenMinutes: '15 minutos',
            thirtyMinutes: '30 minutos',
            oneHour: '1 hora',
            sixHours: '6 horas',
            twelveHours: '12 horas',
            oneDay: '1 dia',
            twoDays: '2 dias',
            threeDays: '3 dias',
            fourDays: '4 dias',
            fiveDays: '5 dias',
            seeAll: 'Ver todos',
            onlyDepartments: 'Ver apenas nos departamentos',
            preferences: 'Preferências',
            liveChat: 'Chat ao Vivo',
            messages: 'Mensagens',
            behavior: 'Comportamento',
            updated: 'Atualizado!',
            myDepartment: 'Meu departamento',
            departmentAdded: 'Departamento adicionado!',
            deletedDepartment: 'Departamento excluído!',
            none: 'Nenhuma',
            noDistribution: 'Sem Distribuição',
            active: 'Ativo',
            inactive: 'Inativo',
            quantity: 'Quantidade',
            attendanceDistribution: 'Distribuição dos Atendimento',
            attendanceDistributionDescription: 'Defina como os atendimentos serão distribuídos neste departamento.',
            balanced: 'Balanceada',
            noDistributionDescription: 'Os atendimentos não serão distribuídos. Ficarão em espera. Os atendentes devem captar e assumir para si individualmente.',
            sequentialDescription: 'Os atendimentos serão distribuídos sequencialmente para os atendentes do departamento disponíveis. O primeiro atendente disponível receberá o atendimento e assim sucessivamente.',
            balancedDescription: 'Os atendimentos serão distribuídos aos atendentes do departamento considerando quem está com menor volume.',
            additionalConfiguration: 'Configurações Adicionais',
            edit: 'Editar',
            confirm: 'Confirmar',
            addDepartment: 'Adicionar departamento',
            updateDepartment: 'Atualizar departamento',
          },
          settings: {
            user: 'Meu Perfil',
            userDescription: 'Consulte e edite suas informações de login e cadastro.',
            preferences: 'Preferências',
            users: 'Usuários',
            usersDescription: 'Administre os usuários da plataforma Globalbot. Você pode incluir, excluir usuários, além de definir e editar as permissões de acesso e funções de cada um deles de forma independente.',
            liveChat: 'Chat ao Vivo',
            liveChatDescription: 'Defina as configurações do módulo Chat ao Vivo. Crie os departamentos, defina a forma de distribuição dos atendimentos e as mensagens automáticas.',
            tags: 'Tags',
            customFields: 'Seções e Campos',
            tagsDescription: 'Acesse as configurações do sistema de tags (etiquetas), que podem ser utilizadas para marcar e classificar diversos itens em uma lista ou coleção (ex. Conversas, Inteligência e Biblioteca)',
            tagsDescriptionMini: 'Crie e edite as tags que você irá utilizar para marcar e classificar as conversas.',
            domainsAndEmail: 'Domínios e E-mails',
            domainsAndEmailDescription: 'Configure domínios e e-mails da sua empresa para que apareçam como remetentes em envios da Mensageria (e-mails, notificações e avisos).',
            lists: 'Listas',
            listsDescription: 'Acesse e controle todas as listas criadas e enviadas para a plataforma.',
            liveChatConfigs: {
              messages: 'Mensagens',
              messagesDescription: 'Confira e edite as mensagens prontas do Chat ao Vivo.',
              behavior: 'Comportamento',
              behaviorDescription: 'Configure o comportamento das funções no Chat ao vivo.',
              departmentsConfig: 'Departamentos',
              departmentsConfigDescription: 'Configure departamentos para organizar e direcionar conversas para atendimento humano.'
            },
            dataBases: 'Bases de Dados',
            dataBasesDescription: 'Importe bases de dados externas para serem integradas com os fluxos dos chatbots.',
            numberStatus: 'Status e Bloqueios',
            numberStatusDescription: 'Consulte os status de números WhatsApp dos clientes e realize bloqueios se necessário.',
            optout: 'Opt-Out',
            optoutDescription: 'Acesse e gerencie as pessoas que optaram por não receber mensagens da sua empresa (Opt-Out).',
            crmDescription: 'Crie e edite seções e campos personalizados para organizar os cadastros de pessoas e empresas e importe registros.',
            whatsappConsumption: 'Consumo WhatsApp',
            whatsappConsumptionDescription: 'Confira o consumo WhatsApp e adicione créditos quando necessário.'
          },
          whatsappConsumption: {
            additionalFilters: 'Filtros adicionais',
            availableBalance: 'Saldo Disponível',
            balanceLimit: 'Limite',
            refreshBalance: 'Atualizar saldo',
            balanceError: 'Não foi possível carregar o saldo. Tente novamente.',
            addCredits: 'Adicionar Créditos',
            charges: {
              title: 'Histórico de cobranças',
              statusFilter: 'Situação',
              createdAt: 'Solicitada em',
              amount: 'Valor',
              paymentMethod: 'Forma de pagamento',
              status: 'Situação',
              dueDate: 'Vencimento',
              paidAt: 'Pago em',
              requestedBy: 'Solicitado por',
              description: 'Descrição',
              paidAmount: 'Valor pago',
              currency: 'Moeda',
              exportCsv: 'Exportar CSV',
              exportSuccess: 'Relatório gerado com sucesso.',
              exportError: 'Não foi possível gerar o relatório de cobranças.',
              csvFilename: 'historico-de-cobrancas',
              providerChargeId: 'Id no provedor',
              registrationStatus: 'Registro do boleto',
              registrationRegistered: 'Registrado',
              registrationPending: 'Pendente de aprovação do banco',
              registrationPendingHint: 'Esta aprovação pode demorar de 1 a 5 minutos para estar apto a ser pago.',
              registrationRejected: 'Erro ao gerar boleto',
              registrationUnknown: 'Registro não confirmado',
              unknownUser: 'Usuário removido',
              empty: 'Nenhuma cobrança registrada.',
              error: 'Não foi possível carregar o histórico de cobranças.',
              statuses: {
                created: 'Registrada',
                pending_confirmation: 'Aguardando confirmação do provedor',
                pending: 'Aguardando pagamento',
                paid: 'Pago',
                cancelled: 'Cancelada',
                expired: 'Vencida',
                failed: 'Falhou'
              }
            },
            charge: {
              title: 'Adicionar Créditos',
              hint: 'Geramos uma cobrança e devolvemos o link de pagamento. O saldo entra assim que o pagamento é confirmado.',
              amount: 'Valor da recarga',
              amountHint: 'Entre',
              paymentMethod: 'Forma de pagamento',
              paymentMethodRequired: 'Escolha a forma de pagamento.',
              paymentMethods: {
                boleto_pix: 'Boleto / Pix',
                cheque: 'Cheque',
                dinheiro: 'Dinheiro',
                cartao_credito: 'Cartão de crédito',
                cartao_debito: 'Cartão de débito',
                deposito: 'Depósito',
                cheque_pre_datado: 'Cheque pré-datado',
                debito_automatico: 'Débito automático',
                transferencia_bancaria: 'Transferência bancária',
                doc_ted: 'DOC / TED',
                outros: 'Outros'
              },
              description: 'Descrição (opcional)',
              dueDateField: 'Data de vencimento (opcional)',
              dueDateHint: 'Se não for definida, o boleto vencerá em {days} dias.',
              dueDateOutOfRange: 'O vencimento deve estar entre',
              descriptionHint: 'Aparece na cobrança enviada ao financeiro.',
              submit: 'Adicionar',
              created: 'Cobrança gerada',
              dueDate: 'Vence em',
              reused: 'Esta solicitação já havia sido gerada; devolvemos a mesma cobrança.',
              checkoutLabel: 'Link de pagamento',
              checkoutPending: 'A cobrança foi registrada, mas o link ainda não está disponível. Consulte novamente em instantes.',
              openCheckout: 'Abrir link de pagamento',
              copyLink: 'Copiar link',
              linkCopied: 'Link copiado!',
              invalidAmount: 'Informe um valor válido.',
              amountOutOfRange: 'O valor deve estar entre',
              amountNotWhole: 'Informe um valor inteiro, sem centavos.',
              errorGatewayNotConfigured: 'Esta conta ainda não tem cadastro no provedor de pagamento. Fale com o seu contato comercial.',
              errorModelNotEnabled: 'Esta conta não está no modelo de saldo por mensagem.',
              errorForbidden: 'Você não tem permissão para solicitar créditos nesta conta.',
              errorGateway: 'O provedor de pagamento não respondeu. Tente novamente em alguns minutos.',
              errorGeneric: 'Não foi possível gerar a cobrança. Tente novamente.'
            },
            chart: {
              title: 'Relatório de Consumo',
              seriesService: 'Service',
              debited: 'Debitado',
              exportCsv: 'Exportar CSV',
              totalMessages: 'Mensagens',
              totalMessagesHint: 'Total de mensagens de serviço (Service) entregues no período, considerando os chatbots do filtro.',
              retry: 'Tentar novamente',
              empty: 'Nenhum consumo no período',
              emptyHint: 'Só aparecem aqui as mensagens de serviço do WhatsApp.',
              errorForbidden: 'Você não tem permissão para ver o consumo desta conta.',
              errorValidation: 'Revise o filtro: o período ou os chatbots selecionados não foram aceitos.',
              errorGeneric: 'Não foi possível carregar o relatório de consumo.',
              csvPeriod: 'Período',
              csvMessages: 'Mensagens de serviço',
              csvDebits: 'Debitado',
              csvCredits: 'Creditado',
              csvNet: 'Saldo do período',
              csvFilename: 'consumo-whatsapp'
            }
          },
          contacts: {
            contacts: 'Contatos',
            people: 'Pessoas',
            data: 'Dados Individuais',
            peopleDescription: 'Você possui X pessoas cadastradas. ',
            companieseDescription: 'Você possui X organizações cadastradas. ',
            companies: 'Empresas'
          },
          optout: {
            optout: 'Opt-Out',
            reseted: 'Revertido em Opt-In',
            add: 'Adicionar',
            addDescription: 'Adicione manualmente um número WhatsApp para a pessoa não receber mais mensagens da empresa.',
            permanence: 'Permanência',
            permanenceDescription: 'MASTER: Defina o tempo de permanência do registro em Opt-Out. (Por padrão: permanente)',
            tableColumns: {
              channel: 'Canal',
              cdt: 'Data e Hora',
              chatbot: 'Chatbot',
              number: 'Número',
              condition: 'Condição',
              user: 'Autor',
              actions: 'Ações',
            },
            addOptout: 'Adicionar Opt-Out',
            important: 'Atenção:',
            importantDescription: 'Informe o número do celular do cliente com DDD com 2 dígitos, exemplo: (XX) XXXXX-XXXX.',
            customerPhone: 'Número do WhatsApp do Cliente*',
            country: 'País*',
            cancel: 'Cancelar',
            close: 'Fechar',
            advance: 'Avançar',
            confirm: 'Confirmar',
            revertToOptIn: 'Reverter para Opt-In',
            confirmChange: 'Por favor confirme esta mudança para o número de WahtsApp',
            backToReceiveMessage: 'Este número voltará a receber mensagens da empresa.',
            permanenceDrawer: {
              permanence: 'Permanência',
              permanenceDescription: 'Defina o tempo de permanência de uma pessoa em Opt-Out. Por padrão o tempo de permanência é “para sempre”. Se você definir outra opção, a condição de Opt-Out passará a expirar de acordo com a sua escolha e as Regras da Permanência.',
              permanenceRules: 'Regras da Permanência',
              permanenceRulesDescriptionOne: 'O tempo de permanência, uma vez ativado, será retroativo. No momento que você ativar ou editar o recurso, ele irá contabilizar o tempo para todos os registros.',
              permanenceRulesDescriptionTwo: 'E se você desativar o recurso todas as contagens de tempo de permanência (se houverem anteriormente) serão canceladas e os registros permanecerão em Opt-Out para sempre.',
              forever: 'para sempre',
              fifteenDays: 'por 15 dias',
              thirtyDays: 'por 30 dias',
              ninetyDays: 'por 90 dias',
              oneHundredEightyDays: 'por 180 dias',
              originNumber: 'Número de origem',
              permanenceOptout: 'Permanecer em Opt-Out'
            },
            selectChatbot: 'Selecione os números que serão adicionados Opt-Out. Este número não irá mais receber mensagens da empresa a partir do(s) Chatbot(s) selecionado(s).',
            phoneRequired: 'Preencha o telefone para adicionar.',
            consultError: 'Oops! Não foi possível consultar número.',
            numberSituation: {
              live: 'Em conversa com atendente.',
              bot: 'Em conversa com o chatbot.',
              live_satisfactionSurvey: 'Conversa com o atendente encerrada, agora o usuário está respondendo a pesquisa de satisfação.',
              bot_satisfactionSurvey: 'Conversa com o chatbot encerrada, agora o usuário está respondendo a pesquisa de satisfação.',
              no_conversation: 'Não está em conversa.',
              optout: 'Já está em Opt-Out.'
            },
            resetError: 'Oops! Erro ao reverter para Opt-In.',
            resetSuccess: 'Revertido para Opt-in com sucesso!',
            permanenceSuccess: 'Tempos de permanência definidos com sucesso!',
            permanenceError: 'Oops! Erro ao definir tempos de permanência.',
            selectRow: 'Nenhum número foi selecioado.',
            insertError: 'Oops! Erro ao setar Opt-Out para bot: ',
            customer: 'Cliente',
            customerDescriptionOptout: 'Cliente optou por não receber mais mensagens (Opt-Out)',
            customerDescriptionReset: 'Cliente iniciou nova conversa com a empresa (Opt-In)',
            system: 'Sistema',
            systemDescriprion: 'Revertido em Opt-In pelo Tempo de Permanência',
            back: 'Voltar'
          },
          tags: {
            preferences: 'Preferências',
            tags: 'Tags',
            add: 'Adicionar',
            columns: 'Colunas',
            color: 'Cor',
            category: 'Categoria',
            title: 'Título',
            description: 'Descrição',
            actions: 'Ações',
            edit: 'Editar',
            exclude: 'Excluir',
            save: 'Salvar',
            cancel: 'Cancelar',
            tagData: 'Dados da Tag',
            deleteTag: 'Excluir tag',
            areYouSureDelete: 'Tem certeza que deseja excluir esta tag? Esta ação não pode ser desfeita.',
            general: 'Geral',
            reports: 'Relatórios',
            realTime: 'Tempo real',
            analytics: 'Estatísticas',
            organization: 'Organização',
            companies: 'Empresas',
            people: 'Pessoas',
            conversation: 'Conversas',
            flow: 'Fluxo',
            knowledge: 'Inteligência',
            message: 'Campanhas',
            liveChat: 'Chat ao vivo',
            library: 'Biblioteca',
            tasks: 'Tarefas',
            deletedTag: 'Tag excluída.',
            errorDeleteThisTag: 'Oops, não conseguimos excluir esta tag!',
            errorSavingTag: 'Oops, algum erro aconteceu ao salvar a tag.',
            requiredFields: 'O campo título e cor precisam ser preenchidos.'
          }
        }
      },
      general: {
        cancel: 'Cancelar',
        save: 'Salvar',
        confirm: 'Confirmar',
        close: 'Fechar',
        back: 'Voltar',
        advance: 'Avançar',
        attention: 'Atenção',
        test: 'Teste',
        start: 'Início',
        retract: 'Recolher',
        users: 'Usuários',
        campaigns: 'Campanhas',
        note: 'Nota',
        edit: 'Editar',
        delete: 'Excluir',
        clear: 'Limpar',
        rename: 'Renomear'
      }
    },
    'en-US': {
      session: {
        policyTitle: 'One device per user',
        policyDescription: 'When enabled, signing in on a new device ends that user\'s previous session. Multiple tabs in the same browser keep working.',
        stateOn: 'Enabled',
        stateOff: 'Disabled',
        policyUpdated: 'Setting updated.',
        policyError: 'Could not update the setting.',
        viewDevices: 'View connected devices',
        revokedNewDevice: 'Your account was accessed on another device. This session has ended.',
        revokedByAdmin: 'Your session was ended by an administrator.',
        title: 'Connected devices',
        subtitle: 'Where this account is open right now',
        devices: 'devices',
        device: 'device',
        currentDevice: 'This device',
        lastSeen: 'Last seen',
        firstSeen: 'First seen',
        revoke: 'End session',
        revokeConfirm: 'End this device session? The person will be disconnected immediately.',
        revoked: 'Session ended.',
        revokeError: 'Could not end the session.',
        noDevices: 'No connected devices.'
      },
      components: {
        sounds: {
          audioBlocked: '🔈 To hear sound notifications, interact with the screen by clicking anywhere.'
        },
        tables: {
          noDataLabel: 'No data available.',
          dragTableColumns: 'Drag columns'
        },
        selects: {
          noSearchResults: 'No results found'
        },
        action: {
          requisition: {
            request: 'Request',
            method: 'Method',
            run: 'Run',
            messageError: 'Oops, missing information.'
          },
          copyToClipboard: 'Copied to clipboard!',
          copyToClipboardError: 'Error copying to clipboard.',
          editCode: 'Edit code',
          copyCode: 'Copy code',
          showEditableBlock: 'View editable block only',
          showFullCode: 'View full code',
          editableBlockNotFound: 'Could not locate the editable block',
        },
        advancedSearch: {
          index: {
            myFilters: 'My search filters',
            custom: 'Custom',
            today: 'Today',
            yesterday: 'Yesterday',
            thisMonth: 'This month',
            lastSevenDays: 'Last 7 days',
            lastFifteenDays: 'Last 15 days',
            lastThirtyDays: 'Last 30 days',
            personalized: 'Personalized',
            search: 'Search',
            initialDate: 'Initial date',
            initialHour: 'Start time',
            endDate: 'End date',
            endHour: 'End time',
            chatbots: 'Chatbots',
            channel: 'Channel',
            all: 'All',
            webchat: 'Webchat',
            dialogue: 'Dialogue',
            dialogueDescription: 'You can filter by who started the conversation, attendant or customer.',
            from: 'From',
            to: 'To',
            botDeleted: 'Bot deleted',
            active: 'Chatbot/Actives',
            receptive: 'Customer/Receptive',
            whatsapp: 'Whatsapp',
            messenger: 'Messenger',
            gbm: 'Google Business Messages',
            rcs: 'RCS',
            instagram: 'Instagram',
            telegram: 'Telegram',
            identifiers: 'Identifiers',
            filter: 'Filter',
            fill: 'Fill',
            filled: 'Filled',
            notFilled: 'Not filled out',
            transhipment: 'Transhipment',
            transhipmentDescription: 'This is a new feature, filters based on this field are not applied to dates before 03/19/2020.',
            withAttachments: 'With attachments',
            indifferent: 'Indifferent',
            attended: 'Attended',
            notAttended: 'Not attended',
            unrealized: 'Unrealized',
            none: 'None',
            attendants: 'Attendants',
            departments: 'Departments',
            otherOptions: 'Other options',
            onlyConversations: 'Only conversations',
            allConversations: 'All',
            incompleteConversations: 'Incomplete',
            conversationFinished: 'Finished',
            satisfaction: 'Satisfaction',
            oneStar: '1 star',
            twoStar: '2 stars',
            threeStar: '3 stars',
            fourStar: '4 stars',
            fiveStar: '5 stars',
            tags: 'Tags',
            term: 'Term',
            inIdentifier: 'In the identifier',
            clear: 'Clear',
            createFilter: 'Create filter',
            title: 'Title',
            save: 'Save',
            messageError: 'Oops, there was an error.',
            listBy: 'List of ',
            savedFilter: 'Your filter has been saved!',
            of: 'of',
            selectAll: 'All',
            interno: 'Internal',
          }
        },
        advancedSearchCrm: {
          index: {
            people: 'People',
            companies: 'Companies',
            equal: 'is equal to',
            notEqual: 'is not equal to',
            filled: 'is filled',
            notFilled: 'is not filled',
            contains: 'contains',
            notContains: 'does not contain',
            greaterThan: 'greater than',
            lessThan: 'less than',
            field: 'Field',
            condition: 'Condition',
            value: 'Value',
          }
        },
        analytics: {
          quickview: {
            conversation: {
              noDataAvailable: 'No data available.'
            },
            knowledge: {
              noDataAvailable: 'No data available.'
            },
            rating: {
              noDataAvailable: 'No data available.'
            },
            usersConnected: {
              noDataAvailable: 'No data available.'
            }
          },
          attendants: {
            attendants: 'Attendants',
            satisfaction: 'Satisfaction',
            attendance: 'Attendances',
            onlineTime: 'Online time',
            reviewsAnswered: 'Reviews Answered',
            awayTime: 'Away time',
            tta: 'TAT - (Total attendance time)',
            tma: 'ATT - (Average attendance time)',
            tme: 'AWT - (Average waiting time)',
            tte: 'TWT - (Total waiting time)',
            noDataAvailable: 'No data available.',
            name: 'Name',
            filteredConversations: 'Conversations in filter',
            participations: 'Attendances (participations)',
            totalsHint: 'Conversations in filter is the total of conversations matching the applied filters, the same number shown by the advanced search indicator. Attendances counts each attendant participation: a transferred conversation adds one attendance for each of them, and a conversation that never reached an attendant adds none.',
            loadError: 'Could not load the attendant indicators.',
            tryAgain: 'Try again'
          },
          botAndAttendant: {
            attendants: 'Attendants',
            noDataAvailable: 'No data available.',
            chatbots: 'Chatbots'
          },
          bubble: {
            sunday: 'Sunday',
            hours: ' hours',
            attendance: ' attendances'
          },
          campaign: {
            utmSource: 'UTM Source',
            tip: 'TIP',
            utmMedium: 'UTM Medium',
            utmCampaign: 'UTM Campaign',
            utmTerm: 'UTM Term',
            utmContent: 'UTM Content',
            withCampaign: 'With campaign',
            withoutCampaign: 'Without campaign'
          },
          channel: {
            noDataAvailable: 'No data available.',
            total: 'Total',
            impressions: 'Impressions',
            impressionsDescription: 'In WebChat, it is the volume of times the chatbot appeared available for click/trigger.',
            attendance: 'Attendances',
            attendanceDescription: 'When a user (customer) activates the chatbot to start the conversation and a attendance is started.',
            messages: 'Messages',
            messagesDescription: 'Total volume of messages exchanged in all conversations (answers). Enter user (customer), chatbots and attendants (if any).',
            ttAttendance: 'TA Time',
            ttAttendanceDescription: 'It is the total service time of the channel, from the moment of activation until the end of the conversation.',
            tmAttendance: 'AT Time',
            tmAttendanceDescription: 'It is the average service time of the channel, considering the selected period.',
            totalTransshipments: 'Total transshipments',
            totalTransshipmentsDescription: 'Number of requests in which the chatbot requests assistance from an attendant, whether triggered by a flow rule or by the user (customer).',
            transshipmentsAttended: 'Transshipment attended',
            transshipmentsAttendedDescription: 'Number of calls where the chatbot passed the conversation to the attendant and he was able to answer.',
            unattendedTransshipments: 'Unattended transshipments',
            unattendedTransshipmentsDescription: 'Number of calls where the chatbot passed the conversation to the attendant and he was unable to answer.',
            unrealizedTransshipments: 'Unshipped transshipments',
            unrealizedTransshipmentsDescription: 'Number of calls where the chatbot was unable to transfer the conversation to an attendant (there were no attendants online at the time). The chatbot resumed the conversation.',
            ttWait: 'TW Time',
            ttWaitDescription: 'It is the total time that users (customers) remained on hold to be attended by attendants (when the service queue is enabled).',
            tmWait: 'AW Time',
            tmWaitDescription: 'It is the average time that users (customers) remained on hold to be attended by attendants (when the service queue is enabled).',
            satisfaction: 'Satisfaction',
            satisfactionDescription: 'It is the service satisfaction rate in general (a survey triggered at the end of the attendance). Scale from 0 to 5 and number of respondents in parentheses.',
            monetaryValueDescription: 'Check the total value generated by conversations during the period (very useful for those who sell products and services). To appear here, the value must be assigned to each conversation individually.',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
            shortJan: 'Jan',
            shortFeb: 'Feb',
            shortMar: 'Mar',
            shortApr: 'Apr',
            shortMay: 'May',
            shortJun: 'Jun',
            shortJul: 'Jul',
            shortAug: 'Aug',
            shortSep: 'Sep',
            shortOct: 'Oct',
            shortNov: 'Nov',
            shortDec: 'Dec',
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            shortSunday: 'Sun',
            shortMonday: 'Mon',
            shortTuesday: 'Tue',
            shortWednesday: 'Wed',
            shortThursday: 'Thu',
            shortFriday: 'Fri',
            shortSaturday: 'Sat',
            exportToSVG: 'Export to SVG',
            exportToPNG: 'Export to PNG',
            exportToCSV: 'Export to CSV',
            menu: 'Menu',
            selection: 'Select',
            selectionZoom: 'Select zoom',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            pan: 'Mover',
            reset: 'Return to default'
          },
          city: {
            noDataAvailable: 'No data available.',
            others: 'Others'
          },
          country: {
            noDataAvailable: 'No data available.',
            others: 'Others'
          },
          department: {
            noDataAvailable: 'No data available.'
          },
          heat: {
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            hours: ' hours',
            attendance: 'Attendances'
          },
          identifier: {
            selectIdentifier: 'Select an identifier',
            noDataAvailable: 'No data available.',
            others: 'Others',
            limitCards: 'Maximum quantity of 12 views. To create a new one, please delete an existing one.'
          },
          knowledgeAnswered: {
            noDataAvailable: 'No data available.',
            answered: 'Answered',
            unambiguous: 'Unambiguous',
            unanswered: 'Unanswered',
            outContext: 'Out of context'
          },
          knowledgeResponses: {
            noDataAvailable: 'No data available.',
            others: 'Others'
          },
          pivot: {
            origin: 'Origin',
            total: 'Total'
          },
          platform: {
            noDataAvailable: 'No data available.',
            incognito: 'Incognito'
          },
          sankey: {
            noDataAvailable: 'No data available.',
            to: 'Para',
            from: 'De',
            amount: 'Amount'
          },
          state: {
            noDataAvailable: 'No data available.',
            others: 'Others'
          }
        },
        crm: {
          expansion: {
            required: 'Required field',
            attach: 'Attach',
            noData: 'No registered document',
            noPermission: 'No permission to view',
            deleted: 'Contact deleted!',
            updated: 'Document updated!',
            uploading: 'Uploading file...',
            removed: 'File removed',
            phoneError: 'Invalid phone number for the selected country.'

          }
        },
        drawers: {
          crm: {
            section: {
              sectionData: 'New Section',
              editSection: 'Edit Section',
              nameRequired: 'Name*',
              description: 'Description',
              newSection: 'Create a new Section, which will contain several custom fields.',
              permissions: 'Permissions',
              required: 'Required Field.',
              type: 'Type*',
              useFields: 'Use fields from this section for contact listing.',
              whoCanSeeAndEdit: 'Who can see this section.',
              canView: 'View',
              canEdit: 'Edit',
              fillAllRequiredFields: 'Fill in all required fields',
              sectionSaved: 'Section saved.',
              people: 'Person',
              company: 'Company',
              admin: 'Administrator',
              manager: 'Manager',
              attendant: 'Attendant'
            },
            custom: {
              sectionData: 'New Field',
              editCustom: 'Edit Field',
              nameRequired: 'Name*',
              description: 'Description',
              newSection: 'Create a new field, defining its parameters and binding to one.',
              permissions: 'Permissions',
              mask: 'Mask',
              currency: 'Currency',
              placeholder: 'Placeholder',
              required: 'Required Field.',
              section: 'Section*',
              type: 'Type*',
              writeOption: 'Type an option',
              addOption: 'Add option',
              name: 'Name',
              token_label: 'token',
              name_label: 'Name',
              token_placeholder: 'token',
              interactionKey: 'Key field for grouping interactions',
              whoCanSeeAndEdit: 'Who can see or edit.',
              canEdit: 'Edit',
              canView: 'View',
              admin: 'Administrator',
              manager: 'Manager',
              attendant: 'Attendant',
              text: 'Text',
              editor: 'Large Text',
              name: 'Name',
              email: 'E-mail',
              number: 'Number',
              decimal: 'Number (with decimals)',
              date: 'Date',
              coin: 'Currency (international type)',
              url: 'URL',
              tel: 'Phone',
              list: 'Single Choice List',
              image: 'Image',
              file: 'Document',
              cnpj: 'CNPJ',
              cpf: 'CPF',
              cep: 'CEP',
              fieldSaved: 'Field saved.',
              tokenExists: 'This token already exists for this section.',
              fillAllRequiredFields: 'Fill in all required fields'
            },
            imports: {
              importsData: 'Record Import',
              fieldCompatibility: 'Field Compatibility',
              importRules: 'Import Rules',
              nameRequired: 'Name*',
              required: 'Required field.',
              importType: 'Import records of type*',
              example: 'Example Messaging.csv',
              fieldCompatibilityDescription: 'Associate the fields found in your spreadsheet with the fields already configured in the Contacts module.',
              note: 'NOTE: ',
              fieldCompatibilityNote: 'Only fields that are compatible will be associated (e.g. number in field of type "numeric").',
              keyFieldDescription: 'The key field serves to verify if the records being imported match records that already exist in the system.',
              keyFieldDescriptionTwo: 'If the record already exists, what should be done:',
              keepExisting: '"Keep what already exists" will not import records where the key field matches. "Replace with imported data" will replace all fields of the record that contain data in this import.',
              selectAction: 'Select an action',
              listImported: 'List imported successfully.',
              fillAllRequiredFields: 'Fill in all required fields',
              people: 'Person',
              company: 'Company',
              keepExisting: 'Keep what already exists',
              replaceWithImported: 'Replace with imported data',
              admin: 'Administrator',
              manager: 'Manager',
              attendant: 'Attendant',
              field: 'Field'
            }
          },
          broadcast: {
            template: {
              email: {
                save: 'Save',
                cancel: 'Cancel',
                messageEditor: 'Message Editor',
                personalizeEmail: 'You can customize your email using variables.',
                library: 'Library',
                messageErrorToCompile: 'Error compiling email!',
                templateSaved: 'Your template has been saved!',
                messageErrorConnection: 'Oops, there was a connection error!'
              },
              sms: {
                save: 'Save',
                cancel: 'Cancel',
                messageEditor: 'Message Editor',
                message: 'Message *',
                messageHas: 'Your message has',
                characters: 'characters.',
                discountCredits: 'Will be deducted',
                discountCreditsFinal: 'for each number.',
                overcomeTheCharacters: 'In cases where the SMS content exceeds 160 characters, more than one credit per 153 characters will be charged.',
                notSupportConcatenation: 'Some operators like Oi and Sercomtel do not support message concatenation, so SMS will be received separately.',
                templateSaved: 'Your template has been saved!',
                messageErrorConnection: 'Oops, there was a connection error!',
                messageNeedFilled: 'The name and message fields must be filled in!'
              },
              whatsapp: {
                save: 'Save',
                cancel: 'Cancel',
                messageEditor: 'Message Editor',
                message: 'Message *',
                messageHas: 'Your message has',
                characters: 'characters.',
                discountCredits: 'Two credits will be deducted for each number.',
                integrations: 'The integration between Globalbot and WhatsApp allows sending active messages considering the following guidelines:',
                activeMessages: 'Active Messages:',
                activeMessagesDescription: 'In this case the WhatsApp chatbot is used for notification and message to customers. And the origin of the attendance (first message) is by the company. If the customer responds to the message, a new chat session (or attendance) will be started.',
                dispatchesInLargeScale: 'Sending large scale:',
                dispatchesInLargeScaleDescription: 'It is important to pay attention to this type of use, as mass mailings (when related to promotions, disclosures, advertising and the like) are not allowed. Automated submissions to groups of customers, such as notifications and notices (within a context that the customer has chosen to receive the message, known as an opt-in), are acceptable.',
                modelSaved: 'Your template has been saved!',
                youCannotChange: 'You cannot change messages on official WhatsApp. Please contact the support team.',
                messageErrorConnection: 'Oops, there was a connection error!',
                messageNeedFilled: 'The name and message fields must be filled in!'
              },
              save: 'Save',
              cancel: 'Cancel',
              modelData: 'Template Data',
              name: 'Name *',
              tags: 'Tags',
              observations: 'Comments',
              integrationsId: 'ID for use in integrations: ',
              modelMessageRequired: 'To carry out a send, you must always use a Message Template already created.',
              newMessageModelData: 'Here you will inform the data of the new Message Template, which can be used to carry out Sends to the recipients you designate.',
              clientsWaba: 'For WABA (WhatsApp Business API) customers, notifications in HSM format are mandatory and must follow pre-approved formats.',
              whatsappTerm: 'WhatsApp Terms of Use:',
              whatsappTermDescription: ' It is very important to point out that, in order to use the integration between Globalbot and WhatsApp, the customer is aware of and accepts the WhatsApp Usage Policies, using the application so as not to violate them. If you do, the number may be blocked. ',
              whatsappUsagePolicies: 'WhatsApp Usage Policies',
              messageSavedModel: 'Your template has been saved!',
              messageErrorConnection: 'Oops, there was a connection error!',
              fieldNameRequired: 'The name and message fields must be filled in!'
            },
            dispatch: {
              save: 'Save',
              cancel: 'Cancel',
              dispatchData: 'Dispatch Data',
              draftData: 'Draft Data',
              newDispatch: 'New Dispatch |',
              createDispatch: 'Create Dispatch',
              dispatchName: 'Dispatch name *',
              observations: 'Comments',
              originAndInitialization: 'Origin and Initialization',
              indicateServer: 'Indicate which WhatsApp server you want to send (corresponds to your enabled number).',
              optional: 'Optional: Customize chatbot behavior if user replies to this message. The number refers to the point in the conversational flow that will be triggered after the response. Find out which point of the flow and its numbering in the Flow module. Leave the value 0 for the flow to run normally from the beginning.',
              whatsappServer: 'WhatsApp Server *',
              flowIndex: 'Flow index',
              message: 'Message *',
              replaceWith: 'Replace with',
              dailyLimit: 'Current daily sending limit',
              templateDescription: 'The use of Templates (Message Models) is mandatory on WhatsApp. To create a sending, you must select a previously created and approved Template.',
              includeIdentifiers: 'Include identifiers in conversation',
              templateMediaDescription: 'If the selected template includes media (image, document, or video), please upload it. If it contains variables such as',
              templateMediaDescriptionTwo: ', use the fields below to replace them with the values from your recipient list.',
              pdfLimitExceeded: 'PDF must be no larger than 100MB.',
              imageLimitExceeded: 'Image must be no larger than 5MB.',
              videoLimitExceeded: 'Video must be no larger than 16MB.',
              advancedSettings: 'Advanced Settings',
              advancedSettingsDescription: 'If the client replies to this message, the chatbot will move to the following flow step:',
              preview: 'Preview',
              previewDescription: 'In the preview, values from the first row of your list are shown to fill in the variables, if any.',
              defineMessage: 'Define the Message',
              preperDispatch: 'Prepare the Dispatch',
              dispatchList: 'Dispatch List',
              sendTest: 'Send Test',
              sendTestDescription: 'In the test, values ​​from the first line of your list will be used to fill the variables, when applicable.',
              textPlaceholder: 'Text to replace',
              phoneNumber: 'Phone number',
              saveAsModel: 'Also save as a template to be used later.',
              back: 'Back',
              text: 'TEXT',
              smsVarDescription: 'If needed, you should use the variables found in your list so the message replaces them according to the instructions below.',
              smsVarEx: 'Example: If the variable in the list is NAME, use it in the message as %NAME%, like: "Hello %NAME%, I am sending you a message."',
              headerLike: 'Header type:',
              importantDescription: 'Statistics may be partial if the dispatch was done recently.',
              readMessages: 'Notes about Read Messages:',
              readMessagesObs: 'This statistic may be approximate, as some people do not enable viewing permission.',
              subjectAndSender: 'Subject and Sender',
              personalizeEmail: 'You can customize your email using variables. See the tips.',
              subjectEmail: 'The subject of your email has ',
              characters: ' characters. The number of characters displayed on mobile devices is 35 and on desktops 70 on average.',
              unsubscribeGroup: {
                pending: 'The group of this domain is still syncing with the provider. Wait a few minutes.',
                missing: 'This domain has no unsubscribe group. Open Settings > Domains and create it.',
                required: 'Pick a sender from a domain that has an unsubscribe group.'
              },
              senderName: 'Sender name *',
              sender: 'Sender *',
              replyTo: 'Reply to *',
              read: 'Read',
              readDesc: 'Total number of recipients who actually viewed the message. This statistic may be approximate as some people do not enable viewing permission.',
              readDesc2: 'Percentage referring to total Deliveries.',
              recipients: 'Recipients',
              trackingConversation: 'Traceability in Conversations',
              trackingConversationDescription: 'Assign a TAG if you want to identify the conversations that are initiated from this sending.',
              recipientsDesc: 'Total recipients selected for sending, considering the attributes and segmentations you chose.',
              dispatchTest: 'Dispatch Test',
              replaceVar: 'Replacement of variables',
              combineLists: 'You can combine lists and filters or even import a new list. ',
              selectList: 'Select an already saved mailing list or import it.',
              clickHere: 'Click here',
              downloadModelList: 'to download a list template.',
              importList: 'Import List',
              lists: 'Lists',
              filters: 'Filters',
              notSend: 'Do not send to...',
              includeCampaign: 'Include in a campaign',
              campaign: 'Campaign *',
              messageCampaignOne: 'A campaign is a collection of related submissions.',
              messageCampaignTwo: 'Campaigns provide a series of grouped reports and statistics for your submissions.',
              messageCampaignThree: 'Use campaigns to group your submissions and analyze the results over time. Examples: Weekly Campaign, January Shipments, etc.',
              integrationsId: 'ID for use in integrations: ',
              found: 'Found',
              repeated: 'Repeated',
              excluded: 'Withdrawn',
              range: 'Reach',
              var: 'List variables',
              varDescription: 'Below are the variables found in the list and examples of values extracted from the first line.',
              deliveries: 'Deliveries',
              totalRecipients: 'Total recipients selected for sending, considering the attributes and targeting you previously chose.',
              sent: 'Sent',
              error: 'Not Delivered',
              errorDesc: 'Total number of recipients whose messages were not delivered, for reasons such as: non-existent WhatsApp number, user is in an open chat session, specific problem with the HSM Template, among others.',
              errorCodesWhatsApp: {
                'BROADCAST_WHATSAPP_TIMEOUT_PROCESS':'Processing timeout',
                'GLOBALBOT_BUBBLE_NOT_FOUND': 'Bubble not found',
                'BROADCAST_DISPATCH_UNEXPECTED_ERROR_TRANSACTION': 'Error processing number dispatch',
                'BROADCAST_WHATSAPP_INTERNAL_ERROR': 'Unexpected error',
                'BROADCAST_WHATSAPP_FAIL_SEND_TO_WORKER': 'Failed to send message to worker',
                'BROADCAST_WHATSAPP_CONVERSATION_ALREADY_EXISTS': 'In conversation',
                'BROADCAST_WHATSAPP_BUBBLE_ALREADY_EXISTS': 'In conversation',
                'GLOBALBOT_NOT_FOUND_TEMPLATE': 'Template not found',
                'GLOBALBOT_INVALID_ARGUMENTS': 'Invalid arguments',
                'GLOBALBOT_MISSING_PARAMS': 'Missing parameters',
                'GLOBALBOT_BOT_NOT_FOUND': 'Bot not found',
                'GLOBALBOT_OPT_OUTED_PHONE': 'Opt-out',
                'GLOBALBOT_ALREADY_IN_CONVERSATION': 'In conversation',
                'GLOBALBOT_UNEXPECTED_ERROR': 'Unexpected processing error',
                'GUPSHUP_INVALID_TEMPLATE_CATEGORY': 'Invalid template category',
                'GUPSHUP_REQUEST_ERROR': 'Error processing request',
                'GUPSHUP_GENERIC_ERROR': 'Generic error',
                'GUPSHUP_INVALID_ARGUMENTS': 'Invalid arguments',
                'GUPSHUP_MISSING_BOT_CONFIG': 'Missing bot configuration',
                'GUPSHUP_UNEXPECTED_ERROR': 'Unexpected processing error',
                'BOT_HISTORY_NOT_FOUND': 'Bot not found',
                'BOT_HISTORY_TOO_MANY_BOTS_WITH_APP_NAME': 'Multiple bots with the same application name',
                'BOT_HISTORY_NOT_FOUND_BOT_WPP_CONFIG': 'Invalid WhatsApp bot configurations',
                ///Interla GlobalBot errors
                '9991': 'Bot without configuration or non-existent',
                '9992': 'Error sending message to broker',
                '9997': 'Failed to send the message to the channel',
                '9998': 'Insufficient credit balance',
                '9990': 'Unknown error',
                '400': 'In Conversation',
                '403': 'In Conversation',
                '472': `User's phone number is part of an experiment`,
                '471': 'Restriction applied by META (Messages blocked or Flagged as spam)',
                '500': "Error on the broker's server, please contact Globalbot",
                '1001': 'Invalid Sender',
                '1002': 'Non-existent Number',
                '1003': 'Globalbot Credits',
                '1004': 'Problem with HSM Template',
                '1005': 'Problem with HSM Template',
                '1006': 'Problem with HSM Template',
                '1007': 'Problem with HSM Template',
                '1026': 'Undeliverable',
                '1008': 'Opt-out',
                '1010': 'Invalid URL',
                '1011': 'Invalid Media Size',
                '1012': 'Message sending failed because the phone number chose to leave this communication channel.',
                '1013': 'Non-existent Number',
                '2000': 'Problem with HSM Template',
                '4002': 'Invalid WhatsApp response',
                '4003': 'Message sending failed because the template did not match.',
                '4004': 'Message type is only supported by Meta hosted cloud API.',
                '4005': 'Message sending failed because the template is paused.',
                ///META Errors
                //'400':'Media download error - Failed to download media from sender.',
                '402': 'Company eligibility (payment issue) - Failed to send message due to one or more errors related to payment method.',
                '408': 'The message is not valid - Failed to send the message because it was pending for too long (for example, more than 1 day). This can happen when restarting the WhatsApp Business API client after more than a day of inactivity.',
                '410': 'Message expired - Message not sent within its TTL (time to live).',
                '429': 'Rate limit reached - number sent too many messages.',
                '430': 'Certificate not signed - Failed to send the message because a certificate-related error occurred.',
                '432': 'Certificate identification mismatch - Failed to send the message because a certificate-related error occurred.',
                '433': "Invalid certificate signing - Occurs when a message is sent but the company's client certificate is not properly signed with the corresponding identity keys.This indicates that the client probably re- registered with new identity keys, but did not complete the entire certificate creation flow.",
                '470': 'Re-engagement message - Failed to send the message because more than 24 hours have passed since the customer last responded to this number.',
                //'471':'Spam rate limit reached - Failed to send the message because there is a limit on how many can be sent from this phone number. It's possible that many previous messages were blocked or marked as spam.',
                //'472':'User's phone number is part of an experiment - Failed to send the message because the user's phone number is part of an',
                '480': "Possible user change - Failed to send the message due to a possible change in the user's phone number.",
                //'500':'Generic error - Failed to send message due to an unknown error.',
                '501': 'The message type is not currently supported. - Document messages with captions are currently not supported.',
                '1000': 'Generic error',
                //'1001':'Message too long - Message length is more than 4,096 characters.',
                //'1002':'Invalid recipient type - Valid recipient types:',
                //'1004':'Already existing resource - Possible UUID conflict for media load requests or already existing UUID assigned to other media.',
                //'1005':'Access denied -',
                //'1006':'Resource not found - File or resource not found.',
                //'1007':'Recipient blocked from receiving messages ( - The recipient is not whitelisted.',
                //'1008':'Required parameter missing - A required parameter is missing.',
                '1009': 'Invalid parameter value - The value entered for a parameter is not the correct type or there is another problem.',
                //'1010':'Non-required parameter - Contains a parameter that is not required.',
                //'1011':'The service is not ready -',
                //'1013':'The user is not valid -',
                '1014': 'Internal error',
                '1015': 'Excessive number of requests - Client rate limit has been reached.',
                '1016': 'System Overload - If the system receives heavy load, this error is returned to allow the system to recover.',
                '1017': 'Non-primary master - This error occurs when a master-level only request (such as set or get settings, import, export, request code, register, and so on) is sent to a node that is not a primary master. This may happen if the WhatsApp Business API client is not configured correctly or if there are internal errors.',
                '1018': 'Coreapp not primary - This error occurs when requests are sent to a Coreapp node that does not own the shard nor is it in the process of becoming the owner. You may see this error when we are doing shard failover in multiconnect configuration.',
                '1021': 'Incorrect user - This error occurs when a user sends a message to themselves.',
                '1022': "Webhooks URL not configured - This error will occur if A's webhooks format",
                '1023': 'Database error',
                '1024': 'Password change requested - Password needs to be changed.',
                '1025': 'Invalid request - The request is not valid.',
                //'1026':'Recipient unavailable - Message not delivered. See 'Why isn't my delivery rate 100%?',
                '1028': 'System notification of type - You sent a message to a WhatsApp user that may have been changed. A notification',
                '1031': "Sender's account is locked - Your account has been locked and will not be able to send messages due to an integrity policy violation.Consult",
                //'2000':'Template parameter count mismatch - The number of parameters provided does not match the expected quantity.',
                '2001': 'Missing template - The template is not active or does not exist for a language and locale.',
                '2002': 'Template fetch failed - Recipient failed to download template.',
                '2003': 'Missing template package - There are no templates for the given language and locale.',
                '2004': 'Template parameter too long - The parameter is too long.',
                '2005': 'Template hydrated text too long - The translated text is too long.',
                '2006': 'Template whitespace policy violated - Whitespace policy was violated.',
                '2007': 'Template format character policy violated - Format character policy was violated.',
                '2008': 'Unsupported model media format - The media format used is not supported.',
                '2009': 'Required template component missing - A required template component is not present.',
                '2010': 'Invalid template hydrated URL - The URL in the button component is not valid.',
                '2011': 'Invalid model phone number - The phone number in the button component is not valid.',
                '2012': 'Template parameter format mismatch - The parameter format does not match the created template.',
                '2013': 'Incompatible model buttons - The buttons are not accepted by the recipient.',
                '2014': 'The expected namespace is empty - This error occurs when the language pack for a message template has not yet been downloaded.',
                '2015': 'Invalid number of sections - The number of sections in the message request is below or above the allowed limit. Consult the',
                '2016': 'Invalid number of lines - The number of lines is not valid. For',
                '2017': "Character policy violated - The format's character policy was violated.",
                '2023': 'Invalid product number - The section object has no products or the total product count has exceeded the maximum number allowed.',
                '2024': 'Catalog ID not found - The catalog ID provided does not exist or does not belong to your WhatsApp Business (WABA) account.',
                '2025': 'Catalog ID not linked to API number - The catalog ID you provided is not linked to the phone number used to send messages.',
                '2026': 'Products not found - Some products provided in your request were not found in the catalogue.',
                '2027': 'No products found - No products were found in the provided catalogue.',
                '2028': 'List of all products with failed compliance',
                '2029': 'List of some products with compliance failure',
                '2030': 'List combining invalid and non-conforming products',
                '2036': 'Invalid header structure - This error is returned when the ',
                '2050': 'Missing compliance information',
                '2060': 'Template rejected - Template status is ',
                '2061': 'Model paused - Model status is',
                '2062': 'Template disabled - Template status is',
                '2064': 'Invalid Stream ID - The stream with specified ID does not exist, does not belong to your WhatsApp Business account, or is in an invalid state.',
                '2068': 'Stream blocked - The stream is in blocked state.',
                '2069': 'Limited flow - The flow is in the limited state, and 10 messages using this flow have already been sent in the last hour.',
                ///CLOUD API META ERROS https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes
                ///Authorization errors
                '0': 'AuthException - It was not possible to authenticate the user of the app.',
                '3': 'API Method - Indicates a problem involving resources or permissions.',
                '10': 'Permission denied - The permission was not granted or removed.',
                '190': 'The access token expired.',
                '200': 'Permissão da API - A permissão was not granted or removed.',
                '299': 'Permissão da API - A permissão was not granted or removed.',
                ///Limitation errors
                '4': 'The application limits the API call rate. - O app atingiu o limite da taxa de chamadas de API.',
                '80007': 'As soon as WhatsApp Business reaches the volume limit. - Upon WhatsApp Business atingiu or volume limit.',
                '130429': 'The Nuvem API message data transfer rate was failed. - The Nuvem API message data transfer rate was disabled.',
                '131048': 'Messages have not been sent due to a shipping limit that may be affected by this phone number. It is possible that many previous messages have been blocked or marked as spam. - You have not sent messages due to a shipping limit that may be affected by this phone number. It is possible that many previous messages have been blocked or marked as spam.',
                '131056': "Foram sent many messages from the sender's telephone number to the same recipient's telephone number in a short period. - Foram sent many messages from the sender's telephone number to the same recipient's telephone number in a short period.",
                '133016': 'I have registered or been excluded from false registration because there have been many attempts at this telephone number in a short period of time. - You register or are excluded from false registration because there are many attempts at this telephone number in a short period of time.',
                ///Integrity errors
                '368': 'Temporarily blocked due to policy violations - As a result, WhatsApp Business associated with the app was restricted or disabled for violating a platform policy.',
                '131031': 'Account blocked - The WhatsApp Business account associated with the app was restricted or disabled for violating a platform policy. So, it was not possible to verify the data included in the application in relation to the set of data in the WhatsApp Business account (for example, the pin of two stages included in the application is incorrect).',
                ///Other errors
                '1': 'There is an invalid request or a possible server error. - There is an invalid request or a possible server error.',
                '2': 'There is a temporary error due to inactivity or overload. - There is a temporary error due to inactivity or overload.',
                '33': 'The business telephone number was excluded. - The business telephone number was excluded.',
                '100': 'The order included one or more parameters that were incompatible or written incorrectly. - The order included one or more parameters that were incompatible or written incorrectly.',
                '130472': 'The message was not sent as part of an experiment.',
                '131000': 'The message has failed to be sent due to an unknown error. - Failed to send a message due to an unknown error.',
                '131005': 'The permission was not granted or removed. - Permissão was not granted or removed.',
                '131008': 'An unrequested mandatory parameter is missing. - An unrequested mandatory parameter is missing.',
                '131009': 'One or more parameter values ​​are invalid. - Some or more parameter values ​​are invalid.',
                '131016': 'Our service is temporarily unavailable. - A service is temporarily unavailable.',
                '131021': 'The telephone number of the recipient and the sender is the same. - The telephone number of the recipient and the sender is the same.',
                '131026': "The message could not be delivered. The reasons may be as follows: - The recipient's phone number is not registered with WhatsApp. / There was an attempt to send an authentication template to a WhatsApp user with the country calling code +91 (India). Currently, it is not possible to send authentication templates to WhatsApp users in India. / The recipient has not accepted the new Terms of Service and the new Privacy Policy. / The recipient is using an old version of WhatsApp / The message was not delivered to create a high-quality user experience.",
                '131042': 'There is an error related to the form of payment. - Ocorreu an error related to the form of payment.',
                '131045': 'You may have failed to send a message due to a phone number registration error. - You may notice an error in sending a message due to a phone number registration error.',
                '131047': "More than 24 hours will pass since the recipient last responded to the sender's number. - More than 24 hours will pass since the recipient last responded to the sender's number.",
                '131049': 'Meta has chosen not to deliver the message in order to maintain healthy ecosystem engagement. - If you receive this error code, do not immediately attempt to send the message again if you suspect the issue is related to the limit. Instead, try again in larger time increments until the message is delivered, as the limit may be in effect for different periods of time. See Marketing Template Message Limits Per User for more information.',
                '131050': 'The message could not be delivered. The recipient has stopped receiving marketing messages from your business on WhatsApp. - Do not attempt to send messages again, as they will not be received by this user.',
                '131051': 'The message type is not compatible. - The type of message is not compatible.',
                '131052': 'It was not possible to download the message sent to the user. - It was not possible to download the information sent to the user.',
                '131053': 'The media could not be loaded for one of the following reasons: Type not accepted, Media too large (Image: 5MB, Video/Audio: 16MB, Documents: 100MB).',
                '131057': 'The commercial account is in maintenance mode. - The commercial account is in maintenance mode.',
                '132000': 'The number of variable parameter values ​​included in the request does not correspond to the number of variable parameters defined in the model. - The number of variable parameter values ​​included in the request does not correspond to the number of variable parameters defined in the model.',
                '132001': 'The model does not exist or the language specified or was not approved. - The model does not exist, the language specified or it has not been approved.',
                '132005': 'The translated text is too long. - The translated text is too long.',
                '132007': 'The content of the model violates a WhatsApp policy. - The content of the model violates a WhatsApp policy.',
                '132012': 'The parameter values ​​vary due to incorrect formats. - Parameter values ​​vary due to incorrect formats.',
                '132015': 'The model was paused by - The model was paused by ',
                '132016': 'The model was paused many times - The model was paused many times ',
                '132018': 'The text parameter cannot contain line breaks, tabs, or more than 4 consecutive spaces.',
                '132068': 'The stream is not in a blocked state. - Or fluxo is not in a blocked state.',
                '132069': 'The flow is not limited, and 10 messages using this flow have been sent in the last hour. - The flow is not limited, and 10 messages using this flow have been sent in the last hour.',
                '133000': 'A previous attempt to cancel the Falhou registration. - A previous attempt to cancel the false registration.',
                '133004': 'The server is temporarily unavailable. - The server is temporarily unavailable.',
                '133005': 'The confirmation PIN in both stages is incorrect. - The confirmation PIN in both stages is incorrect.',
                '133006': 'The phone number needs to be verified before registration. - The telephone number must be verified before registration.',
                '133008': 'Operate several attempts of confirmation PIN in two stages for this phone number. - Several attempts will be made to confirm the PIN in two stages for this phone number.',
                '133009': 'The confirmation PIN in both stages was inserted very quickly. - The confirmation PIN in both stages was inserted very quickly.',
                '133010': 'The phone number is not registered on the WhatsApp Business Platform. - The phone number is not registered on the WhatsApp Business Platform.',
                '133015': 'The phone number you are trying to register was recently excluded, and the exclusion has not yet been concluded. - The phone number you are trying to register was recently excluded, and the exclusion has not yet been concluded.',
                '135000': 'Failed to send message due to an unknown error on the META server. Please contact suporte@globalbot.com.br',
              },
              internalError: 'Internal Error',
              sentDesc: 'Total number of recipients who had the message delivered by Globalbot to the WhatsApp server.',
              processing:'Processed',
              processingDesc: 'Total number of recipients who have or are having the message processed by Globalbot to the WhatsApp server.',
              pending: 'Pendings',
              pendingDesc: 'Total recipients who have not yet received the message(WhatsApp left these messages in the queue).',
              notSent: 'Not sent',
              totalEmails: 'Total emails actually sent, excluding invalid email addresses discarded by the email trigger service.',
              handedOut: 'Handed out',
              handedOutDesc: 'Total number of recipients who had the message delivered by WhatsApp to customer devices.',
              handedOutDesc2: 'Percentage referring to the total number sent.',
              receivedTheEmail: 'Total recipients who received the email, discounting those that bounced. The percentage is about the number of emails sent.',
              softBounce: 'Soft Bounce',
              totalEmailsNotHandedTemporary: 'Total emails that were not delivered for temporary reasons such as: recipient\'s inbox full or recipient\'s offline server. The email provider will try to resend the message during the next 72h. The percentage is about the number of emails sent.',
              hardBounce: 'Hard Bounce',
              totalEmailsNotHandedPermanent: 'Total e-mails that were not delivered for permanent reasons, such as: non-existent e-mails or blocking by the recipient\'s e-mail server, considering it to be spam. The percentage is about the number of emails sent.',
              engagement: 'Engagement',
              openings: 'Openings',
              totalUniqueEmailOpenings: 'Total unique email opens. The percentage is about the number of emails delivered.',
              clicks: 'Clicks',
              totalClickUnique: 'Total unique clicks on email links. The percentage is about the number of emails opened.',
              markedSpam: 'Marked as spam',
              totalMarkedSpam: 'Total users who marked this email as Spam. The percentage is about the number of emails delivered.',
              unsubscriptions: 'Unsubscribes',
              totalUnsubscriptions: 'Total users who unsubscribed from the email sent. The percentage is about the number of emails delivered.',
              totalRecipientsSent: 'Total recipients with a message actually sent, discounting recipients discarded for containing invalid or non-existent numbers.',
              totalRecipientsSms: 'Total de destinatários que tiveram a mensagem entregue pelas operadoras de SMS.',
              totalRecipientsNotSend: 'Total recipients who could not deliver the message for permanent reasons, such as: containing an invalid or non-existent number.',
              waiting: 'Waiting',
              numberOfRecipientsWaiting: 'Number of recipients still waiting for the submission process to complete.',
              handedOutServer: 'Delivered (Server)',
              totalRecipientsFromGlobalbotToWhatsapp: 'Total recipients who had the message delivered by Globalbot to the WhatsApp server.',
              handedOutDevice: 'Delivered (Device)',
              totalRecipientsFromWhatsappToClients: 'Total recipients who had the message delivered by WhatsApp to customer devices.',
              totalRecipientsNotHandedTemporary: 'Total recipients whose messages were not delivered for temporary reasons, such as: recipient is in open chat session. The system will try to resend the message during the next 24h. The percentage is about the number of recipients sent.',
              preview: 'Preview',
              totalRecipientsViewedMessage: 'Total recipients who actually viewed the message.',
              important: 'Important:',
              messageImportantOne: ' You must import a list in .CSV file format, remembering that for sending SMS and',
              messageImportantTwo: 'WhatsApp field "phone" (phone) is required',
              /// Shown when the bot has BSUID sending enabled
              /// (integrations.whatsapp.bsuid.sendByBsuid).
              messageImportantTwoBsuid: 'WhatsApp: provide the "phone" column or "bsuid" — at least one per row.',
              messageImportantThree: 'For email submissions the "email" field is required.',
              messageImportantFour: 'For WhatsApp submissions the phone number must have the user\'s ID, for example: 554899999999 (Brazil)',
              messageImportantFourBsuid: 'For WhatsApp submissions the phone number must have the user\'s ID, for example: 554899999999 (Brazil). When using "bsuid", provide the full identifier, for example: IN.1648738043044942',
              totalFound: 'We found a total of ',
              finish: 'Finish',
              finishEdit: 'Finish Editing',
              finishEditQuestion: 'What do you want to do?',
              items: ' items.',
              import: 'Import',
              modelSelectedNotHaveChannel: 'The selected template does not have a channel, please create a new template again.',
              modelSelectedNotMessageValid: 'The selected model does not have a valid message, please check the message of this model.',
              notIncludeDomain: 'Do not include the domain in the "sender" and "reply to" fields, these fields are selected through the authorized domains!',
              weNeedDomain: 'Unfortunately we need an authorized domain to continue, you can authenticate one in preferences.',
              fieldsNeedFilledOne: 'The field name, sender, reply to, and lists or filters must be filled in!',
              selectServer: 'Please select a server, if not, request one with Globalbot!',
              fieldsNeedFilledTwo: 'The name field and lists or filters need to be filled in!',
              dispatchSaved: 'Your submission has been saved!',
              draftSaved: 'Your draft has been saved!',
              messageErrorConnection: 'Oops, there was a connection error!',
              testDispatchProcessing: 'Your test is being processed, please wait about 1 minute.',
              columnEmailRequired: 'The "email" columns is required.',
              columnPhoneRequired: 'The "phone" columns is required.',
              columnPhoneOrBsuidRequired: 'The "phone" or "bsuid" column is required for this channel.',
              bsuidLabel: 'Customer BSUID',
              contact: 'Contact',
              messageError: 'Oops, there was an error.',
              listSaved: 'Your list has been saved!',
              exportData: 'Do you really want to export all your records?',
              hasConversation: 'Conversation',
              hasConversationTooltip: 'Check if a conversation was generated from this WhatsApp send',
              emailInvalid: 'Invalid email. Please check the email and try again.',
              requiredField: 'Required field.'
            },
            list: {
              title: 'Title *',
              toggleLabel: 'Change label',
              filter: 'Filter *',
              save: 'Save',
              messageError: 'Oops, some error occurred.',
              listSaved: 'Your list has been saved!',
              messageErrorConnection: 'Oops, there was a connection error',
              fieldsRequired: 'Campaign, subject and source email fields need to be filled in!'
            }
          },
          conversation: {
            save: 'Save',
            cancel: 'Cancel',
            saveSuccess: 'Changes saved!',
            saveError: 'Error saving changes.',
            conversationData: 'Conversation Data',
            sections: {
              conversationData: 'Conversation Data',
              kanbanBoards: 'Kanban Boards',
              identifiersAndFields: 'Identifiers and Fields'
            },
            summary: {
              title: 'Conversation Summary',
              newBadge: 'New',
              disclaimer: 'The summary is automatically generated by Artificial Intelligence and may contain inaccuracies. We recommend checking the conversation history when necessary.',
              generate: 'Generate Summary',
              generating: 'Generating summary. Long conversations may take a few seconds.',
              refresh: 'Update Summary',
              generatedAt: 'Generated on {date}',
              loadError: 'Unable to load the conversation summary.',
              generateFailed: 'Unable to generate the summary.',
              noMessages: 'This conversation has no messages to summarize yet.',
              notFound: 'Conversation not found.',
              timeout: 'The summary is taking longer than expected.',
              supportCode: 'Support code: {errorId}',
              retry: 'Try again',
              availableIn: 'Available in {time}',
              originNotAllowed: 'Summaries can only be generated from the panel, in the browser.'
            },
            protocol: 'Protocol',
            identifierId: 'Identifier',
            session: 'Session',
            hasAttachments: 'Has attachments',
            attendants: 'Attendants',
            tags: 'Tags',
            device: 'Device',
            dispatchEmail: 'Lead email sent',
            dispatchEmailToClient: 'Email sent to customer',
            emailViewedByClient: 'Email viewed by the customer',
            dateAndHour: 'Date and Hour',
            channel: 'Channel',
            satisfaction: 'Satisfaction',
            punctuation: 'Punctuation',
            whatsappPhone: 'WhatsApp Phone',
            search: 'Search',
            location: 'Location',
            origin: 'Origin',
            campaigns: 'Campaigns',
            messageSent: 'Message sent:',
            comments: 'Comments',
            messageNotFound: 'Unfortunately we didn\'t find this conversation.',
            messageTryAgain: 'Oops, we had a problem retrieving this conversation, please try again. If the error persists, please contact us.',
            metaCampaigns: 'META Campaign Data',
            openMedia: 'Open media',
            accessConversation: 'Access conversation',
            phoneUnavailable: 'Phone unavailable: contact identified by BSUID (Meta).',
            clickToWhatsAppClientId: 'ClickToWhatsApp Client ID'
          },
          integration: {
            save: 'Save',
            cancel: 'Cancel',
            integrationDetails: 'Integration details',
            activeIntegration: 'Active integration',
            identifier: 'Identifier',
            hash: 'Hash',
            token: 'Token',
            hasToken: 'Has API token',
            webhook: 'Webhook',
            host: 'Host',
            key: 'Key',
            haveRestriction: 'Do you have restrictions?',
            contactPurpose: 'Put below the values for the "Contact Purpose" button that you don\'t want to go to VistaSoft',
            add: 'Add',
            customIdFields: 'Define below the ids of the custom fields and their identifiers, example %NAME%.',
            idField: 'Field id ',
            websiteAddress: 'Website address',
            userProvidedByKSI: 'User provided by KSI',
            passwordProvidedByKSI: 'Password provided by KSI',
            salesFlow: 'Sales flow',
            salesFlowValue: 'What is the identifier that has the sale value in the flow?',
            salesValue: 'Sale identifier value',
            createIdSales: 'Create a default sale property id and put it here',
            rentalFlow: 'Rent flow',
            rentalFlowValue: 'What is the identifier that has the rental value in the flow?',
            rentalValue: 'Rental identifier value',
            createIdRental: 'Create a default rental property id and enter it here',
            releasesFlow: 'Posting flow',
            releasesFlowValue: 'What identifier has the launch value in the stream?',
            releasesValue: 'Posting identifier value',
            createIdSalesInReleases: 'Create a default sale property id and place release',
            endpoint: 'Endpoint',
            enterprises: 'Enterprise',
            sendToAttendant: 'Send to attendant',
            includeInternalMessages: 'Include internal messages',
            enterpriseId: 'Enterprise ID',
            subdomain: 'Subdomain',
            clientSecret: 'Client_Secret',
            clientId: 'Client_Id',
            code: 'Code',
            user: 'User',
            password: 'Password',
            project: 'Project',
            problemType: 'Problem type',
            customField: 'Custom Field',
            customFieldValue: 'Custom Field Value',
            title: 'Title (optional)',
            sendOnlyLivechat: 'Send conversations from live chat only',
            loadLink: 'Cargo link',
            savedPreferences: 'Preference saved successfully',
            responsible: 'Responsible(Id)',
            createdBy: 'Created by(Id)',
            businessPhaseId: 'Business phase(Id)',
            salerCode: 'Saler code',
            methodologyCode: 'Methodology Code',
            salesChannelCode: 'Sales Channel Code',
            baseURL: 'URL base. ex: https://your-development-store.myshopify.com',
            integrationTriggers: 'Integration Triggers',
            integrationTriggersDescription: 'Define when the integration will be triggered (POST).',
            integrationTriggerFinish: 'When the conversation ends (by the chatbot or agent)',
            integrationTriggerAttendant: 'When the agent takes over the conversation',
            integrationTriggerNote: 'The integration will depend on the rules defined in the target system. If more than one option is selected, the integration will be triggered more than once. Therefore, to avoid duplicate records, the target system must handle this information.',
            pipedriveReferral: {
              title: 'Ad attribution (Click to WhatsApp)',
              description: 'When a conversation starts from a Facebook or Instagram ad with the "Send message on WhatsApp" button, Globalbot receives that ad data. Here you define which Pipedrive deal custom field each value is written to.',
              instructions: 'On each row, pick the Pipedrive deal field on the left and the Globalbot value written into it on the right. Only text custom fields created in your Pipedrive account are listed. The field is only filled when the value exists in the conversation.',
              loadFields: 'Load Pipedrive fields',
              loadFieldsTooltip: 'Loads the text custom fields using the token entered above.',
              loadFieldsTokenRequired: 'Enter the Pipedrive token above to load the fields.',
              beforeFetch: 'Click "Load Pipedrive fields" to load the text custom fields from your account.',
              dealField: 'Deal field (Pipedrive)',
              globalbotValue: 'Globalbot value',
              addRow: 'Add mapping',
              addRowDisabled: 'Every available text custom field has already been mapped.',
              removeRow: 'Remove mapping',
              emptyFields: 'No text custom field was found in this account. In Pipedrive, go to Settings > Data fields > Deal, create a Text field and load the fields again.',
              errorInvalidToken: 'Pipedrive could not be reached with this token. Check the token entered above and try again.',
              errorRateLimited: 'Too many requests in a row. Wait a minute and try again.',
              errorGeneric: 'The Pipedrive fields could not be loaded right now. Please try again in a few moments.',
              fieldMissingSuffix: '(not found in Pipedrive)',
              fieldMissing: 'This field no longer exists in Pipedrive. Pick another field or remove the mapping.',
              values: {
                headline: 'Ad headline',
                body: 'Ad body',
                sourceType: 'Ad source type',
                sourceId: 'Ad ID',
                sourceUrl: 'Ad URL',
                mediaType: 'Ad media type',
                mediaUrl: 'Ad media URL',
                imageUrl: 'Ad image URL',
                videoUrl: 'Ad video URL',
                thumbnailUrl: 'Ad thumbnail URL',
                ctwaClid: 'Click to WhatsApp click ID (ctwa_clid)',
                total: 'Total ads in the conversation'
              }
            },
            eventWebhook: {
              title: 'Event webhook',
              intro: 'Globalbot will call the URL below for each selected event, with an HMAC-SHA256 signed body (X-Globalbot-Signature header). Your endpoint must respond 2xx.',
              active: 'Webhook enabled',
              name: 'Name (for your reference)',
              url: 'Endpoint URL (https)',
              urlHint: 'https only. Redirects are not followed.',
              events: 'Events you want to receive',
              eventLabels: {
                'message.status.enqueued': 'Message enqueued',
                'message.status.sent': 'Message sent',
                'message.status.delivered': 'Message delivered',
                'message.status.read': 'Message read',
                'message.status.failed': 'Delivery failed',
                'message.status.deleted': 'Message deleted'
              },
              eventsRequired: 'Select at least one event.',
              notifyTitle: 'Who to notify if the webhook gets disabled',
              notifyUsers: 'Account users',
              notifyEmails: 'Other e-mails',
              notifyEmailsHint: 'Type and press Enter. With nobody selected, account admins are notified.',
              invalidEmail: 'Invalid e-mail',
              terms: 'I declare I have a legal basis to receive this data (which may include the contact phone and identifier) at the given endpoint, and that I am responsible for its security.',
              termsRequired: 'You must accept the statement above to enable the webhook.',
              secretTitle: 'Signing secret',
              secretCurrent: 'Current secret',
              secretNone: 'The secret is generated on first save.',
              secretShownOnce: 'Copy it now: for security, the secret will not be shown again. If lost, generate a new one.',
              copy: 'Copy',
              copied: 'Copied',
              rotate: 'Generate new secret',
              rotateConfirm: 'Generating a new secret invalidates the current one immediately: your endpoint will reject signatures until you update it there. Continue?',
              test: 'Send test event',
              testHint: 'Sends a message.status.delivered event flagged as test (test: true) to the saved URL.',
              testOk: 'Your endpoint responded {status} in {ms} ms.',
              testFail: 'Failed: {detail}',
              testBlocked: 'URL rejected by our protection: {detail}. Use a public https address.',
              testSaveFirst: 'Save the configuration before testing.',
              health: { active: 'Active', failing: 'Failing', disabled: 'Disabled automatically', inactive: 'Turned off' },
              healthLastError: 'Last error',
              healthLastDelivery: 'Last delivery',
              healthFailures: 'Consecutive failures',
              propagation: 'Changes take up to 2 minutes to apply on all servers.',
              reactivated: 'Webhook re-enabled. The failure counter was reset; events missed while disabled are not resent.',
              saved: 'Webhook saved.',
              atLeastOnce: 'Deliveries may repeat: use the deliveryId field to discard duplicates.',
              permissionDenied: 'Only account administrators can configure the event webhook.',
              loadError: 'Could not load the webhook configuration.',
              removedUser: 'Removed user',
              fieldErrors: {
                required: 'Required field.',
                'too-long': 'Value too long.',
                malformed: 'Invalid URL.',
                'not-https': 'The URL must start with https://.',
                'credentials-in-url': 'The URL cannot contain a username and password.',
                'local-host': 'Use a public address; local hosts are not accepted.',
                'at-least-one': 'Select at least one event.',
                'not-an-array': 'Invalid event list.',
                'invalid-email': 'There is an invalid e-mail in the list.',
                'invalid-id': 'There is an invalid user in the list.',
                'not-in-account': 'There is a user that does not belong to this account.',
                'too-many': 'Too many recipients.',
                'required-to-activate': 'To enable, you must accept the statement.',
                generic: 'Invalid value.'
              },
              testReasons: {
                'test-unavailable': 'test delivery temporarily unavailable',
                'no-whatsapp': 'this bot has no WhatsApp integration',
                'bot-not-found': 'bot not found',
                'subscription-not-found': 'configuration not found; save before testing',
                'endpoint-error': 'your endpoint did not respond 2xx',
                'internal-error': 'internal error while sending the test',
                generic: 'the test event could not be sent'
              }
            },
          },
          knowledge: {
            close: 'Close',
            cancel: 'Cancel',
            answered: 'Answered',
            unambiguous: 'Unambiguous',
            unanswered: 'Unanswered',
            outContext: 'Out of context',
            channel: 'Channel',
            date: 'Data',
            question: 'Question',
            media: 'Media',
            response: 'Response',
            testEnvironment: 'Test Environment',
            mode: 'Mode',
            test: 'Test',
            public: 'Public'
          },
          liveAttendants: {
            close: 'Close',
            attendants: 'Attendants',
            avatar: 'Avatar',
            attendance: 'Active conversations',
            name: 'Name',
            departments: 'Departments',
            role: 'Role',
            away: 'Away',
            clear: 'Clear',
            offline: 'Offline',
            rooms: 'Rooms',
            actions: 'Actions'
          },
          connectedUsers: {
            close: 'Close',
            users: 'Connected users',
            avatar: 'Avatar',
            attendance: 'Active conversations',
            name: 'Name',
            departments: 'Departments',
            role: 'Role',
            away: 'Away',
            clear: 'Clear',
            offline: 'Offline',
            rooms: 'Rooms',
            actions: 'Actions'
          },
          liveConfig: {
            save: 'Save',
            cancel: 'Cancel',
            settings: 'Settings',
            soundNewAttendance: 'New attendance sound',
            messageSoundReceived: 'Incoming message sound',
            listOrdering: 'List ordering',
            ascendingArrivalDate: 'Ascending arrival date',
            descendingArrivalDate: 'Descending arrival date',
            lastMessageCrescent: 'Last ascending message',
            lastMessageDecreasing: 'Last descending message',
            crescentGroup: 'By crescent group',
            decreasingGroup: 'By decrescent group',
            amountMessageCrescent: 'Increasing amount of message',
            amountMessageDecreasing: 'Descending message quantity',
            activeTimer: 'Enable Stopwatch',
            totalTimeOfAttendant: 'Total attendance time',
            lastClientInteraction: 'Last customer interaction counter',
            exhibitionAlertTime: 'Alert notice limit',
            minutes: 'minutes',
            alertTimeAttendance: 'Service exceeding limit'
          },
          notifications: {
            notifications: 'Notification Center',
            noNotifications: 'There are no notifications for you at this time.',
            HSM_TEST: {
              label: {
                error: "Failure",
                delivered: "Success!"
              },
              title: {
                error: "HSM Test Sending",
                delivered: "HSM Test Sending"
              },
              message: {
                error: "Failure in sending the HSM test, it was not delivered to the user.",
                delivered: "The HSM test was successfully sent and delivered to the user."
              }
            }
          }
        },
        dashboard: {
          connectedUsers: 'Users Connected',
          connectedUsersTip: 'Check the users who are connected to the Globalbot platform at this moment.'
        },
        editable: {
          carousel: {
            idealResolution: 'Ideal resolution',
            librarySearch: 'Search the library',
            key: 'Key',
            value: 'Value',
            jump: 'Jump',
            title: 'Title',
            description: 'Description',
            select: 'Select',
            image: 'Image',
            buttons: 'Buttons'
          }
        },
        emailBuilder: {
          add: {
            campaigns: 'Messaging ',
            addEmail: ' Add e-mail',
            subject: 'Subject *',
            sender: 'Sender *',
            replyTo: 'Reply to',
            tags: 'Tags',
            save: 'Save',
            attendanceRealized: 'Attendance Realized',
            attendanceProtocol: 'Attendance Protocol',
            historic: 'Historic',
            templateSaved: 'Your template has been saved!',
            messageErrorConnection: 'Oops, there was a connection error!',
            fieldsRequired: 'The fields campaign, subject and email of origin must be filled in!'
          },
          emailBuilder: {
            messageEmailSaved: 'Saved email messages',
            subject: 'Subject: ',
            addNewTemplate: 'Add new template'
          }
        },
        lists: {
          push: {
            insertList: 'Insert in the list',
            list: 'List',
            cancel: 'Cancel',
            insert: 'Insert',
            updatedList: 'Updated list!',
            failedUpdateList: 'Failed to update list!'
          }
        },
        live: {
          container: {
            message: {
              replied: {
                you: 'You',
                video: 'Video',
                audio: 'Audio',
                loading: 'Loading replied message...',
                unavailable: 'Replied message unavailable',
                outOfHistory: 'Load more messages to jump to it',
              },
              cards: {
                startConversation: 'Start Conversation',
                insertList: 'Insert in the list'
              },
              media: {
                speechToText: 'Speech to Text (audio to text transcription)',
                notSupport: 'Your browser is not supported, please use Chrome.',
                notRegistered: 'Not registered',
                openOriginalImage: 'Open original image',
                downloadVideo: 'Download video',
                downloadError: 'Could not download the file. Please try again.'
              },
              yesterday: 'Yesterday',
              today: 'Today',
              hsmYesterday: 'HSM sent yesterday',
              hsmToday: 'HSM sent today',
              hsmSent: 'HSM sent',
              userNotFound: 'User not found',
              status: {
                noSubmitted: 'Unsent message (click to try again)',
                sending: 'Sendind message',
                sended: 'Message sent',
                delivered: 'Message delivered',
                read: 'Message read',
                fail: 'Message fail'
              },
              openInNewTab: 'Open in new tab',
              networkRequired: 'You must be logged in to send the message again.',
              queuePositionFail: 'The message could not be sent because the user\'s last interaction was more than 24 hours ago.',
              systemMessageSuppressed: 'Message not sent to the customer: disabled in Settings › Live Chat › Messages. Recorded for auditing only.',
              systemMessageSuppressedByFlowNode: 'Message not sent to the customer: persistence disabled in this flow node ({step}). Recorded for audit only.',
              persistenceFirstNotice: '1st notice',
              persistenceSecondNotice: '2nd notice',
              serviceMessageBilling: 'Service Message: This message is categorized as Service by Meta (WhatsApp). These messages will start being charged individually on October 1, 2026. Meta WhatsApp Credits must be added to the platform to keep the operation running.',
              balanceBlocked: {
                ariaLabelMessage: 'Message not sent: insufficient credit balance',
                ariaLabelConversation: 'Conversation with a message not sent due to insufficient credit balance',
                messageBefore: 'This WhatsApp message could not be sent because your credit balance is insufficient. Please add credits in',
                conversationBefore: 'A WhatsApp message in this conversation could not be sent because your credit balance is insufficient. Please add credits in',
                after: 'to resume sending messages. (Under Meta\'s new rules, in effect since October 1, 2026.)',
                /// conta mini-globalbot não tem o menu Preferências > Consumo WhatsApp
                miniMessage: 'This WhatsApp message could not be sent because your credit balance is insufficient. Please contact the support team to add credits and resume sending messages. (Under Meta\'s new rules, in effect since October 1, 2026.)',
                miniConversation: 'A WhatsApp message in this conversation could not be sent because your credit balance is insufficient. Please contact the support team to add credits and resume sending messages. (Under Meta\'s new rules, in effect since October 1, 2026.)'
              }
            },
            conversation: {
              identifierId: 'Identifier',
              protocol: 'Protocol',
              tags: 'Tags',
              changeName: 'Change Name',
              device: 'Device',
              dispatchEmailLead: 'Lead email sent',
              dispatchEmailClient: 'Email sent to customer',
              emailViewedClient: 'Email viewed by the customer',
              dateAndTime: 'Date and time',
              channel: 'Channel',
              satisfaction: 'Satisfaction',
              punctuation: 'Punctuation',
              search: 'Search',
              location: 'Location',
              origin: 'Origin'
            },
            knowledge: {
              reply: 'Answer',
              copyReply: 'Copy answer',
              messageErrorKnowledge: 'Error querying knowledge bases',
              messageErrorConsult: 'Error querying questions.'
            }
          },
          footer: {
            actions: {
              annex: {
                sendImage: 'Upload image! (5 MB max size)',
                sendVideo: 'Upload video! (16 MB max size)',
                sendFile: 'Send file! (100 MB max size)',
                selectLibrary: 'Select from the library!',
                library: 'Library',
                preview: 'Preview',
                addLegend: 'Add legend',
                pdfLimitExceeded: 'The file size is greater than the maximum allowed. (100 MB)',
                imageLimitExceeded: 'The image size is greater than the maximum allowed. (5 MB)',
                videoLimitExceeded: 'The video size is greater than the maximum allowed. (16 MB)',
                audioLimitExceeded: 'The audio size is greater than the maximum allowed. (16 MB)',
                cancel: 'Cancel',
                send: 'Send',
                file: 'File',
                avatar: 'Avatar',
                maxFileSize: 'The maximum file size is 20MB.',
                errorProcessingDoc: 'Error processing document.',
                fileFormatNotAccepted: 'File format not supported!'
              },
              audio: {
                recordAudio: 'Record audio (maximum 2 minutes)',
                cancel: 'Cancel',
                send: 'Send',
                preview: 'Preview',
                addLegend: 'Add legend',
                sendText: 'Send text',
                sendAudio: 'Send audio',
                errorProcessingAudio: 'Error processing audio.',
                accessMicrophoneRequired: 'For the live chat to work fully, it is necessary to allow access to the microphone.',
                transcribe: 'Audio transcription'
              },
              quickResponse: {
                quickResponse: 'Quick response',
                add: 'Add',
                close: 'Close',
                unshare: 'Unshare',
                removeShare: 'Remove link to this response',
                reply: 'Reply',
                share: 'Share',
                exclude: 'Delete',
                createQuickResponse: 'Add quick response',
                title: 'Title',
                message: 'Message',
                cancel: 'Cancel',
                errorConsultQuickResponse: 'Error looking up quick response.',
                errorRegisterQuickResponse: 'Error registering quick response.',
                errorExcludeQuickResponse: 'Error exclude quick response.',
                errorShareQuickResponse: 'Error share quick response.',
                excludeQuickResponse: 'Delete Quick Reply',
                youSureExclude: 'Are you sure you want to delete this reply?',
                removeShareQuickResponse: 'Remove link',
                youSureRemoveShare: 'Are you sure you want to remove the link from this quick response?',
                remove: 'Remove',
                requiredField: 'Required field',
              }
            }
          },
          utils: {
            attendants: {
              attendant: 'Attendant',
              attendants: 'Attendants',
              avatar: 'Avatar',
              name: 'Name',
              role: 'Role',
              select: 'Select',
              searchAttendant: 'Search attendant',
              noSearchResults: 'No results found',
              actions: 'Actions'
            },
            departments: {
              department: 'Department',
              attendants: 'Attendants',
              noSearchResults: 'No results found'
            },
            roomOptions: {
              endAttendance: 'Finish attendance',
              archiveAttendance: 'Archive attendance',
              reactivateNotifications: 'Reactivate notifications',
              muteNotifications: 'Silence notifications',
              unpinAttendance: 'Unpin attendance',
              fixedAttendance: 'Fix attedance',
              transferAttendance: 'Transfer attendance',
              transferAttendanceSelected: 'Transfer selected',
              endAttendanceSelected: 'Finish selected',
              transferRestrictedAttendanceSelected: 'Transfer selected (only for Manager and Administrator)',
              archiveAttendanceSelected: 'Archive selected'
            }
          },
          createGroup: {
            newGroup: 'New group',
            newConversation: 'New conversation'
          },
          createHsm: {
            department: 'Department',
            departmentRequired: 'Please select a department.',
            numberBlocked: 'This number is blocked on this chatbot. Sending is still available, but messages from the customer will not reach the service while the block is active.',
            numberBlockedUnlockAt: 'Unblocking is done in',
            numberBlockedContinue: 'To send anyway, continue to choose the template.',
            numberBlockedLookupFailed: 'Could not check whether this number is blocked.',
            numberBlockedChecking: 'Checking the number...',
            limitCharactersExceeded: 'Character limit exceeded!',
            credits: 'Credits',
            creditsDescription: 'To send messages to customers who are inactive on WhatsApp (24 hours after the last message sent by the customer) it is necessary to use a Message Template (HSM) pre-approved by WhatsApp. This shipment consumes 1 platform credit.',
            creditsInsufficient: 'Unfortunately you don\'t have enough credits.',
            attention: 'Attention:',
            attentionDescription: ' After 24 hours of customer inactivity, the company can only send a standardized and pre-approved message by WhatsApp, known as HSM. Each HSM message consumes 01 credit on the platform, as they can be charged by WhatsApp.',
            requestCredits: 'Request more credits',
            whoToSendMessage: 'Who do you want to send the message to?',
            originNumber: 'Origin number *',
            nameClient: 'Customer\'s Whatsapp Name *',
            country: 'Country *',
            nameClientWhatsapp: 'Client number *',
            attentionNinthNumber: ' Enter the customer\'s mobile number with a 2-digit area code, for example: (XX) XXXXX-XXXX. Messages will only be sent to customers who have an active WhatsApp account.\n',
            messageYouCanNot: 'Oops! You will not be able to send message to',
            messageActiveConversationWith: 'because he is already in an ACTIVE conversation with ',
            messageActiveConversationAttendants: 'because he is already in an ACTIVE conversation with another server.',
            messageConversationWithYou: 'is already in conversation with you! Send messages through the chat room.',
            goToRoom: 'Go to room',
            messageTemplate: 'Message Template (HSM)',
            notAuthorized: 'Oops! You will not be able to send a message to this person as he/she has not authorized the receipt of messages (Opt-In) according to WhatsApp policies.',
            messageUserOptIn: 'For your company to send a message to the customer (while outside the chat session), this customer must necessarily be an OPT-IN user (that is, he has given consent to receive messages). Learn more about Opt-In.',
            messageSent: 'Message sent!',
            return: 'Return',
            advance: 'Advance',
            missingMessage: 'Missing message',
            notPossibleStartConversation: 'It was not possible to start the chat as the user is already chatting with the chatbot.',
            numberNotValid: 'Oops! The number entered is not a valid WhatsApp account! Check the number and try again. Remember, do not inform the DDI',
            identifierPhone: 'Phone',
            identifierBsuid: 'BSUID',
            bsuidLabel: 'Contact BSUID *',
            bsuidHint: 'Meta identifier, in the CC.digits format — for example IN.1648738043044942.',
            bsuidNotValid: 'Oops! The BSUID entered is not valid. The expected format is CC.digits, for example IN.1648738043044942.',
            bsuidCopied: 'BSUID copied',
            bsuidCopyHint: 'Click to copy the full BSUID',
            nameNotValid: 'Please enter the customer\'s name.',
            requiredMessage: 'Oops! You need to fill in the message to be sent!',
            satisfactionSurvey: 'is answering the satisfaction survey.',
            optout: 'opted out of receiving messages from your company on',
            livechatQueue: 'is in the service queue.',
            chatbot: 'is chatting with the chatbot.',
            pdfLimitExceeded: 'PDF must be a maximum of 100MB.',
            imageLimitExceeded: 'Image must be a maximum of 5MB.',
            videoLimitExceeded: 'Video must be a maximum of 16MB.',
          },
          pushGroup: {
            add: 'Add',
            attendantAdded: 'Added attendant!',
            alreadyInGroup: 'This attendant is already in the group!'
          },
        },
        micro: {
          cdt: {
            yesterday: 'Yesterday',
            today: 'Today'
          },
          cdtWithHours: {
            yesterday: 'Yesterday',
            today: 'Today',
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday'
          }
        },
        modals: {
          feedback: {
            newFunctions: 'Help us develop new features for the dashboard!',
            help: 'Let\'s help improve our dashboard?',
            info: 'This feedback is for improvement only, if you want to report a technical issue please contact support.',
            nowYouCan: 'Now you can help improve our platform!',
            feedbackWillBeApplied: 'This is the page where feedback will be applied.',
            whatCanBeImproved: 'Tell us what can be improved on this page?',
            example: 'Ex: This page could have an information button.',
            send: 'Send',
            feedbackSentError: 'There was an error sending the feedback',
            feedbackSentSuccessfully: 'Feedback sent successfully!',
            requireFields: 'You need to fill in the fields.',
            contactSupport: 'An error has occurred, please contact support',
            feedbackExcludeError: 'There was an error deleting feedback!',
            feedbackExcludeSuccessfully: 'Feedback successfully deleted!'
          },
          image: {
            image: 'Image'
          },
          recharge: {
            requestCredits: 'Request Credits',
            requestCreditsDescriptionMini: 'You can request additional credits for use in Globalbot.',
            requestCreditsDescriptionMini2: 'Choose one of the options below and our team will contact you.',
            requestCreditsDescription: 'You can request additional credits for use in the Messaging. <span style="color: #ff6600;">Values according to your contracted plan.</span>',
            requestCreditsDescriptionCopilot: 'You can request additional credits for use in the Copilot. Please enter the details below and one of our specialists will contact you.',
            requestCreditsDescription2: 'Choose one of the options below and we will contact you as soon as possible.',
            whatsapp: 'WhatsApp Packages*',
            copilot: 'Copilot*',
            type: 'Type *',
            value: 'Amount *',
            cancel: 'Cancel',
            request: 'Request',
            messageFailedRequestCredits: 'Oops, failed request credits.',
            creditsRequested: 'Credits requested',
            fieldsRequired: 'You need to fill in the fields.',
            mostPopular: 'most popular',
            single: 'single',
            credits: 'credits',
            monthly: 'monthly',
            important: '* The acquired credits are valid for 6 months.',
            smsAndEmail: 'SMS and Email',
            consult: 'Consult',
          },
          upgrade: {
            meetGlobalbot: 'Meet the complete version of Globalbot!',
            additionalFeaturesDescription: 'More than 100 additional features for your company to sell more and provide better service on WhatsApp and other chat channels, including:',
            additionalFeatures: 'Live chat, marketing campaigns, integrations, automations, analytical reports and much more!',
            wantToMeetDescription: 'Click now on <strong>Want to Know</strong> More and one of our professionals will contact you to schedule a demonstration!',
            wantToMeet: 'Want to Know More',
            cancel: 'Cancel',
            requestCompleted: 'Request completed!',
            requestError: 'Request failed, please try again.'
          }
        },
        tags: {
          removeTag: 'Remove tag',
          addTags: 'Add tag',
          labelTag: 'Search tag',
          tagAlreadyExistsInConversation: 'This tag already exists in the conversation.',
          categoryNotFound: 'Category not found, check the mini Tags component.',
          manageTags: 'Manage Tags'
        },
        departments: {
          searchDepartment: 'Search department',
          manageDepartments: 'Manage Departments',
          noDepartments: 'No department found.'
        },
        exporter: {
          mountingReport: 'Assembling report...',
          exportToCsv: 'Export to CSV',
          type: 'Type',
          answered: 'Answered',
          response: 'Response',
          disambiguated: 'Disambiguated',
          notResponse: 'Unanswered',
          active: 'Active',
          inactive: 'Inactive',
          reportGeneratedSuccessfully: 'Report generated successfully.',
          messageFailedReport: 'Oops, reporting failed, try again.'
        },
        loading: {
          connectingToServer: 'Connecting to server...',
          assemblingTheInformation: 'Assembling the information...'
        },
        zendesk: {
          title: 'Zendesk',
          brands: 'Brands',
          forms: 'Forms',
          fields: 'Tags',
          group: 'Groups',
        }
      },
      layouts: {
        default: {
          messageErrorInfo: 'Oops, some error happened while saving the information.',
          tolerancePeriod: 'Tolerance Period',
          finishedJourneyDescription: 'Your workday is over, but you have entered the grace period.',
          timeLeft: 'Finish your work in the remaining time of',
          disconnectedFromThePlatform: 'After the end of the grace period you will be disconnected from the platform.',
          iKnow: 'I know',
          finishedJourney: 'Finished Journey',
          workingEnded: 'Your working day has ended.',
          freeTime: 'Enjoy your free time!',
          seeYouLater: 'See you later',
          lostConnection: 'Connection Lost',
          whatsappBalanceBlocked: {
            title: 'WhatsApp balance depleted',
            description: 'Sending WhatsApp messages is paused. Add credits to resume.',
            descriptionNoPermission: 'Sending WhatsApp messages is paused. Contact your account administrator to add credits.',
            action: 'Add credits',
            close: 'Dismiss notice'
          }
        }
      },
      pages: {
        actions: {
          create: {
            addAction: 'Add action',
            title: 'Title',
            description: 'Description',
            request: 'Request',
            getAndPost: 'GET, POST',
            newAction: 'New action',
            newActionDescription: 'New action description'
          },
          list: {
            actions: 'Actions',
            addAction: 'Add action'
          }
        },
        advanced: {
          emailUnsubscribes: {
            title: 'Email unsubscribes',
            description: 'Supermaster console. "Global suppression": emails that receive no campaign from any customer. "Groups by domain": unsubscribed emails of each domain, from any account. Removing or releasing requires a reason and is logged.',
            tabGlobal: 'Global suppression',
            tabGroups: 'Groups by domain',
            email: 'Email',
            created: 'Unsubscribed at',
            actions: 'Actions',
            remove: 'Remove from global',
            removeTitle: 'Remove email from the global suppression',
            removeDescription: 'The email will receive emails from every client again. This action is audited with the reason.',
            removed: 'Email removed from the global suppression.',
            loadMore: 'Load more',
            page: 'Page',
            previousPage: 'Previous page',
            nextPage: 'Next page',
            empty: 'No emails in the global suppression.',
            searchGroups: 'Search by domain or account id',
            account: 'Account',
            unsubscribed: 'Unsubscribed',
            openGroup: 'View emails',
            groupsEmpty: 'No groups found.',
            back: 'Back',
            checkEmail: 'Check email',
            checkEmailHint: 'The provider has no text search: enter the full email address.',
            check: 'Check',
            invalidEmail: 'Enter a valid email address.',
            checkSuppressed: 'This email is in the global suppression.',
            checkNotSuppressed: 'This email is not in the global suppression.',
            tabBlackList: 'Blocks and releases',
            blackListDescription: 'Local history of unsubscribed (blocked) and released emails, with the release reason, across all accounts.',
            searchBlackList: 'Search by email or account id',
            filterStatus: 'Status',
            filterScope: 'Scope',
            all: 'All',
            scopeGlobal: 'Global',
            scopeGroup: 'Domain group',
            domain: 'Domain',
            lastSource: 'Source',
            blackListEmpty: 'No records found.',
            sources: {
              webhook: 'Unsubscribed by the recipient',
              panel: 'Account administrator',
              supermaster: 'Supermaster',
              'global-reset-script': 'Global suppression reset'
            }
          },
          copilot: {
            assistant: 'Writing Assistant',
            main: 'Main',
            cdt: 'Date/Time',
            account: 'Account',
            user: 'User',
            type: 'Copilot Type',
            question: 'Query',
            response: 'Response',
            rowsPerPage: 'Rows per page:'
          },
          logs: {
            list: {
              addLog: 'Add log',
              version: 'Version',
              change: 'Change',
              visibility: 'Visibility',
              description: 'Description',
              cancel: 'Cancel',
              add: 'Add',
              update: 'Update',
              removedColumn: 'Removed category column for unusability',
              deprecateModal: 'Deprecated observation mode.',
              updateVisualsAndProgrammatic: 'Visual and programmatic updates.'
            }
          },
          conversation: {
            conversationDetails: 'Conversation details',
            search: 'Search',
            account: 'Account',
            attendants: 'Attendants',
            device: 'Device',
            desktop: 'Desktop',
            mobile: 'Mobile',
            chrome: 'Chrome',
            safari: 'Safari',
            mozilla: 'Mozilla Firefox',
            edge: 'Edge',
            explorer: 'Internet Explorer',
            whatsapp: 'Whatsapp',
            facebook: 'Facebook Messenger',
            dispatchEmail: 'Lead email sent',
            dispatchEmailToClient: 'Email sent to customer',
            viewedEmailByClient: 'Email viewed by the customer',
            dateAndHour: 'Date and time',
            channel: 'Channel',
            origin: 'Origin',
            messageNotFoundConversation: 'Unfortunately we didn\'t find this conversation'
          },
          edit: {
            billingCredits: 'Credits Billing',
            hsmMarketingDiscount: 'Deduct 2 credits on Marketing HSM',
            billing: {
              title: 'Billing — Service messages',
              model: 'Billing model',
              modelPerMessageBalance: 'Per-message balance',
              modelSessionCredits: 'Session credits (legacy)',
              modelPerMessageBalanceHint: 'Every delivered service message debits the account balance.',
              modelSessionCreditsHint: 'Legacy model: consumes 1 credit per conversation session, with no balance debit.',
              currency: 'Currency',
              currencyHint: 'Fixed to BRL for now.',
              gatewayCustomerId: 'Customer id at the payment provider',
              gatewayCustomerIdHint: 'Set by the backend when the account is linked to the provider.',
              gatewayNotConfigured: 'Not configured',
              unitPrice: 'Price per service message',
              unitPriceHint: 'Leave empty to apply the default price:',
              lowBalanceThreshold: 'Low balance alert threshold',
              lowBalanceThresholdHint: 'Leave empty to turn the low balance alert off.',
              alertRecipients: 'Balance alert recipients',
              alertRecipientsHint: 'Empty notifies the MASTER/ADMIN users of the account, even with additional emails.',
              alertEmails: 'Additional emails',
              alertEmailsHint: 'For people without a platform user (e.g. finance). Type and press Enter or click +. They only receive the alert email. Maximum:',
              alertEmailsMax: 'Additional email limit reached. Maximum:',
              addAlertEmail: 'Add email',
              invalidEmail: 'Enter a valid email.',
              searchUser: 'Search user',
              removedUser: 'Removed user',
              chargeNonBillable: 'Charge messages Meta did not bill',
              chargeNonBillableHint: 'Also debits messages Meta did not charge, within the monthly free tier.',
              balance: 'Current balance',
              balanceUpdatedAt: 'Updated at',
              lowBalanceAlert: 'Low balance alert',
              zeroBalanceAlert: 'Zero balance alert',
              lastNotifiedAt: 'Last notification',
              lastBalance: 'Balance at notification',
              neverNotified: 'Never notified',
              minPrice: 'Minimum:',
              priceBelowMinimum: 'Price below the allowed minimum:',
              invalidPrice: 'Enter a valid value, with up to 4 decimal places.',
              invalidThreshold: 'Enter a value greater than or equal to zero.',
              overdraftLimit: 'Overdraft limit',
              overdraftLimitHint: 'How far the balance may go negative while still sending. Empty or 0 turns it off. Maximum:',
              maxBlockedNotifications: 'Max blocked notifications',
              maxBlockedNotificationsHint: 'Notices per blocking cycle (the immediate one plus daily resends). 0 sends only the immediate one. Empty uses the default:',
              overdraftExhaustedAlert: 'Overdraft exhausted alert',
              overdraftBelowUsage: 'This limit does not cover the current negative balance: saving blocks the account, with no alert fired. Currently used:',
              addBalance: 'Add balance',
              addBalanceHint: 'Posts a manual adjustment to the account balance. It is recorded in the ledger with the note below and the user who did it.',
              adjustAmount: 'Amount to add',
              adjustNote: 'Reason for the adjustment',
              adjustNoteHint: 'Explain why the balance is being changed. Minimum characters:',
              adjustDuplicate: 'This adjustment had already been applied; the balance did not change again.',
              invalidAdjustAmount: 'Enter a value greater than zero, with up to 4 decimal places.',
              invalidAdjustNote: 'Describe the reason with at least',
              invalidAdjustNoteMax: 'The reason must have at most',
              errorInvalidAmount: 'Amount outside the limits accepted by the server.',
              errorNoteRequired: 'The balance adjustment requires a note explaining the reason.',
              errorModelNotEnabled: 'This account is not on the per-message balance model.',
              notifiedCount: 'Notices in the cycle',
              invalidOverdraftLimit: 'Enter a value greater than or equal to zero, with up to 4 decimal places.',
              invalidOverdraftLimitMax: 'Overdraft above the allowed maximum:',
              invalidMaxBlockedNotifications: 'Enter a whole number between 0 and',
              errorForbidden: 'You do not have permission to change this account billing.',
              errorAccountNotFound: 'Account not found.',
              errorValidation: 'Review the fields: some value was not accepted.'
            },
            yes: 'Yes',
            delPayment: 'Delete payment',
            paid: 'Paid',
            consumption: 'Consumption',
            status: 'Status',
            editAccount: 'Edit account',
            clientsList: 'Customer list',
            editAccountTwo: 'Edit account - ',
            credits: 'Credits',
            recurrentCredits: 'Recurring messaging franchise',
            sharedFranchise: 'Shared franchise',
            newFranchise: 'New model',
            otherChannels: 'Other channels',
            shared: 'Shared',
            add: 'Add',
            del: 'Delete',
            fa: '2FA',
            email: 'E-mail',
            active: 'Active',
            inactive: 'Inactive',
            phone: 'Phone',
            security: 'Enabled modules',
            realTime: 'Real time',
            statistics: 'Statistics',
            people: 'People',
            conversation: 'Conversations',
            interface: 'Interface',
            flow: 'Flow',
            intelligence: 'Intelligence',
            campaigns: 'Campaigns',
            liveChat: 'Live Chat',
            library: 'Library',
            preferences: 'Preferences',
            limiter: 'Users  - Limiter ',
            decraseLimit: 'Lower limit',
            increaseLimit: 'Increase limit',
            createMaster: 'Create master',
            accountDetails: 'Account details',
            accountName: 'Account name',
            addPermissions: 'Add permissions',
            addBriefing: 'Add briefing',
            companyName: 'Company name',
            fantasyName: 'Fantasy name',
            cnpj: 'CNPJ',
            address: 'Address',
            zipCode: 'Zip code',
            street: 'Street',
            edit: 'Edit',
            contacts: 'Contacts',
            plan: 'Plan and Contract',
            uploadContractLabel: 'Contract',
            contractValidityLabel: 'Contract validity',
            contractDateLabel: 'Contract date',
            seeDocument: 'See document',
            successUpdate: 'Client updated!',
            errorUpdate: 'Error updating client!',
            type: 'Type',
            characteristics: 'Franchise and channels',
            numberAttendances: 'Whatsapp - Monthly deductible',
            otherChannelAttendances: 'Other channels - Monthly allowance',
            whatsAppAttendances: 'Whatsapp - Monthly deductible',
            emailAttendances: 'E-mail - Monthly deductible',
            smsAttendances: 'SMS - Monthly deductible',
            webchat: 'Webchat',
            facebook: 'Facebook',
            whatsapp: 'Whatsapp',
            whatsappFranchise: 'Whatsapp Franchise',
            sms: 'SMS',
            integration: 'Integration',
            observations: 'Comments',
            none: 'None',
            simple: 'Simple',
            intermediate: 'Intermediary',
            advanced: 'Advanced',
            payments: 'Payments',
            form: 'Form',
            setup: 'Setup',
            description: 'Description',
            valueReal: 'Value: R$ ',
            date: 'Date',
            monthlyPayment: 'Monthly payment',
            cronogram: 'Schedule',
            planning: 'Planning',
            initialDate: 'Initial date',
            implementation: 'Implementation',
            endDate: 'End date',
            observation: 'Observation',
            customerSuccess: 'Customer Success',
            chatbots: 'Chatbots',
            online: 'Online',
            offline: 'Offline',
            versioning: 'Versioning',
            old: 'OLD',
            stable: 'STABLE',
            beta: 'BETA',
            alpha: 'ALPHA',
            editAddress: 'Edit address',
            number: 'Number',
            district: 'Neighborhood',
            city: 'City',
            state: 'State',
            cancel: 'Cancel',
            save: 'Save',
            addContact: 'Add contact',
            delContact: 'Delete contact',
            editContact: 'Edit contact',
            role: 'Role',
            name: 'Name',
            projectManager: 'Project manager',
            title: 'Title',
            addImplementationCronogram: 'Add implementation schedule',
            addCronogramByCs: 'Add CS schedule',
            addCronogramByPlanning: 'Add planning schedule',
            addRateBySetup: 'Adicionar taxa de SETUP',
            value: 'Valor',
            values: 'Values',
            ongoing: 'OnGoing',
            onboarding: 'OnBoarding',
            csStage: 'CS Stage',
            currentStatus: 'Current Status',
            accountStatusOnline: 'Online',
            accountStatusPartialOnline: 'Partial online',
            accountStatusPaused: 'Paused',
            accountStatusChurn: 'Churn',
            flag: 'Flag',
            addRateMonthly: 'Add monthly fee',
            newUser: 'Add user',
            password: 'Password',
            addCredits: 'Add credits',
            veryLow: 'Very low',
            low: 'Low',
            medium: 'Medium',
            high: 'High',
            veryHigh: 'Very high',
            important: 'IMPORTANT',
            starter: 'G-Starter',
            professional: 'G-Profissional',
            enterprise: 'G-Enterprise',
            gAdvanced: 'G-Advanced',
            orion: 'G-Orion',
            planLite: 'Lite',
            planStarter: 'Starter',
            planProfessional: 'Professional',
            planAdvanced: 'Advanced',
            planEnterprise: 'Enterprise',
            planGlobal: 'Global',
            planLite22: 'LITE-22',
            planStarter22: 'STARTER-22',
            planProfessional22: 'PROFESSIONAL-22',
            planAdvanced22: 'ADVANCED-22',
            planEnterprise22: 'ENTERPRISE-22',
            planLite23: 'LITE-23',
            planStarter23: 'STARTER-23',
            planProfessional23: 'PROFESSIONAL-23',
            planEnterprise23: 'ENTERPRISE-23',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
            genAi: 'Generative AI',
            instagram: 'Instagram',
            crm: "CRM",
            genAiFranchise: 'Generative AI Franchise',
            genAiStandalone: 'Generative AI standalone',
            miniGlobalbot: 'Globalbot Mini'
          },
          list: {
            exportAccounts: 'Export Accounts',
            cs: 'CS Responsible',
            csStage: 'CS Stage',
            accountStatus: 'Account status',
            plan: 'Plan',
            listClients: 'Customer list',
            flagOk: 'Healthy',
            flagYellow: 'Attention',
            flagRed: 'Critical',
            flagNone: 'Not classified',
            model: 'Mod.',
            modelLetterBalance: 'B',
            modelLetterCredits: 'C',
            balance: 'Balance',
            overdraftLimit: 'Overdraft',
            noOverdraft: 'No limit',
            notOnBalance: 'No monetary balance',
            usingOverdraft: 'Using overdraft',
            balanceFilter: 'Balance status',
            balanceAll: 'All',
            balanceWithBalance: 'With balance',
            balanceZero: 'Zero balance',
            balanceUsingOverdraft: 'Using overdraft',
            balanceWithOverdraft: 'With overdraft',
            refreshList: 'Refresh list',
            createNewAccount: 'Create new account',
            wantToCreateNewAccount: 'Want to create a new account? Click here :)',
            version: 'Version',
            stable: 'Stable',
            beta: 'Beta',
            alpha: 'Alpha',
            old: 'Old',
            updateNewVersion: 'Upgrade to new version',
            edit: 'Edit',
            exclude: 'Delete',
            addAccount: 'Add account',
            companyName: 'Company name',
            steps: 'Now follow these steps',
            open: 'Open the',
            spreadsheetClients: 'customer spreadsheet',
            insertEmail: 'Put this email',
            insertPassword: 'Beside, enter the desired password for the account, it needs to be a very secure password.',
            insertPasswordAndAdd: 'Enter the password entered in the spreadsheet in the field below and click Add.',
            passwordMaster: 'Master password',
            cancel: 'Cancel',
            add: 'Add',
            excludeAccount: 'Delete account',
            sureExcludeAccount: 'Are you sure you want to delete this account?',
            allConversationsAndChatbotsDeleted: 'All conversations and all chatbots will be deleted.',
            updateVersionToStable: 'Update version to Stable',
            beAware: 'Before proceeding, be aware that',
            thisChangesVersionPanel: 'This is an action that will change the client\'s dashboard version.',
            losesAllAttendance: 'This option will cause the customer to lose all current calls from Old, and he will no longer have access, only through the Conversations tab.',
            beforeToClick: 'Before clicking on update, check if you already have departments created by accessing https://panel.globalbot.ai in the customer\'s account (if you already have, delete it as it may interfere with the migration).',
            createNewDepartment: 'This action will create new departments (with the same names) and assign them in the flows and in the users, so for security you cannot be editing users or the flow when updating.',
            switchToStableVersion: 'Switch to Stable Version',
            name: 'Name',
            actions: 'Actions',
            jan: 'Jan.',
            feb: 'Feb.',
            mar: 'Mar.',
            apr: 'Apr.',
            may: 'May.',
            jun: 'Jun.',
            jul: 'Jul',
            aug: 'Aug.',
            sep: 'Sep.',
            oct: 'Oct.',
            nov: 'Nov.',
            dec: 'Dec.',
            migratedAccountSuccess: 'Account has been migrated successfully!',
            errorHasOccurred: 'Ocorreu um erro, contate um desenvolvedor urgente!',
            normalStatus: 'Normal',
            endingStatus: 'Ending',
            exceededStatus: 'Exceeded',
            columnFranchise: 'Consumption of the franchise'
          },
          server: {
            serversWhatsapp: 'WhatsApp Servers',
            updateGit: 'Update Git',
            requestUpdateGit: 'Request git update on all servers.',
            update: 'Update',
            servers: 'Servers',
            serversDescription: 'Add new server.',
            add: 'Add',
            numbering: 'Numbering',
            version: 'Version',
            responsible: 'Responsible',
            whatsapp: 'Whatsapp',
            indifferent: 'Indifferent',
            normal: 'Normal',
            business: 'Business',
            chip: 'Chip',
            client: 'Client',
            globalbot: 'Globalbot',
            server: 'Server',
            instanceType: 'Instance type',
            ip: 'IP',
            account: 'Account',
            chatbot: 'Chatbot',
            info: 'Info',
            actions: 'Actions',
            running: 'Running!',
            serverAvailable: 'Server available',
            serverDown: 'Service down, wait manager.',
            qrCode: 'QR Code',
            gitPull: 'Git Pull',
            restartServer: 'Restart server',
            edit: 'Edit',
            excludePairing: 'Delete pairing',
            save: 'Save',
            cancel: 'Cancel',
            serverData: 'Server data',
            instanceId: 'ID da Instância',
            serverName: 'Server name',
            sureRestartServer: 'Are you sure you want to restart this server? This may take a few minutes.',
            restart: 'Restart',
            exclude: 'Delete',
            sureExcludePairing: 'Are you sure you want to delete pairing from this server? You will have to read the QR Code again.',
            cellphone: 'Cell phone',
            manager: 'Manager',
            isBusiness: 'is Business',
            isChipResponsible: 'is Chip Responsible',
            messageError: 'Error, see console!',
            routeNotFound: 'Route not found, server ',
            serverAddedSuccessfully: 'Server added successfully!',
            pairingDeleted: 'Pairing successfully deleted!'
          },
          tasks: {
            tasks: 'Tasks | ',
            newTask: 'New task',
            plan: 'Plan',
            status: 'Status',
            notStarted: 'Not started',
            ready: 'Ready',
            stoppedGlobalbot: 'Stopped Globalbot',
            stoppedClient: 'Stopped Cliente',
            date: 'Date',
            invalidDate: 'Invalid date',
            noDate: 'No date',
            description: 'Description',
            notDescription: 'Not description',
            advancedSettings: 'Advanced settings',
            do: 'Do',
            go: 'Go',
            learn: 'Learn',
            editTask: 'Edit task',
            selectUsers: 'Select users',
            selectAccount: 'Select account',
            selectBot: 'Select bot',
            selectType: 'Select type',
            title: 'Title',
            selectStatus: 'Select status',
            done: 'Done'
          },
          users: {
            listUsers: 'List users',
            user: 'User',
            name: 'Name',
            email: 'Email',
            role: 'Role',
            newPassword: 'New password',
            avatar: 'Avatar',
            permission: 'Permission',
            done: 'Done',
            supreme: 'Supreme',
            master: 'Master',
            administrator: 'Administrator',
            manager: 'Manager',
            attendant: 'Attendant',
            junior: 'Junior',
            messageErrorInfo: 'Oops, some error happened while saving the information.',
            messageErrorUser: 'Oops, some error happened while saving the user.',
            supremeCommander: 'Supreme Commander'
          }
        },
        analytics: {
          attendant: {
            attendant: {
              indicatorsByAttendants: 'Indicators by attendants',
              attendantsByTime: 'Attendances by time of day',
              chatbotsAndAttendants: 'Chatbots x Attendants',
              departments: 'Departments',
              attendants: 'Attendants',
              statistics: 'Statistics',
              exportAttendants: 'Export attendants'
            }
          },
          channels: {
            channels: {
              indicatorsByChannels: 'Indicators by Channels',
              attendantsByTime: 'Attendances by time of day',
              chatbotsAndAttendants: 'Chatbots x Attendants',
              channelOverview: 'Overview by Channel',
              statistics: 'Statistics'
            }
          },
          flow: {
            flow: {
              flowAnalysis: 'Flow Analysis',
              statistics: 'Statistics'
            }
          },
          identifiers: {
            identifiers: {
              customIdentifiers: 'Custom Identifiers',
              statistics: 'Statistics',
              seeMore: 'See More',
              quantity: 'Quantity',
              identifier: 'Identifier'
            }
          },
          knowledge: {
            knowledge: {
              intelligencePerformance: 'Intelligence Performance',
              conventionalIA: 'Conventional AI',
              conventionalIADescription: 'Standardized responses. Interprets the users intention and presents registered responses (text, video, images, documents and links).',
              generativeIA: 'Generative AI',
              generativeIADescription: '',
              knowledgeBase: 'Knowledge Base',
              commonQuestions: 'Common questions',
              advanced: 'Advanced',
              artificialIntelligence: 'Intelligence',
              statistics: 'Statistics'
            },
            responses: {
              response: 'Response'
            }
          },
          location: {
            location: {
              countries: 'Countries',
              states: 'States',
              cities: 'Cities',
              geolocationAdvanced: 'Advance',
              geolocation: 'Geolocation',
              statistics: 'Statistics',
              search: 'Search'
            }
          },
          origin: {
            origin: {
              platformAndBrowsers: 'Platform and Browsers',
              campaign: 'Campaigns',
              originAttendance: 'Attendances origin',
              statistics: 'Statistics',
              url: 'Uniform Resource Locator'
            }
          },
          cards: {
            attendance: 'Attendances',
            descriptionAttendance: 'Total volume of calls (all channels) for the selected period.<br/>The comparison is relative to the immediately preceding period.',
            leads: 'Leads',
            descriptionLeads: 'Total Leads captured in the selected period. Leads are conversations where users filled in at least the email or phone number',
            satisfaction: 'Satisfaction',
            descriptionSatisfaction: 'Satisfaction rate related to the User Satisfaction<br/> Survey in the selected period. The comparison is relative<br/>to the immediately preceding period. This indicator is visible<br/>only when Satisfaction Survey is enabled in the router Preferences > Chatbot > Behavior',
            descriptionSatisfactionMini: 'Satisfaction rate related to the User Satisfaction<br/> Survey in the selected period. The comparison is relative<br/>to the immediately preceding period.',
            intelligence: 'Intelligence',
            descriptionIntelligenceOne: 'Success rate of the Artificial Intelligence(s) of the selected chatbots <br>and period. For Conventional AI, it is the sum<br> of the Answered Questions and Disambiguated Questions.<br> For Generative AI, only the Answered Questions are considered, as <br> there is no disambiguation.<br> The comparison is relative to the immediately previous period.',
            descriptionIntelligenceMini: 'Response rate of Generative Artificial Intelligence, which were answered according to the provided content. The comparison is relative to the immediately previous period.',
            connected: 'Connected',
            descriptionConnected: 'Total users (collaborators) currently connected<br/>to the Globalbot Platform. It refers to<br/>individuals using the platform (such as<br/>administrators, managers or attendants), not<br/>referring to the number of customers in attendance.',
            beta: 'BETA',
            descriptionBeta: 'The feature identified as BETA is under development<br/>and testing by the Globalbot team. Wait for news<br/>regarding the evolution of this feature.',
            viewByChannel: 'Vision by Channel',
            descriptionViewByChannel: 'Check out the main service indicators by channel, quantitative and qualitative.',
            attendants: 'Attendants',
            descriptionAttendants: 'See the performance indicators of the attendants individually and collectively.',
            descriptionIntelligenceTwo: 'Analyze the performance of Artificial Intelligence, including answered, unambiguous and unanswered questions.',
            geolocation: 'Geolocation',
            descriptionGeolocation: 'Check from which locations the attendances are arriving, by country, state and city.',
            origin: 'Origin',
            descriptionOrigin: 'Analyze the origin of calls, considering the sources of traffic, for example, digital campaigns.',
            flowAnalysis: 'Flow Analysis',
            descriptionFlowAnalysis: 'See how users interact with conversational flows, considering engagement and abandonment.',
            customized: 'Custom',
            descriptionCustomized: 'Check out the metrics of your custom identifiers that are part of conversational flows.',
            statistics: 'Statistics',
            tooltipStatistics: 'Doubts in Statistics? Click here and access the Tutorial that our team prepared. We have a lot of news!',
            totalValue: 'Total Value',
            totalValueDescription: 'Check the total value generated by conversations during the period (very useful for those who sell products and services). To appear here, the value must be assigned to each conversation individually.'
          }
        },
        block: {
          create: {
            add: 'Add',
            blocks: 'Blocks',
            welcome: 'Welcome',
            addButton: 'Add button',
            create: 'create',
            title: 'Title',
            description: 'Description',
            message: 'Message',
            name: 'Name',
            firstName: 'First name',
            lastName: 'Last name',
            buttons: 'Buttons',
            button: 'Button',
            email: 'E-mail',
            phone: 'Phone',
            cpf: 'CPF',
            cnpj: 'CNPJ',
            birthDate: 'Birth date',
            calendar: 'Calendar',
            number: 'Number',
            checkbox: 'Checkbox',
            slider: 'Slider',
            image: 'Image',
            intelligence: 'Intelligence',
            liveChat: 'Live chat',
            zipCode: 'Zip code',
            city: 'City',
            state: 'State',
            country: 'Country',
            carousel: 'Carosel',
            guideScreen: 'Guide screen',
            money: 'Money mask',
            exit: 'Finish'
          },
          index: {
            blocks: 'Blocks',
            listblock: 'block list',
            new: 'New',
            index: 'index'
          }
        },
        bots: {
          bots: {
            testChatbot: 'Test Chatbot',
            editFlow: 'Edit flow',
            viewer: 'Viewer',
            lite: 'Lite',
            pro: 'Pro',
            editor: 'Editor',
            settingsAccess: 'Access Settings',
            createNewChatbot: 'New Chatbot',
            createNewChatbotDesc: 'Create a new chatbot, edit the conversational flow, define the parameters and carry out tests.',
            installation: 'Installation',
            titleChatbot: 'Chatbot title',
            nameAttendant: 'Attendant name',
            descriptionChatbot: 'Description',
            fieldRequired: 'Required field',
            cancel: 'Cancel',
            create: 'Create',
            createSuccessfully: 'Chatbot successfully created!',
            createError: 'Error creating chatbot',
            hello: 'Hi. Can I help you?',
            contactGlobalbot: 'Contact Globalbot',
            subject: 'subject',
            content: 'content',
            indication: 'Your friend has a referral',
            thanks: 'Hi{name}, thank you very much for your interest in ',
            introduction: 'With Globalbot your company will offer an experience of dialog with your audiences in the most diverse situations. This experience is fantastic, especially on mobile devices (cell phones and tablets), as people are already used to using messaging apps such as Facebook, Whatsapp and many others.',
            listing: 'I have also listed here some possible applications of ',
            inCompany: ' in your company:',
            leadGeneration: 'Lead Generation:',
            leadGenerationDescription: ' Use to retain the website visitor through dialogue and generate leads for sales teams, integrating with sales force tools or triggering an email.',
            marketingAndSales: 'Marketing and Sales:',
            marketingAndSalesDescription: ' Carry out marketing campaigns and actions focused on sales, presenting a dialogue that leads the customer to engage with the product and its characteristics.',
            search: 'Search:',
            searchDescription: ' Transform extensive opinion and satisfaction surveys into friendly dialogues, avoiding boredom and dispersion.',
            attendance: 'Customer service:',
            attendanceDescription: ' Perform customer service services, based on the most frequent questions and thus eliminate service positions and/or reduce waiting lines.',
            schedulingAndReservations: 'Scheduling and Reservations:',
            schedulingAndReservationsDescription: ' Use to make appointments and reservations (offices, dealerships, restaurants, events and many others) integrating internal systems.',
            databaseAndCrm: 'Database and CRM qualification:',
            databaseAndCrmDescription: ' it can serve as an interface to access information available in databases, allowing the qualification of databases through dialogue.',
            teachingAndLearning: 'Teaching and learning:',
            teachingAndLearningDescription: ' Use for teaching and learning actions, using content from classes for students, being able to talk about specific subjects of the various subjects of the courses.',
            furthermore: 'In addition the ',
            dispatchDescription: ' can send email, SMS, display image, audio, video files and more!',
            surpriseAudience: 'Surprise your audience with this new experience!',
            regards: 'Regards,',
            telmaAyala: 'Telma Ayala',
            virtualAssistant: 'Virtual Assistant',
            address: ' Av. Cristovão Colombo, 3000 / salas 802 e 304 / Floresta Porto Alegre - RS - CEP 90560-002 ',
            moreInformations: 'More information',
            oneMessage: 'Are you still around?',
            twoMessage: 'If you don\'t answer I\'ll have to finish the attendance.',
            threeMessage: 'Alright, if you need help again let me know!',
            closeMessage: 'The attendance was closed by the attendant, we appreciate your contact and if you have any further questions, just call me again.',
            chatbots: 'Chatbots',
            viewGrid: 'Grid',
            viewList: 'List',
            statusActive: 'Active',
            statusInactive: 'Inactive',
            botName: 'Chatbot Name',
            botDescription: 'Description',
            botAuthor: 'Author',
            botUpdatedAt: 'Last Updated',
            changeDescription: 'Edit description',
            updateDescriptionSuccess: 'Description updated!',
            channels: 'Channels',
            integrations: 'Integrations',
            integrationsActive: 'Integrations active',
            channelWebchat: 'WebChat',
            channelDomains: 'domain(s) configured',
            channelWhatsappCopy: 'Click to copy the number',
            channelWhatsappCopied: 'Number copied!',
            searchBotName: 'Search chatbot...',
            filterAll: 'All',
            filterStatus: 'Status',
            filterChannels: 'Channel',
            filterChannelsSelected: 'channel(s)',
            actions: 'Actions',
            filterGroups: 'Filter by group',
            noData: 'No chatbots here.',
            editChatbot: 'Edit Chatbot',
            flowEditor: 'Flow editing',
            createChatbot: 'New Chatbot',
            save: 'Save',
            updateSuccess: 'Chatbot updated!',
            updateError: 'Error updating chatbot'
          },
          groups: {
            allBots: 'All bots',
            manageGroups: 'Manage Groups',
            createGroup: 'Create Group',
            editGroup: 'Edit Group',
            deleteGroup: 'Delete Group',
            groupName: 'Group',
            selectBots: 'Select bots',
            selectBotsHint: 'Select at least one bot for the group',
            searchBots: 'Search bot',
            noBots: 'No bot found',
            botsSelected: 'bots selected',
            noGroups: 'No groups created yet',
            botsInGroup: 'bots',
            groupSingular: 'group',
            groupPlural: 'groups',
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            confirmDelete: 'Delete this group?',
            groupSaved: 'Group saved successfully!',
            groupDeleted: 'Group deleted successfully!',
            errorLoad: 'Error loading groups',
            errorSave: 'Error saving group',
            errorDelete: 'Error deleting group',
            createdAt: 'Creation date'
          }
        },
        broadcast: {
          broadcast: {
            campaigns: 'Campaigns',
            processing: 'Processing...',
            sending: 'Sending: ',
            of: ' of ',
            messageCreate: 'Create message',
            messageType: 'Message type',
            messageSave: 'SMS messages/Whatsapp saved',
            email: 'Email',
            messageTitle: 'Message title',
            confirmation: 'Confirmation',
            saveNewMessageWithName: 'Save new message with name ',
            save: 'Save',
            cancel: 'Cancel',
            messageText: 'Message text',
            next: 'Next',
            recipients: 'Recipients',
            importNewList: 'Import new list',
            myLists: 'My lists',
            listJson: 'Json List',
            send: 'Send',
            sendNow: 'Send now',
            scheduleShipping: 'Schedule shipping',
            submit: 'Send',
            importList: 'Import list',
            import: 'Import',
            saveList: 'Save list',
            listTitle: 'List title',
            totalRecipients: 'Total recipients',
            recipientsToLowerCase: ' recipients',
            importedList: 'Imported list',
            messageSaveList: 'Your list has been saved!',
            messageOpsError: 'Oops, some error occurred.',
            allMessagesWereSent: 'All messages have been sent.',
            messageNotCreditsSms: 'Oops, looks like SMS credits are missing. Please contact us.',
            allMessagesWereScheduled: 'All messages have been scheduled.',
            failedToConnect: 'Failed to connect to broadcast service, please reload the page.',
            messageNotCreditsWhatsapp: 'Oops, looks like WhatsApp credits are missing. Please contact us.',
            messageWereSent: 'Were sent ',
            messageOfTheTotal: ' of the total of ',
            chargedMessages: ' messages. Only sent messages will be charged.',
            gupshupTemplateImport: "Import template HSM"
          },
          broadcast2: {
            templateSyncronizedFailed: 'Oops, there was an error synchronizing the templates. Please try again.',
            templateSyncronized: 'Request for template synchronization sent successfully!, wait a few moments for the templates to be synchronized.',
            templateSyncronizedSuccess: 'Templates synchronized successfully',
            email: 'E-mail',
            communicate: 'Communicate through email marketing or transactional email.',
            createModel: 'Create template',
            sms: 'SMS',
            sendNotificationsSms: 'Send notifications and notices via text messages (SMS).',
            whatsapp: 'WhatsApp',
            instance: 'Instance',
            bot: 'Bot',
            sendNotificationsWhatsapp: 'Send promotional messages, notifications, and surveys via WhatsApp.',
            requestCredits: 'Request Credits',
            requestCreditsMessaging: 'Request additional credits for use in the campaigns.',
            models: 'Models',
            modelNotCreated: 'You haven\'t created any models yet. Start by choosing which type of template you want to create.',
            modelHsm: 'HSM (High Structured Message) message model used for sending pre-approved messages through WhatsApp Business API.',
            tipTemplateQualityWarning: 'WARNING: This template is at risk of being blocked due to high reporting rates and negative user feedback. Avoid using it.',
            tipTemplateQualityBlocked: 'BLOCKED: This template is under security blocking by Globalbot because it has reached critical levels of reporting rates and negative user feedback. This blocking is necessary to avoid blocking (total ban) of the number used on WhatsApp. Use another template.',
            tipCategoryMarketing: 'Template Marketing: This message is categorized as Marketing by Meta (WhatsApp). Commercial use focused on promotions, sales, or engagement. NOTE: Marketing messages may be subject to delivery restrictions due to Meta experiments.',
            tipCategoryUtility: 'Template Utility: This message is categorized as Utility by Meta (WhatsApp). Transactional use focused on customer-requested updates such as order status, notifications, and others.',
            tipCategoryAuthentication: 'Template Authentication: This message is categorized as Authentication by Meta (WhatsApp). Specifically used to authenticate users and secure accounts, focusing on sending codes or tokens.',
            modelData: 'Model Data',
            messageEditor: 'Message Editor',
            preview: 'Preview',
            duplicate: 'Duplicate dispatch',
            duplicateDraft: 'Duplicate draft',
            createDispatch: 'Create dispatch',
            delivered: 'Delivered',
            device: 'Delivered',
            read: 'Read',
            error: 'Not Sent',
            open: 'Opened',
            click: 'Clicked',
            spamreport: 'Marked as spam',
            unsubscribe: 'Unsubscribed',
            notSent: 'Not Sent',
            processed: 'Processing',
            exclude: 'Delete',
            dispatches: 'Dispatches',
            dispatchesApi: 'Api',
            dispatchNotCreated: 'You haven\'t created any submissions yet. Create a submission from a message template.',
            draftNotCreated: 'You still don\'t have drafts.',
            drafts: 'Drafts',
            static: 'Static',
            recurring: 'Recurrent',
            draft: 'Draft',
            readyToSend: 'Ready to send',
            scheduled: 'Scheduled',
            processing: 'Processing',
            scheduledFor: 'Scheduled to ',
            sent: 'Sent',
            insufficientCredits: 'Insufficient credits',
            editDispatch: 'Edit dispatch',
            editDraft: 'Editar draft',
            dataDispatch: 'Dispatch data',
            statsDispach: 'Dispatch statistics',
            prepareDispatch: 'Prepare dispatch',
            modelExclude: 'Delete template',
            cancel: 'Cancel',
            areSureModelExclude: 'Are you sure you want to delete this template?',
            excludeDispatch: 'Excluir envio',
            duplicateDispatch: 'Do you want to make a copy of this dispatch?',
            areSureDispatchExclude: 'Are you sure you want to delete this dispatch?',
            dispatch: 'Dispatch',
            areSureDispatch: 'Are you sure you want to send?',
            found: 'Found',
            repeated: 'Repeated',
            removed: 'Retirados',
            range: 'Range',
            schedule: 'To schedule',
            saveDraft: 'Save as Draft',
            templateChannel: 'Channel',
            templateName: 'Name',
            templateAuthor: 'Author',
            templateEdited: 'Last update',
            templateActions: 'Actions',
            dispatchChannel: 'Channel',
            dispatchName: 'Name',
            dispatchAuthor: 'Author',
            dispatchStatus: 'Status',
            dispatchActions: 'Actions',
            templateExclude: 'Template deleted!',
            dispatchExclude: 'Dispatch deleted!',
            dispatchSuccess: 'Dispatch sent successfully! It may take up to 1 minute.',
            processingDispatch: 'The dispatch is being processed.',
            dispatchScheduled: 'Dispatch has been scheduled.',
            messageOpsNotDispatch: 'Oops, we had some problem processing the dispatch.',
            messageNotCredits: 'Unfortunately your credit balance is not enough!',
            messageOpsNotValid: 'Oops, we had some problem validating the submission.',
            messageNotFoundDispatch: 'Dispatch not found',
            messageOpsErrorDispatch: 'Oops, there was an error retrieving the submission.',
            messageOpsFailedCompileTemplate: 'Oops, failed to compile template',
            campaigns: 'Campaigns',
            doubtsInMessaging: 'Doubts? Click here and check out the interactive tour.',
            canNotDuplicateMissingTemplate: 'Template deleted, it is not possible to duplicate this submission',
            ON_BLACK_LIST_UNSUBSCRIBED: 'Recipient unsubscribed from receiving emails',
            deleted: 'Deleted',
            rejected: 'Rejected',
            disabled: 'Disabled',
            paused: 'Paused',
            pending: 'Pending',
            failed: 'Failed',
            submitted: 'Submitted',
            deactivated: 'Deactivated'
          }
        },
        conversations: {
          conversation: {
            noData: 'No conversation to show.',
            rowsPerPage: 'Records per page',
            recipients: ' recipients',
            createNewList: 'Create new list',
            excludeConversationSelected: 'Delete selected conversations',
            createListConversationSelected: 'Create list with selected conversations',
            of: 'of',
            createListConversationAll: 'Create list with all conversations',
            includeOnKanban: 'Include on Kanban',
            includeOnKanbanTitle: 'Include conversations on Board',
            selectBoard: 'Select a Board',
            selectColumn: 'Select a Stage',
            attention: 'Attention:',
            kanbanIncludeHint: 'Only conversations from the chatbot(s) and/or department(s) assigned to the destination Board will be included.',
            include: 'Include',
            kanbanIncludeSuccess: 'conversations included on Board.',
            kanbanIncludeSkipped: 'skipped (already included or out of parameters).',
            kanbanIncludeError: 'Could not include conversations on Board.',
            kanbanIncludeNoneEligible: 'No selected conversation matches the Board parameters.',
            exportConversationSelected: 'Export selected conversations',
            exportAllConversationSelected: 'Export all conversations',
            forwardConversationSelected: 'Forward selected conversations',
            forwardConversationIntegrations: 'Forward conversations in integrations',
            columns: 'Columns',
            dateAndHour: 'Date and Time',
            protocol: 'Protocol',
            chatbot: 'Chatbot',
            tags: 'Tags',
            channel: 'Channel',
            actions: 'Actions',
            attendedBy: 'Attended by',
            monetaryValue: 'Value',
            phone: 'Phone',
            satisfaction: 'Satisfaction',
            category: 'Category',
            department: 'Department',
            linkDepartment: 'Link department',
            departmentLinked: 'Department linked successfully.',
            linkDepartmentError: 'Unable to link the department.',
            transhipmentAttended: 'Attended transshipment: the attendant served the customer. Everything is OK!',
            transhipmentUserLost: 'Unattended transfer: the customer left the chat before the attendant interacted!',
            transhipmentNotYetAttended: 'Transshipment not yet attended/waiting: the attendant has not yet interacted with the customer.',
            transhipmentWaitigAttended: 'Unattended transshipment: waiting for attendant.',
            botDeleted: 'Bot deleted',
            transhipmentUnrealized: 'Transfer not carried out: No attendant online at this time. Chatbot resumed the conversation.',
            transhipmentRejected: 'transhipment rejected: attendant ended the conversation before interacting with the user',
            transhipmentFromHSMWaiting: 'Conversation started by the attendant still awaiting response from the customer (WhatsApp)',
            transhipmentFromLiveHSMOk: 'Conversation started by the attendant with response from the customer (WhatsApp). Everything ok!',
            transhipmentFromBroadcastHSMOk: 'Conversation started through mass sending of the Campaigns Module with response from the customer (WhatsApp). Everything ok!',
            transhipmentFromLiveHSMIdleFinished: 'Conversation started and ended by the attendant with no response from the customer (WhatsApp)',
            emailLeadSend: 'Lead email sent',
            nameEmailLeadSend: ', Lead email sent',
            createNewListWith: 'Create a List with the ',
            hasAttachments: 'Contains Attachments',
            session: 'Session',
            conversationSelect: ' selected conversations. Use the list created in the Messaging module to send messages via email, SMS or WhatsApp.',
            listName: 'List name',
            cancel: 'Cancel',
            save: 'Save',
            excludeConversations: 'Delete conversations',
            areSureWantToDelete: 'Are you sure you want to delete ',
            conversationsSelected: ' selected conversations?',
            exclude: 'Delete',
            reportExport: 'Report export',
            reportExportNPS: 'Report export NPS',
            willReportExport: 'You will export a report with ',
            conversationsSelectedFormatCsv: ' conversations selected in the format .CSV.',
            exported: 'Export',
            exportedXlsx: 'Export XLSX',
            exportedCsv: 'Export CSV',
            forward: 'Forward',
            youCanSend: 'You will be able to email the selected conversations to someone else.',
            internalMessage: 'Send with live chat internal messages.',
            email: 'E-mail',
            integrations: 'Integrations',
            youCanSendCrmOrTickets: 'You will be able to send the selected conversations to your CRM or ticket system',
            sendConversations: 'conversations sent',
            notSendConversations: 'conversations not sent:',
            selectIntegration: 'Select your integration',
            send: 'Send',
            all: 'All',
            primary: 'Primary',
            conversations: 'Conversations',
            messageSendEmailBut: 'Emails were sent however ',
            messageSendEmailSuccess: 'Emails sent successfully!',
            messageNotSendEmail: 'Oops, the emails weren\'t sent.',
            messageOps: 'Oops, ',
            messageNeedEmail: 'Oops, we need an email to forward!',
            messageIntegrationsSendBut: 'Integrations sent however ',
            messageIntegrationsSendSuccess: 'Integrations submitted successfully!',
            messageIntegrationsNotSend: 'Oops, the integrations weren\'t sent.',
            messageIntegrationsNotSendField: 'Oops, the integrations weren\'t sent. E-mail is required.',
            messageNeedIntegrations: 'Oops, we need an integration to ship!',
            messageSaveList: 'Your list has been saved!',
            messageListNeedName: 'Your list needs a name!',
            messageOpsError: 'Oops, some error occurred.',
            date: 'Date',
            hour: 'Hour'
          }
        },
        consumption: {
          list: {
            clientsConsumption: 'Clients consumption by usage',
          }
        },
        crm: {
          fields: {
            people: 'People',
            company: 'Company'
          },
          exportTableCrm: {
            exportReport: 'Export records',
            exportReportAll: 'Export all records.',
            exportReportSelected: 'Export selected records:',
            exportReportError: 'Error exporting records',
            exportReportSuccess: 'Records exported successfully',
            exportReportCancel: 'Cancel',
            exportReportExportXLSX: 'Export XLSX',
            exportReportExportCSV: 'Export CSV',
          },
          contact: {
            exportReportAll: 'Export all records',
            exportReportSelected: 'Export selected records',
            openArchive: 'Open file',
            openLink: 'Open link',
            openImage: 'Open image',
            noPermission: 'No permission',
            deleteSelected: 'Delete selected records',
            contactDeleted: 'Contact deleted.',
            contactFavorite: 'Contact favorited.',
            excludePeople: 'Delete people',
            excludeCompany: 'Delete companies',
            peopleSelected: 'people selected',
            companySelected: 'companies selected'
          },
          contactAdvanced: {
            customization: 'Customization',
            confirmLeaveDescription: 'You are in edit mode for this record and have not saved your changes yet. What would you like to do?',
            discardChanges: 'Discard Changes',
            keepEditing: 'Keep Editing',
            editingBy: 'This contact is being edited by ',
            editContact: 'Edit Contact',
            waitUser: 'Wait for the user to finish editing this contact.',
            save: 'Save',
            deleteContact: 'Delete Contact',
            defineAttributes: 'Define attributes for segmentation and personalization.',
            deleteContactConfirm: 'Do you really want to delete this contact?',
            none: 'none',
            byDepartment: 'by department',
            byAttendant: 'by attendant',
            emailInvalid: 'Invalid email in Section: ',
            cpfInvalid: 'Invalid CPF in Section: ',
            saveSuccess: 'Contact saved successfully!',
            editing: 'This contact is already being edited.',
            contactDeleted: 'Contact deleted.',
            lastUpdate: 'Last update: ',
            booklet: 'Booklet',
            attendant: 'Attendant',
            department: 'Department',
            create: 'Create',
          },
          import: {
            type: 'Type',
            name: 'Name',
            autor: 'Author',
            status: 'Status',
            listName: 'Imported list',
            count: 'Imported quantity'
          },
          default_sections: {
            people: {
              "people_registration_data_default": "Registration Data",
              "people_address_default": "Address",
              "people_professional_data_default": "Professional Data",
            },
            company: {
              "company_registration_data_default": "Registration Data",
              "company_address_default": "Address"
            }
          },
          default_fields: {
            people: {
              "people_name_default": "Name",
              "people_cpf_default": "CPF",
              "people_email_default": "E-mail",
              "people_phone_whatsapp_default": "Whatsapp Phone",
              "people_born_date_default": "Birth Date",
              "people_cep_default": "ZIP Code",
              "people_address_street_default": "Street",
              "people_address_number_default": "Number",
              "people_address_complement_default": "Complement",
              "people_address_neighborhood_default": "Neighborhood",
              "people_address_city_default": "City",
              "people_address_state_default": "State",
              "people_address_country_default": "Country",
              "people_company_default": "Company",
            },
            company: {
              "company_name_default": "Name",
              "company_cnpj_default": "CNPJ",
              "company_corporate_reason_default": "Corporate Name",
              "company_email_default": "E-mail",
              "company_phone_default": "Phone",
              "company_cep_default": "ZIP Code",
              "company_address_street_default": "Street",
              "company_address_number_default": "Number",
              "company_address_complement_default": "Complement",
              "company_address_neighborhood_default": "Neighborhood",
              "company_address_city_default": "City",
              "company_address_state_default": "State",
              "company_address_country_default": "Country",
            }
          }
        },
        dashboard: {
          dashboard: {
            weHaveNews: 'We have news!',
            helpCenter: 'Discover our Help Center. There are more than',
            articles: '100 articles',
            featuresPlatform: 'explaining<br/> step by step the features of our platform.',
            viewMore: 'See more!',
            welcomeMessage: 'Enjoy the newest features and functionality we\'ve prepared for you!',
            clickItem: 'Click on the items to watch the demo.',
            newLook: 'The platform in a new look.',
            highPerformance: 'Greater performance and processing.',
            talkTeam: 'Talk to your team now too.',
            attendanceChanges: 'Changes when taking over and finalizing the attendance.',
            emojisAndQuickResponse: 'Emojis, quick responses and other news.',
            commentDuringAttendance: 'Comments and notes during the attendance.',
            insights: 'Insights',
            beSurprise: 'Be surprised!',
            beSurpriseDesc: 'Watch the videos and see what\'s new on Globalbot!',
            beSurpriseStatusAndBlock: 'WhatsApp Status and Block',
            beSurpriseWhatsappButton: 'WhatsApp button with tracking',
            beSurpriseMonetaryValue: 'Assigning value to conversations',
            beSurpriseCopilotWriter: 'Writing Assistant Copilot',
            beSurpriseCopilotKnowledge: 'Knowledge Assistant Copilot',
            startHere: 'Start here',
            startHereDesc: 'See the steps to get everything ready!',
            startHereStepOne: 'Define visual aspects of the chatbot',
            startHereStepTwo: 'Configure phrases and data collection',
            startHereStepThree: 'Configure Generative Artificial Intelligence',
            startHereStepFour: 'Test chatbot',
            startHereStepFive: 'Install on your website',
            stillInDoubt: 'Still in doubt?',
            seeVideo: 'Watch the explanatory video',
            additionalFeatures: 'Additional Features',
            additionalFeaturesDesc: 'See some features of the full version of Globalbot.',
            additionalFeaturesSeeMore: 'Learn more and Upgrade!',
            multichannelFeatureDesc: 'Multiple channels for your chatbot: WhatsApp, Instagram, Website Chat, Messenger, and Telegram.',
            liveChatFeatureDesc: 'Live Chat! Transfer the conversation to your sales or customer service team.',
            campaignFeatureDesc: 'Conduct marketing campaigns via WhatsApp, SMS, and email.',
            specialistFeatureDesc: 'Support with a team of specialists and over 100 additional features.',
            remainingCredits: 'Remaining credits.',
            requestCredits: 'Request credits.',
            requestCreditsDesc: 'Your account already has 100 renewable and non-cumulative monthly credits. Each credit is consumed by 1 question + 1 chatbot response. You can request additional credits (which do not expire).',
            news: 'Update History',
            improvement: 'Suggest improvement',
            newsDesc: 'See the update history on the Globalbot platform.',
            visitBlog: 'To access all content, visit our ',
            version: 'Version',
            build: 'Build',
            termsOfUse: 'Terms of use',
            goodMorning: 'Good Morning',
            goodAfternoon: 'Good afternoon',
            goodEvening: 'Good night',
            accountData: 'Account data',
            accountDataLabel: 'Check out the contracted plan information below.',
            systemAvailability: 'System Availability',
            cardAccount: {
              plan: 'Plan',
              consumption: 'Monthly consumption',
              lineWhatsapp: 'Whatsapp',
              lineOtherChannel: 'Other channels'
            },
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
          },
          layout: {
            localization: 'Language',
            portuguese: 'Portuguese',
            english: 'English',
            spanish: 'Spanish',
            online: 'Online',
            kanban: 'Kanban Boards',
            kanbanTagNew: 'NEW',
            availableToNewAttendance: 'You will be available to receive new calls from your department.',
            away: 'Away',
            pauseNewAttendance: 'Pause. You will continue to answer your active conversations but you will not receive new calls.',
            offline: 'Offline',
            disconnectToChat: 'You will immediately disconnect from the chat. No new calls will be assigned to you.',
            myProfile: 'My profile',
            notificationCenter: 'Notification center',
            copilotAnalytics: 'Copilot Analytics',
            emailUnsubscribes: 'Email unsubscribes',
            nightMode: 'Night mode',
            exit: 'Exit',
            tasks: 'Tasks',
            clients: 'Clients',
            actions: 'Actions',
            changeLogs: 'News | Change logs',
            nps: 'Report NPS',
            serverWhatsapp: 'Whatsapp servers',
            conversationDetails: 'Conversation details',
            home: 'Home',
            statistics: 'Statistics',
            conversation: 'Conversations',
            chatBots: 'Chatbots',
            intelligence: 'Intelligence',
            campaigns: 'Campaigns',
            liveChat: 'Live chat',
            library: 'Library',
            needHelp: 'Need help? Tell us what you need and our team will help you!',
            preferences: 'Preferences',
            important: 'Important:',
            messageImportant: ' When you go into pause, you will continue to answer your active conversations but you will not receive new calls.',
            reasonPause: 'Reason of pause',
            cancel: 'Cancel',
            continue: 'Continue',
            deleteAccount: 'Delete Account',
            realyDeleteAccount: 'Do you really want to delete this account?',
            important: 'Important:',
            deleteAccountDescription: 'When deleting the account, all data will be permanently deleted and you and other users will no longer have access to the software.',
            deleteAccountSuccess: 'Account successfully deleted.',
            deleteAccontError: 'Error deleting account.',
            helpCenterTitle: 'Help Center',
            searchHelpCenter: 'Search the Help Center',
            searchHelpCenterDescription: 'Search your questions about Globalbot in our articles and materials.',
            select: 'Select',
            consultTelma: 'Consult Telma',
            virtualAssistant: 'Virtual Assistant',
            consultTelmaDescription: 'Ask questions about the Globalbot solution<br />with our virtual assistant.',
            npsGreeting: 'Hello! We would like your opinion.',
            npsRecommendationQuestion: 'From 0 to 10, how likely are you to recommend Globalbot to a friend or colleague?',
            npsNotRecommend: 'Would not recommend',
            npsHighlyRecommend: 'Would highly recommend',
            npsRatingReason: 'Tell us the reason for your score!',
            npsSend: 'Send',
            npsClose: 'Close',
            npsThanks: 'Thank you very much for your participation.',
            npsGoogleHelp: 'Help us by also leaving a rating or comment on Google, ',
            npsClickHere: 'click here.',
            npsPhone: 'If you would like to be contacted by Globalbot, please provide your phone number.',
            npsNoThanks: 'No, thanks',
            npsJump: 'Jump',
            npsWriteHere: 'Write here',
            npsCommentHere: 'Comment here before sending!',
            npsPhoneHere: 'Enter your phone number before sending!'
          }
        },
        flow: {
          editor: {
            save: 'Save',
            errorSavingInformation: 'Oops, some error happened while saving the information.',
            savedFlow: 'Flow saved'
          },
          flow: {
            flow: 'Flow',
            save: 'Save',
            addOneBalloon: 'Add 1 balloon',
            addTenBalloons: 'Add 10 balloons',
            removeLastBalloon: 'Remove last balloon',
            removeTheLastTenBalloons: 'Remove the last 10 balloons',
            test: 'Test',
            indicateBalloonLine: 'This number indicates the line the balloon is on.',
            responseField: 'Answer field',
            emptyQuestion: 'Empty question',
            clickAndEditBalloon: 'By clicking you can edit the entire balloon.',
            clickGoToLine: 'By clicking you can go to the line.',
            type: 'Type',
            indicatorName: 'Indicator of the name of the',
            balloon: 'of the balloon.',
            identifier: 'Identifier',
            responseWillAppearInConversation: 'This answer will appear in the conversations tab.',
            knowledge: 'Knowledge base',
            jumpIfNotFound: 'Jump if not found',
            ifThereNoQuestionJumpTheLine: 'If there is no question registered, it will jump to the line',
            department: 'Department',
            jumpIfNoOneOnline: 'Jump if no one is online',
            jumpIfNoAttendantOnline: 'If there is no online attendant, it will jump to the line',
            jumpingToLine: 'Jumping to the line',
            botWillGoToLine: 'The bot after going through this balloon, will go to the line',
            clickInNumberGoToLine: 'Click on the number to go to the line.',
            uniqueExternalCode: 'Unique external code',
            webchatExternalCode: 'External code Webchat',
            facebookExternalCode: 'External code Facebook',
            whatsappExternalCode: 'External code Whatsapp',
            glpiIntegration: 'Integration with GLPI',
            sendingLeadEmail: 'Sending lead email',
            thisBalloonCreatesTags: 'This balloon creates tag(s)',
            appearanceTime: 'Appearance time',
            previewAppearanceTime: 'Shows balloon appearance time, default is 3000 milliseconds (3 seconds)',
            finishingBot: 'Bot termination',
            finishingBotDescription: 'When the bot reaches this line it will terminate.',
            dontResponse: 'Do not answer',
            dontResponseDescription: 'Here comes an option for the user not to respond, when clicking on it, the bot goes to the next balloon.',
            comment: 'Comment',
            commentDescription: 'Comment made by an editor of this flow.',
            secureMessage: 'Secure message',
            secureMessageDescription: 'This answer will not be saved in Conversations on the Globalbot platform',
            editLine: 'Edit line',
            emptyBalloon: 'Deflate balloon',
            done: 'Done',
            editText: 'Edit text',
            addRandomResponse: 'Add random response',
            enterYourQuestion: 'Enter your question here',
            editResponseAttributes: 'Edit the answer attributes below',
            titleButtonsListWhatsApp: 'Title of the button list in WhatsApp',
            none: 'None',
            theType: 'The type',
            theTypeNoneDescription: 'it\'s when you don\'t expect any answer, it\'s just to show something in the question.',
            text: 'Text',
            theTypeTextDescription: 'is for answers only, it allows the user to put any text, numbers without any kind of mask.',
            name: 'Name',
            theTypeNameDescription: 'is for answers only, it allows the user to put the name or how he wants to be called.',
            cpf: 'CPF',
            theTypeCpfDescription: 'it is for answers only, it allows the user to put the CPF with the CPF mask.',
            phone: 'Phone',
            theTypePhoneDescription: 'is for answers only, it allows user to put Phone with Phone mask.',
            email: 'E-mail',
            theTypeEmailDescription: 'is for replies only, it allows the user to enter the email and validate it with a tool.',
            buttons: 'Buttons',
            theTypeButtonsDescription: 'is for answers only, it allows the user to choose between 2 or more button options.',
            list: 'List',
            faq: 'FAQ',
            dataBase: 'Data Base',
            theTypeFaqDescription: 'is for answers only, it allows the user to type something and when sending, it searches the intelligence for what he typed.',
            carousel: 'Carousel',
            theTypeCarouselDescription: 'is for answers only, it allows the user to choose an option between 2 or more than one carousel.',
            liveChat: 'Live chat',
            theTypeLiveChatDescription: 'tries to connect to Globalbot\'s live chat.',
            calendar: 'Calendar',
            theTypeCalendarDescription: 'allows the user to choose the desired date on the calendar.',
            time: 'Schedule',
            theTypeTimeDescription: 'allows the user to choose the time on the clock.',
            response: 'Response',
            buttonOptions: 'Options for buttons',
            dragToSwitchPosition: 'Drag to change position',
            value: 'Value',
            jump: 'Jump',
            switchToSmartButton: 'Switch to smart button',
            switchToButtons: 'Switch to buttons',
            excludeButton: 'Delete this button',
            addButton: 'Add another button',
            checkboxOptions: 'Options for checkboxes',
            genai: 'IA Generativo',
            slidersOptions: 'Options for sliders',
            label: 'Label',
            minValue: 'Minimum value',
            maxValue: 'Maximum value',
            initialValue: 'Initial value',
            step: 'Last',
            guideScreenOptions: 'Options for Guided Screen',
            pageLink: 'Page link',
            returnJump: 'Return jump',
            pageButtonLabel: 'Button text',
            pageButtonLabelHint: 'Link button text on WhatsApp. Default: "Open link".',
            faqOptions: 'Options for FAQ',
            dataBaseOptions: 'Opções for Data Base',
            knowledgeBase: 'Knowledge base',
            secondaryKnowledgeBase: 'Secondary knowledge base',
            ifNotFound: 'If not found:',
            faqButtons: 'Buttons on FAQ',
            learningTime: 'Learning time (days)',
            buttonLimit: 'Button Limit',
            machineLearning: 'Learning machine',
            imageOptions: 'Options for Facebook or Whatsapp image',
            imageLink: 'Image link',
            textOptions: 'Options for text.',
            mask: 'Mask',
            messageError: 'Error message',
            messageErrorOption: 'Error message options',
            newMask: 'New mask',
            typeSomething: 'Please type something.',
            onlyFacebook: 'Just for facebook, use embebed youtube or other components',
            chooseVideoFromLibrary: 'Choose a video from the library',
            videoLink: 'Video link AVI, MP4 etc',
            dataBaseNotFound: 'Data Base not founded',
            moreOptions: 'More options',
            kanbanAssociation: 'Associate to Kanban board',
            kanbanAssociationDescription: 'The conversation that goes through this line will be added as a card in the chosen board and column.',
            selectKanbanBoard: 'Select a board',
            selectKanbanColumn: 'Select a column',
            kanbanNoBoards: 'No Kanban board associated with this bot.',
            kanbanColumnRequired: 'Select a Kanban column on line ',
            liveChatOptions: 'Options for Live Chat',
            fill: 'Fill',
            message: 'Message',
            liveErrorJump: 'Live error jump',
            liveErrorJumpMessage: 'The jump cannot be to the same line',
            setIdentifier: 'Set the identifier to save the user response.',
            newIdentifier: 'New identifier',
            jumpLine: 'Line jump',
            defineJumpToNextLine: 'Define where the next line for the chatbot to jump will be.',
            jumpToLine: 'Jumping to the line',
            jumpTo: 'Jump to',
            genaiErrorFallback: 'If the AI agent fails',
            genaiErrorFallbackDescription: 'If an error occurs while the AI agent is processing the message, the customer receives the notice "I couldn\'t process your message, please try again later." and the flow automatically continues to the line set in "Line jump". If no jump is set, the customer is taken to the next line/bubble of the flow, instead of being stuck on this line.',
            assignComment: 'Add a comment',
            assignCommentDescription: 'You will assign a comment to this line within the flow.',
            notResponseOptions: 'Option not to respond',
            createNotResponseOnlyWebchat: 'Creates an option not to answer the question. Webchat only.',
            notResponse: 'Do not answer',
            secureMessageOptions: 'Secure message option',
            writtenMessageOne: 'The message written by the user does not will be stored by Globalbot.',
            waitDefinedValue: 'When enabled, it waits for the set value in milliseconds to appear.',
            timing: 'Time',
            addTiming: 'Add time',
            integrations: 'Integrations',
            ticketTitle: 'Put the title of the Ticket you want and click on the + beside it.',
            sendTicketToGlpi: 'After saving the bot going through this line will send a ticket to the GLPI System.',
            clickTheIcon: 'To disable, just click on the minus icon.',
            editTicketTitle: 'Edit ticket title',
            newTicketTitle: 'New ticket title',
            sendLeadTranscriptEmail: 'Send lead transcript via email',
            insertEmail: 'Enter the email to send the lead in the field below.',
            saveBotAndSendEmail: 'After saving the bot going through this line will send a lead email to the email informed.',
            editEmail: 'Edit email',
            newEmail: 'New email',
            addTagInConversation: 'Add TAG in conversation',
            selectTags: 'Select the tags to be added to the conversation if you pass through this line.',
            selectOneTag: 'Select a TAG',
            addTag: 'Add tags',
            externalCode: 'External codes',
            masterOnlyFunction: 'Function for masters only.',
            insertCode: 'Here\'s some pure javascript code that will run on that line.',
            codeAdapted: 'If it is not the Callback Único, each platform needs an adapted code to work.',
            unifiedExternalCode: 'Unified external code',
            newUnifiedExternalCode: 'New unified external code',
            externalCodeForWebchat: 'External code for webchat',
            newExternalCodeForWebchat: 'New external code for Webchat',
            externalCodeForWhatsapp: 'External code for Whatsapp',
            newExternalCodeForWhatsapp: 'New external code for Whatsapp',
            externalCodeForFacebook: 'External code for Facebook',
            newExternalCodeForFacebook: 'New external code for Facebook',
            close: 'Close',
            guideScreen: 'Guide Screen',
            businessHours: 'Journey',
            zipCode: 'Zip code',
            cnpj: 'CNPJ',
            finish: 'Finish',
            uploadImage: 'Image upload',
            uploadMedia: 'Media upload',
            uploadPdf: 'PDF upload',
            uploadMediaOptions: 'Media upload options',
            mediaSkipToggle: 'Skip upload button',
            mediaSkipLabel: 'Button text',
            mediaSkipJump: 'Jump on skip',
            mediaRetryToggle: 'Invalid attempts limit',
            mediaRetryLimit: 'Attempts',
            mediaRetryJump: 'Jump on excess',
            mediaRetryMessage: 'Invalid attempt message (optional)',
            mediaSkipOnCard: 'Skip upload',
            nameOptions: 'Name options',
            nameConfirmButtonsToggle: 'Confirmation buttons',
            nameConfirmButtonsHint: 'On WhatsApp, when the profile name is already known, asks for confirmation with Yes and No buttons. When off, asks for the name directly.',
            nameConfirmButtonsOffOnCard: 'No confirmation buttons',
            persistenceSendMessagesToggle: 'Send persistence messages',
            persistenceSendMessagesHint: 'When off, the end user does not receive the persistence follow-up messages nor a resend of this node. Timers, closing or handoff keep working and the messages are saved in the history for audit. WhatsApp only. Only takes effect if persistence is configured in the bot behavior settings.',
            persistenceSendMessagesOffOnCard: 'Persistence messages off (WhatsApp)',
            mediaRetryOnCard: 'Attempts exceeded',
            messageErrorMediaSkip: 'Oops, skip button without text or with invalid jump in row ',
            messageErrorMediaRetry: 'Oops, invalid attempts limit or excess jump in row ',
            checkbox: 'Checkbox',
            rating: 'Stars',
            number: 'Number',
            firstName: 'First name',
            lastName: 'Last name',
            audio: 'Audio',
            bornDate: 'Date of birth',
            slider: 'Slider',
            image: 'Image',
            facebookVideo: 'Facebook video',
            video: 'Video',
            city: 'City',
            state: 'State',
            country: 'Country',
            maskMoney: 'Money mask',
            noBaseAvailable: 'No base available',
            noBaseAssigned: 'No base assigned',
            dataBaseNotFoundOption: 'Unfortunately we do not have this option, please choose a valid option.',
            noBaseDefined: 'No defined base',
            noBodyOnline: 'Unfortunately we don\'t have anyone online at the moment.',
            messageErrorSaved: 'Oops, some error happened while saving the information.',
            messageErrorButtonsDuplication: 'Oops, duplicate button names in row ',
            messageErrorButtonsValueDuplication: 'Oops, duplicate button values in row ',
            buttonValueDuplicated: 'Duplicate value in this node',
            messageErrorButtonsEmpty: 'Oops, buttons with empty values in row ',
            messageErrorFAQEmpty: 'Oops, need to define a knowledge base in row ',
            messageErrorFAQButtonsEmpty: 'Oops buttons with empty values in row ',
            messageErrorJourneyJump: 'Oops, error jump not defined in journey ',
            mandatoryField: 'Required field',
            saveDescription: 'Put a description before saving.',
            flowSaved: 'Flow saved',
            editFlow: 'Flow editor',
            flowPublish: 'Flow published',
            title: 'Title',
            description: 'Description',
            select: 'Select',
            defineOutOfHoursMessage: 'Set a message to be shown if the user is outside business hours.',
            outOfHoursMessage: 'Out of hours message',
            defineOutOfHoursJump: 'Specify the flow line to jump to if the user is outside business hours.',
            outOfHoursJump: 'Out of hours jump',
            goToLineInput: 'Go to line...',
            scrollToTop: 'Scroll to top',
            flowChatbot: 'Flow'
          },
          flowLite: {
            flowLite: 'Flow Lite',
            addBalloonAbove: 'Add balloon above',
            randomMessage: 'Random message',
            message: 'Message',
            name: 'Name',
            buttons: 'Buttons',
            intelligence: 'Intelligence',
            carousel: 'Carousel',
            text: 'Text',
            email: 'Email',
            checkbox: 'Checkbox',
            rating: 'Rating',
            number: 'Number',
            firstName: 'First name',
            lastName: 'Last name',
            phone: 'Phone',
            telephone: 'Telephone',
            audio: 'Audio',
            liveChat: 'Live chat',
            cpf: 'CPF',
            zipCode: 'Zip code',
            calendar: 'Calendar',
            slider: 'Slinder',
            image: 'Image',
            city: 'City',
            state: 'State',
            country: 'Country',
            money: 'Money',
            cnpj: 'CNPJ',
            uploadImage: 'Upload image',
            finish: 'Finish',
            guideScreen: 'Guide screen',
            done: 'Done',
            editText: 'Edit text',
            addRandomResponse: 'Add random response',
            randomizeResponse: 'Randomize response',
            edit: 'Edit',
            exclude: 'Delete',
            identifier: 'Identifier',
            jump: 'Jump',
            excludeBalloon: 'Delete balloon',
            wantToExcludeBalloon: 'Are you sure you want to delete this balloon?',
            dontAskAgain: 'Don\'t ask again',
            cancel: 'Cancel',
            editBalloon: 'Edit balloon',
            instructions: 'Instructions',
            saveRepliesDescription: 'The "identifier" is used to create jumps and be recorded in places such as conversations, integrations, etc. Use to save important responses from your customers.',
            doNotUse: 'Do not use "spaces", use "_" (underscore), do not use accents, if you have any questions about it, please contact us.',
            identifierName: 'Identifier name',
            replacementSystem: 'If you want to use the replacement system just put the identifier inside "%", example: %MY_IDENTIFIER%',
            useButtons: 'Use as many buttons as necessary, but remember, if the number is greater than 6 it will become a dropdown list.',
            changePosition: 'If you want to change the position buttons click on the icon',
            andDrag: 'and drag.',
            sameValue: 'Key and value must always have the same values. Don\'t forget to choose a jump tag.',
            key: 'Key',
            value: 'Value',
            add: 'Add',
            specificDepartment: 'Department: if you have a specific department, select it, otherwise leave it as "Primary".',
            messageErrorDescription: 'Error message: message if the AI is unable to respond.',
            jumpErrorDescription: 'Error jump: jump to some identifier if the AI can\'t respond.',
            departments: 'Departments',
            messageError: 'Error message',
            jumpError: 'Error jump',
            knowledgeBaseDescription: 'Knowledge base: The AI search will only be on the selected knowledge base.',
            jumpDescription: 'Jump: If the AI does not have an answer for the question, it will jump to the selected identifier or repeat the question if no identifier is selected.',
            knowledgeBase: 'Knowledge base',
            jumpWithoutAiResponse: 'Jump (no AI response)',
            machineLearning: 'Machine Learning',
            importantDescription: 'Important: This feature only works on Webchat.',
            machineLearningDescription: 'Machine Learning: The AI learns from its customers, bringing the most used answers (in the form of buttons) to facilitate their doubts.',
            learningTimeDescription: 'Learning time: The time (in days) that the AI can use for learning.',
            buttonLimitDescription: 'Button Limit: The AI will bring the answers if you stick to the maximum number of buttons.',
            learningTime: 'Learning time (days)',
            twoDays: 'Two days',
            threeDays: 'Three days',
            oneWeek: 'One week',
            twoWeek: 'Two weeks',
            oneMonth: 'One month',
            oneQuarter: 'One quarter',
            oneSemester: 'One semester',
            buttonLimit: 'Button limit',
            three: 'Three',
            four: 'Four',
            five: 'Five',
            six: 'Six',
            auxiliaryBases: 'Auxiliary bases',
            searchAuxiliaryBases: 'If the AI does not have an answer using the chosen knowledge base, it will look for the auxiliary bases.',
            optionToRefuseDisambiguation: 'Option to refuse disambiguation',
            alwaysAllow: 'The AI will always allow the client to choose the option to decline the answers given by the AI.',
            onlyResponseUnambiguous: 'Remember, this option is for unambiguous answers only.',
            fieldLabel: 'The Label field will appear next to the selected number, for example "25m²"',
            valueMaxAndMin: 'Minimum value and maximum value define how much your customer can choose.',
            selectionInitialValue: 'Choose an initial value too, which may make it easier for your customer.',
            stepDescription: 'The pass is the number jumps, for example if the pass is 5 the customer can choose 25, 30, 35 and so on.',
            label: 'Label',
            minValue: 'Minimum value',
            maxValue: 'Maximum value',
            initialValue: 'Initial value',
            step: 'Step',
            searchLibrary: 'Search the library',
            insertLink: 'Put the link to the page you want to guide your customer.',
            restartReturnJump: 'The bounce back will restart the chat on the selected identifier.',
            pageLink: 'Page link',
            returnJump: 'Return jump',
            useItems: 'Use as many items as needed, but remember, if the number is greater than 6 it will become a dropdown list.',
            changingThePositionButtons: 'If you want to change the position buttons click on the icon',
            googleAnalytics: 'Google Analytics',
            defineTheCategory: 'Define the event category, action, tag and value.',
            requiredFields: 'Don\'t forget, all information needs to be filled in.',
            category: 'Category',
            action: 'Action',
            tag: 'Tag',
            noInteraction: 'No interaction',
            customerResponse: 'Customer response',
            manual: 'Manual',
            none: 'None',
            bornDate: 'Date of birth',
            maskMoney: 'Money mask',
            primary: 'Primary',
            all: 'All',
            clickHere: 'Click here',
            select: 'Select',
            itemOne: 'Item one',
            noBodyOnline: 'Unfortunately we don\'t have anyone online at the moment.',
            editFlowLite: 'Lite flow editor'
          },
          list: {
            viewer: 'Viewer',
            flowStructure: 'Visualize the structure of your flow!',
            editorPro: 'Explore your creativity in the editor for professionals, with many interactive features and new settings.',
            editor: 'Editor',
            editFlow: 'Edit the stream directly in code. For those who have knowledge of HTML and JavaScript code.',
            flows: 'Flows'
          },
          viewer: {
            flow: 'Flow',
            toView: 'To view',
            test: 'Test',
            indicatesTheBalloonLine: 'This number indicates the line the balloon is on.',
            responseField: 'Answer field',
            emptyQuestion: 'Empty question',
            clickGoToLine: 'By clicking you can go to the line.',
            type: 'Type',
            typeDescription: 'Indicator of the name of the',
            theBalloon: 'of the balloon.',
            identifier: 'Identifier',
            identifierDescription: 'This answer will appear in the conversations tab.',
            knowledgeBase: 'Knowledge base',
            jumpCaseNotFound: 'Jump if not found',
            jumpCaseNotFoundDescription: 'If there is no question registered, the line will be skipped',
            department: 'Deparment',
            noBodyOnline: 'Jump if no one is online',
            noBodyOnlineDescription: 'If there is no online attendant, it will jump to the line',
            jumpingToLine: 'Jumping to the line',
            botWillGoToLine: 'The bot after going through this balloon, will go to the line',
            clickInNumberGoToLine: 'Click on the number to go to the line.',
            externalCode: 'External code',
            uniqueExternalCode: 'Unique external code',
            whatsappExternalCode: 'Whatsapp external code',
            facebookExternalCode: 'External code Facebook',
            glpiIntegration: 'Integration with GLPI',
            sendingLeadEmail: 'Sending lead email',
            appearanceTime: 'Appearance time',
            previewAppearanceTime: 'Shows balloon appearance time, default is 3000 milliseconds (3 seconds)',
            finishingBot: 'Bot termination',
            finishingBotDescription: 'When the bot reaches this line it will terminate.',
            dontResponse: 'Do not answer',
            dontResponseDescription: 'Here comes an option for the user not to respond, when clicking on it, the bot goes to the next balloon.',
            comment: 'Comment',
            commentDescription: 'Comment made by an editor of this flow.',
            secureMessage: 'Secure message',
            secureMessageDescription: 'This answer will not be saved in Conversations on the Globalbot platform',
            primary: 'Primary',
            none: 'None',
            name: 'Name',
            faq: 'FAQ',
            buttons: 'Buttons',
            list: 'List',
            carousel: 'Carousel',
            text: 'Text',
            email: 'E-mail',
            phone: 'Phone',
            liveChat: 'Live chat',
            guideScreen: 'Guide screen',
            cpf: 'CPF',
            zipCode: 'Zip code',
            cnpj: 'CNPJ',
            finish: 'Finish',
            uploadImage: 'Upload Image',
            checkbox: 'Checkbox',
            rating: 'Rating',
            number: 'Number',
            firstName: 'First name',
            lastName: 'Last name',
            audio: 'Audio',
            message: 'Message',
            calendar: 'Calendar',
            bornDate: 'Born date',
            slider: ' Slider',
            image: 'Image',
            facebookVideo: 'Facebook Video',
            video: 'Video',
            city: 'City',
            state: 'State',
            country: 'Country',
            maskMoney: 'Money mask',
            noBaseAvailable: 'No base available',
            noBaseAssigned: 'No base assigned',
            dataBaseNotFoundOption: 'Unfortunately we do not have this option, please choose a valid option.',
            title: 'Title',
            description: 'Description',
            select: 'Select',
            messageLiveError: 'Unfortunately we don\'t have anyone online at the moment.',
            noBaseDefined: 'No defined base',
            messageErrorSaveTheInformation: 'Oops, some error happened while saving the information.',
            flowSaved: 'Flow saved',
            flowEditor: 'Flow editor'
          }
        },
        help: {
          help: {
            help: 'Help',
            whatIsYourDoubt: 'What is your doubt?',
            needHelp: 'Need help?',
            tutorials: 'Tutorials',
            messageErrorTestingIntelligence: 'Error testing intelligence'
          }
        },
        kanban: {
          pageTitle: 'Kanban Boards',
          making: 'Making',
          done: 'Done',
          createItem: 'Create item',
          title: 'Title',
          message: 'Message',
          cancel: 'Cancel',
          add: 'Add',
          newColumn: 'Add new Column',
          cardCreatedSuccess: 'Conversation added to the Board.',
          cardCreateError: 'Could not add the conversation to the Board.',
          cardAlreadyExists: 'This conversation is already on the Board.',
          newBoard: 'New board',
          selectBoard: 'Select a Board',
          notSelectedBoard: 'Not selected board',
          createBoardHint: 'When creating a new board, associate it with chatbots and/or departments. The board will only be visible to users linked to them.',
          createBoardNameLabel: 'Name*',
          createBoardNameRequired: 'Name is required',
          createBoardNameMaxLength: 'Board name must be at most 45 characters',
          createBoardChatbotsLabel: 'Chatbots*',
          createBoardChatbotsRequired: 'Chatbots are required',
          createBoardDepartmentsLabel: 'Departments',
          createBoardShowMonetaryValues: 'Show conversation values on the Board',
          createBoardError: 'Could not create the board',
          createBoardErrorTitleExists: 'A board with this name already exists',
          newBoardTitle: 'New Board',
          editBoardTitle: 'Edit Board',
          editBoardError: 'Could not update the board',
          reallyDeleteBoard: 'Are you sure you want to delete this board?',
          reallyDeleteBoardDetail: 'This action cannot be undone.',
          reallyDeleteColumn: 'Are you sure you want to delete this column?',
          reallyDeleteColumnDetail: 'This action cannot be undone.',
          reallyClearColumn: 'Are you sure you want to clear this column?',
          reallyClearColumnDetail: 'All cards will be removed.',
          moveCardError: 'Could not move the card. Its position has been restored.',
          clearColumnTitle: 'Clear column',
          deleteColumnTitle: 'Delete column',
          board: 'Board',
          column: 'Column',
          selectPlaceholder: 'select',
          chooseColumnPlaceholder: 'choose the column',
          cardNamePlaceholder: 'Card name',
          pressEnterToAdd: 'Press Enter to add',
          cardNameRequired: 'Card name is required',
          columnTitleAlreadyExists: 'A column with this name already exists. This change will not be saved.',
          newBoardTitleLabel: 'New Board',
          newBoardDescription: 'Add conversations to a Kanban-style board to organize your operation.',
          emptyStateHint: 'Nothing here. Create your first board.',
          emptyStateWatchDemoVideo: 'Watch the video demo here (3min)',
          emptyStateOr: 'or',
          demoVideoTitle: 'Kanban Boards demo',
          scheduleDemo: 'Schedule a Demo',
          scheduleDemoTitle: 'Schedule a Kanban Boards Demo',
          scheduleDemoDescription: 'The Kanban Boards module is already included in your plan. Schedule a demo and a personalized setup with one of our specialists. As soon as we receive your request, we will get in touch to arrange the schedule and the guests.',
          scheduleDemoPreferredDay: 'Preferred day',
          scheduleDemoPreferredShift: 'Preferred time of day',
          scheduleDemoDays: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday'
          },
          scheduleDemoShifts: {
            morning: 'Morning',
            afternoon: 'Afternoon'
          },
          scheduleDemoFieldRequired: 'Required field',
          scheduleDemoConfirm: 'Request',
          scheduleDemoSuccess: 'Request sent! We will contact you shortly.',
          scheduleDemoError: 'We could not send your request. Please try again.',
          last7Days: 'Last 7 days',
          last30Days: 'Last 30 days',
          last90Days: 'Last 90 days',
          today: 'Today',
          searchPlaceholder: 'Search',
          conversations: 'conversations',
          conversationSingular: 'conversation',
          recentFirst: 'Recent first',
          manualOrder: 'Manual order',
          advancedFiltersHint: 'Additional filters for this search will be applied here.',
          deleteBoardLabel: 'Delete Board',
          chatbotTooltip: 'Chatbot',
          departmentTooltip: 'Department'
        },
        knowledge: {
          genai: {
            title: 'Generative Artificial Intelligence',
            errors: {
              validation: 'Fill in all required fields and try again.',
              auth: 'Invalid or expired session. Please log in again.',
              insufficientCredits: 'Insufficient credits to use Generative AI. Request more credits and try again.',
              notFound: 'The requested resource was not found.',
              provider: 'Failed to communicate with the AI provider. Please try again shortly.',
              timeout: 'The AI provider took too long to respond. Please try again shortly.',
              network: 'Connection failure. Check your internet and try again.',
              invalidCharacters: 'The field {field} has characters that are not accepted: {chars}. Adjust the name and try again.',
              fields: {
                assistantName: 'Agent name',
                trainingTitle: 'Knowledge base title',
                triggerName: 'Trigger name'
              },
              generic: 'An unexpected error occurred. Report code {errorId} to support.'
            },
            card_title: "Generative AI",
            card_description: "Responses created from a large dataset (GPT model).\nInterprets user intent and generates responses (text and links).",
            column_name: "Name",
            column_autor: "Author",
            column_updatedAt: "Last Updated",
            column_action: "Actions",
            drawer_test: {
              title: "Generative AI Test",
              name: 'Name',
              text_motive: "Use the chat on the side to test the Generative AI responses.<br>The responses are automatically generated based on the provided files and documents.",
              note: "NOTE",
              text_note: "Remember that the Generative AI will be part of some chatbot, so some features of this test chat are limited (e.g., no transfer to human agents).",
              restart: "Restart",
              genai_mini: 'Use the chat below to run the tests. When everything is ready, you can then proceed with the installation. The chat below only tests the artificial intelligence and does not capture lead information.'
            },
            drawer_data: {
              updateWebsite: 'Update Website',
              openWebsite: 'Open Website',
              editWebsite: 'Edit Website',
              deleteWebsite: 'Delete Website',
              refreshWebsiteSuccess: 'Website refreshed successfully.',
              refreshWebsiteError: 'Error refreshing website.',
              create: "New Knowledge Base",
              edit: "Edit Knoeledge Base",
              provider: 'AI engine',
              providerDescription: 'Choose which generative AI answers for this knowledge base.',
              promptMinLength: 'Minimum of {min} characters.',
              promptMaxLength: 'Maximum of {max} characters.',
              unavailableOnOpenai: 'Not available on the OpenAI engine yet.',
              triggersPromptDescriptionOpenai: 'On the OpenAI engine, this text is what the AI reads to decide whether the trigger applies. Describe the situation, not the action. E.g.: "when the user asks to talk to a human agent".',
              providerVerbeux: 'Verbeux',
              providerOpenai: 'OpenAI',
              providerImmutable: 'The AI engine cannot be changed after the knowledge base is created.',
              providerFileUnsupported: 'Sending files in the conversation is not available on the OpenAI engine.',
              prompt: 'Context Guidelines (Prompt)',
              promptDescription: "Define the guidelines below to direct Generative AI responses",
              docs: "Knowledge Base",
              docsDescriptions: "Submit the files and/or inform the websites that will be used by Generative AI (PDF) up to 1.5 GB",
              docsDescriptionsOpenai: "Submit the files and/or inform the websites that will be used by Generative AI. Accepted formats: {formats} — up to 512 MB per file.",
              docsDescriptionsMini: "Submit content that will be used as a source of information for Generative AI. Websites and PDF documents up to 1.5 GB. Maximum limit of 400,000 characters in total.",
              informSite: 'Inform Website',
              informSiteDescription: 'Enter the address of a website.',
              url: 'URL Eddress *',
              recursiveSearch: "Recursive search: once this option is activated, all links related to the entered domain will be included.",
              cancel: 'Cancel',
              importDoc: "Import Files",
              clickOrDrag: "Click or drag files to this area.",
              rules: "Additional Rules",
              triggers: "Escape Triggers",
              triggersDescription: "Use triggers to take the user to some point in the chatbot flow.",
              name: 'Name *',
              nameMinLength: 'The name must be at least 3 characters long.',
              invalidCharacters: 'Characters not accepted: {chars}',
              invalidCharactersReason: 'This field becomes an identifier in Generative AI, so it only accepts unaccented letters, numbers, _ and - (spaces are converted to _).',
              invalidCharactersReasonSpaces: 'This field only accepts unaccented letters, numbers, spaces, _ and -.',
              normalizedValue: 'Will be saved as: {value}',
              fileTitleSanitized: 'The file name had characters that are not accepted: {chars} — it was adjusted to {value}.',
              titleSanitized: 'The title had characters that are not accepted: {chars} — it was adjusted to {value}.',
              requiredFieldsError: 'Fill in all mandatory fields.',
              save: 'Save',
              createSuccess: 'Assistant created successfully.',
              updateFileError: 'Archive error:',
              updateSuccess: 'Assistant updated successfully.',
              deleteDocSuccess: 'file deleted successfully.',
              urlError: 'URL error:',
              triggerError: 'Trigger error:',
              fileActive: 'Ready and Available Content',
              fileProcessing: 'Content in Process',
              triggerError: 'Update trigger error:',
              fileError: 'Error Processing. Delete the item and try again',
              triggersPromptDescription: 'Define the guidelines below to direct Generative AI to perform the trigger action.',
              flowJump: 'Action: Go to the following flow line:',
              deleteTrigger: 'Delete Trigger',
              deletedTrigger: "Tigger deleted.",
              errorDeleteThisTrigger: "Error deleting trigger.",
              areYouSureDeleteTrigger: "Are you sure you want to delete this trigger? All data on it will be lost and this action cannot be undone.",
              deleteDoc: 'Delete Archive',
              deletedDoc: "Archive deleted.",
              errorDeleteThisDoc: "Error deleting archive.",
              areYouSureDeleteDoc: "Are you sure you want to delete this archive? All data on it will be lost and this action cannot be undone.",
              delete: 'Delete',
              errorTreatment: 'Error Treatment',
              errorTreatmentDescription: 'Define the chatbots behavior when there is no response.',
              noResponse: 'If you are left unanswered by:',
              errorFlowJump: "Go to the flow line",
              intervention: "Programmed Intervention",
              interventionDescription: "Define a scheduled intervention based on the number of responses.",
              from: "from:",
              subsequentTimes: 'subsequent times',
              subsequentTime: 'time',
              responsesRow: 'responses in a row',
              response: 'response',
              invalidURL: 'Please inform a valid URL.',
            },
            makeUpgrade: 'Make the upgrade.',
            textLimitCharsTraining: 'of 400,000 characters used. Exclude some content or increase or limit.',
            textCountCharsTraining: 'of 400,000 characters used. To increase the limit.',
            genaiNotCreated: "You don't have assistants yet",
            editGenai: "Edit assistant",
            testGenai: "Test assistant",
            add: "Create Assistant",
            exclude: "Delete Assistant",
            deletedAssistant: "Assistant deleted.",
            errorDeleteThisAssistant: "Error deleting assistant.",
            areYouSureDelete: "Are you sure you want to delete this assistant? All its data will be lost and this action cannot be undone.",
            cancel: "Cancel",
            name: 'Name',
            author: 'Author',
            lastUpdate: 'Last update',
            actions: 'Actions'
          },
          knowledge: {
            card_title: "Conventional AI",
            card_description: "Standardized responses. Interprets user intent and presents registered responses (text, video, images, documents, and links).",
            deleteQuestionSelected: 'Delete selected answers',
            rowsPerPage: 'Records per page:',
            conversations: 'Conversations',
            add: 'Add',
            knowledgeBase: 'Knowledge base',
            exclude: 'Delete',
            askQuestion: 'Ask a question (intention test)',
            importQuestions: 'Import questions',
            columns: 'Columns',
            status: 'Status',
            questionKnowledgeBase: 'Question / Knowledge Base',
            response: 'Response',
            intentionsIa: 'Intentions (Artificial Intelligence)',
            actions: 'Actions',
            edit: 'Edit',
            save: 'Save',
            cancel: 'Cancel',
            newQuestion: 'New question',
            questionTitle: 'Question title',
            deleteQuestions: 'Delete Questions',
            createNewKnowledgeBase: 'Create a new Knowledge Base when you need to separate knowledge for different audiences or contexts, as Intelligence is shared with all chatbots in your account.',
            textEditor: 'Text editor',
            addRandomResponse: 'Add random answer',
            responseNotFound: 'Answer not found go to flow position',
            jumpToFlowPosition: 'Jump to flow position',
            search: 'Search',
            noImagesFound: 'No images found',
            urlPage: 'Page URL',
            continueToFlowPosition: 'Continue in flow position',
            randomizeResponse: 'Randomize answer',
            moveUp: 'Move up',
            video: 'Video',
            document: 'Document',
            text: 'Text',
            liveChat: 'Live chat',
            intelligence: 'Intelligence',
            image: 'Image',
            carousel: 'Carousel',
            guideScreen: 'Guide screen',
            jump: 'Jump',
            moveDown: 'Move down',
            continueFlow: 'After presenting the answers above, the chatbot will follow the flow according to the defined sequencing.',
            intentions: 'Intentions',
            registerIntentions: 'Register the intentions considering the main words that may trigger the response being registered. Give greater weights to words that need to avoid disambiguation.',
            newIntention: 'Enter a new intent here and hit "Enter"',
            intention: 'Intention',
            weight: 'Weight',
            minWeight: 'Minimum weight',
            optional: 'Optional',
            optionalDescription: 'Use if you want to define the minimum weight to be added by the intentions to display the answer.',
            addKnowledgeBase: 'Add Knowledge Base',
            title: 'Title',
            excludeQuestion: 'Delete question',
            youSureExclude: 'Are you sure you want to delete this question?',
            justCopy: 'To import questions, just copy',
            thisModel: 'this model',
            standard: 'standard',
            exportToCsv: 'and export it in CSV with your questions you want to register.',
            chooseFileAndImport: 'After that, click Choose file below to import.',
            none: 'None',
            question: 'Question',
            all: 'All',
            messageErrorImportList: 'Error importing bank list',
            youAlreadyHaveBase: 'You already have a base with this title.',
            requiredTitle: 'The title cannot be left blank.',
            duplicateIntention: 'There is already an equal intention, give it more weight.',
            mustHaveMoreThanOneLetter: 'Intent must be more than 1 letter.',
            cannotHaveMoreThanTwoWords: 'Intent cannot be longer than 2 words.',
            questionSave: 'Saved question',
            messageErrorNewQuestion: 'Error saving new question',
            allFieldsRequired: 'All fields need to be filled.',
            questionSuccessfullyDeleted: 'Question successfully deleted.',
            messageErrorExcludeQuestion: 'Error deleting question.',
            messageErrorTestIntelligence: 'Error testing intelligence',
            messageErrorFilter: 'Error filtering intelligence',
            knowledgeBaseExcluded: 'Knowledge base deleted.',
            itWasNotPossibleExclude: 'It was not possible to delete this knowledge base.'
          }
        },
        library: {
          library: {
            limitExceeded: '200MB limit exceeded',
            addFile: 'Add media',
            libraryDescription: 'Here, in the media library, you can add media to live chat and stream carousels.',
            sizeLimitIs: 'Size limit is',
            video: 'Video',
            videos: 'Videos',
            addMedia: 'Add media',
            photos: 'Photos',
            search: 'Search',
            list: 'List',
            gallery: 'Gallery',
            view: 'View',
            name: 'Name',
            sent: 'Sent',
            actions: 'Actions',
            of: 'of',
            documents: 'Documents',
            document: 'Document',
            exclude: 'Delete',
            newFile: 'New file',
            typeFile: 'Type file',
            image: 'Image',
            title: 'Title',
            description: 'Description',
            cancel: 'Cancel',
            save: 'Save',
            areYouSure: 'Are you sure you want to delete the file?',
            clickExclude: 'By clicking "Delete", the file can no longer be recovered.',
            date: 'Date',
            size: 'Size',
            library: 'Library',
            requiredTitle: 'Title field needs to be filled.'
          }
        },
        live: {
          live2: {
            transferTooltip: 'Select an agent or department to transfer the conversation to',
            userLeaveChat: 'User abandons chat',
            userStayOnManualQueue: 'User is in manual queue',
            userStayOnAutoQueue: 'The user is in automatic queue',
            userStayWaiting: 'User is on hold',
            chatIsFinished: 'The conversation is over',
            chatWaitHsm: 'The conversation is paused and awaiting user interaction',
            errorOnTransferRoom: 'We identified an error transferring this conversation. In this case, please take a screenshot of this screen and send it to our support (suporte@globalbot.com.br). Please try to repeat the transfer again.',
            titleErrorOnLive: 'Unable to transfer conversation',
            titleRuleOnLive: 'Unable to perform this action',
            ruleTransferRoomUnauthorizedUser: 'You are not authorized to transfer this room',
            ruleTransferRoomInvalidStatus: 'It is not possible to transfer this room as its status is invalid, if it persists ask a manager to carry out this action',
            liveChatUpperCase: 'Live Chat',
            inbox: 'Attendant inbox',
            waiting: 'Attendant queue',
            newConversation: 'New conversation',
            attendants: 'Attendants',
            settings: 'Settings',
            filter: 'Filter',
            filterByAttendant: 'Filter by attendant',
            searchAttendant: 'Search attendant',
            attendantNoDepartments: 'No departments',
            noSearchResults: 'No results found',
            searchCustomerName: 'Search customer',
            all: 'All',
            filterByDepartment: 'Filter by department',
            internalToUpperCase: 'INTERNAL',
            finishedToUpperCase: 'FINISHED',
            inQueueToUpperCase: 'IN QUEUE',
            waitingToUpperCase: 'WAITING',
            newToUpperCase: 'NEW',
            transferToUpperCase: 'TRANSFERRED',
            yesterday: 'Yesterday',
            finishAttendance: 'Finish attendance(s)',
            finishAndArchiveAttendance: "Finish and Archive",
            finishSuccess: 'Service(s) completed successfully',
            processingAction: 'Processing... Please wait to finish.',
            noAttendance: 'No attendance available.',
            important: 'Important',
            completionMessage: 'Choose one of the options, considering that "Just Finish" will finish the conversation but you will still see the chat room on this screen, while "Finish and Archive" will close and archive the conversation. You can view it later in the Conversations Menu.',
            triggerAgain: 'Its next interaction will trigger the chatbot again, reopening a new attendance.',
            areYouSureFinish: 'Are you sure you want to finish?',
            cancel: 'Cancel',
            finish: 'Finish Only',
            archiveAttendance: 'Archive attendance(s)',
            archiveSuccess: 'Service(s) archived successfully',
            archiveSuccessOther: 'Service(s) archived by another attendant',
            futureConversation: 'When archiving calls, active conversations will automatically end and close. The next interaction of the user(s) will trigger the chatbot again, reopening a new service. You will be able to consult conversations in the future, in the Conversations Menu. Are you sure you want to archive?\n',
            areYouSureArchive: 'Are you sure you want to archive?',
            archive: 'Archive',
            transferAttendance: 'Transfer Attendance(s)',
            transferSuccess: 'Attendance(s) transferred successfully',
            transferDescription: 'Transfer the attendance to another agent (they will receive the attendance) or department (your attendance will be distributed according to the established settings). *Internal conversations are not transferable.',
            areYouSureTransfer: 'Are you sure you want to transfer?',
            byAttendant: 'By attendant',
            byDepartment: 'By deparment',
            transfer: 'Transfer',
            withCustomer: 'with Customer',
            viaWhatsapp: '(via WhatsApp)',
            startConversationWithCustomer: 'Start a conversation with a customer',
            sendingMessage: 'sending a message via WhatsApp.',
            select: 'Select',
            withAttendant: 'with Attendant',
            viaGlobalbot: '(via Globalbot)',
            startConversationWithSomeone: 'Start a conversation with someone from',
            teamSending: 'your work team sending a',
            messageThroughTheGlobalbot: 'message by the Globalbot platform.',
            newAttendance: 'New attendance',
            waitingForYou: 'is waiting for you!',
            see: 'See',
            close: 'Close',
            waitingAttendant: 'is waiting for an attendant.',
            take: 'Take',
            newTransfer: 'New transfer',
            transferredAndWaitingForYou: 'has been transferred and is waiting for you!',
            transferredDepartmentAndWaitingForYou: 'has been transferred to your department is waiting for an attendant.',
            anotherAttendant: 'Another attendant has already taken over this attendance.',
            pinConversation: 'Pin conversation to the top.',
            couldNotFinish: 'Could not finish',
            couldNotDescription: 'conversations, because they have not yet been taken over by any agent. You need to take them first.',
            couldNotArchive: 'Could not archive',
            finishRoomIdColumn: 'Room ID',
            finishRoomReasonCodeColumn: 'Reason'
          },
          room: {
            transferAttendance: 'Transfer attendance',
            finishAttendance: 'Finish attendance',
            noAttendance: 'No attendance available.',
            archive: 'Archive',
            group: 'group',
            attendance: 'attendance',
            theaterMode: 'Theater mode',
            defaultView: 'Default view',
            noOneToAnswer: 'No one to meet at the moment. What do you think about a coffee?',
            chooseOneToAnswer: 'Select an attendance and let\'s go!',
            loadMoreMessages: 'Load more messages',
            isTyping: 'User is still typing!',
            conversation: 'Conversation',
            intelligence: 'Intelligence',
            navigation: 'Navigation',
            data: 'Data',
            abandonedTheChat: 'The user abandoned the chat',
            createdIn: 'Created in',
            attendants: 'Attendants',
            exit: 'Exit',
            quickResponse: 'Quick response',
            internalMessage: 'Internal message',
            send: 'send',
            takeAttendance: 'TAKE ATTENDANCE',
            important: 'Important',
            sendTemplateHsm: 'To talk to the user, send a Message Template (HSM)',
            onlyAttendants: 'Only attendants of this conversation can send messages.',
            automaticArchiving: [
              { label: 'After 1 hour, the conversation will be automatically archived.', value: 1 },
              { label: 'After 6 hours, the conversation will be automatically archived.', value: 6 },
              { label: 'After 12 hours, the conversation will be automatically archived.', value: 12 },
              { label: 'After 1 day, the conversation will be automatically archived.', value: 24 },
              { label: 'After 2 days, the conversation will be automatically archived.', value: 48 },
              { label: 'After 3 days, the conversation will be automatically archived.', value: 72 },
              { label: 'After 4 days, the conversation will be automatically archived.', value: 96 },
              { label: 'After 5 days, the conversation will be automatically archived.', value: 120 },
            ],
            preview: 'Preview',
            addLegend: 'Add caption',
            cancel: 'Cancel',
            search: 'Search',
            notFound: 'No emoji found',
            found: 'Found',
            recent: 'Frequently used',
            people: 'Emojis and People',
            nature: 'Animals and Nature',
            foods: 'Food and Drink',
            activity: 'Activity',
            places: 'Travel & Places',
            objects: 'Objects',
            symbols: 'Symbols',
            flags: 'Flags',
            others: 'Others',
            fullFunctioning: 'For the full functioning of the live chat it is necessary to allow access to the clipboard.',
            anotherAttendant: 'Another attendant has already taken over this service.',
            copilot: 'Copilot',
            assistantCopilotButtonDescription: 'Try the new Writing Assistant.',
            copilotDescription: 'The Writing Assistant Copilot suggests a new writing with a professional tone and corrects spelling.',
            copilotCardDescription: 'Select the Artificial Intelligence to ask questions and help with answers.',
            copilotGenai: 'Generative Artificial Intelligence (GPT model). You will have the General Knowledge Base (world knowledge) and you can also register specific Knowledge Bases with your company\'s content in the Intelligence Module.',
            copilotConventional: 'Conventional Artificial Intelligence (responses based on content inserted manually in Knowledge Bases in the Intelligence Module)',
            copilotCardCredits: 'Each Copilot query in Generative Artificial Intelligence consumes 1 credit. Your account has 100 free monthly credits.',
            copilotCardTooltip: 'The Copilot helps you with your questions and those of your customers using Artificial Intelligence (Generative or Conventional). Try it!',
            copilotCopyMessage: 'Copy Message',
            copilotReplyMessage: 'Reply Directly',
            copilotCredtisDescription: 'Each Copilot query in Generative Artificial Intelligence consumes 1 credit. Your account has 100 free monthly credits.',
            noCredits: 'Credits finished.',
            finishingCredits: 'Credits running out.',
            requestCredits: 'Request credits.',
            messageCopied: 'Copied message!',
            replyMessage: 'Reply to this message'
          }
        },
        login: {
          signin: {
            selectSegment: 'Select a segment to continue.',
            accountAlreadyExists: 'An account already exists for this e-mail.'
          },
          forgot: {
            enterYourEmail: 'Enter your email and we will send you a temporary password',
            buttonRecover: 'Recover my password',
            goBack: 'Go back',
            emptyEmail: 'You need to fill in the email',
            email: 'Email',
            pleaseEmptyEmail: 'Please fill in your email',
            passwordSent: 'Your new password has been sent to your email.',
            contact: 'Oops, por favor entre em contato com o suporte da Globalbot. (suporte@globalbot.com)',
            iForgotMyPassword: 'I forgot my password'
          },
          login: {
            selectAccount: 'Select the desired account to access',
            cancel: 'Cancel',
            forgotPassword: 'I forgot my password',
            verificationCode: 'Verification code',
            enter: 'Enter',
            validate: 'Validar',
            emptyEmail: 'You need to fill in the email',
            labelEmail: 'Email',
            fillAllData: 'Please fill in all fields',
            emptyPassword: 'You need to fill in the password',
            labelPassword: 'Password',
            userInactive: 'This user is inactive, please contact your manager.',
            outOfYourJourney: 'You are out of your workday, please contact your manager.',
            incorrectUsernameOrPassword: 'Incorrect username or password.',
            doubleFactor: 'This account is secured with two-factor authentication, please enter the six-digit code sent to your cell phone.',
            doubleFactorNeedNumber: 'This account is secured with two-factor authentication, and your user does not have a registered mobile number, please contact your manager.',
            unexpectedError: 'Unexpected error.',
            accountNotCorrect: 'Your account does not look correct, please contact Globalbot',
            notifiedHere: 'Now whenever something happens you will be notified here.',
            notificationActivated: 'Notification activated',
            rememberMyPassword: 'Keep me connected'
          }
        },
        notification: {
          control: {
            addNotification: 'Add notification',
            dateAndTime: 'Date and Time',
            type: 'Type',
            title: 'Title',
            actions: 'Actions',
            user: 'User',
            tag: 'Tag',
            department: 'Department',
            role: 'Role',
            account: 'Account',
            group: 'Group',
            all: 'All',
            edit: 'Edit',
            linkUsers: 'Link users',
            exclude: 'Delete',
            recordsPerPage: 'Records per page',
            save: 'Save',
            cancel: 'Cancel',
            newNotification: 'New Notification',
            showAvatar: 'Show avatar',
            customizableLabel: 'Customizable label',
            label: 'Label',
            message: 'Message',
            notificationType: 'Notification type',
            attachments: 'Attachments',
            loadImage: 'Load image',
            notificationControl: 'Notification Control',
            errorUpload: 'Error processing upload.',
            notificationSent: 'Notification Sent',
            errorSent: 'Error sending notification'
          }
        },
        people: {
          people: {
            people: 'People',
            name: 'Name',
            anonymous: 'Anonymous'
          },
          timeline: {
            people: 'People',
            fullName: 'Full name',
            name: 'Name',
            nickname: 'Nickname',
            occupation: 'Occupation',
            cpf: 'CPF',
            anonymous: 'Anonymous',
            company: 'Company',
            cnpj: 'CNPJ',
            country: 'Country',
            city: 'City',
            state: 'State',
            district: 'Neighborhood',
            conversationStarted: 'Conversation started',
            of: 'of',
            at: 'at',
            hoursAnd: 'hours and',
            minutes: 'minutes'
          }
        },
        profile: {
          profile: {
            profile: 'Profile',
            changePhoto: 'Change photo',
            hello: 'Hello',
            personalInformation: 'Personal information',
            name: 'Name',
            email: 'Email',
            role: 'Role',
            phone: 'Phone',
            security: 'Security',
            newPassword: 'New password',
            confirmNewPassword: 'Confirmation of new password',
            connectedDevices: 'Connected Devices',
            deleteDevice: 'Delete device',
            save: 'Save',
            administrator: 'Administrator',
            manager: 'Manager',
            attendant: 'Attendant',
            primary: 'Primary',
            passwordIsNotIdentical: 'Oops, your password is not identical, please review.',
            informationSaved: 'Information saved!',
            errorSavingInformation: 'Oops, some error happened while saving the information.',
          }
        },
        realTime: {
          realTime: {
            preferences: 'Preferences',
            realTime: 'Real time',
            browsing: 'Browsing',
            withChatbots: 'With chatbots',
            withAttendants: 'With attendants',
            alreadyTalked: 'Already talked',
            attendedBy: 'Attended by',
            currentPageContains: 'Current page contains',
            columns: 'Columns',
            channel: 'Channel',
            dateAndTime: 'Date/Time',
            visitor: 'Visitor',
            chatbot: 'Chatbot',
            location: 'Location',
            pages: 'Pages',
            currentPage: 'Current page',
            time: 'Time',
            conversation: 'Conversation',
            actions: 'Actions',
            unknown: 'Unknown',
            seeOnMap: 'See on map',
            seeNavigation: 'See navigation',
            inAttendance: 'In attendance',
            waitingForAttendant: 'Waiting for attendant',
            finishAttendance: 'Attendance finished',
            noAttendance: 'No attendance available.',
            activeVisitor: 'Active visitor',
            inactiveVisitor: 'Inactive visitor',
            startedAt: 'Started at',
            allConversations: 'All conversations',
            of: 'de',
            initialMessage: 'Initial message',
            message: 'Message',
            cancel: 'Cancel',
            intervene: 'Intervene',
            navigation: 'Navigation',
            openPage: 'Open page',
            close: 'Close',
            openConversation: 'Open conversation',
            all: 'All',
            chatbots: 'Chatbots',
            path: 'Path',
            conversations: 'Conversations'
          }
        },
        settings: {
          fields: {
            fields: 'Fields',
            sections: 'Sections',
            imports: 'Imports',
            sectionDescription: 'Create a section to group custom fields and facilitate visualization.',
            fieldsDescription: 'Create custom fields to record data from people and companies.',
            importsDescription: 'Perform batch record imports and check already performed imports.',
            createSection: 'Create section',
            createField: 'Create field',
            createImport: 'Import',
            name: 'Name',
            description: 'Description',
            actions: 'Actions',
            edit: 'Edit',
            type: 'Type',
            section: 'Section',
            edit: 'Edit',
            processing: 'Processing',
            importError: 'Import error',
            fail: 'Failed in',
            failImport: ' imports due to required fields not being filled',
            exclude: 'Delete',
            excludeSection: 'Delete section',
            excludeField: 'Delete custom field',
            reallyDeleteSection: 'Do you really want to delete this section?',
            reallyDeleteField: 'Do you really want to delete this custom field?',
            sectionExcluded: 'Section deleted.',
            sectionInUse: 'There are fields using this Section',
            fieldExcluded: 'Field deleted.',
            fieldInUse: 'Could not delete, this field has already been filled in some contact.',
            imported: 'Imported'
          },
          chatbot: {
            behavior: {
              chatbots: 'Chatbots',
              preferences: 'Preferences',
              behavior: 'Behavior',
              timers: 'Timers',
              balloonAppearanceTime: 'Balloon appearance time',
              chatbotShutdownTime: 'Chatbot shutdown time',
              interactionTime: 'Interaction Time (...)',
              teenMinutes: '10 minutes',
              threeMinutes: '3 minutes',
              oneMinute: '1 minute',
              fiveMinutes: '5 minutes',
              fifteenMinutes: '15 minutes',
              thirtyMinutes: '30 minutes',
              oneHour: '1 hour',
              twoHours: '2 hours',
              threeHours: '3 hours',
              fiveHours: '5 hours',
              teenHours: '10 hours',
              twelveHours: '12 hours',
              fifteenHours: '15 hours',
              twentyHours: '20 hours',
              twentyFourHours: '24 hours',
              whatsappCacheTime: 'WhatsApp cache time',
              firstTime: 'First time',
              secondTime: 'Second time',
              firstInteraction: 'First interaction *',
              secondInteraction: 'Second interaction',
              desiredAction: {
                title: 'Desired Action',
                actionEnd: 'Finish',
                actionTranshipment: 'Tranship',
                messageTranshipment: 'Message before transhipment',
                departmentTranshipment: 'Transfer department',
                tag: 'Tag with'
              },
              messageTranshipment: 'La conversación será transferida a un agente.',
              messageEnd: 'La conversación fue finalizada por falta de interacción.',
              facebookCacheTime: 'Facebook cache time',
              webchatCacheTime: 'Webchat cache time',
              controllers: 'Controllers',
              soundType: 'Sound type',
              fullScreenMode: 'Full screen mode',
              disableControls: 'Disable controls',
              disableHeader: 'Disable header',
              automaticOpening: 'Automatic opening',
              notReopen: 'Do not reopen balloon after attendance',
              satisfactionSurvey: 'Satisfaction survey',
              protocolAttendance: 'Protocol attendance',
              includeInternalMessages: 'Include internal messages',
              optionFinishOrMin: 'Option to finish or minimize.',
              imageUploader: 'Image uploader (client)',
              fileUploader: 'File uploader (client)',
              allConversations: 'All conversations',
              conversationsNotTransshipment: 'Attendant conversations and no overflow',
              onlyAttendantConversations: 'Only attendant conversations',
              viewingConversationsForAttendants: 'Viewing conversations for attendants',
              persistence: 'Persistence',
              activated: 'Activated',
              disabled: 'Disabled',
              firstMessage: 'First message',
              firstMessageTime: 'First message time',
              secondMessage: 'Second message',
              secondMessageTime: 'Second message time',
              thirdMessage: 'Third message',
              thirdMessageTime: 'Third message time',
              save: 'Save',
              areYouSure: 'Are you sure you want to save the changes?',
              youCanChange: 'You can change the settings whenever you want, but the',
              previousContent: 'previous content cannot be restored.',
              cancel: 'Cancel',
              interface: 'Interface',
              interfaceSettings: 'Interface Settings',
              behaviorSettings: 'Chatbot settings',
              installation: 'Installation',
              integrations: 'Integrations',
              liveChat: 'Live chat',
              areYouStillAround: 'Are you still around?',
              ifNotResponse: 'If you don\'t answer I\'ll have to finish the attendance.',
              ifNeedHelp: 'Alright, if you need help again let me know!',
              closeMessage: 'The attendance was closed by the attendant, we appreciate your contact and if you have any further questions, just call me again.',
              preferenceSaved: 'Preference saved successfully'
            },
            installation: {
              whatsapp: {
                installation: 'Whatsapp Installation',
                configuredWithChatbot: 'Your WhatsApp is configured with your Chatbot.',
                notConfiguredWithChatbot: 'Your WhatsApp is not configured with your Chatbot.',
                versionHint: 'Whatsapp version to be used',
                version: 'Version',
                instanceHint: 'Instance ID provided by your Project Manager',
                instance: 'Instance',
                tokenHint: 'Instance Token provided by your Project Manager',
                token: 'Token',
                mobileNumberHint: 'Mobile number to be used',
                mobileNumber: 'Cellphone number',
                customerIdentifierHint: 'Customer identifier provided by Globalbot',
                customerIdentifier: 'Customer identifier',
                instructionsMobileNumbers: 'Mobile number instructions',
                notChangeConfig: 'You cannot change settings while conversations are ongoing.',
                stepOneMobileNumbers: 'Enable the chip containing the number you want to connect the chatbot',
                stepTwoMobileNumbers: 'You will receive an SMS on this number containing a numeric code',
                stepThreeMobileNumbers: 'Inform the code received to the Globalbot team',
                stepFourMobileNumbers: 'Enter the instance and token provided by Globalbot in the fields below',
                instructionsFixedNumbers: 'Landline number instructions',
                stepOneFixedNumbers: 'You will receive a call on your number containing a numeric code',
                stepTwoFixedNumbers: 'Inform the code received to the Globalbot team',
                stepThreeFixedNumbers: 'Enter the instance and token provided by Globalbot in the fields below',
                areYouSureSave: 'Are you sure you want to save your changes?',
                youCanChange: 'You can change the settings whenever you want, but the',
                previousContent: 'previous content cannot be restored.',
                cancel: 'Cancel',
                save: 'Save',
                publish: 'Publish',
                versioningMessage: 'To access previous versions, just access the specific bot settings, go to versioning and publish the desired version to go into production.',
                removeConfig: 'Remove configuration',
                wabaLabel: 'WhatsApp Business Account (WABA)',
                wabaHint: 'Choose the WhatsApp Business Account that holds the number',
                phoneLabel: 'WhatsApp number',
                phoneHint: 'Choose the number this chatbot will use',
                reconnectMetaAccount: 'Reconnect Meta account',
                saveRejected: 'The WhatsApp settings could not be saved. Try again or contact the Globalbot team.',
                metaTokenExchangeFailed: 'Meta did not issue a long-lived token for this number. Reconnect the Meta account and save again.',
                metaConnected: 'Number connected to Meta. Click save to finish.',
                metaSignupCancelled: 'Meta connection was cancelled before finishing.',
                metaSignupNoPhone: 'The Meta signup finished without a WhatsApp number. Finish choosing the number and try again.',
                metaSignupFailed: 'The Meta connection could not be completed. Try again or contact the Globalbot team.',
                metaWebhookNotSubscribed: 'The number was saved, but Meta did not confirm the webhook subscription. Reconnect the account so messages can arrive.',
                pinOptionLabel: 'My number already uses two-step verification',
                pinOptionCaption: 'Enter the number\'s current PIN. Without a PIN, Globalbot generates one and shows it once.',
                pinLabel: 'Two-step verification PIN',
                pinHint: '6 digits. Stored encrypted and used only to operate the number.',
                pinInvalid: 'The PIN must be exactly 6 digits.',
                pinSubmit: 'Register with this PIN',
                pinPromptTitle: 'Enter the number\'s PIN',
                pinPromptDescription: 'Meta requires this number\'s two-step verification PIN to register it. If you don\'t remember it, turn off two-step verification in WhatsApp Manager and try again without a PIN.',
                pinGeneratedTitle: 'Save your number\'s PIN',
                pinGeneratedDescription: 'This is the two-step verification PIN set for the number. It will not be shown again and will be required to change the PIN or remove the number from the platform.',
                pinCopy: 'Copy PIN',
                pinCopied: 'PIN copied',
                pinAcknowledge: 'I copied the PIN and stored it somewhere safe',
                pinClose: 'Done',
                registerNumber: 'Register number',
                checkRegistration: 'Check status',
                registrationRegistered: 'Number registered on the Cloud API. Ready to send and receive messages.',
                registrationPending: 'Number connected but not yet registered on the Cloud API. Register it by {deadline}, otherwise the connection must be redone.',
                registrationExpired: 'The 14-day window to register the number has ended. Reconnect the Meta account to start over.',
                registrationBlockedUntil: 'New attempts allowed at {date}.',
                registrationInProgress: 'A registration is already in progress for this number. Wait a few seconds.',
                registrationFailed: 'The number could not be registered. Try again or contact the Globalbot team.',
                registrationErrorPinMismatch: 'Meta rejected the PIN. Check the number\'s two-step verification PIN, or turn off two-step verification in WhatsApp Manager and try again.',
                registrationErrorPinLocked: 'Too many PIN attempts. Wait before trying again.',
                registrationErrorRateLimited: 'Meta limited registrations for this number for 72 hours.',
                registrationErrorLocalRateLimit: 'Attempt limit reached for now. Wait before trying again.',
                registrationErrorTosNotAccepted: 'Registration is blocked by a pending item between Globalbot and Meta. Our team has been notified; try again later.',
                registrationErrorReverificationNeeded: 'Meta requires this number to be verified again. Redo the verification in WhatsApp Manager and try again.',
                registrationErrorGraphUnavailable: 'Meta did not respond. Try again in a few minutes.',
                registrationErrorUnknown: 'Meta rejected the registration. Try again or contact the Globalbot team.',
                bsuidSection: 'BSUID identification (Meta)',
                bsuidSectionHint: 'The BSUID is the identifier Meta assigns to the contact. It lets you serve people who arrive without a phone number (QR Code, wa.me link, Click-to-WhatsApp ads).',
                bsuidEnabled: 'Enabled',
                bsuidDisabled: 'Disabled',
                sendByBsuid: 'Send by BSUID',
                sendByBsuidHint: 'Allows sending templates to contacts without a phone, using the BSUID as the recipient.',
                bsuidEffects: 'When enabled: this bot\'s message and template sends start using the BSUID as the recipient whenever the contact has one (phone-only contacts keep receiving as usual); the Campaigns screens gain the BSUID options (a "bsuid" column in the recipients import, test send by BSUID and BSUID search in the stats); and the account\'s conversation export gains a BSUID column.',
                sendByBsuidNotSupported: 'Not available on this version: the Meta and Cogna APIs only accept a phone as recipient. Available on Gupshup and Globalbot WhatsApp.',
                reallyRemoveConfig: 'Do you really want to remove the setting?',
                moreThanOneBotWithWhatsAppInstance: 'There are other bot(s) configured with the same WhatsApp instaceId',
                errorSave: 'Unexpected error while saving',
                attention: 'ATTENTION:',
                thereAreConversationsOpenOne: 'There are conversations open on the instance',
                thereAreConversationsOpenTwo: ', changing the settings will end all these conversations. Do you wish to proceed?',
                proceed: 'Proceed',
                clearError: 'Failed to end conversations.',
                qrLeaveWarning: 'This bot is connected through WhatsApp QR Code. Saving will end the WhatsApp session and, to use QR Code again, a new code will have to be scanned on the phone.',
                qrLeaveError: 'Could not end the WhatsApp QR Code session. Nothing was changed; please try again.',
                qrMasterOnly: 'For now, WhatsApp QR Code can only be enabled by Master users.',
                instructionsQr: 'How to connect with the QR Code',
                stepOneQr: 'Click Connect to generate the QR Code.',
                stepTwoQr: 'On the phone of the number the bot will use, open WhatsApp and go to Settings > Linked devices > Link a device.',
                stepThreeQr: 'Point the camera at the QR Code shown. It is renewed automatically while waiting to be scanned.',
                stepFourQr: 'Wait for the Connected status. Keep the phone online with WhatsApp installed so the session stays active.',
                qrConnection: {
                  title: 'QR Code connection',
                  description: 'Connect the bot\'s number by scanning the QR Code with WhatsApp on the phone. No token or identifier is required.',
                  providerSwitchHint: 'When you connect, this bot starts using WhatsApp QR Code as its WhatsApp provider.',
                  loading: 'Loading the connection status...',
                  loadError: 'Could not load the connection status.',
                  retry: 'Try again',
                  permissionDenied: 'Only account administrators can manage the WhatsApp QR Code connection. Ask an administrator to connect or disconnect the number.',
                  stateLabel: 'Connection status:',
                  notCreated: 'No connection has been created for this bot yet. Click Connect to generate the QR Code.',
                  phone: 'Connected number',
                  profileName: 'Profile',
                  qrAlt: 'QR Code to connect this bot\'s WhatsApp. Scan it with the WhatsApp app on the phone.',
                  qrLoading: 'Generating the QR Code...',
                  qrExpired: 'The QR Code has expired. A new code will be shown shortly.',
                  qrInstructions: 'In WhatsApp on the phone, go to Settings > Linked devices > Link a device and point the camera at the code.',
                  qrExpiresIn: 'This code expires in {seconds}s and is renewed automatically.',
                  qrRenewHint: 'This code expires in a few seconds and is renewed automatically.',
                  connect: 'Connect',
                  reconnect: 'Reconnect',
                  disconnect: 'Disconnect (temporary)',
                  disconnectHint: 'Pauses the connection while keeping the session. To resume, click Reconnect; you won\'t need to scan another QR Code.',
                  logout: 'Log out of session',
                  logoutConfirmTitle: 'Log out of the WhatsApp session?',
                  logoutConfirmMessage: 'The session will be ended on WhatsApp and the bot will stop sending and receiving messages on this number. To connect again, a new QR Code will have to be scanned on the phone.',
                  logoutConfirm: 'Log out of session',
                  cancel: 'Cancel',
                  actionError: 'Could not complete the action. Please try again.',
                  conflictError: 'The connection changed state while the action was being processed. Check the status and try again.',
                  unavailableError: 'The WhatsApp connection service is unavailable right now. Please try again shortly.',
                  botHasActiveProviderError: 'This bot already has another active WhatsApp provider. Deactivate the current provider before connecting via QR Code.',
                  rateLimitedError: 'Too many attempts in a short time. Please wait a moment and try again.',
                  states: {
                    disconnected: 'Disconnected',
                    awaiting_scan: 'Waiting for scan',
                    connecting: 'Connecting',
                    connected: 'Connected',
                    error: 'Error',
                  },
                  reasons: {
                    paused: 'Connection paused. The session was kept; click Reconnect to resume.',
                    logged_out: 'Session ended on the phone. A new QR Code will have to be scanned.',
                    qr_limit_reached: 'QR Code limit reached without a scan. Click Reconnect to generate a new one.',
                    session_rejected: 'WhatsApp rejected the session. Click Reconnect and scan a new QR Code.',
                    provider_error: 'The WhatsApp connection service failed. Try reconnecting shortly.',
                  },
                },
              },
              webchat: {
                installation: 'Installation (WebChat and WhatsAppButton)',
                installationMiniGlobalot: 'Installation Webchat',
                configuredWithChatbot: 'The script is installed on your website',
                notConfiguredWithChatbot: 'The script is not installed on your website',
                installationScript: 'Installation script',
                authorizedDomains: 'Authorized domains',
                domainNumber: 'Domain nº',
                addDomain: 'Add domain',
                domainInvalid: 'Domain invalid',
                instructions: 'Installation Instructions',
                stepOne: 'Copy the installation script on the right',
                stepTwo: 'Insert the script into the HTML code of your website on the pages where you want to activate the chatbot (paste the script immediately after the closing </BODY> tag).',
                stepThree: 'After pasting the script on the desired pages, you must indicate on the right which domains the chatbot was added to.',
                stepFour: 'You must indicate below which domains the chatbot can be activated on.',
                externalBoot: 'External boot',
                youCan: 'You can do external initialization via JavaScript code.',
                accessElement: 'Access the element',
                andUse: 'And use the functions available for startups.',
                openBalloon: 'Open the initial balloon',
                initialBalloon: 'Initial balloon with flow position',
                openChat: 'Open the chat',
                openChatWithFlowPosition: 'Open chat with flow position',
                areYouSureSave: 'Are you sure you want to save your changes?',
                youCanChange: 'You can change the settings whenever you want, but the',
                previousContent: 'previous content cannot be restored.',
                cancel: 'Cancel',
                save: 'Save',
              },
              messenger: {
                installation: 'Facebook Messenger Installation',
                configuredWithChatbot: 'Your Facebook is configured with your Chatbot.',
                reset: 'Reset',
                notConfiguredWithChatbot: 'Your Facebook is not configured with your Chatbot.',
                noPagesAvailable: 'No pages available.',
                synchronize: 'Synchronize',
                almostConfigured: 'Not long after, your Facebook page is almost set up with your Chatbot.',
                yourPage: 'Your page',
                instructions: 'Instructions',
                connectFacebook: 'Click on the Sync button',
                followSteps: 'Follow the step-by-step connection',
                youMustBeAdmin: 'You must be a FanPage administrator to grant access',
                areYouSureSave: 'Are you sure you want to save your changes?',
                youCanChange: 'You can change the settings whenever you want, but the',
                previousContent: 'previous content cannot be restored.',
                cancel: 'Cancel',
                save: 'Save',
                disconnect: 'Desconnect',
                reallyDisconnectPage: 'Do you really want to disconnect this page?'
              },
              telegram: {
                installation: 'Telegram Installation',
                configuredWithChatbot: 'Your Telegram is configured with your Chatbot.',
                notConfiguredWithChatbot: 'Your Telegram is configured with your Chatbot.',
                tokenProvidedBot: 'Access token for the API provided by Bot Father',
                token: 'Token',
                instructions: 'Instructions',
                talkToThe: 'Talk to the',
                followStep: 'Follow the step-by-step guide to create your bot',
                indicateBelow: 'Enter the access token for the API below',
                areYouSureSave: 'Are you sure you want to save your changes?',
                youCanChange: 'You can change the settings whenever you want, but the',
                previousContent: 'previous content cannot be restored.',
                cancel: 'Cancel',
                save: 'Save',
                config: 'Configuration Instructions',
                step1: '1 - Go to Telegram and find @BotFather using the search bar.',
                step2: '2 - Type /start and the bot will provide a list of available commands.',
                step3: '3 - Use the /newbot command and follow the provided instructions to create a new bot.',
                step4: '4 - BotFather will send a message once your bot is created. You will receive a link to your bot and an API token.',
                step5: '5 - Copy this token and enter it in the form on the side.',
                step6: '6 - Now all messages sent by new contacts to your bot will appear in the conversation module.',
                existingIntro: 'To connect an existing Telegram bot, do the following:',
                existing1: '1 - Type the /mybots command in @BotFather.',
                existing2: '2 - Choose the bot you want to connect.',
                existing3: '3 - Click on API Token.',
                existing4: '4 - Copy the token and paste it into the form on the side.'
              },
              instagram: {
                authInProgress: 'OAuth in progress',
                waitingForReturn: 'Waiting for return from Instagram...',
                alreadyAuthorized: 'If you have already authorized on Instagram and did not return automatically,',
                clickHereToCheck: 'click here to check',
                toolTipDescribeInstallationBot: 'Opens in popup - does not leave the application',
                installation: 'Instagram Installation',
                yourPage: 'Your page',
                configuredWithChatbot: 'Your Instagram is configured with your Chatbot.',
                reset: 'Reset',
                notConfiguredWithChatbot: 'Your Instagram is not set up with your Chatbot.',
                motiveConfigure: 'The Globalbot platform can only manage messages from INSTAGRAM BUSINESS accounts. It is not possible to connect and manage messages on personal Instagram accounts.',
                important: 'Important: ',
                synchronize: 'Synchronize',
                instructions: 'Instructions',
                stepOne: 'ADD 1st STEP',
                stepTwo: 'ADD 2nd STEP',
                stepThree: 'ADD 3rd STEP',
                areYouSureSave: 'Are you sure you want to save your changes?',
                youCanChange: 'You can change the settings whenever you want, but the',
                previousContent: 'previous content cannot be restored.',
                cancel: 'Cancel',
                save: 'Save',
              },
              chatbots: 'Chatbots',
              preferences: 'Preferences',
              installation: 'Installation',
              interface: 'Interface',
              interfaceSettings: 'Interface settings',
              behavior: 'Behavior',
              chatbotSettings: 'Chatbot settings',
              integrations: 'Integrations',
              liveChat: 'Live chat',
              youHavePermission: 'Oops, looks like permissions are missing.',
              consultTheConsole: 'Oops, some error happened, see the console.',
              preferenceSaved: 'Preference saved successfully'
            },
            integrations: {
              chatbots: 'Chatbots',
              preferences: 'Preferences',
              integrations: 'Integrations',
              reset: 'Reset',
              toSetUp: 'Configure',
              eventWebhookLabel: 'Event webhook',
              descriptions: {
                googleAnalytics: 'This integration is responsible for analyzing statistics of the flow.',
                pipeRun: 'With this integration, the Globalbot platform will record (post) contact (leads) information in Piperun through compatible fields.',
                slack: 'With this integration, the Globalbot platform will send the conversation history to a specific channel. A webhook needs to be configured to receive the event and send messages.',
                vistaSoft: 'This integration is responsible for searching for real estate for rent/purchase according to the user-selected options (number of rooms, type, neighborhood) and recording leads.\nKey fields: phone and/or name and email and "contact_objective"/"interest".',
                rdStation: 'With this integration, the Globalbot platform will record (post) contact (leads) information in RD Station Marketing through compatible fields.\nKey fields: email.',
                pipeDrive: 'With this integration, the Globalbot platform will record (post) contact (leads) information in PipeDrive through compatible fields. It assigns an attendant as responsible based on the email address.',
                rdCrm: 'With this integration, the Globalbot platform will send negotiations to the CRM.\nKey fields: email and/or phone and name.',
                ksi: 'With this integration, the Globalbot platform will record (post) contact (leads) information in Kurole KSI through compatible fields.\nKey fields: email, name, and phone.',
                cv: 'With this integration, the Globalbot platform will record (post) contact (leads) information in the Sales Builder through compatible fields.\nKey fields: email, name, and phone.',
                movidesk: 'With this integration, the Globalbot platform will open tickets.\nKey fields: email.',
                glpi: 'With this integration, the Globalbot platform will open tickets.\nKey fields: name.',
                jira: 'With this integration, the Globalbot platform will create tasks.\nKey fields: email.',
                zendesk: 'With this integration, the Globalbot platform will open tickets.\nKey fields: email.',
                midasSoft: 'With this integration, the Globalbot platform will record (post) contact (leads) information in MidasSoft.',
                rdStationV2: 'This integration is responsible for retrieving information in RD Stations Marketing (only for specific cases).',
                moskit: 'With this integration, the Globalbot platform will be responsible for creating negotiations.',
                funilVendas: 'With this integration, the Globalbot platform will be responsible for creating negotiations.\nKey fields: email, name, and phone.',
                amigo: 'With this integration, the Globalbot platform will schedule medical appointments.',
                agendor: 'With this integration, the Globalbot platform will be responsible for creating negotiations and tasks.\nKey fields: phone.',
                emailLead: 'With this integration, the Globalbot platform will be responsible for sending conversation transcripts by email.',
                shopify: 'This integration is responsible for order tracking.\nKey fields: email.',
                vTiger: 'With this integration, the Globalbot platform will record (post) contact (leads) information in vTiger through compatible fields.\nKey fields: email, name and phone.',
                hubspot: 'With this integration, the Globalbot platform will record (post) contact (leads) information in Hubspot through compatible fields.\nKey fields: email, name and phone.',
                eventWebhook: 'Receive WhatsApp message status events (sent, delivered, read, failed) in your own system in near real time. HMAC-signed delivery with automatic retries on failure.',
              },
              aboutIntegration: 'About integration',
              native: 'NATIVE',
            },
            interface: {
              chatbots: 'Chatbots',
              preferences: 'Preferences',
              interface: 'Interface WebChat',
              chatWindow: 'Chat window',
              botName: 'Bot name',
              attendantName: 'Main Name',
              attendantRole: 'Additional Phrase',
              avatarImage: 'Avatar image',
              balloonImage: 'Button image',
              logoImage: 'Logo',
              logo: 'Logo',
              primaryColor: 'Primary color',
              chatHeight: 'Chat height',
              copyRight: 'Copyright (master only)',
              disabled: 'Disabled',
              activated: 'Activated',
              startBalloon: 'Start button',
              message: 'Message',
              installationInstructions: 'Website Installation Instructions',
              installationInstructionsDescription: 'Install the WebChat trigger script on your website.',
              position: 'Position',
              left: 'Left',
              right: 'Right',
              textColor: 'Text color',
              backgroundColor: 'Background color',
              templates: 'Templates',
              default: 'Default',
              amplified: 'Amplified',
              ticket: 'Ticket',
              noImage: 'No image',
              noText: 'No text',
              ghost: 'Invisible',
              mobile: 'Mobile',
              save: 'Save',
              areYouSureSave: 'Are you sure you want to save the changes?',
              youCanChange: 'You can change the settings whenever you want, but the',
              previousContent: 'previous content cannot be restored.',
              cancel: 'Cancel',
              sampleQuestion: 'Sample question',
              answerExample: 'Answer example',
              typeYourName: 'Type your name',
              typeYourPhone: 'Type your phone',
              typeYourExample: 'Text example',
              virtualAssistant: 'Virtual Assistant',
              preferenceSaved: 'Preference saved successfully'
            },
            whatsapp: {
              settigns: 'Settings',
              chatbotAndNumber: 'Chatbot | WhatsApp Button Number',
              needWhatsappConfig: 'You must have a Whatsapp number configured in the bot to enable this option!',
              buttonStatus: 'Button Status',
              buttonMessage: 'Button Message (optional)',
              buttonPosition: 'Button Position',
              initialMessageWhatsapp: 'Initial WhatsApp Message (optional)',
              initialMessageWhatsappDescription: 'This is the text that will be automatically inserted into the message field of the WhatsApp application.',
              enabled: 'Enabled',
              disabled: 'Disabled',
              rightPosition: 'right (bottom corner)',
              leftPosition: 'left (bottom corner)',
              installationInstructions: 'Website Installation Instructions',
              installationInstructionsDescription: 'Install the WhatsApp Button trigger script on your website.',
              traceOrigin: 'Track Traffic Source (Tracking)',
              traceOriginDescription: 'When this feature is enabled, users will be asked to provide their WhatsApp phone number before starting the conversation. This allows identifying the page the user was on when visiting the website.',
              requestPhone: 'Request phone and enable traceability.',
              logoOrAvatar: 'Image',
              visibleName: 'Visible Name (Display Name)',
              resquestPhoneMessage: 'Message to request WhatsApp number',
              copyright: 'Copyright (master only)'
            },
            master: {
              chatbots: 'Chatbots',
              preferences: 'Preferences',
              master: 'Master',
              locationOfServers: 'Location of servers (master only)',
              newPln: 'New PLN (master only)',
              realTime: 'Real time (master only)',
              cacheConversation: 'Cache conversation (master only)',
              offshoreLastQuestion: 'Offshore last question (master only)',
              excludeChatbot: 'Delete chatbot',
              createCliWithoutBackground: 'Create CLI without Background',
              save: 'Save',
              areYouSureSave: 'Are you sure you want to save the changes?',
              youCanChange: 'You can change the settings whenever you want, but the',
              previousContent: 'previous content cannot be restored.',
              doYouReallyExclude: 'Do you really want to delete the chatbot?',
              cancel: 'Cancel',
              exclude: 'Delete',
              interface: 'Interface',
              interfaceSettings: 'Interface settings',
              behavior: 'Behavior',
              chatbotSettings: 'Chatbot settings',
              installation: 'Installation',
              integrations: 'Integrations',
              areYouStillAround: 'Are you still around?',
              ifYouNotResponse: 'If you don\'t answer I\'ll have to finish the attendance.',
              ifYouNeedHelp: 'Alright, if you need help again let me know!',
              closeMessage: 'The attendance was closed by the attendant, we appreciate your contact and if you have any further questions, just call me again.',
              preferenceSaved: 'Preference saved successfully'
            },
            messages: {
              chatbots: 'Chatbots',
              preferences: 'Preferences',
              messages: 'Messages',
              portuguese: 'Portuguese',
              english: 'English',
              spanish: 'Spanish',
              faqNotFound: 'FAQ not found',
              treatment: 'When the user types good morning instead of their name.',
              noName: 'When the user type it: My name is...',
              ask: 'When the user asks a question.',
              special: 'When the user puts some special character',
              justYourName: 'When the user types the first expletive',
              cursed: 'When the user types the second expletive and closes the chatbot.',
              knowledgeName: 'When there is an intention in intelligence and the user has put it in the name.',
              limit: 'When the user types beyond the allowed limit.',
              manyItems: 'When disambiguating a question',
              faqNoneButton: 'When disambiguated, a button appears with that phrase',
              connectLive: 'When connecting to Live Chat',
              firstNameError: 'When the user misses the name',
              textError: 'When the user does not type anything in a text request',
              emailError: 'When the user misses the email',
              moneyError: 'When the user is asked to enter a monetary amount in error',
              phoneError: 'When the user misses the phone',
              cpfError: 'When the user misses the CPF',
              cnpjError: 'When the user misses the CNPJ',
              faqError: 'When the user doesn\'t type anything in a FAQ',
              save: 'Save',
              areYouSureSave: 'Are you sure you want to save the changes?',
              youCanChange: 'You can change the settings whenever you want, but the',
              previousContent: 'previous content cannot be restored.',
              cancel: 'Cancel',
              interface: 'Interface',
              interfaceSettings: 'Interface Settings',
              behavior: 'Behavior',
              chatbotSettings: 'Chatbot settings',
              installation: 'Installation',
              integrations: 'Integrations',
              areYouStillAround: 'Are you still around?',
              ifYouNotResponse: 'If you don\'t answer I\'ll have to finish the attendance.',
              ifYouNeedHelp: 'Alright, if you need help again let me know!',
              closeMessage: 'The attendance was closed by the attendant, we appreciate your contact and if you have any further questions, just call me again.',
              typeYourName: 'To start our conversation, enter your name.',
              onlyName: 'Just enter your name.',
              toContinueTypeYourNamePlease: 'To continue, please enter your name. ',
              typeYourNamePleaseSpecial: 'Looks like you added a special character. Just enter your name.',
              continueTheConversation: 'That way I can\'t continue the conversation.',
              typeYourNamePlease: 'Please enter only your name.',
              toAnswerYourQuestions: 'To answer your questions, I need you to enter your name.',
              virtualAssistant: 'Virtual Assistant',
              maxLimit: 'You have exceeded the maximum character limit.',
              iCanHelpYou: 'In this question of yours I can help you with more than one option.',
              noneOption: 'None of the above',
              notFound: 'I did not understand your question.',
              waitMoment: 'Wait a moment. An attendant will talk to you right away.',
              selectOneOptions: 'Select one of the options',
              typeName: 'Type your name',
              typeNameError: 'Please enter a valid name.',
              typeFirstName: 'Enter your first name',
              typeFirstNameError: 'Just enter your first name.',
              typeLastName: 'Enter your last name',
              typeLastNameError: 'Just enter your last name.',
              typeHere: 'Type here',
              typeHerePlease: 'Please type something.',
              typeEmail: 'Type your e-mail',
              typeEmailError: 'Please enter a valid email address.',
              typeMoney: 'Enter your value',
              typeMoneyError: 'Please enter a valid amount.',
              typePhone: 'Enter your phone',
              typePhoneError: 'Please enter a valid phone number.',
              typeCpf: 'Enter your CPF',
              typeCpfError: 'Please enter a valid CPF.',
              typeBornDate: 'Enter your birth date',
              typeBornDateError: 'Please advise your valid birth date.',
              typeCnpj: 'Enter your CNPJ',
              typeCnpjError: 'Please enter a valid CNPJ.',
              typeFaq: 'Enter your question',
              typeFaqError: 'Please fill in something.',
              selectListFaq: 'Choose an option',
              selectListFaqError: 'Please choose an option.',
              selectRating: 'Select',
              search: 'Search',
              searchCountry: 'Search country',
              searchState: 'Search state',
              searchCity: 'Search city',
              typeMessage: 'Enter your message...',
              typeMessageError: 'Please, type your message',
              selectDate: 'Choose a date',
              selectDateError: 'Please choose a date',
              selectSize: 'Choose a size',
              selectSizeError: 'Please choose a size',
              typeNumber: 'Enter a number',
              typeNumberError: 'Please enter a number',
              preferenceSaved: 'Preference saved successfully'
            },
            dataCollectionPage: {
              description: 'Define the initial messages and which fields will be requested at the beginning of the conversation to register lead data.',
              leadDataTitle: 'Lead data collection',
              leadDataDescription: 'The enabled fields will be requested when starting a conversation. A lead is counted when there is a collection of the email or phone field.',
              initialPhrase: 'Initial Message (welcome)',
              phrase: 'Message',
              phraseContinue: 'Continuation Message (after requesting data)',
              btnSave: 'Save',
              name: 'Name',
              email: 'Email',
              phone: 'Phone'
            },
            chatbots: 'Chatbots',
            preferences: 'Preferences',
            interfaceChatbot: 'WebChat InterFace',
            setAllVisual: 'Enable and define the visual aspects and functions of WebChat (chat window) installed on the website.',
            behaviorChatbot: 'Behavior',
            accessTheBehaviorSettings: 'Access chatbot behavior settings (time controls, trigger, chat window view modes and chat persistence).',
            installationChatbot: 'Installation',
            accessTheInstallationSettings: 'Access the chatbot installation and activation settings on each of the channels: WebChat, WhatsApp, Instagram, Messenger and Telegram.',
            whatsappChatbot: 'Whatsapp Button',
            whatsappChatbotDescription: 'Enable and define the visual aspects of the WhatsApp Button for your website and configure the Track Traffic Source feature.',
            integrationsChatbot: 'Integrations',
            accessTheIntegrationSettings: 'Access the configuration panel for the various Globalbot integrations with other systems. Some of these configurations are performed by our technical team due to complexity and security.',
            masterChatbot: 'Master',
            exclusiveAccess: 'Globalbot team exclusive access to advanced settings such as server location, conversation cache, artificial intelligence behavior and real time.',
            excludeVersionerAccess: 'Exclusive access for the Globalbot team to view Flow Versions.',
            publishChatbot: 'Versioning',
            dataCollection: 'Data Collection',
            dataCollectionSubtitle: 'Define initial phrases and which fields the chatbot will request from the user at the beginning of the conversation.',
            messagesChatbot: 'Messages',
            modifyMessages: 'Here you can modify some of the messages, only for Masters at the moment.',
            flowPublish: 'Preference saved successfully'
          },
          permission: {
            permission: {
              permission: 'Permissions',
              preferences: 'Preferences',
              conversations: 'Conversations',
              manager: 'Manager',
              attendant: 'Attendant',
              seeAll: 'See all',
              seeAttendedAndWithoutTransshipment: 'See attended and without transshipment',
              onlyAttended: 'See only answered',
              junior: 'Junior',
              done: 'Save',
              updatedPermissions: 'Permissões atualizadas!',
              connectionError: 'Oops, connection error.'
            }
          },
          users: {
            access: {
              preferences: 'Preferences',
              users: 'Users',
              journey: 'Journey',
              addJourney: 'Add Journey',
              name: 'Name',
              description: 'Description',
              actions: 'Actions',
              edit: 'Edit',
              linkUsers: 'Link users',
              exclude: 'Delete',
              totalOf: 'Total of',
              usersBeing: 'users, being',
              inNone: 'in none',
              inOneAnd: 'in one and',
              inTwoOrMore: 'in two or more journeys.',
              save: 'Save',
              cancel: 'Cancel',
              journeyData: 'Journey Details',
              journeyName: 'Journey name *',
              comments: 'Comments',
              schedules: 'Schedules',
              dayOfTheWeek: 'Day of the week *',
              sunday: 'Sunday',
              monday: 'Monday',
              tuesday: 'Tuesday',
              wednesday: 'Wednesday',
              thursday: 'Thursday',
              friday: 'Friday',
              saturday: 'Saturday',
              input: 'Input *',
              exit: 'Exit *',
              addTime: 'Add time',
              tolerance: 'Tolerance',
              defineTheTolerance: 'Define the tolerance time for this journey to access and stay on the platform.',
              important: 'Important',
              onceTheTolerance: 'Once the tolerance time is reached, the platform will issue an alert and a countdown timer for the user to calmly end their activities.',
              whenTheTotal: 'When the total length of stay is finally reached, the user will be logged out automatically. Only administrator users will be able to log into the platform outside their working hours.',
              ifUser: 'If a user is linked in more than one journey, access and permanence will take into account the journey with the longest duration (both for entry and exit).',
              journeyUsers: 'Journey Users',
              outOfTheJourney: 'Out of the journey',
              withinTheJourney: 'Within the journey',
              addSelected: 'Add selected',
              addAll: 'Add all',
              removeAll: 'Remove all',
              removeSelected: 'Remove selected',
              nonexistent: 'Nonexistent',
              deleteJourney: 'Delete Journey',
              areYouSure: 'Are you sure you want to delete this journey? All data from it will be lost and this action cannot be undone.',
              fiveMinutes: '5 minutes',
              tenMinutes: '10 minutes',
              fifteenMinutes: '15 minutes',
              twentyMinutes: '20 minutes',
              twentyFiveMinutes: '25 minutes',
              thirtyMinutes: '30 minutes',
              oneHour: '1 hour',
              twoHours: '2 hours',
              fourHours: '4 hours',
              sixHours: '6 hours',
              twelveHours: '12 hours',
              journeyCreated: 'Your journey has been created!',
              journeyEdited: 'Your journey has been edited!',
              errorAtTheTime: 'Oops, we had an error at the time!',
              duplicateTime: 'Remove duplicate times to save!',
              journeyExcluded: 'Your journey has been deleted!',
              errorCompletingThisAction: 'Oops, we had a problem completing this action.',
              journeyAtDeparmentUnlink: 'The journey is linked to department %1% you need to unlink the journey from the department to delete it.',
              journeyAtBotUnlink: 'The journey is linked to the bot %1% you need to unlink the journey from the bot to delete it.'
            },
            emailExits: 'User with this email already exists',
            preferences: 'Preferences',
            users: 'Users',
            addNewUser: 'Add new users to the platform. If you reach your limit, request the expansion of it.',
            createUser: 'Create user',
            permissions: 'Permissions',
            managerUserPermissions: 'Manage user permissions, enabling or restricting access to platform features.',
            passwordMinimun8chars: 'Please use a minimum of 8 characters!',
            journeys: 'Journeys',
            defineTheJourney: 'Define the operational journey of chatbots, departments and users, controlling access and permanence on the platform.',
            extendLimit: 'Extend Limit',
            yourCurrentLimit: 'Is your current limit not enough? Order the extension now.',
            avatar: 'Avatar',
            reasonForAbsence: 'Reason for absence',
            statusReasonLabel: 'Status reason',
            statusReasonMasterTooltip: 'This column is shown only for master users.',
            statusReasonDescriptionLabel: 'Reason description',
            statusReasonDescriptions: {
              SESSION_REVOKED_NEW_DEVICE: 'Session ended: signed in on another device',
              SESSION_REVOKED_BY_ADMIN: 'Session ended by an administrator',
              AUTH_CONNECT: 'Session connected',
              AUTH_SERVER_NAMESPACE_DISCONNECT: 'Session ended by the server',
              AUTH_CLIENT_NAMESPACE_DISCONNECT: 'Session ended by the browser',
              AUTH_PING_TIMEOUT: 'Session lost due to response timeout',
              AUTH_TRANSPORT_ERROR: 'Session connection error',
              AUTH_TRANSPORT_CLOSE: 'Session connection lost',
              LIVE_SERVER_NAMESPACE_DISCONNECT: 'Live chat ended by the server',
              LIVE_CLIENT_NAMESPACE_DISCONNECT: 'Live chat ended by the browser',
              LIVE_PING_TIMEOUT: 'Live chat connection lost due to response timeout',
              LIVE_TRANSPORT_ERROR: 'Live chat connection error',
              LIVE_TRANSPORT_CLOSE: 'Live chat connection lost',
              PANEL_SYS_CONNECT: 'Status set on connect',
              PANEL_SYS_COOKIE_CONNECT: 'Status restored when opening the panel',
              PANEL_SYS_RECONNECT: 'Status restored after reconnection',
              PANEL_USER_CHANGE_STATUS: 'User changed the status',
              PANEL_USER_CHANGE_STATUS_FROM_LIST: 'Status changed from the attendants list',
            },
            addAvatar: 'Add avatar',
            name: 'Name',
            nameRequired: 'Name *',
            email: 'Email',
            emailRequired: 'Email *',
            role: 'Role',
            roleRequired: 'Role *',
            departmentsFilter: 'Select a Department',
            chatbotsFilter: 'Select a Chatbot',
            linked: 'Linked',
            unlinked: 'Unlinked',
            permission: 'Permission',
            permissionRequired: 'Permission *',
            actions: 'Actions',
            accessReport: 'Access report',
            edit: 'Edit',
            exclude: 'Delete',
            understood: 'Understood',
            important: 'IMPORTANT',
            impossibleToDelete: ': Unable to delete this user because he has ',
            activeConversations: 'active conversations. You must transfer or terminate this user\'s conversations before requesting deletion.',
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            userData: 'User Data',
            ddi: 'DDI',
            phone: 'Phone',
            newPassword: 'New Password *',
            chatbots: 'Chatbots',
            departments: 'Departments',
            accessLogs: 'Access Logs',
            initialDate: 'Initial date',
            startTime: 'Start time',
            finalDate: 'Final date',
            endTime: 'End time',
            status: 'Status',
            date: 'Date',
            intentions: 'Intentions',
            intentionsDescription: 'Select the date and time for the filter to search within the chosen area.',
            available: 'Online',
            away: 'Away',
            offline: 'Offline',
            connected: 'Connected',
            disconnected: 'Disconnected',
            excludeUser: 'Delete user',
            endJourney: 'End Journey',
            areYouSureDelete: 'Are you sure you want to delete this user? All his or her data will be lost and this action cannot be undone.',
            youCanRequest: 'You can request additional users for use on the platform. Please enter your details below and one of our specialists will contact you.',
            amount: 'Amount *',
            request: 'Request',
            primary: 'Primary',
            administrator: 'Administrator',
            manager: 'Manager',
            attendant: 'Attendant',
            junior: 'Junior',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
            shortJan: 'Jan',
            shortFeb: 'Feb',
            shortMar: 'Mar',
            shortApr: 'Apr',
            shortMay: 'May',
            shortJun: 'Jun',
            shortJul: 'Jul',
            shortAug: 'Aug',
            shortSep: 'Sep',
            shortOct: 'Oct',
            shortNov: 'Nov',
            shortDec: 'Dec',
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            shortSunday: 'Sun',
            shortMonday: 'Mon',
            shortTuesday: 'Tue',
            shortWednesday: 'Wed',
            shortThursday: 'Thu',
            shortFriday: 'Fri',
            shortSaturday: 'Sat',
            exportToSVG: 'Export to SVG',
            exportToPNG: 'Export to PNG',
            exportToCSV: 'Export to CSV',
            menu: 'Menu',
            selection: 'Select',
            selectionZoom: 'Select zoom',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            pan: 'Mover',
            reset: 'Return to default',
            userDeleted: 'Usuário excluído.',
            errorUserDelete: 'Oops, não conseguimos excluir este usuário!',
            notLimit: 'Você não tem mais limite para adicionar usuários.',
            errorPasswordLength: 'Enter a password longer than 6 characters.',
            errorSavingUser: 'Fill in all mandatory fields.',
            invalidPassword: 'Password must be at least 8 digits long!',
            theArchitect: 'O Arquiteto',
            notFound: 'Não encontrado',
            dominion: 'Domínio',
            master: 'Mestre',
            senior: 'Sênior',
            failedToRequest: 'Oops, failed to request users.',
            requestedUsers: 'Requested users.',
            requiredFields: 'You need to fill in the fields.',
            userCreatedSuccessfully: 'User created successfully!',
            userUpdatedSuccessfully: 'User updated successfully!',
            userSeeAnyAttendantConversations: "Allow viewing and transferring conversations of other attendants?",
            restrictToLinkedBots: "Allow functions and views only for the chatbot(s) assigned to this user.",
            restrictToLinkedBotsLockedTooltip: "You cannot disable this option on your own profile while it is active."
          },
          unsubscribeGroups: {
            title: 'Unsubscribe groups',
            description: 'Each domain has one unsubscribe group. Anyone who clicks "unsubscribe" in an email sent from this domain lands here and stops receiving its campaigns, without affecting other domains or system emails.',
            backToDomains: 'Back to domains',
            domain: 'Domain',
            status: 'Status',
            statusActive: 'Active',
            statusPendingSync: 'Syncing with the provider',
            pendingSyncHint: 'The email provider has not confirmed this group yet. We retry automatically every day at 03:00, or right now with the Sync button.',
            displayName: 'Name',
            descriptionField: 'Description shown to the recipient',
            descriptionHint: 'Up to 100 characters. Shown on the recipient\'s email preferences page.',
            edit: 'Edit',
            save: 'Save',
            cancel: 'Cancel',
            saved: 'Group updated.',
            noGroupTitle: 'This domain has no unsubscribe group yet',
            noGroupDescription: 'The group is created automatically when the domain is added. If that failed, you can create it now.',
            createGroup: 'Create group',
            groupCreated: 'Group created.',
            unsubscribedEmails: 'Unsubscribed emails',
            searchEmail: 'Search email',
            email: 'Email',
            unsubscribedAt: 'Unsubscribed at',
            releasedAt: 'Released at',
            releasedBy: 'Released by',
            reason: 'Reason',
            actions: 'Actions',
            rowUnsubscribed: 'Unsubscribed',
            rowReleased: 'Released',
            systemRelease: {
              resubscribed_by_recipient: 'Resubscribed by the recipient',
              global_suppression_reset: 'Global suppression reset'
            },
            release: 'Release email',
            releaseTitle: 'Release email from the group',
            releaseDescription: 'The email will receive campaigns from this domain again. It stays in the list as "released", with the reason you provide.',
            reasonLabel: 'Reason *',
            reasonRequired: 'Enter a reason with at least 3 characters.',
            confirmRelease: 'Release',
            released: 'Email released.',
            releaseOnlyAdmin: 'Only account administrators can release emails.',
            empty: 'No unsubscribed emails in this group.',
            loadError: 'Could not load the data. Try again.',
            providerUnavailable: 'The email provider is unavailable right now. Try again in a moment.',
            rowsPerPage: 'Rows per page',
            retry: 'Try again',
            displayNameRequired: 'Enter the group name.',
            saveError: 'Could not save the group. Try again.',
            syncNow: 'Sync now',
            stillPending: 'The group is still syncing with the provider. We will retry automatically.',
            onlyAdminCanCreate: 'Only account administrators can create or sync the group.',
            editOnlyAdmin: 'Only account administrators can edit the group.',
            forbidden: 'You do not have permission for this action.',
            invalidPayload: 'Invalid data. Review the fields and try again.',
            genericError: 'Could not complete the operation. Try again.'
          },
          domains: {
            unsubscribeGroups: 'Unsubscribe groups',
            domainInUse: 'The unsubscribe group of this domain is in use by scheduled or ongoing dispatches. Finish or cancel them before deleting the domain.',
            providerUnavailable: 'The email provider is unavailable right now and the domain was not deleted. Try again in a moment.',
            deleteConsequence: 'The unsubscribe group and the unsubscribe list of this domain will also be deleted at the email provider.',
            preferences: 'Preferences',
            domains: 'Domains',
            addNewDomainsToThePlatform: 'Add new domains to the platform. First, the domain\'s DKIM, TXT and CNAME must be registered.',
            addDomain: 'Add domain',
            creation: 'Creation',
            domain: 'Domain',
            emails: 'E-mails',
            name: 'Name',
            actions: 'Actions',
            waiting: 'Waiting',
            verified: 'Verified',
            type: 'TIPO',
            host: 'HOST',
            data: 'DATA',
            verifyDomain: 'Verify domain',
            exclude: 'Delete',
            addNewDomain: 'Add new domain',
            insertRecords: 'Now you need to enter the following records into your DNS.',
            updateDomain: 'A propagação do seu DNS pode levar algumas horas, e o status do seu domínio será atualizado na plataforma.',
            record: 'Record',
            nameToUpperCase: 'NAME',
            valueToUpperCase: 'VALUE',
            cancel: 'Cancel',
            add: 'Add',
            addNewEmail: 'Add new email',
            confirmationEmail: 'You will receive a confirmation email, click on the link in the body of the email to proceed with the email verification.',
            email: 'Email',
            excludeDomain: 'Delete Domain',
            areYouSure: 'Are you sure you want to delete this domain?',
            domainSuccessfully: 'Domain successfully registered.',
            connectionError: 'Connection error',
            domainAlreadyRegistered: 'Domain already registered, try again with another one.',
            startTheProcess: 'To start the process you need a domain.',
            deletedDomain: 'Deleted domain.',
            domainSuccessfullyValidated: 'Domain successfully validated!',
            fieldsNotAuthenticated: 'There are some fields not yet authenticated, '
          },
          lists: {
            preferences: 'Preferences',
            lists: 'Lists',
            deleteSelectedLists: 'Delete selected lists',
            avatar: 'Avatar',
            title: 'Title',
            amount: 'Amount',
            actions: 'Actions',
            view: 'View',
            exclude: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            listData: 'List data',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            excludeList: 'Delete list',
            areYouSure: 'Are you sure you want to delete this list?',
            listDeleted: 'Your list has been deleted',
            errorDeleteThisList: 'Oops, we couldn\'t delete this list!'
          },
          dataBases: {
            importData: 'Import data',
            name: 'Name',
            cdt: 'Date/Hour',
            replaceData: 'Replace data',
            import: 'Import',
            importCSV: "Import CSV file",
            syncGoogleSheet: "Sync with Google Sheets",
            invalidSpreadsheetId: 'Invalid worksheet ID',
            foundSheets: 'Worksheets found',
            shareSpreadsheet: 'You need to share your spreadsheet with this email: ',
            listPages: 'List pages',
            reportSpreadsheetId: 'Enter the spreadsheet ID',
            reportTabSheet: 'Select the spreadsheet you want to import.',
            reportName: 'Put a name',
            alreadyBaseName: 'There already exists a base with this name',
            alreadyBaseSheetName: 'There is already a base with this spreadsheet page',
            dataGoogleSpreadSheet: 'Google spreadsheet data',
            deleteDataBase: 'Delete database',
            spreadSheetId: 'Google spreadsheet ID',
            sheetPageName: 'Page name',
            close: 'Close',
            delete: 'Delete'

          },
          status: {
            consult: 'Consult',
            consultDescription: 'Check the current status of a WhatsApp number within Globalbot and perform reset and blocking actions.',
            consultNumber: 'Check WhatsApp number',
            country: 'Country *',
            customerNumber: 'Customer WhatsApp Number *',
            alert: 'Attention:',
            alertDescription: 'Enter the customer\'s mobile number with 2-digit area code, example (XX) XXXXX-XXXX.',
            cancel: 'Cancel',
            phoneRequired: 'Fill in the phone number to consult.',
            status: 'Status:',
            statusMessage: {
              live: 'In conversation with attendant.',
              bot: 'In conversation with chatbot.',
              live_satisfactionSurvey: 'Conversation with attendant ended, now in satisfaction survey.',
              bot_satisfactionSurvey: 'Conversation with chatbot ended, now in satisfaction survey.',
              no_conversation: 'Not in conversation.',
              blocked: 'Blocked Number.'
            },
            reset: 'Reset',
            block: 'Block',
            resetNumber: 'Reset WhatsApp number',
            confirmReset: 'Please confirm the RESET of the WhatsApp number',
            resetDescription: 'From the moment of RESET the number will be unlinked from chatbot journey. The next user interaction will start the conversation with the chatbot.',
            resetBlockedWarning: 'This number is blocked on this chatbot. The reset ends the interaction but does not remove the block.',
            blockNumber: 'Block WhatsApp number',
            confirmBlock: 'Please confirm blocking the WhatsApp number',
            blockDescription: 'This number will no longer be able to interact with this chatbot until it is unblocked.',
            unblockNumber: 'Unblock WhatsApp number',
            confirmUnblock: 'Please confirm unblocking the WhatsApp number',
            unblockDesription: 'From this moment on this number will be free to interact with the chatbot',
            confirm: 'Confirm',
            current_status: {
              reseted: 'Number reset',
              blocked: 'Number blocked',
              unblocked: 'Number unblocked'
            },
            channel: 'Channel',
            cdt: 'Date and Time',
            back: 'Back',
            chatbot: 'Chatbot',
            number: 'Number',
            identification: 'Identification',
            identificationTooltip: 'Contact identification: the phone number or, when Meta does not provide a phone, the BSUID — the user identifier assigned by Meta (e.g. BR.1914261605930178).',
            condition: 'Condition',
            user: 'Author',
            actions: 'Actions',
            resetError: 'Oops! Unable to reset number.',
            resetSuccess: 'Number reset successfully!',
            blockError: 'Oops! Unable to block number.',
            blockSuccess: 'Number blocked successfully!',
            unblockError: 'Oops! Unable to unblock number.',
            unblockSuccess: 'Number unblocked successfully!',
            consultError: 'Oops! Unable to query number.',
            consultSuccess: 'Number is not in a conversation.',
            system: 'System',
            reason: 'Reason:',
            blockReason: {
              too_many_messages: 'More than 200 messages exchanged within 20 minutes.',
              loop_marker: 'The user moved back and forth more than 50 times to the same point in the flow.',
              lock_marker: 'The user repeatedly jumped to the same point in the flow more than 50 times.'
            },
            noInformation: 'No Information',
            numberNoConversationDescriprion: 'The number in question is not in any conversation. If you want to block this number, select the desired ChatBot below.',
            historyFilter: 'Action history',
            historyFilterTooltip: 'Shows only actions of the selected type. The list is the action history, from newest to oldest.',
            historyAll: 'All',
            historyAction: {
              blocked: 'Was blocked',
              unblocked: 'Was unblocked',
              reseted: 'Was reset'
            },
            viewHistory: 'View history',
            historyTitle: 'Action history',
            historyEmpty: 'No actions recorded for this number.',
            historyError: 'Oops! Could not load the history.',
            listError: 'Oops! Could not load the number list.',
            tryAgain: 'Try again',
            close: 'Close'
          },
          live: {
            serviceMessages: 'Service messages',
            portuguese: 'Portuguese',
            english: 'English',
            spanish: 'Spanish',
            completionMessage: 'Completion message',
            finishAndArchivedMessage: 'Finish and archive message',
            archivalMessage: 'Archival message',
            transferMessage: 'Transfer message',
            automaticTransferToAttendant: 'Automatic transfer to attendant',
            transshipmentAvailableForAttendants: 'Transshipment available for attendants',
            queueTransshipmentWithoutDistribution: 'Queue transshipment (without distribution)',
            queueTransshipmentWithDistribution: 'Queue transshipment (with distribution)',
            queuePositionLabel: 'Message to transmit position in the queue',
            queuePositionVariableRequired: 'This message needs the %POSITION% variable',
            deliveryTitle: 'Sending to the customer',
            deliveryDescription: 'Choose which automatic messages the customer receives. A disabled message is not sent, but it is still recorded in the conversation for auditing, marked as not sent.',
            deliveryReadOnlyHint: 'Platform default text, not editable.',
            deliveryEditableHint: 'Text configurable above.',
            sendToCustomer: 'Send to customer',
            deliveryTypes: {
              take_room: { label: 'Attendant took over the service', example: '{name} took over this service.' },
              transfer_room: { label: 'Conversation transferred', example: '{name} transferred this room.' },
              finish_room: { label: 'Service finished', example: '{name} finished the service.' },
              finish_and_archive_room: { label: 'Service finished and archived', example: '{name} finished and archived the service.' },
              archive_room: { label: 'Service archived', example: '{name} archived the room.' },
              with_attendant: { label: 'Automatic transfer to attendant', example: 'With attendant.' },
              available: { label: 'Transshipment available for attendants', example: 'Available.' },
              queue: { label: 'Queue transshipment (without distribution)', example: 'In line.' },
              queue_distribution: { label: 'Queue transshipment (with distribution)', example: 'Automatic queued' },
              waiting: { label: 'Waiting for attendant', example: 'Waiting.' },
              no_vacancy: { label: 'No attendant available', example: 'Text defined in the Live Chat node of the flow.' },
              finished_reply: { label: 'Reply in an already finished conversation', example: 'Uses the completion message.' },
              user_reconnected: { label: 'Customer returned to the chat', example: 'The user returned to the chat.' }
            },
            transshipmentAwaitingAttendants: 'Transshipment awaiting attendants (check in disabled)',
            noAttendantsAvailable: 'No attendants available (check in enabled)',
            tipDepartmentIsPersistent: 'It is not possible to activate check-in as this department is configured in the bots persistence: ',
            pauseOptions: 'Pause Options',
            activated: 'Activated',
            disabled: 'Disabled',
            enterHereAll: 'Enter here all possible breaks that attendants can select.',
            add: 'Add option',
            automaticAway: 'Automatic away',
            determineTheCheckInTime: 'Determine the check-in time.',
            time: 'Time',
            viewingOptions: 'Viewing Options',
            autoArchive: 'Time for conversations archive',
            autoArchiveCaption: 'Configure the live chat auto conversation archive.',
            conversationCloseOptions: "Conversation Close Options",
            conversationCloseOptionsDescription: "Enable tagging or assigning value when closing a conversation.",
            addTag: "Assign Tags",
            addMonetary: "Assign Value",
            requiredTagsBatch:'Conversations without tags, set the tags to end the conversations!',
requiredMonetaryValueBatch:'Conversations without value, set the monetary value to end the conversations!',
            errorReasonPhrases: {
              ROOM_NOT_FOUND: 'Conversation not found.',
              ROOM_NOT_FINISHED: 'The conversation was not finished.',
              NO_ATTENDANTS: 'No attendants in the conversation.',
              MISSING_INFORMATION: 'Missing information.',
              UNKNOWN_ERROR: 'Unknown error.',
              ROOM_ALREADY_CLOSED: 'The conversation has already been closed.',
            },
            required: "Required",
            coin: "Currency",
            coinTypes: {
              BRL: "Brazilian Real - BRL",
              USD: "American Dollar - USD"
            },
            chooseTheLevel: 'Choose the level of access your operators will be able to see in the attendant list.',
            managers: 'Managers',
            attendants: 'Attendants',
            departments: 'Departments',
            newDepartment: 'New department',
            newDepartmentDescription: 'Create departments to organize and direct conversations for human service.',
            addDepartment: 'Add a new one',
            actions: 'Actions',
            color: 'Color',
            defineTheDepartments: 'Define the departments of the Live Chat module below. Departments are useful for "routing" contact requests, handling them in a segmented way.',
            whenCreatingTheDepartments: 'When creating the departments, use the User settings to define in which department(s) each user can operate.',
            name: 'Name',
            setBehavior: 'Set the inbound behavior if you don\'t have any attendants online at the moment.',
            checkIn: 'Check-in',
            forcePass: 'Force Pass',
            forcePassDescription: 'Also distribute calls to offline attendants.',
            forcePassDistributionNone: 'You need to select a distribution type when Force Pass is enabled.',
            queueDisable: 'The Queue is mandatory when Force Pass is enabled.',
            queuePositionDisable: 'Transmit Queue Position can only be enabled with Queueing enabled and a Distribution type selected.',
            forcePassDisable: 'It is not possible to activate Force Pass with Check-in enabled.',
            checkInDisable: 'It is not possible to activate Check-in with Force Pass enabled.',
            attendanceQueue: 'Attendance queue',
            lastUpdate: 'Last update',
            persistence: 'Persistence',
            persistenceDescription: 'The persistence feature sends messages to the customer when they are inactive in Live Chat, with the goal of obtaining a response to expedite service.',
            activatePersistence: 'Activate Persistence',
            firstMessageIn: 'First message in',
            secondMessageIn: 'Second message in',
            firstMessageTooltip: 'Time to send the first persistence message',
            secondMessageTooltip: 'Time to send the second persistence message',
            transmitQueuePosition: 'Transmit queue position',
            transmitQueuePositionDescription: 'Broadcast the position of the queue to the waiting customers.',
            maxAttendances: 'Maximum attendance',
            maxAttendancesDescription: 'Set the maximum amount that each server can serve simultaneously.',
            customersByAttendants: 'Customers by attendants',
            distribution: 'Distribution',
            distributionDescription: 'Choose the way to distribute the calls in the Live Chat module.',
            balancing: 'Balancing',
            disabledNone: 'Disabled',
            businessHours: 'Journey',
            businessHoursDescription: 'Choose a journey to define department business hours.',
            autoBalance: 'Auto Balance',
            sequential: 'Sequential',
            save: 'Save',
            confirm: 'Confirm',
            exclude: 'Delete',
            addDepartment: 'Add department',
            cantDeleteDepartmentUser: 'You cannot delete this department because there are people linked to it:',
            cantDeleteDepartmentPersistence: 'You cannot delete this department because there are bots linked to it in the persistence configuration:',
            areYouSureSaved: 'Are you sure you want to save the changes?',
            areYouSureDeleted: 'Are your sure you want to delete this deparment?',
            youCanChange: 'You can change the settings whenever you want, but the',
            previousContent: 'previous content cannot be restored.',
            cancel: 'Cancel',
            finishRoom: 'The conversation ended.',
            archiveRoom: 'The conversation has been archived.',
            transferRoom: 'The conversation was transferred.',
            withAttendant: 'With attendant.',
            available: 'Available.',
            queue: 'In line.',
            queueDistribution: 'Automatic queued',
            waiting: 'Waiting',
            noVacancy: 'No attendant at the moment.',
            oneMinute: '1 minute',
            twoMinutes: '2 minutes',
            threeMinutes: '3 minutes',
            fourMinutes: '4 minutes',
            fiveMinutes: '5 minutes',
            tenMinutes: '10 minutes',
            fifteenMinutes: '15 minutes',
            thirtyMinutes: '30 minutes',
            oneHour: '1 hour',
            sixHours: '6 hours',
            twelveHours: '12 hours',
            oneDay: '1 Day',
            twoDays: '2 days',
            threeDays: '3 days',
            fourDays: '4 days',
            fiveDays: '5 days',
            seeAll: 'See all',
            onlyDepartments: 'See only in departments',
            preferences: 'Preferences',
            liveChat: 'Live chat',
            behavior: 'Behavior',
            updated: 'Updated!',
            myDepartment: 'My department',
            departmentAdded: 'Department added!',
            deletedDepartment: 'Deleted department!',
            none: 'None',
            noDistribution: 'No distribution',
            active: 'Active',
            inactive: 'Inactive',
            quantity: 'Quantity',
            attendanceDistribution: 'Attendance Distribution',
            attendanceDistributionDescription: 'Define how attendances will be distributed in this department.',
            balanced: 'Balanced',
            noDistributionDescription: 'Attendances will not be distributed. They will remain on hold. Attendants must pick them up and take them individually.',
            sequentialDescription: 'Attendances will be distributed sequentially to the available attendants in the department. The first available attendant will receive the attendance and so on.',
            balancedDescription: 'Attendances will be distributed among the attendants in the department considering who has the lowest volume.',
            additionalConfiguration: 'Additional Configurations',
            edit: 'Edit',
            confirm: 'Confirm',
            addDepartment: 'Add department',
            updateDepartment: 'Update department',
          },
          settings: {
            user: 'My Profile',
            userDescription: 'View and edit your login and registration information.',
            preferences: 'Preferences',
            users: 'Users',
            usersDescription: 'Administer Globalbot platform users. You can add, exclude users, and set and edit access permissions and roles for each of them independently.',
            liveChat: 'Live chat',
            liveChatDescription: 'Configure the Live Chat module settings. Create departments, define the form of distribution of calls and automatic messages.',
            tags: 'Tags',
            customFields: 'Fields and Sectionss',
            tagsDescription: 'Access the tag system settings, which can be used to tag and classify various items in a list or collection (eg Conversations, Intelligence and Library)',
            tagsDescriptionMini: 'Create and edit the tags you will use to mark and classify conversations.',
            domainsAndEmail: 'Domains and Emails',
            domainsAndEmailDescription: 'Configure your company\'s domains and emails so that they appear as senders in Messenger submissions (emails, notifications and notices).',
            lists: 'Lists',
            listsDescription: 'Access and control all lists created and uploaded to the platform.',
            liveChatConfigs: {
              messages: 'Messages',
              messagesDescription: 'Check and edit the preset messages for Live Chat.',
              behavior: 'Behavior',
              behaviorDescription: 'Configure the behavior of features in Live Chat.',
              departmentsConfig: 'Departments',
              departmentsConfigDescription: 'Configure departments to organize and direct conversations for human service.'
            },
            dataBases: 'Data Base',
            dataBasesDescription: 'Import external databases to be integrated with chatbot flows.',
            numberStatus: 'Status and Blocks',
            numberStatusDescription: 'Check WhatsApp number status of customers and block them if necessary.',
            optout: 'Opt-Out',
            optoutDescription: 'Access and manage the people who have chosen not to receive messages from your company (Opt-Out).',
            crmDescription: 'Create and edit sections and custom fields to organize people and company registrations and import records.',
            whatsappConsumption: 'WhatsApp Consumption',
            whatsappConsumptionDescription: 'Check the WhatsApp consumption and add credits when necessary.'
          },
          whatsappConsumption: {
            additionalFilters: 'Additional filters',
            availableBalance: 'Available balance',
            balanceLimit: 'Limit',
            refreshBalance: 'Refresh balance',
            balanceError: 'The balance could not be loaded. Please try again.',
            addCredits: 'Add Credits',
            charges: {
              title: 'Charge history',
              statusFilter: 'Status',
              createdAt: 'Requested on',
              amount: 'Amount',
              paymentMethod: 'Payment method',
              status: 'Status',
              dueDate: 'Due date',
              paidAt: 'Paid on',
              requestedBy: 'Requested by',
              description: 'Description',
              paidAmount: 'Amount paid',
              currency: 'Currency',
              exportCsv: 'Export CSV',
              exportSuccess: 'Report generated successfully.',
              exportError: 'Could not generate the charge report.',
              csvFilename: 'charge-history',
              providerChargeId: 'Provider id',
              registrationStatus: 'Boleto registration',
              registrationRegistered: 'Registered',
              registrationPending: 'Pending bank approval',
              registrationPendingHint: 'This approval can take 1 to 5 minutes before the boleto can be paid.',
              registrationRejected: 'Could not generate boleto',
              registrationUnknown: 'Registration not confirmed',
              unknownUser: 'Removed user',
              empty: 'No charges registered.',
              error: 'The charge history could not be loaded.',
              statuses: {
                created: 'Registered',
                pending_confirmation: 'Awaiting provider confirmation',
                pending: 'Awaiting payment',
                paid: 'Paid',
                cancelled: 'Cancelled',
                expired: 'Expired',
                failed: 'Failed'
              }
            },
            charge: {
              title: 'Request credits',
              hint: 'We create a charge and return the payment link. The balance is added as soon as the payment is confirmed.',
              amount: 'Top-up amount',
              amountHint: 'Between',
              paymentMethod: 'Payment method',
              paymentMethodRequired: 'Choose a payment method.',
              paymentMethods: {
                boleto_pix: 'Boleto / Pix',
                cheque: 'Check',
                dinheiro: 'Cash',
                cartao_credito: 'Credit card',
                cartao_debito: 'Debit card',
                deposito: 'Deposit',
                cheque_pre_datado: 'Post-dated check',
                debito_automatico: 'Direct debit',
                transferencia_bancaria: 'Bank transfer',
                doc_ted: 'DOC / TED',
                outros: 'Other'
              },
              description: 'Description (optional)',
              dueDateField: 'Due date (optional)',
              dueDateHint: 'If not set, the bill will be due in {days} days.',
              dueDateOutOfRange: 'The due date must be between',
              descriptionHint: 'Shown on the charge sent to your finance team.',
              submit: 'Request',
              created: 'Charge created',
              dueDate: 'Due on',
              reused: 'This request had already been created; we returned the same charge.',
              checkoutLabel: 'Payment link',
              checkoutPending: 'The charge was registered, but the link is not available yet. Check again shortly.',
              openCheckout: 'Open payment link',
              copyLink: 'Copy link',
              linkCopied: 'Link copied!',
              invalidAmount: 'Enter a valid amount.',
              amountOutOfRange: 'The amount must be between',
              amountNotWhole: 'Enter a whole amount, without cents.',
              errorGatewayNotConfigured: 'This account is not registered with the payment provider yet. Talk to your account manager.',
              errorModelNotEnabled: 'This account is not on the per-message balance model.',
              errorForbidden: 'You do not have permission to request credits for this account.',
              errorGateway: 'The payment provider did not respond. Please try again in a few minutes.',
              errorGeneric: 'The charge could not be created. Please try again.'
            },
            chart: {
              title: 'Consumption Report',
              seriesService: 'Service',
              debited: 'Debited',
              exportCsv: 'Export CSV',
              totalMessages: 'Messages',
              totalMessagesHint: 'Total service messages delivered in the period, for the chatbots in the filter.',
              retry: 'Try again',
              empty: 'No consumption in the period',
              emptyHint: 'Only WhatsApp service messages show up here.',
              errorForbidden: 'You do not have permission to see this account consumption.',
              errorValidation: 'Review the filter: the period or the selected chatbots were not accepted.',
              errorGeneric: 'The consumption report could not be loaded.',
              csvPeriod: 'Period',
              csvMessages: 'Service messages',
              csvDebits: 'Debited',
              csvCredits: 'Credited',
              csvNet: 'Period balance',
              csvFilename: 'whatsapp-consumption'
            }
          },
          contacts: {
            contacts: 'Contacts',
            people: 'People',
            companies: 'Companies'
          },
          optout: {
            optout: 'Opt-Out',
            reseted: 'Reverted to Opt-In',
            add: 'Add',
            addDescription: 'Manually add a WhatsApp number so the person no longer receives messages from the company.',
            permanence: 'Permanence',
            permanenceDescription: 'MASTER: Set how long the record stays in Opt-Out. (Default: permanent)',
            tableColumns: {
              channel: 'Channel',
              cdt: 'Date and Time',
              chatbot: 'Chatbot',
              number: 'Number',
              condition: 'Condition',
              user: 'Author',
              actions: 'Actions',
            },
            addOptout: 'Add Opt-Out',
            important: 'Attention:',
            importantDescription: 'Enter the customer\'s mobile number including the 2-digit area code, e.g.: (XX) XXXXX-XXXX.',
            customerPhone: 'Customer WhatsApp Number*',
            country: 'Country*',
            cancel: 'Cancel',
            close: 'Close',
            advance: 'Next',
            confirm: 'Confirm',
            revertToOptIn: 'Revert to Opt-In',
            confirmChange: 'Please confirm this change to the WhatsApp number',
            backToReceiveMessage: 'This number will start receiving messages from the company again.',
            permanenceDrawer: {
              permanence: 'Permanence',
              permanenceDescription: 'Set how long a person remains in Opt-Out. By default, the permanence period is “forever”. If you select another option, the Opt-Out status will expire according to your choice and the Permanence Rules.',
              permanenceRules: 'Permanence Rules',
              permanenceRulesDescriptionOne: 'Once enabled, permanence time will be retroactive. As soon as you activate or edit the feature, it will start counting time for all records.',
              permanenceRulesDescriptionTwo: 'And if you disable the feature, all permanence time counts (if there were any) will be canceled and the records will remain in Opt-Out permanently.',
              forever: 'forever',
              fifteenDays: 'for 15 days',
              thirtyDays: 'for 30 days',
              ninetyDays: 'for 90 days',
              oneHundredEightyDays: 'for 180 days',
              originNumber: 'Origin number',
              permanenceOptout: 'Remain in Opt-Out'
            },
            selectChatbot: 'Select the numbers to be added to Opt-Out. These numbers will no longer receive messages from the company via the selected Chatbot(s).',
            phoneRequired: 'Fill in the phone number to add.',
            consultError: 'Oops! Unable to consult the number.',
            numberSituation: {
              live: 'In conversation with an agent.',
              bot: 'In conversation with the chatbot.',
              live_satisfactionSurvey: 'Conversation with the agent ended, now the user is answering the satisfaction survey.',
              bot_satisfactionSurvey: 'Conversation with the chatbot ended, now the user is answering the satisfaction survey.',
              no_conversation: 'Not in a conversation.',
              optout: 'Already opted out.'
            },
            resetError: 'Oops! Error while reverting to Opt-In.',
            resetSuccess: 'Successfully reverted to Opt-In!',
            permanenceSuccess: 'Permanence times successfully set!',
            permanenceError: 'Oops! Error while setting permanence times.',
            selectRow: 'No phone was selected.',
            insertError: 'Oops! Error while setting Opt-Out for bot: ',
            customer: 'Customer',
            customerDescriptionOptout: 'Customer chose not to receive messages anymore (Opt-Out)',
            customerDescriptionReset: 'Customer started a new conversation with the company (Opt-In)',
            system: 'System',
            systemDescriprion: 'Reverted to Opt-In due to Inactivity Timeout',
            back: 'Back'
          },
          tags: {
            preferences: 'Preferences',
            tags: 'Tags',
            add: 'Add',
            columns: 'Columns',
            color: 'Color',
            category: 'Category',
            title: 'Title',
            description: 'Description',
            actions: 'Actions',
            edit: 'Edit',
            exclude: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            tagData: 'Tag Data',
            deleteTag: 'Delete tag',
            areYouSureDelete: 'Are you sure you want to delete this tag? This action cannot be undone.',
            general: 'General',
            reports: 'Reports',
            realTime: 'Real time',
            analytics: 'Statistics',
            organization: 'Organization',
            companies: 'Companies',
            people: 'People',
            conversation: 'Conversations',
            flow: 'Flow',
            knowledge: 'Intelligence',
            message: 'Message',
            liveChat: 'Live chat',
            library: 'Library',
            tasks: 'Tasks',
            deletedTag: 'Deleted tag.',
            errorDeleteThisTag: 'Oops, we couldn\'t delete this tag!',
            errorSavingTag: 'Oops, some error happened while saving the tag.',
            requiredFields: 'The title and color field need to be filled.'
          }
        }
      },
      general: {
        cancel: 'Cancel',
        save: 'Save',
        confirm: 'Confirm',
        close: 'Close',
        back: 'Back',
        advance: 'Advance',
        attention: 'Attention',
        test: 'Test',
        start: 'Start',
        retract: 'Retract',
        users: 'Users',
        campaigns: 'Campaigns',
        note: 'Note',
        edit: 'Edit',
        delete: 'Delete',
        clear: 'Clear',
        rename: 'Rename'
      }
    },
    'es-ES': {
      session: {
        policyTitle: 'Un dispositivo por usuario',
        policyDescription: 'Cuando está activado, iniciar sesión en un dispositivo nuevo finaliza la sesión anterior del mismo usuario. Varias pestañas del mismo navegador siguen funcionando.',
        stateOn: 'Activado',
        stateOff: 'Desactivado',
        policyUpdated: 'Configuración actualizada.',
        policyError: 'No se pudo actualizar la configuración.',
        viewDevices: 'Ver dispositivos conectados',
        revokedNewDevice: 'Se accedió a su cuenta desde otro dispositivo. Esta sesión ha finalizado.',
        revokedByAdmin: 'Su sesión fue finalizada por un administrador.',
        title: 'Dispositivos conectados',
        subtitle: 'Dónde está abierta esta cuenta ahora',
        devices: 'dispositivos',
        device: 'dispositivo',
        currentDevice: 'Este dispositivo',
        lastSeen: 'Último acceso',
        firstSeen: 'Primer acceso',
        revoke: 'Finalizar sesión',
        revokeConfirm: '¿Finalizar la sesión de este dispositivo? La persona se desconectará de inmediato.',
        revoked: 'Sesión finalizada.',
        revokeError: 'No se pudo finalizar la sesión.',
        noDevices: 'Ningún dispositivo conectado.'
      },
      components: {
        sounds: {
          audioBlocked: '🔈 Para escuchar las notificaciones sonoras, interactúe con la pantalla haciendo clic en cualquier lugar.'
        },
        tables: {
          noDataLabel: 'No hay registros disponibles.',
          dragTableColumns: 'Arrastre las columnas'
        },
        selects: {
          noSearchResults: 'No se encontraron resultados'
        },
        action: {
          requisition: {
            request: 'Solicitud',
            method: 'Método',
            run: 'Run',
            messageError: 'Vaya, faltan datos.'
          },
          copyToClipboard: '¡Copiado al portapapeles!',
          copyToClipboardError: 'Error al copiar al portapapeles.',
          editCode: 'Editar código',
          copyCode: 'Copiar código',
          showEditableBlock: 'Ver apenas bloco editável',
          showFullCode: 'Ver código completo',
          editableBlockNotFound: 'Não foi possível localizar o bloco editável',
        },
        advancedSearch: {
          index: {
            myFilters: 'Mis filtros de búsqueda',
            custom: 'Personalizado',
            today: 'Hoy dia',
            yesterday: 'El dia de ayer',
            thisMonth: 'Este mes',
            lastSevenDays: 'Los últimos 7 días',
            lastFifteenDays: 'Los últimos 15 días',
            lastThirtyDays: 'Los últimos 30 días',
            personalized: 'Personalizado',
            search: 'Buscar',
            initialDate: 'La fecha de inicio',
            initialHour: 'Hora de inicio',
            endDate: 'Fecha final',
            endHour: 'Hora de finalización',
            chatbots: 'Chatbots',
            channel: 'Canal',
            all: 'Todos',
            webchat: 'Webchat',
            dialogue: 'Diálogo',
            dialogueDescription: 'Puede filtrar por quién inició la conversación, asistente o cliente.',
            from: 'De',
            to: 'A',
            botDeleted: 'Robot eliminado',
            active: 'Chatbot/Activo',
            receptive: 'Cliente/Receptivos',
            whatsapp: 'Whatsapp',
            messenger: 'Messenger',
            gbm: 'Google Business Messages',
            rcs: 'RCS',
            instagram: 'Instagram',
            telegram: 'Telegram',
            identifiers: 'Identificadores',
            filter: 'Filtrar',
            fill: 'Llenar',
            filled: 'Lleno',
            notFilled: 'No llenado',
            transhipment: 'Transbordo',
            transhipmentDescription: 'Esta es una característica nueva, los filtros basados en este campo no se aplican a fechas anteriores al 19/03/2020.',
            withAttachments: 'Con archivos adjuntos',
            indifferent: 'Indiferente',
            attended: 'Asistió',
            notAttended: 'No asistió',
            unrealized: 'No realizados',
            none: 'Ninguno',
            attendants: 'Acomodadores',
            departments: 'Departamentos',
            otherOptions: 'Otras opciones',
            onlyConversations: 'Solo conversaciones',
            allConversations: 'Todos',
            incompleteConversations: 'Incompleta',
            conversationFinished: 'Finalizada',
            satisfaction: 'Satisfacción',
            oneStar: '1 estrella',
            twoStar: '2 estrellas',
            threeStar: '3 estrellas',
            fourStar: '4 estrellas',
            fiveStar: '5 estrellas',
            tags: 'Tags',
            term: 'Términos',
            inIdentifier: 'En el identificador',
            clear: 'Limpiar',
            createFilter: 'Crear filtro',
            title: 'Título',
            save: 'Guardar',
            messageError: 'Vaya, hubo un error.',
            listBy: 'Lista de ',
            savedFilter: '¡Tu filtro se ha guardado!',
            of: 'de',
            selectAll: 'Todo',
            interno: 'Interno',
          }
        },
        advancedSearchCrm: {
          index: {
            people: 'Personas',
            companies: 'Empresas',
            equal: 'es igual a',
            notEqual: 'no es igual a',
            filled: 'está lleno',
            notFilled: 'no está lleno',
            contains: 'contiene',
            notContains: 'no contiene',
            greaterThan: 'mayor que',
            lessThan: 'menor que',
            field: 'Campo',
            condition: 'Condición',
            value: 'Valor',
          }
        },
        analytics: {
          quickview: {
            conversation: {
              noDataAvailable: 'Datos no disponibles.'
            },
            knowledge: {
              noDataAvailable: 'Datos no disponibles.'
            },
            rating: {
              noDataAvailable: 'Datos no disponibles.'
            },
            usersConnected: {
              noDataAvailable: 'Datos no disponibles.'
            }
          },
          attendants: {
            attendants: 'Acomodadores',
            satisfaction: 'Satisfacción',
            attendance: 'Asistencias',
            reviewsAnswered: 'Reseñas respondidas',
            onlineTime: 'Tiempo Online',
            awayTime: 'Tiempo Away',
            tta: 'TTA - (Tiempo total de asistencia)',
            tma: 'TMA - (Tiempo medio de asistencia)',
            tme: 'TPE - (Tiempo promedio de espera)',
            tte: 'TTE - (Tiempo total de espera)',
            noDataAvailable: 'Datos no disponibles.',
            name: 'Nombre',
            filteredConversations: 'Conversaciones en el filtro',
            participations: 'Asistencias (participaciones)',
            totalsHint: 'Conversaciones en el filtro es el total de conversaciones que cumplen los filtros aplicados, el mismo número del indicador de la búsqueda avanzada. Asistencias cuenta la participación de cada acomodador: una conversación transferida suma una asistencia para cada uno de ellos, y una conversación que no llegó a ningún acomodador no suma ninguna.',
            loadError: 'No se pudieron cargar los indicadores por acomodador.',
            tryAgain: 'Intentar de nuevo'
          },
          botAndAttendant: {
            attendants: 'Acomodadores',
            noDataAvailable: 'Datos no disponibles.',
            chatbots: 'Chatbots'
          },
          bubble: {
            sunday: 'Domingo',
            hours: ' horas',
            attendance: ' asistencias'
          },
          campaign: {
            utmSource: 'UTM Source',
            tip: 'TIP',
            utmMedium: 'UTM Medium',
            utmCampaign: 'UTM Campaign',
            utmTerm: 'UTM Term',
            utmContent: 'UTM Content',
            withCampaign: 'Con campaña',
            withoutCampaign: 'Sin campaña'
          },
          channel: {
            noDataAvailable: 'Datos no disponibles.',
            total: 'Total',
            impressions: 'Impresiones',
            impressionsDescription: 'En WebChat, es el volumen de veces que el chatbot apareció disponible para hacer clic/activar.',
            attendance: 'Asistencias',
            attendanceDescription: 'Cuando un usuario (cliente) activa el chatbot para iniciar la conversación y se inicia una asistencia.',
            messages: 'Mensajes',
            messagesDescription: 'Volumen total de mensajes intercambiados en todas las conversaciones (respuestas). Ingrese usuario (cliente), chatbots y asistentes (si corresponde).',
            ttAttendance: 'TT Asistencia',
            ttAttendanceDescription: 'Es el tiempo total de servicio del canal, desde el momento de la activación hasta el final de la conversación.',
            tmAttendance: 'TM Asistencia',
            tmAttendanceDescription: 'Es el tiempo medio de servicio del canal, considerando el período.',
            totalTransshipments: 'Transbordos totales',
            totalTransshipmentsDescription: 'Número de solicitudes en las que el chatbot solicita la asistencia de un asistente, ya sea desencadenado por una regla de flujo o por el usuario (cliente).',
            transshipmentsAttended: 'Transbordos atendidos',
            transshipmentsAttendedDescription: 'Número de llamadas en las que el chatbot pasó la conversación al asistente y él pudo responder.',
            unattendedTransshipments: 'Transbordos desatendidos',
            unattendedTransshipmentsDescription: 'Número de llamadas en las que el chatbot pasó la conversación al asistente y no pudo responder.',
            unrealizedTransshipments: 'Transbordos no enviados',
            unrealizedTransshipmentsDescription: 'Número de llamadas en las que el chatbot no pudo transferir la conversación a un asistente (no había asistentes en línea en ese momento). El chatbot reanudó la conversación.',
            ttWait: 'TT Espera',
            ttWaitDescription: 'Es el tiempo total que los usuarios (clientes) permanecieron en espera para ser atendidos por los asistentes (cuando la cola de servicio está habilitada).',
            tmWait: 'TM Espera',
            tmWaitDescription: 'Es el tiempo medio que los usuarios (clientes) permanecieron en espera para ser atendidos por los asistentes (cuando la cola de servicio está habilitada).',
            satisfaction: 'Satisfacción',
            satisfactionDescription: 'Es el índice de satisfacción del servicio en general (una encuesta que se activa al finalizar la asistencia). Escala de 0 a 5 y número de encuestados entre paréntesis.',
            monetaryValueDescription: 'Consulta el valor total generado por las conversaciones durante el periodo (muy útil para quienes venden productos y servicios). Para aparecer aquí, el valor debe asignarse a cada conversación individualmente.',
            january: 'Enero',
            february: 'Febrero',
            march: 'Marcha',
            april: 'Abril',
            may: 'Mayo',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
            shortJan: 'Ene',
            shortFeb: 'Feb',
            shortMar: 'Mar',
            shortApr: 'Abr',
            shortMay: 'May',
            shortJun: 'Jun',
            shortJul: 'Jul',
            shortAug: 'Ago',
            shortSep: 'Sep',
            shortOct: 'Oct',
            shortNov: 'Nov',
            shortDec: 'Dic',
            sunday: 'Domingo',
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes',
            saturday: 'Sábado',
            shortSunday: 'Dom',
            shortMonday: 'Lun',
            shortTuesday: 'Mar',
            shortWednesday: 'Mié',
            shortThursday: 'Jue',
            shortFriday: 'Vie',
            shortSaturday: 'Sab',
            exportToSVG: 'Exportar a SVG',
            exportToPNG: 'Exportar a PNG',
            exportToCSV: 'Exportar a CSV',
            menu: 'Menú',
            selection: 'Seleccione',
            selectionZoom: 'Seleccionar zoom',
            zoomIn: 'Acercarse',
            zoomOut: 'Disminuir el zoom',
            pan: 'Para mover',
            reset: 'Volver al valor predeterminado'
          },
          city: {
            noDataAvailable: 'Datos no disponibles.',
            others: 'Otros'
          },
          country: {
            noDataAvailable: 'Datos no disponibles.',
            others: 'Otros'
          },
          department: {
            noDataAvailable: 'Datos no disponibles.'
          },
          heat: {
            sunday: 'Domingo',
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes',
            saturday: 'Sábado',
            hours: ' horas',
            attendance: 'Atenciones'
          },
          identifier: {
            selectIdentifier: 'Seleccione un identificador',
            noDataAvailable: 'Datos no disponibles.',
            others: 'Otros',
            limitCards: 'Cantidad máxima de 12 vistas. Para crear una nueva, por favor elimine una existente.'
          },
          knowledgeAnswered: {
            noDataAvailable: 'Datos no disponibles.',
            answered: 'Contestado',
            unambiguous: 'Desambiguación',
            unanswered: 'Sin respuesta',
            outContext: 'Fuera de contexto'
          },
          knowledgeResponses: {
            noDataAvailable: 'Datos no disponibles.',
            others: 'Otros'
          },
          pivot: {
            origin: 'Origen',
            total: 'Total'
          },
          platform: {
            noDataAvailable: 'Datos no disponibles.',
            incognito: 'Incógnito'
          },
          sankey: {
            noDataAvailable: 'Datos no disponibles.',
            to: 'Para',
            from: 'De',
            amount: 'La cantidad'
          },
          state: {
            noDataAvailable: 'Datos no disponibles.',
            others: 'Otros'
          }
        },
        crm: {
          expansion: {
            required: 'Campo requerido',
            attach: 'Adjuntar',
            noData: 'Ningún documento registrado',
            noPermission: 'Sin permiso para visualizar',
            deleted: '¡Contacto eliminado!',
            updated: '¡Documento actualizado!',
            uploading: 'Subiendo archivo...',
            removed: 'Archivo removido',
            phoneError: 'Número de teléfono no válido para el país seleccionado.'
          }
        },
        drawers: {
          crm: {
            section: {
              sectionData: 'Nova Sección',
              editSection: 'Editar Sección',
              nameRequired: 'Nome*',
              description: 'Descrição',
              newSection: 'Cree una nueva Sección, que contendrá varios campos personalizados.',
              permissions: 'Permisos',
              required: 'Campo Requerido.',
              type: 'Tipo*',
              useFields: 'Usar campos de esta sección para la lista de contactos.',
              whoCanSeeAndEdit: 'Quién puede ver esta sección.',
              canView: 'Ver',
              canEdit: 'Editar',
              fillAllRequiredFields: 'Complete todos los campos requeridos',
              sectionSaved: 'Sección guardada.',
              people: 'Persona',
              company: 'Empresa',
              admin: 'Administrador',
              manager: 'Gerente',
              attendant: 'Atendente'
            },
            custom: {
              sectionData: 'Novo Campo',
              editCustom: 'Editar Campo',
              nameRequired: 'Nome*',
              description: 'Descrição',
              newSection: 'Crea un nuevo campo, definiendo sus parámetros y vinculándolo a uno.',
              permissions: 'Permisos',
              mask: 'Máscara',
              currency: 'Divisa',
              placeholder: 'Marcador de posición',
              required: 'Campo Requerido.',
              section: 'Sección*',
              type: 'Tipo*',
              writeOption: 'Escriba una opción',
              addOption: 'Agregar opción',
              name: 'Nombre',
              token_label: 'token',
              name_label: 'Nombre',
              token_placeholder: 'token',
              interactionKey: 'Campo clave para agrupación de interacciones',
              whoCanSeeAndEdit: 'Quién puede ver o editar.',
              canEdit: 'Editar',
              canView: 'Ver',
              admin: 'Administrador',
              manager: 'Gerente',
              attendant: 'Atendente',
              text: 'Texto',
              editor: 'Texto Grande',
              name: 'Nome',
              email: 'E-mail',
              number: 'Número',
              decimal: 'Número (com decimais)',
              date: 'Data',
              coin: 'Moeda (tipo internacional)',
              url: 'URL',
              tel: 'Telefone',
              list: 'Lista de Única Escolha',
              image: 'Imagem',
              file: 'Documento',
              cnpj: 'CNPJ',
              cpf: 'CPF',
              cep: 'CEP',
              fieldSaved: 'Campo salvo.',
              tokenExists: 'Este token já existe para esta seção.',
              fillAllRequiredFields: 'Preencha todos os campos abrigatórios'
            },
            imports: {
              importsData: 'Importación de Registros',
              fieldCompatibility: 'Compatibilidad de Campos',
              importRules: 'Reglas de Importación',
              nameRequired: 'Nombre*',
              required: 'Campo obligatorio.',
              importType: 'Importar registros del tipo*',
              example: 'Ejemplo Mensajería.csv',
              fieldCompatibilityDescription: 'Asocie los campos encontrados en su hoja de cálculo con los campos ya configurados en el módulo Contactos.',
              note: 'NOTA: ',
              fieldCompatibilityNote: 'Solo se asociarán los campos que son compatibles (ej. número en campo del tipo "numérico").',
              keyFieldDescription: 'El campo-clave sirve para verificar si los registros que se están importando coinciden con registros que ya existen en el sistema.',
              keyFieldDescriptionTwo: 'Si el registro ya existe, qué debe hacerse:',
              keepExisting: '"Mantener lo que ya existe" no importará los registros en los cuales el campo-clave coincide. "Reemplazar con los datos importados" reemplazará todos los campos del registro que contengan datos en esta importación.',
              selectAction: 'Seleccione una acción',
              listImported: 'Lista importada con éxito.',
              fillAllRequiredFields: 'Complete todos los campos obligatorios',
              people: 'Persona',
              company: 'Empresa',
              keepExisting: 'Mantener lo que ya existe',
              replaceWithImported: 'Reemplazar con los datos importados',
              admin: 'Administrador',
              manager: 'Gerente',
              attendant: 'Atendente',
              field: 'Campo'
            }
          },
          broadcast: {
            template: {
              email: {
                save: 'Guardar',
                cancel: 'Cancelar',
                messageEditor: 'Editora de mensajes',
                personalizeEmail: 'Puede personalizar su correo electrónico usando variables.',
                library: 'Biblioteca',
                messageErrorToCompile: '¡Error al compilar el correo electrónico!',
                templateSaved: '¡Tu plantilla se ha guardado!',
                messageErrorConnection: '¡Vaya, hubo un error de conexión!'
              },
              sms: {
                save: 'Guardar',
                cancel: 'Cancelar',
                messageEditor: 'Editora de mensajes',
                message: 'Mensaje *',
                messageHas: 'Tu mensaje tiene',
                characters: 'caracteres.',
                discountCredits: 'Se descontarán',
                discountCreditsFinal: 'créditos por cada número.',
                overcomeTheCharacters: 'En los casos en que el contenido de SMS supere los 160 caracteres, se cobrará más de un crédito por cada 153 caracteres.',
                notSupportConcatenation: 'Algunos operadores como Oi y Sercomtel no admiten la concatenación de mensajes, por lo que los SMS se recibirán por separado.',
                templateSaved: '¡Tu plantilla se ha guardado!',
                messageErrorConnection: '¡Vaya, hubo un error de conexión!',
                messageNeedFilled: '¡Debes completar los campos de nombre y mensaje!'
              },
              whatsapp: {
                save: 'Guardar',
                cancel: 'Cancelar',
                messageEditor: 'Editora de mensajes',
                message: 'Mensaje *',
                messageHas: 'Tu mensaje tiene',
                characters: 'caracteres.',
                discountCredits: 'Se descontarán dos créditos por cada número.',
                integrations: 'La integración entre Globalbot y WhatsApp permite enviar mensajes activos considerando las siguientes pautas:',
                activeMessages: 'Mensajes Activos:',
                activeMessagesDescription: 'En este caso, el chatbot de WhatsApp se utiliza para notificar y enviar mensajes a los clientes. Y el origen de la asistencia (primer mensaje) es de la empresa. Si el cliente responde al mensaje, se iniciará una nueva sesión de chat (o asistencia).',
                dispatchesInLargeScale: 'Envíos a granel:',
                dispatchesInLargeScaleDescription: 'Es importante prestar atención a este tipo de uso, ya que no se permiten envíos masivos (cuando se relacionen con promociones, divulgaciones, publicidad y similares). Se aceptan envíos automatizados a grupos de clientes, como notificaciones y avisos (dentro de un contexto en el que el cliente ha elegido recibir el mensaje, conocido como opt-in).',
                modelSaved: '¡Tu modelo ha sido guardado!',
                youCannotChange: 'No puede cambiar los mensajes en WhatsApp oficial. Por favor contacte al equipo de soporte.',
                messageErrorConnection: '¡Vaya, hubo un error de conexión!',
                messageNeedFilled: '¡Debes completar los campos de nombre y mensaje!'
              },
              save: 'Guardar',
              cancel: 'Cancelar',
              modelData: 'Datos del modelo',
              name: 'Nombre *',
              tags: 'Tags',
              observations: 'Comentarios',
              integrationsId: 'ID para usar en integraciones: ',
              modelMessageRequired: 'Para realizar un envío, siempre debe utilizar una plantilla de mensaje ya creada.',
              newMessageModelData: 'Aquí informará los datos de la nueva Plantilla de Mensaje, que podrá utilizar para realizar Envíos a los destinatarios que usted designe.',
              clientsWaba: 'Para los clientes de WABA (WhatsApp Business API), las notificaciones en formato HSM son obligatorias y deben seguir formatos aprobados previamente.',
              whatsappTerm: 'Condiciones de uso de WhatsApp:',
              whatsappTermDescription: ' Es muy importante señalar que, para utilizar la integración entre Globalbot y WhatsApp, el cliente conoce y acepta las Políticas de Uso de WhatsApp, utilizando la aplicación para no violarlas. Si lo hace, es posible que el número esté bloqueado. ',
              whatsappUsagePolicies: 'Políticas de uso de WhatsApp',
              messageSavedModel: '¡Tu modelo ha sido guardado!',
              messageErrorConnection: '¡Vaya, hubo un error de conexión!',
              fieldNameRequired: '¡Debes completar los campos de nombre y mensaje!'
            },
            dispatch: {
              save: 'Guardar',
              cancel: 'Cancelar',
              dispatchData: 'Datos de Envio',
              draftData: 'Datos de Bosquejo',
              createDispatch: 'Crear Envío',
              newDispatch: 'Nuevo Envio |',
              dispatchName: 'Nombre de envío *',
              read: 'Lidos',
              readDesc: 'Número total de destinatarios que realmente vieron el mensaje. Esta estadística puede ser aproximada ya que algunas personas no habilitan el permiso de visualización.',
              readDesc2: 'Porcentaje referido al total de Entregas.',
              observations: 'Comentarios',
              originAndInitialization: 'Origen e Inicialización',
              indicateServer: 'Indique qué servidor de WhatsApp desea enviar (corresponde a su número habilitado).',
              optional: 'Opcional: personalice el comportamiento del chatbot si el usuario responde a este mensaje. El número se refiere al punto en el flujo de la conversación que se activará después de la respuesta. Descubra qué punto del flujo y su numeración en el módulo de flujo. Deje el valor 0 para que el flujo se ejecute normalmente desde el principio.',
              whatsappServer: 'Servidor de WhatsApp *',
              flowIndex: 'Índice de flujo',
              message: 'Mensaje *',
              replaceWith: 'Reemplazar con',
              dailyLimit: 'Límite actual de envío diario',
              templateDescription: 'El uso de Plantillas (Modelos de Mensaje) es obligatorio en WhatsApp. Para crear un envío, debes seleccionar una plantilla ya creada y aprobada.',
              includeIdentifiers: 'Incluir identificadores en la conversación',
              templateMediaDescription: 'Si la plantilla seleccionada contiene medios (imagen, documento o video), súbelos. Si contiene variables como',
              templateMediaDescriptionTwo: ', utiliza los campos a continuación para reemplazarlas con los valores de tu lista de destinatarios.',
              pdfLimitExceeded: 'El PDF debe tener como máximo 100MB.',
              imageLimitExceeded: 'La imagen debe tener como máximo 5MB.',
              videoLimitExceeded: 'El video debe tener como máximo 16MB.',
              headerLike: 'Tipo de encabezado:',
              advancedSettings: 'Configuraciones Avanzadas',
              advancedSettingsDescription: 'Si el cliente responde a este mensaje, el chatbot avanzará a la siguiente línea del flujo:',
              preview: 'Vista previa',
              defineMessage: 'Definir el Mensaje',
              preperDispatch: 'Preparar el Envío',
              dispatchList: 'Lista de Envío',
              sendTest: 'Enviar Prueba',
              sendTestDescription: 'En la prueba, se utilizarán los valores de la primera línea de su lista para completar las variables, cuando corresponda.',
              back: 'Volver',
              phoneNumber: 'Número de celular',
              saveAsModel: 'Guardar también como plantilla para usar más tarde.',
              text: 'TEXTO',
              smsVarDescription: 'Si es necesario, debes utilizar las variables que se encuentran en tu lista para que el mensaje las reemplace según las instrucciones a continuación.',
              smsVarEx: 'Ejemplo: Si la variable en la lista es NOMBRE, úsala en el mensaje como %NOMBRE%, así: "Hola %NOMBRE%, te estoy enviando un mensaje."',
              textPlaceholder: 'Texto para reemplazar',
              previewDescription: 'En la vista previa, se muestran los valores de la primera fila de tu lista para completar las variables, si las hay.',
              importantDescription: 'Las estadísticas pueden ser parciales si el envío se realizó recientemente.',
              readMessages: 'Observaciones sobre Mensajes Leídos:',
              readMessagesObs: 'Esta estadística puede ser aproximada, ya que algunas personas no habilitan el permiso de visualización.',
              subjectAndSender: 'Asunto y Remitente',
              personalizeEmail: 'Puede personalizar su correo electrónico usando variables. Vea los consejos.',
              subjectEmail: 'El asunto de su correo electrónico tiene ',
              characters: ' caracteres. La cantidad de caracteres que se muestran en los dispositivos móviles es de 35 y en los equipos de escritorio 70 en promedio.',
              unsubscribeGroup: {
                pending: 'El grupo de este dominio aún se está sincronizando con el proveedor. Espera unos minutos.',
                missing: 'Este dominio no tiene grupo de cancelación. Abre Configuración > Dominios y créalo.',
                required: 'Elige un remitente de un dominio que tenga grupo de cancelación.'
              },
              senderName: 'Nombre del remitente *',
              sender: 'Remitente *',
              replyTo: 'Responder a *',
              error: 'No Entregado',
              errorCodesWhatsApp: {
                'BROADCAST_WHATSAPP_TIMEOUT_PROCESS':'Tiempo de espera de procesamiento',
                'GLOBALBOT_BUBBLE_NOT_FOUND': 'Burbuja no encontrada',
                'BROADCAST_DISPATCH_UNEXPECTED_ERROR_TRANSACTION': 'Error al procesar el envío del número',
                'BROADCAST_WHATSAPP_INTERNAL_ERROR': 'Error inesperado',
                'BROADCAST_WHATSAPP_FAIL_SEND_TO_WORKER': 'Error al enviar el mensaje al trabajador',
                'BROADCAST_WHATSAPP_CONVERSATION_ALREADY_EXISTS': 'En conversación',
                'BROADCAST_WHATSAPP_BUBBLE_ALREADY_EXISTS': 'En conversación',
                'GLOBALBOT_NOT_FOUND_TEMPLATE': 'Plantilla no encontrada',
                'GLOBALBOT_INVALID_ARGUMENTS': 'Argumentos no válidos',
                'GLOBALBOT_MISSING_PARAMS': 'Parámetros faltantes',
                'GLOBALBOT_BOT_NOT_FOUND': 'Bot no encontrado',
                'GLOBALBOT_OPT_OUTED_PHONE': 'Darse de baja',
                'GLOBALBOT_ALREADY_IN_CONVERSATION': 'En conversación',
                'GLOBALBOT_UNEXPECTED_ERROR': 'Error de procesamiento inesperado',
                'GUPSHUP_INVALID_TEMPLATE_CATEGORY': 'Categoría de plantilla no válida',
                'GUPSHUP_REQUEST_ERROR': 'Error al procesar la solicitud',
                'GUPSHUP_GENERIC_ERROR': 'Error genérico',
                'GUPSHUP_INVALID_ARGUMENTS': 'Argumentos no válidos',
                'GUPSHUP_MISSING_BOT_CONFIG': 'Configuración del bot faltante',
                'GUPSHUP_UNEXPECTED_ERROR': 'Error de procesamiento inesperado',
                'BOT_HISTORY_NOT_FOUND': 'Bot no encontrado',
                'BOT_HISTORY_TOO_MANY_BOTS_WITH_APP_NAME': 'Varios bots con el mismo nombre de aplicación',
                'BOT_HISTORY_NOT_FOUND_BOT_WPP_CONFIG': 'Configuraciones de bots de WhatsApp no ​​válidas',
                ///Errores de Interla GlobalBot
                '9991': 'Bot sin configuración o inexistente',
                '9992': 'Error al enviar mensaje al broker',
                '9997': 'Error al enviar el mensaje al canal',
                '9998': 'Saldo de créditos insuficiente',
                '9990': 'Error desconocido',
                '400': 'En conversación',
                '403': 'En conversación',
                '472': 'El número de teléfono del usuario es parte de un experimento.',
                '471': 'Restricción aplicada por META (Mensajes bloqueados o Marcados como spam)',
                '500': "Error en el servidor del broker, por favor contacte a Globalbot",
                '1001': 'Remitente no Válido',
                '1002': 'Número Inexistente',
                '1003': 'Créditos Globalbot',
                '1004': 'Problema con la Template HSM',
                '1005': 'Problema con la Template HSM',
                '1006': 'Problema con la Template HSM',
                '1007': 'Problema con la Template HSM',
                '1008': 'Opt-out',
                '1010': 'URL inválido',
                '1011': 'Tamaño de Medio no Válido',
                '1012': 'El envío del mensaje falló porque el número de teléfono eligió abandonar este canal de comunicación.',
                '1013': 'Número Inexistente',
                '1026': 'Problema con la Template HSM',
                '2000': 'Problema con la Template HSM',
                '4002': 'Respuesta de WhatsApp no ​​válida',
                '4003': 'Falló el envío del mensaje porque la plantilla no coincide.',
                '4004': 'El tipo de mensaje sólo es compatible con la API de nube alojada en Meta.',
                '4005': 'Falló el envío del mensaje porque la plantilla está en pausa.',
                ///Errores META
                //'400':'Error de descarga de medios: no se pudo descargar los medios del remitente.',
                '402': 'Elegibilidad de la empresa (problema de pago): no se pudo enviar el mensaje debido a uno o más errores relacionados con el método de pago.',
                '408': 'El mensaje no es válido - No se pudo enviar el mensaje porque estuvo pendiente durante demasiado tiempo (por ejemplo, más de 1 día). Esto puede suceder al reiniciar el cliente API de WhatsApp Business después de más de un día de inactividad.',
                '410': 'Mensaje caducado - Mensaje no enviado dentro de su TTL (tiempo de vida).',
                '429': 'Límite de velocidad alcanzado - el número envió demasiados mensajes.',
                '430': 'Certificado no firmado - No se pudo enviar el mensaje porque ocurrió un error relacionado con el certificado.',
                '432': 'La identificación del certificado no coincide - No se pudo enviar el mensaje porque ocurrió un error relacionado con el certificado.',
                '433': "Firma de certificado no válida: ocurre cuando se envía un mensaje pero el certificado de cliente de la empresa no está firmado correctamente con las claves de identidad correspondientes. Esto indica que el cliente probablemente se volvió a registrar con nuevas claves de identidad, pero no completó el proceso completo. flujo de creación de certificados.",
                '470': 'Mensaje de reactivación: no se pudo enviar el mensaje porque han pasado más de 24 horas desde la última vez que el cliente respondió a este número.',
                //'471':'Límite de tasa de spam alcanzado: no se pudo enviar el mensaje porque hay un límite en la cantidad de mensajes que se pueden enviar desde este número de teléfono. Es posible que muchos mensajes anteriores hayan sido bloqueados o marcados como spam.',
                //'472':'El número de teléfono del usuario es parte de un experimento. No se pudo enviar el mensaje porque el número de teléfono del usuario es parte de un',
                '480': "Posible cambio de usuario - No se pudo enviar el mensaje debido a un posible cambio en el número de teléfono del usuario.",
                //'500':'Error genérico: no se pudo enviar el mensaje debido a un error desconocido.',
                '501': 'El tipo de mensaje no es compatible actualmente. - Actualmente no se admiten mensajes de documentos con subtítulos.',
                '1000': 'Error genérico',
                //'1001':'Mensaje demasiado largo: la longitud del mensaje es superior a 4096 caracteres.',
                //'1002':'Tipo de destinatario no válido - Tipos de destinatario válidos:',
                //'1004':'Recurso ya existente - Posible conflicto de UUID para solicitudes de carga de medios o UUID ya existente asignado a otros medios.',
                //'1005':'Acceso denegado -',
                //'1006':'Recurso no encontrado - Archivo o recurso no encontrado.',
                //'1007':'Destinatario bloqueado para recibir mensajes ( - El destinatario no está en la lista blanca.',
                //'1008':'Falta el parámetro requerido - Falta un parámetro requerido.',
                '1009': 'Valor de parámetro no válido - El valor ingresado para un parámetro no es del tipo correcto o hay otro problema.',
                //'1010':'Parámetro no requerido: contiene un parámetro que no es requerido.',
                //'1011':'El servicio no está listo -',
                //'1013':'El usuario no es válido -',
                '1014': 'Error interno',
                '1015': 'Número excesivo de solicitudes: se alcanzó el límite de tarifa del cliente.',
                '1016': 'Sobrecarga del sistema: si el sistema recibe una carga pesada, se devuelve este error para permitir que el sistema se recupere.',
                '1017': 'Maestro no principal: este error se produce cuando una solicitud de nivel maestro únicamente (como establecer u obtener configuraciones, importar, exportar, solicitar código, registrarse, etc.) se envía a un nodo que no es un maestro primario. Esto puede suceder si el cliente API de WhatsApp Business no está configurado correctamente o si hay errores internos.',
                '1018': 'Coreapp no principal: este error se produce cuando las solicitudes se envían a un nodo Coreapp que no es propietario del fragmento ni está en proceso de convertirse en propietario. Es posible que vea este error cuando realicemos una conmutación por error de fragmentos en una configuración de conexión múltiple.',
                '1021': 'Usuario incorrecto: este error ocurre cuando un usuario se envía un mensaje a sí mismo.',
                '1022': "URL de webhooks no configurada: este error ocurrirá si el formato de webhooks de A",
                '1023': 'Error de base de datos',
                '1024': 'Cambio de contraseña solicitado - La contraseña debe cambiarse.',
                '1025': 'Solicitud no válida - La solicitud no es válida.',
                //'1026':'Destinatario no disponible - Mensaje no entregado. Consulte '¿Por qué mi tasa de entrega no es del 100%?',
                '1028': 'Tipo de notificación del sistema: enviaste un mensaje a un usuario de WhatsApp que puede haber sido modificado. Una notificación',
                '1031': "La cuenta del remitente está bloqueada - Su cuenta ha sido bloqueada y no podrá enviar mensajes debido a una violación de la política de integridad. Consulte",
                //'2000':'El recuento de parámetros de la plantilla no coincide: el número de parámetros proporcionados no coincide con la cantidad esperada.',
                '2001': 'Falta plantilla: la plantilla no está activa o no existe para un idioma y configuración regional.',
                '2002': 'Error al recuperar la plantilla - El destinatario no pudo descargar la plantilla.',
                '2003': 'Falta un paquete de plantilla - No hay plantillas para el idioma y la configuración regional indicados.',
                '2004': 'Parámetro de plantilla demasiado largo - El parámetro es demasiado largo.',
                '2005': 'Texto hidratado de plantilla demasiado largo - El texto traducido es demasiado largo.',
                '2006': 'Se violó la política de espacios en blanco de la plantilla - Se violó la política de espacios en blanco.',
                '2007': 'Se violó la política de caracteres de formato de plantilla - Se violó la política de caracteres de formato.',
                '2008': 'Formato de medios de modelo no admitido - El formato de medios utilizado no es compatible.',
                '2009': 'Falta el componente de plantilla requerido - No hay un componente de plantilla requerido.',
                '2010': 'URL hidratada de plantilla no válida - La URL en el componente del botón no es válida.',
                '2011': 'Número de teléfono de modelo no válido - El número de teléfono en el componente del botón no es válido.',
                '2012': 'El formato del parámetro de plantilla no coincide - El formato del parámetro no coincide con la plantilla creada.',
                '2013': 'Botones de modelo incompatibles: el destinatario no acepta los botones.',
                '2014': 'El espacio de nombres esperado está vacío. Este error ocurre cuando el paquete de idioma para una plantilla de mensaje aún no se ha descargado.',
                '2015': 'Número de secciones no válido: el número de secciones en la solicitud de mensaje está por debajo o por encima del límite permitido. Consulta el',
                '2016': 'Número de líneas no válido - El número de líneas no es válido. Para',
                '2017': "Se violó la política de caracteres - Se violó la política de caracteres del formato.",
                '2023': 'Número de producto no válido: el objeto de la sección no tiene productos o el recuento total de productos ha excedido el número máximo permitido.',
                '2024': 'ID de catálogo no encontrado - El ID de catálogo proporcionado no existe o no pertenece a su cuenta de WhatsApp Business (WABA).',
                '2025': 'ID de catálogo no vinculado al número API - El ID de catálogo que proporcionó no está vinculado al número de teléfono utilizado para enviar mensajes.',
                '2026': 'Productos no encontrados - Algunos productos proporcionados en su solicitud no se encontraron en el catálogo.',
                '2027': 'No se encontraron productos - No se encontraron productos en el catálogo proporcionado.',
                '2028': 'Lista de todos los productos con incumplimiento',
                '2029': 'Lista de algunos productos con fallas de cumplimiento',
                '2030': 'Lista que combina productos no válidos y no conformes',
                '2036': 'Estructura de encabezado no válida: este error se devuelve cuando ',
                '2050': 'Falta información de cumplimiento',
                '2060': 'Plantilla rechazada - El estado de la plantilla es ',
                '2061': 'Modelo en pausa - El estado del modelo es',
                '2062': 'Plantilla deshabilitada - El estado de la plantilla es',
                '2064': 'ID de transmisión no válida: la transmisión con la ID especificada no existe, no pertenece a su cuenta de WhatsApp Business o se encuentra en un estado no válido.',
                '2068': 'Transmisión bloqueada: la transmisión está en estado bloqueado.',
                '2069': 'Flujo limitado: el flujo está en estado limitado y ya se han enviado 10 mensajes usando este flujo en la última hora.',
                /// META ERRORES DE LA API DE LA NUBE https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes
                ///Errores de autorización
                '0': 'AuthException - No se puede autenticar al usuario de la aplicación.',
                '3': 'Método API: indica un problema relacionado con recursos o permisos.',
                '10': 'Permiso denegado - El permiso no fue otorgado o fue eliminado.',
                '190': 'El token de acceso ha caducado.',
                '200': 'Permiso de API: el permiso no se otorgó o se eliminó.',
                '299': 'Permiso API - El permiso no fue otorgado o fue eliminado.',
                ///Limitar errores
                '4': 'La aplicación ha alcanzado el límite de tasa de llamadas API. - La aplicación ha alcanzado el límite de tasa de llamadas API.',
                '80007': 'La cuenta de WhatsApp Business ha alcanzado el límite de volumen. - La cuenta de WhatsApp Business ha alcanzado el límite de volumen.',
                '130429': 'Se alcanzó el rendimiento de datos de mensajería de la API de la nube. - Se alcanzó el rendimiento de datos de mensajería de la API de la nube.',
                '131048': 'Error al enviar el mensaje debido a un límite en la cantidad de mensajes que se pueden enviar desde este número de teléfono. Es posible que muchos mensajes anteriores hayan sido bloqueados o marcados como spam. - No se pudo enviar el mensaje debido a un límite en la cantidad de mensajes que se pueden enviar desde este número de teléfono. Es posible que muchos mensajes anteriores hayan sido bloqueados o marcados como spam.',
                '131056': 'Se enviaron demasiados mensajes desde el número de teléfono del remitente al mismo número de teléfono del destinatario en un corto período de tiempo. - Se enviaron muchos mensajes desde el número de teléfono del remitente al mismo número de teléfono del destinatario en un corto período de tiempo.',
                '133016': 'El registro o la eliminación del registro fallaron porque se realizaron demasiados intentos a este número de teléfono en un corto período de tiempo. - El registro o la cancelación del registro fallaron porque se realizaron demasiados intentos en este número de teléfono en un corto período de tiempo.',
                ///Errores de integridad
                '368': 'Bloqueada temporalmente debido a violaciones de políticas - La cuenta de WhatsApp Business asociada con la aplicación ha sido restringida o deshabilitada por violar una política de la plataforma.',
                '131031': 'Cuenta bloqueada: la cuenta de WhatsApp Business asociada con la aplicación ha sido restringida o deshabilitada por violar una política de la plataforma. O bien, los datos incluidos en la solicitud no se pudieron verificar con el conjunto de datos de la cuenta de WhatsApp Business (por ejemplo, el pin de dos pasos incluido en la solicitud es incorrecto).',
                ///Otros errores
                '1': 'Hay una solicitud no válida o posible error del servidor. - Hay una solicitud no válida o posible error del servidor.',
                '2': 'Hay un error temporal por inactividad o sobrecarga. - Hay un error temporal por inactividad o sobrecarga.',
                '33': 'El número de teléfono del trabajo ha sido eliminado. - El número de teléfono comercial ha sido eliminado.',
                '100': 'La solicitud incluía uno o más parámetros incompatibles o escritos incorrectamente. - La solicitud incluía uno o más parámetros incompatibles o escritos incorrectamente.',
                '130472': 'El mensaje no fue enviado como parte de un experimento.',
                '131000': 'No se pudo enviar el mensaje debido a un error desconocido. - No se pudo enviar el mensaje debido a un error desconocido.',
                '131005': 'El permiso no se concedió o se eliminó. - El permiso no fue concedido o fue eliminado.',
                '131008': 'A la solicitud le falta un parámetro obligatorio. - A la solicitud le falta un parámetro obligatorio.',
                '131009': 'Uno o más valores de parámetros no son válidos. - Uno o más valores de parámetros no son válidos.',
                '131016': 'Un servicio no está disponible temporalmente. - Un servicio no está disponible temporalmente.',
                '131021': 'El número de teléfono del destinatario y del remitente es el mismo. - El número de teléfono del destinatario y del remitente es el mismo.',
                '131026': 'No se pudo entregar el mensaje. Los motivos pueden ser los siguientes: - El número de teléfono del destinatario no está registrado en WhatsApp. / Se intentó enviar una plantilla de autenticación a un usuario de WhatsApp con el código de llamada del país +91 (India). Actualmente, no es posible enviar plantillas de autenticación a usuarios de WhatsApp en India. / El destinatario no ha aceptado los nuevos Términos de Servicio y la nueva Política de Privacidad. / El destinatario está utilizando una versión antigua de WhatsApp / El mensaje no se entregó para crear una experiencia de usuario de alta calidad.',
                '131042': 'Ocurrió un error con respecto al método de pago. - Se produjo un error con respecto al método de pago.',
                '131045': 'El mensaje no se pudo enviar debido a un error de registro del número de teléfono. - El mensaje no se pudo enviar debido a un error de registro del número de teléfono.',
                '131047': 'Han pasado más de 24 horas desde la última vez que el destinatario respondió al número del remitente. - Han pasado más de 24 horas desde la última vez que el destinatario respondió al número del remitente.',
                '131049': 'Meta ha decidido no enviar el mensaje para mantener una interacción saludable con el ecosistema. Si recibe este código de error, no intente enviar el mensaje de nuevo inmediatamente si sospecha que el problema está relacionado con el límite. En su lugar, inténtelo de nuevo con intervalos mayores hasta que se entregue el mensaje, ya que el límite puede tener diferentes periodos de vigencia. Consulte "Límites de mensajes por usuario en las plantillas de marketing" para obtener más información.',
                '131050': 'No se pudo entregar el mensaje. El destinatario dejó de recibir mensajes de marketing de tu empresa en WhatsApp. No intentes volver a enviar mensajes, ya que este usuario no los recibirá.',
                '131051': 'El tipo de mensaje no es compatible. - El tipo de mensaje no es compatible.',
                '131052': 'No se pueden descargar los medios subidos por el usuario. - No se pueden descargar los medios subidos por el usuario.',
                '131053': 'No se pudo cargar el contenido multimedia por uno de los siguientes motivos: Tipo no aceptado, Contenido multimedia demasiado grande (Imagen: 5 MB, Vídeo/Audio: 16 MB, Documentos: 100 MB).',
                '131057': 'La cuenta comercial está en modo de mantenimiento. - La cuenta comercial está en modo de mantenimiento.',
                '132000': 'El número de valores de parámetros variables incluidos en la solicitud no coincide con el número de parámetros variables definidos en la plantilla. - El número de valores de parámetros variables incluidos en la solicitud no coincide con el número de parámetros variables definidos en la plantilla.',
                '132001': 'La plantilla no existe en el idioma especificado o no ha sido aprobada. - La plantilla no existe en el idioma especificado o no ha sido aprobada.',
                '132005': 'El texto traducido es demasiado largo. - El texto traducido es demasiado largo.',
                '132007': 'El contenido de la plantilla viola la política de WhatsApp. - El contenido de la plantilla viola la política de WhatsApp.',
                '132012': 'Los valores de los parámetros variables estaban formateados incorrectamente. - Los valores de los parámetros variables estaban formateados incorrectamente.',
                '132015': 'El modelo fue pausado por - El modelo fue pausado por ',
                '132016': 'El modelo ha sido pausado demasiadas veces por - El modelo ha sido pausado demasiadas veces por ',
                '132018': 'El parámetro text no puede contener saltos de línea, tabulaciones o más de 4 espacios consecutivos.',           
                '132068': 'La transmisión está en estado bloqueado. - La transmisión está en estado bloqueado.',
                '132069': 'El flujo está en estado limitado y ya se han enviado 10 mensajes usando este flujo en la última hora. - El flujo está en estado limitado y ya se han enviado 10 mensajes utilizando este flujo en la última hora.',
                '133000': 'Falló un intento anterior de cancelar el registro. - Un intento anterior de cancelar el registro falló.',
                '133004': 'El servidor no está disponible temporalmente. - El servidor no está disponible temporalmente.',
                '133005': 'El PIN de confirmación de dos pasos es incorrecto. - El PIN de confirmación de dos pasos es incorrecto.',
                '133006': 'El número de teléfono debe verificarse antes del registro. - El número de teléfono debe verificarse antes del registro.',
                '133008': 'Hubo demasiados intentos de confirmación de PIN en dos pasos para este número de teléfono. - Hubo demasiados intentos de confirmación de PIN en dos pasos para este número de teléfono.',
                '133009': 'El PIN de confirmación de dos pasos se ingresó demasiado rápido. - El PIN de confirmación de dos pasos se ingresó muy rápidamente.',
                '133010': 'El número de teléfono no está registrado en la plataforma WhatsApp Business. - El número de teléfono no está registrado en la plataforma WhatsApp Business.',
                '133015': 'El número de teléfono que está intentando registrar se eliminó recientemente y la eliminación aún no se ha completado. - El número de teléfono que está intentando registrar se eliminó recientemente y la eliminación aún no se ha completado.',
                '135000': 'No se pudo enviar el mensaje debido a un error desconocido en el servidor META. Por favor, contacte con suporte@globalbot.com.br',
              },
              internalError: 'Erro Interno',
              errorDesc: 'Número total de destinatarios cuyos mensajes no fueron entregados, por motivos como: número de WhatsApp inexistente, usuario está en sesión de chat abierta, problema específico con la Plantilla HSM, entre otros.',
              recipients: 'Destinatarios',
              recipientsDesc: 'Destinatarios totales seleccionados para envío, considerando los atributos y segmentaciones que elegiste.',
              trackingConversation: 'Trazabilidad en conversaciones',
              trackingConversationDescription: 'Asignar una etiqueta si se desea identificar las conversaciones que se inician a partir de este envío.',
              dispatchTest: 'Prueba de Envío',
              replaceVar: 'Sustitución de variables',
              combineLists: 'Puede combinar listas y filtros o incluso importar una nueva lista. ',
              selectList: 'Selecciona una lista de correo ya guardada o impórtala.',
              clickHere: 'Haga clic aquí',
              downloadModelList: 'para descargar una plantilla de lista.',
              importList: 'Importar lista',
              lists: 'Lista',
              filters: 'Filtros',
              notSend: 'No enviar a...',
              includeCampaign: 'Incluir en una campaña',
              campaign: 'Campaña *',
              messageCampaignOne: 'Una campaña es una colección de presentaciones relacionadas.',
              messageCampaignTwo: 'Las campañas proporcionan una serie de informes y estadísticas agrupados para sus envíos.',
              messageCampaignThree: 'Utilice campañas para agrupar sus envíos y analizar los resultados a lo largo del tiempo. Ejemplos: campaña semanal, envíos de enero, etc.',
              integrationsId: 'ID para usar en integraciones: ',
              found: 'Fundar',
              repeated: 'Repetido',
              excluded: 'Retirado',
              range: 'Alcance',
              var: 'Variáveis da lista',
              varDescription: 'A continuación, las variables encontradas en la lista y ejemplos de valores extraídos de la primera línea.',
              deliveries: 'Entregas',
              totalRecipients: 'Total de destinatarios seleccionados para enviar, teniendo en cuenta los atributos y la orientación que eligió anteriormente.',
              sent: 'Enviado',
              processing:'Procesados',
              processingDesc: 'Número total de destinatarios cuyos mensajes han sido o están siendo procesados ​​por Globalbot en el servidor de WhatsApp.',
              sentDesc: 'Número total de destinatarios a quienes Globalbot entregó el mensaje al servidor de WhatsApp.',
              pending: 'Pendiente',
              pendingDesc: 'Número total de destinatarios que no recibieron mensajes (WhatsApp envía estos mensajes en secuencia).',
              notSent: 'No enviado',
              totalEmails: 'Total de correos electrónicos realmente enviados, excluidas las direcciones de correo electrónico no válidas descartadas por el servicio de activación de correo electrónico.',
              handedOut: 'Entregado',
              handedOutDesc: 'Número total de destinatarios a quienes se les entregó el mensaje por WhatsApp en los dispositivos de los clientes.',
              handedOutDesc2: 'Porcentaje referido al total enviado.',
              receivedTheEmail: 'Total de destinatarios que recibieron el correo electrónico, descontando los que rebotaron. El porcentaje se refiere a la cantidad de correos electrónicos enviados.',
              softBounce: 'Soft Bounce',
              totalEmailsNotHandedTemporary: 'Total de correos electrónicos que no se entregaron por motivos temporales como: bandeja de entrada del destinatario llena o servidor fuera de línea del destinatario. El proveedor de correo electrónico intentará reenviar el mensaje durante las próximas 72 horas. El porcentaje se refiere a la cantidad de correos electrónicos enviados.',
              hardBounce: 'Hard Bounce',
              totalEmailsNotHandedPermanent: 'Total de correos que no fueron entregados por motivos permanentes, tales como: correos inexistentes o bloqueados por el servidor de correo del destinatario por considerarlos spam. El porcentaje se refiere a la cantidad de correos electrónicos enviados.',
              engagement: 'Compromiso',
              openings: 'Aberturas',
              totalUniqueEmailOpenings: 'Se abre el correo electrónico único total. El porcentaje se refiere a la cantidad de correos electrónicos entregados.',
              clicks: 'Clics',
              totalClickUnique: 'Total de clics únicos en enlaces de correo electrónico. El porcentaje se refiere a la cantidad de correos electrónicos abiertos.',
              markedSpam: 'Marcado como spam',
              totalMarkedSpam: 'Total de usuarios que marcaron este correo electrónico como spam. El porcentaje está en la cantidad de correos electrónicos entregados.',
              unsubscriptions: 'Darse de baja',
              totalUnsubscriptions: 'Total de usuarios que se dieron de baja del correo electrónico enviado. El porcentaje se refiere a la cantidad de correos electrónicos entregados.',
              totalRecipientsSent: 'Total de destinatarios con un mensaje realmente enviado, descontando los destinatarios descartados por contener números no válidos o inexistentes.',
              totalRecipientsSms: 'Total de destinatarios que recibieron el mensaje entregado por operadores de SMS.',
              totalRecipientsNotSend: 'Total de destinatarios que no pudieron entregar el mensaje por motivos permanentes, como: contener un número inválido o inexistente.',
              waiting: 'Esperando',
              numberOfRecipientsWaiting: 'Número de destinatarios que aún esperan a que se complete el proceso de envío.',
              handedOutServer: 'Entregado (servidor)',
              totalRecipientsFromGlobalbotToWhatsapp: 'Total de destinatarios que recibieron el mensaje entregado por Globalbot al servidor de WhatsApp.',
              handedOutDevice: 'Entregado (Dispositivo)',
              totalRecipientsFromWhatsappToClients: 'Total de destinatarios que recibieron el mensaje de WhatsApp en los dispositivos de los clientes.',
              totalRecipientsNotHandedTemporary: 'Total de destinatarios cuyos mensajes no se entregaron por motivos temporales, como: el destinatario está en una sesión de chat abierta. El sistema intentará reenviar el mensaje durante las próximas 24 horas. El porcentaje se refiere al número de destinatarios enviados.',
              preview: 'Visualización',
              totalRecipientsViewedMessage: 'Total de destinatarios que realmente vieron el mensaje.',
              important: 'Importante:',
              messageImportantOne: ' Debe importar una lista en formato de archivo .CSV, recordando que para enviar SMS y',
              messageImportantTwo: 'El campo de WhatsApp "teléfono" (phone) es obligatorio.',
              /// Variante mostrada cuando el bot tiene el envío por BSUID
              /// habilitado (integrations.whatsapp.bsuid.sendByBsuid).
              messageImportantTwoBsuid: 'WhatsApp: informe la columna "phone" (teléfono) o "bsuid" — al menos una por línea.',
              messageImportantThree: 'Para envíos por correo electrónico, el campo "email" es obligatorio.',
              messageImportantFour: 'Para los envíos de WhatsApp, el número de teléfono debe tener la identificación del usuario, por ejemplo: 554899999999 (Brasil)',
              messageImportantFourBsuid: 'Para los envíos de WhatsApp, el número de teléfono debe tener la identificación del usuario, por ejemplo: 554899999999 (Brasil). Cuando use "bsuid", informe el identificador completo, por ejemplo: IN.1648738043044942',
              totalFound: 'Encontramos un total de ',
              items: ' elementos.',
              import: 'Importar',
              finish: 'Finalizar',
              finishEdit: 'Finalizar Edición',
              finishEditQuestion: '¿Qué deseas hacer?',
              modelSelectedNotHaveChannel: 'La plantilla seleccionada no tiene canal. Vuelva a crear una nueva plantilla.',
              modelSelectedNotMessageValid: 'El modelo seleccionado no tiene un mensaje válido, consulte el mensaje de este modelo.',
              notIncludeDomain: 'No incluya el dominio en los campos "remitente" y "responder a", estos campos se seleccionan a través de los dominios autorizados.',
              weNeedDomain: 'Desafortunadamente, necesitamos un dominio autorizado para continuar, puede autenticar uno en las preferencias.',
              fieldsNeedFilledOne: 'Se deben completar el nombre del campo, el remitente, la respuesta y las listas o filtros.',
              selectServer: 'Seleccione un servidor, si no es así, solicite uno con Globalbot.',
              fieldsNeedFilledTwo: '¡Es necesario completar el campo de nombre y las listas o filtros!',
              dispatchSaved: 'Su presentación se ha grabado!',
              draftSaved: 'Su rascunho se ha grabado!',
              messageErrorConnection: '¡Vaya, hubo un error de conexión!',
              testDispatchProcessing: 'Tu prueba se está procesando, espera aproximadamente 1 minuto.',
              columnEmailRequired: 'Las columnas "email" son obligatorias.',
              columnPhoneRequired: 'Las columnas "phone" son obligatorias.',
              columnPhoneOrBsuidRequired: 'La columna "phone" o "bsuid" es obligatoria para este canal.',
              bsuidLabel: 'BSUID del cliente',
              contact: 'Contacto',
              messageError: 'Vaya, hubo un error.',
              listSaved: '¡Tu lista se ha guardado!',
              exportData: '¿Realmente desea exportar todos sus registros?',
              hasConversation: 'Conversación',
              hasConversationTooltip: 'Verifique si se ha generado una conversación a partir de este envío de WhatsApp',
              emailInvalid: 'Correo electrónico inválido. Por favor, verifica el correo e inténtalo de nuevo.',
              requiredField: 'Campo obligatorio.'
            },
            list: {
              title: 'Título *',
              toggleLabel: 'Cambiar etiqueta',
              filter: 'Filtrar *',
              save: 'Salvar',
              messageError: 'Vaya, se produjo un error.',
              listSaved: '¡Tu lista se ha guardado!',
              messageErrorConnection: '¡Vaya, hubo un error de conexión!',
              fieldsRequired: 'Es necesario completar los campos de la campaña, el asunto y el correo electrónico de origen.'
            }
          },
          conversation: {
            save: 'Salvar',
            cancel: 'Cancelar',
            saveSuccess: '¡Cambios guardados!',
            saveError: 'Error al guardar los cambios.',
            conversationData: 'Datos de Conversación',
            sections: {
              conversationData: 'Datos de la Conversación',
              kanbanBoards: 'Tableros Kanban',
              identifiersAndFields: 'Identificadores y Campos'
            },
            summary: {
              title: 'Resumen de la Conversación',
              newBadge: 'Nuevo',
              disclaimer: 'El resumen es generado automáticamente por Inteligencia Artificial y puede contener imprecisiones. Recomendamos consultar el historial de la conversación cuando sea necesario.',
              generate: 'Generar Resumen',
              generating: 'Generando resumen. Las conversaciones largas pueden tardar algunos segundos.',
              refresh: 'Actualizar Resumen',
              generatedAt: 'Generado el {date}',
              loadError: 'No fue posible cargar el resumen de la conversación.',
              generateFailed: 'No fue posible generar el resumen.',
              noMessages: 'Esta conversación aún no tiene mensajes para resumir.',
              notFound: 'Conversación no encontrada.',
              timeout: 'El resumen está tardando más de lo esperado.',
              supportCode: 'Código para soporte: {errorId}',
              retry: 'Intentar de nuevo',
              availableIn: 'Disponible en {time}',
              originNotAllowed: 'El resumen solo puede generarse desde el panel, en el navegador.'
            },
            protocol: 'Protocolo',
            identifierId: 'Identificador',
            session: 'Sesión',
            hasAttachments: 'Contiene adjunto(s)',
            attendants: 'Acomodadoras',
            tags: 'Tags',
            device: 'Dispositivo',
            dispatchEmail: 'Correo electrónico de cliente potencial enviado',
            dispatchEmailToClient: 'Correo electrónico enviado al cliente',
            emailViewedByClient: 'Correo electrónico visto por el cliente',
            dateAndHour: 'Fecha y hora',
            channel: 'Canal',
            satisfaction: 'Satisfacción',
            punctuation: 'Puntuación',
            whatsappPhone: 'WhatsApp Telefono',
            search: 'Buscar',
            location: 'Localización',
            origin: 'Origen',
            campaigns: 'Campañas',
            messageSent: 'Mensaje enviado:',
            comments: 'Comentarios',
            messageNotFound: 'Desafortunadamente, no encontramos esta conversación.',
            messageTryAgain: 'Vaya, tuvimos un problema al recuperar esta conversación. Vuelve a intentarlo. Si el error persiste, contáctanos.',
            metaCampaigns: 'Datos de la campaña META',
            openMedia: 'Abrir media',
            accessConversation: 'Acceder a la conversación',
            phoneUnavailable: 'Teléfono no disponible: contacto identificado por BSUID (Meta).',
            clickToWhatsAppClientId: 'ID de cliente Click to WhatsApp'
          },
          integration: {
            save: 'Guardar',
            cancel: 'Cancelar',
            integrationDetails: 'Detalles de integración',
            activeIntegration: 'Integración activa',
            identifier: 'Identificador',
            hash: 'Hash',
            token: 'Token',
            hasToken: 'Tiene API token',
            webhook: 'Webhook',
            host: 'Host',
            key: 'Key',
            haveRestriction: '¿Tiene restricciones?',
            contactPurpose: 'Ponga debajo los valores para el botón "Propósito de contacto" que no desea ir a VistaSoft',
            add: 'Agregar',
            customIdFields: 'Defina a continuación los identificadores de los campos personalizados y sus identificadores, ejemplo %NAME%.',
            idField: 'Id de campo ',
            websiteAddress: 'Dirección web',
            userProvidedByKSI: 'Usuario proporcionado por KSI',
            passwordProvidedByKSI: 'Contraseña proporcionada por KSI',
            salesFlow: 'Flujo de ventas',
            salesFlowValue: '¿Cuál es el identificador que tiene el valor de venta en el flujo?',
            salesValue: 'Valor del identificador de venta',
            createIdSales: 'Cree un ID de propiedad de venta predeterminado y colóquelo aquí',
            rentalFlow: 'Flujo de alquiler',
            rentalFlowValue: '¿Cuál es el identificador que tiene el valor de alquiler en el flujo?',
            rentalValue: 'Valor del identificador de alquiler',
            createIdRental: 'Cree un ID de propiedad de alquiler predeterminado e ingréselo aquí',
            releasesFlow: 'Flujo de publicación',
            releasesFlowValue: 'Qual o identificador que tem o valor de lançamento no fluxo?',
            releasesValue: 'Valor del identificador de publicación',
            createIdSalesInReleases: 'Cree un ID de propiedad de venta predeterminado y coloque la liberación',
            endpoint: 'Punto final',
            enterprises: 'Empresa',
            enterpriseId: 'ID da Empresa',
            sendToAttendant: 'Enviar al asistente',
            includeInternalMessages: 'Incluir mensajes internos',
            subdomain: 'Subdominio',
            clientSecret: 'Client_Secret',
            user: 'Usuario',
            clientId: 'Client_Id',
            code: 'Code',
            password: 'Contraseña',
            project: 'Proyecto',
            problemType: 'Tipo de problema',
            customField: 'Campo personalizado',
            customFieldValue: 'Valor de campo personalizado',
            title: 'Título (opcional)',
            sendOnlyLivechat: 'Envía conversaciones solo desde el chat en vivo',
            loadLink: 'Enlace de carga',
            savedPreferences: 'Preferencia guardada con éxito',
            responsible: 'Responsable(Id)',
            createdBy: 'Creado por(Id)',
            businessPhaseId: 'Fase comercial(Id)',
            salerCode: 'Código de vendedor',
            methodologyCode: 'Código de metodología',
            salesChannelCode: 'Código de canal de ventas',
            baseURL: 'URL base. ex: https://tu-tienda-de-desarrollo.myshopify.com',
            integrationTriggers: 'Desencadenantes de integración',
            integrationTriggersDescription: 'Definir cuándo se activará la integración (POST)',
            integrationTriggerFinish: 'Al finalizar la conversación (por el chatbot o agente)',
            integrationTriggerAttendant: 'Cuando el agente asume la conversación',
            integrationTriggerNote: 'La integración dependerá de las reglas definidas en el sistema de destino. Si se selecciona más de una opción, la integración se activará más de una vez. Por lo tanto, para evitar registros duplicados, el sistema de destino debe gestionar esta información.',
            pipedriveReferral: {
              title: 'Atribución de anuncio (Click to WhatsApp)',
              description: 'Cuando la conversación comienza desde un anuncio de Facebook o Instagram con el botón "Enviar mensaje por WhatsApp", Globalbot recibe los datos de ese anuncio. Aquí defines en qué campo personalizado del trato en Pipedrive se guardará cada dato.',
              instructions: 'En cada fila, elige a la izquierda el campo del trato en Pipedrive y a la derecha el valor de Globalbot que se guardará en él. Solo se muestran campos personalizados de tipo texto creados en tu cuenta de Pipedrive. El campo solo se completa cuando el valor existe en la conversación.',
              loadFields: 'Buscar campos de Pipedrive',
              loadFieldsTooltip: 'Busca los campos personalizados de texto usando el token indicado arriba.',
              loadFieldsTokenRequired: 'Indica el token de Pipedrive arriba para buscar los campos.',
              beforeFetch: 'Haz clic en "Buscar campos de Pipedrive" para cargar los campos personalizados de texto de tu cuenta.',
              dealField: 'Campo del trato (Pipedrive)',
              globalbotValue: 'Valor de Globalbot',
              addRow: 'Agregar asignación',
              addRowDisabled: 'Todos los campos personalizados de texto disponibles ya fueron asignados.',
              removeRow: 'Eliminar asignación',
              emptyFields: 'No se encontró ningún campo personalizado de texto en esta cuenta. En Pipedrive, ve a Configuración > Campos de datos > Trato, crea un campo de tipo Texto y busca los campos nuevamente.',
              errorInvalidToken: 'No fue posible acceder a Pipedrive con este token. Verifica el token indicado arriba e inténtalo de nuevo.',
              errorRateLimited: 'Demasiadas búsquedas seguidas. Espera un minuto e inténtalo de nuevo.',
              errorGeneric: 'No fue posible buscar los campos de Pipedrive en este momento. Inténtalo de nuevo en unos instantes.',
              fieldMissingSuffix: '(no encontrado en Pipedrive)',
              fieldMissing: 'Este campo ya no existe en Pipedrive. Elige otro campo o elimina la asignación.',
              values: {
                headline: 'Título del anuncio',
                body: 'Texto del anuncio',
                sourceType: 'Tipo de origen del anuncio',
                sourceId: 'ID del anuncio',
                sourceUrl: 'URL del anuncio',
                mediaType: 'Tipo de medio del anuncio',
                mediaUrl: 'URL del medio del anuncio',
                imageUrl: 'URL de la imagen del anuncio',
                videoUrl: 'URL del video del anuncio',
                thumbnailUrl: 'URL de la miniatura del anuncio',
                ctwaClid: 'ID de clic Click to WhatsApp (ctwa_clid)',
                total: 'Total de anuncios en la conversación'
              }
            },
            eventWebhook: {
              title: 'Webhook de eventos',
              intro: 'Globalbot llamará a la URL de abajo en cada evento seleccionado, con el cuerpo firmado (HMAC-SHA256 en el header X-Globalbot-Signature). Su endpoint debe responder 2xx.',
              active: 'Webhook activo',
              name: 'Nombre (solo para identificarlo)',
              url: 'URL del endpoint (https)',
              urlHint: 'Solo https. No se siguen redirecciones.',
              events: 'Eventos que desea recibir',
              eventLabels: {
                'message.status.enqueued': 'Mensaje en cola',
                'message.status.sent': 'Mensaje enviado',
                'message.status.delivered': 'Mensaje entregado',
                'message.status.read': 'Mensaje leído',
                'message.status.failed': 'Falla en el envío',
                'message.status.deleted': 'Mensaje eliminado'
              },
              eventsRequired: 'Seleccione al menos un evento.',
              notifyTitle: 'A quién avisar si el webhook se desactiva',
              notifyUsers: 'Usuarios de la cuenta',
              notifyEmails: 'Otros correos',
              notifyEmailsHint: 'Escriba y presione Enter. Sin nadie seleccionado, avisamos a los administradores de la cuenta.',
              invalidEmail: 'Correo inválido',
              terms: 'Declaro que tengo base legal para recibir estos datos (que pueden incluir teléfono e identificador del contacto) en el endpoint indicado, y que soy responsable de su seguridad.',
              termsRequired: 'Para activar, debe aceptar la declaración anterior.',
              secretTitle: 'Secret de la firma',
              secretCurrent: 'Secret actual',
              secretNone: 'El secret se genera al guardar por primera vez.',
              secretShownOnce: 'Cópielo ahora: por seguridad, el secret no se mostrará de nuevo. Si lo pierde, genere uno nuevo.',
              copy: 'Copiar',
              copied: 'Copiado',
              rotate: 'Generar nuevo secret',
              rotateConfirm: 'Generar un nuevo secret invalida el actual de inmediato: su endpoint rechazará las firmas hasta que actualice el valor allí. ¿Continuar?',
              test: 'Enviar evento de prueba',
              testHint: 'Envía un evento message.status.delivered marcado como prueba (test: true) a la URL guardada.',
              testOk: 'Su endpoint respondió {status} en {ms} ms.',
              testFail: 'Falla: {detail}',
              testBlocked: 'URL rechazada por nuestra protección: {detail}. Use una dirección pública en https.',
              testSaveFirst: 'Guarde la configuración antes de probar.',
              health: { active: 'Activo', failing: 'Con fallas', disabled: 'Desactivado automáticamente', inactive: 'Apagado' },
              healthLastError: 'Último error',
              healthLastDelivery: 'Última entrega',
              healthFailures: 'Fallas consecutivas',
              propagation: 'Los cambios tardan hasta 2 minutos en aplicarse en todos los servidores.',
              reactivated: 'Webhook reactivado. El contador de fallas se reinició; los eventos perdidos durante la desactivación no se reenvían.',
              saved: 'Webhook guardado.',
              atLeastOnce: 'Las entregas pueden repetirse: use el campo deliveryId para descartar duplicados.',
              permissionDenied: 'Solo los administradores de la cuenta pueden configurar el webhook de eventos.',
              loadError: 'No se pudo cargar la configuración del webhook.',
              removedUser: 'Usuario eliminado',
              fieldErrors: {
                required: 'Campo obligatorio.',
                'too-long': 'Valor demasiado largo.',
                malformed: 'URL inválida.',
                'not-https': 'La URL debe comenzar con https://.',
                'credentials-in-url': 'La URL no puede contener usuario y contraseña.',
                'local-host': 'Use una dirección pública; no se aceptan hosts locales.',
                'at-least-one': 'Seleccione al menos un evento.',
                'not-an-array': 'Lista de eventos inválida.',
                'invalid-email': 'Hay un correo inválido en la lista.',
                'invalid-id': 'Hay un usuario inválido en la lista.',
                'not-in-account': 'Hay un usuario que no pertenece a esta cuenta.',
                'too-many': 'Demasiados destinatarios.',
                'required-to-activate': 'Para activar, debe aceptar la declaración.',
                generic: 'Valor inválido.'
              },
              testReasons: {
                'test-unavailable': 'envío de prueba temporalmente no disponible',
                'no-whatsapp': 'este bot no tiene integración con WhatsApp',
                'bot-not-found': 'bot no encontrado',
                'subscription-not-found': 'configuración no encontrada; guarde antes de probar',
                'endpoint-error': 'su endpoint no respondió 2xx',
                'internal-error': 'error interno al enviar la prueba',
                generic: 'no fue posible enviar el evento de prueba'
              }
            },
          },
          knowledge: {
            close: 'Cerrar',
            cancel: 'Cancelar',
            answered: 'Contestada',
            unambiguous: 'Desambiguación',
            unanswered: 'Sin respuesta',
            outContext: 'Fuera de contexto',
            channel: 'Canal',
            date: 'Fecha',
            question: 'Pregunta',
            media: 'Medios',
            response: 'Respuesta',
            testEnvironment: 'Entorno de prueba',
            mode: 'Modo',
            test: 'Prueba',
            public: 'Público'
          },
          liveAttendants: {
            close: 'Cerrar',
            attendants: 'Acomodadores',
            avatar: 'Avatar',
            attendance: 'Conversaciones activas',
            name: 'Nombre',
            departments: 'Departamentos',
            role: 'Cargo',
            away: 'Away',
            clear: 'Limpio',
            offline: 'Offline',
            rooms: 'Habitaciones',
            actions: 'Comportamiento'
          },
          connectedUsers: {
            close: 'Cerrar',
            users: 'Usuarios conectados',
            avatar: 'Avatar',
            attendance: 'Conversaciones activas',
            name: 'Nombre',
            departments: 'Departamentos',
            role: 'Cargo',
            away: 'Away',
            clear: 'Limpio',
            offline: 'Offline',
            rooms: 'Habitaciones',
            actions: 'Comportamiento'
          },
          liveConfig: {
            save: 'Guardar',
            cancel: 'Cancelar',
            settings: 'Ajustes',
            soundNewAttendance: 'Nuevo sonido de asistencia',
            messageSoundReceived: 'Sonido de mensaje entrante',
            listOrdering: 'Orden de lista',
            ascendingArrivalDate: 'Fecha de llegada ascendente',
            descendingArrivalDate: 'Fecha de llegada descendente',
            lastMessageCrescent: 'Último mensaje ascendente',
            lastMessageDecreasing: 'Último mensaje descendente',
            crescentGroup: 'Por grupo crescente',
            decreasingGroup: 'Por grupo decrescente',
            amountMessageCrescent: 'Quantidade de mensagens crescente',
            amountMessageDecreasing: 'Quantidade de mensagens decrescente',
            activeTimer: 'Habilitar Cronómetro',
            totalTimeOfAttendant: 'Tiempo total de asistencia',
            lastClientInteraction: 'Contador de última interacción con el cliente',
            exhibitionAlertTime: 'Limite de Aviso de Alerta',
            minutes: 'minutos',
            alertTimeAttendance: 'Servicio excediendo el límite'
          },
          notifications: {
            notifications: 'Centro de Notificaciones',
            noNotifications: 'No hay notificaciones para ti en este momento.',
            HSM_TEST: {
              label: {
                error: "Falla",
                delivered: "¡Éxito!"
              },
              title: {
                error: "Envío de prueba de HSM",
                delivered: "Envío de prueba de HSM"
              },
              message: {
                error: "Falla en el envío de la prueba de HSM, no fue entregada al usuario.",
                delivered: "La prueba de HSM fue enviada con éxito y entregada al usuario."
              }
            }
          }
        },
        dashboard: {
          connectedUsers: 'Usuarios Conectados',
          connectedUsersTip: 'Verifica los usuarios que están conectados a la plataforma Globalbot en este momento.',
        },
        editable: {
          carousel: {
            idealResolution: 'Resolucion ideal',
            librarySearch: 'Buscar en la biblioteca',
            key: 'Llave',
            value: 'Valor',
            jump: 'Salto',
            title: 'Título',
            description: 'Descripción',
            select: 'Seleccione',
            image: 'Imagen',
            buttons: 'Botones'
          }
        },
        emailBuilder: {
          add: {
            campaigns: 'Mensajería ',
            addEmail: ' Agregar e-mail',
            subject: 'Sujeto *',
            sender: 'Remitente *',
            replyTo: 'Responder a',
            tags: 'Tags',
            save: 'Guardar',
            attendanceRealized: 'Asistencia realizada',
            attendanceProtocol: 'Protocolo de asistencia',
            historic: 'Histórico',
            templateSaved: '¡Tu modelo ha sido guardado!',
            messageErrorConnection: 'Oops, ocorreu um erro de conexão!',
            fieldsRequired: '¡Debes completar los campos campaña, asunto y correo electrónico de origen!'
          },
          emailBuilder: {
            messageEmailSaved: 'Mensajes de correo electrónico guardados',
            subject: 'Asunto: ',
            addNewTemplate: 'Agregar nuevo modelo'
          }
        },
        lists: {
          push: {
            insertList: 'Insertar en la lista',
            list: 'Lista',
            cancel: 'Cancelar',
            insert: 'Inserir',
            updatedList: '¡Lista actualizada!',
            failedUpdateList: '¡No se pudo actualizar la lista!'
          }
        },
        live: {
          container: {
            message: {
              replied: {
                you: 'Tú',
                video: 'Vídeo',
                audio: 'Audio',
                loading: 'Cargando mensaje respondido...',
                unavailable: 'Mensaje respondido no disponible',
                outOfHistory: 'Carga más mensajes para ir hasta él',
              },
              cards: {
                startConversation: 'Iniciar Conversación',
                insertList: 'Insertar en la lista'
              },
              media: {
                speechToText: 'Speech to Text (transcripción de audio a texto)',
                notSupport: 'Su navegador no es compatible, utilice Chrome.',
                notRegistered: 'No registrado',
                openOriginalImage: 'Abrir imagen original',
                downloadVideo: 'Descargar vídeo',
                downloadError: 'No se pudo descargar el archivo. Inténtalo de nuevo.'
              },
              yesterday: 'El dia de ayer',
              today: 'Hoy dia',
              hsmYesterday: 'HSM enviado ayer',
              hsmToday: 'HSM enviado hoy',
              hsmSent: 'HSM enviado',
              userNotFound: 'Usuario no encontrado',
              status: {
                noSubmitted: 'Mensaje no enviada(haga clic para intentarlo de nuevo)',
                sending: 'Enviando mensaje',
                sended: 'Mensaje enviada',
                delivered: 'Mensaje entregado',
                read: 'Mensaje leído',
                fail: 'Mensaje fallido'
              },
              openInNewTab: 'Abrir em nova guia',
              networkRequired: 'Debes iniciar sesión para enviar el mensaje nuevamente.',
              queuePositionFail: 'No se pudo enviar el mensaje porque la última interacción del usuario fue hace más de 24 horas.',
              systemMessageSuppressed: 'Mensaje no enviado al cliente: desactivado en Configuración › Chat en Vivo › Mensajes. Registrado solo para auditoría.',
              systemMessageSuppressedByFlowNode: 'Mensaje no enviado al cliente: persistencia desactivada en este nodo del flujo ({step}). Registrado solo para auditoría.',
              persistenceFirstNotice: '1.er aviso',
              persistenceSecondNotice: '2.º aviso',
              serviceMessageBilling: 'Service Message: Este mensaje está categorizado como Service por Meta (WhatsApp). Estos mensajes pasarán a cobrarse de forma unitaria a partir del 1 de octubre de 2026. Es necesaria la inclusión de Créditos Meta WhatsApp en la plataforma para la continuidad de la operación.',
              balanceBlocked: {
                ariaLabelMessage: 'Mensaje no enviado: saldo de créditos insuficiente',
                ariaLabelConversation: 'Conversación con un mensaje no enviado por saldo de créditos insuficiente',
                messageBefore: 'Este mensaje de WhatsApp no se pudo enviar porque el saldo de créditos es insuficiente. Cargue créditos en',
                conversationBefore: 'Un mensaje de WhatsApp de esta conversación no se pudo enviar porque el saldo de créditos es insuficiente. Cargue créditos en',
                after: 'para reanudar los envíos. (Según las nuevas reglas de Meta, vigentes desde el 1 de octubre de 2026.)',
                /// conta mini-globalbot não tem o menu Preferências > Consumo WhatsApp
                miniMessage: 'Este mensaje de WhatsApp no se pudo enviar porque el saldo de créditos es insuficiente. Póngase en contacto con el equipo de soporte para cargar créditos y reanudar los envíos. (Según las nuevas reglas de Meta, vigentes desde el 1 de octubre de 2026.)',
                miniConversation: 'Un mensaje de WhatsApp de esta conversación no se pudo enviar porque el saldo de créditos es insuficiente. Póngase en contacto con el equipo de soporte para cargar créditos y reanudar los envíos. (Según las nuevas reglas de Meta, vigentes desde el 1 de octubre de 2026.)'
              }
            },
            conversation: {
              identifierId: 'Identificador',
              protocol: 'Protocolo',
              tags: 'Tags',
              changeName: 'Alterar nome',
              device: 'Dispositivo',
              dispatchEmailLead: 'Correo electrónico de cliente potencial enviado',
              dispatchEmailClient: 'Correo electrónico enviado al cliente',
              emailViewedClient: 'Correo electrónico visto por el cliente',
              dateAndTime: 'Fecha y hora',
              channel: 'Canal',
              satisfaction: 'Satisfacción',
              punctuation: 'Puntuación',
              search: 'Buscar',
              location: 'Localización',
              origin: 'Origen'
            },
            knowledge: {
              reply: 'Respuesta',
              copyReply: 'Copiar respuesta',
              messageErrorKnowledge: 'Error al consultar las bases de conocimientos',
              messageErrorConsult: 'Error al consultar preguntas.'
            }
          },
          footer: {
            actions: {
              annex: {
                sendImage: '¡Cargar imagen! (5 MB talla máxima)',
                sendVideo: '¡Enviar video! (16 MB talla máxima)',
                sendFile: '¡Enviar archivo! (100 MB talla máxima)',
                selectLibrary: '¡Seleccione de la biblioteca!',
                library: 'Biblioteca',
                preview: 'Avance',
                addLegend: 'Agregar leyenda',
                pdfLimitExceeded: 'El tamaño del archivo es mayor que el máximo permitido. (100 MB)',
                imageLimitExceeded: 'El tamaño de la imagen es mayor que el máximo permitido. (5 MB)',
                videoLimitExceeded: 'El tamaño del video es mayor que el máximo permitido. (16 MB)',
                audioLimitExceeded: 'El tamaño del audio es mayor que el máximo permitido. (16 MB)',
                cancel: 'Cancelar',
                send: 'Enviar',
                file: 'Expediente',
                avatar: 'Avatar',
                maxFileSize: 'El tamaño máximo de archivo es de 20 MB.',
                errorProcessingDoc: 'Error al procesar el documento.',
                fileFormatNotAccepted: '¡Formato de archivo no soportado!'
              },
              audio: {
                recordAudio: 'Grabar audio (máximo 2 minutos)',
                cancel: 'Cancelar',
                send: 'Enviar',
                preview: 'Avance',
                addLegend: 'Agregar leyenda',
                sendText: 'Enviar texto',
                sendAudio: 'Enviar audio',
                errorProcessingAudio: 'Error al procesar el audio.',
                accessMicrophoneRequired: 'Para que el chat en vivo funcione completamente, es necesario permitir el acceso al micrófono.',
                transcribe: 'Transcripción de audio'
              },
              quickResponse: {
                quickResponse: 'Respuesta rápida',
                add: 'Agregar',
                close: 'Cerrar',
                unshare: 'Dejar de compartir',
                removeShare: 'Eliminar vínculo de esta respuesta',
                reply: 'Respuesta',
                share: 'Compartir',
                exclude: 'Eliminar',
                createQuickResponse: 'Agregar una respuesta rápida',
                title: 'Título',
                message: 'Mensaje',
                cancel: 'Cancelar',
                errorConsultQuickResponse: 'Error al buscar la respuesta rápidas.',
                errorRegisterQuickResponse: 'Error al registrar la respuesta rápida.',
                errorExcludeQuickResponse: 'Error al eliminar la respuesta rápida.',
                errorShareQuickResponse: 'Error al compartir la respuesta rápida.',
                excludeQuickResponse: 'Eliminar respuesta rápida',
                youSureExclude: '¿Estás seguro de que deseas eliminar esta respuesta?',
                removeShareQuickResponse: 'Eliminar vínculo',
                youSureRemoveShare: '¿Estás seguro de que deseas eliminar el vínculo de esta respuesta rápida?',
                remove: 'Eliminar',
                requiredField: 'Campo obligatorio',
              }
            }
          },
          utils: {
            attendants: {
              attendant: 'Asistente',
              attendants: 'Acomodadores',
              avatar: 'Avatar',
              name: 'Nombre',
              role: 'Ocupación',
              select: 'Seleccione',
              searchAttendant: 'Buscar asistente',
              noSearchResults: 'No se encontraron resultados',
              actions: 'Comportamiento'
            },
            departments: {
              department: 'Departamento',
              attendants: 'Acomodadores',
              noSearchResults: 'No se encontraron resultados'
            },
            roomOptions: {
              endAttendance: 'Terminar asistencia',
              archiveAttendance: 'Arquivar asistencia',
              reactivateNotifications: 'Reactivar notificaciones',
              muteNotifications: 'Silenciar notificaciones',
              unpinAttendance: 'Desanclar asistencia',
              fixedAttendance: 'Arreglar asistencia',
              transferAttendance: 'Transferir asistencia',
              transferAttendanceSelected: 'Transferir seleccionado',
              endAttendanceSelected: 'Terminar seleccionado',
              transferRestrictedAttendanceSelected: 'Transferir seleccionado (olo para Gerente y Administrador)',
              archiveAttendanceSelected: 'Arquivar seleccionado'
            }
          },
          createGroup: {
            newGroup: 'Nuevo grupo',
            newConversation: 'Nueva conversación'
          },
          createHsm: {
            department: 'Departamento',
            departmentRequired: 'Seleccione un departamento.',
            numberBlocked: 'Este número está bloqueado en este chatbot. El envío sigue disponible, pero los mensajes del cliente no llegarán a la atención mientras el bloqueo esté activo.',
            numberBlockedUnlockAt: 'El desbloqueo se hace en',
            numberBlockedContinue: 'Para enviar de todos modos, avanza para elegir la plantilla.',
            numberBlockedLookupFailed: 'No fue posible verificar si este número está bloqueado.',
            numberBlockedChecking: 'Verificando el número...',
            limitCharactersExceeded: '¡Se superó el límite de caracteres!',
            credits: 'Créditos',
            creditsDescription: 'Para enviar mensajes a los clientes que están inactivos en WhatsApp (24 horas después del último mensaje enviado por el cliente) es necesario utilizar una Plantilla de Mensaje (HSM) preaprobada por WhatsApp. Este envío consume 1 crédito de plataforma.',
            creditsInsufficient: 'Desafortunadamente, no tienes suficientes créditos.',
            attention: 'Atención:',
            attentionDescription: ' Después de 24 horas de inactividad del cliente, la empresa solo puede enviar un mensaje estandarizado y preaprobado por WhatsApp, conocido como HSM. Cada mensaje HSM consume 01 crédito en la plataforma, ya que pueden ser cobrados por WhatsApp.',
            requestCredits: 'Solicita más créditos',
            whoToSendMessage: '¿A quién quieres enviar el mensaje?',
            originNumber: 'Número de origen *',
            nameClient: 'Client name *',
            country: 'País *',
            nameClientWhatsapp: 'Número de WhatsApp del cliente *',
            attentionNinthNumber: ' Ingresa el número de celular del cliente con un código de área de 2 dígitos, por ejemplo: (XX) XXXXX-XXXX. Los mensajes solo se enviarán a los clientes que tengan una cuenta de WhatsApp activa.',
            messageYouCanNot: '¡UPS! No podrás enviar mensajes a',
            messageActiveConversationWith: 'porque ya está en una conversación ACTIVA con ',
            messageActiveConversationAttendants: 'porque ya está en una conversación ACTIVA con otro servidor.',
            messageConversationWithYou: 'ya está en conversación contigo! Envía mensajes a través de la sala de chat.',
            goToRoom: 'Ir a la habitación',
            messageTemplate: 'Plantilla de mensaje (HSM)',
            notAuthorized: '¡UPS! No podrás enviar un mensaje a esta persona ya que no ha autorizado la recepción de mensajes (Opt-In) según las políticas de WhatsApp.',
            messageUserOptIn: 'Para que su empresa envíe un mensaje al cliente (mientras está fuera de la sesión de chat), este cliente debe ser necesariamente un usuario OPT-IN (es decir, ha dado su consentimiento para recibir mensajes). Obtenga más información sobre Opt-In.',
            messageSent: '¡Mensaje enviado!',
            return: 'Regreso',
            advance: 'Avance',
            missingMessage: 'Mensaje faltante',
            notPossibleStartConversation: 'No fue posible iniciar el chat porque el usuario ya está chateando con el chatbot.',
            numberNotValid: '¡UPS! ¡El número ingresado no es una cuenta de WhatsApp válida! Verifique el número y vuelva a intentarlo. Recuerde, no informe a la DDI.',
            identifierPhone: 'Teléfono',
            identifierBsuid: 'BSUID',
            bsuidLabel: 'BSUID del contacto *',
            bsuidHint: 'Identificador de Meta, en el formato PP.números — por ejemplo IN.1648738043044942.',
            bsuidNotValid: '¡UPS! El BSUID informado no es válido. Se espera el formato PP.números, por ejemplo IN.1648738043044942.',
            bsuidCopied: 'BSUID copiado',
            bsuidCopyHint: 'Haga clic para copiar el BSUID completo',
            nameNotValid: 'Ingrese el nombre del cliente.',
            requiredMessage: '¡UPS! ¡Debe completar el mensaje que se enviará!',
            satisfactionSurvey: 'está respondiendo la encuesta de satisfacción.',
            optout: 'optó por no recibir mensajes de su empresa el',
            livechatQueue: 'está en la cola de atención.',
            chatbot: 'está conversando con el chatbot.',
            pdfLimitExceeded: 'El PDF debe tener como máximo 100MB.',
            imageLimitExceeded: 'La imagen debe tener como máximo 5MB.',
            videoLimitExceeded: 'El video debe tener como máximo 16MB.',
          },
          pushGroup: {
            add: 'Agregar',
            attendantAdded: 'Asistente agregado!',
            alreadyInGroup: '¡Este asistente ya está en el grupo!'
          },
        },
        micro: {
          cdt: {
            yesterday: 'El dia de ayer',
            today: 'Hoy dia'
          },
          cdtWithHours: {
            yesterday: 'El dia de ayer',
            today: 'Hoy dia',
            sunday: 'Domingo',
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes',
            saturday: 'Sábado'
          }
        },
        modals: {
          feedback: {
            newFunctions: '¡Ayúdanos a desarrollar nuevas funciones para el tablero!',
            help: '¿Ayudemos a mejorar nuestro panel de control?',
            info: 'Estos comentarios son solo para mejorar, si desea informar un problema técnico, comuníquese con el soporte.',
            nowYouCan: '¡Ahora puedes ayudar a mejorar nuestra plataforma!',
            feedbackWillBeApplied: 'Esta es la página donde se aplicarán los comentarios.',
            whatCanBeImproved: 'Cuéntanos qué se puede mejorar en esta página.',
            example: 'Ej .: Esta página podría tener un botón de información.',
            send: 'Enviar',
            feedbackSentError: 'Hubo un error al enviar los comentarios.',
            feedbackSentSuccessfully: '¡Comentarios enviados con éxito!',
            requireFields: 'Debes completar los campos.',
            contactSupport: 'Se ha producido un error, póngase en contacto con el servicio de asistencia.',
            feedbackExcludeError: 'Se produjo un error al eliminar los comentarios.',
            feedbackExcludeSuccessfully: '¡Comentarios eliminados correctamente!'
          },
          image: {
            image: 'Imagen'
          },
          recharge: {
            requestCredits: 'Solicitar Créditos',
            requestCreditsDescriptionMini: 'Puede solicitar créditos adicionales para usar en Globalbot.',
            requestCreditsDescriptionMini2: 'Elija una de las opciones a continuación y nuestro equipo se pondrá en contacto con usted.',
            requestCreditsDescription: 'Puede solicitar créditos adicionales para usar en la mensajería. <span style="color: #ff6600;">Valores de acuerdo con su plan contratado.</span>',
            requestCreditsDescriptionCopilot: 'Puede solicitar créditos adicionales para usar en el Copiloto. Por favor, ingrese los detalles a continuación y uno de nuestros especialistas se pondrá en contacto con usted.',
            requestCreditsDescription2: 'Elija una de las opciones a continuación y nos pondremos en contacto con usted lo antes posible.',
            whatsapp: 'Paquetes de WhatsApp*',
            copilot: 'Copiloto*',
            type: 'Escribe *',
            value: 'La cantidad *',
            cancel: 'Cancelar',
            request: 'Solicitud',
            messageFailedRequestCredits: 'Oops, falha ao solicitar créditos.',
            creditsRequested: 'Créditos solicitados.',
            fieldsRequired: 'Debes completar los campos.',
            mostPopular: 'más popular',
            single: 'individual',
            credits: 'créditos',
            monthly: 'mensual',
            important: '* Los créditos adquiridos tienen una validez de 6 meses.',
            smsAndEmail: 'SMS e Email',
            consult: 'Consultar'
          },
          upgrade: {
            meetGlobalbot: '¡Conoce la versión completa de Globalbot!',
            additionalFeaturesDescription: 'Más de 100 funciones adicionales para que su empresa venda más y brinde un mejor servicio en WhatsApp y otros canales de chat, incluyendo:',
            additionalFeatures: '¡Chat en vivo, campañas de marketing, integraciones, automatizaciones, informes analíticos y mucho más!',
            wantToMeetDescription: '¡Haga clic ahora en <strong>Quiero Conocer</strong> y uno de nuestros profesionales se pondrá en contacto con usted para programar una demostración!',
            wantToMeet: 'Quiero Conocer',
            cancel: 'Cancelar',
            requestCompleted: '¡Solicitud completada!',
            requestError: 'Error al solicitar, inténtelo de nuevo.'
          }
        },
        tags: {
          removeTag: 'Remover tag',
          addTags: 'Add tag',
          labelTag: 'Buscar tag',
          tagAlreadyExistsInConversation: 'Esta etiqueta ya existe en la conversación.',
          categoryNotFound: 'Categoría no encontrada, verifique el componente mini Tags.',
          manageTags: 'Administrar Tags'
        },
        departments: {
          searchDepartment: 'Buscar departamento',
          manageDepartments: 'Gestionar Departamentos',
          noDepartments: 'Ningún departamento encontrado.'
        },
        exporter: {
          mountingReport: 'Montaje de informe ...',
          exportToCsv: 'Exporta a CSV',
          type: 'Escribe',
          answered: 'Contestado',
          response: 'Respuesta',
          disambiguated: 'Desambiguación',
          notResponse: 'Sin respuesta',
          active: 'Activo',
          inactive: 'Inactivo',
          reportGeneratedSuccessfully: 'Informe generado con éxito.',
          messageFailedReport: 'Vaya, fallaron los informes. Vuelve a intentarlo.'
        },
        loading: {
          connectingToServer: 'Conectando al servidor...',
          assemblingTheInformation: 'Reuniendo la información...'
        },
        zendesk: {
          title: 'Zendesk',
          brands: 'Marcas',
          forms: 'Formas',
          fields: 'Etiquetas',
          group: 'Grupo',
        }
      },
      layouts: {
        default: {
          messageErrorInfo: 'Vaya, se produjo un error al guardar la información.',
          tolerancePeriod: 'Período de tolerancia',
          finishedJourneyDescription: 'Su jornada laboral ha terminado, pero ha entrado en el período de gracia.',
          timeLeft: 'Termine su trabajo en el tiempo restante de',
          disconnectedFromThePlatform: 'Una vez finalizado el período de gracia, se le desconectará de la plataforma.',
          iKnow: 'Estoy consciente',
          finishedJourney: 'Viaje terminado',
          workingEnded: 'Tu jornada laboral ha terminado.',
          freeTime: '¡Disfruta tu tiempo libre!',
          seeYouLater: 'Hasta luego',
          lostConnection: 'Conexión Perdida',
          whatsappBalanceBlocked: {
            title: 'Saldo de WhatsApp agotado',
            description: 'El envío de mensajes por WhatsApp está pausado. Agregue créditos para reanudarlo.',
            descriptionNoPermission: 'El envío de mensajes por WhatsApp está pausado. Contacte al administrador de la cuenta para agregar créditos.',
            action: 'Agregar créditos',
            close: 'Cerrar aviso'
          }
        }
      },
      pages: {
        actions: {
          create: {
            addAction: 'Agregar acción',
            title: 'Título',
            description: 'Descripción',
            request: 'Solicitud',
            getAndPost: 'GET, POST',
            newAction: 'Nueva acción',
            newActionDescription: 'Descripción de la nueva acción'
          },
          list: {
            actions: 'Comportamiento',
            addAction: 'Agregar acción'
          }
        },
        advanced: {
          emailUnsubscribes: {
            title: 'Bajas de correo',
            description: 'Consola del supermaster. "Supresión global": correos que no reciben campañas de ningún cliente. "Grupos por dominio": correos dados de baja en cada dominio, de cualquier cuenta. Eliminar o liberar exige un motivo y queda registrado.',
            tabGlobal: 'Supresión global',
            tabGroups: 'Grupos por dominio',
            email: 'Correo',
            created: 'Baja el',
            actions: 'Acciones',
            remove: 'Quitar de la global',
            removeTitle: 'Quitar correo de la supresión global',
            removeDescription: 'El correo volverá a recibir correos de todos los clientes. Esta acción queda auditada con el motivo.',
            removed: 'Correo quitado de la supresión global.',
            loadMore: 'Cargar más',
            page: 'Página',
            previousPage: 'Página anterior',
            nextPage: 'Página siguiente',
            empty: 'Ningún correo en la supresión global.',
            searchGroups: 'Buscar por dominio o id de cuenta',
            account: 'Cuenta',
            unsubscribed: 'Dados de baja',
            openGroup: 'Ver correos',
            groupsEmpty: 'Ningún grupo encontrado.',
            back: 'Volver',
            checkEmail: 'Verificar correo',
            checkEmailHint: 'El proveedor no tiene búsqueda por texto: ingresa el correo completo.',
            check: 'Verificar',
            invalidEmail: 'Ingresa un correo válido.',
            checkSuppressed: 'Este correo está en la supresión global.',
            checkNotSuppressed: 'Este correo no está en la supresión global.',
            tabBlackList: 'Bloqueos y liberaciones',
            blackListDescription: 'Historial local de correos dados de baja (bloqueos) y liberados, con el motivo de la liberación, de todas las cuentas.',
            searchBlackList: 'Buscar por correo o id de cuenta',
            filterStatus: 'Situación',
            filterScope: 'Ámbito',
            all: 'Todos',
            scopeGlobal: 'Global',
            scopeGroup: 'Grupo del dominio',
            domain: 'Dominio',
            lastSource: 'Origen',
            blackListEmpty: 'Ningún registro encontrado.',
            sources: {
              webhook: 'Baja por el destinatario',
              panel: 'Administrador de la cuenta',
              supermaster: 'Supermaster',
              'global-reset-script': 'Reinicio de la supresión global'
            }
          },
          copilot: {
            assistant: 'Asistente de Escritura',
            main: 'Principal',
            cdt: 'Fecha/Hora',
            account: 'Cuenta',
            user: 'Usuario',
            type: 'Tipo Copiloto',
            question: 'Consulta',
            response: 'Respuesta',
            rowsPerPage: 'Filas por página:'
          },
          logs: {
            list: {
              addLog: 'Agregar log',
              version: 'Versión',
              change: 'Cambio',
              description: 'Description',
              cancel: 'Cancelar',
              add: 'Adicionar',
              update: 'Atualizar',
              removedColumn: 'Columna de categoría eliminada por inutilización',
              deprecateModal: 'Modo de observación obsoleto.',
              updateVisualsAndProgrammatic: 'Actualizaciones visuales y programáticas.'
            }
          },
          conversation: {
            conversationDetails: 'Detalles de la conversación',
            search: 'Buscar',
            account: 'Cuenta',
            attendants: 'Acomodadores',
            device: 'Dispositivo',
            desktop: 'Desktop',
            mobile: 'Mobile',
            chrome: 'Chrome',
            safari: 'Safari',
            mozilla: 'Mozilla Firefox',
            edge: 'Edge',
            explorer: 'Internet Explorer',
            whatsapp: 'Whatsapp',
            facebook: 'Facebook Messenger',
            dispatchEmail: 'Correo electrónico de cliente potencial enviado',
            dispatchEmailToClient: 'Correo electrónico enviado al cliente',
            viewedEmailByClient: 'Correo electrónico visto por el cliente',
            dateAndHour: 'Fecha y hora',
            channel: 'Canal',
            origin: 'Origen',
            messageNotFoundConversation: 'Desafortunadamente, no encontramos esta conversación.'
          },
          edit: {
            billingCredits: 'Facturación de Créditos',
            hsmMarketingDiscount: 'Descontar 2 créditos en HSM de Marketing',
            billing: {
              title: 'Billing — Mensajes de servicio',
              model: 'Modelo de cobro',
              modelPerMessageBalance: 'Saldo por mensaje',
              modelSessionCredits: 'Créditos por sesión (heredado)',
              modelPerMessageBalanceHint: 'Cada mensaje de servicio entregado descuenta el saldo de la cuenta.',
              modelSessionCreditsHint: 'Modelo anterior: consume 1 crédito por sesión de conversación, sin descontar saldo.',
              currency: 'Moneda',
              currencyHint: 'Fija en BRL por ahora.',
              gatewayCustomerId: 'Id del cliente en el proveedor de pago',
              gatewayCustomerIdHint: 'Definido por el backend al vincular la cuenta al proveedor.',
              gatewayNotConfigured: 'No configurado',
              unitPrice: 'Precio por mensaje de servicio',
              unitPriceHint: 'En blanco aplica el precio predeterminado:',
              lowBalanceThreshold: 'Límite de alerta de saldo bajo',
              lowBalanceThresholdHint: 'En blanco desactiva la alerta de saldo bajo.',
              alertRecipients: 'Destinatarios de las alertas de saldo',
              alertRecipientsHint: 'Vacío notifica a los usuarios MASTER/ADMIN de la cuenta, incluso con correos adicionales.',
              alertEmails: 'Correos adicionales',
              alertEmailsHint: 'Para quien no tiene usuario en la plataforma (ej.: finanzas). Escriba y presione Enter o haga clic en +. Solo reciben el correo de aviso. Máximo:',
              alertEmailsMax: 'Límite de correos adicionales alcanzado. Máximo:',
              addAlertEmail: 'Agregar correo',
              invalidEmail: 'Ingrese un correo válido.',
              searchUser: 'Buscar usuario',
              removedUser: 'Usuario eliminado',
              chargeNonBillable: 'Cobrar mensajes exentos por Meta',
              chargeNonBillableHint: 'También descuenta los mensajes que Meta no cobró, dentro de la franquicia gratuita mensual.',
              balance: 'Saldo actual',
              balanceUpdatedAt: 'Actualizado el',
              lowBalanceAlert: 'Alerta de saldo bajo',
              zeroBalanceAlert: 'Alerta de saldo cero',
              lastNotifiedAt: 'Última notificación',
              lastBalance: 'Saldo en la notificación',
              neverNotified: 'Nunca notificado',
              minPrice: 'Mínimo:',
              priceBelowMinimum: 'Precio por debajo del mínimo permitido:',
              invalidPrice: 'Introduzca un valor válido, con hasta 4 decimales.',
              invalidThreshold: 'Introduzca un valor mayor o igual a cero.',
              overdraftLimit: 'Sobregiro (límite)',
              overdraftLimitHint: 'Cuánto puede quedar negativo el saldo sin dejar de enviar. Vacío o 0 lo desactiva. Máximo:',
              maxBlockedNotifications: 'Máximo de avisos de bloqueo',
              maxBlockedNotificationsHint: 'Avisos por ciclo de bloqueo (el inmediato más los reenvíos diarios). 0 envía solo el inmediato. Vacío usa el valor predeterminado:',
              overdraftExhaustedAlert: 'Alerta de sobregiro agotado',
              overdraftBelowUsage: 'Este límite no cubre el negativo actual: la cuenta se bloquea al guardar, y sin disparar alerta. Uso actual:',
              addBalance: 'Agregar saldo',
              addBalanceHint: 'Registra un ajuste manual en el saldo de la cuenta. Queda en el extracto con la observación de abajo y el usuario que lo hizo.',
              adjustAmount: 'Importe a agregar',
              adjustNote: 'Motivo del ajuste',
              adjustNoteHint: 'Explique por qué se está cambiando el saldo. Mínimo de caracteres:',
              adjustDuplicate: 'Este ajuste ya había sido aplicado; el saldo no cambió de nuevo.',
              invalidAdjustAmount: 'Introduzca un valor mayor que cero, con hasta 4 decimales.',
              invalidAdjustNote: 'Describa el motivo con al menos',
              invalidAdjustNoteMax: 'El motivo debe tener como máximo',
              errorInvalidAmount: 'Importe fuera de los límites aceptados por el servidor.',
              errorNoteRequired: 'El ajuste de saldo exige una observación explicando el motivo.',
              errorModelNotEnabled: 'Esta cuenta no está en el modelo de saldo por mensaje.',
              notifiedCount: 'Avisos en el ciclo',
              invalidOverdraftLimit: 'Introduzca un valor mayor o igual a cero, con hasta 4 decimales.',
              invalidOverdraftLimitMax: 'Sobregiro por encima del máximo permitido:',
              invalidMaxBlockedNotifications: 'Introduzca un número entero entre 0 y',
              errorForbidden: 'No tiene permiso para cambiar el billing de esta cuenta.',
              errorAccountNotFound: 'Cuenta no encontrada.',
              errorValidation: 'Revise los campos: algún valor no fue aceptado.'
            },
            yes: 'Sim',
            delPayment: 'Borrar pagamiento',
            paid: 'Pagado',
            consumption: 'Consumo',
            status: 'Status',
            editAccount: 'Editar cuenta',
            clientsList: 'Lista de clientes',
            editAccountTwo: 'Editar cuenta - ',
            credits: 'Créditos',
            recurrentCredits: 'Franquicia de mensajería recurrente',
            sharedFranchise: 'Franquicia compartida',
            otherChannels: 'Otros canales',
            newFranchise: 'Nuevo modelo',
            shared: 'Compartida',
            add: 'Agregar',
            del: 'Borrar',
            fa: '2FA',
            email: 'E-mail',
            active: 'Activo',
            inactive: 'Inactivo',
            phone: 'Teléfono',
            security: 'Módulos habilitados',
            realTime: 'Tiempo real',
            statistics: 'Estadísticas',
            people: 'Gente',
            conversation: 'Conversaciones',
            interface: 'Interface',
            flow: 'Fluir',
            intelligence: 'Inteligencia',
            campaigns: 'Campañas',
            liveChat: 'Chat en vivo',
            library: 'Biblioteca',
            preferences: 'Preferencias',
            limiter: 'Usuarios  - Limitador ',
            decraseLimit: 'Límite inferior',
            increaseLimit: 'Aumentar el límite',
            createMaster: 'Crear master',
            accountDetails: 'Detalles de la cuenta',
            accountName: 'Nombre de la cuenta',
            addPermissions: 'Agregar permisos',
            addBriefing: 'Agregar briefing',
            companyName: 'Nombre de empresa',
            fantasyName: 'Nombre de fantasía',
            cnpj: 'CNPJ',
            address: 'Dirección',
            zipCode: 'Código postal',
            street: 'Calle',
            edit: 'Editar',
            contacts: 'Contactos',
            plan: 'Planificar y Contratar',
            uploadContractLabel: 'Contrato',
            contractValidityLabel: 'Vigencia del contrato',
            contractDateLabel: 'Fecha del contrato',
            seeDocument: 'Ver documento',
            successUpdate: '¡Cliente actualizado!',
            errorUpdate: '¡Error al actualizar el cliente!',
            type: 'Tipo',
            characteristics: 'Franquicias y canales',
            numberAttendances: 'Whatsapp - deducible mensual',
            otherChannelAttendances: 'Otros canales - Asignación mensual',
            whatsAppAttendances: 'Whatsapp - deducible mensual',
            emailAttendances: 'E-mail - deducible mensual',
            smsAttendances: 'SMS - deducible mensual',
            webchat: 'Webchat',
            facebook: 'Facebook',
            whatsapp: 'Whatsapp',
            whatsappFranchise: 'Whatsapp Franquicia',
            sms: 'SMS',
            integration: 'Integración',
            observations: 'Comentarios',
            none: 'Ninguno',
            simple: 'Simples',
            intermediate: 'Intermediario',
            advanced: 'Avanzado',
            payments: 'Pagos',
            form: 'Formulario',
            setup: 'Configuración',
            description: 'Descripción',
            valueReal: 'Valor: R$ ',
            date: 'Fecha',
            monthlyPayment: 'Mensualidad',
            cronogram: 'Cronograma',
            planning: 'Planificación',
            initialDate: 'La fecha de inicio',
            implementation: 'Implementación',
            endDate: 'Fecha final',
            observation: 'Observación',
            customerSuccess: 'Éxito del cliente',
            chatbots: 'Chatbots',
            online: 'Online',
            offline: 'Offline',
            versioning: 'Control de versiones',
            old: 'VIEJO',
            stable: 'ESTABLE',
            beta: 'BETA',
            alpha: 'ALFA',
            editAddress: 'Editar dirección',
            number: 'Número',
            district: 'Vecindario',
            city: 'Ciudad',
            state: 'Estado',
            cancel: 'Cancelar',
            save: 'Guardar',
            addContact: 'Agregar contacto',
            delContact: 'Borrar contacto',
            editContact: 'Editar contacto',
            role: 'Oficina',
            name: 'Nombre',
            projectManager: 'Gerente de proyecto',
            title: 'Titulo',
            addImplementationCronogram: 'Agregar programa de implementación',
            addCronogramByCs: 'Agregar programa de CS',
            addCronogramByPlanning: 'Agregar programa de planificación',
            addRateBySetup: 'Agregar tarifa de CONFIGURACIÓN',
            value: 'Valor',
            values: 'Valores',
            csStage: 'Etapa CS',
            currentStatus: 'Estado actual',
            accountStatusOnline: 'Online',
            accountStatusPartialOnline: 'Online parcial',
            accountStatusPaused: 'En pausa',
            accountStatusChurn: 'Churn',
            flag: 'Flag',
            ongoing: 'OnGoing',
            onboarding: 'OnBoarding',
            addRateMonthly: 'Agregar tarifa mensual',
            newUser: 'Agregar usuario',
            password: 'Contraseña',
            addCredits: 'Agregar créditos',
            veryLow: 'Muy bajo',
            low: 'Bajo',
            medium: 'Promedio',
            high: 'Alta',
            veryHigh: 'Muy alta',
            important: 'IMPORTANTE',
            starter: 'G-Principiante',
            professional: 'G-Profesional',
            enterprise: 'G-Enterprise',
            gAdvanced: 'G-Advanced',
            orion: 'G-Orion',
            planLite: 'Lite',
            planStarter: 'Starter',
            planProfessional: 'Professional',
            planAdvanced: 'Advanced',
            planEnterprise: 'Enterprise',
            planGlobal: 'Global',
            planLite22: 'LITE-22',
            planStarter22: 'STARTER-22',
            planProfessional22: 'PROFESSIONAL-22',
            planAdvanced22: 'ADVANCED-22',
            planEnterprise22: 'ENTERPRISE-22',
            planLite23: 'LITE-23',
            planStarter23: 'STARTER-23',
            planProfessional23: 'PROFESSIONAL-23',
            planEnterprise23: 'ENTERPRISE-23',
            january: 'Enero',
            february: 'Febrero',
            march: 'Marcha',
            april: 'Abril',
            may: 'Mayo',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
            genAi: 'IA generativa',
            instagram: 'Instagram',
            crm: "CRM",
            genAiFranchise: 'Franquicia de IA generativa',
            genAiStandalone: 'IA generativa independiente',
            miniGlobalbot: 'Globalbot Mini'
          },
          list: {
            exportAccounts: 'Exportar cuentas',
            plan: 'Plan',
            csStage: 'Etapa CS',
            accountStatus: 'Estado de la cuenta',
            cs: 'CS Responsable',
            listClients: 'Lista de clientes',
            flagOk: 'Saludable',
            flagYellow: 'Atención',
            flagRed: 'Crítica',
            flagNone: 'Sin clasificación',
            model: 'Mod.',
            modelLetterBalance: 'S',
            modelLetterCredits: 'C',
            balance: 'Saldo',
            overdraftLimit: 'Sobregiro',
            noOverdraft: 'Sin límite',
            notOnBalance: 'Sin saldo monetario',
            usingOverdraft: 'Usando sobregiro',
            balanceFilter: 'Situación del saldo',
            balanceAll: 'Todas',
            balanceWithBalance: 'Con saldo',
            balanceZero: 'Saldo en cero',
            balanceUsingOverdraft: 'Usando sobregiro',
            balanceWithOverdraft: 'Con sobregiro',
            refreshList: 'Actualizar lista',
            createNewAccount: 'Crear una nueva cuenta',
            wantToCreateNewAccount: '¿Quiere crear una nueva cuenta? Haga clic aquí :)',
            version: 'Versión',
            stable: 'Estable',
            beta: 'Beta',
            alpha: 'Alfa',
            old: 'Viejo',
            updateNewVersion: 'Actualizar a una nueva versión',
            edit: 'Editar',
            exclude: 'Borrar',
            addAccount: 'Añadir cuenta',
            companyName: 'Nombre de la empresa',
            steps: 'Ahora sigue estos pasos',
            open: 'Abre el',
            spreadsheetClients: 'hoja de cálculo del cliente',
            insertEmail: 'Poner este correo electrónico',
            insertPassword: 'Además, ingrese la contraseña deseada para la cuenta, debe ser una contraseña muy segura.',
            insertPasswordAndAdd: 'Ingrese la contraseña ingresada en la hoja de cálculo en el campo a continuación y haga clic en Agregar.',
            passwordMaster: 'Contraseña maestra',
            cancel: 'Cancelar',
            add: 'Agregar',
            excludeAccount: 'Borrar cuenta',
            sureExcludeAccount: '¿Estás segura de que quieres eliminar esta cuenta?',
            allConversationsAndChatbotsDeleted: 'Se eliminarán todas las conversaciones y todos los chatbots.',
            updateVersionToStable: 'Actualizar la versión a estable',
            beAware: 'Antes de continuar, tenga en cuenta que',
            thisChangesVersionPanel: 'Esta es una acción que cambiará la versión del panel del cliente.',
            losesAllAttendance: 'Esta opción hará que el cliente pierda todas las llamadas actuales de Old y ya no tendrá acceso, solo a través de la pestaña Conversaciones.',
            beforeToClick: 'Antes de hacer clic en actualizar, verifique si ya tiene departamentos creados accediendo a https://panel.globalbot.ai en la cuenta del cliente (si ya los tiene, elimínelos, ya que puede interferir con la migración).',
            createNewDepartment: 'Esta acción creará nuevos departamentos (con los mismos nombres) y los asignará en los flujos y en los usuarios, por lo que por seguridad no puede estar editando usuarios o el flujo al actualizar.',
            switchToStableVersion: 'Cambiar a versión estable',
            name: 'Nombre',
            actions: 'Comportamiento',
            jan: 'Ene.',
            feb: 'Feb.',
            mar: 'Mar.',
            apr: 'Abr.',
            may: 'May.',
            jun: 'Jun.',
            jul: 'Jul',
            aug: 'Ago.',
            sep: 'Sep.',
            oct: 'Oct.',
            nov: 'Nov.',
            dec: 'Dic.',
            migratedAccountSuccess: '¡La cuenta se ha migrado correctamente!',
            errorHasOccurred: 'Ha ocurrido un error, ¡contacta a un desarrollador urgentemente!',
            normalStatus: 'Normal',
            endingStatus: 'Finalizando',
            exceededStatus: 'Excedido',
            columnFranchise: 'Consumo de la franquicia'
          },
          server: {
            serversWhatsapp: 'Servidores de WhatsApp',
            updateGit: 'Atualizar Git',
            requestUpdateGit: 'Solicite la actualización de git en todos los servidores.',
            update: 'Actualizar',
            servers: 'Servidores',
            serversDescription: 'Agregar nuevo servidor.',
            add: 'Agregar',
            numbering: 'Numeración',
            version: 'Versión',
            responsible: 'Responsable',
            whatsapp: 'Whatsapp',
            indifferent: 'Indiferente',
            normal: 'Normal',
            business: 'Business',
            chip: 'Chip',
            client: 'Cliente',
            globalbot: 'Globalbot',
            server: 'Servidor',
            instanceType: 'Tipo de Instancia',
            ip: 'IP',
            account: 'Cuenta',
            chatbot: 'Chatbot',
            info: 'Información',
            actions: 'Comportamiento',
            running: 'Corriendo!',
            serverAvailable: 'Servidor disponible',
            serverDown: 'Servicio caído, gerente de espera.',
            qrCode: 'QR Code',
            gitPull: 'Git Pull',
            restartServer: 'Reiniciar servidor',
            edit: 'Editar',
            excludePairing: 'Eliminar emparejamiento',
            save: 'Guardar',
            cancel: 'Cancelar',
            serverData: 'Datos del servidor',
            instanceId: 'ID de Instancia',
            serverName: 'Nombre del servidor',
            sureRestartServer: '¿Está seguro de que desea reiniciar este servidor? Esto puede tomar unos pocos minutos.',
            restart: 'Reiniciar',
            exclude: 'Borrar',
            sureExcludePairing: '¿Está seguro de que desea eliminar el emparejamiento de este servidor? Tendrá que volver a leer el código QR.',
            cellphone: 'Teléfono móvil',
            manager: 'Gerente',
            isBusiness: 'is Business',
            isChipResponsible: 'is Chip Responsible',
            messageError: '¡Error, ver consola!',
            routeNotFound: 'Ruta no encontrada, servidor ',
            serverAddedSuccessfully: '¡Servidor agregado exitosamente!',
            pairingDeleted: '¡Emparejamiento eliminado correctamente!'
          },
          tasks: {
            tasks: 'Tareas | ',
            newTask: 'Nueva tarea',
            plan: 'Plan',
            status: 'Status',
            notStarted: 'No empezado',
            ready: 'Listo',
            stoppedGlobalbot: 'Interrumpido Globalbot',
            stoppedClient: 'Interrumpido Cliente',
            date: 'Fecha',
            invalidDate: 'Fecha invalida',
            noDate: 'Sin fecha',
            description: 'Descripción',
            notDescription: 'No hay una descripción',
            advancedSettings: 'Configuraciones avanzadas',
            do: 'Do',
            go: 'Go',
            learn: 'Learn',
            editTask: 'Editar Tarefa',
            selectUsers: 'Seleccionar usuarios',
            selectAccount: 'Seleccionar cuenta',
            selectBot: 'Seleccionar bot',
            selectType: 'Seleccione tipo',
            title: 'Título',
            selectStatus: 'Seleccionar estado',
            done: 'Hecho'
          },
          users: {
            listUsers: 'Lista de usuarios',
            user: 'Usuario',
            name: 'Nombre',
            email: 'Email',
            role: 'Oficina',
            newPassword: 'Nueva contrasenã',
            avatar: 'Avatar',
            permission: 'Permiso',
            done: 'Hecho',
            supreme: 'Supreme',
            master: 'Master',
            administrator: 'Administrador',
            manager: 'Gerente',
            attendant: 'Asistente',
            junior: 'Junior',
            messageErrorInfo: 'Vaya, se produjo un error al guardar la información.',
            messageErrorUser: 'Vaya, se produjo un error al guardar al usuario.',
            supremeCommander: 'Supreme Commander'
          }
        },
        analytics: {
          attendant: {
            attendant: {
              indicatorsByAttendants: 'Indicadores por asistentes',
              attendantsByTime: 'Asistencias por hora del día',
              chatbotsAndAttendants: 'Chatbots x Acomodadores',
              departments: 'Departamentos',
              attendants: 'Acomodadores',
              statistics: 'Estadísticas',
              exportAttendants: 'Exportar llamadas'
            }
          },
          channels: {
            channels: {
              indicatorsByChannels: 'Indicadores por Canales',
              attendantsByTime: 'Asistencias por hora del día',
              chatbotsAndAttendants: 'Chatbots x Acomodadores',
              channelOverview: 'Resumen por canal',
              statistics: 'Estadísticas'
            }
          },
          flow: {
            flow: {
              flowAnalysis: 'Análisis de flujo',
              statistics: 'Estadísticas'
            }
          },
          identifiers: {
            identifiers: {
              customIdentifiers: 'Identificadores personalizados',
              statistics: 'Estadísticas',
              seeMore: 'Ver Más',
              quantity: 'Cantidad',
              identifier: 'Identificador'
            }
          },
          knowledge: {
            knowledge: {
              intelligencePerformance: 'Rendimiento de inteligencia',
              conventionalIA: 'IA Convencional',
              conventionalIADescription: 'Respuestas estandarizadas. Interpreta la intención del usuario y presenta respuestas registradas (texto, vídeo, imágenes, documentos y enlaces).',
              generativeIA: 'IA Generativa',
              generativeIADescription: '',
              knowledgeBase: 'Base de conhecimento',
              commonQuestions: 'Preguntas comunes',
              advanced: 'Avanzado',
              artificialIntelligence: 'Inteligencia',
              statistics: 'Estadísticas'
            },
            responses: {
              response: 'Respuesta'
            }
          },
          location: {
            location: {
              countries: 'Países',
              states: 'Estados',
              cities: 'Ciudades',
              geolocationAdvanced: 'Avanzado',
              geolocation: 'Geolocalización',
              statistics: 'Estadísticas',
              search: 'Buscar'
            }
          },
          origin: {
            origin: {
              platformAndBrowsers: 'Plataforma y navegadores',
              campaign: 'Campañas',
              originAttendance: 'Origen de las asistencias',
              statistics: 'Estadísticas',
              url: 'Localizador Uniforme de Recursos'
            }
          },
          cards: {
            attendance: 'Asistencias',
            descriptionAttendance: 'Volumen total de llamadas (todos los canales) para el período seleccionado.<br/>La comparación es relativa al período inmediatamente anterior.',
            leads: 'Leads',
            descriptionLeads: 'Total de Leads capturados en el período seleccionado. Los Leads son conversaciones en las que los usuarios completaron al menos el correo electrónico o el teléfono',
            satisfaction: 'Satisfacción',
            descriptionSatisfaction: 'Tasa de satisfacción relacionada con la Encuesta de satisfacción del<br/>usuario en el período seleccionado. La comparación es relativa al período inmediatamente anterior.<br/>Este indicador es visible solo cuando la Encuesta de satisfacción está habilitada en la ruta Preferencias > Chatbot > Comportamiento.',
            descriptionSatisfactionMini: 'Tasa de satisfacción relacionada con la Encuesta de satisfacción del<br/>usuario en el período seleccionado. La comparación es relativa al período inmediatamente anterior.',
            intelligence: 'Inteligencia',
            descriptionIntelligenceOne: 'Tasa de éxito de la(s) Inteligencia(s) Artificial(es) de los chatbots seleccionados <br>y punto. Para la IA convencional, es la suma<br> de las preguntas respondidas y las preguntas desambiguadas.<br> Para la IA generativa, solo se consideran las preguntas respondidas, ya que <br> no hay desambiguación.<br> La comparación es relativa a el período inmediatamente anterior.',
            descriptionIntelligenceMini: 'Tasa de respuestas de la Inteligencia Artificial Generativa, que fueron respondidas de acuerdo con el contenido proporcionado. La comparación es relativa al período inmediatamente anterior.',
            connected: 'Conectado',
            descriptionConnected: 'Total de usuarios (colaboradores) conectados<br/>actualmente a la Plataforma Globalbot.<br/>Se refiere a las personas que utilizan la<br/>plataforma (como administradores, gerentes<br/>o asistentes), sin referirse al número de<br/>clientes en servicio.',
            beta: 'BETA',
            descriptionBeta: 'El equipo de Globalbot está desarrollando<br/>y probando la función identificada como BETA. Espere noticias sobre<br/>la evolución de esta función.',
            viewByChannel: 'Visión por Canal',
            descriptionViewByChannel: 'Consulta los principales indicadores de servicio por canal, cuantitativos y cualitativos.',
            attendants: 'Acomodadores',
            descriptionAttendants: 'Ver los indicadores de desempeño de los asistentes de forma individual y colectiva.',
            descriptionIntelligenceTwo: 'Analizar el desempeño de la Inteligencia Artificial, incluyendo preguntas respondidas, inequívocas y sin respuesta.',
            geolocation: 'Geolocalización',
            descriptionGeolocation: 'Verifique desde qué lugares llegan los asistentes, por país, estado y ciudad.',
            origin: 'Origen',
            descriptionOrigin: 'Analizar el origen de las llamadas, considerando las fuentes de tráfico, por ejemplo, campañas digitales.',
            flowAnalysis: 'Análisis de flujo',
            descriptionFlowAnalysis: 'Vea cómo los usuarios interactúan con los flujos de conversación, considerando el compromiso y el abandono.',
            customized: 'Personalizado',
            descriptionCustomized: 'Consulte las métricas de sus identificadores personalizados que forman parte de los flujos de conversación.',
            statistics: 'Estadísticas',
            tooltipStatistics: '¿Dudas en estadística? Haga clic aquí y acceda al Tutorial que preparó nuestro equipo. ¡Tenemos muchas novedades!',
            totalValue: 'Valor Total',
            totalValueDescription: 'Consulta el valor total generado por las conversaciones durante el período (muy útil para quienes venden productos y servicios). Para aparecer aquí, el valor debe asignarse a cada conversación de forma individual.'
          }
        },
        block: {
          create: {
            add: 'Agregar',
            blocks: 'Bloques',
            welcome: 'Bienvenido',
            addButton: 'Botón agregar',
            create: 'Crear',
            title: 'Título',
            description: 'Descripción',
            message: 'Mensaje',
            name: 'Nombre',
            firstName: 'Primer nombre',
            lastName: 'Apellido',
            buttons: 'Botones',
            button: 'Botón',
            email: 'E-mail',
            phone: 'Teléfono',
            cpf: 'CPF',
            cnpj: 'CNPJ',
            birthDate: 'Fecha de nacimiento',
            calendar: 'Calendario',
            number: 'Número',
            checkbox: 'Checkbox',
            slider: 'Slider',
            image: 'Imagen',
            intelligence: 'Inteligencia',
            liveChat: 'Chat en vivo',
            zipCode: 'Código postal',
            city: 'Ciudad',
            state: 'Estado',
            country: 'País',
            carousel: 'Carrusel',
            guideScreen: 'Pantalla de guía',
            money: 'Máscara de dinero',
            exit: 'Terminar'
          },
          index: {
            blocks: 'Bloques',
            listblock: 'lista de bloqueos',
            new: 'Nuevo',
            index: 'index'
          }
        },
        bots: {
          bots: {
            testChatbot: 'Testar Chatbot',
            editFlow: 'Editar Flujo',
            viewer: 'Espectador',
            lite: 'Lite',
            pro: 'Pro',
            editor: 'Editor',
            settingsAccess: 'Configuración de acceso',
            createNewChatbot: 'Nuevo Chatbot',
            createNewChatbotDesc: 'Crea un nuevo chatbot, edita el flujo conversacional, define parámetros y prueba.',
            installation: 'Instalación',
            titleChatbot: 'Título del chatbot',
            nameAttendant: 'Nombre del asistente',
            descriptionChatbot: 'Descripción',
            fieldRequired: 'Campo obligatorio',
            cancel: 'Cancelar',
            create: 'Crear',
            createSuccessfully: '¡Chatbot creado exitosamente!',
            createError: 'Error al crear chatbot',
            hello: 'Hola. ¿Puedo ayudarte?',
            contactGlobalbot: 'Contacto Globalbot',
            subject: 'assunto',
            content: 'contenido',
            indication: 'Tu amigo tiene una referencia',
            thanks: 'Hola, {nombre}, muchas gracias por tu interés en ',
            introduction: 'Con Globalbot su empresa ofrecerá una experiencia de diálogo con sus públicos en las situaciones más diversas. Esta experiencia es fantástica, especialmente en dispositivos móviles (teléfonos celulares y tabletas), ya que la gente ya está acostumbrada a usar aplicaciones de mensajería como Facebook, Whatsapp y muchas otras.',
            listing: 'También he enumerado aquí algunas posibles aplicaciones de ',
            inCompany: ' en tu compañía:',
            leadGeneration: 'Generación líder:',
            leadGenerationDescription: ' Úselo para retener al visitante del sitio web a través del diálogo y generar clientes potenciales para los equipos de ventas, integrándolo con herramientas de la fuerza de ventas o activando un correo electrónico.',
            marketingAndSales: 'Marketing y ventas:',
            marketingAndSalesDescription: ' Realizar campañas y acciones de marketing enfocadas a las ventas, presentando un diálogo que lleve al cliente a involucrarse con el producto y sus características.',
            search: 'Buscar:',
            searchDescription: ' Transforma extensas encuestas de opinión y satisfacción en diálogos amigables, evitando el aburrimiento y la dispersión.',
            attendance: 'Asistencia al Cliente:',
            attendanceDescription: ' Realizar servicios de atención al cliente, basados en las preguntas más frecuentes y así eliminar puestos de servicio y / o reducir filas de espera.',
            schedulingAndReservations: 'Programación y reservas:',
            schedulingAndReservationsDescription: ' Utilícelo para realizar citas y reservas (oficinas, concesionarios, restaurantes, eventos y muchos otros) integrando sistemas internos.',
            databaseAndCrm: 'Calificación de base de datos y CRM:',
            databaseAndCrmDescription: ' puede servir como interfaz para acceder a la información disponible en las bases de datos, permitiendo la calificación de las bases de datos a través del diálogo.',
            teachingAndLearning: 'Enseñando y aprendiendo:',
            teachingAndLearningDescription: ' Utilizar para acciones de enseñanza y aprendizaje, utilizando los contenidos de la clase para los estudiantes, pudiendo hablar sobre temas específicos de las distintas materias de los cursos.',
            furthermore: 'Además el ',
            dispatchDescription: ' ¡Puede enviar correo electrónico, SMS, mostrar imágenes, audio, archivos de video y más!',
            surpriseAudience: '¡Sorprende a tu audiencia con esta nueva experiencia!',
            regards: 'Graciosamente,',
            telmaAyala: 'Telma Ayala',
            virtualAssistant: 'Asistente virtual',
            address: ' Av. Cristovão Colombo, 3000 / salas 802 e 304 / Floresta Porto Alegre - RS - CEP 90560-002 ',
            moreInformations: 'Más información',
            oneMessage: '¿Sigues por aquí?',
            twoMessage: 'Si no contesta tendré que terminar la asistencia.',
            threeMessage: 'Muy bien, si necesitas ayuda nuevamente, avísame.',
            closeMessage: 'La asistencia fue cerrada por el asistente, agradecemos su contacto y si tiene más preguntas, simplemente llámeme nuevamente.',
            chatbots: 'Chatbots',
            viewGrid: 'Cuadrícula',
            viewList: 'Lista',
            statusActive: 'Activo',
            statusInactive: 'Inactivo',
            botName: 'Nombre Chatbot',
            botDescription: 'Descripción',
            botAuthor: 'Autor',
            botUpdatedAt: 'Última actualización',
            changeDescription: 'Editar descripción',
            updateDescriptionSuccess: '¡Descripción actualizada!',
            channels: 'Canales',
            integrations: 'Integraciones',
            integrationsActive: 'Integraciones activas',
            channelWebchat: 'WebChat',
            channelDomains: 'dominio(s) configurado(s)',
            channelWhatsappCopy: 'Haz clic para copiar el número',
            channelWhatsappCopied: '¡Número copiado!',
            searchBotName: 'Buscar chatbot...',
            filterAll: 'Todos',
            filterStatus: 'Estado',
            filterChannels: 'Canal',
            filterChannelsSelected: 'canal(es)',
            actions: 'Acciones',
            filterGroups: 'Filtrar por grupo',
            noData: 'Ningún chatbot por aquí.',
            editChatbot: 'Editar Chatbot',
            flowEditor: 'Edición de flujo',
            createChatbot: 'Nuevo Chatbot',
            save: 'Guardar',
            updateSuccess: '¡Chatbot actualizado!',
            updateError: 'Error al actualizar chatbot'
          },
          groups: {
            allBots: 'Todos los bots',
            manageGroups: 'Gestionar Grupos',
            createGroup: 'Crear Grupo',
            editGroup: 'Editar Grupo',
            deleteGroup: 'Eliminar Grupo',
            groupName: 'Grupo',
            selectBots: 'Seleccionar bots',
            selectBotsHint: 'Seleccione al menos un bot para el grupo',
            searchBots: 'Buscar bot',
            noBots: 'No se encontró ningún bot',
            botsSelected: 'bots seleccionados',
            noGroups: 'Aún no hay grupos creados',
            botsInGroup: 'bots',
            groupSingular: 'grupo',
            groupPlural: 'grupos',
            save: 'Guardar',
            cancel: 'Cancelar',
            close: 'Cerrar',
            confirmDelete: '¿Eliminar este grupo?',
            groupSaved: '¡Grupo guardado con éxito!',
            groupDeleted: '¡Grupo eliminado con éxito!',
            errorLoad: 'Error al cargar grupos',
            errorSave: 'Error al guardar grupo',
            errorDelete: 'Error al eliminar grupo',
            createdAt: 'Fecha de creación'
          }
        },
        broadcast: {
          broadcast: {
            campaigns: 'Mensaje',
            processing: 'Procesando...',
            sending: 'Enviando: ',
            of: ' en ',
            messageCreate: 'Crear un mensaje',
            messageType: 'Tipo de mensaje',
            messageSave: 'Mensajes SMS/Whatsapp guardados',
            email: 'Email',
            messageTitle: 'Título del mensaje',
            confirmation: 'Confirmación',
            saveNewMessageWithName: 'Guardar mensaje nuevo con nombre ',
            save: 'Guardar',
            cancel: 'Cancelar',
            messageText: 'Mensaje de texto',
            next: 'Próximo',
            recipients: 'Destinatarios',
            importNewList: 'Importar nueva lista',
            myLists: 'Mis listas',
            listJson: 'Lista Json',
            send: 'Enviar',
            sendNow: 'Enviar agora',
            scheduleShipping: 'Programar envío',
            submit: 'Enviar',
            importList: 'Lista de importación',
            import: 'Importar',
            saveList: 'Guardar lista',
            listTitle: 'Título de la lista',
            totalRecipients: 'Destinatarios totales',
            recipientsToLowerCase: ' destinatarios',
            importedList: 'Lista importada',
            messageSaveList: '¡Tu lista se ha guardado!',
            messageOpsError: 'Oops, some error occurred.',
            allMessagesWereSent: 'Se han enviado todos los mensajes.',
            messageNotCreditsSms: 'Vaya, parece que faltan créditos de SMS. Por favor contáctenos.',
            allMessagesWereScheduled: 'Se han programado todos los mensajes.',
            failedToConnect: 'No se pudo conectar al servicio de transmisión, vuelva a cargar la página.',
            messageNotCreditsWhatsapp: 'Vaya, parece que faltan créditos de WhatsApp. Por favor contáctenos.',
            messageWereSent: 'Fueron enviados ',
            messageOfTheTotal: ' del total de ',
            chargedMessages: ' Mensajes. Solo se cobrarán los mensajes enviados.',
            gupshupTemplateImport: "Importar pantilha HSM"
          },
          broadcast2: {
            templateSyncronizedFailed: 'Oops, se produjo un error al sincronizar las plantillas. Inténtalo de nuevo.',
            templateSyncronized: '¡Solicitud de sincronización de plantillas enviada correctamente! Espere unos instantes a que se sincronicen las plantillas.',
            templateSyncronizedSuccess: 'Plantillas sincronizadas con éxito',
            email: 'E-mail',
            communicate: 'Comuníquese a través de marketing por correo electrónico o correo electrónico transaccional.',
            createModel: 'Crear plantilla',
            sms: 'SMS',
            sendNotificationsSms: 'Envíe notificaciones y avisos a través de mensajes de texto (SMS).',
            whatsapp: 'WhatsApp',
            instance: 'Instancia',
            bot: 'Bot',
            sendNotificationsWhatsapp: 'Envía mensajes promocionales, notificaciones y encuestas a través de WhatsApp.',
            requestCredits: 'Solicitar Créditos',
            requestCreditsMessaging: 'Solicite créditos adicionales para usar en la campañas.',
            models: 'Modelos',
            modelNotCreated: 'Aún no has creado ningún modelo. Comience eligiendo qué tipo de plantilla desea crear..',
            modelHsm: 'Modelo de mensaje HSM (High Structured Message) utilizado para enviar mensajes preaprobados a través de la API de WhatsApp Business.',
            tipTemplateQualityWarning: 'ADVERTENCIA: Esta plantilla corre el riesgo de ser bloqueada debido a la alta tasa de denuncias y comentarios negativos de los usuarios. Evite usarla.',
            tipTemplateQualityBlocked: 'BLOQUEADA: Esta plantilla está bajo bloqueo de seguridad por Globalbot debido a niveles críticos de denuncias y comentarios negativos de los usuarios. Este bloqueo es necesario para evitar el bloqueo total del número utilizado en WhatsApp. Use otra plantilla.',
            tipCategoryMarketing: 'Template Marketing: Este mensaje se clasifica como Marketing por Meta (WhatsApp). Uso comercial enfocado en promociones, ventas o interacción. NOTA: Los mensajes de marketing pueden estar sujetos a restricciones de entrega debido a los experimentos de Meta.',
            tipCategoryUtility: 'Template Utility: Este mensaje se clasifica como Utilidad por Meta (WhatsApp). Uso transaccional enfocado en actualizaciones solicitadas por el cliente, como estado de pedidos, notificaciones y otros.',
            tipCategoryAuthentication: 'Este mensaje se clasifica como Autenticación por Meta (WhatsApp). Se utiliza específicamente para autenticar usuarios y proteger cuentas, centrándose en el envío de códigos o tokens.',
            modelData: 'Datos del modelo',
            messageEditor: 'Editor de mensajes',
            preview: 'Avance',
            duplicate: 'Duplicar envio',
            duplicateDraft: 'Duplicar bosquejo',
            createDispatch: 'Crear envío',
            exclude: 'Borrar',
            dispatches: 'Transporte',
            dispatchesApi: 'Api',
            dispatchNotCreated: 'Aún no ha creado ningún envío. Crea un envío a partir de una plantilla de mensaje.',
            draftNotCreated: 'Todavía no tienes borradores',
            drafts: 'Damas',
            static: 'Estático',
            recurring: 'Recurrente',
            draft: 'Borrador',
            readyToSend: 'Pronto para Envio',
            scheduled: 'Programado',
            processing: 'Procesando',
            scheduledFor: 'Programado para ',
            delivered: 'Entregado',
            device: 'Entregado',
            read: 'Leer',
            error: 'No Enviada',
            open: 'Apertura',
            click: 'Clic',
            spamreport: 'Marcado como spam',
            unsubscribe: 'Baja',
            notSent: 'No Enviada',
            processed: 'Tratamiento',
            sent: 'Enviado',
            insufficientCredits: 'Créditos insuficientes',
            editDispatch: 'Editar Envío',
            editDraft: 'Editar bosquejo',
            dataDispatch: 'Detalles de envío',
            statsDispach: 'Estadísticas de envío',
            prepareDispatch: 'Preparar Envio',
            modelExclude: 'Eliminar modelo',
            cancel: 'Cancelar',
            areSureModelExclude: '¿Está seguro de que desea eliminar esta plantilla?',
            excludeDispatch: 'Eliminar envio',
            duplicateDispatch: '¿Desea hacer una copia de este envío?',
            areSureDispatchExclude: '¿Está seguro de que desea eliminar este envío?',
            dispatch: 'Envío',
            areSureDispatch: '¿Estás seguro de que quieres enviar?',
            found: 'Encontrado',
            repeated: 'Repetido',
            removed: 'Retirados',
            range: 'Alcance',
            schedule: 'Para programar',
            saveDraft: 'Guardar como Borrador',
            templateChannel: 'Canal',
            templateName: 'Nombre',
            templateAuthor: 'Autor',
            templateEdited: 'Última actualización',
            templateActions: 'Comportamiento',
            dispatchChannel: 'Canal',
            dispatchName: 'Nombre',
            dispatchAuthor: 'Autor',
            dispatchStatus: 'Status',
            dispatchActions: 'Comportamiento',
            templateExclude: '¡Plantilla eliminada!',
            dispatchExclude: '¡Envío excluido!',
            dispatchSuccess: '¡Envío realizado con éxito! Puede llegar en hasta 1 minuto.',
            processingDispatch: 'Se está procesando el envío.',
            dispatchScheduled: 'Se ha programado el envío.',
            messageOpsNotDispatch: 'Vaya, tuvimos algún problema al procesar el envío.',
            messageNotCredits: 'Lamentablemente, su saldo de crédito no es suficiente.',
            messageOpsNotValid: 'Vaya, tuvimos algún problema al validar el envío.',
            messageNotFoundDispatch: 'Envío no encontrado',
            messageOpsErrorDispatch: 'Vaya, se produjo un error al recuperar el envío.',
            messageOpsFailedCompileTemplate: 'Vaya, no se pudo compilar la plantilla',
            campaigns: 'Campañas',
            doubtsInMessaging: '¿Dudas? Haz clic aquí y mira el recorrido interactivo.',
            canNotDuplicateMissingTemplate: 'Plantilla eliminada, no es posible duplicar este envío.',
            ON_BLACK_LIST_UNSUBSCRIBED: 'El destinatario se dio de baja para no recibir correos electrónicos',
            deleted: 'Eliminado',
            rejected: 'Rechazado',
            disabled: 'Deshabilitado',
            paused: 'En pausa',
            pending: 'Pendiente',
            failed: 'Fallido',
            submitted: 'Enviado',
            deactivated: 'Desactivada'
          }
        },
        conversations: {
          conversation: {
            noData: 'No hay conversación para mostrar.',
            rowsPerPage: 'Registros por página',
            recipients: ' destinatarios',
            createNewList: 'Crear nueva lista',
            excludeConversationSelected: 'Eliminar conversaciones seleccionadas',
            createListConversationSelected: 'Crear lista con conversaciones seleccionadas',
            of: 'de',
            createListConversationAll: 'Crear lista con todas las conversaciones',
            includeOnKanban: 'Incluir en Kanban',
            includeOnKanbanTitle: 'Incluir conversaciones en el Tablero',
            selectBoard: 'Seleccione un Tablero',
            selectColumn: 'Seleccione una Etapa',
            attention: 'Atención:',
            kanbanIncludeHint: 'Solo se incluirán las conversaciones de los chatbot(s) y/o departamento(s) designados en el Tablero de destino.',
            include: 'Incluir',
            kanbanIncludeSuccess: 'conversaciones incluidas en el Tablero.',
            kanbanIncludeSkipped: 'ignoradas (ya incluidas o fuera de los parámetros).',
            kanbanIncludeError: 'No se pudieron incluir las conversaciones en el Tablero.',
            kanbanIncludeNoneEligible: 'Ninguna conversación seleccionada cumple con los parámetros del Tablero.',
            exportConversationSelected: 'Exportar conversaciones seleccionadas',
            exportAllConversationSelected: 'Exportar todas conversaciones',
            forwardConversationSelected: 'Reenviar conversaciones seleccionadas',
            forwardConversationIntegrations: 'Reenviar conversaciones en integraciones',
            columns: 'Columnas',
            dateAndHour: 'Fecha y hora',
            protocol: 'Protocolo',
            chatbot: 'Chatbot',
            tags: 'Tags',
            channel: 'Canal',
            actions: 'Comportamiento',
            attendedBy: 'Atendido por',
            monetaryValue: 'Valor',
            phone: 'Teléfono',
            satisfaction: 'Satisfacción',
            category: 'Categoría',
            department: 'Departamento',
            linkDepartment: 'Vincular departamento',
            departmentLinked: 'Departamento vinculado con éxito.',
            linkDepartmentError: 'No se pudo vincular el departamento.',
            transhipmentAttended: 'Transbordo servido: el asistente atendió al cliente. ¡Todo bien!',
            transhipmentUserLost: 'Transferencia desatendida: ¡el cliente abandonó el chat antes de que el asistente interactuara!',
            transhipmentNotYetAttended: 'Transbordo aún no atendido/en espera: el asistente aún no ha interactuado con el cliente.',
            transhipmentWaitigAttended: 'Transbordo desatendido: esperando al asistente.',
            botDeleted: 'Robot eliminado',
            transhipmentUnrealized: 'Transbordo no realizado: No hay asistente en línea en este momento. Chatbot reanudó la conversación.',
            transhipmentRejected: 'Transferencia rechazada: el asistente finalizó la conversación antes de interactuar con el usuario',
            transhipmentFromHSMWaiting: 'Conversación iniciada por el asistente y aún espera respuesta del cliente (WhatsApp).',
            transhipmentFromLiveHSMOk: 'Conversación iniciada por el asistente con respuesta del cliente (WhatsApp). ¡Todo correcto!',
            transhipmentFromBroadcastHSMOk: 'Conversación iniciada mediante envío masivo del Módulo de Campañas con respuesta del cliente (WhatsApp). ¡Todo correcto!',
            transhipmentFromLiveHSMIdleFinished: 'Conversación iniciada y finalizada por el asistente sin respuesta del cliente (WhatsApp).',
            emailLeadSend: 'Correo electrónico de cliente potencial enviado',
            nameEmailLeadSend: ', Correo electrónico de cliente potencial enviado',
            createNewListWith: 'Crea una lista con el ',
            hasAttachments: 'Contiene archivos adjuntos',
            session: 'Sesión',
            conversationSelect: ' conversaciones seleccionadas. Utilice la lista creada en el módulo de Mensajería para enviar mensajes por correo electrónico, SMS o WhatsApp.',
            listName: 'Lista de nombres',
            cancel: 'Cancelar',
            save: 'Guardar',
            excludeConversations: 'Eliminar conversaciones',
            areSureWantToDelete: '¿Estás seguro de que quieres eliminar ',
            conversationsSelected: ' conversaciones seleccionadas?',
            exclude: 'Eliminar',
            reportExport: 'Exportación de informes',
            reportExportNPS: 'Exportación de informes NPS',
            willReportExport: 'Exportarás un informe con ',
            conversationsSelectedFormatCsv: ' conversaciones seleccionadas en el formato .CSV.',
            exported: 'Exportar',
            exportedXlsx: 'Exportar XLSX',
            exportedCsv: 'Exportar CSV',
            forward: 'Hacia adelante',
            youCanSend: 'Podrá enviar por correo electrónico las conversaciones seleccionadas a otra persona.',
            internalMessage: 'Enviar con mensajes internos de chat en vivo.',
            email: 'E-mail',
            integrations: 'Integraciones',
            youCanSendCrmOrTickets: 'Podrás enviar las conversaciones seleccionadas a tu CRM o sistema de tickets',
            sendConversations: 'conversaciones enviadas',
            notSendConversations: 'conversaciones no enviadas:',
            selectIntegration: 'Seleccione su integración',
            send: 'Enviar',
            all: 'Todos',
            primary: 'Primario',
            conversations: 'Conversaciones',
            messageSendEmailBut: 'Sin embargo, se enviaron correos electrónicos ',
            messageSendEmailSuccess: '¡Correos enviados con éxito!',
            messageNotSendEmail: 'Vaya, los correos electrónicos no se enviaron.',
            messageOps: 'UPS, ',
            messageNeedEmail: '¡Vaya, necesitamos un correo electrónico para reenviar!',
            messageIntegrationsSendBut: 'Integraciones enviadas sin embargo ',
            messageIntegrationsSendSuccess: '¡Integraciones enviadas con éxito!',
            messageIntegrationsNotSend: 'Vaya, las integraciones no se enviaron.',
            messageIntegrationsNotSendField: 'Vaya, las integraciones no se enviaron. Email es requerido.',
            messageNeedIntegrations: '¡Vaya, necesitamos una integración para enviar!',
            messageSaveList: '¡Tu lista se ha guardado!',
            messageListNeedName: '¡Tu lista necesita un nombre!',
            messageOpsError: 'Vaya, se produjo un error.',
            date: 'Fecha',
            hour: 'Hora',
            name: 'Nombre',
          }
        },
        crm: {
          fields: {
            people: 'Persona',
            company: 'Empresas'
          },
          exportTableCrm: {
            exportReport: 'Export records',
            exportReportAll: 'Export all records.',
            exportReportSelected: 'Export selected records:',
            exportReportError: 'Error exporting records',
            exportReportSuccess: 'Records exported successfully',
            exportReportCancel: 'Cancel',
            exportReportExportXLSX: 'Export XLSX',
            exportReportExportCSV: 'Export CSV',
          },
          contact: {
            exportReportAll: 'Exportar todos los registros',
            exportReportSelected: 'Exportar registros seleccionados',
            openImage: 'Abrir imagen',
            openArchive: 'Abrir archivo',
            openLink: 'Abrir enlace',
            noPermission: 'No permission',
            deleteSelected: 'Eliminar registros seleccionados',
            contactDeleted: 'Contacto eliminado.',
            contactFavorite: 'Contacto favorito.',
            excludePeople: 'Eliminar personas',
            excludeCompany: 'Eliminar empresas',
            peopleSelected: 'personas seleccionadas',
            companySelected: 'empresas seleccionadas'
          },
          contactAdvanced: {
            customization: 'Personalización',
            confirmLeaveDescription: 'Estás en modo de edición de este registro y aún no has guardado tus cambios. ¿Qué deseas hacer?',
            discardChanges: 'Descartar cambios',
            keepEditing: 'Seguir editando',
            editingBy: 'Este contacto está siendo editado por ',
            editContact: 'Editar Contacto',
            waitUser: 'Espere a que el usuario finalice la edición de este contacto.',
            save: 'Guardar',
            deleteContact: 'Eliminar Contacto',
            defineAttributes: 'Defina atributos para segmentación y personalización.',
            deleteContactConfirm: '¿Realmente quiere eliminar este contacto?',
            none: 'ninguno',
            byDepartment: 'por departamento',
            byAttendant: 'por atendente',
            emailInvalid: 'Email inválido en la Sección: ',
            cpfInvalid: 'CPF inválido en la Sección: ',
            saveSuccess: '¡Contacto guardado con éxito!',
            editing: 'Este contacto ya está siendo editado.',
            contactDeleted: 'Contacto eliminado.',
            lastUpdate: 'Última actualización: ',
            booklet: 'Encarteiramento',
            attendant: 'Atendente',
            department: 'Departamento',
            create: 'Crear',
          },
          import: {
            type: 'Tipo',
            name: 'Nombre',
            autor: 'Autor',
            status: 'Estado',
            listName: 'Lista importada',
            count: 'Cantidad importada'
          },
          default_sections: {
            people: {
              "people_registration_data_default": "Datos de registro",
              "people_address_default": "Dirección",
              "people_professional_data_default": "Datos profesionales",
            },
            company: {
              "company_registration_data_default": "Datos de registro",
              "company_address_default": "Dirección"
            }
          },
          default_fields: {
            people: {
              "people_name_default": "Nombre",
              "people_cpf_default": "CPF",
              "people_email_default": "Correo electrónico",
              "people_phone_whatsapp_default": "Teléfono Whatsapp",
              "people_born_date_default": "Fecha de nacimiento",
              "people_cep_default": "Código postal",
              "people_address_street_default": "Calle",
              "people_address_number_default": "Número",
              "people_address_complement_default": "Complemento",
              "people_address_neighborhood_default": "Barrio",
              "people_address_city_default": "Ciudad",
              "people_address_state_default": "Estado",
              "people_address_country_default": "País",
              "people_company_default": "Empresa",
            },
            company: {
              "company_name_default": "Nombre",
              "company_cnpj_default": "CNPJ",
              "company_corporate_reason_default": "Razón social",
              "company_email_default": "Correo electrónico",
              "company_phone_default": "Teléfono",
              "company_cep_default": "Código postal",
              "company_address_street_default": "Calle",
              "company_address_number_default": "Número",
              "company_address_complement_default": "Complemento",
              "company_address_neighborhood_default": "Barrio",
              "company_address_city_default": "Ciudad",
              "company_address_state_default": "Estado",
              "company_address_country_default": "País",
            }
          }
        },
        dashboard: {
          dashboard: {
            weHaveNews: '¡Tenemos novedades!',
            helpCenter: 'Descubra nuestro Centro de ayuda. Hay más de',
            articles: '100 artículos',
            featuresPlatform: 'que explican<br/> paso a paso las características de nuestra plataforma.',
            viewMore: '¡Ver más!',
            welcomeMessage: '¡Disfrute de las funciones y funciones más nuevas que hemos preparado para usted!',
            clickItem: 'Haga clic en los elementos para ver la demostración.',
            newLook: 'La plataforma con un nuevo look.',
            highPerformance: 'Mayor rendimiento y procesamiento.',
            talkTeam: 'Habla con tu equipo ahora también.',
            attendanceChanges: 'Cambios al hacerse cargo y finalizar el servicio.',
            emojisAndQuickResponse: 'Emojis, respuestas rápidas y otras novedades.',
            commentDuringAttendance: 'Comentarios y notas durante la asistencia.',
            insights: 'Insights',
            beSurprise: '¡Sorpréndete!',
            beSurpriseDesc: '¡Mira los videos y ve lo nuevo en Globalbot!',
            beSurpriseStatusAndBlock: 'Estado y bloqueo de WhatsApp',
            beSurpriseWhatsappButton: 'Botón WhatsApp con rastreo',
            beSurpriseMonetaryValue: 'Asignando valor a las conversaciones',
            beSurpriseCopilotWriter: 'Copiloto Asistente de Escritura',
            beSurpriseCopilotKnowledge: 'Copiloto Asistente de Conocimiento',
            startHere: 'Empieza aquí',
            startHereDesc: '¡Vea los pasos para dejarlo todo listo!',
            startHereStepOne: 'Define aspectos visuales del chatbot',
            startHereStepTwo: 'Configura frases y recopilación de datos',
            startHereStepThree: 'Configura la Inteligencia Artificial Generativa',
            startHereStepFour: 'Prueba el chatbot',
            startHereStepFive: 'Instálalo en tu sitio web',
            stillInDoubt: '¿Aún tienes dudas?',
            seeVideo: 'Ver el video explicativo',
            additionalFeatures: 'Características Adicionales',
            additionalFeaturesDesc: 'Vea algunas características de la versión completa de Globalbot.',
            additionalFeaturesSeeMore: '¡Aprende más y haz el Upgrade!',
            multichannelFeatureDesc: 'Múltiples canales para tu chatbot: WhatsApp, Instagram, Chat del Sitio, Messenger y Telegram.',
            liveChatFeatureDesc: '¡Chat en Vivo! Transfiere la conversación a tu equipo de ventas o atención al cliente.',
            campaignFeatureDesc: 'Realiza campañas de marketing a través de WhatsApp, SMS y correo electrónico.',
            specialistFeatureDesc: 'Apoyo con un equipo de especialistas y más de 100 recursos adicionales.',
            remainingCredits: 'Créditos restantes.',
            requestCredits: 'Solicitar créditos.',
            requestCreditsDesc: 'Su cuenta ya tiene 100 créditos mensuales renovables y no acumulativos. Cada crédito se consume por 1 pregunta + 1 respuesta del chatbot. Puede solicitar créditos adicionales (que no caducan).',
            news: 'Historial de actualizaciones',
            improvement: 'Sugerir mejora',
            visitBlog: 'Para acceder a todo el contenido, visite nuestro ',
            newsDesc: 'Ver el historial de actualizaciones en la plataforma Globalbot.',
            version: 'Versión',
            build: 'Build',
            termsOfUse: 'Condiciones de uso',
            goodMorning: 'Buenos días',
            goodAfternoon: 'Buenas tardes',
            goodEvening: 'Buenas noches',
            accountData: 'Dados de la cuenta ',
            accountDataLabel: 'Consulta la información del plan contratado a continuación.',
            systemAvailability: 'Disponibilidad del Sistema',
            cardAccount: {
              plan: 'Plan',
              consumption: 'Consumo mensual',
              lineWhatsapp: 'Whatsapp',
              lineOtherChannel: 'Otros canales'
            },
            january: 'Enero',
            february: 'Febrero',
            march: 'Marcha',
            april: 'Abril',
            may: 'Mayo',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
          },
          layout: {
            localization: 'Idioma',
            portuguese: 'Portugués',
            english: 'Inglés',
            spanish: 'Español',
            online: 'Online',
            kanban: 'Tableros Kanban',
            kanbanTagNew: 'NEW',
            availableToNewAttendance: 'Estará disponible para recibir nuevas llamadas de su departamento.',
            away: 'Away',
            pauseNewAttendance: 'Pausa. Continuará respondiendo a sus conversaciones activas pero no recibirá nuevas llamadas.',
            offline: 'Offline',
            disconnectToChat: 'Inmediatamente se desconectará del chat. No se le asignarán nuevas llamadas.',
            myProfile: 'Mi perfil',
            notificationCenter: 'Centro de notificaciones',
            nightMode: 'Modo nocturno',
            exit: 'Salida',
            tasks: 'Tareas',
            clients: 'Clientes',
            copilotAnalytics: 'Copiloto Analytics',
            emailUnsubscribes: 'Bajas de correo',
            actions: 'Comportamiento',
            changeLogs: 'Noticias | Change Logs',
            nps: 'Informe NPS',
            serverWhatsapp: 'Servidores de WhatsApp',
            conversationDetails: 'Detalles de la Conversación',
            home: 'Pantalla de inicio',
            statistics: 'Estadísticas',
            conversation: 'Conversaciones',
            chatBots: 'Chatbots',
            intelligence: 'Inteligencia',
            campaigns: 'Campañas',
            liveChat: 'Chat en vivo',
            library: 'Biblioteca',
            needHelp: '¿Necesitas ayuda? ¡Cuéntanos qué necesitas y nuestro equipo te ayudará!',
            preferences: 'Preferencia',
            important: 'Importante:',
            messageImportant: ' Cuando entre en pausa, continuará respondiendo a sus conversaciones activas pero no recibirá nuevas llamadas.',
            reasonPause: 'Motivo de la pausa',
            cancel: 'Cancelar',
            continue: 'Continuar',
            deleteAccount: 'Eliminar cuenta',
            realyDeleteAccount: '¿Realmente desea eliminar esta cuenta?',
            important: 'Importante:',
            deleteAccountDescription: 'Al eliminar la cuenta, todos los datos se eliminarán permanentemente y usted y otros usuarios ya no tendrán acceso al software.',
            deleteAccountSuccess: 'Cuenta eliminada con éxito.',
            deleteAccontError: 'Error al eliminar la cuenta.',
            helpCenterTitle: 'Centro de Ayuda',
            searchHelpCenter: 'Buscar en el Centro de Ayuda',
            searchHelpCenterDescription: 'Busque su duda sobre Globalbot en nuestros artículos y materiales.',
            select: 'Seleccionar',
            consultTelma: 'Consultar Telma',
            virtualAssistant: 'Asistente Virtual',
            consultTelmaDescription: 'Aclare sus dudas sobre la solución Globalbot<br />con nuestra asistente virtual.',
            npsGreeting: '¡Hola! Queremos conocer tu opinión.',
            npsRecommendationQuestion: 'Del 0 al 10, ¿qué probabilidad hay de que recomiendes Globalbot a un amigo o colega?',
            npsNotRecommend: 'No recomendaría',
            npsHighlyRecommend: 'Recomendaría mucho',
            npsRatingReason: '¡Cuéntanos la razón de tu calificación!',
            npsSend: 'Enviar',
            npsClose: 'Cerrar',
            npsThanks: 'Muchas gracias por tu participación.',
            npsGoogleHelp: 'Ayúdanos también dejando una calificación o comentario en Google, ',
            npsClickHere: 'haz clic aquí.',
            npsPhone: 'Si deseas ser contactado(a) por Globalbot, proporciona tu número de teléfono.',
            npsNoThanks: 'No, gracias',
            npsJump: 'Pular',
            npsWriteHere: 'Escribe aquí',
            npsCommentHere: '¡Comenta aquí antes de enviar!',
            npsPhoneHere: '¡Ingresa tu número de teléfono antes de enviar!'
          }
        },
        flow: {
          editor: {
            save: 'Guardar',
            errorSavingInformation: 'Vaya, se produjo un error al guardar la información.',
            savedFlow: 'Se guardó la transmisión'
          },
          flow: {
            flow: 'Fluxo',
            save: 'Salvar',
            addOneBalloon: 'Agregar 1 globo',
            addTenBalloons: 'Agrega 10 globos',
            removeLastBalloon: 'Quitar el último globo',
            removeTheLastTenBalloons: 'Retire los últimos 10 globos',
            test: 'Prueba',
            indicateBalloonLine: 'Este número indica la línea en la que se encuentra el globo.',
            responseField: 'Campo de respuesta',
            emptyQuestion: 'Pregunta vacía',
            clickAndEditBalloon: 'Al hacer clic, puede editar todo el globo.',
            clickGoToLine: 'Haciendo clic puede ir a la línea.',
            type: 'Tipo',
            indicatorName: 'Indicador del nombre del',
            balloon: 'del globo.',
            identifier: 'Identificador',
            responseWillAppearInConversation: 'Esta respuesta aparecerá en la pestaña de conversaciones.',
            knowledge: 'Base de conocimientos',
            jumpIfNotFound: 'Saltar si no se encuentra',
            ifThereNoQuestionJumpTheLine: 'Si no hay ninguna pregunta registrada, saltará a la línea',
            department: 'Departamento',
            jumpIfNoOneOnline: 'Salta si no hay nadie en línea',
            jumpIfNoAttendantOnline: 'Si no hay un asistente en línea, saltará a la línea',
            jumpingToLine: 'Saltando a la línea',
            botWillGoToLine: 'El bot después de pasar por este globo, irá a la línea.',
            clickInNumberGoToLine: 'Haga clic en el número para ir a la línea.',
            uniqueExternalCode: 'Código externo único',
            webchatExternalCode: 'Código Webchat externo',
            facebookExternalCode: 'Código externo Facebook',
            whatsappExternalCode: 'Código externo Whatsapp',
            glpiIntegration: 'Integración con GLPI',
            sendingLeadEmail: 'Envío de correo electrónico de clientes potenciales',
            thisBalloonCreatesTags: 'Este globo crea etiquetas',
            appearanceTime: 'Tiempo de aparición',
            previewAppearanceTime: 'Muestra el tiempo de aparición del globo, el valor predeterminado es 3000 milisegundos (3 segundos)',
            finishingBot: 'Terminación de bot',
            finishingBotDescription: 'Cuando el bot llegue a esta línea, terminará.',
            dontResponse: 'No respondas',
            dontResponseDescription: 'Aquí viene una opción para que el usuario no responda, al hacer clic en ella, el bot pasa al siguiente globo.',
            comment: 'Comentario',
            commentDescription: 'Comentario realizado por un editor de este flujo.',
            secureMessage: 'Mensaje seguro',
            secureMessageDescription: 'Esta respuesta no se guardará en Conversaciones en la plataforma Globalbot',
            editLine: 'Editar línea',
            emptyBalloon: 'Desinflar globo',
            done: 'Hecho',
            editText: 'Editar texto',
            addRandomResponse: 'Agregar respuesta aleatoria',
            enterYourQuestion: 'Ingrese su pregunta aquí',
            editResponseAttributes: 'Edite los atributos de respuesta a continuación',
            titleButtonsListWhatsApp: 'Título de la lista de botones en WhatsApp',
            none: 'Ninguno',
            theType: 'El tipo',
            theTypeNoneDescription: 'es cuando no espera ninguna respuesta, es solo para mostrar algo en la pregunta.',
            text: 'Texto',
            theTypeTextDescription: 'es solo para respuestas, permite al usuario poner cualquier texto, números sin ningún tipo de máscara.',
            name: 'Nombre',
            theTypeNameDescription: 'es solo para respuestas, permite al usuario poner el nombre o cómo quiere que lo llamen.',
            cpf: 'CPF',
            theTypeCpfDescription: 'es solo para respuestas, permite al usuario colocar el CPF con la máscara de CPF.',
            phone: 'Teléfono',
            theTypePhoneDescription: 'es solo para respuestas, permite al usuario poner el teléfono con la máscara del teléfono.',
            email: 'E-mail',
            theTypeEmailDescription: 'es solo para respuestas, permite al usuario ingresar el correo electrónico y validarlo con una herramienta.',
            buttons: 'Botones',
            theTypeButtonsDescription: 'es solo para respuestas, permite al usuario elegir entre 2 o más opciones de botones.',
            list: 'Lista',
            faq: 'FAQ',
            dataBase: 'Base de Datos',
            dataBaseNotFound: 'Datos da base não enontrados',
            theTypeFaqDescription: 'es solo para respuestas, le permite al usuario escribir algo y al enviarlo, busca en la inteligencia lo que escribió.',
            carousel: 'Carrusel',
            theTypeCarouselDescription: 'es solo para respuestas, permite al usuario elegir una opción entre 2 o más de un carrusel.',
            liveChat: 'Chat en vivo',
            theTypeLiveChatDescription: 'intenta conectarse al chat en vivo de Globalbot.',
            calendar: 'Calendario',
            theTypeCalendarDescription: 'permite al usuario elegir la fecha deseada en el calendario.',
            time: 'Tiempo',
            theTypeTimeDescription: 'permite al usuario elegir la hora en el reloj.',
            response: 'Respuesta',
            buttonOptions: 'Opciones para botones',
            dragToSwitchPosition: 'Arrastra para cambiar de posición',
            value: 'Valor',
            jump: 'Salto',
            switchToSmartButton: 'Cambiar a botón inteligente',
            switchToButtons: 'Cambiar a botones',
            excludeButton: 'Eliminar este botón',
            addButton: 'Agregar otro botón',
            checkboxOptions: 'Opciones para casillas de verificación',
            slidersOptions: 'Opciones para controles deslizantes',
            label: 'Label',
            minValue: 'Valor mínimo',
            maxValue: 'Valor máximo',
            initialValue: 'Valor inicial',
            step: 'Último',
            guideScreenOptions: 'Opciones para la pantalla guiada',
            pageLink: 'Enlace de página',
            returnJump: 'Salto de regreso',
            pageButtonLabel: 'Texto del botón',
            pageButtonLabelHint: 'Texto del botón de enlace en WhatsApp. Predeterminado: "Abrir enlace".',
            faqOptions: 'Opciones para FAQ',
            dataBaseOptions: 'Opciones para Base de Datos',
            knowledgeBase: 'Base de conocimientos',
            secondaryKnowledgeBase: 'Base de conocimientos secundaria',
            ifNotFound: 'Si no se encuentra:',
            faqButtons: 'Botones en FAQ',
            learningTime: 'Tiempo de aprendizaje (días)',
            buttonLimit: 'Límite de botones',
            machineLearning: 'Máquina de aprendizaje',
            imageOptions: 'Opciones para imagen de Facebook o Whatsapp',
            imageLink: 'Enlace de imágen',
            textOptions: 'Opciones de texto.',
            mask: 'Máscara',
            messageError: 'Mensaje de error',
            messageErrorOption: 'Mensaje de error de opciones',
            newMask: 'Nueva mascara',
            typeSomething: 'Por favor escriba algo.',
            onlyFacebook: 'Solo para facebook, use youtube incrustado u otros componentes',
            chooseVideoFromLibrary: 'Elige un vídeo de la biblioteca',
            videoLink: 'Enlace de video AVI, MP4 etc',
            moreOptions: 'Mas opciones',
            kanbanAssociation: 'Asociar al tablero Kanban',
            kanbanAssociationDescription: 'La conversación que pase por esta línea se agregará como tarjeta en el tablero y la columna elegidos.',
            selectKanbanBoard: 'Seleccione un tablero',
            selectKanbanColumn: 'Seleccione una columna',
            kanbanNoBoards: 'Ningún tablero Kanban asociado a este bot.',
            kanbanColumnRequired: 'Seleccione una columna del Kanban en la línea ',
            liveChatOptions: 'Opciones para chat en vivo',
            fill: 'Llenar',
            message: 'Mensaje',
            liveErrorJump: 'Error de salto',
            liveErrorJumpMessage: 'El salto no puede ser a la misma línea.',
            setIdentifier: 'Establezca el identificador para guardar la respuesta del usuario.',
            newIdentifier: 'Nuevo identificador',
            jumpLine: 'Salto de línea',
            defineJumpToNextLine: 'Defina dónde estará la siguiente línea para que salte el chatbot.',
            jumpToLine: 'Saltando a la línea',
            jumpTo: 'Salta a',
            genaiErrorFallback: 'Si el agente de IA falla',
            genaiErrorFallbackDescription: 'Si ocurre algún error al procesar el mensaje en el agente de IA, el cliente recibe el aviso "No pude procesar tu mensaje, inténtalo de nuevo más tarde." y el flujo continúa automáticamente hacia la línea definida en "Salto de línea". Si no hay salto definido, el cliente pasa a la siguiente línea/globo del flujo, sin quedarse atascado en esta línea.',
            assignComment: 'Añadir un comentario',
            assignCommentDescription: 'Asignará un comentario a esta línea dentro del flujo.',
            notResponseOptions: 'Opción de no responder',
            createNotResponseOnlyWebchat: 'Crea una opción para no responder a la pregunta. Solo Webchat.',
            notResponse: 'No respondas',
            secureMessageOptions: 'Opción de mensaje seguro',
            writtenMessageOne: 'El mensaje escrito por el usuario no será almacenado por Globalbot.',
            waitDefinedValue: 'Cuando está habilitado, espera a que aparezca el valor establecido en milisegundos.',
            timing: 'Tiempo',
            addTiming: 'Agregar tiempo',
            integrations: 'Integraciones',
            ticketTitle: 'Ponga el título del Ticket que desee y haga clic en el + al lado.',
            sendTicketToGlpi: 'Después de guardar, el bot que pasa por esta línea enviará un ticket al Sistema GLPI.',
            clickTheIcon: 'Para deshabilitar, simplemente haga clic en el icono menos.',
            editTicketTitle: 'Editar el título del boleto',
            newTicketTitle: 'Nuevo título del boleto',
            sendLeadTranscriptEmail: 'Envíe la transcripción del cliente potencial por correo electrónico',
            insertEmail: 'Ingrese el correo electrónico para enviar el cliente potencial en el campo a continuación.',
            saveBotAndSendEmail: 'Después de guardar el bot pasando por esta línea se enviará un correo electrónico de plomo al correo electrónico informado.',
            editEmail: 'Edit email',
            newEmail: 'New email',
            addTagInConversation: 'Agregar TAG en la conversación',
            selectTags: 'Seleccione las etiquetas que se agregarán a la conversación si pasa por esta línea.',
            selectOneTag: 'Seleccione una TAG',
            addTag: 'Agregar tags',
            externalCode: 'Códigos externos',
            masterOnlyFunction: 'Función solo para maestros.',
            insertCode: 'Aquí hay un código javascript puro que se ejecutará en esa línea.',
            codeAdapted: 'Si no es el Callback Único, cada plataforma necesita un código adaptado para funcionar.',
            unifiedExternalCode: 'Código externo unificado',
            newUnifiedExternalCode: 'Nuevo código externo unificado',
            externalCodeForWebchat: 'Código externo para Webchat',
            newExternalCodeForWebchat: 'Nuevo código externo para Webchat',
            externalCodeForWhatsapp: 'Código externo para Whatsapp',
            newExternalCodeForWhatsapp: 'Nuevo código externo para Whatsapp',
            externalCodeForFacebook: 'Código externo para Facebook',
            newExternalCodeForFacebook: 'Nuevo código externo para Facebook',
            close: 'Cerrar',
            guideScreen: 'Pantalla guiada',
            businessHours: 'Jornada',
            zipCode: 'Código postal',
            cnpj: 'CNPJ',
            finish: 'Terminar',
            uploadImage: 'Carga de imagen',
            uploadMedia: 'Carga de media',
            uploadPdf: 'Carga de PDF',
            uploadMediaOptions: 'Opciones de carga de media',
            mediaSkipToggle: 'Botón de omitir envío',
            mediaSkipLabel: 'Texto del botón',
            mediaSkipJump: 'Salto al omitir',
            mediaRetryToggle: 'Límite de intentos inválidos',
            mediaRetryLimit: 'Intentos',
            mediaRetryJump: 'Salto al exceso',
            mediaRetryMessage: 'Mensaje de intento inválido (opcional)',
            mediaSkipOnCard: 'Omitir envío',
            nameOptions: 'Opciones del nombre',
            nameConfirmButtonsToggle: 'Botones de confirmación',
            nameConfirmButtonsHint: 'En WhatsApp, cuando el nombre del perfil ya es conocido, pide la confirmación con los botones Sí y No. Desactivado, pregunta el nombre directamente.',
            nameConfirmButtonsOffOnCard: 'Sin botones de confirmación',
            persistenceSendMessagesToggle: 'Enviar mensajes de persistencia',
            persistenceSendMessagesHint: 'Si está desactivado, el cliente no recibe los mensajes de seguimiento de la persistencia ni el reenvío de este nodo. Los tiempos, el cierre o el traspaso siguen funcionando y los mensajes quedan guardados en el historial para auditoría. Solo WhatsApp. Solo tiene efecto si la persistencia está configurada en el comportamiento del bot.',
            persistenceSendMessagesOffOnCard: 'Mensajes de persistencia desactivados (WhatsApp)',
            mediaRetryOnCard: 'Exceso de intentos',
            messageErrorMediaSkip: '¡Uy! Botón de omitir sin texto o con salto inválido en la fila ',
            messageErrorMediaRetry: '¡Uy! Límite de intentos o salto de exceso inválido en la fila ',
            checkbox: 'Checkbox',
            rating: 'Estrellas',
            number: 'Número',
            firstName: 'Nombre de pila',
            lastName: 'Apellido',
            audio: 'Audio',
            bornDate: 'Fecha de nacimiento',
            slider: 'Slider',
            image: 'Imagen',
            facebookVideo: 'Video de Facebook',
            video: 'Video',
            city: 'Ciudad',
            state: 'Estado',
            country: 'País',
            maskMoney: 'Máscara de dinero',
            noBaseAvailable: 'No hay base disponible',
            noBaseAssigned: 'Sin base asignada',
            dataBaseNotFoundOption: 'Lamentablemente no tenemos esta opción, elija una opción válida.',
            noBaseDefined: 'Sin base definida',
            noBodyOnline: 'Desafortunadamente, no tenemos a nadie en línea en este momento.',
            messageErrorSaved: 'Vaya, se produjo un error al guardar la información.',
            messageErrorButtonsDuplication: 'Oops, nombres de botones duplicados en la fila ',
            messageErrorButtonsValueDuplication: 'Oops, valores de botones duplicados en la fila ',
            buttonValueDuplicated: 'Valor duplicado en este nodo',
            messageErrorButtonsEmpty: '¡Uy! Botones con valores vacíos en la fila ',
            messageErrorFAQEmpty: '¡Uy! Se necesita definir una base de conocimiento en la fila ',
            messageErrorFAQButtonsEmpty: '¡Uy! Botones con valores vacíos en la fila ',
            messageErrorJourneyJump: 'Ups, error salto no definido en el recorrido ',
            mandatoryField: 'Campo obligatorio',
            saveDescription: 'Poner una descripción antes de guardar',
            flowSaved: 'Se guardó la transmisión',
            flowPublish: 'Flujo publicado',
            editFlow: 'Editor de flujo',
            title: 'Título',
            description: 'Descripción',
            select: 'Seleccione',
            defineOutOfHoursMessage: 'Defina un mensaje que se mostrará si el usuario está fuera del horario laboral.',
            outOfHoursMessage: 'Mensaje fuera del horario',
            defineOutOfHoursJump: 'Especifique a qué línea del flujo irá si el usuario está fuera del horario laboral.',
            outOfHoursJump: 'Salto fuera del horario',
            goToLineInput: 'Ir a la línea...',
            scrollToTop: 'Ir al inicio',
            flowChatbot: 'Flujo'
          },
          flowLite: {
            flowLite: 'Flujo Lite',
            addBalloonAbove: 'Agregar globo a la parte superior',
            randomMessage: 'Mensaje aleatorio',
            message: 'Mensaje',
            name: 'Nombre',
            buttons: 'Botones',
            intelligence: 'Inteligencia',
            carousel: 'Carrusel',
            text: 'Texto',
            email: 'Email',
            checkbox: 'Checkbox',
            rating: 'Estrellas',
            number: 'Número',
            firstName: 'Primer nombre',
            lastName: 'Apellido',
            phone: 'Teléfono',
            telephone: 'El teléfono',
            audio: 'Audio',
            liveChat: 'Chat en vivo',
            cpf: 'CPF',
            zipCode: 'Código postal',
            calendar: 'Calendario',
            slider: 'Slinder',
            image: 'Imagen',
            city: 'Ciudad',
            state: 'Estado',
            country: 'El país',
            money: 'Dinero',
            cnpj: 'CNPJ',
            uploadImage: 'Carga de imagen',
            finish: 'Terminar',
            guideScreen: 'Pantalla guiada',
            done: 'Hecho',
            editText: 'Editar texto',
            addRandomResponse: 'Agregar respuesta aleatoria',
            randomizeResponse: 'Respuesta aleatoria',
            edit: 'Edit',
            exclude: 'Borrar',
            identifier: 'Identificador',
            jump: 'Salto',
            excludeBalloon: 'Eliminar globo',
            wantToExcludeBalloon: '¿Está seguro de que desea eliminar este globo?',
            dontAskAgain: 'No vuelvas a preguntar',
            cancel: 'Cancelar',
            editBalloon: 'Editar globo',
            instructions: 'Instrucciones',
            saveRepliesDescription: 'El "identificador" se utiliza para crear saltos y grabarse en lugares como conversaciones, integraciones, etc. Úselo para guardar respuestas importantes de sus clientes.',
            doNotUse: 'No use "espacios", use "_" (guión bajo), no use acentos, si tiene alguna pregunta al respecto, comuníquese con nosotros.',
            identifierName: 'Nombre del identificador',
            replacementSystem: 'Si desea utilizar el sistema de reemplazo, simplemente coloque el identificador dentro de "%", por ejemplo: %MY_IDENTIFIER%',
            useButtons: 'Use tantos botones como sea necesario, pero recuerde, si el número es mayor que 6, se convertirá en una lista desplegable.',
            changePosition: 'Si desea cambiar los botones de posición, haga clic en el icono',
            andDrag: 'y arrastre.',
            sameValue: 'La clave y el valor siempre deben tener los mismos valores. No olvide elegir una etiqueta de salto.',
            key: 'Llave',
            value: 'Valor',
            add: 'Agregar',
            specificDepartment: 'Departamento: si tiene un departamento específico, selecciónelo, de lo contrario déjelo como "Principal".',
            messageErrorDescription: 'Mensaje de error: mensaje si la IA no puede responder.',
            jumpErrorDescription: 'Salto de error: salta a algún identificador si la IA no puede responder.',
            departments: 'Departamentos',
            messageError: 'Mensaje de error',
            jumpError: 'Salto de error',
            knowledgeBaseDescription: 'Base de conocimientos: la búsqueda de IA solo se realizará en la base de conocimientos seleccionada.',
            jumpDescription: 'Saltar: si la IA no tiene una respuesta para la pregunta, saltará al identificador seleccionado o repetirá la pregunta si no se selecciona ningún identificador.',
            knowledgeBase: 'Base de conocimientos',
            jumpWithoutAiResponse: 'Saltar (sin respuesta de IA)',
            machineLearning: 'Aprendizaje automático',
            importantDescription: 'Importante: esta función solo funciona en Webchat.',
            machineLearningDescription: 'Aprendizaje automático: La IA aprende de sus clientes, aportando las respuestas (en forma de botones) más utilizadas para facilitar sus dudas.',
            learningTimeDescription: 'Tiempo de aprendizaje: el tiempo (en días) que la IA puede usar para aprender.',
            buttonLimitDescription: 'Límite de botones: la IA traerá las respuestas si te ciñes al número máximo de botones.',
            learningTime: 'Tiempo de aprendizaje (días)',
            twoDays: 'Dos dias',
            threeDays: 'Tres dias',
            oneWeek: 'Una semana',
            twoWeek: 'Dos semanas',
            oneMonth: 'Un mes',
            oneQuarter: 'Un cuarto',
            oneSemester: 'Un semestre',
            buttonLimit: 'Límite de botones',
            three: 'Tres',
            four: 'Cuatro',
            five: 'Cinco',
            six: 'Seis',
            auxiliaryBases: 'Bases auxiliares',
            searchAuxiliaryBases: 'Si la IA no tiene una respuesta utilizando la base de conocimiento elegida, buscará las bases auxiliares.',
            optionToRefuseDisambiguation: 'Opción de rechazar la desambiguación',
            alwaysAllow: 'La IA siempre permitirá al cliente elegir la opción de rechazar las respuestas dadas por la IA.',
            onlyResponseUnambiguous: 'Recuerde, esta opción es solo para respuestas inequívocas.',
            fieldLabel: 'El campo Etiqueta aparecerá junto al número seleccionado, por ejemplo, "25m²".',
            valueMaxAndMin: 'El valor mínimo y el valor máximo definen cuánto puede elegir su cliente.',
            selectionInitialValue: 'Elija también un valor inicial, que puede facilitarle las cosas a su cliente.',
            stepDescription: 'El pase es el número de saltos, por ejemplo si el pase es 5 el cliente puede elegir 25, 30, 35 y así sucesivamente.',
            label: 'Label',
            minValue: 'Valor mínimo',
            maxValue: 'Valor máximo',
            initialValue: 'Valor inicial',
            step: 'Paso',
            searchLibrary: 'Buscar en la biblioteca',
            insertLink: 'Coloque el enlace a la página que desea guiar a su cliente.',
            restartReturnJump: 'El rebote reiniciará el chat en el identificador seleccionado.',
            pageLink: 'Link de página',
            returnJump: 'Salto de regreso',
            useItems: 'Use tantos elementos como necesite, pero recuerde, si el número es mayor que 6, se convertirá en una lista desplegable.',
            changingThePositionButtons: 'Si desea cambiar los botones de posición, haga clic en el icono',
            googleAnalytics: 'Google Analytics',
            defineTheCategory: 'Defina la categoría, acción, etiqueta y valor del evento.',
            requiredFields: 'No olvide que debe completar toda la información.',
            category: 'Categoria',
            action: 'Acción',
            tag: 'Etiqueta',
            noInteraction: 'Sin interacción',
            customerResponse: 'Respuesta del cliente',
            manual: 'Manual',
            none: 'Ninguno',
            bornDate: 'Fecha de nacimiento',
            maskMoney: 'Máscara de dinero',
            primary: 'Primario',
            all: 'Todas',
            clickHere: 'Haga clic aquí',
            select: 'Escoger',
            itemOne: 'Artículo uno',
            noBodyOnline: 'Desafortunadamente, no tenemos a nadie en línea en este momento.',
            editFlowLite: 'Editor de flujo lite'
          },
          list: {
            viewer: 'Espectador',
            flowStructure: '¡Visualiza la estructura de tu flujo!',
            editorPro: 'Explore su creatividad en el editor para profesionales, con muchas funciones interactivas y nuevas configuraciones.',
            editor: 'Editor',
            editFlow: 'Edite la transmisión directamente en el código. Para aquellos que tienen conocimientos de código HTML y JavaScript.',
            flows: 'Flujos'
          },
          viewer: {
            flow: 'Fluxo',
            toView: 'Para ver',
            test: 'Prueba',
            indicatesTheBalloonLine: 'Este número indica la línea en la que se encuentra el globo.',
            responseField: 'Campo de respuesta',
            emptyQuestion: 'Pregunta vacía',
            clickGoToLine: 'Haciendo clic puede ir a la línea.',
            type: 'Escribe',
            typeDescription: 'Indicador del nombre del',
            theBalloon: 'del globo.',
            identifier: 'Identificador',
            identifierDescription: 'Esta respuesta aparecerá en la pestaña de conversaciones.',
            knowledgeBase: 'Base de conocimientos',
            jumpCaseNotFound: 'Saltar si no se encuentra',
            jumpCaseNotFoundDescription: 'Si no hay ninguna pregunta registrada, se saltará la línea.',
            department: 'Departamento',
            noBodyOnline: 'Salta si no hay nadie en línea',
            noBodyOnlineDescription: 'Si no hay un asistente en línea, saltará a la línea',
            jumpingToLine: 'Saltando a la línea',
            botWillGoToLine: 'El bot después de pasar por este globo, irá a la línea.',
            clickInNumberGoToLine: 'Haga clic en el número para ir a la línea.',
            externalCode: 'Código externo',
            uniqueExternalCode: 'Código externo único',
            whatsappExternalCode: 'Código externo de Whatsapp',
            facebookExternalCode: 'Código externo Facebook',
            glpiIntegration: 'Integración con GLPI',
            sendingLeadEmail: 'Envío de correo electrónico de clientes potenciales',
            appearanceTime: 'Tiempo de aparición',
            previewAppearanceTime: 'Muestra el tiempo de aparición del globo, el valor predeterminado es 3000 milisegundos (3 segundos)',
            finishingBot: 'Terminación de bot',
            finishingBotDescription: 'Cuando el bot llegue a esta línea, terminará.',
            dontResponse: 'No responder',
            dontResponseDescription: 'Aquí viene una opción para que el usuario no responda, al hacer clic en ella, el bot pasa al siguiente globo.',
            comment: 'Comentario',
            commentDescription: 'Comentario realizado por un editor de esta corriente.',
            secureMessage: 'Mensaje seguro',
            secureMessageDescription: 'Esta respuesta no se guardará en Conversaciones en la plataforma Globalbot.',
            primary: 'Primario',
            none: 'Ninguno',
            name: 'Nombre',
            faq: 'FAQ',
            buttons: 'Botones',
            list: 'Lista',
            carousel: 'Carrusel',
            text: 'Texto',
            email: 'E-mail',
            phone: 'Teléfono',
            liveChat: 'Chat en vivo',
            guideScreen: 'Pantalla guiada',
            cpf: 'CPF',
            zipCode: 'Código postal',
            cnpj: 'CNPJ',
            finish: 'Terminar',
            uploadImage: 'Carga de imagen',
            checkbox: 'Checkbox',
            rating: 'Estrellas',
            number: 'Número',
            firstName: 'Primer nombre',
            lastName: 'Apellido',
            audio: 'Audio',
            message: 'Mensaje',
            calendar: 'Calendario',
            bornDate: 'Fecha de nacimiento',
            slider: ' Slider',
            image: 'Imagen',
            facebookVideo: 'Vídeo de Facebook',
            video: 'Video',
            city: 'Ciudad',
            state: 'Estado',
            country: 'País',
            maskMoney: 'Máscara de dinero',
            noBaseAvailable: 'No hay base disponible',
            noBaseAssigned: 'Sin base asignada',
            dataBaseNotFoundOption: 'Lamentablemente no tenemos esta opción, elija una opción válida.',
            title: 'Título',
            description: 'Descripción',
            select: 'Seleccione',
            messageLiveError: 'Desafortunadamente, no tenemos a nadie en línea en este momento.',
            noBaseDefined: 'Sin base definida',
            messageErrorSaveTheInformation: 'Vaya, se produjo un error al guardar la información.',
            flowSaved: 'Se guardó lo flujo',
            flowEditor: 'Editor de flujo'
          }
        },
        help: {
          help: {
            help: 'Ajuda',
            whatIsYourDoubt: '¿Cuál es su duda?',
            needHelp: '¿Necesita ayuda?',
            tutorials: 'Tutoriales',
            messageErrorTestingIntelligence: 'Inteligencia de prueba de errores'
          }
        },
        kanban: {
          pageTitle: 'Tableros Kanban',
          making: 'Haciendo',
          done: 'Hecho',
          createItem: 'Crear artículo',
          title: 'Título',
          message: 'Mensaje',
          cancel: 'Cancelar',
          add: 'Agregar',
          newColumn: 'Agregar nueva Columna',
          cardCreatedSuccess: 'Conversación incluida en el Tablero.',
          cardCreateError: 'No fue posible incluir la conversación en el Tablero.',
          cardAlreadyExists: 'Esta conversación ya está en el Tablero.',
          newBoard: 'Nuevo tablero',
          selectBoard: 'Seleccione un Tablero',
          notSelectedBoard: 'No se ha seleccionado ningún tablero',
          createBoardHint: 'Al crear un nuevo tablero, asócialo a chatbots y/o departamentos. El tablero solo será visible para los usuarios vinculados a ellos.',
          createBoardNameLabel: 'Nombre*',
          createBoardNameRequired: 'El nombre es obligatorio',
          createBoardNameMaxLength: 'El nombre del tablero debe tener como máximo 45 caracteres',
          createBoardChatbotsLabel: 'Chatbots*',
          createBoardChatbotsRequired: 'Los chatbots son obligatorios',
          createBoardDepartmentsLabel: 'Departamentos',
          createBoardShowMonetaryValues: 'Mostrar valores de las conversaciones en el Tablero',
          createBoardError: 'No se pudo crear el tablero',
          createBoardErrorTitleExists: 'Ya existe un tablero con este nombre',
          newBoardTitle: 'Nuevo Tablero',
          editBoardTitle: 'Editar Tablero',
          editBoardError: 'No se pudo actualizar el tablero',
          reallyDeleteBoard: '¿Está seguro de que desea eliminar este tablero?',
          reallyDeleteBoardDetail: 'Esta acción no se puede deshacer.',
          reallyDeleteColumn: '¿Está seguro de que desea eliminar esta columna?',
          reallyDeleteColumnDetail: 'Esta acción no se puede deshacer.',
          reallyClearColumn: '¿Está seguro de que desea limpiar esta columna?',
          reallyClearColumnDetail: 'Todas las tarjetas serán removidas.',
          moveCardError: 'No se pudo mover la tarjeta. Se restauró su posición.',
          clearColumnTitle: 'Limpiar columna',
          deleteColumnTitle: 'Eliminar columna',
          board: 'Tablero',
          column: 'Columna',
          selectPlaceholder: 'seleccione',
          chooseColumnPlaceholder: 'elija la columna',
          cardNamePlaceholder: 'Nombre de la tarjeta',
          pressEnterToAdd: 'Presione Enter para agregar',
          cardNameRequired: 'El nombre de la tarjeta es obligatorio',
          columnTitleAlreadyExists: 'Ya existe una columna con este nombre. Este cambio no se guardará.',
          newBoardTitleLabel: 'Nuevo Tablero',
          newBoardDescription: 'Agrega conversaciones a un tablero estilo Kanban para organizar tu operación.',
          emptyStateHint: 'Nada por aquí. Crea tu primer tablero.',
          emptyStateWatchDemoVideo: 'Mira aquí la demostración en video (3min)',
          emptyStateOr: 'o',
          demoVideoTitle: 'Demostración de los Tableros Kanban',
          scheduleDemo: 'Agendar Demostración',
          scheduleDemoTitle: 'Agendar Demostración Tableros Kanban',
          scheduleDemoDescription: 'El módulo Tableros Kanban ya está incluido en tu plan. Agenda una demostración y una configuración personalizada con uno de nuestros especialistas. En cuanto recibamos tu solicitud, nos pondremos en contacto para organizar la agenda y los invitados.',
          scheduleDemoPreferredDay: 'Día preferido',
          scheduleDemoPreferredShift: 'Turno preferido',
          scheduleDemoDays: {
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes'
          },
          scheduleDemoShifts: {
            morning: 'Mañana',
            afternoon: 'Tarde'
          },
          scheduleDemoFieldRequired: 'Campo obligatorio',
          scheduleDemoConfirm: 'Solicitar',
          scheduleDemoSuccess: '¡Solicitud enviada! Pronto nos pondremos en contacto contigo.',
          scheduleDemoError: 'No pudimos enviar tu solicitud. Inténtalo de nuevo.',
          last7Days: 'Últimos 7 días',
          last30Days: 'Últimos 30 días',
          last90Days: 'Últimos 90 días',
          today: 'Hoy',
          searchPlaceholder: 'Buscar',
          conversations: 'conversaciones',
          conversationSingular: 'conversación',
          recentFirst: 'Recientes arriba',
          manualOrder: 'Orden manual',
          advancedFiltersHint: 'Los filtros adicionales para esta búsqueda se aplicarán aquí.',
          deleteBoardLabel: 'Eliminar Tablero',
          chatbotTooltip: 'Chatbot',
          departmentTooltip: 'Departamento'
        },
        knowledge: {
          genai: {
            title: 'Inteligencia Artificial Generativa',
            errors: {
              validation: 'Complete todos los campos obligatorios e inténtelo de nuevo.',
              auth: 'Sesión inválida o expirada. Inicie sesión nuevamente.',
              insufficientCredits: 'Créditos insuficientes para utilizar la IA Generativa. Solicite más créditos e inténtelo de nuevo.',
              notFound: 'No se encontró el recurso solicitado.',
              provider: 'Fallo en la comunicación con el proveedor de IA. Inténtelo de nuevo en unos instantes.',
              timeout: 'El proveedor de IA tardó demasiado en responder. Inténtelo de nuevo en unos instantes.',
              network: 'Fallo de conexión. Verifique su internet e inténtelo de nuevo.',
              invalidCharacters: 'El campo {field} tiene caracteres no aceptados: {chars}. Ajuste el nombre e inténtelo de nuevo.',
              fields: {
                assistantName: 'Nombre del agente',
                trainingTitle: 'Título de la base de conocimiento',
                triggerName: 'Nombre del disparador'
              },
              generic: 'Ocurrió un error inesperado. Informe el código {errorId} al soporte.'
            },
            card_title: "IA Generativa",
            card_description: "Respuestas creadas a partir de un gran conjunto de datos (modelo GPT).\nInterpreta la intención del usuario y genera respuestas (texto y enlaces).",
            column_name: "Nombre",
            column_autor: "Autor",
            column_updatedAt: "Última actualización",
            column_action: "Acciones",
            drawer_test: {
              title: "Prueba de IA Generativa",
              name: 'Nombre',
              text_motive: "Utilice el chat al lado para probar las respuestas de la IA Generativa.<br>Las respuestas se generan automáticamente en función de los archivos y documentos proporcionados.",
              note: "NOTA",
              text_note: "Recuerde que la IA Generativa formará parte de algún chatbot, por lo que algunas funciones de este chat de prueba son limitadas (por ejemplo, no hay transferencia a agentes humanos).",
              restart: "Reiniciar",
              genai_mini: 'Utilice el chat a continuación para realizar las pruebas. Cuando todo esté listo, podrá proceder con la instalación. El chat a continuación solo prueba la inteligencia artificial y no captura la información del lead.'
            },
            drawer_data: {
              updateWebsite: 'Actualizar sitio web',
              openWebsite: 'Abrir sitio web',
              editWebsite: 'Editar sitio web',
              deleteWebsite: 'Eliminar sitio web',
              refreshWebsiteSuccess: 'Website atualizado com sucesso.',
              refreshWebsiteError: 'Erro ao atualizar website.',
              create: "Nueva Base de Conocimientos",
              edit: "Editar Base de Conocimientos",
              provider: 'Motor de IA',
              providerDescription: 'Elija qué IA generativa responde por esta base de conocimientos.',
              promptMinLength: 'Mínimo de {min} caracteres.',
              promptMaxLength: 'Máximo de {max} caracteres.',
              unavailableOnOpenai: 'Aún no disponible en el motor OpenAI.',
              triggersPromptDescriptionOpenai: 'En el motor OpenAI, este texto es lo que la IA lee para decidir si el disparador se aplica. Describa la situación, no la acción. Ej.: "cuando el usuario pida hablar con un agente humano".',
              providerVerbeux: 'Verbeux',
              providerOpenai: 'OpenAI',
              providerImmutable: 'El motor de IA no se puede cambiar después de crear la base de conocimientos.',
              providerFileUnsupported: 'El envío de archivos en la conversación no está disponible en el motor OpenAI.',
              prompt: 'Pautas de Contexto (Prompt)',
              promptDescription: "Defina las pautas a continuación para dirigir las respuestas de IA generativa.",
              docs: "Base de Conocimiento",
              docsDescriptions: "Enviar los archivos y/o informar los sitios web que serán utilizados por Generative AI (PDF) hasta 1,5 GB",
              docsDescriptionsOpenai: "Envíe los archivos y/o informe los sitios web que serán utilizados por la IA Generativa. Formatos aceptados: {formats} — hasta 512 MB por archivo.",
              docsDescriptionsMini: "Envíe contenido que se utilizará como fuente de información para la IA generativa. Sitios web y documentos PDF de hasta 1,5 GB. Límite máximo de 400.000 caracteres en total.",
              informSite: 'Informar al Sitio Eeb',
              informSiteDescription: 'Introduzca la dirección de un sitio web.',
              url: 'Dirección URL *',
              recursiveSearch: "Búsqueda recursiva: una vez activada esta opción se incluirán todos los enlaces relacionados con el dominio ingresado.",
              cancel: 'Cancelar',
              importDoc: "Importar Archivos",
              clickOrDrag: "Haga clic o arrastre archivos a esta área.",
              rules: "Reglas Adicionales",
              updateFileError: 'Error archivo:',
              triggers: "Desencadenantes de Escape",
              triggersDescription: "Utilice disparadores para llevar al usuario a algún punto del flujo del chatbot.",
              name: 'Nombre *',
              nameMinLength: 'El nombre debe tener al menos 3 caracteres.',
              invalidCharacters: 'Caracteres no aceptados: {chars}',
              invalidCharactersReason: 'Este campo se convierte en identificador en la IA Generativa, por eso solo acepta letras sin acento, números, _ y - (el espacio se convierte en _).',
              invalidCharactersReasonSpaces: 'Este campo solo acepta letras sin acento, números, espacio, _ y -.',
              normalizedValue: 'Se guardará como: {value}',
              fileTitleSanitized: 'El nombre del archivo tenía caracteres no aceptados: {chars} — fue ajustado a {value}.',
              titleSanitized: 'El título tenía caracteres no aceptados: {chars} — fue ajustado a {value}.',
              requiredFieldsError: 'Complete todos los campos obligatorios.',
              save: 'Salvar',
              createSuccess: 'Asistente creado exitosamente.',
              updateSuccess: 'Asistente actualizado exitosamente.',
              deleteDocSuccess: 'Archivo eliminado exitosamente.',
              urlError: 'Error URL:',
              triggerError: 'Error disparador:',
              fileActive: 'Contenido listo y disponible',
              fileProcessing: 'Contenido en proceso',
              fileError: 'Procesamiento de errores. Elimina el elemento y vuelve a intentarlo.',
              triggerError: 'Erro al actualizar gatilho:',
              triggersPromptDescription: 'Defina las pautas a continuación para indicarle a la IA generativa que realice la acción desencadenante.',
              flowJump: 'Acción: Vaya a la siguiente línea de flujo:',
              deleteTrigger: 'Eliminar Disparador',
              deletedTrigger: "Disparador eliminado.",
              errorDeleteThisTrigger: "Error al eliminar el disparador.",
              areYouSureDeleteTrigger: "¿Está seguro de que desea eliminar este disparador? Todos los datos que contenga se perderán y esta acción no se podrá deshacer.",
              deleteDoc: 'Eliminar Archivo',
              deletedDoc: "Archivo eliminado.",
              errorDeleteThisDoc: "Error al eliminar el archivo.",
              areYouSureDeleteDoc: "¿Está seguro de que desea eliminar este archivo? Todos los datos que contenga se perderán y esta acción no se podrá deshacer.",
              delete: 'Eliminar',
              errorTreatment: 'Manejo de Errores',
              errorTreatmentDescription: 'Definir el comportamiento del chatbot cuando no hay respuesta.',
              noResponse: 'Si no te responde:',
              errorFlowJump: "Ir a la línea de flujo",
              intervention: "Intervención programada",
              interventionDescription: "Definir una intervención programada en función del número de respuestas.",
              from: "Desde:",
              subsequentTimes: 'veces seguidas',
              subsequentTime: 'vez',
              responsesRow: 'respuestas seguidas',
              response: 'respuesta',
              invalidURL: 'Por favor, ingrese una URL válida.',         
            },
            makeUpgrade: 'Frente a la actualización.',
            textLimitCharsTraining: 'de 400.000 caracteres utilizados. Eliminar algún contenido o aumentar el límite.',
            textCountCharsTraining: 'de 400.000 caracteres utilizados. Para aumentar el límite.',
            genaiNotCreated: "Aún no tienes asistentes",
            editGenai: "Editar asistente",
            testGenai: "Probar asistente",
            add: "Crear Asistente",
            exclude: "Eliminar Asistente",
            deletedAssistant: "Asistente eliminado.",
            errorDeleteThisAssistant: "Error al eliminar el asistente.",
            areYouSureDelete: "¿Está seguro de que desea eliminar este asistente? Todos sus datos se perderán y esta acción no se puede deshacer.",
            cancel: "Cancelar",
            name: 'Nombre',
            author: 'Autor',
            lastUpdate: 'última actualización',
            actions: 'Comportamiento'
          },
          knowledge: {
            card_title: "IA Convencional",
            card_description: "Respuestas estandarizadas. Interpreta la intención del usuario y presenta respuestas registradas (texto, video, imágenes, documentos y enlaces).",
            deleteQuestionSelected: 'Eliminar respuestas seleccionadas',
            rowsPerPage: 'Registros por página:',
            conversations: 'Conversaciones',
            add: 'Agregar',
            knowledgeBase: 'Base de conocimientos',
            exclude: 'Borrar',
            askQuestion: 'Hacer una pregunta (prueba de intención)',
            importQuestions: 'Importar preguntas',
            columns: 'Columnas',
            status: 'Status',
            questionKnowledgeBase: 'Pregunta / Base de conocimientos',
            response: 'Respuesta',
            intentionsIa: 'Intenciones (inteligencia artificial)',
            actions: 'Comportamiento',
            edit: 'Para editar',
            save: 'Salvar',
            cancel: 'Cancelar',
            deleteQuestions: 'Borrar Preguntas',
            newQuestion: 'Nueva pregunta',
            questionTitle: 'Título de la pregunta',
            createNewKnowledgeBase: 'Cree una nueva base de conocimientos cuando necesite separar el conocimiento para diferentes audiencias o contextos, ya que la inteligencia se comparte con todos los chatbots de su cuenta.',
            textEditor: 'Editor de texto',
            addRandomResponse: 'Agregar respuesta aleatoria',
            responseNotFound: 'Respuesta no encontrada ir a la posición de flujo',
            jumpToFlowPosition: 'Saltar a la posición de flujo',
            search: 'Buscar',
            noImagesFound: 'No se encontraron imágenes',
            urlPage: 'URL de la página',
            continueToFlowPosition: 'Continuar en posición de flujo',
            randomizeResponse: 'Respuesta aleatoria',
            moveUp: 'Ascender',
            document: 'Documento',
            video: 'Vídeo',
            text: 'Texto',
            liveChat: 'Chat en vivo',
            intelligence: 'Inteligencia',
            image: 'Imagen',
            carousel: 'Carrusel',
            guideScreen: 'Pantalla guiada',
            jump: 'Salto',
            moveDown: 'Mover hacia abajo',
            continueFlow: 'Después de presentar las respuestas anteriores, el chatbot seguirá el flujo de acuerdo con la secuencia definida.',
            intentions: 'Intenciones',
            registerIntentions: 'Registre las intenciones considerando las principales palabras que pueden desencadenar el registro de la respuesta. Dé mayor peso a las palabras que deben evitar la desambiguación.',
            newIntention: 'Ingrese una nueva intención aquí y presione "Enter"',
            intention: 'Intención',
            weight: 'Peso',
            minWeight: 'Peso mínimo',
            optional: 'Opcional',
            optionalDescription: 'Úselo si desea definir el peso mínimo que se agregará por las intenciones para mostrar la respuesta.',
            addKnowledgeBase: 'Agregar base de conocimientos',
            title: 'Título',
            excludeQuestion: 'Eliminar pregunta',
            youSureExclude: '¿Está seguro de que desea eliminar esta pregunta?',
            justCopy: 'Para importar preguntas, simplemente copie',
            thisModel: 'este modelo',
            standard: 'patrón',
            exportToCsv: 'y expórtalo en CSV con tus preguntas que quieras registrar.',
            chooseFileAndImport: 'Después de eso, haga clic en Elegir archivo a continuación para importar.',
            none: 'Ninguno',
            question: 'Pregunta',
            all: 'Todos',
            messageErrorImportList: 'Error al importar la lista de bancos',
            youAlreadyHaveBase: 'Ya tienes una base con este título.',
            requiredTitle: 'El título no puede dejarse en blanco.',
            duplicateIntention: 'Ya hay igual intención, dale más peso.',
            mustHaveMoreThanOneLetter: 'La intención debe tener más de 1 letra.',
            cannotHaveMoreThanTwoWords: 'La intención no puede tener más de 2 palabras.',
            questionSave: 'Pregunta guardada',
            messageErrorNewQuestion: 'Error al guardar la nueva pregunta',
            allFieldsRequired: 'Es necesario completar todos los campos.',
            questionSuccessfullyDeleted: 'Pregunta eliminada correctamente.',
            messageErrorExcludeQuestion: 'Error al eliminar la pregunta.',
            messageErrorTestIntelligence: 'Inteligencia de prueba de errores',
            messageErrorFilter: 'Error al filtrar la inteligencia',
            knowledgeBaseExcluded: 'Base de conocimientos eliminada.',
            itWasNotPossibleExclude: 'No fue posible eliminar esta base de conocimientos.'
          }
        },
        library: {
          library: {
            limitExceeded: 'Se superó el límite de 200 MB',
            addFile: 'Agregar media',
            addMedia: 'Agregar media',
            libraryDescription: 'Aquí, en la biblioteca de medios, puede agregar medios al chat en vivo y a los carruseles de flujo.',
            sizeLimitIs: 'El límite de tamaño es',
            video: 'Video',
            videos: 'Videos',
            photos: 'Fotos',
            search: 'Buscar',
            list: 'Lista',
            gallery: 'Galería',
            view: 'Para ver',
            name: 'Nombre',
            sent: 'Enviado',
            actions: 'Comportamiento',
            of: 'en',
            documents: 'Documentos',
            document: 'Documento',
            exclude: 'Borrar',
            newFile: 'Archivo nuevo',
            typeFile: 'Tipo de archivo',
            image: 'Imagen',
            title: 'Título',
            description: 'Descripción',
            cancel: 'Cancelar',
            save: 'Guardar',
            areYouSure: '¿Está seguro de que desea eliminarlo o archivarlo?',
            clickExclude: 'Al hacer clic en "Eliminar", el archivo ya no se puede recuperar.',
            date: 'Fecha',
            size: 'Tamaño',
            library: 'Biblioteca',
            requiredTitle: 'Es necesario completar el campo de título.'
          }
        },
        live: {
          live2: {
            transferTooltip: 'Seleccione un agente o departamento al que transferir la conversación',
            userLeaveChat: 'El usuario abandonó el chat',
            userStayOnManualQueue: 'El usuario está en cola manual',
            userStayOnAutoQueue: 'El usuario está en cola automática',
            userStayWaiting: 'El usuario está en espera',
            chatIsFinished: 'La conversación ha terminado',
            chatWaitHsm: 'La conversación está en pausa y esperando la interacción del usuario',
            errorOnTransferRoom: 'Identificamos un error al transferir esta conversación. En este caso, tome una captura de pantalla de esta pantalla y envíela a nuestro soporte (suporte@globalbot.com.br). Intente repetir la transferencia nuevamente.',
            titleErrorOnLive: 'No se puede transferir la conversación',
            titleRuleOnLive: 'No se puede realizar esta acción',
            ruleTransferRoomUnauthorizedUser: 'No estás autorizado a transferir esta habitación.',
            ruleTransferRoomInvalidStatus: 'No es posible transferir esta sala ya que su estado no es válido, si persiste solicite a un gerente que realice esta acción',
            liveChatUpperCase: 'Chat en Vivo',
            inbox: 'Bandeja de entrada del asistente',
            waiting: 'Cola de asistente',
            newConversation: 'Nueva conversación',
            filter: 'Filtro',
            attendants: 'Acomodadores',
            settings: 'Ajustes',
            filterByAttendant: 'Filtro de asistente',
            searchAttendant: 'Buscar asistente',
            attendantNoDepartments: 'Sin departamentos',
            noSearchResults: 'No se encontraron resultados',
            all: 'Todos',
            searchCustomerName: 'Obtener el cliente',
            filterByDepartment: 'Filtro de departamento',
            internalToUpperCase: 'INTERNO',
            finishedToUpperCase: 'FINALIZADO',
            inQueueToUpperCase: 'EN FILA',
            waitingToUpperCase: 'ESPERANDO',
            newToUpperCase: 'NUEVO',
            transferToUpperCase: 'TRANSFERIDO',
            yesterday: 'El dia de ayer',
            finishAttendance: 'Asistencia(s) final',
            finishAndArchiveAttendance: "Finalizar y Archivar",
            finishSuccess: 'Servicio(s) completado(s) exitosamente',
            processingAction: 'Procesando... Espere hasta finalizar.',
            noAttendance: 'No hay asistencia disponible.',
            important: 'Importante',
            completionMessage: 'Elija una de las opciones, considerando que "Solo Finalizar" finaliza, pero aún verá la sala de chat en esta pantalla, mientras que "Finalizar y Archivar" finalizará y archivará la conversación. Podrá consultarlo más tarde en el Menú de Conversaciones.',
            triggerAgain: 'Su próxima interacción activará el chatbot nuevamente, reabriendo una nueva asistencia.',
            areYouSureFinish: '¿Seguro que quieres terminar?',
            cancel: 'Cancelar',
            finish: 'Solo Finalizar',
            archiveAttendance: 'Asistencia(s) de archivo',
            archiveSuccess: 'Atención(s) arquivado(s) con éxito',
            archiveSuccessOther: 'Atención(es) archivada(s) por otro asistente',
            futureConversation: 'When archiving calls, active conversations will automatically end and close. The next interaction of the user(s) will trigger the chatbot again, reopening a new service. You will be able to consult conversations in the future, in the Conversations Menu. Are you sure you want to archive?',
            areYouSureArchive: '¿Está seguro de que desea archivar?',
            archive: 'Archivar',
            transferAttendance: 'Asistencia(s) de transferencia',
            transferSuccess: 'Atención(s) transferida(s) con éxito',
            transferDescription: 'Transferir la asistencia a otro operador (ellos recibirán la asistencia) o departamento (su asistencia se distribuirá según la configuración establecida). *Las conversaciones internas no son transferibles.',
            areYouSureTransfer: '¿Estás seguro de que deseas realizar la transferencia?',
            byAttendant: 'Por asistente',
            byDepartment: 'Por departamento',
            transfer: 'Transferir',
            withCustomer: 'con el cliente',
            viaWhatsapp: '(a través de WhatsApp)',
            startConversationWithCustomer: 'Iniciar una conversación con un cliente',
            sendingMessage: 'enviando un mensaje a través de WhatsApp.',
            select: 'Seleccione',
            withAttendant: 'con Asistente',
            viaGlobalbot: '(a través de Globalbot)',
            startConversationWithSomeone: 'Inicie una conversación con alguien de',
            teamSending: 'tu equipo de trabajo enviando un',
            messageThroughTheGlobalbot: 'mensaje de la plataforma Globalbot.',
            newAttendance: 'Nueva asistencia',
            waitingForYou: '¡te está esperando!',
            see: 'Ver',
            close: 'Cerrar',
            waitingAttendant: 'está esperando un asistente.',
            take: 'Asumir',
            newTransfer: 'Nueva transferencia',
            transferredAndWaitingForYou: 'ha sido transferido y te está esperando!',
            transferredDepartmentAndWaitingForYou: 'ha sido transferido a su departamento está esperando un asistente.',
            anotherAttendant: 'Otro asistente ya se ha hecho cargo de esta asistencia.',
            pinConversation: 'Fijar conversación en la parte superior.',
            couldNotFinish: 'No se pudo finalizar',
            couldNotDescription: 'las conversaciones, ya que aún no han sido asumidas por ningún agente. Primero debes asumirlas.',
            couldNotArchive: 'No se pudo archivar',
            finishRoomIdColumn: 'ID de sala',
            finishRoomReasonCodeColumn: 'Motivo'
          },
          room: {
            transferAttendance: 'Transferir la asistencia',
            finishAttendance: 'Terminar la asistencia',
            noAttendance: 'No hay asistencia disponible.',
            archive: 'Archivar',
            group: 'grupo',
            attendance: 'asistencia',
            theaterMode: 'Modo teatro',
            defaultView: 'Vista predeterminada',
            noOneToAnswer: 'Nadie con quien reunirse en este momento. ¿Qué tal un café?',
            chooseOneToAnswer: '¡Selecciona un servicio y vamos!',
            loadMoreMessages: 'Cargar más mensajes',
            isTyping: '¡El usuario todavía está escribiendo!',
            conversation: 'Hablar',
            intelligence: 'Inteligencia',
            navigation: 'Navegación',
            data: 'Datos',
            abandonedTheChat: 'El usuario abandonó el chat.',
            createdIn: 'Creado en',
            attendants: 'Acomodadores',
            exit: 'Salir',
            quickResponse: 'Respuesta rápida',
            internalMessage: 'Mensaje interno',
            send: 'Mandar',
            takeAttendance: 'ASUMIR ASISTENCIA',
            important: 'Importante',
            sendTemplateHsm: 'Para hablar con el usuario, envíe una plantilla de mensaje (HSM)',
            onlyAttendants: 'Solo los asistentes de esta conversación pueden enviar mensajes.',
            automaticArchiving: [
              { label: 'Después de 1 hora, la conversación se archivará automáticamente.', value: 1 },
              { label: 'Después de 6 horas, la conversación se archivará automáticamente.', value: 6 },
              { label: 'Después de 12 horas, la conversación se archivará automáticamente.', value: 12 },
              { label: 'Después de 1 día, la conversación se archivará automáticamente.', value: 24 },
              { label: 'Después de 2 días, la conversación se archivará automáticamente.', value: 48 },
              { label: 'Después de 3 días, la conversación se archivará automáticamente.', value: 72 },
              { label: 'Después de 4 días, la conversación se archivará automáticamente.', value: 96 },
              { label: 'Después de 5 días, la conversación se archivará automáticamente.', value: 120 },
            ],
            preview: 'Avance',
            addLegend: 'Adicionar legenda',
            cancel: 'Cancelar',
            search: 'Buscar',
            notFound: 'No se encontró ningún emoji',
            found: 'Fundar',
            recent: 'Usado frecuentemente',
            people: 'Emojis y Personas',
            nature: 'Animales y naturaleza',
            foods: 'Comida y Bebida',
            activity: 'Actividad',
            places: 'Viajes y lugares',
            objects: 'Objetos',
            symbols: 'Simbolos',
            flags: 'Banderas',
            others: 'Otros',
            fullFunctioning: 'Para el pleno funcionamiento del chat en vivo es necesario permitir el acceso al portapapeles.',
            anotherAttendant: 'Otro asistente ya se ha hecho cargo de esta asistencia.',
            copilot: 'Copiloto',
            assistantCopilotButtonDescription: 'Prueba el nuevo Asistente de Escritura.',
            copilotDescription: 'El Copiloto Asistente de Escritura sugiere una nueva redacción con un tono profesional y corrige la ortografía.',
            copilotCardDescription: 'Seleccione la Inteligencia Artificial para resolver dudas y ayudar con las respuestas.',
            copilotGenai: 'Inteligencia Artificial Generativa (modelo GPT). Usted tendrá la Base de Conocimiento General (conocimiento del mundo) y puede también registrar Bases de Conocimiento específicas con contenido de su empresa en el Módulo Inteligencia.',
            copilotConventional: 'Inteligencia Artificial Convencional (respuestas basadas en contenido insertado manualmente en Bases de Conocimiento en el Módulo Inteligencia)',
            copilotCardCredits: 'Cada consulta del Copiloto en Inteligencia Artificial Generativa consume 1 crédito. Su cuenta tiene 100 créditos gratuitos mensuales.',
            copilotCardTooltip: 'El Copiloto ayuda a resolver dudas suyas y de sus clientes usando Inteligencia Artificial (Generativa o Convencional). Experimente!',
            copilotCopyMessage: 'Copiar Mensaje',
            copilotReplyMessage: 'Responder Directamente',
            copilotCredtisDescription: 'Cada consulta del Copiloto en Inteligencia Artificial Generativa consume 1 crédito. Tu cuenta tiene 100 créditos gratuitos mensuales.',
            noCredits: 'Créditos agotados.',
            finishingCredits: 'Créditos por agotarse.',
            requestCredits: 'Solicitar créditos.',
            messageCopied: 'Mensaje copiado!',
            replyMessage: 'Responder a este mensaje'
          }
        },
        login: {
          signin: {
            selectSegment: 'Seleccione un segmento para continuar.',
            accountAlreadyExists: 'Ya existe una cuenta para este correo electrónico.'
          },
          forgot: {
            enterYourEmail: 'Ingrese su correo electrónico y le enviaremos una contraseña temporal',
            buttonRecover: 'Recuperar mi contraseña',
            goBack: 'Vuelve',
            emptyEmail: 'Necesitas completar el correo electrónico',
            email: 'Correo electrónico',
            pleaseEmptyEmail: 'Por favor complete su correo electrónico',
            passwordSent: 'Su nueva contraseña ha sido enviada a su correo electrónico.',
            contact: 'Vaya, comuníquese con el soporte de Globalbot. (support@globalbot.com.br)',
            iForgotMyPassword: 'Olvide mi contraseña'
          },
          login: {
            selectAccount: 'Seleccione la cuenta deseada para acceder',
            cancel: 'Cancelar',
            forgotPassword: 'Olvide mi contraseña',
            verificationCode: 'Código de verificación',
            enter: 'Entrar',
            validate: 'Validar',
            emptyEmail: 'Necesitas completar el correo electrónico',
            labelEmail: 'Correo electrónico',
            fillAllData: 'Por favor rellena todos los campos',
            emptyPassword: 'Necesitas completar la contraseña',
            labelPassword: 'Contraseña',
            userInactive: 'Este usuario está inactivo, comuníquese con su gerente.',
            outOfYourJourney: 'Está fuera de su jornada laboral, comuníquese con su gerente.',
            incorrectUsernameOrPassword: 'Nombre de usuario o contraseña incorrecta.',
            doubleFactor: 'Esta cuenta está protegida con autenticación de dos factores, ingrese el código de seis dígitos enviado a su teléfono celular.',
            doubleFactorNeedNumber: 'Esta cuenta está protegida con autenticación de dos factores y su usuario no tiene un número de teléfono móvil registrado, comuníquese con su gerente.',
            unexpectedError: 'Error inesperado.',
            accountNotCorrect: 'Su cuenta no parece correcta, comuníquese con Globalbot',
            notifiedHere: 'Ahora, siempre que suceda algo, se le notificará aquí.',
            notificationActivated: 'Notificación activada',
            rememberMyPassword: 'Mantenme conectado'
          }
        },
        notification: {
          control: {
            addNotification: 'Agregar notificación',
            dateAndTime: 'Fecha y hora',
            type: 'Escribe',
            title: 'Título',
            actions: 'Comportamiento',
            user: 'Usuario',
            tag: 'Tag',
            department: 'Departamento',
            role: 'Oficina',
            account: 'Cuenta',
            group: 'Grupo',
            all: 'Todos',
            edit: 'Editar',
            linkUsers: 'Vincular usuarios',
            exclude: 'Borrar',
            recordsPerPage: 'Registros por página',
            save: 'Guardar',
            cancel: 'Cancelar',
            newNotification: 'Nueva notificación',
            showAvatar: 'Mostrar avatar',
            customizableLabel: 'Etiqueta personalizable',
            label: 'Etiqueta',
            message: 'Mensaje',
            notificationType: 'Tipo de notificación',
            attachments: 'Archivos adjuntos',
            loadImage: 'Cargar imagen',
            notificationControl: 'Control de notificaciones',
            errorUpload: 'Error al procesar la carga.',
            notificationSent: 'Notificación enviada',
            errorSent: 'Error al enviar notificación'
          }
        },
        people: {
          people: {
            people: 'Gente',
            name: 'Nombre',
            anonymous: 'Anónimo'
          },
          timeline: {
            people: 'Gente',
            fullName: 'Nombre completo',
            name: 'Nombre',
            nickname: 'Apellido',
            occupation: 'Ocupación',
            cpf: 'CPF',
            anonymous: 'Anónimo',
            company: 'Empresa',
            cnpj: 'CNPJ',
            country: 'País',
            city: 'Ciudad',
            state: 'Estado',
            district: 'Vecindario',
            conversationStarted: 'Conversación iniciada',
            of: 'de',
            at: 'a las',
            hoursAnd: 'horas y',
            minutes: 'minutos'
          }
        },
        profile: {
          profile: {
            profile: 'Perfil',
            changePhoto: 'Cambiar foto',
            hello: 'Hola',
            personalInformation: 'Informaciones personales',
            name: 'Nombre',
            email: 'Correo electrónico',
            role: 'Papel',
            phone: 'Teléfono',
            security: 'Seguridad',
            newPassword: 'Nueva contraseña',
            confirmNewPassword: 'Confirmación de nueva contraseña',
            connectedDevices: 'Dispositivos conectados',
            deleteDevice: 'Eliminar dispositivo',
            save: 'Guardar',
            administrator: 'Administrador',
            manager: 'Gerente',
            attendant: 'Empleado',
            primary: 'Primario',
            passwordIsNotIdentical: 'Vaya, su contraseña no es idéntica, revísela.',
            informationSaved: '¡Información guardada!',
            errorSavingInformation: 'Vaya, se produjo un error al guardar la información.',
          }
        },
        realTime: {
          realTime: {
            preferences: 'Preferencias',
            realTime: 'Tiempo real',
            browsing: 'Hojeada',
            withChatbots: 'Con chatbots',
            withAttendants: 'Con asistentes',
            alreadyTalked: 'Ya hablé',
            attendedBy: 'Atendido por',
            currentPageContains: 'La página actual contiene',
            columns: 'Columnas',
            channel: 'Canal',
            dateAndTime: 'Fecha y hora',
            visitor: 'Visitante',
            chatbot: 'Chatbot',
            location: 'Localización',
            pages: 'Paginas',
            currentPage: 'Pagina actual',
            time: 'Tiempo',
            conversation: 'Conversacion',
            actions: 'Comportamiento',
            unknown: 'Desconocido',
            seeOnMap: 'Ver en el mapa',
            seeNavigation: 'Ver navegación',
            inAttendance: 'En asistencia',
            waitingForAttendant: 'Esperando asistente',
            finishAttendance: 'Finished attendance',
            noAttendance: 'No hay asistencia disponible.',
            activeVisitor: 'Visitante activo',
            inactiveVisitor: 'Visitante inactivo',
            startedAt: 'Empezó a las',
            allConversations: 'Todas las conversaciones',
            of: 'en',
            initialMessage: 'Mensaje inicial',
            message: 'Mensaje',
            cancel: 'Cancelar',
            intervene: 'Intervenir',
            navigation: 'Navegación',
            openPage: 'Abre la pagina',
            close: 'Cerrar',
            openConversation: 'Conversación abierta',
            all: 'Todos',
            chatbots: 'Chatbots',
            path: 'Sendero',
            conversations: 'Conversaciones'
          }
        },
        settings: {
          fields: {
            fields: 'Campos',
            sections: 'Secciones',
            imports: 'Importaciones',
            sectionDescription: 'Cree una sección para agrupar los campos personalizados y facilitar la visualización.',
            fieldsDescription: 'Cree campos personalizados para registrar datos de personas y empresas.',
            importsDescription: 'Realice importación de registros en lote y confirme importaciones ya realizadas.',
            createSection: 'Crear sección',
            createField: 'Crear campo',
            createImport: 'Importar',
            name: 'Nombre',
            description: 'Descripción',
            actions: 'Acciones',
            edit: 'Editar',
            type: 'Tipo',
            section: 'Sección',
            edit: 'Editar',
            processing: 'Procesando',
            importError: 'Error en la importación',
            fail: 'Falla en',
            failImport: ' importaciones por compos obligatorios no estar llenos',
            exclude: 'Excluir',
            excludeSection: 'Excluir Sección',
            excludeField: 'Excluir Campo Personalizado',
            reallyDeleteSection: '¿Realmente desea excluir esta sección?',
            reallyDeleteField: '¿Realmente desea excluir este campo personalizado?',
            sectionExcluded: 'Sección excluida.',
            sectionInUse: 'Existe campos utilizando esta Sección',
            fieldExcluded: 'Campo excluido.',
            fieldInUse: 'No fue posible excluir, este campo ya fue llenado en algún contacto.',
            imported: 'Importado',
          },
          chatbot: {
            behavior: {
              chatbots: 'Chatbots',
              preferences: 'Preferencias',
              behavior: 'Comportamiento',
              timers: 'Temporizadores',
              balloonAppearanceTime: 'Tiempo de aparición del globo',
              chatbotShutdownTime: 'Tiempo de apagado del chatbot',
              interactionTime: 'Tiempo de interacción (...)',
              teenMinutes: '10 minutos',
              threeMinutes: '3 minutos',
              fiveMinutes: '5 minutos',
              fifteenMinutes: '15 minutos',
              thirtyMinutes: '30 minutos',
              oneHour: '1 hora',
              twoHours: '2 horas',
              threeHours: '3 horas',
              fiveHours: '5 horas',
              teenHours: '10 horas',
              twelveHours: '12 horas',
              twentyHours: '20 horas',
              fifteenHours: '15 horas',
              twentyFourHours: '24 horas',
              whatsappCacheTime: 'Tiempo de caché de WhatsApp',
              firstTime: 'Primeiro tempo',
              secondTime: 'Segundo tempo',
              firstInteraction: 'Primera interacción *',
              secondInteraction: 'Segunda interacción',
              desiredAction: {
                title: 'Acción deseada',
                actionEnd: 'Finalizar',
                actionTranshipment: 'Transbordar',
                messageTranshipment: 'Mensaje antes del transbordo',
                departmentTranshipment: 'Transferir departamento',
                tag: 'Etiquetar con'
              },
              messageTranshipment: 'A conversa será transferida para um atendente.',
              messageEnd: 'Por falta de interação a conversa foi finalizada.',
              facebookCacheTime: 'Tiempo de caché de Facebook',
              webchatCacheTime: 'Tiempo de caché de chat web',
              controllers: 'Controladores',
              soundType: 'Tipo de sonido',
              fullScreenMode: 'Modo de pantalla completa',
              disableControls: 'Deshabilitar controles',
              disableHeader: 'Deshabilitar encabezado',
              automaticOpening: 'Apertura automatica',
              notReopen: 'No vuelva a abrir el globo después de la asistencia.',
              satisfactionSurvey: 'Búsqueda de satisfacción',
              protocolAttendance: 'Asistencia de protocolo',
              includeInternalMessages: 'Incluir mensajes internos',
              optionFinishOrMin: 'Opción de terminar o minimizar.',
              imageUploader: 'Cargador de imágenes (cliente)',
              fileUploader: 'Cargador de archivos (cliente)',
              allConversations: 'Todas las conversaciones',
              conversationsNotTransshipment: 'Conversaciones de asistente y sin desbordamiento',
              onlyAttendantConversations: 'Solo conversaciones de asistente',
              viewingConversationsForAttendants: 'Ver conversaciones para asistentes',
              persistence: 'Persistencia',
              activated: 'Activado',
              disabled: 'Discapacitado',
              firstMessage: 'Primer mensaje',
              firstMessageTime: 'Hora del primer mensaje',
              secondMessage: 'Segundo mensaje',
              secondMessageTime: 'Hora del segundo mensaje',
              thirdMessage: 'Tercer mensaje',
              thirdMessageTime: 'Hora del tercer mensaje',
              save: 'Guardar',
              areYouSure: '¿Está seguro de que desea guardar los cambios?',
              youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
              previousContent: 'el contenido anterior no se puede restaurar.',
              cancel: 'Cancelar',
              interface: 'Interface',
              interfaceSettings: 'Configuración de la interface',
              behaviorSettings: 'Configuración del chatbot',
              installation: 'Instalación',
              integrations: 'Integraciones',
              liveChat: 'Chat en vivo',
              areYouStillAround: '¿Sigues por aquí?',
              ifNotResponse: 'Si no contesta tendré que terminar la asistencia.',
              ifNeedHelp: 'Muy bien, si necesitas ayuda nuevamente, avísame.',
              closeMessage: 'La asistencia fue cerrado por el asistente, agradecemos su contacto y si tiene más preguntas, simplemente llámeme nuevamente.',
              preferenceSaved: 'Preferencia guardada con éxito'
            },
            installation: {
              whatsapp: {
                installation: 'Instalación de Whatsapp',
                configuredWithChatbot: 'Tu WhatsApp está configurado con tu Chatbot.',
                notConfiguredWithChatbot: 'Tu WhatsApp no está configurado con tu Chatbot.',
                versionHint: 'Versión de Whatsapp a utilizar',
                version: 'Versión',
                instanceHint: 'ID de instancia proporcionado por su administrador de proyectos',
                instance: 'Ejemplo',
                tokenHint: 'Token de instancia proporcionado por su administrador de proyectos',
                token: 'Token',
                mobileNumberHint: 'Mobile number to be used',
                mobileNumber: 'Número de teléfono',
                customerIdentifierHint: 'Identificador de cliente proporcionado por Globalbot',
                customerIdentifier: 'Identificador de cliente',
                instructionsMobileNumbers: 'Instrucciones de número de móvil',
                notChangeConfig: 'No es posible cambiar la configuración mientras hay conversaciones en curso.',
                stepOneMobileNumbers: 'Habilite el chip que contiene el número que desea conectar el chatbot',
                stepTwoMobileNumbers: 'Recibirá un SMS en este número que contiene un código numérico',
                stepThreeMobileNumbers: 'Informar el código recibido al equipo de Globalbot',
                stepFourMobileNumbers: 'Ingrese la instancia y el token provistos por Globalbot en los campos a continuación',
                instructionsFixedNumbers: 'Instrucciones de número de teléfono fijo',
                stepOneFixedNumbers: 'Recibirá una llamada en su número que contiene un código numérico',
                stepTwoFixedNumbers: 'Informar el código recibido al equipo de Globalbot',
                stepThreeFixedNumbers: 'Ingrese la instancia y el token provistos por Globalbot en los campos a continuación',
                areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
                youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
                previousContent: 'el contenido anterior no se puede restaurar.',
                cancel: 'Cancelar',
                save: 'Guardar',
                publish: 'Publicar',
                versioningMessage: 'Para acceder a versiones anteriores basta con acceder a la configuración específica del bot, ir a versionado y publicar la versión deseada para entrar en producción.',
                removeConfig: 'Eliminar configuración',
                wabaLabel: 'Cuenta de WhatsApp Business (WABA)',
                wabaHint: 'Elija la cuenta de WhatsApp Business que contiene el número',
                phoneLabel: 'Número de WhatsApp',
                phoneHint: 'Elija el número que usará este chatbot',
                reconnectMetaAccount: 'Reconectar cuenta de Meta',
                saveRejected: 'No fue posible guardar la configuración de WhatsApp. Inténtelo de nuevo o contacte al equipo de Globalbot.',
                metaTokenExchangeFailed: 'Meta no emitió un token de larga duración para este número. Reconecte la cuenta de Meta y guarde de nuevo.',
                metaConnected: 'Número conectado a Meta con éxito. Haga clic en guardar para concluir.',
                metaSignupCancelled: 'La conexión con Meta fue cancelada antes de terminar.',
                metaSignupNoPhone: 'El registro en Meta terminó sin un número de WhatsApp. Complete la elección del número e inténtelo de nuevo.',
                metaSignupFailed: 'No fue posible concluir la conexión con Meta. Inténtelo de nuevo o contacte al equipo de Globalbot.',
                metaWebhookNotSubscribed: 'El número se guardó, pero Meta no confirmó la suscripción del webhook. Reconecte la cuenta para que lleguen los mensajes.',
                pinOptionLabel: 'Mi número ya usa verificación en dos pasos',
                pinOptionCaption: 'Informe el PIN actual del número. Sin PIN, Globalbot genera uno y lo muestra una sola vez.',
                pinLabel: 'PIN de verificación en dos pasos',
                pinHint: '6 dígitos. Se guarda cifrado y solo se usa para operar el número.',
                pinInvalid: 'El PIN debe tener exactamente 6 dígitos.',
                pinSubmit: 'Registrar con este PIN',
                pinPromptTitle: 'Informe el PIN del número',
                pinPromptDescription: 'Meta exige el PIN de verificación en dos pasos de este número para registrarlo. Si no lo recuerda, desactive la verificación en dos pasos en WhatsApp Manager e inténtelo de nuevo sin PIN.',
                pinGeneratedTitle: 'Guarde el PIN de su número',
                pinGeneratedDescription: 'Este es el PIN de verificación en dos pasos definido para el número. No se mostrará de nuevo y se pedirá para cambiar el PIN o quitar el número de la plataforma.',
                pinCopy: 'Copiar PIN',
                pinCopied: 'PIN copiado',
                pinAcknowledge: 'Copié y guardé el PIN en un lugar seguro',
                pinClose: 'Concluir',
                registerNumber: 'Registrar número',
                checkRegistration: 'Verificar estado',
                registrationRegistered: 'Número registrado en la Cloud API. Listo para enviar y recibir mensajes.',
                registrationPending: 'Número conectado, pero aún no registrado en la Cloud API. Regístrelo hasta {deadline}; de lo contrario habrá que rehacer la conexión.',
                registrationExpired: 'El plazo de 14 días para registrar el número terminó. Reconecte la cuenta de Meta para empezar de nuevo.',
                registrationBlockedUntil: 'Nuevos intentos disponibles a las {date}.',
                registrationInProgress: 'Ya hay un registro en curso para este número. Espere unos segundos.',
                registrationFailed: 'No fue posible registrar el número. Inténtelo de nuevo o contacte al equipo de Globalbot.',
                registrationErrorPinMismatch: 'Meta rechazó el PIN. Revise el PIN de verificación en dos pasos del número o desactive la verificación en WhatsApp Manager e inténtelo de nuevo.',
                registrationErrorPinLocked: 'Demasiados intentos de PIN. Espere antes de intentarlo de nuevo.',
                registrationErrorRateLimited: 'Meta limitó los registros de este número por 72 horas.',
                registrationErrorLocalRateLimit: 'Límite de intentos alcanzado por ahora. Espere antes de intentarlo de nuevo.',
                registrationErrorTosNotAccepted: 'El registro está bloqueado por una pendencia de Globalbot con Meta. Nuestro equipo ya fue avisado; inténtelo más tarde.',
                registrationErrorReverificationNeeded: 'Meta pide una nueva verificación de este número. Rehaga la verificación en WhatsApp Manager e inténtelo de nuevo.',
                registrationErrorGraphUnavailable: 'Meta no respondió. Inténtelo de nuevo en unos minutos.',
                registrationErrorUnknown: 'Meta rechazó el registro. Inténtelo de nuevo o contacte al equipo de Globalbot.',
                bsuidSection: 'Identificación por BSUID (Meta)',
                bsuidSectionHint: 'El BSUID es el identificador que Meta asigna al contacto. Permite atender a quien llega sin número de teléfono (QR Code, enlace wa.me, anuncios Click-to-WhatsApp).',
                bsuidEnabled: 'Habilitado',
                bsuidDisabled: 'Deshabilitado',
                sendByBsuid: 'Enviar por BSUID',
                sendByBsuidHint: 'Permite disparar plantillas a contactos sin teléfono, usando el BSUID como destinatario.',
                bsuidEffects: 'Al habilitar: los envíos de mensajes y plantillas de este bot pasan a usar el BSUID como destinatario siempre que el contacto tenga uno (los contactos solo con teléfono siguen recibiendo normalmente); las pantallas de Campañas ganan las opciones de BSUID (columna "bsuid" en la importación de destinatarios, envío de prueba por BSUID y búsqueda por BSUID en las estadísticas); y la exportación de conversaciones de la cuenta gana la columna BSUID.',
                sendByBsuidNotSupported: 'No disponible en esta versión: la API de Meta y Cogna solo aceptan teléfono como destinatario. Disponible en Gupshup y Globalbot WhatsApp.',
                reallyRemoveConfig: '¿Realmente quieres eliminar la configuración?',
                moreThanOneBotWithWhatsAppInstance: 'Hay otros bot(s) configurados con el mismo instaceId que WhatsApp',
                errorSave: 'Error inesperado al guardar',
                attention: 'ATENCIÓN:',
                thereAreConversationsOpenOne: 'Hay conversaciones abiertas en la instancia',
                thereAreConversationsOpenTwo: ', al cambiar todas estas conversaciones se finalizarán. ¿Desea continuar?',
                proceed: 'Continuar',
                clearError: 'Error al finalizar conversaciones.',
                qrLeaveWarning: 'Este bot está conectado por WhatsApp QR Code. Al guardar, la sesión de WhatsApp se cerrará y, para volver a usar el QR Code, será necesario escanear un nuevo código en el celular.',
                qrLeaveError: 'No fue posible cerrar la sesión de WhatsApp QR Code. No se modificó nada; inténtelo de nuevo.',
                qrMasterOnly: 'Por ahora, WhatsApp QR Code solo puede ser habilitado por usuarios Master.',
                instructionsQr: 'Cómo conectar con el código QR',
                stepOneQr: 'Haga clic en Conectar para generar el código QR.',
                stepTwoQr: 'En el celular del número que usará el bot, abra WhatsApp y vaya a Ajustes > Dispositivos vinculados > Vincular un dispositivo.',
                stepThreeQr: 'Apunte la cámara al código QR mostrado. Se renueva automáticamente mientras espera ser escaneado.',
                stepFourQr: 'Espere el estado Conectado. Mantenga el celular con internet y WhatsApp instalado para que la sesión siga activa.',
                qrConnection: {
                  title: 'Conexión por código QR',
                  description: 'Conecte el número del bot escaneando el código QR con WhatsApp en el celular. No es necesario informar token ni identificador.',
                  providerSwitchHint: 'Al conectar, este bot pasa a usar WhatsApp QR Code como proveedor de WhatsApp.',
                  loading: 'Cargando el estado de la conexión...',
                  loadError: 'No fue posible cargar el estado de la conexión.',
                  retry: 'Intentar de nuevo',
                  permissionDenied: 'Solo los administradores de la cuenta pueden gestionar la conexión de WhatsApp QR Code. Pida a un administrador que conecte o desconecte el número.',
                  stateLabel: 'Estado de la conexión:',
                  notCreated: 'Todavía no se creó ninguna conexión para este bot. Haga clic en Conectar para generar el código QR.',
                  phone: 'Número conectado',
                  profileName: 'Perfil',
                  qrAlt: 'Código QR para conectar el WhatsApp de este bot. Escanéelo con la aplicación WhatsApp del celular.',
                  qrLoading: 'Generando el código QR...',
                  qrExpired: 'El código QR expiró. Se mostrará un nuevo código en instantes.',
                  qrInstructions: 'En WhatsApp del celular, vaya a Ajustes > Dispositivos vinculados > Vincular un dispositivo y apunte la cámara al código.',
                  qrExpiresIn: 'Este código expira en {seconds}s y se renueva automáticamente.',
                  qrRenewHint: 'Este código expira en pocos segundos y se renueva automáticamente.',
                  connect: 'Conectar',
                  reconnect: 'Reconectar',
                  disconnect: 'Desconectar (temporal)',
                  disconnectHint: 'Pausa la conexión manteniendo la sesión. Para volver, haga clic en Reconectar; no es necesario escanear otro código QR.',
                  logout: 'Cerrar sesión',
                  logoutConfirmTitle: '¿Cerrar la sesión de WhatsApp?',
                  logoutConfirmMessage: 'La sesión se cerrará en WhatsApp y el bot dejará de enviar y recibir mensajes por este número. Para conectar de nuevo será necesario escanear un nuevo código QR en el celular.',
                  logoutConfirm: 'Cerrar sesión',
                  cancel: 'Cancelar',
                  actionError: 'No fue posible completar la acción. Inténtelo de nuevo.',
                  conflictError: 'La conexión cambió de estado mientras se procesaba la acción. Revise el estado e inténtelo de nuevo.',
                  unavailableError: 'El servicio de conexión de WhatsApp no está disponible en este momento. Inténtelo de nuevo en instantes.',
                  botHasActiveProviderError: 'Este bot ya tiene otro proveedor de WhatsApp activo. Desactive el proveedor actual antes de conectar por QR Code.',
                  rateLimitedError: 'Demasiados intentos en poco tiempo. Espere unos instantes e inténtelo de nuevo.',
                  states: {
                    disconnected: 'Desconectado',
                    awaiting_scan: 'Esperando escaneo',
                    connecting: 'Conectando',
                    connected: 'Conectado',
                    error: 'Error',
                  },
                  reasons: {
                    paused: 'Conexión pausada. La sesión se mantuvo; haga clic en Reconectar para retomarla.',
                    logged_out: 'Sesión cerrada en el celular. Será necesario escanear un nuevo código QR.',
                    qr_limit_reached: 'Se alcanzó el límite de códigos QR sin escaneo. Haga clic en Reconectar para generar uno nuevo.',
                    session_rejected: 'WhatsApp rechazó la sesión. Haga clic en Reconectar y escanee un nuevo código QR.',
                    provider_error: 'Falla en el servicio de conexión de WhatsApp. Intente reconectar en instantes.',
                  },
                },
              },
              webchat: {
                installation: 'Instalación (WebChat and Botão WhatsApp)',
                installationMiniGlobalot: 'Instalación Webchat',
                configuredWithChatbot: 'Tu script está configurado con tu website.',
                notConfiguredWithChatbot: 'Tu script no está configurado con tu website.',
                installationScript: 'Script de instalación',
                authorizedDomains: 'Dominios autorizados',
                domainNumber: 'Número de dominio',
                addDomain: 'Agregar dominio',
                domainInvalid: 'Dominio inválido',
                instructions: 'Instrucciones de Instalación',
                stepOne: 'Copia el script de instalación a la derecha',
                stepTwo: 'Inserta el script en el código HTML de tu sitio web en las páginas donde deseas activar el chatbot (pega el script inmediatamente después del cierre de la etiqueta </BODY>).',
                stepThree: 'Después de pegar el script en las páginas deseadas, debes indicar a la derecha en qué dominios se agregó el chatbot.',
                stepFour: 'Debes indicar abajo en qué dominios se puede activar el chatbot.',
                externalBoot: 'Arranque externo',
                youCan: 'Puede realizar una inicialización externa a través del código JavaScript.',
                accessElement: 'Accede al elemento',
                andUse: 'Y usa las funciones disponibles para startups.',
                openBalloon: 'Abre el globo inicial',
                initialBalloon: 'Balón inicial con posición de flujo',
                openChat: 'Abre el chat',
                openChatWithFlowPosition: 'Abrir chat con posición de flujo',
                areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
                youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
                previousContent: 'el contenido anterior no se puede restaurar.',
                cancel: 'Cancelar',
                save: 'Guardar',
              },
              messenger: {
                installation: 'Instalación de Facebook Messenger',
                configuredWithChatbot: 'Tu Facebook está configurado con tu Chatbot.',
                reset: 'Reconfigurar',
                notConfiguredWithChatbot: 'Tu Facebook no está configurado con tu Chatbot.',
                noPagesAvailable: 'No hay páginas disponibles.',
                synchronize: 'Sincronizar',
                almostConfigured: 'No mucho después, su página de Facebook está casi configurada con su Chatbot.',
                yourPage: 'Tu pagina',
                instructions: 'Instrucciones',
                connectFacebook: 'Haga clic en el botón Sincronizar',
                followSteps: 'Sigue la conexión paso a paso',
                youMustBeAdmin: 'Debes ser administrador de FanPage para otorgar acceso',
                areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
                youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
                previousContent: 'el contenido anterior no se puede restaurar.',
                cancel: 'Cancelar',
                save: 'Guardar',
                disconnect: 'Desconectar',
                reallyDisconnectPage: '¿Realmente quieres desconectar esta página?'
              },
              telegram: {
                installation: 'Instalación de Telegramas',
                configuredWithChatbot: 'Tu Telegram está configurado con tu Chatbot.',
                notConfiguredWithChatbot: 'Tu Telegram no está configurado con tu Chatbot.',
                tokenProvidedBot: 'Token de acceso para la API proporcionada por Bot Father',
                token: 'Token',
                instructions: 'Instrucciones',
                talkToThe: 'Habla al',
                followStep: 'Sigue la guía paso a paso para crear tu bot',
                indicateBelow: 'Ingrese el token de acceso para la API a continuación',
                areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
                youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
                previousContent: 'el contenido anterior no se puede restaurar.',
                cancel: 'Cancelar',
                save: 'Guardar',
                config: 'Configuration Instructions',
                step1: '1 - Ve a Telegram y encuentra a @BotFather usando la barra de búsqueda.',
                step2: '2 - Escribe /start y el bot proporcionará una lista de comandos disponibles.',
                step3: '3 - Usa el comando /newbot y sigue las instrucciones proporcionadas para crear un nuevo bot.',
                step4: '4 - BotFather enviará un mensaje de texto cuando tu bot sea creado. Recibirás un enlace a tu bot y un token de API.',
                step5: '5 - Copia ese token y escríbelo en el formulario al lado.',
                step6: '6 - Ahora todos los mensajes enviados por nuevos contactos a tu bot se mostrarán en el módulo de conversaciones.',
                existingIntro: 'Para conectar un bot existente de Telegram, haz lo siguiente:',
                existing1: '1 - Escribe el comando /mybots en @BotFather.',
                existing2: '2 - Elige el bot que deseas conectar.',
                existing3: '3 - Haz clic en API Token.',
                existing4: '4 - Copia el token y pégalo en el formulario al lado.'

              },
              instagram: {
                authInProgress: 'OAuth en proceso',
                waitingForReturn: 'Esperando respuesta de Instagram...',
                alreadyAuthorized: 'Si ya te has autorizado en Instagram y no se ha restaurado automáticamente',
                clickHereToCheck: 'Haz clic aquí para comprobarlo',
                toolTipDescribeInstallationBot: 'Se abre en una ventana emergente; no cierra la aplicación',
                installation: 'Instalación de Instagram',
                yourPage: 'Tu pagina',
                configuredWithChatbot: 'Tu Instagram está configurado con tu Chatbot.',
                reset: 'Reconfigurar',
                notConfiguredWithChatbot: 'Tu Instagram no está configurado con tu Chatbot.',
                motiveConfigure: 'La plataforma Globalbot solo puede administrar mensajes de cuentas de INSTAGRAM BUSINESS. No es posible conectarse y administrar mensajes en cuentas personales de Instagram.',
                important: 'Importante: ',
                synchronize: 'Sincronizar',
                instructions: 'Instrucciones',
                stepOne: 'AGREGAR 1er PASO',
                stepTwo: 'AGREGAR 2do PASO',
                stepThree: 'AGREGAR 3er PASO',
                areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
                youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
                previousContent: 'el contenido anterior no se puede restaurar.',
                cancel: 'Cancelar',
                save: 'Guardar',
              },
              chatbots: 'Chatbots',
              preferences: 'Preferencias',
              installation: 'Instalación',
              interface: 'Interface',
              interfaceSettings: 'Configuración de la interface',
              behavior: 'Conducta',
              chatbotSettings: 'Configuración del chatbot',
              integrations: 'Integraciones',
              liveChat: 'Chat en vivo',
              youHavePermission: 'Ups, parece que faltan permisos.',
              consultTheConsole: 'Ups, ocurrió algún error, mira la consola.',
              preferenceSaved: 'Preferencia guardada con éxito'
            },
            integrations: {
              chatbots: 'Chatbots',
              preferences: 'Preferencias',
              integrations: 'Integraciones',
              reset: 'Reiniciar',
              toSetUp: 'Configurar',
              eventWebhookLabel: 'Webhook de eventos',
              descriptions: {
                googleAnalytics: 'Esta integración es responsable de analizar estadísticas del flujo.',
                pipeRun: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contactos (leads) en Piperun a través de campos compatibles.',
                slack: 'Con esta integración, la plataforma Globalbot enviará el historial de conversaciones a un canal específico. Se debe configurar un webhook para recibir el evento y enviar mensajes.',
                vistaSoft: 'Esta integración se encarga de buscar bienes raíces en alquiler/compra según las opciones seleccionadas por el usuario (número de habitaciones, tipo, vecindario) y registrar leads. Campos clave: teléfono y/o nombre y correo electrónico y "objetivo de contacto"/"interés".',
                rdStation: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contacto (leads) en RD Station Marketing a través de campos compatibles. Campos clave: correo electrónico.',
                pipeDrive: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contacto (leads) en PipeDrive a través de campos compatibles. Asigna a un asistente como responsable según la dirección de correo electrónico.',
                rdCrm: 'Con esta integración, la plataforma Globalbot enviará negociaciones al CRM. Campos clave: correo electrónico y/o teléfono y nombre.',
                ksi: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contacto (leads) en Kurole KSI a través de campos compatibles. Campos clave: correo electrónico, nombre y teléfono.',
                cv: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contacto (leads) en Sales Builder a través de campos compatibles. Campos clave: correo electrónico, nombre y teléfono.',
                movidesk: 'Con esta integración, la plataforma Globalbot abrirá tickets. Campos clave: correo electrónico.',
                glpi: 'Con esta integración, la plataforma Globalbot abrirá tickets. Campos clave: nombre.',
                jira: 'Con esta integración, la plataforma Globalbot creará tareas. Campos clave: correo electrónico.',
                zendesk: 'Con esta integración, la plataforma Globalbot abrirá tickets. Campos clave: correo electrónico.',
                midasSoft: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contacto (leads) en MidasSoft.',
                rdStationV2: 'Esta integración se encarga de recuperar información en RD Stations Marketing (solo para casos específicos).',
                moskit: 'Con esta integración, la plataforma Globalbot será responsable de crear negociaciones.',
                funilVendas: 'Con esta integración, la plataforma Globalbot será responsable de crear negociaciones. Campos clave: correo electrónico, nombre y teléfono.',
                amigo: 'Con esta integración, la plataforma Globalbot programará citas médicas.',
                agendor: 'Con esta integración, la plataforma Globalbot será responsable de crear negociaciones y tareas. Campos clave: teléfono.',
                emailLead: 'Con esta integración, la plataforma Globalbot será responsable de enviar transcripciones de conversaciones por correo electrónico.',
                shopify: 'Esta integración es responsable del seguimiento de pedidos. Campos clave: correo electrónico.',
                vTiger: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contacto (leads) en vTiger a través de campos compatibles. Campos clave: correo electrónico, nombre y teléfono.',
                hubspot: 'Con esta integración, la plataforma Globalbot registrará (publicará) información de contacto (leads) en Hubspot a través de campos compatibles. Campos clave: correo electrónico, nombre y teléfono.',
                eventWebhook: 'Reciba en su sistema, casi en tiempo real, los eventos de estado de los mensajes de WhatsApp (enviado, entregado, leído, fallido). Entrega firmada con HMAC y reenvío automático en caso de falla.',
              },
              aboutIntegration: 'Sobre la Integración',
              native: 'NATIVO',
            },
            interface: {
              chatbots: 'Chatbots',
              preferences: 'Preferencias',
              interface: 'Interface WebChat',
              chatWindow: 'Ventana de chat',
              botName: 'Nombre del bot',
              attendantName: 'Nombre Principal',
              attendantRole: 'Frase Adicional',
              avatarImage: 'Imagen de avatar',
              balloonImage: 'Imagen de botón',
              logoImage: 'Logo',
              installationInstructions: 'Instrucciones de Instalación en el Sitio Web',
              installationInstructionsDescription: 'Instale el script de activación del WebChat en su sitio web.',
              logo: 'Logotipo',
              primaryColor: 'Color primario',
              chatHeight: 'Altura del chat',
              copyRight: 'Copyright (solo maestro)',
              disabled: 'Discapacitado',
              activated: 'Activado',
              startBalloon: 'Botón de inicio',
              message: 'Mensaje',
              position: 'Posición',
              left: 'Izquierda',
              right: 'Derecha',
              textColor: 'Color de texto',
              backgroundColor: 'Color de fondo',
              templates: 'Modelos',
              default: 'Patrón',
              amplified: 'Amplificado',
              ticket: 'Ticket',
              noImage: 'Sin imagen',
              noText: 'Sin texto',
              ghost: 'invisible',
              mobile: 'Móvil',
              save: 'Salvar',
              areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
              youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
              previousContent: 'el contenido anterior no se puede restaurar.',
              cancel: 'Cancelar',
              sampleQuestion: 'Pregunta de muestra',
              answerExample: 'Ejemplo de respuesta',
              typeYourName: 'Escriba su nombre',
              typeYourPhone: 'Digite seu telefone',
              typeYourExample: 'Ejemplo de texto',
              virtualAssistant: 'Asistente virtual',
              preferenceSaved: 'Preferencia guardada con éxito'
            },
            whatsapp: {
              settigns: 'Configuraciones',
              chatbotAndNumber: 'Chatbot | Número del Botón de WhatsApp',
              needWhatsappConfig: '¡Debes tener un número de WhatsApp configurado en el bot para habilitar esta opción!',
              buttonStatus: 'Estado del Botón',
              buttonMessage: 'Mensaje del Botón (opcional)',
              buttonPosition: 'Posición del Botón',
              initialMessageWhatsapp: 'Mensaje inicial en WhatsApp (opcional)',
              initialMessageWhatsappDescription: 'Este es el texto que se insertará automáticamente en el campo de mensaje de la aplicación WhatsApp.',
              enabled: 'Activado',
              disabled: 'Desactivado',
              rightPosition: 'a la derecha (esquina inferior)',
              leftPosition: 'a la izquierda (esquina inferior)',
              installationInstructions: 'Instrucciones de Instalación en el Sitio Web',
              installationInstructionsDescription: 'Instale el script de activación del Botón de WhatsApp en su sitio web.',
              traceOrigin: 'Rastrear Origen de Tráfico (Tracking)',
              traceOriginDescription: 'Al habilitar esta función, se solicitará al usuario que proporcione su número de teléfono de WhatsApp antes de iniciar la conversación. Esto permitirá identificar la página en la que el usuario estaba al visitar el sitio.',
              requestPhone: 'Solicitar teléfono y habilitar la trazabilidad.',
              logoOrAvatar: 'Imagen',
              visibleName: 'Nombre Visible (Display Name)',
              resquestPhoneMessage: 'Mensaje para solicitar el número de WhatsApp',
              copyright: 'Copyright (solo para el master)'
            },
            master: {
              chatbots: 'Chatbots',
              preferences: 'Preferencias',
              master: 'Master',
              locationOfServers: 'Localização dos servidores (solamente master)',
              newPln: 'Nuevo PLN (solamente master)',
              realTime: 'Tiempo real (solamente master)',
              cacheConversation: 'Cache del chat (solamente master)',
              offshoreLastQuestion: 'Offshore last question (solamente master)',
              excludeChatbot: 'Eliminar chatbot',
              createCliWithoutBackground: 'Crear CLI sin fondo',
              save: 'Guardar',
              areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
              youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
              previousContent: 'el contenido anterior no se puede restaurar.',
              doYouReallyExclude: '¿Realmente quieres eliminar el chatbot?',
              cancel: 'Cancelar',
              exclude: 'Borrar',
              interface: 'Interface',
              interfaceSettings: 'Configuración de la interface',
              behavior: 'Comportamiento',
              chatbotSettings: 'Configuración del chatbot',
              installation: 'Instalación',
              integrations: 'Integraciones',
              areYouStillAround: '¿Sigues por aquí?',
              ifYouNotResponse: 'Si no contesta tendré que terminar el servicio.',
              ifYouNeedHelp: 'Muy bien, si necesitas ayuda nuevamente, avísame.',
              closeMessage: 'La asistencia fue cerrado por el asistente, agradecemos su contacto y si tiene más preguntas, simplemente llámeme nuevamente.',
              preferenceSaved: 'Preferencia guardada con éxito'
            },
            messages: {
              chatbots: 'Chatbots',
              preferences: 'Preferências',
              messages: 'Mensagens',
              portuguese: 'Portugués',
              english: 'Inglés',
              spanish: 'Español',
              faqNotFound: 'FAQ não encontrada',
              treatment: 'Cuando el usuario escribe buenos días en lugar de su nombre.',
              noName: 'Cuando el usuario escribe: Mi nombre es...',
              ask: 'Cuando el usuario hace una pregunta.',
              special: 'Cuando el usuario pone algún carácter especial',
              justYourName: 'Cuando el usuario escribe el primer improperio',
              cursed: 'Cuando el usuario escribe la segunda palabrota y cierra el chatbot.',
              knowledgeName: 'Cuando hay una intención en la inteligencia y el usuario la ha puesto en el nombre.',
              limit: 'Cuando el usuario escribe más allá del límite permitido.',
              manyItems: 'Al eliminar la ambigüedad de una pregunta',
              faqNoneButton: 'Cuando se desambigua, aparece un botón con esta frase',
              connectLive: 'Al conectarse al chat en vivo',
              firstNameError: 'Cuando el usuario pierde el nombre',
              textError: 'Cuando el usuario no escribe nada en una solicitud de texto',
              emailError: 'Cuando el usuario pierde el correo electrónico',
              moneyError: 'Cuando se le pide al usuario que ingrese una cantidad monetaria por error',
              phoneError: 'Cuando el usuario pierde el teléfono',
              cpfError: 'Cuando el usuario pierde el CPF',
              cnpjError: 'Cuando el usuario extraña el CNPJ',
              faqError: 'Cuando el usuario no escribe nada en una pregunta frecuente',
              save: 'Guardar',
              areYouSureSave: '¿Está seguro de que desea guardar los cambios?',
              youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
              previousContent: 'el contenido anterior no se puede restaurar.',
              cancel: 'Cancelar',
              interface: 'Interface',
              interfaceSettings: 'Configuración de la interface',
              behavior: 'Comportamiento',
              chatbotSettings: 'Configurações de chatbot',
              installation: 'Instalación',
              integrations: 'Integraciones',
              areYouStillAround: '¿Sigues por aquí?',
              ifYouNotResponse: 'Si no contesta tendré que terminar la asistencia',
              ifYouNeedHelp: 'Muy bien, si necesitas ayuda nuevamente, avísame.',
              closeMessage: 'La asistencia fue cerrado por el asistente, agradecemos su contacto y si tiene más preguntas, simplemente llámeme nuevamente.',
              typeYourName: 'Para iniciar nuestra conversación, ingrese su nombre.',
              onlyName: 'Solo ingrese su nombre.',
              toContinueTypeYourNamePlease: 'Para continuar, ingrese su nombre. ',
              typeYourNamePleaseSpecial: 'Parece que agregó un carácter especial. Solo ingrese su nombre.',
              continueTheConversation: 'De esa forma no puedo continuar la conversación.',
              typeYourNamePlease: 'Por favor ingrese solo su nombre.',
              toAnswerYourQuestions: 'Para responder a sus preguntas, necesito que ingrese su nombre.',
              virtualAssistant: 'Asistente virtual',
              maxLimit: 'Has superado el límite máximo de caracteres.',
              iCanHelpYou: 'En esta pregunta tuya puedo ayudarte con más de una opción.',
              noneOption: 'Ninguna de las anteriores',
              notFound: 'No entendí su pregunta.',
              waitMoment: 'Espera un momento. Un asistente le hablará de inmediato.',
              selectOneOptions: 'Seleccione una de las opciones',
              typeName: 'Escriba su nombre',
              typeNameError: 'Por favor ingrese un nombre valido.',
              typeFirstName: 'Ponga su primer nombre',
              typeFirstNameError: 'Solo ingrese su nombre.',
              typeLastName: 'Ingrese su apellido',
              typeLastNameError: 'Solo ingrese su apellido.',
              typeHere: 'Digite aquí',
              typeHerePlease: 'Por favor escriba algo.',
              typeEmail: 'Escriba su correo electrónico',
              typeEmailError: 'Por favor, introduce una dirección de correo electrónico válida.',
              typeMoney: 'Ingrese su valor',
              typeMoneyError: 'Por favor ingrese una cifra válida.',
              typePhone: 'Ingrese su teléfono',
              typePhoneError: 'Por favor ingrese un número de teléfono válido.',
              typeCpf: 'Ingrese su CPF',
              typeCpfError: 'Ingrese un CPF válido.',
              typeBornDate: 'Introduzca su fecha de nacimiento',
              typeBornDateError: 'Indique su fecha de nacimiento válida.',
              typeCnpj: 'Ingrese su CNPJ',
              typeCnpjError: 'Ingrese un CNPJ válido.',
              typeFaq: 'Ingrese su pregunta',
              typeFaqError: 'Por favor, complete algo.',
              selectListFaq: 'Elija una opción',
              selectListFaqError: 'Por favor, elija una opción.',
              selectRating: 'Seleccione',
              search: 'Buscar',
              searchCountry: 'Países de búsqueda',
              searchState: 'Estado de búsqueda',
              searchCity: 'Buscar ciudad',
              typeMessage: 'Ingrese su mensaje...',
              typeMessageError: 'Por favor, escriba su mensaje',
              selectDate: 'Elige una fecha',
              selectDateError: 'Por favor elige una fecha',
              selectSize: 'Elige una talla',
              selectSizeError: 'Por favor, elija un tamaño',
              typeNumber: 'Ingrese un numero',
              typeNumberError: 'Por favor, introduzca un número',
              preferenceSaved: 'Preferencia guardada con éxito'
            },
            dataCollectionPage: {
              description: 'Define los mensajes iniciales y qué campos se solicitarán al principio de la conversación para registrar datos del lead.',
              leadDataTitle: 'Colección de datos del lead',
              leadDataDescription: 'Los campos habilitados serán solicitados al iniciar una conversación. Un lead es contabilizado cuando hay colecta del campo email o teléfono.',
              initialPhrase: 'Mensaje inicial (bienvenida)',
              phrase: 'Mensaje',
              phraseContinue: 'Mensaje de continuación (después de solicitar datos)',
              btnSave: 'Guardar',
              name: 'Nombre',
              email: 'Email',
              phone: 'Telefone'
            },
            chatbots: 'Chatbots',
            preferences: 'Preferencias',
            interfaceChatbot: 'Interface WebChat',
            setAllVisual: 'Habilitar y definir los aspectos visuales y funciones del WebChat (ventana de chat) instalado en el sitio web.',
            behaviorChatbot: 'Comportamiento',
            accessTheBehaviorSettings: 'Acceda a la configuración de comportamiento del chatbot (controles de tiempo, disparador, modos de visualización de la ventana de chat y persistencia del chat).',
            installationChatbot: 'Instalación',
            accessTheInstallationSettings: 'Accede a la configuración de instalación y activación del chatbot en cada uno de los canales: WebChat, WhatsApp, Instagram, Messenger y Telegram.',
            whatsappChatbot: 'Boton Whatsapp',
            whatsappChatbotDescription: 'Habilite y defina los aspectos visuales del botón de WhatsApp para su sitio web y configure la función Seguimiento de fuente de tráfico.',
            integrationsChatbot: 'Integraciones',
            accessTheIntegrationSettings: 'Acceda al panel de configuración de las distintas integraciones de Globalbot con otros sistemas. Algunas de estas configuraciones son realizadas por nuestro equipo técnico debido a su complejidad y seguridad.',
            masterChatbot: 'Master',
            exclusiveAccess: 'Acceso exclusivo del equipo de Globalbot a configuraciones avanzadas como ubicación del servidor, caché de conversación, comportamiento de inteligencia artificial y tiempo real.',
            excludeVersionerAccess: 'Acceso exclusivo para el equipo de Globalbot para ver las versiones de flujo.',
            publishChatbot: 'Versionamiento',
            dataCollection: 'Recopilación de datos',
            dataCollectionSubtitle: 'Define frases iniciales y qué campos solicitará el chatbot al usuario al comienzo de la conversación.',
            messagesChatbot: 'Mensajes',
            modifyMessages: 'Aquí puedes modificar algunos de los mensajes, solo para Maestros por el momento.',
            flowPublish: 'Preferencia guardada con éxito'
          },
          permission: {
            permission: {
              permission: 'Permisos',
              preferences: 'Preferencias',
              conversations: 'Conversaciones',
              manager: 'Gerente',
              attendant: 'Asistente',
              seeAll: 'Ver todo',
              seeAttendedAndWithoutTransshipment: 'Ver atendido y sin transbordo',
              onlyAttended: 'Ver solo respondido',
              junior: 'Júnior',
              done: 'Guardar',
              updatedPermissions: 'Permisos actualizados!',
              connectionError: 'Vaya, error de conexión.'
            }
          },
          users: {
            access: {
              preferences: 'Preferencias',
              users: 'Usuarios',
              journey: 'Viajes',
              addJourney: 'Agregar viaje',
              name: 'Nombre',
              description: 'Descripción',
              actions: 'Comportamiento',
              edit: 'Editar',
              linkUsers: 'Vincular usuarios',
              exclude: 'Borrar',
              totalOf: 'Total de',
              usersBeing: 'usuários, sendo',
              inNone: 'en ninguno',
              inOneAnd: 'en uno y',
              inTwoOrMore: 'en dos o más viajes.',
              save: 'Guardar',
              cancel: 'Cancelar',
              journeyData: 'Detalles del viaje',
              journeyName: 'Nombre del viaje *',
              comments: 'Comentarios',
              schedules: 'Horarios',
              dayOfTheWeek: 'Dia de la semana *',
              sunday: 'Domingo',
              monday: 'Lunes',
              tuesday: 'Martes',
              wednesday: 'Miércoles',
              thursday: 'Jueves',
              friday: 'Viernes',
              saturday: 'Sábado',
              input: 'Aporte *',
              exit: 'Salida *',
              addTime: 'Agregar tiempo',
              tolerance: 'Tolerancia',
              defineTheTolerance: 'Defina el tiempo de tolerancia del viaje para acceder y permanecer en la plataforma.',
              important: 'Importante',
              onceTheTolerance: 'Una vez que se alcanza el tiempo de tolerancia, la plataforma emitirá una alerta y un temporizador de cuenta atrás para que el usuario finalice tranquilamente sus actividades.',
              whenTheTotal: 'Cuando finalmente se alcance la duración total de la estadía, el usuario cerrará la sesión automáticamente. Solo los usuarios administradores podrán iniciar sesión en la plataforma fuera de su horario laboral.',
              ifUser: 'Si un usuario está vinculado en más de un viaje, el acceso y la permanencia tendrán en cuenta el viaje de mayor duración (tanto de entrada como de salida).',
              journeyUsers: 'Usuarios de viaje',
              outOfTheJourney: 'Fuera del viaje',
              withinTheJourney: 'Dentro del viaje',
              addSelected: 'Agregar seleccionados',
              addAll: 'Agregar todo',
              removeAll: 'Eliminar todo',
              removeSelected: 'Eliminar selección',
              nonexistent: 'Inexistente',
              deleteJourney: 'Eliminar viaje',
              areYouSure: '¿Está seguro de que desea eliminar este viaje? Se perderán todos los datos y esta acción no se puede deshacer.',
              fiveMinutes: '5 minutos',
              tenMinutes: '10 minutos',
              fifteenMinutes: '15 minutos',
              twentyMinutes: '20 minutos',
              twentyFiveMinutes: '25 minutos',
              thirtyMinutes: '30 minutos',
              oneHour: '1 hora',
              twoHours: '2 horas',
              fourHours: '4 horas',
              sixHours: '6 horas',
              twelveHours: '12 horas',
              journeyCreated: '¡Tu viaje ha sido creado!',
              journeyEdited: '¡Tu viaje ha sido editado!',
              errorAtTheTime: '¡Vaya, tuvimos un error en ese momento!',
              duplicateTime: 'Eliminar tiempos duplicados para guardar.',
              journeyExcluded: '¡Tu viaje ha sido eliminado!',
              errorCompletingThisAction: 'Vaya, tuvimos un problema al completar esta acción.',
              journeyAtDeparmentUnlink: 'El viaje está vinculado al departamento %1%, debe desvincular el viaje del departamento para eliminarlo.',
              journeyAtBotUnlink: 'El viaje está vinculado al bot %1%, debes desvincular el viaje del bot para eliminarlo.'
            },
            emailExits: 'El usuario con este correo electrónico ya existe',
            preferences: 'Preferências',
            users: 'Usuarios',
            addNewUser: 'Agrega nuevos usuarios a la plataforma. Si alcanza su límite, solicite la expansión del mismo.',
            createUser: 'Crear usuario',
            permissions: 'Permisos',
            managerUserPermissions: 'Administre los permisos de los usuarios, habilitando o restringiendo el acceso a las funciones de la plataforma.',
            passwordMinimun8chars: 'Utilice al menos 8 caracteres.!',
            journeys: 'Jornadas',
            defineTheJourney: 'Definir el jornada operativo de los chatbots, departamentos y usuarios, controlando el acceso y permanencia en la plataforma.',
            extendLimit: 'Límite extendido',
            yourCurrentLimit: '¿Tu límite actual no es suficiente? Solicite la extensión ahora.',
            avatar: 'Avatar',
            addAvatar: 'Agregar avatar',
            reasonForAbsence: 'Motivo de ausencia',
            statusReasonLabel: 'Motivo del estado',
            statusReasonMasterTooltip: 'Esta columna solo se muestra para usuarios master.',
            statusReasonDescriptionLabel: 'Descripción del motivo',
            statusReasonDescriptions: {
              SESSION_REVOKED_NEW_DEVICE: 'Sesión finalizada: acceso desde otro dispositivo',
              SESSION_REVOKED_BY_ADMIN: 'Sesión finalizada por un administrador',
              AUTH_CONNECT: 'Sesión conectada',
              AUTH_SERVER_NAMESPACE_DISCONNECT: 'Sesión finalizada por el servidor',
              AUTH_CLIENT_NAMESPACE_DISCONNECT: 'Sesión finalizada por el navegador',
              AUTH_PING_TIMEOUT: 'Sesión perdida por tiempo de respuesta',
              AUTH_TRANSPORT_ERROR: 'Error de conexión en la sesión',
              AUTH_TRANSPORT_CLOSE: 'Conexión de sesión perdida',
              LIVE_SERVER_NAMESPACE_DISCONNECT: 'Chat en vivo finalizado por el servidor',
              LIVE_CLIENT_NAMESPACE_DISCONNECT: 'Chat en vivo finalizado por el navegador',
              LIVE_PING_TIMEOUT: 'Conexión del chat en vivo perdida por tiempo de respuesta',
              LIVE_TRANSPORT_ERROR: 'Error de conexión en el chat en vivo',
              LIVE_TRANSPORT_CLOSE: 'Conexión del chat en vivo perdida',
              PANEL_SYS_CONNECT: 'Estado definido al conectar',
              PANEL_SYS_COOKIE_CONNECT: 'Estado restaurado al abrir el panel',
              PANEL_SYS_RECONNECT: 'Estado restaurado tras la reconexión',
              PANEL_USER_CHANGE_STATUS: 'El usuario cambió el estado',
              PANEL_USER_CHANGE_STATUS_FROM_LIST: 'Estado cambiado desde la lista de agentes',
            },
            name: 'Nombre',
            nameRequired: 'Nombre *',
            email: 'Correo electrónico',
            emailRequired: 'Correo electrónico *',
            role: 'Ocupación',
            roleRequired: 'Ocupación *',
            departmentsFilter: 'Seleccione un departamento',
            chatbotsFilter: 'Seleccione un chatbot',
            linked: 'Vinculado',
            unlinked: 'Sin vínculo',
            permission: 'Permiso',
            permissionRequired: 'Permiso *',
            actions: 'Comportamiento',
            accessReport: 'Informe de acceso',
            edit: 'Editar',
            exclude: 'Borrar',
            understood: 'Comprendido',
            important: 'IMPORTANTE',
            impossibleToDelete: ': No se puede eliminar este usuario porque tiene ',
            activeConversations: 'conversaciones activas. Debe transferir o finalizar las conversaciones de este usuario antes de solicitar la eliminación.',
            save: 'Guardar',
            cancel: 'Cancelar',
            close: 'Cerrar',
            userData: 'Datos del usuario',
            ddi: 'DDI',
            phone: 'Teléfono móvil',
            newPassword: 'Nueva contraseña *',
            chatbots: 'Chatbots',
            departments: 'Departamentos',
            accessLogs: 'Registros de acceso',
            initialDate: 'Fecha de inicio',
            startTime: 'Hora de inicio',
            finalDate: 'Fecha final',
            endTime: 'Hora de finalización',
            status: 'Status',
            date: 'Fecha',
            intentions: 'Intenciones',
            intentionsDescription: 'Seleccione la fecha y la hora para que el filtro busque dentro del área elegida.',
            available: 'Online',
            away: 'Lejos',
            offline: 'Offline',
            connected: 'Conectado',
            disconnected: 'Desconectado',
            endJourney: 'Final del Jornada',
            excludeUser: 'Borrar usuario',
            areYouSureDelete: '¿Está seguro de que desea eliminar este usuario? Se perderán todos los datos y esta acción no se puede deshacer.',
            youCanRequest: 'Puede solicitar usuarios adicionales para usar la plataforma. Ingrese los detalles a continuación y uno de nuestros especialistas se comunicará con usted.',
            amount: 'Cantidad *',
            request: 'Solicitud',
            primary: 'Primario',
            administrator: 'Administrador',
            manager: 'Administrador',
            attendant: 'Atendente',
            junior: 'Júnior',
            january: 'Enero',
            february: 'Febrero',
            march: 'Marcha',
            april: 'Abril',
            may: 'Mayo',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
            shortJan: 'Ene',
            shortFeb: 'Feb',
            shortMar: 'Mar',
            shortApr: 'Abr',
            shortMay: 'May',
            shortJun: 'Jun',
            shortJul: 'Jul',
            shortAug: 'Ago',
            shortSep: 'Sep',
            shortOct: 'Oct',
            shortNov: 'Nov',
            shortDec: 'Dic',
            sunday: 'Domingo',
            monday: 'Lunes',
            tuesday: 'Martes',
            wednesday: 'Miércoles',
            thursday: 'Jueves',
            friday: 'Viernes',
            saturday: 'Sábado',
            shortSunday: 'Dom',
            shortMonday: 'Lun',
            shortTuesday: 'Mar',
            shortWednesday: 'Mié',
            shortThursday: 'Jue',
            shortFriday: 'Vie',
            shortSaturday: 'Sab',
            exportToSVG: 'Exportar a SVG',
            exportToPNG: 'Exportar a PNG',
            exportToCSV: 'Exportar a CSV',
            menu: 'Menú',
            selection: 'Seleccione',
            selectionZoom: 'Seleccionar zoom',
            zoomIn: 'Acercarse',
            zoomOut: 'Disminuir el zoom',
            pan: 'Para mover',
            reset: 'Volver al valor predeterminado',
            userDeleted: 'Usuário excluído.',
            errorUserDelete: 'Oops, não conseguimos excluir este usuário!',
            notLimit: 'Você não tem mais limite para adicionar usuários.',
            errorPasswordLength: 'Introduzca una contraseña de más de 6 caracteres.',
            errorSavingUser: 'Rellene todos los campos obligatorios.',
            invalidPassword: '¡La contraseña debe tener al menos 8 dígitos!',
            theArchitect: 'O Arquiteto',
            notFound: 'Não encontrado',
            dominion: 'Domínio',
            master: 'Mestre',
            senior: 'Sênior',
            failedToRequest: 'Vaya, no se pudo solicitar a los usuarios.',
            requestedUsers: 'Usuarios solicitados.',
            requiredFields: 'Debes completar los campos.',
            userCreatedSuccessfully: '¡Usuario creado con éxito!',
            userUpdatedSuccessfully: '¡Usuario actualizado correctamente!',
            userSeeAnyAttendantConversations: "¿Permitir ver y transferir conversaciones de otros asistentes?",
            restrictToLinkedBots: "¿Permitir funciones y visualizaciones solo para el/los chatbot(s) asignados a este usuario?",
            restrictToLinkedBotsLockedTooltip: "No puede desactivar esta opción en su propio perfil mientras esté activa."
          },
          unsubscribeGroups: {
            title: 'Grupos de cancelación de suscripción',
            description: 'Cada dominio tiene un grupo de cancelación. Quien haga clic en "cancelar suscripción" en un correo enviado desde este dominio entra en esta lista y deja de recibir sus campañas, sin afectar a otros dominios ni a los correos del sistema.',
            backToDomains: 'Volver a dominios',
            domain: 'Dominio',
            status: 'Estado',
            statusActive: 'Activo',
            statusPendingSync: 'Sincronizando con el proveedor',
            pendingSyncHint: 'El proveedor de correo aún no confirmó este grupo. Reintentamos automáticamente cada día a las 03:00, o ahora con el botón Sincronizar.',
            displayName: 'Nombre',
            descriptionField: 'Descripción mostrada al destinatario',
            descriptionHint: 'Hasta 100 caracteres. Aparece en la página de preferencias de correo del destinatario.',
            edit: 'Editar',
            save: 'Guardar',
            cancel: 'Cancelar',
            saved: 'Grupo actualizado.',
            noGroupTitle: 'Este dominio aún no tiene grupo de cancelación',
            noGroupDescription: 'El grupo se crea automáticamente al registrar el dominio. Si la creación falló, puedes crearlo ahora.',
            createGroup: 'Crear grupo',
            groupCreated: 'Grupo creado.',
            unsubscribedEmails: 'Correos dados de baja',
            searchEmail: 'Buscar correo',
            email: 'Correo',
            unsubscribedAt: 'Baja el',
            releasedAt: 'Liberado el',
            releasedBy: 'Liberado por',
            reason: 'Motivo',
            actions: 'Acciones',
            rowUnsubscribed: 'Dado de baja',
            rowReleased: 'Liberado',
            systemRelease: {
              resubscribed_by_recipient: 'Reinscrito por el propio destinatario',
              global_suppression_reset: 'Reinicio de la supresión global'
            },
            release: 'Liberar correo',
            releaseTitle: 'Liberar correo del grupo',
            releaseDescription: 'El correo volverá a recibir campañas de este dominio. Sigue en la lista como "liberado", con el motivo indicado.',
            reasonLabel: 'Motivo *',
            reasonRequired: 'Indica un motivo con al menos 3 caracteres.',
            confirmRelease: 'Liberar',
            released: 'Correo liberado.',
            releaseOnlyAdmin: 'Solo los administradores de la cuenta pueden liberar correos.',
            empty: 'Ningún correo dado de baja en este grupo.',
            loadError: 'No se pudieron cargar los datos. Inténtalo de nuevo.',
            providerUnavailable: 'El proveedor de correo no está disponible ahora. Inténtalo de nuevo en unos instantes.',
            rowsPerPage: 'Filas por página',
            retry: 'Intentar de nuevo',
            displayNameRequired: 'Ingresa el nombre del grupo.',
            saveError: 'No fue posible guardar el grupo. Inténtalo de nuevo.',
            syncNow: 'Sincronizar ahora',
            stillPending: 'El grupo sigue sincronizándose con el proveedor. Lo intentaremos de nuevo automáticamente.',
            onlyAdminCanCreate: 'Solo los administradores de la cuenta pueden crear o sincronizar el grupo.',
            editOnlyAdmin: 'Solo los administradores de la cuenta pueden editar el grupo.',
            forbidden: 'No tienes permiso para esta acción.',
            invalidPayload: 'Datos inválidos. Revisa los campos e inténtalo de nuevo.',
            genericError: 'No fue posible completar la operación. Inténtalo de nuevo.'
          },
          domains: {
            unsubscribeGroups: 'Grupos de cancelación de suscripción',
            domainInUse: 'El grupo de cancelación de suscripción de este dominio está en uso por envíos programados o en curso. Finalízalos o cancélalos antes de eliminar el dominio.',
            providerUnavailable: 'El proveedor de correo no está disponible en este momento y el dominio no fue eliminado. Inténtalo de nuevo en unos instantes.',
            deleteConsequence: 'El grupo de cancelación de suscripción y la lista de bajas de este dominio también se eliminarán en el proveedor de correo.',
            preferences: 'Preferências',
            domains: 'Domínios',
            addNewDomainsToThePlatform: 'Agrega nuevos dominios a la plataforma. Primero, se debe registrar el DKIM, TXT y CNAME del dominio.',
            addDomain: 'Agregar dominio',
            creation: 'Creación',
            domain: 'Dominio',
            emails: 'Correos electrónicos',
            name: 'Nombre',
            actions: 'Comportamiento',
            waiting: 'Esperando',
            verified: 'Verificado',
            type: 'TIPO',
            host: 'HOST',
            data: 'DATA',
            verifyDomain: 'Verificar dominio',
            exclude: 'Borrar',
            addNewDomain: 'Agregar nuevo dominio',
            insertRecords: 'Ahora debe ingresar los siguientes registros en su DNS.',
            updateDomain: 'A propagação do seu DNS pode levar algumas horas, e o status do seu domínio será atualizado na plataforma.',
            record: 'Registro',
            nameToUpperCase: 'NOMBRE',
            valueToUpperCase: 'VALOR',
            cancel: 'Cancelar',
            add: 'Agregar',
            addNewEmail: 'Agregar un nuevo correo electrónico',
            confirmationEmail: 'Recibirá un correo electrónico de confirmación, haga clic en el enlace en el cuerpo del correo electrónico para continuar con la verificación del correo electrónico.',
            email: 'Correo electrónico',
            excludeDomain: 'Eliminar dominio',
            areYouSure: '¿Estás seguro de que deseas eliminar este dominio?',
            domainSuccessfully: 'Dominio registrado correctamente.',
            connectionError: 'Error de conexión',
            domainAlreadyRegistered: 'Dominio ya registrado, vuelve a intentarlo con otro.',
            startTheProcess: 'Para iniciar el proceso necesitas un dominio.',
            deletedDomain: 'Dominio eliminado.',
            domainSuccessfullyValidated: '¡Dominio validado con éxito!',
            fieldsNotAuthenticated: 'Hay algunos campos que aún no se han autenticado. '
          },
          lists: {
            preferences: 'Preferencias',
            lists: 'Lista',
            deleteSelectedLists: 'Eliminar listas seleccionadas',
            avatar: 'Avatar',
            title: 'Título',
            amount: 'La cantidad',
            actions: 'Comportamiento',
            view: 'Ver',
            exclude: 'Borrar',
            save: 'Guardar',
            cancel: 'Cancelar',
            listData: 'Dados da lista',
            name: 'Nombre',
            email: 'Correo electrónico',
            phone: 'Teléfono',
            excludeList: 'Borrar lista',
            areYouSure: '¿Está seguro de que desea eliminar esta lista?',
            listDeleted: 'Tu lista ha sido eliminada',
            errorDeleteThisList: '¡Vaya, no pudimos eliminar esta lista!'
          },
          dataBases: {
            importData: 'Datos de importacion',
            name: 'Nombre',
            cdt: 'Data/Hora',
            replaceData: 'Reemplazar datos',
            import: 'Importar',
            importCSV: "Importar archivo CSV",
            syncGoogleSheet: "Sincronizar con Google Sheets",
            invalidSpreadsheetId: 'ID de hoja de cálculo no válido',
            foundSheets: 'Hojas de trabajo encontradas',
            shareSpreadsheet: 'Necesitas compartir tu hoja de cálculo con este correo electrónico: ',
            listPages: 'Lista de páginas',
            reportSpreadsheetId: 'Ingrese el ID de la hoja de cálculo',
            reportTabSheet: 'Seleccione la hoja de cálculo que desea importar.',
            reportName: 'Pon un nombre',
            alreadyBaseName: 'Ya existe una base con este nombre',
            alreadyBaseSheetName: 'Ya existe una base con esta página de hoja de cálculo',
            dataGoogleSpreadSheet: 'Datos de la hoja de cálculo de Google',
            deleteDataBase: 'Eliminar base de datos',
            spreadSheetId: 'ID de hoja de cálculo de Google',
            sheetPageName: 'Nombre de la página',
            close: 'Cerrar',
            delete: 'Borrar'
          },
          status: {
            consult: 'Consultar',
            consultDescription: 'Verifique el estado actual de un número de WhatsApp dentro de Globalbot y realice acciones de reinicio y bloqueo.',
            consultNumber: 'Consultar número de WhatsApp',
            country: 'País *',
            customerNumber: 'Número de WhatsApp del Cliente *',
            alert: 'Atención:',
            alertDescription: 'Ingrese el número de celular del cliente con código de área de 2 dígitos, ejemplo (XX) XXXXX-XXXX.',
            cancel: 'Cancelar',
            phoneRequired: 'Complete el número de teléfono para consultar.',
            status: 'Status:',
            statusMessage: {
              live: 'En conversación con asistente.',
              bot: 'En conversación con el chatbot.',
              live_satisfactionSurvey: 'Conversación con el asistente finalizada, ahora está en la encuesta de satisfacción.',
              bot_satisfactionSurvey: 'Conversación con el chatbot finalizada, ahora está en la encuesta de satisfacción.',
              no_conversation: 'No está en conversación.',
              blocked: 'Numero bloqueado.'
            },
            reset: 'Reiniciar',
            block: 'Bloquear',
            resetNumber: 'Restablecer número de WhatsApp',
            confirmReset: 'Por favor confirme el RESET del número de WhatsApp',
            resetDescription: 'A partir del momento del RESET el número será desvinculado de chatbot conversación. La próxima interacción del usuario iniciará la conversación con el chatbot.',
            resetBlockedWarning: 'Este número está bloqueado en este chatbot. El reset finaliza la interacción, pero no elimina el bloqueo.',
            blockNumber: 'Bloquear número de WhatsApp',
            confirmBlock: 'Por favor confirme el bloqueo del número de WhatsApp',
            blockDescription: 'Este número no podrá interactuar más en este chatbot hasta que sea desbloqueado.',
            unblockNumber: 'Desbloquear número de WhatsApp',
            confirmUnblock: 'Por favor confirme el desbloqueo del número de WhatsApp',
            unblockDesription: 'A partir de este momento este número estará liberado para interactuar nuevamente en el chatbot',
            confirm: 'Confirmar',
            current_status: {
              reseted: 'Número reiniciado',
              blocked: 'Número bloqueado',
              unblocked: 'Número desbloqueado'
            },
            channel: 'Canal',
            cdt: 'Fecha y Hora',
            chatbot: 'Chatbot',
            number: 'Número',
            identification: 'Identificación',
            identificationTooltip: 'Identificación del contacto: el número de teléfono o, cuando Meta no proporciona el teléfono, el BSUID — identificador del usuario asignado por Meta (ej.: BR.1914261605930178).',
            condition: 'Condición',
            user: 'Autor',
            actions: 'Acciones',
            resetError: '¡Ups! No se pudo restablecer el número.',
            resetSuccess: '¡Número restablecido con éxito!',
            blockError: '¡Ups! No se pudo bloquear el número.',
            blockSuccess: '¡Número bloqueado con éxito!',
            unblockError: '¡Ups! No se pudo desbloquear el número.',
            unblockSuccess: '¡Número desbloqueado con éxito!',
            consultError: '¡Ups! No fue posible consultar el número.',
            consultSuccess: 'El número no está en conversación.',
            system: 'Sistema',
            back: 'Volver',
            reason: 'Motivo:',
            blockReason: {
              too_many_messages: 'Más de 200 mensajes intercambiados en un lapso de 20 minutos.',
              loop_marker: 'El usuario fue y volvió más de 50 veces al mismo punto del flujo.',
              lock_marker: 'El usuario saltó repetidamente al mismo punto del flujo más de 50 veces.'
            },
            noInformation: 'Sin Información',
            numberNoConversationDescriprion: 'El número en cuestión no está en ninguna conversación. Si desea bloquear este número, seleccione el ChatBot deseado a continuación.',
            historyFilter: 'Historial de acciones',
            historyFilterTooltip: 'Muestra solo las acciones del tipo seleccionado. La lista es el historial de acciones, de la más reciente a la más antigua.',
            historyAll: 'Todos',
            historyAction: {
              blocked: 'Fue bloqueado',
              unblocked: 'Fue desbloqueado',
              reseted: 'Fue reseteado'
            },
            viewHistory: 'Ver historial',
            historyTitle: 'Historial de acciones',
            historyEmpty: 'No hay acciones registradas para este número.',
            historyError: '¡Ups! No fue posible cargar el historial.',
            listError: '¡Ups! No fue posible cargar la lista de números.',
            tryAgain: 'Intentar de nuevo',
            close: 'Cerrar'
          },
          live: {
            serviceMessages: 'Mensajes de servicio',
            portuguese: 'Portugués',
            english: 'Inglés',
            spanish: 'Español',
            completionMessage: 'Mensaje de finalización',
            finishAndArchivedMessage: 'Mensaje de finalización y archivo',
            archivalMessage: 'Mensaje de archivo',
            transferMessage: 'Transferir mensaje',
            automaticTransferToAttendant: 'Transferencia automática a asistente',
            transshipmentAvailableForAttendants: 'Transbordo disponible para asistentes',
            queueTransshipmentWithoutDistribution: 'Transbordo en cola (sin distribución)',
            queueTransshipmentWithDistribution: 'Transbordo en cola (con distribución)',
            queuePositionLabel: 'Mensaje para transmitir posición en la cola.',
            queuePositionVariableRequired: 'Este mensaje necesita la variable %POSITION%',
            deliveryTitle: 'Envío al cliente',
            deliveryDescription: 'Elija qué mensajes automáticos recibe el cliente. Un mensaje desactivado no se envía, pero sigue registrado en la conversación para auditoría, marcado como no enviado.',
            deliveryReadOnlyHint: 'Texto predeterminado de la plataforma, sin edición.',
            deliveryEditableHint: 'Texto configurable arriba.',
            sendToCustomer: 'Enviar al cliente',
            deliveryTypes: {
              take_room: { label: 'El asistente asumió la atención', example: '{nombre} se hizo cargo de este servicio.' },
              transfer_room: { label: 'Conversación transferida', example: '{nombre} transfirió esta habitación.' },
              finish_room: { label: 'Atención finalizada', example: '{nombre} terminó el servicio.' },
              finish_and_archive_room: { label: 'Atención finalizada y archivada', example: '{nombre} terminó y archivó el servicio.' },
              archive_room: { label: 'Atención archivada', example: '{nombre} archivó la habitación.' },
              with_attendant: { label: 'Transferencia automática al asistente', example: 'Con asistente.' },
              available: { label: 'Transferencia disponible para asistentes', example: 'Disponible.' },
              queue: { label: 'Transferencia en cola (sin distribución)', example: 'En fila.' },
              queue_distribution: { label: 'Transferencia en cola (con distribución)', example: 'Cola automática' },
              waiting: { label: 'Esperando asistente', example: 'Esperando' },
              no_vacancy: { label: 'Ningún asistente disponible', example: 'Texto definido en el nodo de Chat en Vivo del flujo.' },
              finished_reply: { label: 'Respuesta en conversación ya finalizada', example: 'Usa el mensaje de finalización.' },
              user_reconnected: { label: 'El cliente regresó al chat', example: 'El usuario regresó al chat.' }
            },
            transshipmentAwaitingAttendants: 'Transbordo en espera de asistentes (check in discapacitados)',
            noAttendantsAvailable: 'No hay asistentes disponibles (registro habilitado)',
            tipDepartmentIsPersistent: 'No es posible activar el check-in ya que este departamento está configurado en la persistencia de los bots: ',
            pauseOptions: 'Opciones de pausa',
            activated: 'Activado',
            disabled: 'Discapacitado',
            enterHereAll: 'Ingrese aquí todos los posibles descansos que los asistentes pueden seleccionar.',
            add: 'Agregar opción',
            automaticAway: 'Automático de distancia',
            determineTheCheckInTime: 'Determine el horario de check-in.',
            time: 'Tiempo',
            viewingOptions: 'Opciones de visualización',
            autoArchive: 'Tiempo de archivo de conversaciones',
            autoArchiveCaption: 'Configure el archivo automático de conversaciones en el chat en vivo.',
            conversationCloseOptions: "Opciones al cerrar conversación",
            conversationCloseOptionsDescription: "Habilite la asignación de etiquetas o valor al cerrar una conversación.",
            addTag: "Asignar Etiquetas",
            addMonetary: "Asignar Valor",
            requiredTagsBatch: 'Conversaciones sin etiquetas. ¡Añade etiquetas para finalizar las conversaciones!',
            requiredMonetaryValueBatch: 'Conversaciones sin valor. ¡Añade un valor monetario para finalizar las conversaciones!',
            errorReasonPhrases: {
              ROOM_NOT_FOUND: 'Conversación no encontrada.',
              ROOM_NOT_FINISHED: 'La conversación no ha sido finalizada.',
              NO_ATTENDANTS: 'No hay asistentes en la conversa.',
              MISSING_INFORMATION: 'Información incompleta o faltante.',
              UNKNOWN_ERROR: 'Error desconocido.',
              ROOM_ALREADY_CLOSED: 'La conversa ya ha sido finalizada.',
            },
            required: "Obligatorio",
            coin: "Moneda",
            coinTypes: {
              BRL: "Real Brasileño - BRL",
              USD: "Dólar Americano - USD"
            },
            chooseTheLevel: 'Elija el nivel de acceso que sus operadores podrán ver en la lista de asistentes.',
            managers: 'Gerentes',
            attendants: 'Acomodadores',
            departments: 'Departamentos',
            newDepartment: 'Nuevo departamento',
            newDepartmentDescription: 'Cree departamentos para organizar y dirigir conversaciones para la atención humana.',
            addDepartment: 'Agregar uno nuevo',
            actions: 'Acciones',
            color: 'Color',
            defineTheDepartments: 'Defina los departamentos del módulo Chat en vivo a continuación. Los departamentos son útiles para "enrutar" las solicitudes de contacto, manejándolas de forma segmentada.',
            whenCreatingTheDepartments: 'Al crear los departamentos, utilice la configuración de usuario para definir en qué departamento (s) puede operar cada usuario.',
            name: 'Nombre',
            setBehavior: 'Configure el comportamiento entrante si no tiene ningún asistente en línea en este momento.',
            checkIn: 'Check-in',
            forcePass: 'Force Pass',
            forcePassDescription: 'También distribuya las llamadas a los asistentes fuera de línea.',
            forcePassDistributionNone: 'Debe seleccionar un tipo de distribución cuando Force Pass está habilitado.',
            queueDisable: 'La cola de servicio es obligatoria cuando Forzar paso está habilitado.',
            queuePositionDisable: 'La posición de la cola de transmisión solo se puede activar con la cola de servicio habilitada y un tipo de distribución seleccionado.',
            forcePassDisable: 'No es posible activar Force Pass con el Check-in habilitado.',
            checkInDisable: 'No es posible activar Check-in con el Force Pass habilitado.',
            attendanceQueue: 'Cola de asistencia',
            lastUpdate: 'Última actualización',
            persistence: 'Persistencia',
            persistenceDescription: 'La función de persistencia envía mensajes al cliente cuando está inactivo en el chat en vivo, con el objetivo de obtener una respuesta para agilizar el servicio.',
            activatePersistence: 'Activar persistencia',
            firstMessageIn: 'Primer mensaje entrante',
            secondMessageIn: 'Segundo mensaje entrante',
            firstMessageTooltip: 'Tiempo para enviar el primer mensaje de persistencia',
            secondMessageTooltip: 'Tiempo para enviar el segundo mensaje de persistencia',
            transmitQueuePosition: 'Transmitir la posición de la cola',
            transmitQueuePositionDescription: 'Transmita la posición de la cola a los clientes en espera.',
            maxAttendances: 'Asistencia máxima',
            maxAttendancesDescription: 'Establezca la cantidad máxima que cada servidor puede servir simultáneamente.',
            customersByAttendants: 'Clientes por asistentes',
            distribution: 'Distribución',
            distributionDescription: 'Elija la forma de distribuir las llamadas en el módulo Chat en vivo.',
            balancing: 'Equilibrio',
            disabledNone: 'Discapacitado',
            businessHours: 'Jornada',
            businessHoursDescription: 'Seleccione un recorrido para definir el horario comercial del departamento.',
            autoBalance: 'Autoequilibrio',
            sequential: 'Secuencial',
            save: 'Guardar',
            confirm: 'Confirmar',
            exclude: 'Borrar',
            addDepartment: 'Agregar departamento',
            cantDeleteDepartmentUser: 'No puede eliminar este departamento porque hay personas vinculadas a él:',
            cantDeleteDepartmentPersistence: 'No puede eliminar este departamento porque hay bots vinculados a él en la configuración de persistencia:',
            areYouSureSaved: '¿Está seguro de que desea guardar los cambios?',
            areYouSureDeleted: '¿Está seguro de que desea guardar los cambios?',
            youCanChange: 'Puede cambiar la configuración cuando lo desee, pero el',
            previousContent: 'el contenido anterior no se puede restaurar.',
            cancel: 'Cancelar',
            finishRoom: 'La conversación terminó.',
            archiveRoom: 'La conversación se ha archivado.',
            transferRoom: 'La conversación fue transferida.',
            withAttendant: 'Con asistente.',
            available: 'Disponible.',
            queue: 'En fila.',
            queueDistribution: 'Cola automática',
            waiting: 'Esperando',
            noVacancy: 'No hay asistentes por el momento.',
            oneMinute: '1 minuto',
            twoMinutes: '2 minutos',
            threeMinutes: '3 minutos',
            fourMinutes: '4 minutos',
            fiveMinutes: '5 minutos',
            tenMinutes: '10 minutos',
            fifteenMinutes: '15 minutos',
            thirtyMinutes: '30 minutos',
            oneHour: '1 hora',
            sixHours: '6 horas',
            twelveHours: '12 horas',
            oneDay: '1 día',
            twoDays: '2 días',
            threeDays: '3 días',
            fourDays: '4 días',
            fiveDays: '5 días',
            seeAll: 'Ver todo',
            onlyDepartments: 'Ver solo en departamentos',
            preferences: 'Preferencias',
            behavior: 'Comportamiento',
            liveChat: 'Chat en Vivo',
            updated: '¡Actualizado!',
            myDepartment: 'Mi departamento',
            departmentAdded: 'Departamento agregado!',
            deletedDepartment: 'Departamento eliminado!',
            none: 'Ninguno',
            noDistribution: 'Sin distribución',
            active: 'Activo',
            inactive: 'Inactivo',
            quantity: 'Cantidad',
            attendanceDistribution: 'Distribución de la Atención',
            attendanceDistributionDescription: 'Defina cómo se distribuirán las atenciones en este departamento.',
            balanced: 'Equilibrada',
            noDistributionDescription: 'Las atenciones no serán distribuidas. Permanecerán en espera. Los asistentes deben tomarlas y asumirlas individualmente.',
            sequentialDescription: 'Las atenciones se distribuirán secuencialmente a los asistentes del departamento que estén disponibles. El primer asistente disponible recibirá la atención y así sucesivamente.',
            balancedDescription: 'Las atenciones se distribuirán entre los asistentes del departamento considerando quién tiene el menor volumen.',
            additionalConfiguration: 'Configuraciones Adicionales',
            edit: 'Editar',
            confirm: 'Confirmar',
            addDepartment: 'Adicionar departamento',
            updateDepartment: 'Atualizar departamento',
          },
          settings: {
            user: 'Mi Perfil',
            userDescription: 'Consulte y edite su información de inicio de sesión y registro.',
            preferences: 'Preferencias',
            users: 'Usuarios',
            usersDescription: 'Administrar usuarios de la plataforma Globalbot. Puede agregar, excluir usuarios y establecer y editar permisos y roles de acceso para cada uno de ellos de forma independiente.',
            liveChat: 'Chat en Vivo',
            liveChatDescription: 'Configure los ajustes del módulo de chat en vivo. Crea departamentos, define la forma de distribución de llamadas y mensajes automáticos.',
            tags: 'Tags',
            customFields: 'Campos y Secciones',
            tagsDescription: 'Acceda a la configuración del sistema de etiquetas, que se puede usar para etiquetar y clasificar varios elementos en una lista o colección (por ejemplo, Conversaciones, Inteligencia y Biblioteca)',
            tagsDescriptionMini: 'Cree y edite las etiquetas que utilizará para marcar y clasificar las conversaciones.',
            domainsAndEmail: 'Dominios y correos electrónicos',
            domainsAndEmailDescription: 'Configure los dominios y correos electrónicos de su empresa para que aparezcan como remitentes en los envíos de Messenger (correos electrónicos, notificaciones y avisos).',
            lists: 'Listas',
            listsDescription: 'Acceda y controle todas las listas creadas y cargadas a la plataforma.',
            liveChatConfigs: {
              messages: 'Mensajes',
              messagesDescription: 'Revisa y edita los mensajes predefinidos del Chat en Vivo.',
              behavior: 'Comportamiento',
              behaviorDescription: 'Configura el comportamiento de las funciones en el Chat en Vivo.',
              departmentsConfig: 'Departamentos',
              departmentsConfigDescription: 'Configure departamentos para organizar y dirigir conversaciones para atención humana.'
            },
            dataBases: 'Bases de Datos',
            dataBasesDescription: 'Importe bases de datos externas para integrarlas con los flujos de chatbot.',
            numberStatus: 'Estado y Bloqueos',
            numberStatusDescription: 'Consulte el estado de los números de WhatsApp de los clientes y bloquéelos si es necesario.',
            optout: 'Opt-Out',
            optoutDescription: 'Acceda y administre las personas que han elegido no recibir mensajes de su empresa (Opt-Out).',
            crmDescription: 'Cree y edite secciones y campos personalizados para organizar registros de personas y empresas e importar registros.',
            whatsappConsumption: 'Consumo de WhatsApp',
            whatsappConsumptionDescription: 'Consulte el consumo de WhatsApp y agregue créditos cuando sea necesario.'
          },
          whatsappConsumption: {
            additionalFilters: 'Filtros adicionales',
            availableBalance: 'Saldo disponible',
            balanceLimit: 'Límite',
            refreshBalance: 'Actualizar saldo',
            balanceError: 'No se pudo cargar el saldo. Inténtelo de nuevo.',
            addCredits: 'Agregar Créditos',
            charges: {
              title: 'Historial de cobros',
              statusFilter: 'Situación',
              createdAt: 'Solicitado el',
              amount: 'Importe',
              paymentMethod: 'Forma de pago',
              status: 'Situación',
              dueDate: 'Vencimiento',
              paidAt: 'Pagado el',
              requestedBy: 'Solicitado por',
              description: 'Descripción',
              paidAmount: 'Valor pagado',
              currency: 'Moneda',
              exportCsv: 'Exportar CSV',
              exportSuccess: 'Informe generado con éxito.',
              exportError: 'No se pudo generar el informe de cobros.',
              csvFilename: 'historial-de-cobros',
              providerChargeId: 'Id en el proveedor',
              registrationStatus: 'Registro del boleto',
              registrationRegistered: 'Registrado',
              registrationPending: 'Pendiente de aprobación del banco',
              registrationPendingHint: 'Esta aprobación puede tardar de 1 a 5 minutos hasta que el boleto pueda pagarse.',
              registrationRejected: 'Error al generar el boleto',
              registrationUnknown: 'Registro no confirmado',
              unknownUser: 'Usuario eliminado',
              empty: 'Ningún cobro registrado.',
              error: 'No se pudo cargar el historial de cobros.',
              statuses: {
                created: 'Registrado',
                pending_confirmation: 'Esperando confirmación del proveedor',
                pending: 'Esperando pago',
                paid: 'Pagado',
                cancelled: 'Cancelado',
                expired: 'Vencido',
                failed: 'Falló'
              }
            },
            charge: {
              title: 'Solicitar créditos',
              hint: 'Generamos un cobro y devolvemos el enlace de pago. El saldo entra en cuanto se confirma el pago.',
              amount: 'Importe de la recarga',
              amountHint: 'Entre',
              paymentMethod: 'Forma de pago',
              paymentMethodRequired: 'Elija la forma de pago.',
              paymentMethods: {
                boleto_pix: 'Boleto / Pix',
                cheque: 'Cheque',
                dinheiro: 'Efectivo',
                cartao_credito: 'Tarjeta de crédito',
                cartao_debito: 'Tarjeta de débito',
                deposito: 'Depósito',
                cheque_pre_datado: 'Cheque posfechado',
                debito_automatico: 'Débito automático',
                transferencia_bancaria: 'Transferencia bancaria',
                doc_ted: 'DOC / TED',
                outros: 'Otros'
              },
              description: 'Descripción (opcional)',
              dueDateField: 'Fecha de vencimiento (opcional)',
              dueDateHint: 'Si no se define, el boleto vencerá en {days} días.',
              dueDateOutOfRange: 'El vencimiento debe estar entre',
              descriptionHint: 'Aparece en el cobro enviado al área financiera.',
              submit: 'Solicitar',
              created: 'Cobro generado',
              dueDate: 'Vence el',
              reused: 'Esta solicitud ya había sido generada; devolvimos el mismo cobro.',
              checkoutLabel: 'Enlace de pago',
              checkoutPending: 'El cobro fue registrado, pero el enlace aún no está disponible. Consulte de nuevo en instantes.',
              openCheckout: 'Abrir enlace de pago',
              copyLink: 'Copiar enlace',
              linkCopied: '¡Enlace copiado!',
              invalidAmount: 'Introduzca un importe válido.',
              amountOutOfRange: 'El importe debe estar entre',
              amountNotWhole: 'Introduzca un importe entero, sin céntimos.',
              errorGatewayNotConfigured: 'Esta cuenta aún no tiene registro en el proveedor de pago. Hable con su contacto comercial.',
              errorModelNotEnabled: 'Esta cuenta no está en el modelo de saldo por mensaje.',
              errorForbidden: 'No tiene permiso para solicitar créditos en esta cuenta.',
              errorGateway: 'El proveedor de pago no respondió. Inténtelo de nuevo en unos minutos.',
              errorGeneric: 'No se pudo generar el cobro. Inténtelo de nuevo.'
            },
            chart: {
              title: 'Informe de Consumo',
              seriesService: 'Service',
              debited: 'Debitado',
              exportCsv: 'Exportar CSV',
              totalMessages: 'Mensajes',
              totalMessagesHint: 'Total de mensajes de servicio (Service) entregados en el período, considerando los chatbots del filtro.',
              retry: 'Intentar de nuevo',
              empty: 'Ningún consumo en el período',
              emptyHint: 'Aquí solo aparecen los mensajes de servicio de WhatsApp.',
              errorForbidden: 'No tiene permiso para ver el consumo de esta cuenta.',
              errorValidation: 'Revise el filtro: el período o los chatbots seleccionados no fueron aceptados.',
              errorGeneric: 'No se pudo cargar el informe de consumo.',
              csvPeriod: 'Período',
              csvMessages: 'Mensajes de servicio',
              csvDebits: 'Debitado',
              csvCredits: 'Acreditado',
              csvNet: 'Saldo del período',
              csvFilename: 'consumo-whatsapp'
            }
          },
          contacts: {
            contacts: 'Contatos',
            people: 'People',
            companies: 'Companies'
          },
          optout: {
            optout: 'Opt-Out',
            reseted: 'Revertido a Opt-In',
            add: 'Agregar',
            addDescription: 'Agregue manualmente un número de WhatsApp para que la persona no reciba más mensajes de la empresa.',
            permanence: 'Permanencia',
            permanenceDescription: 'MASTER: Defina cuánto tiempo permanecerá el registro en Opt-Out. (Por defecto: permanente)',
            tableColumns: {
              channel: 'Canal',
              cdt: 'Fecha y Hora',
              chatbot: 'Chatbot',
              number: 'Número',
              condition: 'Condición',
              user: 'Autor',
              actions: 'Acciones',
            },
            addOptout: 'Agregar Opt-Out',
            important: 'Atención:',
            importantDescription: 'Ingrese el número de celular del cliente con el código de área de 2 dígitos, por ejemplo: (XX) XXXXX-XXXX.',
            customerPhone: 'Número de WhatsApp del Cliente*',
            country: 'País*',
            cancel: 'Cancelar',
            close: 'Fechar',
            advance: 'Siguiente',
            confirm: 'Confirmar',
            revertToOptIn: 'Revert to Opt-In',
            confirmChange: 'Por favor confirme este cambio al número de WhatsApp',
            backToReceiveMessage: 'Este número volverá a recibir mensajes de la empresa.',
            permanenceDrawer: {
              permanence: 'Permanencia',
              permanenceDescription: 'Defina cuánto tiempo una persona permanecerá en Opt-Out. Por defecto, el tiempo de permanencia es “para siempre”. Si eliges otra opción, el estado de Opt-Out expirará según tu elección y las Reglas de Permanencia.',
              permanenceRules: 'Reglas de Permanencia',
              permanenceRulesDescriptionOne: 'Una vez activado, el tiempo de permanencia será retroactivo. En el momento en que actives o edites la función, comenzará a contar el tiempo para todos los registros.',
              permanenceRulesDescriptionTwo: 'Y si desactivas la función, todos los conteos de tiempo de permanencia (si los hubiera) serán cancelados y los registros permanecerán en Opt-Out para siempre.',
              forever: 'para siempre',
              fifteenDays: 'por 15 días',
              thirtyDays: 'por 30 días',
              ninetyDays: 'por 90 días',
              oneHundredEightyDays: 'por 180 días',
              originNumber: 'Número de origen',
              permanenceOptout: 'Permanecer en Opt-Out'
            },
            selectChatbot: 'Seleccione los números que serán añadidos a Opt-Out. Estos números ya no recibirán mensajes de la empresa desde los Chatbot(s) seleccionados.',
            phoneRequired: 'Complete el número de teléfono para agregar.',
            consultError: '¡Ups! No fue posible consultar el número.',
            numberSituation: {
              live: 'En conversación con un agente.',
              bot: 'En conversación con el chatbot.',
              live_satisfactionSurvey: 'La conversación con el agente ha terminado, ahora el usuario está respondiendo la encuesta de satisfacción.',
              bot_satisfactionSurvey: 'La conversación con el chatbot ha terminado, ahora el usuario está respondiendo la encuesta de satisfacción.',
              no_conversation: 'No está en una conversación.',
              optout: 'Ya está en Opt-Out.'
            },
            resetError: '¡Ups! Error al revertir a Opt-In.',
            resetSuccess: '¡Revertido a Opt-In con éxito!',
            permanenceSuccess: '¡Tiempos de permanencia definidos con éxito!',
            permanenceError: '¡Ups! Error al definir los tiempos de permanencia.',
            selectRow: 'Ningún número fue seleccionado.',
            insertError: '¡Ups! Error al aplicar Opt-Out para el bot: ',
            customer: 'Cliente',
            customerDescriptionOptout: 'El cliente optó por no recibir más mensajes (Opt-Out)',
            customerDescriptionReset: 'El cliente inició una nueva conversación con la empresa (Opt-In)',
            system: 'Sistema',
            systemDescriprion: 'Revertido a Opt-In por tiempo de inactividad',
            back: 'Volver'
          },
          tags: {
            preferences: 'Preferencias',
            tags: 'Tags',
            add: 'Agregar',
            columns: 'Columnas',
            color: 'Color',
            category: 'Categoría',
            title: 'Título',
            description: 'Descripción',
            actions: 'Comportamiento',
            edit: 'Editar',
            exclude: 'Borrar',
            save: 'Guardar',
            cancel: 'Cancelar',
            tagData: 'Datos de etiqueta',
            deleteTag: 'Eliminar tag',
            areYouSureDelete: '¿Está seguro de que desea eliminar esta etiqueta? Esta acción no se puede deshacer.',
            general: 'General',
            reports: 'Informes',
            realTime: 'Tiempo real',
            analytics: 'Estadísticas',
            organization: 'Organización',
            companies: 'Compañías',
            people: 'Gente',
            conversation: 'Conversaciones',
            flow: 'Flujo',
            knowledge: 'Inteligencia',
            message: 'Mensaje',
            liveChat: 'Chat en vivo',
            library: 'Biblioteca',
            tasks: 'Tareas',
            deletedTag: 'Tag eliminada.',
            errorDeleteThisTag: '¡Vaya! No pudimos eliminar esta etiqueta.',
            errorSavingTag: 'Vaya, se produjo un error al guardar la tag.',
            requiredFields: 'Es necesario completar el campo de título y color.'
          }
        }
      },
      general: {
        cancel: 'Cancelar',
        save: 'Guardar',
        confirm: 'Confirmar',
        close: 'Cerrar',
        back: 'Atrás',
        advance: 'Avance',
        attention: 'Atención',
        test: 'Prueba',
        start: 'Comenzar',
        retract: 'Retraer',
        users: 'Usuarios',
        campaigns: 'Campañas',
        note: 'Aviso',
        edit: 'Editar',
        delete: 'Eliminar',
        clear: 'Limpiar',
        rename: 'Renombrar'
      }
    }
  }
}
